/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/eastend/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(229);
	module.exports = __webpack_require__(114);


/***/ },
/* 1 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(230);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 3 */
/***/ function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/* @preserve
	 * Leaflet 1.5.1+build.2e3e0ff, a JS library for interactive maps. http://leafletjs.com
	 * (c) 2010-2018 Vladimir Agafonkin, (c) 2010-2011 CloudMade
	 */
	
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.L = {})));
	}(this, (function (exports) { 'use strict';
	
	var version = "1.5.1+build.2e3e0ffb";
	
	/*
	 * @namespace Util
	 *
	 * Various utility functions, used by Leaflet internally.
	 */
	
	var freeze = Object.freeze;
	Object.freeze = function (obj) { return obj; };
	
	// @function extend(dest: Object, src?: Object): Object
	// Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
	function extend(dest) {
		var i, j, len, src;
	
		for (j = 1, len = arguments.length; j < len; j++) {
			src = arguments[j];
			for (i in src) {
				dest[i] = src[i];
			}
		}
		return dest;
	}
	
	// @function create(proto: Object, properties?: Object): Object
	// Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
	var create = Object.create || (function () {
		function F() {}
		return function (proto) {
			F.prototype = proto;
			return new F();
		};
	})();
	
	// @function bind(fn: Function, …): Function
	// Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	// Has a `L.bind()` shortcut.
	function bind(fn, obj) {
		var slice = Array.prototype.slice;
	
		if (fn.bind) {
			return fn.bind.apply(fn, slice.call(arguments, 1));
		}
	
		var args = slice.call(arguments, 2);
	
		return function () {
			return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
		};
	}
	
	// @property lastId: Number
	// Last unique ID used by [`stamp()`](#util-stamp)
	var lastId = 0;
	
	// @function stamp(obj: Object): Number
	// Returns the unique ID of an object, assigning it one if it doesn't have it.
	function stamp(obj) {
		/*eslint-disable */
		obj._leaflet_id = obj._leaflet_id || ++lastId;
		return obj._leaflet_id;
		/* eslint-enable */
	}
	
	// @function throttle(fn: Function, time: Number, context: Object): Function
	// Returns a function which executes function `fn` with the given scope `context`
	// (so that the `this` keyword refers to `context` inside `fn`'s code). The function
	// `fn` will be called no more than one time per given amount of `time`. The arguments
	// received by the bound function will be any arguments passed when binding the
	// function, followed by any arguments passed when invoking the bound function.
	// Has an `L.throttle` shortcut.
	function throttle(fn, time, context) {
		var lock, args, wrapperFn, later;
	
		later = function () {
			// reset lock and call if queued
			lock = false;
			if (args) {
				wrapperFn.apply(context, args);
				args = false;
			}
		};
	
		wrapperFn = function () {
			if (lock) {
				// called too soon, queue to call later
				args = arguments;
	
			} else {
				// call and lock until later
				fn.apply(context, arguments);
				setTimeout(later, time);
				lock = true;
			}
		};
	
		return wrapperFn;
	}
	
	// @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
	// Returns the number `num` modulo `range` in such a way so it lies within
	// `range[0]` and `range[1]`. The returned value will be always smaller than
	// `range[1]` unless `includeMax` is set to `true`.
	function wrapNum(x, range, includeMax) {
		var max = range[1],
		    min = range[0],
		    d = max - min;
		return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
	}
	
	// @function falseFn(): Function
	// Returns a function which always returns `false`.
	function falseFn() { return false; }
	
	// @function formatNum(num: Number, digits?: Number): Number
	// Returns the number `num` rounded to `digits` decimals, or to 6 decimals by default.
	function formatNum(num, digits) {
		digits = (digits === undefined ? 6 : digits);
		return +(Math.round(num + ('e+' + digits)) + ('e-' + digits));
	}
	
	// @function trim(str: String): String
	// Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
	function trim(str) {
		return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	}
	
	// @function splitWords(str: String): String[]
	// Trims and splits the string on whitespace and returns the array of parts.
	function splitWords(str) {
		return trim(str).split(/\s+/);
	}
	
	// @function setOptions(obj: Object, options: Object): Object
	// Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
	function setOptions(obj, options) {
		if (!obj.hasOwnProperty('options')) {
			obj.options = obj.options ? create(obj.options) : {};
		}
		for (var i in options) {
			obj.options[i] = options[i];
		}
		return obj.options;
	}
	
	// @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
	// Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
	// translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
	// be appended at the end. If `uppercase` is `true`, the parameter names will
	// be uppercased (e.g. `'?A=foo&B=bar'`)
	function getParamString(obj, existingUrl, uppercase) {
		var params = [];
		for (var i in obj) {
			params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
		}
		return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
	}
	
	var templateRe = /\{ *([\w_-]+) *\}/g;
	
	// @function template(str: String, data: Object): String
	// Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
	// and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
	// `('Hello foo, bar')`. You can also specify functions instead of strings for
	// data values — they will be evaluated passing `data` as an argument.
	function template(str, data) {
		return str.replace(templateRe, function (str, key) {
			var value = data[key];
	
			if (value === undefined) {
				throw new Error('No value provided for variable ' + str);
	
			} else if (typeof value === 'function') {
				value = value(data);
			}
			return value;
		});
	}
	
	// @function isArray(obj): Boolean
	// Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
	var isArray = Array.isArray || function (obj) {
		return (Object.prototype.toString.call(obj) === '[object Array]');
	};
	
	// @function indexOf(array: Array, el: Object): Number
	// Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
	function indexOf(array, el) {
		for (var i = 0; i < array.length; i++) {
			if (array[i] === el) { return i; }
		}
		return -1;
	}
	
	// @property emptyImageUrl: String
	// Data URI string containing a base64-encoded empty GIF image.
	// Used as a hack to free memory from unused images on WebKit-powered
	// mobile devices (by setting image `src` to this string).
	var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
	
	// inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	
	function getPrefixed(name) {
		return window['webkit' + name] || window['moz' + name] || window['ms' + name];
	}
	
	var lastTime = 0;
	
	// fallback for IE 7-8
	function timeoutDefer(fn) {
		var time = +new Date(),
		    timeToCall = Math.max(0, 16 - (time - lastTime));
	
		lastTime = time + timeToCall;
		return window.setTimeout(fn, timeToCall);
	}
	
	var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
	var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') ||
			getPrefixed('CancelRequestAnimationFrame') || function (id) { window.clearTimeout(id); };
	
	// @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
	// Schedules `fn` to be executed when the browser repaints. `fn` is bound to
	// `context` if given. When `immediate` is set, `fn` is called immediately if
	// the browser doesn't have native support for
	// [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
	// otherwise it's delayed. Returns a request ID that can be used to cancel the request.
	function requestAnimFrame(fn, context, immediate) {
		if (immediate && requestFn === timeoutDefer) {
			fn.call(context);
		} else {
			return requestFn.call(window, bind(fn, context));
		}
	}
	
	// @function cancelAnimFrame(id: Number): undefined
	// Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
	function cancelAnimFrame(id) {
		if (id) {
			cancelFn.call(window, id);
		}
	}
	
	
	var Util = (Object.freeze || Object)({
		freeze: freeze,
		extend: extend,
		create: create,
		bind: bind,
		lastId: lastId,
		stamp: stamp,
		throttle: throttle,
		wrapNum: wrapNum,
		falseFn: falseFn,
		formatNum: formatNum,
		trim: trim,
		splitWords: splitWords,
		setOptions: setOptions,
		getParamString: getParamString,
		template: template,
		isArray: isArray,
		indexOf: indexOf,
		emptyImageUrl: emptyImageUrl,
		requestFn: requestFn,
		cancelFn: cancelFn,
		requestAnimFrame: requestAnimFrame,
		cancelAnimFrame: cancelAnimFrame
	});
	
	// @class Class
	// @aka L.Class
	
	// @section
	// @uninheritable
	
	// Thanks to John Resig and Dean Edwards for inspiration!
	
	function Class() {}
	
	Class.extend = function (props) {
	
		// @function extend(props: Object): Function
		// [Extends the current class](#class-inheritance) given the properties to be included.
		// Returns a Javascript function that is a class constructor (to be called with `new`).
		var NewClass = function () {
	
			// call the constructor
			if (this.initialize) {
				this.initialize.apply(this, arguments);
			}
	
			// call all constructor hooks
			this.callInitHooks();
		};
	
		var parentProto = NewClass.__super__ = this.prototype;
	
		var proto = create(parentProto);
		proto.constructor = NewClass;
	
		NewClass.prototype = proto;
	
		// inherit parent's statics
		for (var i in this) {
			if (this.hasOwnProperty(i) && i !== 'prototype' && i !== '__super__') {
				NewClass[i] = this[i];
			}
		}
	
		// mix static properties into the class
		if (props.statics) {
			extend(NewClass, props.statics);
			delete props.statics;
		}
	
		// mix includes into the prototype
		if (props.includes) {
			checkDeprecatedMixinEvents(props.includes);
			extend.apply(null, [proto].concat(props.includes));
			delete props.includes;
		}
	
		// merge options
		if (proto.options) {
			props.options = extend(create(proto.options), props.options);
		}
	
		// mix given properties into the prototype
		extend(proto, props);
	
		proto._initHooks = [];
	
		// add method for calling all hooks
		proto.callInitHooks = function () {
	
			if (this._initHooksCalled) { return; }
	
			if (parentProto.callInitHooks) {
				parentProto.callInitHooks.call(this);
			}
	
			this._initHooksCalled = true;
	
			for (var i = 0, len = proto._initHooks.length; i < len; i++) {
				proto._initHooks[i].call(this);
			}
		};
	
		return NewClass;
	};
	
	
	// @function include(properties: Object): this
	// [Includes a mixin](#class-includes) into the current class.
	Class.include = function (props) {
		extend(this.prototype, props);
		return this;
	};
	
	// @function mergeOptions(options: Object): this
	// [Merges `options`](#class-options) into the defaults of the class.
	Class.mergeOptions = function (options) {
		extend(this.prototype.options, options);
		return this;
	};
	
	// @function addInitHook(fn: Function): this
	// Adds a [constructor hook](#class-constructor-hooks) to the class.
	Class.addInitHook = function (fn) { // (Function) || (String, args...)
		var args = Array.prototype.slice.call(arguments, 1);
	
		var init = typeof fn === 'function' ? fn : function () {
			this[fn].apply(this, args);
		};
	
		this.prototype._initHooks = this.prototype._initHooks || [];
		this.prototype._initHooks.push(init);
		return this;
	};
	
	function checkDeprecatedMixinEvents(includes) {
		if (typeof L === 'undefined' || !L || !L.Mixin) { return; }
	
		includes = isArray(includes) ? includes : [includes];
	
		for (var i = 0; i < includes.length; i++) {
			if (includes[i] === L.Mixin.Events) {
				console.warn('Deprecated include of L.Mixin.Events: ' +
					'this property will be removed in future releases, ' +
					'please inherit from L.Evented instead.', new Error().stack);
			}
		}
	}
	
	/*
	 * @class Evented
	 * @aka L.Evented
	 * @inherits Class
	 *
	 * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
	 *
	 * @example
	 *
	 * ```js
	 * map.on('click', function(e) {
	 * 	alert(e.latlng);
	 * } );
	 * ```
	 *
	 * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
	 *
	 * ```js
	 * function onClick(e) { ... }
	 *
	 * map.on('click', onClick);
	 * map.off('click', onClick);
	 * ```
	 */
	
	var Events = {
		/* @method on(type: String, fn: Function, context?: Object): this
		 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
		 *
		 * @alternative
		 * @method on(eventMap: Object): this
		 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
		 */
		on: function (types, fn, context) {
	
			// types can be a map of types/handlers
			if (typeof types === 'object') {
				for (var type in types) {
					// we don't process space-separated events here for performance;
					// it's a hot path since Layer uses the on(obj) syntax
					this._on(type, types[type], fn);
				}
	
			} else {
				// types can be a string of space-separated words
				types = splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._on(types[i], fn, context);
				}
			}
	
			return this;
		},
	
		/* @method off(type: String, fn?: Function, context?: Object): this
		 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
		 *
		 * @alternative
		 * @method off(eventMap: Object): this
		 * Removes a set of type/listener pairs.
		 *
		 * @alternative
		 * @method off: this
		 * Removes all listeners to all events on the object. This includes implicitly attached events.
		 */
		off: function (types, fn, context) {
	
			if (!types) {
				// clear all listeners if called without arguments
				delete this._events;
	
			} else if (typeof types === 'object') {
				for (var type in types) {
					this._off(type, types[type], fn);
				}
	
			} else {
				types = splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._off(types[i], fn, context);
				}
			}
	
			return this;
		},
	
		// attach listener (without syntactic sugar now)
		_on: function (type, fn, context) {
			this._events = this._events || {};
	
			/* get/init listeners for type */
			var typeListeners = this._events[type];
			if (!typeListeners) {
				typeListeners = [];
				this._events[type] = typeListeners;
			}
	
			if (context === this) {
				// Less memory footprint.
				context = undefined;
			}
			var newListener = {fn: fn, ctx: context},
			    listeners = typeListeners;
	
			// check if fn already there
			for (var i = 0, len = listeners.length; i < len; i++) {
				if (listeners[i].fn === fn && listeners[i].ctx === context) {
					return;
				}
			}
	
			listeners.push(newListener);
		},
	
		_off: function (type, fn, context) {
			var listeners,
			    i,
			    len;
	
			if (!this._events) { return; }
	
			listeners = this._events[type];
	
			if (!listeners) {
				return;
			}
	
			if (!fn) {
				// Set all removed listeners to noop so they are not called if remove happens in fire
				for (i = 0, len = listeners.length; i < len; i++) {
					listeners[i].fn = falseFn;
				}
				// clear all listeners for a type if function isn't specified
				delete this._events[type];
				return;
			}
	
			if (context === this) {
				context = undefined;
			}
	
			if (listeners) {
	
				// find fn and remove it
				for (i = 0, len = listeners.length; i < len; i++) {
					var l = listeners[i];
					if (l.ctx !== context) { continue; }
					if (l.fn === fn) {
	
						// set the removed listener to noop so that's not called if remove happens in fire
						l.fn = falseFn;
	
						if (this._firingCount) {
							/* copy array in case events are being fired */
							this._events[type] = listeners = listeners.slice();
						}
						listeners.splice(i, 1);
	
						return;
					}
				}
			}
		},
	
		// @method fire(type: String, data?: Object, propagate?: Boolean): this
		// Fires an event of the specified type. You can optionally provide an data
		// object — the first argument of the listener function will contain its
		// properties. The event can optionally be propagated to event parents.
		fire: function (type, data, propagate) {
			if (!this.listens(type, propagate)) { return this; }
	
			var event = extend({}, data, {
				type: type,
				target: this,
				sourceTarget: data && data.sourceTarget || this
			});
	
			if (this._events) {
				var listeners = this._events[type];
	
				if (listeners) {
					this._firingCount = (this._firingCount + 1) || 1;
					for (var i = 0, len = listeners.length; i < len; i++) {
						var l = listeners[i];
						l.fn.call(l.ctx || this, event);
					}
	
					this._firingCount--;
				}
			}
	
			if (propagate) {
				// propagate the event to parents (set with addEventParent)
				this._propagateEvent(event);
			}
	
			return this;
		},
	
		// @method listens(type: String): Boolean
		// Returns `true` if a particular event type has any listeners attached to it.
		listens: function (type, propagate) {
			var listeners = this._events && this._events[type];
			if (listeners && listeners.length) { return true; }
	
			if (propagate) {
				// also check parents for listeners if event propagates
				for (var id in this._eventParents) {
					if (this._eventParents[id].listens(type, propagate)) { return true; }
				}
			}
			return false;
		},
	
		// @method once(…): this
		// Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
		once: function (types, fn, context) {
	
			if (typeof types === 'object') {
				for (var type in types) {
					this.once(type, types[type], fn);
				}
				return this;
			}
	
			var handler = bind(function () {
				this
				    .off(types, fn, context)
				    .off(types, handler, context);
			}, this);
	
			// add a listener that's executed once and removed after that
			return this
			    .on(types, fn, context)
			    .on(types, handler, context);
		},
	
		// @method addEventParent(obj: Evented): this
		// Adds an event parent - an `Evented` that will receive propagated events
		addEventParent: function (obj) {
			this._eventParents = this._eventParents || {};
			this._eventParents[stamp(obj)] = obj;
			return this;
		},
	
		// @method removeEventParent(obj: Evented): this
		// Removes an event parent, so it will stop receiving propagated events
		removeEventParent: function (obj) {
			if (this._eventParents) {
				delete this._eventParents[stamp(obj)];
			}
			return this;
		},
	
		_propagateEvent: function (e) {
			for (var id in this._eventParents) {
				this._eventParents[id].fire(e.type, extend({
					layer: e.target,
					propagatedFrom: e.target
				}, e), true);
			}
		}
	};
	
	// aliases; we should ditch those eventually
	
	// @method addEventListener(…): this
	// Alias to [`on(…)`](#evented-on)
	Events.addEventListener = Events.on;
	
	// @method removeEventListener(…): this
	// Alias to [`off(…)`](#evented-off)
	
	// @method clearAllEventListeners(…): this
	// Alias to [`off()`](#evented-off)
	Events.removeEventListener = Events.clearAllEventListeners = Events.off;
	
	// @method addOneTimeEventListener(…): this
	// Alias to [`once(…)`](#evented-once)
	Events.addOneTimeEventListener = Events.once;
	
	// @method fireEvent(…): this
	// Alias to [`fire(…)`](#evented-fire)
	Events.fireEvent = Events.fire;
	
	// @method hasEventListeners(…): Boolean
	// Alias to [`listens(…)`](#evented-listens)
	Events.hasEventListeners = Events.listens;
	
	var Evented = Class.extend(Events);
	
	/*
	 * @class Point
	 * @aka L.Point
	 *
	 * Represents a point with `x` and `y` coordinates in pixels.
	 *
	 * @example
	 *
	 * ```js
	 * var point = L.point(200, 300);
	 * ```
	 *
	 * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
	 *
	 * ```js
	 * map.panBy([200, 300]);
	 * map.panBy(L.point(200, 300));
	 * ```
	 *
	 * Note that `Point` does not inherit from Leafet's `Class` object,
	 * which means new classes can't inherit from it, and new methods
	 * can't be added to it with the `include` function.
	 */
	
	function Point(x, y, round) {
		// @property x: Number; The `x` coordinate of the point
		this.x = (round ? Math.round(x) : x);
		// @property y: Number; The `y` coordinate of the point
		this.y = (round ? Math.round(y) : y);
	}
	
	var trunc = Math.trunc || function (v) {
		return v > 0 ? Math.floor(v) : Math.ceil(v);
	};
	
	Point.prototype = {
	
		// @method clone(): Point
		// Returns a copy of the current point.
		clone: function () {
			return new Point(this.x, this.y);
		},
	
		// @method add(otherPoint: Point): Point
		// Returns the result of addition of the current and the given points.
		add: function (point) {
			// non-destructive, returns a new point
			return this.clone()._add(toPoint(point));
		},
	
		_add: function (point) {
			// destructive, used directly for performance in situations where it's safe to modify existing point
			this.x += point.x;
			this.y += point.y;
			return this;
		},
	
		// @method subtract(otherPoint: Point): Point
		// Returns the result of subtraction of the given point from the current.
		subtract: function (point) {
			return this.clone()._subtract(toPoint(point));
		},
	
		_subtract: function (point) {
			this.x -= point.x;
			this.y -= point.y;
			return this;
		},
	
		// @method divideBy(num: Number): Point
		// Returns the result of division of the current point by the given number.
		divideBy: function (num) {
			return this.clone()._divideBy(num);
		},
	
		_divideBy: function (num) {
			this.x /= num;
			this.y /= num;
			return this;
		},
	
		// @method multiplyBy(num: Number): Point
		// Returns the result of multiplication of the current point by the given number.
		multiplyBy: function (num) {
			return this.clone()._multiplyBy(num);
		},
	
		_multiplyBy: function (num) {
			this.x *= num;
			this.y *= num;
			return this;
		},
	
		// @method scaleBy(scale: Point): Point
		// Multiply each coordinate of the current point by each coordinate of
		// `scale`. In linear algebra terms, multiply the point by the
		// [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
		// defined by `scale`.
		scaleBy: function (point) {
			return new Point(this.x * point.x, this.y * point.y);
		},
	
		// @method unscaleBy(scale: Point): Point
		// Inverse of `scaleBy`. Divide each coordinate of the current point by
		// each coordinate of `scale`.
		unscaleBy: function (point) {
			return new Point(this.x / point.x, this.y / point.y);
		},
	
		// @method round(): Point
		// Returns a copy of the current point with rounded coordinates.
		round: function () {
			return this.clone()._round();
		},
	
		_round: function () {
			this.x = Math.round(this.x);
			this.y = Math.round(this.y);
			return this;
		},
	
		// @method floor(): Point
		// Returns a copy of the current point with floored coordinates (rounded down).
		floor: function () {
			return this.clone()._floor();
		},
	
		_floor: function () {
			this.x = Math.floor(this.x);
			this.y = Math.floor(this.y);
			return this;
		},
	
		// @method ceil(): Point
		// Returns a copy of the current point with ceiled coordinates (rounded up).
		ceil: function () {
			return this.clone()._ceil();
		},
	
		_ceil: function () {
			this.x = Math.ceil(this.x);
			this.y = Math.ceil(this.y);
			return this;
		},
	
		// @method trunc(): Point
		// Returns a copy of the current point with truncated coordinates (rounded towards zero).
		trunc: function () {
			return this.clone()._trunc();
		},
	
		_trunc: function () {
			this.x = trunc(this.x);
			this.y = trunc(this.y);
			return this;
		},
	
		// @method distanceTo(otherPoint: Point): Number
		// Returns the cartesian distance between the current and the given points.
		distanceTo: function (point) {
			point = toPoint(point);
	
			var x = point.x - this.x,
			    y = point.y - this.y;
	
			return Math.sqrt(x * x + y * y);
		},
	
		// @method equals(otherPoint: Point): Boolean
		// Returns `true` if the given point has the same coordinates.
		equals: function (point) {
			point = toPoint(point);
	
			return point.x === this.x &&
			       point.y === this.y;
		},
	
		// @method contains(otherPoint: Point): Boolean
		// Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
		contains: function (point) {
			point = toPoint(point);
	
			return Math.abs(point.x) <= Math.abs(this.x) &&
			       Math.abs(point.y) <= Math.abs(this.y);
		},
	
		// @method toString(): String
		// Returns a string representation of the point for debugging purposes.
		toString: function () {
			return 'Point(' +
			        formatNum(this.x) + ', ' +
			        formatNum(this.y) + ')';
		}
	};
	
	// @factory L.point(x: Number, y: Number, round?: Boolean)
	// Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
	
	// @alternative
	// @factory L.point(coords: Number[])
	// Expects an array of the form `[x, y]` instead.
	
	// @alternative
	// @factory L.point(coords: Object)
	// Expects a plain object of the form `{x: Number, y: Number}` instead.
	function toPoint(x, y, round) {
		if (x instanceof Point) {
			return x;
		}
		if (isArray(x)) {
			return new Point(x[0], x[1]);
		}
		if (x === undefined || x === null) {
			return x;
		}
		if (typeof x === 'object' && 'x' in x && 'y' in x) {
			return new Point(x.x, x.y);
		}
		return new Point(x, y, round);
	}
	
	/*
	 * @class Bounds
	 * @aka L.Bounds
	 *
	 * Represents a rectangular area in pixel coordinates.
	 *
	 * @example
	 *
	 * ```js
	 * var p1 = L.point(10, 10),
	 * p2 = L.point(40, 60),
	 * bounds = L.bounds(p1, p2);
	 * ```
	 *
	 * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	 *
	 * ```js
	 * otherBounds.intersects([[10, 10], [40, 60]]);
	 * ```
	 *
	 * Note that `Bounds` does not inherit from Leafet's `Class` object,
	 * which means new classes can't inherit from it, and new methods
	 * can't be added to it with the `include` function.
	 */
	
	function Bounds(a, b) {
		if (!a) { return; }
	
		var points = b ? [a, b] : a;
	
		for (var i = 0, len = points.length; i < len; i++) {
			this.extend(points[i]);
		}
	}
	
	Bounds.prototype = {
		// @method extend(point: Point): this
		// Extends the bounds to contain the given point.
		extend: function (point) { // (Point)
			point = toPoint(point);
	
			// @property min: Point
			// The top left corner of the rectangle.
			// @property max: Point
			// The bottom right corner of the rectangle.
			if (!this.min && !this.max) {
				this.min = point.clone();
				this.max = point.clone();
			} else {
				this.min.x = Math.min(point.x, this.min.x);
				this.max.x = Math.max(point.x, this.max.x);
				this.min.y = Math.min(point.y, this.min.y);
				this.max.y = Math.max(point.y, this.max.y);
			}
			return this;
		},
	
		// @method getCenter(round?: Boolean): Point
		// Returns the center point of the bounds.
		getCenter: function (round) {
			return new Point(
			        (this.min.x + this.max.x) / 2,
			        (this.min.y + this.max.y) / 2, round);
		},
	
		// @method getBottomLeft(): Point
		// Returns the bottom-left point of the bounds.
		getBottomLeft: function () {
			return new Point(this.min.x, this.max.y);
		},
	
		// @method getTopRight(): Point
		// Returns the top-right point of the bounds.
		getTopRight: function () { // -> Point
			return new Point(this.max.x, this.min.y);
		},
	
		// @method getTopLeft(): Point
		// Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
		getTopLeft: function () {
			return this.min; // left, top
		},
	
		// @method getBottomRight(): Point
		// Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
		getBottomRight: function () {
			return this.max; // right, bottom
		},
	
		// @method getSize(): Point
		// Returns the size of the given bounds
		getSize: function () {
			return this.max.subtract(this.min);
		},
	
		// @method contains(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle contains the given one.
		// @alternative
		// @method contains(point: Point): Boolean
		// Returns `true` if the rectangle contains the given point.
		contains: function (obj) {
			var min, max;
	
			if (typeof obj[0] === 'number' || obj instanceof Point) {
				obj = toPoint(obj);
			} else {
				obj = toBounds(obj);
			}
	
			if (obj instanceof Bounds) {
				min = obj.min;
				max = obj.max;
			} else {
				min = max = obj;
			}
	
			return (min.x >= this.min.x) &&
			       (max.x <= this.max.x) &&
			       (min.y >= this.min.y) &&
			       (max.y <= this.max.y);
		},
	
		// @method intersects(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle intersects the given bounds. Two bounds
		// intersect if they have at least one point in common.
		intersects: function (bounds) { // (Bounds) -> Boolean
			bounds = toBounds(bounds);
	
			var min = this.min,
			    max = this.max,
			    min2 = bounds.min,
			    max2 = bounds.max,
			    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
			    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);
	
			return xIntersects && yIntersects;
		},
	
		// @method overlaps(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle overlaps the given bounds. Two bounds
		// overlap if their intersection is an area.
		overlaps: function (bounds) { // (Bounds) -> Boolean
			bounds = toBounds(bounds);
	
			var min = this.min,
			    max = this.max,
			    min2 = bounds.min,
			    max2 = bounds.max,
			    xOverlaps = (max2.x > min.x) && (min2.x < max.x),
			    yOverlaps = (max2.y > min.y) && (min2.y < max.y);
	
			return xOverlaps && yOverlaps;
		},
	
		isValid: function () {
			return !!(this.min && this.max);
		}
	};
	
	
	// @factory L.bounds(corner1: Point, corner2: Point)
	// Creates a Bounds object from two corners coordinate pairs.
	// @alternative
	// @factory L.bounds(points: Point[])
	// Creates a Bounds object from the given array of points.
	function toBounds(a, b) {
		if (!a || a instanceof Bounds) {
			return a;
		}
		return new Bounds(a, b);
	}
	
	/*
	 * @class LatLngBounds
	 * @aka L.LatLngBounds
	 *
	 * Represents a rectangular geographical area on a map.
	 *
	 * @example
	 *
	 * ```js
	 * var corner1 = L.latLng(40.712, -74.227),
	 * corner2 = L.latLng(40.774, -74.125),
	 * bounds = L.latLngBounds(corner1, corner2);
	 * ```
	 *
	 * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	 *
	 * ```js
	 * map.fitBounds([
	 * 	[40.712, -74.227],
	 * 	[40.774, -74.125]
	 * ]);
	 * ```
	 *
	 * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
	 *
	 * Note that `LatLngBounds` does not inherit from Leafet's `Class` object,
	 * which means new classes can't inherit from it, and new methods
	 * can't be added to it with the `include` function.
	 */
	
	function LatLngBounds(corner1, corner2) { // (LatLng, LatLng) or (LatLng[])
		if (!corner1) { return; }
	
		var latlngs = corner2 ? [corner1, corner2] : corner1;
	
		for (var i = 0, len = latlngs.length; i < len; i++) {
			this.extend(latlngs[i]);
		}
	}
	
	LatLngBounds.prototype = {
	
		// @method extend(latlng: LatLng): this
		// Extend the bounds to contain the given point
	
		// @alternative
		// @method extend(otherBounds: LatLngBounds): this
		// Extend the bounds to contain the given bounds
		extend: function (obj) {
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2, ne2;
	
			if (obj instanceof LatLng) {
				sw2 = obj;
				ne2 = obj;
	
			} else if (obj instanceof LatLngBounds) {
				sw2 = obj._southWest;
				ne2 = obj._northEast;
	
				if (!sw2 || !ne2) { return this; }
	
			} else {
				return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
			}
	
			if (!sw && !ne) {
				this._southWest = new LatLng(sw2.lat, sw2.lng);
				this._northEast = new LatLng(ne2.lat, ne2.lng);
			} else {
				sw.lat = Math.min(sw2.lat, sw.lat);
				sw.lng = Math.min(sw2.lng, sw.lng);
				ne.lat = Math.max(ne2.lat, ne.lat);
				ne.lng = Math.max(ne2.lng, ne.lng);
			}
	
			return this;
		},
	
		// @method pad(bufferRatio: Number): LatLngBounds
		// Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
		// For example, a ratio of 0.5 extends the bounds by 50% in each direction.
		// Negative values will retract the bounds.
		pad: function (bufferRatio) {
			var sw = this._southWest,
			    ne = this._northEast,
			    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
			    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
	
			return new LatLngBounds(
			        new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
			        new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
		},
	
		// @method getCenter(): LatLng
		// Returns the center point of the bounds.
		getCenter: function () {
			return new LatLng(
			        (this._southWest.lat + this._northEast.lat) / 2,
			        (this._southWest.lng + this._northEast.lng) / 2);
		},
	
		// @method getSouthWest(): LatLng
		// Returns the south-west point of the bounds.
		getSouthWest: function () {
			return this._southWest;
		},
	
		// @method getNorthEast(): LatLng
		// Returns the north-east point of the bounds.
		getNorthEast: function () {
			return this._northEast;
		},
	
		// @method getNorthWest(): LatLng
		// Returns the north-west point of the bounds.
		getNorthWest: function () {
			return new LatLng(this.getNorth(), this.getWest());
		},
	
		// @method getSouthEast(): LatLng
		// Returns the south-east point of the bounds.
		getSouthEast: function () {
			return new LatLng(this.getSouth(), this.getEast());
		},
	
		// @method getWest(): Number
		// Returns the west longitude of the bounds
		getWest: function () {
			return this._southWest.lng;
		},
	
		// @method getSouth(): Number
		// Returns the south latitude of the bounds
		getSouth: function () {
			return this._southWest.lat;
		},
	
		// @method getEast(): Number
		// Returns the east longitude of the bounds
		getEast: function () {
			return this._northEast.lng;
		},
	
		// @method getNorth(): Number
		// Returns the north latitude of the bounds
		getNorth: function () {
			return this._northEast.lat;
		},
	
		// @method contains(otherBounds: LatLngBounds): Boolean
		// Returns `true` if the rectangle contains the given one.
	
		// @alternative
		// @method contains (latlng: LatLng): Boolean
		// Returns `true` if the rectangle contains the given point.
		contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
			if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) {
				obj = toLatLng(obj);
			} else {
				obj = toLatLngBounds(obj);
			}
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2, ne2;
	
			if (obj instanceof LatLngBounds) {
				sw2 = obj.getSouthWest();
				ne2 = obj.getNorthEast();
			} else {
				sw2 = ne2 = obj;
			}
	
			return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
			       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
		},
	
		// @method intersects(otherBounds: LatLngBounds): Boolean
		// Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
		intersects: function (bounds) {
			bounds = toLatLngBounds(bounds);
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2 = bounds.getSouthWest(),
			    ne2 = bounds.getNorthEast(),
	
			    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
			    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);
	
			return latIntersects && lngIntersects;
		},
	
		// @method overlaps(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
		overlaps: function (bounds) {
			bounds = toLatLngBounds(bounds);
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2 = bounds.getSouthWest(),
			    ne2 = bounds.getNorthEast(),
	
			    latOverlaps = (ne2.lat > sw.lat) && (sw2.lat < ne.lat),
			    lngOverlaps = (ne2.lng > sw.lng) && (sw2.lng < ne.lng);
	
			return latOverlaps && lngOverlaps;
		},
	
		// @method toBBoxString(): String
		// Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
		toBBoxString: function () {
			return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
		},
	
		// @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
		// Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
		equals: function (bounds, maxMargin) {
			if (!bounds) { return false; }
	
			bounds = toLatLngBounds(bounds);
	
			return this._southWest.equals(bounds.getSouthWest(), maxMargin) &&
			       this._northEast.equals(bounds.getNorthEast(), maxMargin);
		},
	
		// @method isValid(): Boolean
		// Returns `true` if the bounds are properly initialized.
		isValid: function () {
			return !!(this._southWest && this._northEast);
		}
	};
	
	// TODO International date line?
	
	// @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
	// Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
	
	// @alternative
	// @factory L.latLngBounds(latlngs: LatLng[])
	// Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
	function toLatLngBounds(a, b) {
		if (a instanceof LatLngBounds) {
			return a;
		}
		return new LatLngBounds(a, b);
	}
	
	/* @class LatLng
	 * @aka L.LatLng
	 *
	 * Represents a geographical point with a certain latitude and longitude.
	 *
	 * @example
	 *
	 * ```
	 * var latlng = L.latLng(50.5, 30.5);
	 * ```
	 *
	 * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
	 *
	 * ```
	 * map.panTo([50, 30]);
	 * map.panTo({lon: 30, lat: 50});
	 * map.panTo({lat: 50, lng: 30});
	 * map.panTo(L.latLng(50, 30));
	 * ```
	 *
	 * Note that `LatLng` does not inherit from Leaflet's `Class` object,
	 * which means new classes can't inherit from it, and new methods
	 * can't be added to it with the `include` function.
	 */
	
	function LatLng(lat, lng, alt) {
		if (isNaN(lat) || isNaN(lng)) {
			throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
		}
	
		// @property lat: Number
		// Latitude in degrees
		this.lat = +lat;
	
		// @property lng: Number
		// Longitude in degrees
		this.lng = +lng;
	
		// @property alt: Number
		// Altitude in meters (optional)
		if (alt !== undefined) {
			this.alt = +alt;
		}
	}
	
	LatLng.prototype = {
		// @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
		// Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
		equals: function (obj, maxMargin) {
			if (!obj) { return false; }
	
			obj = toLatLng(obj);
	
			var margin = Math.max(
			        Math.abs(this.lat - obj.lat),
			        Math.abs(this.lng - obj.lng));
	
			return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
		},
	
		// @method toString(): String
		// Returns a string representation of the point (for debugging purposes).
		toString: function (precision) {
			return 'LatLng(' +
			        formatNum(this.lat, precision) + ', ' +
			        formatNum(this.lng, precision) + ')';
		},
	
		// @method distanceTo(otherLatLng: LatLng): Number
		// Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
		distanceTo: function (other) {
			return Earth.distance(this, toLatLng(other));
		},
	
		// @method wrap(): LatLng
		// Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
		wrap: function () {
			return Earth.wrapLatLng(this);
		},
	
		// @method toBounds(sizeInMeters: Number): LatLngBounds
		// Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
		toBounds: function (sizeInMeters) {
			var latAccuracy = 180 * sizeInMeters / 40075017,
			    lngAccuracy = latAccuracy / Math.cos((Math.PI / 180) * this.lat);
	
			return toLatLngBounds(
			        [this.lat - latAccuracy, this.lng - lngAccuracy],
			        [this.lat + latAccuracy, this.lng + lngAccuracy]);
		},
	
		clone: function () {
			return new LatLng(this.lat, this.lng, this.alt);
		}
	};
	
	
	
	// @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
	// Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
	
	// @alternative
	// @factory L.latLng(coords: Array): LatLng
	// Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
	
	// @alternative
	// @factory L.latLng(coords: Object): LatLng
	// Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
	
	function toLatLng(a, b, c) {
		if (a instanceof LatLng) {
			return a;
		}
		if (isArray(a) && typeof a[0] !== 'object') {
			if (a.length === 3) {
				return new LatLng(a[0], a[1], a[2]);
			}
			if (a.length === 2) {
				return new LatLng(a[0], a[1]);
			}
			return null;
		}
		if (a === undefined || a === null) {
			return a;
		}
		if (typeof a === 'object' && 'lat' in a) {
			return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
		}
		if (b === undefined) {
			return null;
		}
		return new LatLng(a, b, c);
	}
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Base
	 * Object that defines coordinate reference systems for projecting
	 * geographical points into pixel (screen) coordinates and back (and to
	 * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
	 * [spatial reference system](http://en.wikipedia.org/wiki/Coordinate_reference_system).
	 *
	 * Leaflet defines the most usual CRSs by default. If you want to use a
	 * CRS not defined by default, take a look at the
	 * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
	 *
	 * Note that the CRS instances do not inherit from Leafet's `Class` object,
	 * and can't be instantiated. Also, new classes can't inherit from them,
	 * and methods can't be added to them with the `include` function.
	 */
	
	var CRS = {
		// @method latLngToPoint(latlng: LatLng, zoom: Number): Point
		// Projects geographical coordinates into pixel coordinates for a given zoom.
		latLngToPoint: function (latlng, zoom) {
			var projectedPoint = this.projection.project(latlng),
			    scale = this.scale(zoom);
	
			return this.transformation._transform(projectedPoint, scale);
		},
	
		// @method pointToLatLng(point: Point, zoom: Number): LatLng
		// The inverse of `latLngToPoint`. Projects pixel coordinates on a given
		// zoom into geographical coordinates.
		pointToLatLng: function (point, zoom) {
			var scale = this.scale(zoom),
			    untransformedPoint = this.transformation.untransform(point, scale);
	
			return this.projection.unproject(untransformedPoint);
		},
	
		// @method project(latlng: LatLng): Point
		// Projects geographical coordinates into coordinates in units accepted for
		// this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
		project: function (latlng) {
			return this.projection.project(latlng);
		},
	
		// @method unproject(point: Point): LatLng
		// Given a projected coordinate returns the corresponding LatLng.
		// The inverse of `project`.
		unproject: function (point) {
			return this.projection.unproject(point);
		},
	
		// @method scale(zoom: Number): Number
		// Returns the scale used when transforming projected coordinates into
		// pixel coordinates for a particular zoom. For example, it returns
		// `256 * 2^zoom` for Mercator-based CRS.
		scale: function (zoom) {
			return 256 * Math.pow(2, zoom);
		},
	
		// @method zoom(scale: Number): Number
		// Inverse of `scale()`, returns the zoom level corresponding to a scale
		// factor of `scale`.
		zoom: function (scale) {
			return Math.log(scale / 256) / Math.LN2;
		},
	
		// @method getProjectedBounds(zoom: Number): Bounds
		// Returns the projection's bounds scaled and transformed for the provided `zoom`.
		getProjectedBounds: function (zoom) {
			if (this.infinite) { return null; }
	
			var b = this.projection.bounds,
			    s = this.scale(zoom),
			    min = this.transformation.transform(b.min, s),
			    max = this.transformation.transform(b.max, s);
	
			return new Bounds(min, max);
		},
	
		// @method distance(latlng1: LatLng, latlng2: LatLng): Number
		// Returns the distance between two geographical coordinates.
	
		// @property code: String
		// Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
		//
		// @property wrapLng: Number[]
		// An array of two numbers defining whether the longitude (horizontal) coordinate
		// axis wraps around a given range and how. Defaults to `[-180, 180]` in most
		// geographical CRSs. If `undefined`, the longitude axis does not wrap around.
		//
		// @property wrapLat: Number[]
		// Like `wrapLng`, but for the latitude (vertical) axis.
	
		// wrapLng: [min, max],
		// wrapLat: [min, max],
	
		// @property infinite: Boolean
		// If true, the coordinate space will be unbounded (infinite in both axes)
		infinite: false,
	
		// @method wrapLatLng(latlng: LatLng): LatLng
		// Returns a `LatLng` where lat and lng has been wrapped according to the
		// CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
		wrapLatLng: function (latlng) {
			var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng,
			    lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat,
			    alt = latlng.alt;
	
			return new LatLng(lat, lng, alt);
		},
	
		// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
		// Returns a `LatLngBounds` with the same size as the given one, ensuring
		// that its center is within the CRS's bounds.
		// Only accepts actual `L.LatLngBounds` instances, not arrays.
		wrapLatLngBounds: function (bounds) {
			var center = bounds.getCenter(),
			    newCenter = this.wrapLatLng(center),
			    latShift = center.lat - newCenter.lat,
			    lngShift = center.lng - newCenter.lng;
	
			if (latShift === 0 && lngShift === 0) {
				return bounds;
			}
	
			var sw = bounds.getSouthWest(),
			    ne = bounds.getNorthEast(),
			    newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift),
			    newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
	
			return new LatLngBounds(newSw, newNe);
		}
	};
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Earth
	 *
	 * Serves as the base for CRS that are global such that they cover the earth.
	 * Can only be used as the base for other CRS and cannot be used directly,
	 * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
	 * meters.
	 */
	
	var Earth = extend({}, CRS, {
		wrapLng: [-180, 180],
	
		// Mean Earth Radius, as recommended for use by
		// the International Union of Geodesy and Geophysics,
		// see http://rosettacode.org/wiki/Haversine_formula
		R: 6371000,
	
		// distance between two geographical points using spherical law of cosines approximation
		distance: function (latlng1, latlng2) {
			var rad = Math.PI / 180,
			    lat1 = latlng1.lat * rad,
			    lat2 = latlng2.lat * rad,
			    sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2),
			    sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2),
			    a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon,
			    c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
			return this.R * c;
		}
	});
	
	/*
	 * @namespace Projection
	 * @projection L.Projection.SphericalMercator
	 *
	 * Spherical Mercator projection — the most common projection for online maps,
	 * used by almost all free and commercial tile providers. Assumes that Earth is
	 * a sphere. Used by the `EPSG:3857` CRS.
	 */
	
	var earthRadius = 6378137;
	
	var SphericalMercator = {
	
		R: earthRadius,
		MAX_LATITUDE: 85.0511287798,
	
		project: function (latlng) {
			var d = Math.PI / 180,
			    max = this.MAX_LATITUDE,
			    lat = Math.max(Math.min(max, latlng.lat), -max),
			    sin = Math.sin(lat * d);
	
			return new Point(
				this.R * latlng.lng * d,
				this.R * Math.log((1 + sin) / (1 - sin)) / 2);
		},
	
		unproject: function (point) {
			var d = 180 / Math.PI;
	
			return new LatLng(
				(2 * Math.atan(Math.exp(point.y / this.R)) - (Math.PI / 2)) * d,
				point.x * d / this.R);
		},
	
		bounds: (function () {
			var d = earthRadius * Math.PI;
			return new Bounds([-d, -d], [d, d]);
		})()
	};
	
	/*
	 * @class Transformation
	 * @aka L.Transformation
	 *
	 * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
	 * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
	 * the reverse. Used by Leaflet in its projections code.
	 *
	 * @example
	 *
	 * ```js
	 * var transformation = L.transformation(2, 5, -1, 10),
	 * 	p = L.point(1, 2),
	 * 	p2 = transformation.transform(p), //  L.point(7, 8)
	 * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
	 * ```
	 */
	
	
	// factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
	// Creates a `Transformation` object with the given coefficients.
	function Transformation(a, b, c, d) {
		if (isArray(a)) {
			// use array properties
			this._a = a[0];
			this._b = a[1];
			this._c = a[2];
			this._d = a[3];
			return;
		}
		this._a = a;
		this._b = b;
		this._c = c;
		this._d = d;
	}
	
	Transformation.prototype = {
		// @method transform(point: Point, scale?: Number): Point
		// Returns a transformed point, optionally multiplied by the given scale.
		// Only accepts actual `L.Point` instances, not arrays.
		transform: function (point, scale) { // (Point, Number) -> Point
			return this._transform(point.clone(), scale);
		},
	
		// destructive transform (faster)
		_transform: function (point, scale) {
			scale = scale || 1;
			point.x = scale * (this._a * point.x + this._b);
			point.y = scale * (this._c * point.y + this._d);
			return point;
		},
	
		// @method untransform(point: Point, scale?: Number): Point
		// Returns the reverse transformation of the given point, optionally divided
		// by the given scale. Only accepts actual `L.Point` instances, not arrays.
		untransform: function (point, scale) {
			scale = scale || 1;
			return new Point(
			        (point.x / scale - this._b) / this._a,
			        (point.y / scale - this._d) / this._c);
		}
	};
	
	// factory L.transformation(a: Number, b: Number, c: Number, d: Number)
	
	// @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
	// Instantiates a Transformation object with the given coefficients.
	
	// @alternative
	// @factory L.transformation(coefficients: Array): Transformation
	// Expects an coefficients array of the form
	// `[a: Number, b: Number, c: Number, d: Number]`.
	
	function toTransformation(a, b, c, d) {
		return new Transformation(a, b, c, d);
	}
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG3857
	 *
	 * The most common CRS for online maps, used by almost all free and commercial
	 * tile providers. Uses Spherical Mercator projection. Set in by default in
	 * Map's `crs` option.
	 */
	
	var EPSG3857 = extend({}, Earth, {
		code: 'EPSG:3857',
		projection: SphericalMercator,
	
		transformation: (function () {
			var scale = 0.5 / (Math.PI * SphericalMercator.R);
			return toTransformation(scale, 0.5, -scale, 0.5);
		}())
	});
	
	var EPSG900913 = extend({}, EPSG3857, {
		code: 'EPSG:900913'
	});
	
	// @namespace SVG; @section
	// There are several static functions which can be called without instantiating L.SVG:
	
	// @function create(name: String): SVGElement
	// Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
	// corresponding to the class name passed. For example, using 'line' will return
	// an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
	function svgCreate(name) {
		return document.createElementNS('http://www.w3.org/2000/svg', name);
	}
	
	// @function pointsToPath(rings: Point[], closed: Boolean): String
	// Generates a SVG path string for multiple rings, with each ring turning
	// into "M..L..L.." instructions
	function pointsToPath(rings, closed) {
		var str = '',
		i, j, len, len2, points, p;
	
		for (i = 0, len = rings.length; i < len; i++) {
			points = rings[i];
	
			for (j = 0, len2 = points.length; j < len2; j++) {
				p = points[j];
				str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
			}
	
			// closes the ring for polygons; "x" is VML syntax
			str += closed ? (svg ? 'z' : 'x') : '';
		}
	
		// SVG complains about empty path strings
		return str || 'M0 0';
	}
	
	/*
	 * @namespace Browser
	 * @aka L.Browser
	 *
	 * A namespace with static properties for browser/feature detection used by Leaflet internally.
	 *
	 * @example
	 *
	 * ```js
	 * if (L.Browser.ielt9) {
	 *   alert('Upgrade your browser, dude!');
	 * }
	 * ```
	 */
	
	var style$1 = document.documentElement.style;
	
	// @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
	var ie = 'ActiveXObject' in window;
	
	// @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
	var ielt9 = ie && !document.addEventListener;
	
	// @property edge: Boolean; `true` for the Edge web browser.
	var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
	
	// @property webkit: Boolean;
	// `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
	var webkit = userAgentContains('webkit');
	
	// @property android: Boolean
	// `true` for any browser running on an Android platform.
	var android = userAgentContains('android');
	
	// @property android23: Boolean; `true` for browsers running on Android 2 or Android 3.
	var android23 = userAgentContains('android 2') || userAgentContains('android 3');
	
	/* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */
	var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
	// @property androidStock: Boolean; `true` for the Android stock browser (i.e. not Chrome)
	var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
	
	// @property opera: Boolean; `true` for the Opera browser
	var opera = !!window.opera;
	
	// @property chrome: Boolean; `true` for the Chrome browser.
	var chrome = userAgentContains('chrome');
	
	// @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
	var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
	
	// @property safari: Boolean; `true` for the Safari browser.
	var safari = !chrome && userAgentContains('safari');
	
	var phantom = userAgentContains('phantom');
	
	// @property opera12: Boolean
	// `true` for the Opera browser supporting CSS transforms (version 12 or later).
	var opera12 = 'OTransition' in style$1;
	
	// @property win: Boolean; `true` when the browser is running in a Windows platform
	var win = navigator.platform.indexOf('Win') === 0;
	
	// @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
	var ie3d = ie && ('transition' in style$1);
	
	// @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
	var webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23;
	
	// @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
	var gecko3d = 'MozPerspective' in style$1;
	
	// @property any3d: Boolean
	// `true` for all browsers supporting CSS transforms.
	var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
	
	// @property mobile: Boolean; `true` for all browsers running in a mobile device.
	var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
	
	// @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
	var mobileWebkit = mobile && webkit;
	
	// @property mobileWebkit3d: Boolean
	// `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
	var mobileWebkit3d = mobile && webkit3d;
	
	// @property msPointer: Boolean
	// `true` for browsers implementing the Microsoft touch events model (notably IE10).
	var msPointer = !window.PointerEvent && window.MSPointerEvent;
	
	// @property pointer: Boolean
	// `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
	var pointer = !!(window.PointerEvent || msPointer);
	
	// @property touch: Boolean
	// `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
	// This does not necessarily mean that the browser is running in a computer with
	// a touchscreen, it only means that the browser is capable of understanding
	// touch events.
	var touch = !window.L_NO_TOUCH && (pointer || 'ontouchstart' in window ||
			(window.DocumentTouch && document instanceof window.DocumentTouch));
	
	// @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
	var mobileOpera = mobile && opera;
	
	// @property mobileGecko: Boolean
	// `true` for gecko-based browsers running in a mobile device.
	var mobileGecko = mobile && gecko;
	
	// @property retina: Boolean
	// `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
	var retina = (window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI)) > 1;
	
	
	// @property canvas: Boolean
	// `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	var canvas = (function () {
		return !!document.createElement('canvas').getContext;
	}());
	
	// @property svg: Boolean
	// `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
	var svg = !!(document.createElementNS && svgCreate('svg').createSVGRect);
	
	// @property vml: Boolean
	// `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
	var vml = !svg && (function () {
		try {
			var div = document.createElement('div');
			div.innerHTML = '<v:shape adj="1"/>';
	
			var shape = div.firstChild;
			shape.style.behavior = 'url(#default#VML)';
	
			return shape && (typeof shape.adj === 'object');
	
		} catch (e) {
			return false;
		}
	}());
	
	
	function userAgentContains(str) {
		return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
	}
	
	
	var Browser = (Object.freeze || Object)({
		ie: ie,
		ielt9: ielt9,
		edge: edge,
		webkit: webkit,
		android: android,
		android23: android23,
		androidStock: androidStock,
		opera: opera,
		chrome: chrome,
		gecko: gecko,
		safari: safari,
		phantom: phantom,
		opera12: opera12,
		win: win,
		ie3d: ie3d,
		webkit3d: webkit3d,
		gecko3d: gecko3d,
		any3d: any3d,
		mobile: mobile,
		mobileWebkit: mobileWebkit,
		mobileWebkit3d: mobileWebkit3d,
		msPointer: msPointer,
		pointer: pointer,
		touch: touch,
		mobileOpera: mobileOpera,
		mobileGecko: mobileGecko,
		retina: retina,
		canvas: canvas,
		svg: svg,
		vml: vml
	});
	
	/*
	 * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
	 */
	
	
	var POINTER_DOWN =   msPointer ? 'MSPointerDown'   : 'pointerdown';
	var POINTER_MOVE =   msPointer ? 'MSPointerMove'   : 'pointermove';
	var POINTER_UP =     msPointer ? 'MSPointerUp'     : 'pointerup';
	var POINTER_CANCEL = msPointer ? 'MSPointerCancel' : 'pointercancel';
	var TAG_WHITE_LIST = ['INPUT', 'SELECT', 'OPTION'];
	
	var _pointers = {};
	var _pointerDocListener = false;
	
	// DomEvent.DoubleTap needs to know about this
	var _pointersCount = 0;
	
	// Provides a touch events wrapper for (ms)pointer events.
	// ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
	
	function addPointerListener(obj, type, handler, id) {
		if (type === 'touchstart') {
			_addPointerStart(obj, handler, id);
	
		} else if (type === 'touchmove') {
			_addPointerMove(obj, handler, id);
	
		} else if (type === 'touchend') {
			_addPointerEnd(obj, handler, id);
		}
	
		return this;
	}
	
	function removePointerListener(obj, type, id) {
		var handler = obj['_leaflet_' + type + id];
	
		if (type === 'touchstart') {
			obj.removeEventListener(POINTER_DOWN, handler, false);
	
		} else if (type === 'touchmove') {
			obj.removeEventListener(POINTER_MOVE, handler, false);
	
		} else if (type === 'touchend') {
			obj.removeEventListener(POINTER_UP, handler, false);
			obj.removeEventListener(POINTER_CANCEL, handler, false);
		}
	
		return this;
	}
	
	function _addPointerStart(obj, handler, id) {
		var onDown = bind(function (e) {
			if (e.pointerType !== 'mouse' && e.MSPOINTER_TYPE_MOUSE && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
				// In IE11, some touch events needs to fire for form controls, or
				// the controls will stop working. We keep a whitelist of tag names that
				// need these events. For other target tags, we prevent default on the event.
				if (TAG_WHITE_LIST.indexOf(e.target.tagName) < 0) {
					preventDefault(e);
				} else {
					return;
				}
			}
	
			_handlePointer(e, handler);
		});
	
		obj['_leaflet_touchstart' + id] = onDown;
		obj.addEventListener(POINTER_DOWN, onDown, false);
	
		// need to keep track of what pointers and how many are active to provide e.touches emulation
		if (!_pointerDocListener) {
			// we listen documentElement as any drags that end by moving the touch off the screen get fired there
			document.documentElement.addEventListener(POINTER_DOWN, _globalPointerDown, true);
			document.documentElement.addEventListener(POINTER_MOVE, _globalPointerMove, true);
			document.documentElement.addEventListener(POINTER_UP, _globalPointerUp, true);
			document.documentElement.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
	
			_pointerDocListener = true;
		}
	}
	
	function _globalPointerDown(e) {
		_pointers[e.pointerId] = e;
		_pointersCount++;
	}
	
	function _globalPointerMove(e) {
		if (_pointers[e.pointerId]) {
			_pointers[e.pointerId] = e;
		}
	}
	
	function _globalPointerUp(e) {
		delete _pointers[e.pointerId];
		_pointersCount--;
	}
	
	function _handlePointer(e, handler) {
		e.touches = [];
		for (var i in _pointers) {
			e.touches.push(_pointers[i]);
		}
		e.changedTouches = [e];
	
		handler(e);
	}
	
	function _addPointerMove(obj, handler, id) {
		var onMove = function (e) {
			// don't fire touch moves when mouse isn't down
			if ((e.pointerType === e.MSPOINTER_TYPE_MOUSE || e.pointerType === 'mouse') && e.buttons === 0) { return; }
	
			_handlePointer(e, handler);
		};
	
		obj['_leaflet_touchmove' + id] = onMove;
		obj.addEventListener(POINTER_MOVE, onMove, false);
	}
	
	function _addPointerEnd(obj, handler, id) {
		var onUp = function (e) {
			_handlePointer(e, handler);
		};
	
		obj['_leaflet_touchend' + id] = onUp;
		obj.addEventListener(POINTER_UP, onUp, false);
		obj.addEventListener(POINTER_CANCEL, onUp, false);
	}
	
	/*
	 * Extends the event handling code with double tap support for mobile browsers.
	 */
	
	var _touchstart = msPointer ? 'MSPointerDown' : pointer ? 'pointerdown' : 'touchstart';
	var _touchend = msPointer ? 'MSPointerUp' : pointer ? 'pointerup' : 'touchend';
	var _pre = '_leaflet_';
	
	// inspired by Zepto touch code by Thomas Fuchs
	function addDoubleTapListener(obj, handler, id) {
		var last, touch$$1,
		    doubleTap = false,
		    delay = 250;
	
		function onTouchStart(e) {
			var count;
	
			if (pointer) {
				if ((!edge) || e.pointerType === 'mouse') { return; }
				count = _pointersCount;
			} else {
				count = e.touches.length;
			}
	
			if (count > 1) { return; }
	
			var now = Date.now(),
			    delta = now - (last || now);
	
			touch$$1 = e.touches ? e.touches[0] : e;
			doubleTap = (delta > 0 && delta <= delay);
			last = now;
		}
	
		function onTouchEnd(e) {
			if (doubleTap && !touch$$1.cancelBubble) {
				if (pointer) {
					if ((!edge) || e.pointerType === 'mouse') { return; }
					// work around .type being readonly with MSPointer* events
					var newTouch = {},
					    prop, i;
	
					for (i in touch$$1) {
						prop = touch$$1[i];
						newTouch[i] = prop && prop.bind ? prop.bind(touch$$1) : prop;
					}
					touch$$1 = newTouch;
				}
				touch$$1.type = 'dblclick';
				touch$$1.button = 0;
				handler(touch$$1);
				last = null;
			}
		}
	
		obj[_pre + _touchstart + id] = onTouchStart;
		obj[_pre + _touchend + id] = onTouchEnd;
		obj[_pre + 'dblclick' + id] = handler;
	
		obj.addEventListener(_touchstart, onTouchStart, false);
		obj.addEventListener(_touchend, onTouchEnd, false);
	
		// On some platforms (notably, chrome<55 on win10 + touchscreen + mouse),
		// the browser doesn't fire touchend/pointerup events but does fire
		// native dblclicks. See #4127.
		// Edge 14 also fires native dblclicks, but only for pointerType mouse, see #5180.
		obj.addEventListener('dblclick', handler, false);
	
		return this;
	}
	
	function removeDoubleTapListener(obj, id) {
		var touchstart = obj[_pre + _touchstart + id],
		    touchend = obj[_pre + _touchend + id],
		    dblclick = obj[_pre + 'dblclick' + id];
	
		obj.removeEventListener(_touchstart, touchstart, false);
		obj.removeEventListener(_touchend, touchend, false);
		if (!edge) {
			obj.removeEventListener('dblclick', dblclick, false);
		}
	
		return this;
	}
	
	/*
	 * @namespace DomUtil
	 *
	 * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
	 * tree, used by Leaflet internally.
	 *
	 * Most functions expecting or returning a `HTMLElement` also work for
	 * SVG elements. The only difference is that classes refer to CSS classes
	 * in HTML and SVG classes in SVG.
	 */
	
	
	// @property TRANSFORM: String
	// Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
	var TRANSFORM = testProp(
		['transform', 'webkitTransform', 'OTransform', 'MozTransform', 'msTransform']);
	
	// webkitTransition comes first because some browser versions that drop vendor prefix don't do
	// the same for the transitionend event, in particular the Android 4.1 stock browser
	
	// @property TRANSITION: String
	// Vendor-prefixed transition style name.
	var TRANSITION = testProp(
		['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);
	
	// @property TRANSITION_END: String
	// Vendor-prefixed transitionend event name.
	var TRANSITION_END =
		TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
	
	
	// @function get(id: String|HTMLElement): HTMLElement
	// Returns an element given its DOM id, or returns the element itself
	// if it was passed directly.
	function get(id) {
		return typeof id === 'string' ? document.getElementById(id) : id;
	}
	
	// @function getStyle(el: HTMLElement, styleAttrib: String): String
	// Returns the value for a certain style attribute on an element,
	// including computed values or values set through CSS.
	function getStyle(el, style) {
		var value = el.style[style] || (el.currentStyle && el.currentStyle[style]);
	
		if ((!value || value === 'auto') && document.defaultView) {
			var css = document.defaultView.getComputedStyle(el, null);
			value = css ? css[style] : null;
		}
		return value === 'auto' ? null : value;
	}
	
	// @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
	// Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
	function create$1(tagName, className, container) {
		var el = document.createElement(tagName);
		el.className = className || '';
	
		if (container) {
			container.appendChild(el);
		}
		return el;
	}
	
	// @function remove(el: HTMLElement)
	// Removes `el` from its parent element
	function remove(el) {
		var parent = el.parentNode;
		if (parent) {
			parent.removeChild(el);
		}
	}
	
	// @function empty(el: HTMLElement)
	// Removes all of `el`'s children elements from `el`
	function empty(el) {
		while (el.firstChild) {
			el.removeChild(el.firstChild);
		}
	}
	
	// @function toFront(el: HTMLElement)
	// Makes `el` the last child of its parent, so it renders in front of the other children.
	function toFront(el) {
		var parent = el.parentNode;
		if (parent && parent.lastChild !== el) {
			parent.appendChild(el);
		}
	}
	
	// @function toBack(el: HTMLElement)
	// Makes `el` the first child of its parent, so it renders behind the other children.
	function toBack(el) {
		var parent = el.parentNode;
		if (parent && parent.firstChild !== el) {
			parent.insertBefore(el, parent.firstChild);
		}
	}
	
	// @function hasClass(el: HTMLElement, name: String): Boolean
	// Returns `true` if the element's class attribute contains `name`.
	function hasClass(el, name) {
		if (el.classList !== undefined) {
			return el.classList.contains(name);
		}
		var className = getClass(el);
		return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
	}
	
	// @function addClass(el: HTMLElement, name: String)
	// Adds `name` to the element's class attribute.
	function addClass(el, name) {
		if (el.classList !== undefined) {
			var classes = splitWords(name);
			for (var i = 0, len = classes.length; i < len; i++) {
				el.classList.add(classes[i]);
			}
		} else if (!hasClass(el, name)) {
			var className = getClass(el);
			setClass(el, (className ? className + ' ' : '') + name);
		}
	}
	
	// @function removeClass(el: HTMLElement, name: String)
	// Removes `name` from the element's class attribute.
	function removeClass(el, name) {
		if (el.classList !== undefined) {
			el.classList.remove(name);
		} else {
			setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
		}
	}
	
	// @function setClass(el: HTMLElement, name: String)
	// Sets the element's class.
	function setClass(el, name) {
		if (el.className.baseVal === undefined) {
			el.className = name;
		} else {
			// in case of SVG element
			el.className.baseVal = name;
		}
	}
	
	// @function getClass(el: HTMLElement): String
	// Returns the element's class.
	function getClass(el) {
		// Check if the element is an SVGElementInstance and use the correspondingElement instead
		// (Required for linked SVG elements in IE11.)
		if (el.correspondingElement) {
			el = el.correspondingElement;
		}
		return el.className.baseVal === undefined ? el.className : el.className.baseVal;
	}
	
	// @function setOpacity(el: HTMLElement, opacity: Number)
	// Set the opacity of an element (including old IE support).
	// `opacity` must be a number from `0` to `1`.
	function setOpacity(el, value) {
		if ('opacity' in el.style) {
			el.style.opacity = value;
		} else if ('filter' in el.style) {
			_setOpacityIE(el, value);
		}
	}
	
	function _setOpacityIE(el, value) {
		var filter = false,
		    filterName = 'DXImageTransform.Microsoft.Alpha';
	
		// filters collection throws an error if we try to retrieve a filter that doesn't exist
		try {
			filter = el.filters.item(filterName);
		} catch (e) {
			// don't set opacity to 1 if we haven't already set an opacity,
			// it isn't needed and breaks transparent pngs.
			if (value === 1) { return; }
		}
	
		value = Math.round(value * 100);
	
		if (filter) {
			filter.Enabled = (value !== 100);
			filter.Opacity = value;
		} else {
			el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
		}
	}
	
	// @function testProp(props: String[]): String|false
	// Goes through the array of style names and returns the first name
	// that is a valid style name for an element. If no such name is found,
	// it returns false. Useful for vendor-prefixed styles like `transform`.
	function testProp(props) {
		var style = document.documentElement.style;
	
		for (var i = 0; i < props.length; i++) {
			if (props[i] in style) {
				return props[i];
			}
		}
		return false;
	}
	
	// @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
	// Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
	// and optionally scaled by `scale`. Does not have an effect if the
	// browser doesn't support 3D CSS transforms.
	function setTransform(el, offset, scale) {
		var pos = offset || new Point(0, 0);
	
		el.style[TRANSFORM] =
			(ie3d ?
				'translate(' + pos.x + 'px,' + pos.y + 'px)' :
				'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') +
			(scale ? ' scale(' + scale + ')' : '');
	}
	
	// @function setPosition(el: HTMLElement, position: Point)
	// Sets the position of `el` to coordinates specified by `position`,
	// using CSS translate or top/left positioning depending on the browser
	// (used by Leaflet internally to position its layers).
	function setPosition(el, point) {
	
		/*eslint-disable */
		el._leaflet_pos = point;
		/* eslint-enable */
	
		if (any3d) {
			setTransform(el, point);
		} else {
			el.style.left = point.x + 'px';
			el.style.top = point.y + 'px';
		}
	}
	
	// @function getPosition(el: HTMLElement): Point
	// Returns the coordinates of an element previously positioned with setPosition.
	function getPosition(el) {
		// this method is only used for elements previously positioned using setPosition,
		// so it's safe to cache the position for performance
	
		return el._leaflet_pos || new Point(0, 0);
	}
	
	// @function disableTextSelection()
	// Prevents the user from generating `selectstart` DOM events, usually generated
	// when the user drags the mouse through a page with text. Used internally
	// by Leaflet to override the behaviour of any click-and-drag interaction on
	// the map. Affects drag interactions on the whole document.
	
	// @function enableTextSelection()
	// Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
	var disableTextSelection;
	var enableTextSelection;
	var _userSelect;
	if ('onselectstart' in document) {
		disableTextSelection = function () {
			on(window, 'selectstart', preventDefault);
		};
		enableTextSelection = function () {
			off(window, 'selectstart', preventDefault);
		};
	} else {
		var userSelectProperty = testProp(
			['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);
	
		disableTextSelection = function () {
			if (userSelectProperty) {
				var style = document.documentElement.style;
				_userSelect = style[userSelectProperty];
				style[userSelectProperty] = 'none';
			}
		};
		enableTextSelection = function () {
			if (userSelectProperty) {
				document.documentElement.style[userSelectProperty] = _userSelect;
				_userSelect = undefined;
			}
		};
	}
	
	// @function disableImageDrag()
	// As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
	// for `dragstart` DOM events, usually generated when the user drags an image.
	function disableImageDrag() {
		on(window, 'dragstart', preventDefault);
	}
	
	// @function enableImageDrag()
	// Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
	function enableImageDrag() {
		off(window, 'dragstart', preventDefault);
	}
	
	var _outlineElement;
	var _outlineStyle;
	// @function preventOutline(el: HTMLElement)
	// Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
	// of the element `el` invisible. Used internally by Leaflet to prevent
	// focusable elements from displaying an outline when the user performs a
	// drag interaction on them.
	function preventOutline(element) {
		while (element.tabIndex === -1) {
			element = element.parentNode;
		}
		if (!element.style) { return; }
		restoreOutline();
		_outlineElement = element;
		_outlineStyle = element.style.outline;
		element.style.outline = 'none';
		on(window, 'keydown', restoreOutline);
	}
	
	// @function restoreOutline()
	// Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
	function restoreOutline() {
		if (!_outlineElement) { return; }
		_outlineElement.style.outline = _outlineStyle;
		_outlineElement = undefined;
		_outlineStyle = undefined;
		off(window, 'keydown', restoreOutline);
	}
	
	// @function getSizedParentNode(el: HTMLElement): HTMLElement
	// Finds the closest parent node which size (width and height) is not null.
	function getSizedParentNode(element) {
		do {
			element = element.parentNode;
		} while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
		return element;
	}
	
	// @function getScale(el: HTMLElement): Object
	// Computes the CSS scale currently applied on the element.
	// Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
	// and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
	function getScale(element) {
		var rect = element.getBoundingClientRect(); // Read-only in old browsers.
	
		return {
			x: rect.width / element.offsetWidth || 1,
			y: rect.height / element.offsetHeight || 1,
			boundingClientRect: rect
		};
	}
	
	
	var DomUtil = (Object.freeze || Object)({
		TRANSFORM: TRANSFORM,
		TRANSITION: TRANSITION,
		TRANSITION_END: TRANSITION_END,
		get: get,
		getStyle: getStyle,
		create: create$1,
		remove: remove,
		empty: empty,
		toFront: toFront,
		toBack: toBack,
		hasClass: hasClass,
		addClass: addClass,
		removeClass: removeClass,
		setClass: setClass,
		getClass: getClass,
		setOpacity: setOpacity,
		testProp: testProp,
		setTransform: setTransform,
		setPosition: setPosition,
		getPosition: getPosition,
		disableTextSelection: disableTextSelection,
		enableTextSelection: enableTextSelection,
		disableImageDrag: disableImageDrag,
		enableImageDrag: enableImageDrag,
		preventOutline: preventOutline,
		restoreOutline: restoreOutline,
		getSizedParentNode: getSizedParentNode,
		getScale: getScale
	});
	
	/*
	 * @namespace DomEvent
	 * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
	 */
	
	// Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
	
	// @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
	// Adds a listener function (`fn`) to a particular DOM event type of the
	// element `el`. You can optionally specify the context of the listener
	// (object the `this` keyword will point to). You can also pass several
	// space-separated types (e.g. `'click dblclick'`).
	
	// @alternative
	// @function on(el: HTMLElement, eventMap: Object, context?: Object): this
	// Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	function on(obj, types, fn, context) {
	
		if (typeof types === 'object') {
			for (var type in types) {
				addOne(obj, type, types[type], fn);
			}
		} else {
			types = splitWords(types);
	
			for (var i = 0, len = types.length; i < len; i++) {
				addOne(obj, types[i], fn, context);
			}
		}
	
		return this;
	}
	
	var eventsKey = '_leaflet_events';
	
	// @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
	// Removes a previously added listener function.
	// Note that if you passed a custom context to on, you must pass the same
	// context to `off` in order to remove the listener.
	
	// @alternative
	// @function off(el: HTMLElement, eventMap: Object, context?: Object): this
	// Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	function off(obj, types, fn, context) {
	
		if (typeof types === 'object') {
			for (var type in types) {
				removeOne(obj, type, types[type], fn);
			}
		} else if (types) {
			types = splitWords(types);
	
			for (var i = 0, len = types.length; i < len; i++) {
				removeOne(obj, types[i], fn, context);
			}
		} else {
			for (var j in obj[eventsKey]) {
				removeOne(obj, j, obj[eventsKey][j]);
			}
			delete obj[eventsKey];
		}
	
		return this;
	}
	
	function addOne(obj, type, fn, context) {
		var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
	
		if (obj[eventsKey] && obj[eventsKey][id]) { return this; }
	
		var handler = function (e) {
			return fn.call(context || obj, e || window.event);
		};
	
		var originalHandler = handler;
	
		if (pointer && type.indexOf('touch') === 0) {
			// Needs DomEvent.Pointer.js
			addPointerListener(obj, type, handler, id);
	
		} else if (touch && (type === 'dblclick') && addDoubleTapListener &&
		           !(pointer && chrome)) {
			// Chrome >55 does not need the synthetic dblclicks from addDoubleTapListener
			// See #5180
			addDoubleTapListener(obj, handler, id);
	
		} else if ('addEventListener' in obj) {
	
			if (type === 'mousewheel') {
				obj.addEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);
	
			} else if ((type === 'mouseenter') || (type === 'mouseleave')) {
				handler = function (e) {
					e = e || window.event;
					if (isExternalTarget(obj, e)) {
						originalHandler(e);
					}
				};
				obj.addEventListener(type === 'mouseenter' ? 'mouseover' : 'mouseout', handler, false);
	
			} else {
				if (type === 'click' && android) {
					handler = function (e) {
						filterClick(e, originalHandler);
					};
				}
				obj.addEventListener(type, handler, false);
			}
	
		} else if ('attachEvent' in obj) {
			obj.attachEvent('on' + type, handler);
		}
	
		obj[eventsKey] = obj[eventsKey] || {};
		obj[eventsKey][id] = handler;
	}
	
	function removeOne(obj, type, fn, context) {
	
		var id = type + stamp(fn) + (context ? '_' + stamp(context) : ''),
		    handler = obj[eventsKey] && obj[eventsKey][id];
	
		if (!handler) { return this; }
	
		if (pointer && type.indexOf('touch') === 0) {
			removePointerListener(obj, type, id);
	
		} else if (touch && (type === 'dblclick') && removeDoubleTapListener &&
		           !(pointer && chrome)) {
			removeDoubleTapListener(obj, id);
	
		} else if ('removeEventListener' in obj) {
	
			if (type === 'mousewheel') {
				obj.removeEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);
	
			} else {
				obj.removeEventListener(
					type === 'mouseenter' ? 'mouseover' :
					type === 'mouseleave' ? 'mouseout' : type, handler, false);
			}
	
		} else if ('detachEvent' in obj) {
			obj.detachEvent('on' + type, handler);
		}
	
		obj[eventsKey][id] = null;
	}
	
	// @function stopPropagation(ev: DOMEvent): this
	// Stop the given event from propagation to parent elements. Used inside the listener functions:
	// ```js
	// L.DomEvent.on(div, 'click', function (ev) {
	// 	L.DomEvent.stopPropagation(ev);
	// });
	// ```
	function stopPropagation(e) {
	
		if (e.stopPropagation) {
			e.stopPropagation();
		} else if (e.originalEvent) {  // In case of Leaflet event.
			e.originalEvent._stopped = true;
		} else {
			e.cancelBubble = true;
		}
		skipped(e);
	
		return this;
	}
	
	// @function disableScrollPropagation(el: HTMLElement): this
	// Adds `stopPropagation` to the element's `'mousewheel'` events (plus browser variants).
	function disableScrollPropagation(el) {
		addOne(el, 'mousewheel', stopPropagation);
		return this;
	}
	
	// @function disableClickPropagation(el: HTMLElement): this
	// Adds `stopPropagation` to the element's `'click'`, `'doubleclick'`,
	// `'mousedown'` and `'touchstart'` events (plus browser variants).
	function disableClickPropagation(el) {
		on(el, 'mousedown touchstart dblclick', stopPropagation);
		addOne(el, 'click', fakeStop);
		return this;
	}
	
	// @function preventDefault(ev: DOMEvent): this
	// Prevents the default action of the DOM Event `ev` from happening (such as
	// following a link in the href of the a element, or doing a POST request
	// with page reload when a `<form>` is submitted).
	// Use it inside listener functions.
	function preventDefault(e) {
		if (e.preventDefault) {
			e.preventDefault();
		} else {
			e.returnValue = false;
		}
		return this;
	}
	
	// @function stop(ev: DOMEvent): this
	// Does `stopPropagation` and `preventDefault` at the same time.
	function stop(e) {
		preventDefault(e);
		stopPropagation(e);
		return this;
	}
	
	// @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
	// Gets normalized mouse position from a DOM event relative to the
	// `container` (border excluded) or to the whole page if not specified.
	function getMousePosition(e, container) {
		if (!container) {
			return new Point(e.clientX, e.clientY);
		}
	
		var scale = getScale(container),
		    offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
	
		return new Point(
			// offset.left/top values are in page scale (like clientX/Y),
			// whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
			(e.clientX - offset.left) / scale.x - container.clientLeft,
			(e.clientY - offset.top) / scale.y - container.clientTop
		);
	}
	
	// Chrome on Win scrolls double the pixels as in other platforms (see #4538),
	// and Firefox scrolls device pixels, not CSS pixels
	var wheelPxFactor =
		(win && chrome) ? 2 * window.devicePixelRatio :
		gecko ? window.devicePixelRatio : 1;
	
	// @function getWheelDelta(ev: DOMEvent): Number
	// Gets normalized wheel delta from a mousewheel DOM event, in vertical
	// pixels scrolled (negative if scrolling down).
	// Events from pointing devices without precise scrolling are mapped to
	// a best guess of 60 pixels.
	function getWheelDelta(e) {
		return (edge) ? e.wheelDeltaY / 2 : // Don't trust window-geometry-based delta
		       (e.deltaY && e.deltaMode === 0) ? -e.deltaY / wheelPxFactor : // Pixels
		       (e.deltaY && e.deltaMode === 1) ? -e.deltaY * 20 : // Lines
		       (e.deltaY && e.deltaMode === 2) ? -e.deltaY * 60 : // Pages
		       (e.deltaX || e.deltaZ) ? 0 :	// Skip horizontal/depth wheel events
		       e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : // Legacy IE pixels
		       (e.detail && Math.abs(e.detail) < 32765) ? -e.detail * 20 : // Legacy Moz lines
		       e.detail ? e.detail / -32765 * 60 : // Legacy Moz pages
		       0;
	}
	
	var skipEvents = {};
	
	function fakeStop(e) {
		// fakes stopPropagation by setting a special event flag, checked/reset with skipped(e)
		skipEvents[e.type] = true;
	}
	
	function skipped(e) {
		var events = skipEvents[e.type];
		// reset when checking, as it's only used in map container and propagates outside of the map
		skipEvents[e.type] = false;
		return events;
	}
	
	// check if element really left/entered the event target (for mouseenter/mouseleave)
	function isExternalTarget(el, e) {
	
		var related = e.relatedTarget;
	
		if (!related) { return true; }
	
		try {
			while (related && (related !== el)) {
				related = related.parentNode;
			}
		} catch (err) {
			return false;
		}
		return (related !== el);
	}
	
	var lastClick;
	
	// this is a horrible workaround for a bug in Android where a single touch triggers two click events
	function filterClick(e, handler) {
		var timeStamp = (e.timeStamp || (e.originalEvent && e.originalEvent.timeStamp)),
		    elapsed = lastClick && (timeStamp - lastClick);
	
		// are they closer together than 500ms yet more than 100ms?
		// Android typically triggers them ~300ms apart while multiple listeners
		// on the same event should be triggered far faster;
		// or check if click is simulated on the element, and if it is, reject any non-simulated events
	
		if ((elapsed && elapsed > 100 && elapsed < 500) || (e.target._simulatedClick && !e._simulated)) {
			stop(e);
			return;
		}
		lastClick = timeStamp;
	
		handler(e);
	}
	
	
	
	
	var DomEvent = (Object.freeze || Object)({
		on: on,
		off: off,
		stopPropagation: stopPropagation,
		disableScrollPropagation: disableScrollPropagation,
		disableClickPropagation: disableClickPropagation,
		preventDefault: preventDefault,
		stop: stop,
		getMousePosition: getMousePosition,
		getWheelDelta: getWheelDelta,
		fakeStop: fakeStop,
		skipped: skipped,
		isExternalTarget: isExternalTarget,
		addListener: on,
		removeListener: off
	});
	
	/*
	 * @class PosAnimation
	 * @aka L.PosAnimation
	 * @inherits Evented
	 * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
	 *
	 * @example
	 * ```js
	 * var fx = new L.PosAnimation();
	 * fx.run(el, [300, 500], 0.5);
	 * ```
	 *
	 * @constructor L.PosAnimation()
	 * Creates a `PosAnimation` object.
	 *
	 */
	
	var PosAnimation = Evented.extend({
	
		// @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
		// Run an animation of a given element to a new position, optionally setting
		// duration in seconds (`0.25` by default) and easing linearity factor (3rd
		// argument of the [cubic bezier curve](http://cubic-bezier.com/#0,0,.5,1),
		// `0.5` by default).
		run: function (el, newPos, duration, easeLinearity) {
			this.stop();
	
			this._el = el;
			this._inProgress = true;
			this._duration = duration || 0.25;
			this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
	
			this._startPos = getPosition(el);
			this._offset = newPos.subtract(this._startPos);
			this._startTime = +new Date();
	
			// @event start: Event
			// Fired when the animation starts
			this.fire('start');
	
			this._animate();
		},
	
		// @method stop()
		// Stops the animation (if currently running).
		stop: function () {
			if (!this._inProgress) { return; }
	
			this._step(true);
			this._complete();
		},
	
		_animate: function () {
			// animation loop
			this._animId = requestAnimFrame(this._animate, this);
			this._step();
		},
	
		_step: function (round) {
			var elapsed = (+new Date()) - this._startTime,
			    duration = this._duration * 1000;
	
			if (elapsed < duration) {
				this._runFrame(this._easeOut(elapsed / duration), round);
			} else {
				this._runFrame(1);
				this._complete();
			}
		},
	
		_runFrame: function (progress, round) {
			var pos = this._startPos.add(this._offset.multiplyBy(progress));
			if (round) {
				pos._round();
			}
			setPosition(this._el, pos);
	
			// @event step: Event
			// Fired continuously during the animation.
			this.fire('step');
		},
	
		_complete: function () {
			cancelAnimFrame(this._animId);
	
			this._inProgress = false;
			// @event end: Event
			// Fired when the animation ends.
			this.fire('end');
		},
	
		_easeOut: function (t) {
			return 1 - Math.pow(1 - t, this._easeOutPower);
		}
	});
	
	/*
	 * @class Map
	 * @aka L.Map
	 * @inherits Evented
	 *
	 * The central class of the API — it is used to create a map on a page and manipulate it.
	 *
	 * @example
	 *
	 * ```js
	 * // initialize the map on the "map" div with a given center and zoom
	 * var map = L.map('map', {
	 * 	center: [51.505, -0.09],
	 * 	zoom: 13
	 * });
	 * ```
	 *
	 */
	
	var Map = Evented.extend({
	
		options: {
			// @section Map State Options
			// @option crs: CRS = L.CRS.EPSG3857
			// The [Coordinate Reference System](#crs) to use. Don't change this if you're not
			// sure what it means.
			crs: EPSG3857,
	
			// @option center: LatLng = undefined
			// Initial geographic center of the map
			center: undefined,
	
			// @option zoom: Number = undefined
			// Initial map zoom level
			zoom: undefined,
	
			// @option minZoom: Number = *
			// Minimum zoom level of the map.
			// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
			// the lowest of their `minZoom` options will be used instead.
			minZoom: undefined,
	
			// @option maxZoom: Number = *
			// Maximum zoom level of the map.
			// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
			// the highest of their `maxZoom` options will be used instead.
			maxZoom: undefined,
	
			// @option layers: Layer[] = []
			// Array of layers that will be added to the map initially
			layers: [],
	
			// @option maxBounds: LatLngBounds = null
			// When this option is set, the map restricts the view to the given
			// geographical bounds, bouncing the user back if the user tries to pan
			// outside the view. To set the restriction dynamically, use
			// [`setMaxBounds`](#map-setmaxbounds) method.
			maxBounds: undefined,
	
			// @option renderer: Renderer = *
			// The default method for drawing vector layers on the map. `L.SVG`
			// or `L.Canvas` by default depending on browser support.
			renderer: undefined,
	
	
			// @section Animation Options
			// @option zoomAnimation: Boolean = true
			// Whether the map zoom animation is enabled. By default it's enabled
			// in all browsers that support CSS3 Transitions except Android.
			zoomAnimation: true,
	
			// @option zoomAnimationThreshold: Number = 4
			// Won't animate zoom if the zoom difference exceeds this value.
			zoomAnimationThreshold: 4,
	
			// @option fadeAnimation: Boolean = true
			// Whether the tile fade animation is enabled. By default it's enabled
			// in all browsers that support CSS3 Transitions except Android.
			fadeAnimation: true,
	
			// @option markerZoomAnimation: Boolean = true
			// Whether markers animate their zoom with the zoom animation, if disabled
			// they will disappear for the length of the animation. By default it's
			// enabled in all browsers that support CSS3 Transitions except Android.
			markerZoomAnimation: true,
	
			// @option transform3DLimit: Number = 2^23
			// Defines the maximum size of a CSS translation transform. The default
			// value should not be changed unless a web browser positions layers in
			// the wrong place after doing a large `panBy`.
			transform3DLimit: 8388608, // Precision limit of a 32-bit float
	
			// @section Interaction Options
			// @option zoomSnap: Number = 1
			// Forces the map's zoom level to always be a multiple of this, particularly
			// right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
			// By default, the zoom level snaps to the nearest integer; lower values
			// (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
			// means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
			zoomSnap: 1,
	
			// @option zoomDelta: Number = 1
			// Controls how much the map's zoom level will change after a
			// [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
			// or `-` on the keyboard, or using the [zoom controls](#control-zoom).
			// Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
			zoomDelta: 1,
	
			// @option trackResize: Boolean = true
			// Whether the map automatically handles browser window resize to update itself.
			trackResize: true
		},
	
		initialize: function (id, options) { // (HTMLElement or String, Object)
			options = setOptions(this, options);
	
			// Make sure to assign internal flags at the beginning,
			// to avoid inconsistent state in some edge cases.
			this._handlers = [];
			this._layers = {};
			this._zoomBoundLayers = {};
			this._sizeChanged = true;
	
			this._initContainer(id);
			this._initLayout();
	
			// hack for https://github.com/Leaflet/Leaflet/issues/1980
			this._onResize = bind(this._onResize, this);
	
			this._initEvents();
	
			if (options.maxBounds) {
				this.setMaxBounds(options.maxBounds);
			}
	
			if (options.zoom !== undefined) {
				this._zoom = this._limitZoom(options.zoom);
			}
	
			if (options.center && options.zoom !== undefined) {
				this.setView(toLatLng(options.center), options.zoom, {reset: true});
			}
	
			this.callInitHooks();
	
			// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
			this._zoomAnimated = TRANSITION && any3d && !mobileOpera &&
					this.options.zoomAnimation;
	
			// zoom transitions run with the same duration for all layers, so if one of transitionend events
			// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
			if (this._zoomAnimated) {
				this._createAnimProxy();
				on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
			}
	
			this._addLayers(this.options.layers);
		},
	
	
		// @section Methods for modifying map state
	
		// @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
		// Sets the view of the map (geographical center and zoom) with the given
		// animation options.
		setView: function (center, zoom, options) {
	
			zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
			center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
			options = options || {};
	
			this._stop();
	
			if (this._loaded && !options.reset && options !== true) {
	
				if (options.animate !== undefined) {
					options.zoom = extend({animate: options.animate}, options.zoom);
					options.pan = extend({animate: options.animate, duration: options.duration}, options.pan);
				}
	
				// try animating pan or zoom
				var moved = (this._zoom !== zoom) ?
					this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
					this._tryAnimatedPan(center, options.pan);
	
				if (moved) {
					// prevent resize handler call, the view will refresh after animation anyway
					clearTimeout(this._sizeTimer);
					return this;
				}
			}
	
			// animation didn't start, just reset the map view
			this._resetView(center, zoom);
	
			return this;
		},
	
		// @method setZoom(zoom: Number, options?: Zoom/pan options): this
		// Sets the zoom of the map.
		setZoom: function (zoom, options) {
			if (!this._loaded) {
				this._zoom = zoom;
				return this;
			}
			return this.setView(this.getCenter(), zoom, {zoom: options});
		},
	
		// @method zoomIn(delta?: Number, options?: Zoom options): this
		// Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
		zoomIn: function (delta, options) {
			delta = delta || (any3d ? this.options.zoomDelta : 1);
			return this.setZoom(this._zoom + delta, options);
		},
	
		// @method zoomOut(delta?: Number, options?: Zoom options): this
		// Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
		zoomOut: function (delta, options) {
			delta = delta || (any3d ? this.options.zoomDelta : 1);
			return this.setZoom(this._zoom - delta, options);
		},
	
		// @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
		// Zooms the map while keeping a specified geographical point on the map
		// stationary (e.g. used internally for scroll zoom and double-click zoom).
		// @alternative
		// @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
		// Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
		setZoomAround: function (latlng, zoom, options) {
			var scale = this.getZoomScale(zoom),
			    viewHalf = this.getSize().divideBy(2),
			    containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng),
	
			    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
			    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
	
			return this.setView(newCenter, zoom, {zoom: options});
		},
	
		_getBoundsCenterZoom: function (bounds, options) {
	
			options = options || {};
			bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
	
			var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
			    paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),
	
			    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
	
			zoom = (typeof options.maxZoom === 'number') ? Math.min(options.maxZoom, zoom) : zoom;
	
			if (zoom === Infinity) {
				return {
					center: bounds.getCenter(),
					zoom: zoom
				};
			}
	
			var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),
	
			    swPoint = this.project(bounds.getSouthWest(), zoom),
			    nePoint = this.project(bounds.getNorthEast(), zoom),
			    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
	
			return {
				center: center,
				zoom: zoom
			};
		},
	
		// @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
		// Sets a map view that contains the given geographical bounds with the
		// maximum zoom level possible.
		fitBounds: function (bounds, options) {
	
			bounds = toLatLngBounds(bounds);
	
			if (!bounds.isValid()) {
				throw new Error('Bounds are not valid.');
			}
	
			var target = this._getBoundsCenterZoom(bounds, options);
			return this.setView(target.center, target.zoom, options);
		},
	
		// @method fitWorld(options?: fitBounds options): this
		// Sets a map view that mostly contains the whole world with the maximum
		// zoom level possible.
		fitWorld: function (options) {
			return this.fitBounds([[-90, -180], [90, 180]], options);
		},
	
		// @method panTo(latlng: LatLng, options?: Pan options): this
		// Pans the map to a given center.
		panTo: function (center, options) { // (LatLng)
			return this.setView(center, this._zoom, {pan: options});
		},
	
		// @method panBy(offset: Point, options?: Pan options): this
		// Pans the map by a given number of pixels (animated).
		panBy: function (offset, options) {
			offset = toPoint(offset).round();
			options = options || {};
	
			if (!offset.x && !offset.y) {
				return this.fire('moveend');
			}
			// If we pan too far, Chrome gets issues with tiles
			// and makes them disappear or appear in the wrong place (slightly offset) #2602
			if (options.animate !== true && !this.getSize().contains(offset)) {
				this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
				return this;
			}
	
			if (!this._panAnim) {
				this._panAnim = new PosAnimation();
	
				this._panAnim.on({
					'step': this._onPanTransitionStep,
					'end': this._onPanTransitionEnd
				}, this);
			}
	
			// don't fire movestart if animating inertia
			if (!options.noMoveStart) {
				this.fire('movestart');
			}
	
			// animate pan unless animate: false specified
			if (options.animate !== false) {
				addClass(this._mapPane, 'leaflet-pan-anim');
	
				var newPos = this._getMapPanePos().subtract(offset).round();
				this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
			} else {
				this._rawPanBy(offset);
				this.fire('move').fire('moveend');
			}
	
			return this;
		},
	
		// @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
		// Sets the view of the map (geographical center and zoom) performing a smooth
		// pan-zoom animation.
		flyTo: function (targetCenter, targetZoom, options) {
	
			options = options || {};
			if (options.animate === false || !any3d) {
				return this.setView(targetCenter, targetZoom, options);
			}
	
			this._stop();
	
			var from = this.project(this.getCenter()),
			    to = this.project(targetCenter),
			    size = this.getSize(),
			    startZoom = this._zoom;
	
			targetCenter = toLatLng(targetCenter);
			targetZoom = targetZoom === undefined ? startZoom : targetZoom;
	
			var w0 = Math.max(size.x, size.y),
			    w1 = w0 * this.getZoomScale(startZoom, targetZoom),
			    u1 = (to.distanceTo(from)) || 1,
			    rho = 1.42,
			    rho2 = rho * rho;
	
			function r(i) {
				var s1 = i ? -1 : 1,
				    s2 = i ? w1 : w0,
				    t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1,
				    b1 = 2 * s2 * rho2 * u1,
				    b = t1 / b1,
				    sq = Math.sqrt(b * b + 1) - b;
	
				    // workaround for floating point precision bug when sq = 0, log = -Infinite,
				    // thus triggering an infinite loop in flyTo
				    var log = sq < 0.000000001 ? -18 : Math.log(sq);
	
				return log;
			}
	
			function sinh(n) { return (Math.exp(n) - Math.exp(-n)) / 2; }
			function cosh(n) { return (Math.exp(n) + Math.exp(-n)) / 2; }
			function tanh(n) { return sinh(n) / cosh(n); }
	
			var r0 = r(0);
	
			function w(s) { return w0 * (cosh(r0) / cosh(r0 + rho * s)); }
			function u(s) { return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2; }
	
			function easeOut(t) { return 1 - Math.pow(1 - t, 1.5); }
	
			var start = Date.now(),
			    S = (r(1) - r0) / rho,
			    duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
	
			function frame() {
				var t = (Date.now() - start) / duration,
				    s = easeOut(t) * S;
	
				if (t <= 1) {
					this._flyToFrame = requestAnimFrame(frame, this);
	
					this._move(
						this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom),
						this.getScaleZoom(w0 / w(s), startZoom),
						{flyTo: true});
	
				} else {
					this
						._move(targetCenter, targetZoom)
						._moveEnd(true);
				}
			}
	
			this._moveStart(true, options.noMoveStart);
	
			frame.call(this);
			return this;
		},
	
		// @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
		// Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
		// but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
		flyToBounds: function (bounds, options) {
			var target = this._getBoundsCenterZoom(bounds, options);
			return this.flyTo(target.center, target.zoom, options);
		},
	
		// @method setMaxBounds(bounds: Bounds): this
		// Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
		setMaxBounds: function (bounds) {
			bounds = toLatLngBounds(bounds);
	
			if (!bounds.isValid()) {
				this.options.maxBounds = null;
				return this.off('moveend', this._panInsideMaxBounds);
			} else if (this.options.maxBounds) {
				this.off('moveend', this._panInsideMaxBounds);
			}
	
			this.options.maxBounds = bounds;
	
			if (this._loaded) {
				this._panInsideMaxBounds();
			}
	
			return this.on('moveend', this._panInsideMaxBounds);
		},
	
		// @method setMinZoom(zoom: Number): this
		// Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
		setMinZoom: function (zoom) {
			var oldZoom = this.options.minZoom;
			this.options.minZoom = zoom;
	
			if (this._loaded && oldZoom !== zoom) {
				this.fire('zoomlevelschange');
	
				if (this.getZoom() < this.options.minZoom) {
					return this.setZoom(zoom);
				}
			}
	
			return this;
		},
	
		// @method setMaxZoom(zoom: Number): this
		// Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
		setMaxZoom: function (zoom) {
			var oldZoom = this.options.maxZoom;
			this.options.maxZoom = zoom;
	
			if (this._loaded && oldZoom !== zoom) {
				this.fire('zoomlevelschange');
	
				if (this.getZoom() > this.options.maxZoom) {
					return this.setZoom(zoom);
				}
			}
	
			return this;
		},
	
		// @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
		// Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
		panInsideBounds: function (bounds, options) {
			this._enforcingBounds = true;
			var center = this.getCenter(),
			    newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
	
			if (!center.equals(newCenter)) {
				this.panTo(newCenter, options);
			}
	
			this._enforcingBounds = false;
			return this;
		},
	
		// @method panInside(latlng: LatLng, options?: options): this
		// Pans the map the minimum amount to make the `latlng` visible. Use
		// `padding`, `paddingTopLeft` and `paddingTopRight` options to fit
		// the display to more restricted bounds, like [`fitBounds`](#map-fitbounds).
		// If `latlng` is already within the (optionally padded) display bounds,
		// the map will not be panned.
		panInside: function (latlng, options) {
			options = options || {};
	
			var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
			    paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),
			    center = this.getCenter(),
			    pixelCenter = this.project(center),
			    pixelPoint = this.project(latlng),
			    pixelBounds = this.getPixelBounds(),
			    halfPixelBounds = pixelBounds.getSize().divideBy(2),
			    paddedBounds = toBounds([pixelBounds.min.add(paddingTL), pixelBounds.max.subtract(paddingBR)]);
	
			if (!paddedBounds.contains(pixelPoint)) {
				this._enforcingBounds = true;
				var diff = pixelCenter.subtract(pixelPoint),
				    newCenter = toPoint(pixelPoint.x + diff.x, pixelPoint.y + diff.y);
	
				if (pixelPoint.x < paddedBounds.min.x || pixelPoint.x > paddedBounds.max.x) {
					newCenter.x = pixelCenter.x - diff.x;
					if (diff.x > 0) {
						newCenter.x += halfPixelBounds.x - paddingTL.x;
					} else {
						newCenter.x -= halfPixelBounds.x - paddingBR.x;
					}
				}
				if (pixelPoint.y < paddedBounds.min.y || pixelPoint.y > paddedBounds.max.y) {
					newCenter.y = pixelCenter.y - diff.y;
					if (diff.y > 0) {
						newCenter.y += halfPixelBounds.y - paddingTL.y;
					} else {
						newCenter.y -= halfPixelBounds.y - paddingBR.y;
					}
				}
				this.panTo(this.unproject(newCenter), options);
				this._enforcingBounds = false;
			}
			return this;
		},
	
		// @method invalidateSize(options: Zoom/pan options): this
		// Checks if the map container size changed and updates the map if so —
		// call it after you've changed the map size dynamically, also animating
		// pan by default. If `options.pan` is `false`, panning will not occur.
		// If `options.debounceMoveend` is `true`, it will delay `moveend` event so
		// that it doesn't happen often even if the method is called many
		// times in a row.
	
		// @alternative
		// @method invalidateSize(animate: Boolean): this
		// Checks if the map container size changed and updates the map if so —
		// call it after you've changed the map size dynamically, also animating
		// pan by default.
		invalidateSize: function (options) {
			if (!this._loaded) { return this; }
	
			options = extend({
				animate: false,
				pan: true
			}, options === true ? {animate: true} : options);
	
			var oldSize = this.getSize();
			this._sizeChanged = true;
			this._lastCenter = null;
	
			var newSize = this.getSize(),
			    oldCenter = oldSize.divideBy(2).round(),
			    newCenter = newSize.divideBy(2).round(),
			    offset = oldCenter.subtract(newCenter);
	
			if (!offset.x && !offset.y) { return this; }
	
			if (options.animate && options.pan) {
				this.panBy(offset);
	
			} else {
				if (options.pan) {
					this._rawPanBy(offset);
				}
	
				this.fire('move');
	
				if (options.debounceMoveend) {
					clearTimeout(this._sizeTimer);
					this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
				} else {
					this.fire('moveend');
				}
			}
	
			// @section Map state change events
			// @event resize: ResizeEvent
			// Fired when the map is resized.
			return this.fire('resize', {
				oldSize: oldSize,
				newSize: newSize
			});
		},
	
		// @section Methods for modifying map state
		// @method stop(): this
		// Stops the currently running `panTo` or `flyTo` animation, if any.
		stop: function () {
			this.setZoom(this._limitZoom(this._zoom));
			if (!this.options.zoomSnap) {
				this.fire('viewreset');
			}
			return this._stop();
		},
	
		// @section Geolocation methods
		// @method locate(options?: Locate options): this
		// Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
		// event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
		// and optionally sets the map view to the user's location with respect to
		// detection accuracy (or to the world view if geolocation failed).
		// Note that, if your page doesn't use HTTPS, this method will fail in
		// modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
		// See `Locate options` for more details.
		locate: function (options) {
	
			options = this._locateOptions = extend({
				timeout: 10000,
				watch: false
				// setView: false
				// maxZoom: <Number>
				// maximumAge: 0
				// enableHighAccuracy: false
			}, options);
	
			if (!('geolocation' in navigator)) {
				this._handleGeolocationError({
					code: 0,
					message: 'Geolocation not supported.'
				});
				return this;
			}
	
			var onResponse = bind(this._handleGeolocationResponse, this),
			    onError = bind(this._handleGeolocationError, this);
	
			if (options.watch) {
				this._locationWatchId =
				        navigator.geolocation.watchPosition(onResponse, onError, options);
			} else {
				navigator.geolocation.getCurrentPosition(onResponse, onError, options);
			}
			return this;
		},
	
		// @method stopLocate(): this
		// Stops watching location previously initiated by `map.locate({watch: true})`
		// and aborts resetting the map view if map.locate was called with
		// `{setView: true}`.
		stopLocate: function () {
			if (navigator.geolocation && navigator.geolocation.clearWatch) {
				navigator.geolocation.clearWatch(this._locationWatchId);
			}
			if (this._locateOptions) {
				this._locateOptions.setView = false;
			}
			return this;
		},
	
		_handleGeolocationError: function (error) {
			var c = error.code,
			    message = error.message ||
			            (c === 1 ? 'permission denied' :
			            (c === 2 ? 'position unavailable' : 'timeout'));
	
			if (this._locateOptions.setView && !this._loaded) {
				this.fitWorld();
			}
	
			// @section Location events
			// @event locationerror: ErrorEvent
			// Fired when geolocation (using the [`locate`](#map-locate) method) failed.
			this.fire('locationerror', {
				code: c,
				message: 'Geolocation error: ' + message + '.'
			});
		},
	
		_handleGeolocationResponse: function (pos) {
			var lat = pos.coords.latitude,
			    lng = pos.coords.longitude,
			    latlng = new LatLng(lat, lng),
			    bounds = latlng.toBounds(pos.coords.accuracy * 2),
			    options = this._locateOptions;
	
			if (options.setView) {
				var zoom = this.getBoundsZoom(bounds);
				this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
			}
	
			var data = {
				latlng: latlng,
				bounds: bounds,
				timestamp: pos.timestamp
			};
	
			for (var i in pos.coords) {
				if (typeof pos.coords[i] === 'number') {
					data[i] = pos.coords[i];
				}
			}
	
			// @event locationfound: LocationEvent
			// Fired when geolocation (using the [`locate`](#map-locate) method)
			// went successfully.
			this.fire('locationfound', data);
		},
	
		// TODO Appropriate docs section?
		// @section Other Methods
		// @method addHandler(name: String, HandlerClass: Function): this
		// Adds a new `Handler` to the map, given its name and constructor function.
		addHandler: function (name, HandlerClass) {
			if (!HandlerClass) { return this; }
	
			var handler = this[name] = new HandlerClass(this);
	
			this._handlers.push(handler);
	
			if (this.options[name]) {
				handler.enable();
			}
	
			return this;
		},
	
		// @method remove(): this
		// Destroys the map and clears all related event listeners.
		remove: function () {
	
			this._initEvents(true);
	
			if (this._containerId !== this._container._leaflet_id) {
				throw new Error('Map container is being reused by another instance');
			}
	
			try {
				// throws error in IE6-8
				delete this._container._leaflet_id;
				delete this._containerId;
			} catch (e) {
				/*eslint-disable */
				this._container._leaflet_id = undefined;
				/* eslint-enable */
				this._containerId = undefined;
			}
	
			if (this._locationWatchId !== undefined) {
				this.stopLocate();
			}
	
			this._stop();
	
			remove(this._mapPane);
	
			if (this._clearControlPos) {
				this._clearControlPos();
			}
			if (this._resizeRequest) {
				cancelAnimFrame(this._resizeRequest);
				this._resizeRequest = null;
			}
	
			this._clearHandlers();
	
			if (this._loaded) {
				// @section Map state change events
				// @event unload: Event
				// Fired when the map is destroyed with [remove](#map-remove) method.
				this.fire('unload');
			}
	
			var i;
			for (i in this._layers) {
				this._layers[i].remove();
			}
			for (i in this._panes) {
				remove(this._panes[i]);
			}
	
			this._layers = [];
			this._panes = [];
			delete this._mapPane;
			delete this._renderer;
	
			return this;
		},
	
		// @section Other Methods
		// @method createPane(name: String, container?: HTMLElement): HTMLElement
		// Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
		// then returns it. The pane is created as a child of `container`, or
		// as a child of the main map pane if not set.
		createPane: function (name, container) {
			var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''),
			    pane = create$1('div', className, container || this._mapPane);
	
			if (name) {
				this._panes[name] = pane;
			}
			return pane;
		},
	
		// @section Methods for Getting Map State
	
		// @method getCenter(): LatLng
		// Returns the geographical center of the map view
		getCenter: function () {
			this._checkIfLoaded();
	
			if (this._lastCenter && !this._moved()) {
				return this._lastCenter;
			}
			return this.layerPointToLatLng(this._getCenterLayerPoint());
		},
	
		// @method getZoom(): Number
		// Returns the current zoom level of the map view
		getZoom: function () {
			return this._zoom;
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the geographical bounds visible in the current map view
		getBounds: function () {
			var bounds = this.getPixelBounds(),
			    sw = this.unproject(bounds.getBottomLeft()),
			    ne = this.unproject(bounds.getTopRight());
	
			return new LatLngBounds(sw, ne);
		},
	
		// @method getMinZoom(): Number
		// Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
		getMinZoom: function () {
			return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
		},
	
		// @method getMaxZoom(): Number
		// Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
		getMaxZoom: function () {
			return this.options.maxZoom === undefined ?
				(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
				this.options.maxZoom;
		},
	
		// @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
		// Returns the maximum zoom level on which the given bounds fit to the map
		// view in its entirety. If `inside` (optional) is set to `true`, the method
		// instead returns the minimum zoom level on which the map view fits into
		// the given bounds in its entirety.
		getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
			bounds = toLatLngBounds(bounds);
			padding = toPoint(padding || [0, 0]);
	
			var zoom = this.getZoom() || 0,
			    min = this.getMinZoom(),
			    max = this.getMaxZoom(),
			    nw = bounds.getNorthWest(),
			    se = bounds.getSouthEast(),
			    size = this.getSize().subtract(padding),
			    boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(),
			    snap = any3d ? this.options.zoomSnap : 1,
			    scalex = size.x / boundsSize.x,
			    scaley = size.y / boundsSize.y,
			    scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
	
			zoom = this.getScaleZoom(scale, zoom);
	
			if (snap) {
				zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
				zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
			}
	
			return Math.max(min, Math.min(max, zoom));
		},
	
		// @method getSize(): Point
		// Returns the current size of the map container (in pixels).
		getSize: function () {
			if (!this._size || this._sizeChanged) {
				this._size = new Point(
					this._container.clientWidth || 0,
					this._container.clientHeight || 0);
	
				this._sizeChanged = false;
			}
			return this._size.clone();
		},
	
		// @method getPixelBounds(): Bounds
		// Returns the bounds of the current map view in projected pixel
		// coordinates (sometimes useful in layer and overlay implementations).
		getPixelBounds: function (center, zoom) {
			var topLeftPoint = this._getTopLeftPoint(center, zoom);
			return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
		},
	
		// TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
		// the map pane? "left point of the map layer" can be confusing, specially
		// since there can be negative offsets.
		// @method getPixelOrigin(): Point
		// Returns the projected pixel coordinates of the top left point of
		// the map layer (useful in custom layer and overlay implementations).
		getPixelOrigin: function () {
			this._checkIfLoaded();
			return this._pixelOrigin;
		},
	
		// @method getPixelWorldBounds(zoom?: Number): Bounds
		// Returns the world's bounds in pixel coordinates for zoom level `zoom`.
		// If `zoom` is omitted, the map's current zoom level is used.
		getPixelWorldBounds: function (zoom) {
			return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
		},
	
		// @section Other Methods
	
		// @method getPane(pane: String|HTMLElement): HTMLElement
		// Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
		getPane: function (pane) {
			return typeof pane === 'string' ? this._panes[pane] : pane;
		},
	
		// @method getPanes(): Object
		// Returns a plain object containing the names of all [panes](#map-pane) as keys and
		// the panes as values.
		getPanes: function () {
			return this._panes;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTML element that contains the map.
		getContainer: function () {
			return this._container;
		},
	
	
		// @section Conversion Methods
	
		// @method getZoomScale(toZoom: Number, fromZoom: Number): Number
		// Returns the scale factor to be applied to a map transition from zoom level
		// `fromZoom` to `toZoom`. Used internally to help with zoom animations.
		getZoomScale: function (toZoom, fromZoom) {
			// TODO replace with universal implementation after refactoring projections
			var crs = this.options.crs;
			fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
			return crs.scale(toZoom) / crs.scale(fromZoom);
		},
	
		// @method getScaleZoom(scale: Number, fromZoom: Number): Number
		// Returns the zoom level that the map would end up at, if it is at `fromZoom`
		// level and everything is scaled by a factor of `scale`. Inverse of
		// [`getZoomScale`](#map-getZoomScale).
		getScaleZoom: function (scale, fromZoom) {
			var crs = this.options.crs;
			fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
			var zoom = crs.zoom(scale * crs.scale(fromZoom));
			return isNaN(zoom) ? Infinity : zoom;
		},
	
		// @method project(latlng: LatLng, zoom: Number): Point
		// Projects a geographical coordinate `LatLng` according to the projection
		// of the map's CRS, then scales it according to `zoom` and the CRS's
		// `Transformation`. The result is pixel coordinate relative to
		// the CRS origin.
		project: function (latlng, zoom) {
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
		},
	
		// @method unproject(point: Point, zoom: Number): LatLng
		// Inverse of [`project`](#map-project).
		unproject: function (point, zoom) {
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.pointToLatLng(toPoint(point), zoom);
		},
	
		// @method layerPointToLatLng(point: Point): LatLng
		// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
		// returns the corresponding geographical coordinate (for the current zoom level).
		layerPointToLatLng: function (point) {
			var projectedPoint = toPoint(point).add(this.getPixelOrigin());
			return this.unproject(projectedPoint);
		},
	
		// @method latLngToLayerPoint(latlng: LatLng): Point
		// Given a geographical coordinate, returns the corresponding pixel coordinate
		// relative to the [origin pixel](#map-getpixelorigin).
		latLngToLayerPoint: function (latlng) {
			var projectedPoint = this.project(toLatLng(latlng))._round();
			return projectedPoint._subtract(this.getPixelOrigin());
		},
	
		// @method wrapLatLng(latlng: LatLng): LatLng
		// Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
		// map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
		// CRS's bounds.
		// By default this means longitude is wrapped around the dateline so its
		// value is between -180 and +180 degrees.
		wrapLatLng: function (latlng) {
			return this.options.crs.wrapLatLng(toLatLng(latlng));
		},
	
		// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
		// Returns a `LatLngBounds` with the same size as the given one, ensuring that
		// its center is within the CRS's bounds.
		// By default this means the center longitude is wrapped around the dateline so its
		// value is between -180 and +180 degrees, and the majority of the bounds
		// overlaps the CRS's bounds.
		wrapLatLngBounds: function (latlng) {
			return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
		},
	
		// @method distance(latlng1: LatLng, latlng2: LatLng): Number
		// Returns the distance between two geographical coordinates according to
		// the map's CRS. By default this measures distance in meters.
		distance: function (latlng1, latlng2) {
			return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
		},
	
		// @method containerPointToLayerPoint(point: Point): Point
		// Given a pixel coordinate relative to the map container, returns the corresponding
		// pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
		containerPointToLayerPoint: function (point) { // (Point)
			return toPoint(point).subtract(this._getMapPanePos());
		},
	
		// @method layerPointToContainerPoint(point: Point): Point
		// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
		// returns the corresponding pixel coordinate relative to the map container.
		layerPointToContainerPoint: function (point) { // (Point)
			return toPoint(point).add(this._getMapPanePos());
		},
	
		// @method containerPointToLatLng(point: Point): LatLng
		// Given a pixel coordinate relative to the map container, returns
		// the corresponding geographical coordinate (for the current zoom level).
		containerPointToLatLng: function (point) {
			var layerPoint = this.containerPointToLayerPoint(toPoint(point));
			return this.layerPointToLatLng(layerPoint);
		},
	
		// @method latLngToContainerPoint(latlng: LatLng): Point
		// Given a geographical coordinate, returns the corresponding pixel coordinate
		// relative to the map container.
		latLngToContainerPoint: function (latlng) {
			return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
		},
	
		// @method mouseEventToContainerPoint(ev: MouseEvent): Point
		// Given a MouseEvent object, returns the pixel coordinate relative to the
		// map container where the event took place.
		mouseEventToContainerPoint: function (e) {
			return getMousePosition(e, this._container);
		},
	
		// @method mouseEventToLayerPoint(ev: MouseEvent): Point
		// Given a MouseEvent object, returns the pixel coordinate relative to
		// the [origin pixel](#map-getpixelorigin) where the event took place.
		mouseEventToLayerPoint: function (e) {
			return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
		},
	
		// @method mouseEventToLatLng(ev: MouseEvent): LatLng
		// Given a MouseEvent object, returns geographical coordinate where the
		// event took place.
		mouseEventToLatLng: function (e) { // (MouseEvent)
			return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
		},
	
	
		// map initialization methods
	
		_initContainer: function (id) {
			var container = this._container = get(id);
	
			if (!container) {
				throw new Error('Map container not found.');
			} else if (container._leaflet_id) {
				throw new Error('Map container is already initialized.');
			}
	
			on(container, 'scroll', this._onScroll, this);
			this._containerId = stamp(container);
		},
	
		_initLayout: function () {
			var container = this._container;
	
			this._fadeAnimated = this.options.fadeAnimation && any3d;
	
			addClass(container, 'leaflet-container' +
				(touch ? ' leaflet-touch' : '') +
				(retina ? ' leaflet-retina' : '') +
				(ielt9 ? ' leaflet-oldie' : '') +
				(safari ? ' leaflet-safari' : '') +
				(this._fadeAnimated ? ' leaflet-fade-anim' : ''));
	
			var position = getStyle(container, 'position');
	
			if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') {
				container.style.position = 'relative';
			}
	
			this._initPanes();
	
			if (this._initControlPos) {
				this._initControlPos();
			}
		},
	
		_initPanes: function () {
			var panes = this._panes = {};
			this._paneRenderers = {};
	
			// @section
			//
			// Panes are DOM elements used to control the ordering of layers on the map. You
			// can access panes with [`map.getPane`](#map-getpane) or
			// [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
			// [`map.createPane`](#map-createpane) method.
			//
			// Every map has the following default panes that differ only in zIndex.
			//
			// @pane mapPane: HTMLElement = 'auto'
			// Pane that contains all other map panes
	
			this._mapPane = this.createPane('mapPane', this._container);
			setPosition(this._mapPane, new Point(0, 0));
	
			// @pane tilePane: HTMLElement = 200
			// Pane for `GridLayer`s and `TileLayer`s
			this.createPane('tilePane');
			// @pane overlayPane: HTMLElement = 400
			// Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
			this.createPane('shadowPane');
			// @pane shadowPane: HTMLElement = 500
			// Pane for overlay shadows (e.g. `Marker` shadows)
			this.createPane('overlayPane');
			// @pane markerPane: HTMLElement = 600
			// Pane for `Icon`s of `Marker`s
			this.createPane('markerPane');
			// @pane tooltipPane: HTMLElement = 650
			// Pane for `Tooltip`s.
			this.createPane('tooltipPane');
			// @pane popupPane: HTMLElement = 700
			// Pane for `Popup`s.
			this.createPane('popupPane');
	
			if (!this.options.markerZoomAnimation) {
				addClass(panes.markerPane, 'leaflet-zoom-hide');
				addClass(panes.shadowPane, 'leaflet-zoom-hide');
			}
		},
	
	
		// private methods that modify map state
	
		// @section Map state change events
		_resetView: function (center, zoom) {
			setPosition(this._mapPane, new Point(0, 0));
	
			var loading = !this._loaded;
			this._loaded = true;
			zoom = this._limitZoom(zoom);
	
			this.fire('viewprereset');
	
			var zoomChanged = this._zoom !== zoom;
			this
				._moveStart(zoomChanged, false)
				._move(center, zoom)
				._moveEnd(zoomChanged);
	
			// @event viewreset: Event
			// Fired when the map needs to redraw its content (this usually happens
			// on map zoom or load). Very useful for creating custom overlays.
			this.fire('viewreset');
	
			// @event load: Event
			// Fired when the map is initialized (when its center and zoom are set
			// for the first time).
			if (loading) {
				this.fire('load');
			}
		},
	
		_moveStart: function (zoomChanged, noMoveStart) {
			// @event zoomstart: Event
			// Fired when the map zoom is about to change (e.g. before zoom animation).
			// @event movestart: Event
			// Fired when the view of the map starts changing (e.g. user starts dragging the map).
			if (zoomChanged) {
				this.fire('zoomstart');
			}
			if (!noMoveStart) {
				this.fire('movestart');
			}
			return this;
		},
	
		_move: function (center, zoom, data) {
			if (zoom === undefined) {
				zoom = this._zoom;
			}
			var zoomChanged = this._zoom !== zoom;
	
			this._zoom = zoom;
			this._lastCenter = center;
			this._pixelOrigin = this._getNewPixelOrigin(center);
	
			// @event zoom: Event
			// Fired repeatedly during any change in zoom level, including zoom
			// and fly animations.
			if (zoomChanged || (data && data.pinch)) {	// Always fire 'zoom' if pinching because #3530
				this.fire('zoom', data);
			}
	
			// @event move: Event
			// Fired repeatedly during any movement of the map, including pan and
			// fly animations.
			return this.fire('move', data);
		},
	
		_moveEnd: function (zoomChanged) {
			// @event zoomend: Event
			// Fired when the map has changed, after any animations.
			if (zoomChanged) {
				this.fire('zoomend');
			}
	
			// @event moveend: Event
			// Fired when the center of the map stops changing (e.g. user stopped
			// dragging the map).
			return this.fire('moveend');
		},
	
		_stop: function () {
			cancelAnimFrame(this._flyToFrame);
			if (this._panAnim) {
				this._panAnim.stop();
			}
			return this;
		},
	
		_rawPanBy: function (offset) {
			setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
		},
	
		_getZoomSpan: function () {
			return this.getMaxZoom() - this.getMinZoom();
		},
	
		_panInsideMaxBounds: function () {
			if (!this._enforcingBounds) {
				this.panInsideBounds(this.options.maxBounds);
			}
		},
	
		_checkIfLoaded: function () {
			if (!this._loaded) {
				throw new Error('Set map center and zoom first.');
			}
		},
	
		// DOM event handling
	
		// @section Interaction events
		_initEvents: function (remove$$1) {
			this._targets = {};
			this._targets[stamp(this._container)] = this;
	
			var onOff = remove$$1 ? off : on;
	
			// @event click: MouseEvent
			// Fired when the user clicks (or taps) the map.
			// @event dblclick: MouseEvent
			// Fired when the user double-clicks (or double-taps) the map.
			// @event mousedown: MouseEvent
			// Fired when the user pushes the mouse button on the map.
			// @event mouseup: MouseEvent
			// Fired when the user releases the mouse button on the map.
			// @event mouseover: MouseEvent
			// Fired when the mouse enters the map.
			// @event mouseout: MouseEvent
			// Fired when the mouse leaves the map.
			// @event mousemove: MouseEvent
			// Fired while the mouse moves over the map.
			// @event contextmenu: MouseEvent
			// Fired when the user pushes the right mouse button on the map, prevents
			// default browser context menu from showing if there are listeners on
			// this event. Also fired on mobile when the user holds a single touch
			// for a second (also called long press).
			// @event keypress: KeyboardEvent
			// Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
			// @event keydown: KeyboardEvent
			// Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
			// the `keydown` event is fired for keys that produce a character value and for keys
			// that do not produce a character value.
			// @event keyup: KeyboardEvent
			// Fired when the user releases a key from the keyboard while the map is focused.
			onOff(this._container, 'click dblclick mousedown mouseup ' +
				'mouseover mouseout mousemove contextmenu keypress keydown keyup', this._handleDOMEvent, this);
	
			if (this.options.trackResize) {
				onOff(window, 'resize', this._onResize, this);
			}
	
			if (any3d && this.options.transform3DLimit) {
				(remove$$1 ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
			}
		},
	
		_onResize: function () {
			cancelAnimFrame(this._resizeRequest);
			this._resizeRequest = requestAnimFrame(
			        function () { this.invalidateSize({debounceMoveend: true}); }, this);
		},
	
		_onScroll: function () {
			this._container.scrollTop  = 0;
			this._container.scrollLeft = 0;
		},
	
		_onMoveEnd: function () {
			var pos = this._getMapPanePos();
			if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
				// https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
				// a pixel offset on very high values, see: http://jsfiddle.net/dg6r5hhb/
				this._resetView(this.getCenter(), this.getZoom());
			}
		},
	
		_findEventTargets: function (e, type) {
			var targets = [],
			    target,
			    isHover = type === 'mouseout' || type === 'mouseover',
			    src = e.target || e.srcElement,
			    dragging = false;
	
			while (src) {
				target = this._targets[stamp(src)];
				if (target && (type === 'click' || type === 'preclick') && !e._simulated && this._draggableMoved(target)) {
					// Prevent firing click after you just dragged an object.
					dragging = true;
					break;
				}
				if (target && target.listens(type, true)) {
					if (isHover && !isExternalTarget(src, e)) { break; }
					targets.push(target);
					if (isHover) { break; }
				}
				if (src === this._container) { break; }
				src = src.parentNode;
			}
			if (!targets.length && !dragging && !isHover && isExternalTarget(src, e)) {
				targets = [this];
			}
			return targets;
		},
	
		_handleDOMEvent: function (e) {
			if (!this._loaded || skipped(e)) { return; }
	
			var type = e.type;
	
			if (type === 'mousedown' || type === 'keypress' || type === 'keyup' || type === 'keydown') {
				// prevents outline when clicking on keyboard-focusable element
				preventOutline(e.target || e.srcElement);
			}
	
			this._fireDOMEvent(e, type);
		},
	
		_mouseEvents: ['click', 'dblclick', 'mouseover', 'mouseout', 'contextmenu'],
	
		_fireDOMEvent: function (e, type, targets) {
	
			if (e.type === 'click') {
				// Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
				// @event preclick: MouseEvent
				// Fired before mouse click on the map (sometimes useful when you
				// want something to happen on click before any existing click
				// handlers start running).
				var synth = extend({}, e);
				synth.type = 'preclick';
				this._fireDOMEvent(synth, synth.type, targets);
			}
	
			if (e._stopped) { return; }
	
			// Find the layer the event is propagating from and its parents.
			targets = (targets || []).concat(this._findEventTargets(e, type));
	
			if (!targets.length) { return; }
	
			var target = targets[0];
			if (type === 'contextmenu' && target.listens(type, true)) {
				preventDefault(e);
			}
	
			var data = {
				originalEvent: e
			};
	
			if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
				var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
				data.containerPoint = isMarker ?
					this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
				data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
				data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
			}
	
			for (var i = 0; i < targets.length; i++) {
				targets[i].fire(type, data, true);
				if (data.originalEvent._stopped ||
					(targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1)) { return; }
			}
		},
	
		_draggableMoved: function (obj) {
			obj = obj.dragging && obj.dragging.enabled() ? obj : this;
			return (obj.dragging && obj.dragging.moved()) || (this.boxZoom && this.boxZoom.moved());
		},
	
		_clearHandlers: function () {
			for (var i = 0, len = this._handlers.length; i < len; i++) {
				this._handlers[i].disable();
			}
		},
	
		// @section Other Methods
	
		// @method whenReady(fn: Function, context?: Object): this
		// Runs the given function `fn` when the map gets initialized with
		// a view (center and zoom) and at least one layer, or immediately
		// if it's already initialized, optionally passing a function context.
		whenReady: function (callback, context) {
			if (this._loaded) {
				callback.call(context || this, {target: this});
			} else {
				this.on('load', callback, context);
			}
			return this;
		},
	
	
		// private methods for getting map state
	
		_getMapPanePos: function () {
			return getPosition(this._mapPane) || new Point(0, 0);
		},
	
		_moved: function () {
			var pos = this._getMapPanePos();
			return pos && !pos.equals([0, 0]);
		},
	
		_getTopLeftPoint: function (center, zoom) {
			var pixelOrigin = center && zoom !== undefined ?
				this._getNewPixelOrigin(center, zoom) :
				this.getPixelOrigin();
			return pixelOrigin.subtract(this._getMapPanePos());
		},
	
		_getNewPixelOrigin: function (center, zoom) {
			var viewHalf = this.getSize()._divideBy(2);
			return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
		},
	
		_latLngToNewLayerPoint: function (latlng, zoom, center) {
			var topLeft = this._getNewPixelOrigin(center, zoom);
			return this.project(latlng, zoom)._subtract(topLeft);
		},
	
		_latLngBoundsToNewLayerBounds: function (latLngBounds, zoom, center) {
			var topLeft = this._getNewPixelOrigin(center, zoom);
			return toBounds([
				this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
			]);
		},
	
		// layer point of the current center
		_getCenterLayerPoint: function () {
			return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
		},
	
		// offset of the specified place to the current center in pixels
		_getCenterOffset: function (latlng) {
			return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
		},
	
		// adjust center for view to get inside bounds
		_limitCenter: function (center, zoom, bounds) {
	
			if (!bounds) { return center; }
	
			var centerPoint = this.project(center, zoom),
			    viewHalf = this.getSize().divideBy(2),
			    viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
			    offset = this._getBoundsOffset(viewBounds, bounds, zoom);
	
			// If offset is less than a pixel, ignore.
			// This prevents unstable projections from getting into
			// an infinite loop of tiny offsets.
			if (offset.round().equals([0, 0])) {
				return center;
			}
	
			return this.unproject(centerPoint.add(offset), zoom);
		},
	
		// adjust offset for view to get inside bounds
		_limitOffset: function (offset, bounds) {
			if (!bounds) { return offset; }
	
			var viewBounds = this.getPixelBounds(),
			    newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
	
			return offset.add(this._getBoundsOffset(newBounds, bounds));
		},
	
		// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
		_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
			var projectedMaxBounds = toBounds(
			        this.project(maxBounds.getNorthEast(), zoom),
			        this.project(maxBounds.getSouthWest(), zoom)
			    ),
			    minOffset = projectedMaxBounds.min.subtract(pxBounds.min),
			    maxOffset = projectedMaxBounds.max.subtract(pxBounds.max),
	
			    dx = this._rebound(minOffset.x, -maxOffset.x),
			    dy = this._rebound(minOffset.y, -maxOffset.y);
	
			return new Point(dx, dy);
		},
	
		_rebound: function (left, right) {
			return left + right > 0 ?
				Math.round(left - right) / 2 :
				Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
		},
	
		_limitZoom: function (zoom) {
			var min = this.getMinZoom(),
			    max = this.getMaxZoom(),
			    snap = any3d ? this.options.zoomSnap : 1;
			if (snap) {
				zoom = Math.round(zoom / snap) * snap;
			}
			return Math.max(min, Math.min(max, zoom));
		},
	
		_onPanTransitionStep: function () {
			this.fire('move');
		},
	
		_onPanTransitionEnd: function () {
			removeClass(this._mapPane, 'leaflet-pan-anim');
			this.fire('moveend');
		},
	
		_tryAnimatedPan: function (center, options) {
			// difference between the new and current centers in pixels
			var offset = this._getCenterOffset(center)._trunc();
	
			// don't animate too far unless animate: true specified in options
			if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }
	
			this.panBy(offset, options);
	
			return true;
		},
	
		_createAnimProxy: function () {
	
			var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
			this._panes.mapPane.appendChild(proxy);
	
			this.on('zoomanim', function (e) {
				var prop = TRANSFORM,
				    transform = this._proxy.style[prop];
	
				setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
	
				// workaround for case when transform is the same and so transitionend event is not fired
				if (transform === this._proxy.style[prop] && this._animatingZoom) {
					this._onZoomTransitionEnd();
				}
			}, this);
	
			this.on('load moveend', function () {
				var c = this.getCenter(),
				    z = this.getZoom();
				setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
			}, this);
	
			this._on('unload', this._destroyAnimProxy, this);
		},
	
		_destroyAnimProxy: function () {
			remove(this._proxy);
			delete this._proxy;
		},
	
		_catchTransitionEnd: function (e) {
			if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
				this._onZoomTransitionEnd();
			}
		},
	
		_nothingToAnimate: function () {
			return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
		},
	
		_tryAnimatedZoom: function (center, zoom, options) {
	
			if (this._animatingZoom) { return true; }
	
			options = options || {};
	
			// don't animate if disabled, not supported or zoom difference is too large
			if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
			        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }
	
			// offset is the pixel coords of the zoom origin relative to the current center
			var scale = this.getZoomScale(zoom),
			    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
	
			// don't animate if the zoom origin isn't within one screen from the current center, unless forced
			if (options.animate !== true && !this.getSize().contains(offset)) { return false; }
	
			requestAnimFrame(function () {
				this
				    ._moveStart(true, false)
				    ._animateZoom(center, zoom, true);
			}, this);
	
			return true;
		},
	
		_animateZoom: function (center, zoom, startAnim, noUpdate) {
			if (!this._mapPane) { return; }
	
			if (startAnim) {
				this._animatingZoom = true;
	
				// remember what center/zoom to set after animation
				this._animateToCenter = center;
				this._animateToZoom = zoom;
	
				addClass(this._mapPane, 'leaflet-zoom-anim');
			}
	
			// @event zoomanim: ZoomAnimEvent
			// Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
			this.fire('zoomanim', {
				center: center,
				zoom: zoom,
				noUpdate: noUpdate
			});
	
			// Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
			setTimeout(bind(this._onZoomTransitionEnd, this), 250);
		},
	
		_onZoomTransitionEnd: function () {
			if (!this._animatingZoom) { return; }
	
			if (this._mapPane) {
				removeClass(this._mapPane, 'leaflet-zoom-anim');
			}
	
			this._animatingZoom = false;
	
			this._move(this._animateToCenter, this._animateToZoom);
	
			// This anim frame should prevent an obscure iOS webkit tile loading race condition.
			requestAnimFrame(function () {
				this._moveEnd(true);
			}, this);
		}
	});
	
	// @section
	
	// @factory L.map(id: String, options?: Map options)
	// Instantiates a map object given the DOM ID of a `<div>` element
	// and optionally an object literal with `Map options`.
	//
	// @alternative
	// @factory L.map(el: HTMLElement, options?: Map options)
	// Instantiates a map object given an instance of a `<div>` HTML element
	// and optionally an object literal with `Map options`.
	function createMap(id, options) {
		return new Map(id, options);
	}
	
	/*
	 * @class Control
	 * @aka L.Control
	 * @inherits Class
	 *
	 * L.Control is a base class for implementing map controls. Handles positioning.
	 * All other controls extend from this class.
	 */
	
	var Control = Class.extend({
		// @section
		// @aka Control options
		options: {
			// @option position: String = 'topright'
			// The position of the control (one of the map corners). Possible values are `'topleft'`,
			// `'topright'`, `'bottomleft'` or `'bottomright'`
			position: 'topright'
		},
	
		initialize: function (options) {
			setOptions(this, options);
		},
	
		/* @section
		 * Classes extending L.Control will inherit the following methods:
		 *
		 * @method getPosition: string
		 * Returns the position of the control.
		 */
		getPosition: function () {
			return this.options.position;
		},
	
		// @method setPosition(position: string): this
		// Sets the position of the control.
		setPosition: function (position) {
			var map = this._map;
	
			if (map) {
				map.removeControl(this);
			}
	
			this.options.position = position;
	
			if (map) {
				map.addControl(this);
			}
	
			return this;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTMLElement that contains the control.
		getContainer: function () {
			return this._container;
		},
	
		// @method addTo(map: Map): this
		// Adds the control to the given map.
		addTo: function (map) {
			this.remove();
			this._map = map;
	
			var container = this._container = this.onAdd(map),
			    pos = this.getPosition(),
			    corner = map._controlCorners[pos];
	
			addClass(container, 'leaflet-control');
	
			if (pos.indexOf('bottom') !== -1) {
				corner.insertBefore(container, corner.firstChild);
			} else {
				corner.appendChild(container);
			}
	
			this._map.on('unload', this.remove, this);
	
			return this;
		},
	
		// @method remove: this
		// Removes the control from the map it is currently active on.
		remove: function () {
			if (!this._map) {
				return this;
			}
	
			remove(this._container);
	
			if (this.onRemove) {
				this.onRemove(this._map);
			}
	
			this._map.off('unload', this.remove, this);
			this._map = null;
	
			return this;
		},
	
		_refocusOnMap: function (e) {
			// if map exists and event is not a keyboard event
			if (this._map && e && e.screenX > 0 && e.screenY > 0) {
				this._map.getContainer().focus();
			}
		}
	});
	
	var control = function (options) {
		return new Control(options);
	};
	
	/* @section Extension methods
	 * @uninheritable
	 *
	 * Every control should extend from `L.Control` and (re-)implement the following methods.
	 *
	 * @method onAdd(map: Map): HTMLElement
	 * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
	 *
	 * @method onRemove(map: Map)
	 * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
	 */
	
	/* @namespace Map
	 * @section Methods for Layers and Controls
	 */
	Map.include({
		// @method addControl(control: Control): this
		// Adds the given control to the map
		addControl: function (control) {
			control.addTo(this);
			return this;
		},
	
		// @method removeControl(control: Control): this
		// Removes the given control from the map
		removeControl: function (control) {
			control.remove();
			return this;
		},
	
		_initControlPos: function () {
			var corners = this._controlCorners = {},
			    l = 'leaflet-',
			    container = this._controlContainer =
			            create$1('div', l + 'control-container', this._container);
	
			function createCorner(vSide, hSide) {
				var className = l + vSide + ' ' + l + hSide;
	
				corners[vSide + hSide] = create$1('div', className, container);
			}
	
			createCorner('top', 'left');
			createCorner('top', 'right');
			createCorner('bottom', 'left');
			createCorner('bottom', 'right');
		},
	
		_clearControlPos: function () {
			for (var i in this._controlCorners) {
				remove(this._controlCorners[i]);
			}
			remove(this._controlContainer);
			delete this._controlCorners;
			delete this._controlContainer;
		}
	});
	
	/*
	 * @class Control.Layers
	 * @aka L.Control.Layers
	 * @inherits Control
	 *
	 * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](http://leafletjs.com/examples/layers-control/)). Extends `Control`.
	 *
	 * @example
	 *
	 * ```js
	 * var baseLayers = {
	 * 	"Mapbox": mapbox,
	 * 	"OpenStreetMap": osm
	 * };
	 *
	 * var overlays = {
	 * 	"Marker": marker,
	 * 	"Roads": roadsLayer
	 * };
	 *
	 * L.control.layers(baseLayers, overlays).addTo(map);
	 * ```
	 *
	 * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
	 *
	 * ```js
	 * {
	 *     "<someName1>": layer1,
	 *     "<someName2>": layer2
	 * }
	 * ```
	 *
	 * The layer names can contain HTML, which allows you to add additional styling to the items:
	 *
	 * ```js
	 * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
	 * ```
	 */
	
	var Layers = Control.extend({
		// @section
		// @aka Control.Layers options
		options: {
			// @option collapsed: Boolean = true
			// If `true`, the control will be collapsed into an icon and expanded on mouse hover or touch.
			collapsed: true,
			position: 'topright',
	
			// @option autoZIndex: Boolean = true
			// If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
			autoZIndex: true,
	
			// @option hideSingleBase: Boolean = false
			// If `true`, the base layers in the control will be hidden when there is only one.
			hideSingleBase: false,
	
			// @option sortLayers: Boolean = false
			// Whether to sort the layers. When `false`, layers will keep the order
			// in which they were added to the control.
			sortLayers: false,
	
			// @option sortFunction: Function = *
			// A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
			// that will be used for sorting the layers, when `sortLayers` is `true`.
			// The function receives both the `L.Layer` instances and their names, as in
			// `sortFunction(layerA, layerB, nameA, nameB)`.
			// By default, it sorts layers alphabetically by their name.
			sortFunction: function (layerA, layerB, nameA, nameB) {
				return nameA < nameB ? -1 : (nameB < nameA ? 1 : 0);
			}
		},
	
		initialize: function (baseLayers, overlays, options) {
			setOptions(this, options);
	
			this._layerControlInputs = [];
			this._layers = [];
			this._lastZIndex = 0;
			this._handlingClick = false;
	
			for (var i in baseLayers) {
				this._addLayer(baseLayers[i], i);
			}
	
			for (i in overlays) {
				this._addLayer(overlays[i], i, true);
			}
		},
	
		onAdd: function (map) {
			this._initLayout();
			this._update();
	
			this._map = map;
			map.on('zoomend', this._checkDisabledLayers, this);
	
			for (var i = 0; i < this._layers.length; i++) {
				this._layers[i].layer.on('add remove', this._onLayerChange, this);
			}
	
			return this._container;
		},
	
		addTo: function (map) {
			Control.prototype.addTo.call(this, map);
			// Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
			return this._expandIfNotCollapsed();
		},
	
		onRemove: function () {
			this._map.off('zoomend', this._checkDisabledLayers, this);
	
			for (var i = 0; i < this._layers.length; i++) {
				this._layers[i].layer.off('add remove', this._onLayerChange, this);
			}
		},
	
		// @method addBaseLayer(layer: Layer, name: String): this
		// Adds a base layer (radio button entry) with the given name to the control.
		addBaseLayer: function (layer, name) {
			this._addLayer(layer, name);
			return (this._map) ? this._update() : this;
		},
	
		// @method addOverlay(layer: Layer, name: String): this
		// Adds an overlay (checkbox entry) with the given name to the control.
		addOverlay: function (layer, name) {
			this._addLayer(layer, name, true);
			return (this._map) ? this._update() : this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Remove the given layer from the control.
		removeLayer: function (layer) {
			layer.off('add remove', this._onLayerChange, this);
	
			var obj = this._getLayer(stamp(layer));
			if (obj) {
				this._layers.splice(this._layers.indexOf(obj), 1);
			}
			return (this._map) ? this._update() : this;
		},
	
		// @method expand(): this
		// Expand the control container if collapsed.
		expand: function () {
			addClass(this._container, 'leaflet-control-layers-expanded');
			this._section.style.height = null;
			var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
			if (acceptableHeight < this._section.clientHeight) {
				addClass(this._section, 'leaflet-control-layers-scrollbar');
				this._section.style.height = acceptableHeight + 'px';
			} else {
				removeClass(this._section, 'leaflet-control-layers-scrollbar');
			}
			this._checkDisabledLayers();
			return this;
		},
	
		// @method collapse(): this
		// Collapse the control container if expanded.
		collapse: function () {
			removeClass(this._container, 'leaflet-control-layers-expanded');
			return this;
		},
	
		_initLayout: function () {
			var className = 'leaflet-control-layers',
			    container = this._container = create$1('div', className),
			    collapsed = this.options.collapsed;
	
			// makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
			container.setAttribute('aria-haspopup', true);
	
			disableClickPropagation(container);
			disableScrollPropagation(container);
	
			var section = this._section = create$1('section', className + '-list');
	
			if (collapsed) {
				this._map.on('click', this.collapse, this);
	
				if (!android) {
					on(container, {
						mouseenter: this.expand,
						mouseleave: this.collapse
					}, this);
				}
			}
	
			var link = this._layersLink = create$1('a', className + '-toggle', container);
			link.href = '#';
			link.title = 'Layers';
	
			if (touch) {
				on(link, 'click', stop);
				on(link, 'click', this.expand, this);
			} else {
				on(link, 'focus', this.expand, this);
			}
	
			if (!collapsed) {
				this.expand();
			}
	
			this._baseLayersList = create$1('div', className + '-base', section);
			this._separator = create$1('div', className + '-separator', section);
			this._overlaysList = create$1('div', className + '-overlays', section);
	
			container.appendChild(section);
		},
	
		_getLayer: function (id) {
			for (var i = 0; i < this._layers.length; i++) {
	
				if (this._layers[i] && stamp(this._layers[i].layer) === id) {
					return this._layers[i];
				}
			}
		},
	
		_addLayer: function (layer, name, overlay) {
			if (this._map) {
				layer.on('add remove', this._onLayerChange, this);
			}
	
			this._layers.push({
				layer: layer,
				name: name,
				overlay: overlay
			});
	
			if (this.options.sortLayers) {
				this._layers.sort(bind(function (a, b) {
					return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
				}, this));
			}
	
			if (this.options.autoZIndex && layer.setZIndex) {
				this._lastZIndex++;
				layer.setZIndex(this._lastZIndex);
			}
	
			this._expandIfNotCollapsed();
		},
	
		_update: function () {
			if (!this._container) { return this; }
	
			empty(this._baseLayersList);
			empty(this._overlaysList);
	
			this._layerControlInputs = [];
			var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
	
			for (i = 0; i < this._layers.length; i++) {
				obj = this._layers[i];
				this._addItem(obj);
				overlaysPresent = overlaysPresent || obj.overlay;
				baseLayersPresent = baseLayersPresent || !obj.overlay;
				baseLayersCount += !obj.overlay ? 1 : 0;
			}
	
			// Hide base layers section if there's only one layer.
			if (this.options.hideSingleBase) {
				baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
				this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
			}
	
			this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
	
			return this;
		},
	
		_onLayerChange: function (e) {
			if (!this._handlingClick) {
				this._update();
			}
	
			var obj = this._getLayer(stamp(e.target));
	
			// @namespace Map
			// @section Layer events
			// @event baselayerchange: LayersControlEvent
			// Fired when the base layer is changed through the [layer control](#control-layers).
			// @event overlayadd: LayersControlEvent
			// Fired when an overlay is selected through the [layer control](#control-layers).
			// @event overlayremove: LayersControlEvent
			// Fired when an overlay is deselected through the [layer control](#control-layers).
			// @namespace Control.Layers
			var type = obj.overlay ?
				(e.type === 'add' ? 'overlayadd' : 'overlayremove') :
				(e.type === 'add' ? 'baselayerchange' : null);
	
			if (type) {
				this._map.fire(type, obj);
			}
		},
	
		// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
		_createRadioElement: function (name, checked) {
	
			var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' +
					name + '"' + (checked ? ' checked="checked"' : '') + '/>';
	
			var radioFragment = document.createElement('div');
			radioFragment.innerHTML = radioHtml;
	
			return radioFragment.firstChild;
		},
	
		_addItem: function (obj) {
			var label = document.createElement('label'),
			    checked = this._map.hasLayer(obj.layer),
			    input;
	
			if (obj.overlay) {
				input = document.createElement('input');
				input.type = 'checkbox';
				input.className = 'leaflet-control-layers-selector';
				input.defaultChecked = checked;
			} else {
				input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
			}
	
			this._layerControlInputs.push(input);
			input.layerId = stamp(obj.layer);
	
			on(input, 'click', this._onInputClick, this);
	
			var name = document.createElement('span');
			name.innerHTML = ' ' + obj.name;
	
			// Helps from preventing layer control flicker when checkboxes are disabled
			// https://github.com/Leaflet/Leaflet/issues/2771
			var holder = document.createElement('div');
	
			label.appendChild(holder);
			holder.appendChild(input);
			holder.appendChild(name);
	
			var container = obj.overlay ? this._overlaysList : this._baseLayersList;
			container.appendChild(label);
	
			this._checkDisabledLayers();
			return label;
		},
	
		_onInputClick: function () {
			var inputs = this._layerControlInputs,
			    input, layer;
			var addedLayers = [],
			    removedLayers = [];
	
			this._handlingClick = true;
	
			for (var i = inputs.length - 1; i >= 0; i--) {
				input = inputs[i];
				layer = this._getLayer(input.layerId).layer;
	
				if (input.checked) {
					addedLayers.push(layer);
				} else if (!input.checked) {
					removedLayers.push(layer);
				}
			}
	
			// Bugfix issue 2318: Should remove all old layers before readding new ones
			for (i = 0; i < removedLayers.length; i++) {
				if (this._map.hasLayer(removedLayers[i])) {
					this._map.removeLayer(removedLayers[i]);
				}
			}
			for (i = 0; i < addedLayers.length; i++) {
				if (!this._map.hasLayer(addedLayers[i])) {
					this._map.addLayer(addedLayers[i]);
				}
			}
	
			this._handlingClick = false;
	
			this._refocusOnMap();
		},
	
		_checkDisabledLayers: function () {
			var inputs = this._layerControlInputs,
			    input,
			    layer,
			    zoom = this._map.getZoom();
	
			for (var i = inputs.length - 1; i >= 0; i--) {
				input = inputs[i];
				layer = this._getLayer(input.layerId).layer;
				input.disabled = (layer.options.minZoom !== undefined && zoom < layer.options.minZoom) ||
				                 (layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom);
	
			}
		},
	
		_expandIfNotCollapsed: function () {
			if (this._map && !this.options.collapsed) {
				this.expand();
			}
			return this;
		},
	
		_expand: function () {
			// Backward compatibility, remove me in 1.1.
			return this.expand();
		},
	
		_collapse: function () {
			// Backward compatibility, remove me in 1.1.
			return this.collapse();
		}
	
	});
	
	
	// @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
	// Creates an attribution control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
	var layers = function (baseLayers, overlays, options) {
		return new Layers(baseLayers, overlays, options);
	};
	
	/*
	 * @class Control.Zoom
	 * @aka L.Control.Zoom
	 * @inherits Control
	 *
	 * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
	 */
	
	var Zoom = Control.extend({
		// @section
		// @aka Control.Zoom options
		options: {
			position: 'topleft',
	
			// @option zoomInText: String = '+'
			// The text set on the 'zoom in' button.
			zoomInText: '+',
	
			// @option zoomInTitle: String = 'Zoom in'
			// The title set on the 'zoom in' button.
			zoomInTitle: 'Zoom in',
	
			// @option zoomOutText: String = '&#x2212;'
			// The text set on the 'zoom out' button.
			zoomOutText: '&#x2212;',
	
			// @option zoomOutTitle: String = 'Zoom out'
			// The title set on the 'zoom out' button.
			zoomOutTitle: 'Zoom out'
		},
	
		onAdd: function (map) {
			var zoomName = 'leaflet-control-zoom',
			    container = create$1('div', zoomName + ' leaflet-bar'),
			    options = this.options;
	
			this._zoomInButton  = this._createButton(options.zoomInText, options.zoomInTitle,
			        zoomName + '-in',  container, this._zoomIn);
			this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle,
			        zoomName + '-out', container, this._zoomOut);
	
			this._updateDisabled();
			map.on('zoomend zoomlevelschange', this._updateDisabled, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off('zoomend zoomlevelschange', this._updateDisabled, this);
		},
	
		disable: function () {
			this._disabled = true;
			this._updateDisabled();
			return this;
		},
	
		enable: function () {
			this._disabled = false;
			this._updateDisabled();
			return this;
		},
	
		_zoomIn: function (e) {
			if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
				this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
			}
		},
	
		_zoomOut: function (e) {
			if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
				this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
			}
		},
	
		_createButton: function (html, title, className, container, fn) {
			var link = create$1('a', className, container);
			link.innerHTML = html;
			link.href = '#';
			link.title = title;
	
			/*
			 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
			 */
			link.setAttribute('role', 'button');
			link.setAttribute('aria-label', title);
	
			disableClickPropagation(link);
			on(link, 'click', stop);
			on(link, 'click', fn, this);
			on(link, 'click', this._refocusOnMap, this);
	
			return link;
		},
	
		_updateDisabled: function () {
			var map = this._map,
			    className = 'leaflet-disabled';
	
			removeClass(this._zoomInButton, className);
			removeClass(this._zoomOutButton, className);
	
			if (this._disabled || map._zoom === map.getMinZoom()) {
				addClass(this._zoomOutButton, className);
			}
			if (this._disabled || map._zoom === map.getMaxZoom()) {
				addClass(this._zoomInButton, className);
			}
		}
	});
	
	// @namespace Map
	// @section Control options
	// @option zoomControl: Boolean = true
	// Whether a [zoom control](#control-zoom) is added to the map by default.
	Map.mergeOptions({
		zoomControl: true
	});
	
	Map.addInitHook(function () {
		if (this.options.zoomControl) {
			// @section Controls
			// @property zoomControl: Control.Zoom
			// The default zoom control (only available if the
			// [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
			this.zoomControl = new Zoom();
			this.addControl(this.zoomControl);
		}
	});
	
	// @namespace Control.Zoom
	// @factory L.control.zoom(options: Control.Zoom options)
	// Creates a zoom control
	var zoom = function (options) {
		return new Zoom(options);
	};
	
	/*
	 * @class Control.Scale
	 * @aka L.Control.Scale
	 * @inherits Control
	 *
	 * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
	 *
	 * @example
	 *
	 * ```js
	 * L.control.scale().addTo(map);
	 * ```
	 */
	
	var Scale = Control.extend({
		// @section
		// @aka Control.Scale options
		options: {
			position: 'bottomleft',
	
			// @option maxWidth: Number = 100
			// Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
			maxWidth: 100,
	
			// @option metric: Boolean = True
			// Whether to show the metric scale line (m/km).
			metric: true,
	
			// @option imperial: Boolean = True
			// Whether to show the imperial scale line (mi/ft).
			imperial: true
	
			// @option updateWhenIdle: Boolean = false
			// If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
		},
	
		onAdd: function (map) {
			var className = 'leaflet-control-scale',
			    container = create$1('div', className),
			    options = this.options;
	
			this._addScales(options, className + '-line', container);
	
			map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
			map.whenReady(this._update, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
		},
	
		_addScales: function (options, className, container) {
			if (options.metric) {
				this._mScale = create$1('div', className, container);
			}
			if (options.imperial) {
				this._iScale = create$1('div', className, container);
			}
		},
	
		_update: function () {
			var map = this._map,
			    y = map.getSize().y / 2;
	
			var maxMeters = map.distance(
				map.containerPointToLatLng([0, y]),
				map.containerPointToLatLng([this.options.maxWidth, y]));
	
			this._updateScales(maxMeters);
		},
	
		_updateScales: function (maxMeters) {
			if (this.options.metric && maxMeters) {
				this._updateMetric(maxMeters);
			}
			if (this.options.imperial && maxMeters) {
				this._updateImperial(maxMeters);
			}
		},
	
		_updateMetric: function (maxMeters) {
			var meters = this._getRoundNum(maxMeters),
			    label = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';
	
			this._updateScale(this._mScale, label, meters / maxMeters);
		},
	
		_updateImperial: function (maxMeters) {
			var maxFeet = maxMeters * 3.2808399,
			    maxMiles, miles, feet;
	
			if (maxFeet > 5280) {
				maxMiles = maxFeet / 5280;
				miles = this._getRoundNum(maxMiles);
				this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
	
			} else {
				feet = this._getRoundNum(maxFeet);
				this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
			}
		},
	
		_updateScale: function (scale, text, ratio) {
			scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
			scale.innerHTML = text;
		},
	
		_getRoundNum: function (num) {
			var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
			    d = num / pow10;
	
			d = d >= 10 ? 10 :
			    d >= 5 ? 5 :
			    d >= 3 ? 3 :
			    d >= 2 ? 2 : 1;
	
			return pow10 * d;
		}
	});
	
	
	// @factory L.control.scale(options?: Control.Scale options)
	// Creates an scale control with the given options.
	var scale = function (options) {
		return new Scale(options);
	};
	
	/*
	 * @class Control.Attribution
	 * @aka L.Control.Attribution
	 * @inherits Control
	 *
	 * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
	 */
	
	var Attribution = Control.extend({
		// @section
		// @aka Control.Attribution options
		options: {
			position: 'bottomright',
	
			// @option prefix: String = 'Leaflet'
			// The HTML text shown before the attributions. Pass `false` to disable.
			prefix: '<a href="https://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
		},
	
		initialize: function (options) {
			setOptions(this, options);
	
			this._attributions = {};
		},
	
		onAdd: function (map) {
			map.attributionControl = this;
			this._container = create$1('div', 'leaflet-control-attribution');
			disableClickPropagation(this._container);
	
			// TODO ugly, refactor
			for (var i in map._layers) {
				if (map._layers[i].getAttribution) {
					this.addAttribution(map._layers[i].getAttribution());
				}
			}
	
			this._update();
	
			return this._container;
		},
	
		// @method setPrefix(prefix: String): this
		// Sets the text before the attributions.
		setPrefix: function (prefix) {
			this.options.prefix = prefix;
			this._update();
			return this;
		},
	
		// @method addAttribution(text: String): this
		// Adds an attribution text (e.g. `'Vector data &copy; Mapbox'`).
		addAttribution: function (text) {
			if (!text) { return this; }
	
			if (!this._attributions[text]) {
				this._attributions[text] = 0;
			}
			this._attributions[text]++;
	
			this._update();
	
			return this;
		},
	
		// @method removeAttribution(text: String): this
		// Removes an attribution text.
		removeAttribution: function (text) {
			if (!text) { return this; }
	
			if (this._attributions[text]) {
				this._attributions[text]--;
				this._update();
			}
	
			return this;
		},
	
		_update: function () {
			if (!this._map) { return; }
	
			var attribs = [];
	
			for (var i in this._attributions) {
				if (this._attributions[i]) {
					attribs.push(i);
				}
			}
	
			var prefixAndAttribs = [];
	
			if (this.options.prefix) {
				prefixAndAttribs.push(this.options.prefix);
			}
			if (attribs.length) {
				prefixAndAttribs.push(attribs.join(', '));
			}
	
			this._container.innerHTML = prefixAndAttribs.join(' | ');
		}
	});
	
	// @namespace Map
	// @section Control options
	// @option attributionControl: Boolean = true
	// Whether a [attribution control](#control-attribution) is added to the map by default.
	Map.mergeOptions({
		attributionControl: true
	});
	
	Map.addInitHook(function () {
		if (this.options.attributionControl) {
			new Attribution().addTo(this);
		}
	});
	
	// @namespace Control.Attribution
	// @factory L.control.attribution(options: Control.Attribution options)
	// Creates an attribution control.
	var attribution = function (options) {
		return new Attribution(options);
	};
	
	Control.Layers = Layers;
	Control.Zoom = Zoom;
	Control.Scale = Scale;
	Control.Attribution = Attribution;
	
	control.layers = layers;
	control.zoom = zoom;
	control.scale = scale;
	control.attribution = attribution;
	
	/*
		L.Handler is a base class for handler classes that are used internally to inject
		interaction features like dragging to classes like Map and Marker.
	*/
	
	// @class Handler
	// @aka L.Handler
	// Abstract class for map interaction handlers
	
	var Handler = Class.extend({
		initialize: function (map) {
			this._map = map;
		},
	
		// @method enable(): this
		// Enables the handler
		enable: function () {
			if (this._enabled) { return this; }
	
			this._enabled = true;
			this.addHooks();
			return this;
		},
	
		// @method disable(): this
		// Disables the handler
		disable: function () {
			if (!this._enabled) { return this; }
	
			this._enabled = false;
			this.removeHooks();
			return this;
		},
	
		// @method enabled(): Boolean
		// Returns `true` if the handler is enabled
		enabled: function () {
			return !!this._enabled;
		}
	
		// @section Extension methods
		// Classes inheriting from `Handler` must implement the two following methods:
		// @method addHooks()
		// Called when the handler is enabled, should add event hooks.
		// @method removeHooks()
		// Called when the handler is disabled, should remove the event hooks added previously.
	});
	
	// @section There is static function which can be called without instantiating L.Handler:
	// @function addTo(map: Map, name: String): this
	// Adds a new Handler to the given map with the given name.
	Handler.addTo = function (map, name) {
		map.addHandler(name, this);
		return this;
	};
	
	var Mixin = {Events: Events};
	
	/*
	 * @class Draggable
	 * @aka L.Draggable
	 * @inherits Evented
	 *
	 * A class for making DOM elements draggable (including touch support).
	 * Used internally for map and marker dragging. Only works for elements
	 * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
	 *
	 * @example
	 * ```js
	 * var draggable = new L.Draggable(elementToDrag);
	 * draggable.enable();
	 * ```
	 */
	
	var START = touch ? 'touchstart mousedown' : 'mousedown';
	var END = {
		mousedown: 'mouseup',
		touchstart: 'touchend',
		pointerdown: 'touchend',
		MSPointerDown: 'touchend'
	};
	var MOVE = {
		mousedown: 'mousemove',
		touchstart: 'touchmove',
		pointerdown: 'touchmove',
		MSPointerDown: 'touchmove'
	};
	
	
	var Draggable = Evented.extend({
	
		options: {
			// @section
			// @aka Draggable options
			// @option clickTolerance: Number = 3
			// The max number of pixels a user can shift the mouse pointer during a click
			// for it to be considered a valid click (as opposed to a mouse drag).
			clickTolerance: 3
		},
	
		// @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
		// Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
		initialize: function (element, dragStartTarget, preventOutline$$1, options) {
			setOptions(this, options);
	
			this._element = element;
			this._dragStartTarget = dragStartTarget || element;
			this._preventOutline = preventOutline$$1;
		},
	
		// @method enable()
		// Enables the dragging ability
		enable: function () {
			if (this._enabled) { return; }
	
			on(this._dragStartTarget, START, this._onDown, this);
	
			this._enabled = true;
		},
	
		// @method disable()
		// Disables the dragging ability
		disable: function () {
			if (!this._enabled) { return; }
	
			// If we're currently dragging this draggable,
			// disabling it counts as first ending the drag.
			if (Draggable._dragging === this) {
				this.finishDrag();
			}
	
			off(this._dragStartTarget, START, this._onDown, this);
	
			this._enabled = false;
			this._moved = false;
		},
	
		_onDown: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
	
			this._moved = false;
	
			if (hasClass(this._element, 'leaflet-zoom-anim')) { return; }
	
			if (Draggable._dragging || e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches)) { return; }
			Draggable._dragging = this;  // Prevent dragging multiple objects at once.
	
			if (this._preventOutline) {
				preventOutline(this._element);
			}
	
			disableImageDrag();
			disableTextSelection();
	
			if (this._moving) { return; }
	
			// @event down: Event
			// Fired when a drag is about to start.
			this.fire('down');
	
			var first = e.touches ? e.touches[0] : e,
			    sizedParent = getSizedParentNode(this._element);
	
			this._startPoint = new Point(first.clientX, first.clientY);
	
			// Cache the scale, so that we can continuously compensate for it during drag (_onMove).
			this._parentScale = getScale(sizedParent);
	
			on(document, MOVE[e.type], this._onMove, this);
			on(document, END[e.type], this._onUp, this);
		},
	
		_onMove: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
	
			if (e.touches && e.touches.length > 1) {
				this._moved = true;
				return;
			}
	
			var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
			    offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
	
			if (!offset.x && !offset.y) { return; }
			if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) { return; }
	
			// We assume that the parent container's position, border and scale do not change for the duration of the drag.
			// Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
			// and we can use the cached value for the scale.
			offset.x /= this._parentScale.x;
			offset.y /= this._parentScale.y;
	
			preventDefault(e);
	
			if (!this._moved) {
				// @event dragstart: Event
				// Fired when a drag starts
				this.fire('dragstart');
	
				this._moved = true;
				this._startPos = getPosition(this._element).subtract(offset);
	
				addClass(document.body, 'leaflet-dragging');
	
				this._lastTarget = e.target || e.srcElement;
				// IE and Edge do not give the <use> element, so fetch it
				// if necessary
				if ((window.SVGElementInstance) && (this._lastTarget instanceof SVGElementInstance)) {
					this._lastTarget = this._lastTarget.correspondingUseElement;
				}
				addClass(this._lastTarget, 'leaflet-drag-target');
			}
	
			this._newPos = this._startPos.add(offset);
			this._moving = true;
	
			cancelAnimFrame(this._animRequest);
			this._lastEvent = e;
			this._animRequest = requestAnimFrame(this._updatePosition, this, true);
		},
	
		_updatePosition: function () {
			var e = {originalEvent: this._lastEvent};
	
			// @event predrag: Event
			// Fired continuously during dragging *before* each corresponding
			// update of the element's position.
			this.fire('predrag', e);
			setPosition(this._element, this._newPos);
	
			// @event drag: Event
			// Fired continuously during dragging.
			this.fire('drag', e);
		},
	
		_onUp: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
			this.finishDrag();
		},
	
		finishDrag: function () {
			removeClass(document.body, 'leaflet-dragging');
	
			if (this._lastTarget) {
				removeClass(this._lastTarget, 'leaflet-drag-target');
				this._lastTarget = null;
			}
	
			for (var i in MOVE) {
				off(document, MOVE[i], this._onMove, this);
				off(document, END[i], this._onUp, this);
			}
	
			enableImageDrag();
			enableTextSelection();
	
			if (this._moved && this._moving) {
				// ensure drag is not fired after dragend
				cancelAnimFrame(this._animRequest);
	
				// @event dragend: DragEndEvent
				// Fired when the drag ends.
				this.fire('dragend', {
					distance: this._newPos.distanceTo(this._startPos)
				});
			}
	
			this._moving = false;
			Draggable._dragging = false;
		}
	
	});
	
	/*
	 * @namespace LineUtil
	 *
	 * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
	 */
	
	// Simplify polyline with vertex reduction and Douglas-Peucker simplification.
	// Improves rendering performance dramatically by lessening the number of points to draw.
	
	// @function simplify(points: Point[], tolerance: Number): Point[]
	// Dramatically reduces the number of points in a polyline while retaining
	// its shape and returns a new array of simplified points, using the
	// [Douglas-Peucker algorithm](http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm).
	// Used for a huge performance boost when processing/displaying Leaflet polylines for
	// each zoom level and also reducing visual noise. tolerance affects the amount of
	// simplification (lesser value means higher quality but slower and with more points).
	// Also released as a separated micro-library [Simplify.js](http://mourner.github.com/simplify-js/).
	function simplify(points, tolerance) {
		if (!tolerance || !points.length) {
			return points.slice();
		}
	
		var sqTolerance = tolerance * tolerance;
	
		    // stage 1: vertex reduction
		    points = _reducePoints(points, sqTolerance);
	
		    // stage 2: Douglas-Peucker simplification
		    points = _simplifyDP(points, sqTolerance);
	
		return points;
	}
	
	// @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
	// Returns the distance between point `p` and segment `p1` to `p2`.
	function pointToSegmentDistance(p, p1, p2) {
		return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
	}
	
	// @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
	// Returns the closest point from a point `p` on a segment `p1` to `p2`.
	function closestPointOnSegment(p, p1, p2) {
		return _sqClosestPointOnSegment(p, p1, p2);
	}
	
	// Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
	function _simplifyDP(points, sqTolerance) {
	
		var len = points.length,
		    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
		    markers = new ArrayConstructor(len);
	
		    markers[0] = markers[len - 1] = 1;
	
		_simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
	
		var i,
		    newPoints = [];
	
		for (i = 0; i < len; i++) {
			if (markers[i]) {
				newPoints.push(points[i]);
			}
		}
	
		return newPoints;
	}
	
	function _simplifyDPStep(points, markers, sqTolerance, first, last) {
	
		var maxSqDist = 0,
		index, i, sqDist;
	
		for (i = first + 1; i <= last - 1; i++) {
			sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
	
			if (sqDist > maxSqDist) {
				index = i;
				maxSqDist = sqDist;
			}
		}
	
		if (maxSqDist > sqTolerance) {
			markers[index] = 1;
	
			_simplifyDPStep(points, markers, sqTolerance, first, index);
			_simplifyDPStep(points, markers, sqTolerance, index, last);
		}
	}
	
	// reduce points that are too close to each other to a single point
	function _reducePoints(points, sqTolerance) {
		var reducedPoints = [points[0]];
	
		for (var i = 1, prev = 0, len = points.length; i < len; i++) {
			if (_sqDist(points[i], points[prev]) > sqTolerance) {
				reducedPoints.push(points[i]);
				prev = i;
			}
		}
		if (prev < len - 1) {
			reducedPoints.push(points[len - 1]);
		}
		return reducedPoints;
	}
	
	var _lastCode;
	
	// @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
	// Clips the segment a to b by rectangular bounds with the
	// [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
	// (modifying the segment points directly!). Used by Leaflet to only show polyline
	// points that are on the screen or near, increasing performance.
	function clipSegment(a, b, bounds, useLastCode, round) {
		var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds),
		    codeB = _getBitCode(b, bounds),
	
		    codeOut, p, newCode;
	
		    // save 2nd code to avoid calculating it on the next segment
		    _lastCode = codeB;
	
		while (true) {
			// if a,b is inside the clip window (trivial accept)
			if (!(codeA | codeB)) {
				return [a, b];
			}
	
			// if a,b is outside the clip window (trivial reject)
			if (codeA & codeB) {
				return false;
			}
	
			// other cases
			codeOut = codeA || codeB;
			p = _getEdgeIntersection(a, b, codeOut, bounds, round);
			newCode = _getBitCode(p, bounds);
	
			if (codeOut === codeA) {
				a = p;
				codeA = newCode;
			} else {
				b = p;
				codeB = newCode;
			}
		}
	}
	
	function _getEdgeIntersection(a, b, code, bounds, round) {
		var dx = b.x - a.x,
		    dy = b.y - a.y,
		    min = bounds.min,
		    max = bounds.max,
		    x, y;
	
		if (code & 8) { // top
			x = a.x + dx * (max.y - a.y) / dy;
			y = max.y;
	
		} else if (code & 4) { // bottom
			x = a.x + dx * (min.y - a.y) / dy;
			y = min.y;
	
		} else if (code & 2) { // right
			x = max.x;
			y = a.y + dy * (max.x - a.x) / dx;
	
		} else if (code & 1) { // left
			x = min.x;
			y = a.y + dy * (min.x - a.x) / dx;
		}
	
		return new Point(x, y, round);
	}
	
	function _getBitCode(p, bounds) {
		var code = 0;
	
		if (p.x < bounds.min.x) { // left
			code |= 1;
		} else if (p.x > bounds.max.x) { // right
			code |= 2;
		}
	
		if (p.y < bounds.min.y) { // bottom
			code |= 4;
		} else if (p.y > bounds.max.y) { // top
			code |= 8;
		}
	
		return code;
	}
	
	// square distance (to avoid unnecessary Math.sqrt calls)
	function _sqDist(p1, p2) {
		var dx = p2.x - p1.x,
		    dy = p2.y - p1.y;
		return dx * dx + dy * dy;
	}
	
	// return closest point on segment or distance to that point
	function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
		var x = p1.x,
		    y = p1.y,
		    dx = p2.x - x,
		    dy = p2.y - y,
		    dot = dx * dx + dy * dy,
		    t;
	
		if (dot > 0) {
			t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
	
			if (t > 1) {
				x = p2.x;
				y = p2.y;
			} else if (t > 0) {
				x += dx * t;
				y += dy * t;
			}
		}
	
		dx = p.x - x;
		dy = p.y - y;
	
		return sqDist ? dx * dx + dy * dy : new Point(x, y);
	}
	
	
	// @function isFlat(latlngs: LatLng[]): Boolean
	// Returns true if `latlngs` is a flat array, false is nested.
	function isFlat(latlngs) {
		return !isArray(latlngs[0]) || (typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined');
	}
	
	function _flat(latlngs) {
		console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
		return isFlat(latlngs);
	}
	
	
	var LineUtil = (Object.freeze || Object)({
		simplify: simplify,
		pointToSegmentDistance: pointToSegmentDistance,
		closestPointOnSegment: closestPointOnSegment,
		clipSegment: clipSegment,
		_getEdgeIntersection: _getEdgeIntersection,
		_getBitCode: _getBitCode,
		_sqClosestPointOnSegment: _sqClosestPointOnSegment,
		isFlat: isFlat,
		_flat: _flat
	});
	
	/*
	 * @namespace PolyUtil
	 * Various utility functions for polygon geometries.
	 */
	
	/* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
	 * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
	 * Used by Leaflet to only show polygon points that are on the screen or near, increasing
	 * performance. Note that polygon points needs different algorithm for clipping
	 * than polyline, so there's a separate method for it.
	 */
	function clipPolygon(points, bounds, round) {
		var clippedPoints,
		    edges = [1, 4, 2, 8],
		    i, j, k,
		    a, b,
		    len, edge, p;
	
		for (i = 0, len = points.length; i < len; i++) {
			points[i]._code = _getBitCode(points[i], bounds);
		}
	
		// for each edge (left, bottom, right, top)
		for (k = 0; k < 4; k++) {
			edge = edges[k];
			clippedPoints = [];
	
			for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
				a = points[i];
				b = points[j];
	
				// if a is inside the clip window
				if (!(a._code & edge)) {
					// if b is outside the clip window (a->b goes out of screen)
					if (b._code & edge) {
						p = _getEdgeIntersection(b, a, edge, bounds, round);
						p._code = _getBitCode(p, bounds);
						clippedPoints.push(p);
					}
					clippedPoints.push(a);
	
				// else if b is inside the clip window (a->b enters the screen)
				} else if (!(b._code & edge)) {
					p = _getEdgeIntersection(b, a, edge, bounds, round);
					p._code = _getBitCode(p, bounds);
					clippedPoints.push(p);
				}
			}
			points = clippedPoints;
		}
	
		return points;
	}
	
	
	var PolyUtil = (Object.freeze || Object)({
		clipPolygon: clipPolygon
	});
	
	/*
	 * @namespace Projection
	 * @section
	 * Leaflet comes with a set of already defined Projections out of the box:
	 *
	 * @projection L.Projection.LonLat
	 *
	 * Equirectangular, or Plate Carree projection — the most simple projection,
	 * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
	 * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
	 * `EPSG:4326` and `Simple` CRS.
	 */
	
	var LonLat = {
		project: function (latlng) {
			return new Point(latlng.lng, latlng.lat);
		},
	
		unproject: function (point) {
			return new LatLng(point.y, point.x);
		},
	
		bounds: new Bounds([-180, -90], [180, 90])
	};
	
	/*
	 * @namespace Projection
	 * @projection L.Projection.Mercator
	 *
	 * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
	 */
	
	var Mercator = {
		R: 6378137,
		R_MINOR: 6356752.314245179,
	
		bounds: new Bounds([-20037508.34279, -15496570.73972], [20037508.34279, 18764656.23138]),
	
		project: function (latlng) {
			var d = Math.PI / 180,
			    r = this.R,
			    y = latlng.lat * d,
			    tmp = this.R_MINOR / r,
			    e = Math.sqrt(1 - tmp * tmp),
			    con = e * Math.sin(y);
	
			var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
			y = -r * Math.log(Math.max(ts, 1E-10));
	
			return new Point(latlng.lng * d * r, y);
		},
	
		unproject: function (point) {
			var d = 180 / Math.PI,
			    r = this.R,
			    tmp = this.R_MINOR / r,
			    e = Math.sqrt(1 - tmp * tmp),
			    ts = Math.exp(-point.y / r),
			    phi = Math.PI / 2 - 2 * Math.atan(ts);
	
			for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
				con = e * Math.sin(phi);
				con = Math.pow((1 - con) / (1 + con), e / 2);
				dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
				phi += dphi;
			}
	
			return new LatLng(phi * d, point.x * d / r);
		}
	};
	
	/*
	 * @class Projection
	
	 * An object with methods for projecting geographical coordinates of the world onto
	 * a flat surface (and back). See [Map projection](http://en.wikipedia.org/wiki/Map_projection).
	
	 * @property bounds: Bounds
	 * The bounds (specified in CRS units) where the projection is valid
	
	 * @method project(latlng: LatLng): Point
	 * Projects geographical coordinates into a 2D point.
	 * Only accepts actual `L.LatLng` instances, not arrays.
	
	 * @method unproject(point: Point): LatLng
	 * The inverse of `project`. Projects a 2D point into a geographical location.
	 * Only accepts actual `L.Point` instances, not arrays.
	
	 * Note that the projection instances do not inherit from Leafet's `Class` object,
	 * and can't be instantiated. Also, new classes can't inherit from them,
	 * and methods can't be added to them with the `include` function.
	
	 */
	
	
	
	
	var index = (Object.freeze || Object)({
		LonLat: LonLat,
		Mercator: Mercator,
		SphericalMercator: SphericalMercator
	});
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG3395
	 *
	 * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
	 */
	var EPSG3395 = extend({}, Earth, {
		code: 'EPSG:3395',
		projection: Mercator,
	
		transformation: (function () {
			var scale = 0.5 / (Math.PI * Mercator.R);
			return toTransformation(scale, 0.5, -scale, 0.5);
		}())
	});
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG4326
	 *
	 * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
	 *
	 * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
	 * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
	 * with this CRS, ensure that there are two 256x256 pixel tiles covering the
	 * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
	 * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
	 */
	
	var EPSG4326 = extend({}, Earth, {
		code: 'EPSG:4326',
		projection: LonLat,
		transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
	});
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Simple
	 *
	 * A simple CRS that maps longitude and latitude into `x` and `y` directly.
	 * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
	 * axis should still be inverted (going from bottom to top). `distance()` returns
	 * simple euclidean distance.
	 */
	
	var Simple = extend({}, CRS, {
		projection: LonLat,
		transformation: toTransformation(1, 0, -1, 0),
	
		scale: function (zoom) {
			return Math.pow(2, zoom);
		},
	
		zoom: function (scale) {
			return Math.log(scale) / Math.LN2;
		},
	
		distance: function (latlng1, latlng2) {
			var dx = latlng2.lng - latlng1.lng,
			    dy = latlng2.lat - latlng1.lat;
	
			return Math.sqrt(dx * dx + dy * dy);
		},
	
		infinite: true
	});
	
	CRS.Earth = Earth;
	CRS.EPSG3395 = EPSG3395;
	CRS.EPSG3857 = EPSG3857;
	CRS.EPSG900913 = EPSG900913;
	CRS.EPSG4326 = EPSG4326;
	CRS.Simple = Simple;
	
	/*
	 * @class Layer
	 * @inherits Evented
	 * @aka L.Layer
	 * @aka ILayer
	 *
	 * A set of methods from the Layer base class that all Leaflet layers use.
	 * Inherits all methods, options and events from `L.Evented`.
	 *
	 * @example
	 *
	 * ```js
	 * var layer = L.marker(latlng).addTo(map);
	 * layer.addTo(map);
	 * layer.remove();
	 * ```
	 *
	 * @event add: Event
	 * Fired after the layer is added to a map
	 *
	 * @event remove: Event
	 * Fired after the layer is removed from a map
	 */
	
	
	var Layer = Evented.extend({
	
		// Classes extending `L.Layer` will inherit the following options:
		options: {
			// @option pane: String = 'overlayPane'
			// By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
			pane: 'overlayPane',
	
			// @option attribution: String = null
			// String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
			attribution: null,
	
			bubblingMouseEvents: true
		},
	
		/* @section
		 * Classes extending `L.Layer` will inherit the following methods:
		 *
		 * @method addTo(map: Map|LayerGroup): this
		 * Adds the layer to the given map or layer group.
		 */
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		// @method remove: this
		// Removes the layer from the map it is currently active on.
		remove: function () {
			return this.removeFrom(this._map || this._mapToAdd);
		},
	
		// @method removeFrom(map: Map): this
		// Removes the layer from the given map
		removeFrom: function (obj) {
			if (obj) {
				obj.removeLayer(this);
			}
			return this;
		},
	
		// @method getPane(name? : String): HTMLElement
		// Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
		getPane: function (name) {
			return this._map.getPane(name ? (this.options[name] || name) : this.options.pane);
		},
	
		addInteractiveTarget: function (targetEl) {
			this._map._targets[stamp(targetEl)] = this;
			return this;
		},
	
		removeInteractiveTarget: function (targetEl) {
			delete this._map._targets[stamp(targetEl)];
			return this;
		},
	
		// @method getAttribution: String
		// Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
		getAttribution: function () {
			return this.options.attribution;
		},
	
		_layerAdd: function (e) {
			var map = e.target;
	
			// check in case layer gets added and then removed before the map is ready
			if (!map.hasLayer(this)) { return; }
	
			this._map = map;
			this._zoomAnimated = map._zoomAnimated;
	
			if (this.getEvents) {
				var events = this.getEvents();
				map.on(events, this);
				this.once('remove', function () {
					map.off(events, this);
				}, this);
			}
	
			this.onAdd(map);
	
			if (this.getAttribution && map.attributionControl) {
				map.attributionControl.addAttribution(this.getAttribution());
			}
	
			this.fire('add');
			map.fire('layeradd', {layer: this});
		}
	});
	
	/* @section Extension methods
	 * @uninheritable
	 *
	 * Every layer should extend from `L.Layer` and (re-)implement the following methods.
	 *
	 * @method onAdd(map: Map): this
	 * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
	 *
	 * @method onRemove(map: Map): this
	 * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
	 *
	 * @method getEvents(): Object
	 * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
	 *
	 * @method getAttribution(): String
	 * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
	 *
	 * @method beforeAdd(map: Map): this
	 * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
	 */
	
	
	/* @namespace Map
	 * @section Layer events
	 *
	 * @event layeradd: LayerEvent
	 * Fired when a new layer is added to the map.
	 *
	 * @event layerremove: LayerEvent
	 * Fired when some layer is removed from the map
	 *
	 * @section Methods for Layers and Controls
	 */
	Map.include({
		// @method addLayer(layer: Layer): this
		// Adds the given layer to the map
		addLayer: function (layer) {
			if (!layer._layerAdd) {
				throw new Error('The provided object is not a Layer.');
			}
	
			var id = stamp(layer);
			if (this._layers[id]) { return this; }
			this._layers[id] = layer;
	
			layer._mapToAdd = this;
	
			if (layer.beforeAdd) {
				layer.beforeAdd(this);
			}
	
			this.whenReady(layer._layerAdd, layer);
	
			return this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Removes the given layer from the map.
		removeLayer: function (layer) {
			var id = stamp(layer);
	
			if (!this._layers[id]) { return this; }
	
			if (this._loaded) {
				layer.onRemove(this);
			}
	
			if (layer.getAttribution && this.attributionControl) {
				this.attributionControl.removeAttribution(layer.getAttribution());
			}
	
			delete this._layers[id];
	
			if (this._loaded) {
				this.fire('layerremove', {layer: layer});
				layer.fire('remove');
			}
	
			layer._map = layer._mapToAdd = null;
	
			return this;
		},
	
		// @method hasLayer(layer: Layer): Boolean
		// Returns `true` if the given layer is currently added to the map
		hasLayer: function (layer) {
			return !!layer && (stamp(layer) in this._layers);
		},
	
		/* @method eachLayer(fn: Function, context?: Object): this
		 * Iterates over the layers of the map, optionally specifying context of the iterator function.
		 * ```
		 * map.eachLayer(function(layer){
		 *     layer.bindPopup('Hello');
		 * });
		 * ```
		 */
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		_addLayers: function (layers) {
			layers = layers ? (isArray(layers) ? layers : [layers]) : [];
	
			for (var i = 0, len = layers.length; i < len; i++) {
				this.addLayer(layers[i]);
			}
		},
	
		_addZoomLimit: function (layer) {
			if (isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
				this._zoomBoundLayers[stamp(layer)] = layer;
				this._updateZoomLevels();
			}
		},
	
		_removeZoomLimit: function (layer) {
			var id = stamp(layer);
	
			if (this._zoomBoundLayers[id]) {
				delete this._zoomBoundLayers[id];
				this._updateZoomLevels();
			}
		},
	
		_updateZoomLevels: function () {
			var minZoom = Infinity,
			    maxZoom = -Infinity,
			    oldZoomSpan = this._getZoomSpan();
	
			for (var i in this._zoomBoundLayers) {
				var options = this._zoomBoundLayers[i].options;
	
				minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
				maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
			}
	
			this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
			this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
	
			// @section Map state change events
			// @event zoomlevelschange: Event
			// Fired when the number of zoomlevels on the map is changed due
			// to adding or removing a layer.
			if (oldZoomSpan !== this._getZoomSpan()) {
				this.fire('zoomlevelschange');
			}
	
			if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
				this.setZoom(this._layersMaxZoom);
			}
			if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
				this.setZoom(this._layersMinZoom);
			}
		}
	});
	
	/*
	 * @class LayerGroup
	 * @aka L.LayerGroup
	 * @inherits Layer
	 *
	 * Used to group several layers and handle them as one. If you add it to the map,
	 * any layers added or removed from the group will be added/removed on the map as
	 * well. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.layerGroup([marker1, marker2])
	 * 	.addLayer(polyline)
	 * 	.addTo(map);
	 * ```
	 */
	
	var LayerGroup = Layer.extend({
	
		initialize: function (layers, options) {
			setOptions(this, options);
	
			this._layers = {};
	
			var i, len;
	
			if (layers) {
				for (i = 0, len = layers.length; i < len; i++) {
					this.addLayer(layers[i]);
				}
			}
		},
	
		// @method addLayer(layer: Layer): this
		// Adds the given layer to the group.
		addLayer: function (layer) {
			var id = this.getLayerId(layer);
	
			this._layers[id] = layer;
	
			if (this._map) {
				this._map.addLayer(layer);
			}
	
			return this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Removes the given layer from the group.
		// @alternative
		// @method removeLayer(id: Number): this
		// Removes the layer with the given internal ID from the group.
		removeLayer: function (layer) {
			var id = layer in this._layers ? layer : this.getLayerId(layer);
	
			if (this._map && this._layers[id]) {
				this._map.removeLayer(this._layers[id]);
			}
	
			delete this._layers[id];
	
			return this;
		},
	
		// @method hasLayer(layer: Layer): Boolean
		// Returns `true` if the given layer is currently added to the group.
		// @alternative
		// @method hasLayer(id: Number): Boolean
		// Returns `true` if the given internal ID is currently added to the group.
		hasLayer: function (layer) {
			return !!layer && (layer in this._layers || this.getLayerId(layer) in this._layers);
		},
	
		// @method clearLayers(): this
		// Removes all the layers from the group.
		clearLayers: function () {
			return this.eachLayer(this.removeLayer, this);
		},
	
		// @method invoke(methodName: String, …): this
		// Calls `methodName` on every layer contained in this group, passing any
		// additional parameters. Has no effect if the layers contained do not
		// implement `methodName`.
		invoke: function (methodName) {
			var args = Array.prototype.slice.call(arguments, 1),
			    i, layer;
	
			for (i in this._layers) {
				layer = this._layers[i];
	
				if (layer[methodName]) {
					layer[methodName].apply(layer, args);
				}
			}
	
			return this;
		},
	
		onAdd: function (map) {
			this.eachLayer(map.addLayer, map);
		},
	
		onRemove: function (map) {
			this.eachLayer(map.removeLayer, map);
		},
	
		// @method eachLayer(fn: Function, context?: Object): this
		// Iterates over the layers of the group, optionally specifying context of the iterator function.
		// ```js
		// group.eachLayer(function (layer) {
		// 	layer.bindPopup('Hello');
		// });
		// ```
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		// @method getLayer(id: Number): Layer
		// Returns the layer with the given internal ID.
		getLayer: function (id) {
			return this._layers[id];
		},
	
		// @method getLayers(): Layer[]
		// Returns an array of all the layers added to the group.
		getLayers: function () {
			var layers = [];
			this.eachLayer(layers.push, layers);
			return layers;
		},
	
		// @method setZIndex(zIndex: Number): this
		// Calls `setZIndex` on every layer contained in this group, passing the z-index.
		setZIndex: function (zIndex) {
			return this.invoke('setZIndex', zIndex);
		},
	
		// @method getLayerId(layer: Layer): Number
		// Returns the internal ID for a layer
		getLayerId: function (layer) {
			return stamp(layer);
		}
	});
	
	
	// @factory L.layerGroup(layers?: Layer[], options?: Object)
	// Create a layer group, optionally given an initial set of layers and an `options` object.
	var layerGroup = function (layers, options) {
		return new LayerGroup(layers, options);
	};
	
	/*
	 * @class FeatureGroup
	 * @aka L.FeatureGroup
	 * @inherits LayerGroup
	 *
	 * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
	 *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
	 *  * Events are propagated to the `FeatureGroup`, so if the group has an event
	 * handler, it will handle events from any of the layers. This includes mouse events
	 * and custom events.
	 *  * Has `layeradd` and `layerremove` events
	 *
	 * @example
	 *
	 * ```js
	 * L.featureGroup([marker1, marker2, polyline])
	 * 	.bindPopup('Hello world!')
	 * 	.on('click', function() { alert('Clicked on a member of the group!'); })
	 * 	.addTo(map);
	 * ```
	 */
	
	var FeatureGroup = LayerGroup.extend({
	
		addLayer: function (layer) {
			if (this.hasLayer(layer)) {
				return this;
			}
	
			layer.addEventParent(this);
	
			LayerGroup.prototype.addLayer.call(this, layer);
	
			// @event layeradd: LayerEvent
			// Fired when a layer is added to this `FeatureGroup`
			return this.fire('layeradd', {layer: layer});
		},
	
		removeLayer: function (layer) {
			if (!this.hasLayer(layer)) {
				return this;
			}
			if (layer in this._layers) {
				layer = this._layers[layer];
			}
	
			layer.removeEventParent(this);
	
			LayerGroup.prototype.removeLayer.call(this, layer);
	
			// @event layerremove: LayerEvent
			// Fired when a layer is removed from this `FeatureGroup`
			return this.fire('layerremove', {layer: layer});
		},
	
		// @method setStyle(style: Path options): this
		// Sets the given path options to each layer of the group that has a `setStyle` method.
		setStyle: function (style) {
			return this.invoke('setStyle', style);
		},
	
		// @method bringToFront(): this
		// Brings the layer group to the top of all other layers
		bringToFront: function () {
			return this.invoke('bringToFront');
		},
	
		// @method bringToBack(): this
		// Brings the layer group to the back of all other layers
		bringToBack: function () {
			return this.invoke('bringToBack');
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
		getBounds: function () {
			var bounds = new LatLngBounds();
	
			for (var id in this._layers) {
				var layer = this._layers[id];
				bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
			}
			return bounds;
		}
	});
	
	// @factory L.featureGroup(layers: Layer[])
	// Create a feature group, optionally given an initial set of layers.
	var featureGroup = function (layers) {
		return new FeatureGroup(layers);
	};
	
	/*
	 * @class Icon
	 * @aka L.Icon
	 *
	 * Represents an icon to provide when creating a marker.
	 *
	 * @example
	 *
	 * ```js
	 * var myIcon = L.icon({
	 *     iconUrl: 'my-icon.png',
	 *     iconRetinaUrl: 'my-icon@2x.png',
	 *     iconSize: [38, 95],
	 *     iconAnchor: [22, 94],
	 *     popupAnchor: [-3, -76],
	 *     shadowUrl: 'my-icon-shadow.png',
	 *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
	 *     shadowSize: [68, 95],
	 *     shadowAnchor: [22, 94]
	 * });
	 *
	 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	 * ```
	 *
	 * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
	 *
	 */
	
	var Icon = Class.extend({
	
		/* @section
		 * @aka Icon options
		 *
		 * @option iconUrl: String = null
		 * **(required)** The URL to the icon image (absolute or relative to your script path).
		 *
		 * @option iconRetinaUrl: String = null
		 * The URL to a retina sized version of the icon image (absolute or relative to your
		 * script path). Used for Retina screen devices.
		 *
		 * @option iconSize: Point = null
		 * Size of the icon image in pixels.
		 *
		 * @option iconAnchor: Point = null
		 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
		 * will be aligned so that this point is at the marker's geographical location. Centered
		 * by default if size is specified, also can be set in CSS with negative margins.
		 *
		 * @option popupAnchor: Point = [0, 0]
		 * The coordinates of the point from which popups will "open", relative to the icon anchor.
		 *
		 * @option tooltipAnchor: Point = [0, 0]
		 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
		 *
		 * @option shadowUrl: String = null
		 * The URL to the icon shadow image. If not specified, no shadow image will be created.
		 *
		 * @option shadowRetinaUrl: String = null
		 *
		 * @option shadowSize: Point = null
		 * Size of the shadow image in pixels.
		 *
		 * @option shadowAnchor: Point = null
		 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
		 * as iconAnchor if not specified).
		 *
		 * @option className: String = ''
		 * A custom class name to assign to both icon and shadow images. Empty by default.
		 */
	
		options: {
			popupAnchor: [0, 0],
			tooltipAnchor: [0, 0]
		},
	
		initialize: function (options) {
			setOptions(this, options);
		},
	
		// @method createIcon(oldIcon?: HTMLElement): HTMLElement
		// Called internally when the icon has to be shown, returns a `<img>` HTML element
		// styled according to the options.
		createIcon: function (oldIcon) {
			return this._createIcon('icon', oldIcon);
		},
	
		// @method createShadow(oldIcon?: HTMLElement): HTMLElement
		// As `createIcon`, but for the shadow beneath it.
		createShadow: function (oldIcon) {
			return this._createIcon('shadow', oldIcon);
		},
	
		_createIcon: function (name, oldIcon) {
			var src = this._getIconUrl(name);
	
			if (!src) {
				if (name === 'icon') {
					throw new Error('iconUrl not set in Icon options (see the docs).');
				}
				return null;
			}
	
			var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
			this._setIconStyles(img, name);
	
			return img;
		},
	
		_setIconStyles: function (img, name) {
			var options = this.options;
			var sizeOption = options[name + 'Size'];
	
			if (typeof sizeOption === 'number') {
				sizeOption = [sizeOption, sizeOption];
			}
	
			var size = toPoint(sizeOption),
			    anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor ||
			            size && size.divideBy(2, true));
	
			img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
	
			if (anchor) {
				img.style.marginLeft = (-anchor.x) + 'px';
				img.style.marginTop  = (-anchor.y) + 'px';
			}
	
			if (size) {
				img.style.width  = size.x + 'px';
				img.style.height = size.y + 'px';
			}
		},
	
		_createImg: function (src, el) {
			el = el || document.createElement('img');
			el.src = src;
			return el;
		},
	
		_getIconUrl: function (name) {
			return retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
		}
	});
	
	
	// @factory L.icon(options: Icon options)
	// Creates an icon instance with the given options.
	function icon(options) {
		return new Icon(options);
	}
	
	/*
	 * @miniclass Icon.Default (Icon)
	 * @aka L.Icon.Default
	 * @section
	 *
	 * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
	 * no icon is specified. Points to the blue marker image distributed with Leaflet
	 * releases.
	 *
	 * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
	 * (which is a set of `Icon options`).
	 *
	 * If you want to _completely_ replace the default icon, override the
	 * `L.Marker.prototype.options.icon` with your own icon instead.
	 */
	
	var IconDefault = Icon.extend({
	
		options: {
			iconUrl:       'marker-icon.png',
			iconRetinaUrl: 'marker-icon-2x.png',
			shadowUrl:     'marker-shadow.png',
			iconSize:    [25, 41],
			iconAnchor:  [12, 41],
			popupAnchor: [1, -34],
			tooltipAnchor: [16, -28],
			shadowSize:  [41, 41]
		},
	
		_getIconUrl: function (name) {
			if (!IconDefault.imagePath) {	// Deprecated, backwards-compatibility only
				IconDefault.imagePath = this._detectIconPath();
			}
	
			// @option imagePath: String
			// `Icon.Default` will try to auto-detect the location of the
			// blue icon images. If you are placing these images in a non-standard
			// way, set this option to point to the right path.
			return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
		},
	
		_detectIconPath: function () {
			var el = create$1('div',  'leaflet-default-icon-path', document.body);
			var path = getStyle(el, 'background-image') ||
			           getStyle(el, 'backgroundImage');	// IE8
	
			document.body.removeChild(el);
	
			if (path === null || path.indexOf('url') !== 0) {
				path = '';
			} else {
				path = path.replace(/^url\(["']?/, '').replace(/marker-icon\.png["']?\)$/, '');
			}
	
			return path;
		}
	});
	
	/*
	 * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
	 */
	
	
	/* @namespace Marker
	 * @section Interaction handlers
	 *
	 * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
	 *
	 * ```js
	 * marker.dragging.disable();
	 * ```
	 *
	 * @property dragging: Handler
	 * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
	 */
	
	var MarkerDrag = Handler.extend({
		initialize: function (marker) {
			this._marker = marker;
		},
	
		addHooks: function () {
			var icon = this._marker._icon;
	
			if (!this._draggable) {
				this._draggable = new Draggable(icon, icon, true);
			}
	
			this._draggable.on({
				dragstart: this._onDragStart,
				predrag: this._onPreDrag,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this).enable();
	
			addClass(icon, 'leaflet-marker-draggable');
		},
	
		removeHooks: function () {
			this._draggable.off({
				dragstart: this._onDragStart,
				predrag: this._onPreDrag,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this).disable();
	
			if (this._marker._icon) {
				removeClass(this._marker._icon, 'leaflet-marker-draggable');
			}
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		_adjustPan: function (e) {
			var marker = this._marker,
			    map = marker._map,
			    speed = this._marker.options.autoPanSpeed,
			    padding = this._marker.options.autoPanPadding,
			    iconPos = getPosition(marker._icon),
			    bounds = map.getPixelBounds(),
			    origin = map.getPixelOrigin();
	
			var panBounds = toBounds(
				bounds.min._subtract(origin).add(padding),
				bounds.max._subtract(origin).subtract(padding)
			);
	
			if (!panBounds.contains(iconPos)) {
				// Compute incremental movement
				var movement = toPoint(
					(Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) -
					(Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x),
	
					(Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) -
					(Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)
				).multiplyBy(speed);
	
				map.panBy(movement, {animate: false});
	
				this._draggable._newPos._add(movement);
				this._draggable._startPos._add(movement);
	
				setPosition(marker._icon, this._draggable._newPos);
				this._onDrag(e);
	
				this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
			}
		},
	
		_onDragStart: function () {
			// @section Dragging events
			// @event dragstart: Event
			// Fired when the user starts dragging the marker.
	
			// @event movestart: Event
			// Fired when the marker starts moving (because of dragging).
	
			this._oldLatLng = this._marker.getLatLng();
			this._marker
			    .closePopup()
			    .fire('movestart')
			    .fire('dragstart');
		},
	
		_onPreDrag: function (e) {
			if (this._marker.options.autoPan) {
				cancelAnimFrame(this._panRequest);
				this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
			}
		},
	
		_onDrag: function (e) {
			var marker = this._marker,
			    shadow = marker._shadow,
			    iconPos = getPosition(marker._icon),
			    latlng = marker._map.layerPointToLatLng(iconPos);
	
			// update shadow position
			if (shadow) {
				setPosition(shadow, iconPos);
			}
	
			marker._latlng = latlng;
			e.latlng = latlng;
			e.oldLatLng = this._oldLatLng;
	
			// @event drag: Event
			// Fired repeatedly while the user drags the marker.
			marker
			    .fire('move', e)
			    .fire('drag', e);
		},
	
		_onDragEnd: function (e) {
			// @event dragend: DragEndEvent
			// Fired when the user stops dragging the marker.
	
			 cancelAnimFrame(this._panRequest);
	
			// @event moveend: Event
			// Fired when the marker stops moving (because of dragging).
			delete this._oldLatLng;
			this._marker
			    .fire('moveend')
			    .fire('dragend', e);
		}
	});
	
	/*
	 * @class Marker
	 * @inherits Interactive layer
	 * @aka L.Marker
	 * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.marker([50.5, 30.5]).addTo(map);
	 * ```
	 */
	
	var Marker = Layer.extend({
	
		// @section
		// @aka Marker options
		options: {
			// @option icon: Icon = *
			// Icon instance to use for rendering the marker.
			// See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
			// If not specified, a common instance of `L.Icon.Default` is used.
			icon: new IconDefault(),
	
			// Option inherited from "Interactive layer" abstract class
			interactive: true,
	
			// @option keyboard: Boolean = true
			// Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
			keyboard: true,
	
			// @option title: String = ''
			// Text for the browser tooltip that appear on marker hover (no tooltip by default).
			title: '',
	
			// @option alt: String = ''
			// Text for the `alt` attribute of the icon image (useful for accessibility).
			alt: '',
	
			// @option zIndexOffset: Number = 0
			// By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
			zIndexOffset: 0,
	
			// @option opacity: Number = 1.0
			// The opacity of the marker.
			opacity: 1,
	
			// @option riseOnHover: Boolean = false
			// If `true`, the marker will get on top of others when you hover the mouse over it.
			riseOnHover: false,
	
			// @option riseOffset: Number = 250
			// The z-index offset used for the `riseOnHover` feature.
			riseOffset: 250,
	
			// @option pane: String = 'markerPane'
			// `Map pane` where the markers icon will be added.
			pane: 'markerPane',
	
			// @option pane: String = 'shadowPane'
			// `Map pane` where the markers shadow will be added.
			shadowPane: 'shadowPane',
	
			// @option bubblingMouseEvents: Boolean = false
			// When `true`, a mouse event on this marker will trigger the same event on the map
			// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
			bubblingMouseEvents: false,
	
			// @section Draggable marker options
			// @option draggable: Boolean = false
			// Whether the marker is draggable with mouse/touch or not.
			draggable: false,
	
			// @option autoPan: Boolean = false
			// Whether to pan the map when dragging this marker near its edge or not.
			autoPan: false,
	
			// @option autoPanPadding: Point = Point(50, 50)
			// Distance (in pixels to the left/right and to the top/bottom) of the
			// map edge to start panning the map.
			autoPanPadding: [50, 50],
	
			// @option autoPanSpeed: Number = 10
			// Number of pixels the map should pan by.
			autoPanSpeed: 10
		},
	
		/* @section
		 *
		 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
		 */
	
		initialize: function (latlng, options) {
			setOptions(this, options);
			this._latlng = toLatLng(latlng);
		},
	
		onAdd: function (map) {
			this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
	
			if (this._zoomAnimated) {
				map.on('zoomanim', this._animateZoom, this);
			}
	
			this._initIcon();
			this.update();
		},
	
		onRemove: function (map) {
			if (this.dragging && this.dragging.enabled()) {
				this.options.draggable = true;
				this.dragging.removeHooks();
			}
			delete this.dragging;
	
			if (this._zoomAnimated) {
				map.off('zoomanim', this._animateZoom, this);
			}
	
			this._removeIcon();
			this._removeShadow();
		},
	
		getEvents: function () {
			return {
				zoom: this.update,
				viewreset: this.update
			};
		},
	
		// @method getLatLng: LatLng
		// Returns the current geographical position of the marker.
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setLatLng(latlng: LatLng): this
		// Changes the marker position to the given point.
		setLatLng: function (latlng) {
			var oldLatLng = this._latlng;
			this._latlng = toLatLng(latlng);
			this.update();
	
			// @event move: Event
			// Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
			return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
		},
	
		// @method setZIndexOffset(offset: Number): this
		// Changes the [zIndex offset](#marker-zindexoffset) of the marker.
		setZIndexOffset: function (offset) {
			this.options.zIndexOffset = offset;
			return this.update();
		},
	
		// @method getIcon: Icon
		// Returns the current icon used by the marker
		getIcon: function () {
			return this.options.icon;
		},
	
		// @method setIcon(icon: Icon): this
		// Changes the marker icon.
		setIcon: function (icon) {
	
			this.options.icon = icon;
	
			if (this._map) {
				this._initIcon();
				this.update();
			}
	
			if (this._popup) {
				this.bindPopup(this._popup, this._popup.options);
			}
	
			return this;
		},
	
		getElement: function () {
			return this._icon;
		},
	
		update: function () {
	
			if (this._icon && this._map) {
				var pos = this._map.latLngToLayerPoint(this._latlng).round();
				this._setPos(pos);
			}
	
			return this;
		},
	
		_initIcon: function () {
			var options = this.options,
			    classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
			var icon = options.icon.createIcon(this._icon),
			    addIcon = false;
	
			// if we're not reusing the icon, remove the old one and init new one
			if (icon !== this._icon) {
				if (this._icon) {
					this._removeIcon();
				}
				addIcon = true;
	
				if (options.title) {
					icon.title = options.title;
				}
	
				if (icon.tagName === 'IMG') {
					icon.alt = options.alt || '';
				}
			}
	
			addClass(icon, classToAdd);
	
			if (options.keyboard) {
				icon.tabIndex = '0';
			}
	
			this._icon = icon;
	
			if (options.riseOnHover) {
				this.on({
					mouseover: this._bringToFront,
					mouseout: this._resetZIndex
				});
			}
	
			var newShadow = options.icon.createShadow(this._shadow),
			    addShadow = false;
	
			if (newShadow !== this._shadow) {
				this._removeShadow();
				addShadow = true;
			}
	
			if (newShadow) {
				addClass(newShadow, classToAdd);
				newShadow.alt = '';
			}
			this._shadow = newShadow;
	
	
			if (options.opacity < 1) {
				this._updateOpacity();
			}
	
	
			if (addIcon) {
				this.getPane().appendChild(this._icon);
			}
			this._initInteraction();
			if (newShadow && addShadow) {
				this.getPane(options.shadowPane).appendChild(this._shadow);
			}
		},
	
		_removeIcon: function () {
			if (this.options.riseOnHover) {
				this.off({
					mouseover: this._bringToFront,
					mouseout: this._resetZIndex
				});
			}
	
			remove(this._icon);
			this.removeInteractiveTarget(this._icon);
	
			this._icon = null;
		},
	
		_removeShadow: function () {
			if (this._shadow) {
				remove(this._shadow);
			}
			this._shadow = null;
		},
	
		_setPos: function (pos) {
			setPosition(this._icon, pos);
	
			if (this._shadow) {
				setPosition(this._shadow, pos);
			}
	
			this._zIndex = pos.y + this.options.zIndexOffset;
	
			this._resetZIndex();
		},
	
		_updateZIndex: function (offset) {
			this._icon.style.zIndex = this._zIndex + offset;
		},
	
		_animateZoom: function (opt) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
	
			this._setPos(pos);
		},
	
		_initInteraction: function () {
	
			if (!this.options.interactive) { return; }
	
			addClass(this._icon, 'leaflet-interactive');
	
			this.addInteractiveTarget(this._icon);
	
			if (MarkerDrag) {
				var draggable = this.options.draggable;
				if (this.dragging) {
					draggable = this.dragging.enabled();
					this.dragging.disable();
				}
	
				this.dragging = new MarkerDrag(this);
	
				if (draggable) {
					this.dragging.enable();
				}
			}
		},
	
		// @method setOpacity(opacity: Number): this
		// Changes the opacity of the marker.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			if (this._map) {
				this._updateOpacity();
			}
	
			return this;
		},
	
		_updateOpacity: function () {
			var opacity = this.options.opacity;
	
			if (this._icon) {
				setOpacity(this._icon, opacity);
			}
	
			if (this._shadow) {
				setOpacity(this._shadow, opacity);
			}
		},
	
		_bringToFront: function () {
			this._updateZIndex(this.options.riseOffset);
		},
	
		_resetZIndex: function () {
			this._updateZIndex(0);
		},
	
		_getPopupAnchor: function () {
			return this.options.icon.options.popupAnchor;
		},
	
		_getTooltipAnchor: function () {
			return this.options.icon.options.tooltipAnchor;
		}
	});
	
	
	// factory L.marker(latlng: LatLng, options? : Marker options)
	
	// @factory L.marker(latlng: LatLng, options? : Marker options)
	// Instantiates a Marker object given a geographical point and optionally an options object.
	function marker(latlng, options) {
		return new Marker(latlng, options);
	}
	
	/*
	 * @class Path
	 * @aka L.Path
	 * @inherits Interactive layer
	 *
	 * An abstract class that contains options and constants shared between vector
	 * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
	 */
	
	var Path = Layer.extend({
	
		// @section
		// @aka Path options
		options: {
			// @option stroke: Boolean = true
			// Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
			stroke: true,
	
			// @option color: String = '#3388ff'
			// Stroke color
			color: '#3388ff',
	
			// @option weight: Number = 3
			// Stroke width in pixels
			weight: 3,
	
			// @option opacity: Number = 1.0
			// Stroke opacity
			opacity: 1,
	
			// @option lineCap: String= 'round'
			// A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
			lineCap: 'round',
	
			// @option lineJoin: String = 'round'
			// A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
			lineJoin: 'round',
	
			// @option dashArray: String = null
			// A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
			dashArray: null,
	
			// @option dashOffset: String = null
			// A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
			dashOffset: null,
	
			// @option fill: Boolean = depends
			// Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
			fill: false,
	
			// @option fillColor: String = *
			// Fill color. Defaults to the value of the [`color`](#path-color) option
			fillColor: null,
	
			// @option fillOpacity: Number = 0.2
			// Fill opacity.
			fillOpacity: 0.2,
	
			// @option fillRule: String = 'evenodd'
			// A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
			fillRule: 'evenodd',
	
			// className: '',
	
			// Option inherited from "Interactive layer" abstract class
			interactive: true,
	
			// @option bubblingMouseEvents: Boolean = true
			// When `true`, a mouse event on this path will trigger the same event on the map
			// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
			bubblingMouseEvents: true
		},
	
		beforeAdd: function (map) {
			// Renderer is set here because we need to call renderer.getEvents
			// before this.getEvents.
			this._renderer = map.getRenderer(this);
		},
	
		onAdd: function () {
			this._renderer._initPath(this);
			this._reset();
			this._renderer._addPath(this);
		},
	
		onRemove: function () {
			this._renderer._removePath(this);
		},
	
		// @method redraw(): this
		// Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
		redraw: function () {
			if (this._map) {
				this._renderer._updatePath(this);
			}
			return this;
		},
	
		// @method setStyle(style: Path options): this
		// Changes the appearance of a Path based on the options in the `Path options` object.
		setStyle: function (style) {
			setOptions(this, style);
			if (this._renderer) {
				this._renderer._updateStyle(this);
				if (this.options.stroke && style.hasOwnProperty('weight')) {
					this._updateBounds();
				}
			}
			return this;
		},
	
		// @method bringToFront(): this
		// Brings the layer to the top of all path layers.
		bringToFront: function () {
			if (this._renderer) {
				this._renderer._bringToFront(this);
			}
			return this;
		},
	
		// @method bringToBack(): this
		// Brings the layer to the bottom of all path layers.
		bringToBack: function () {
			if (this._renderer) {
				this._renderer._bringToBack(this);
			}
			return this;
		},
	
		getElement: function () {
			return this._path;
		},
	
		_reset: function () {
			// defined in child classes
			this._project();
			this._update();
		},
	
		_clickTolerance: function () {
			// used when doing hit detection for Canvas layers
			return (this.options.stroke ? this.options.weight / 2 : 0) + this._renderer.options.tolerance;
		}
	});
	
	/*
	 * @class CircleMarker
	 * @aka L.CircleMarker
	 * @inherits Path
	 *
	 * A circle of a fixed size with radius specified in pixels. Extends `Path`.
	 */
	
	var CircleMarker = Path.extend({
	
		// @section
		// @aka CircleMarker options
		options: {
			fill: true,
	
			// @option radius: Number = 10
			// Radius of the circle marker, in pixels
			radius: 10
		},
	
		initialize: function (latlng, options) {
			setOptions(this, options);
			this._latlng = toLatLng(latlng);
			this._radius = this.options.radius;
		},
	
		// @method setLatLng(latLng: LatLng): this
		// Sets the position of a circle marker to a new location.
		setLatLng: function (latlng) {
			this._latlng = toLatLng(latlng);
			this.redraw();
			return this.fire('move', {latlng: this._latlng});
		},
	
		// @method getLatLng(): LatLng
		// Returns the current geographical position of the circle marker
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setRadius(radius: Number): this
		// Sets the radius of a circle marker. Units are in pixels.
		setRadius: function (radius) {
			this.options.radius = this._radius = radius;
			return this.redraw();
		},
	
		// @method getRadius(): Number
		// Returns the current radius of the circle
		getRadius: function () {
			return this._radius;
		},
	
		setStyle : function (options) {
			var radius = options && options.radius || this._radius;
			Path.prototype.setStyle.call(this, options);
			this.setRadius(radius);
			return this;
		},
	
		_project: function () {
			this._point = this._map.latLngToLayerPoint(this._latlng);
			this._updateBounds();
		},
	
		_updateBounds: function () {
			var r = this._radius,
			    r2 = this._radiusY || r,
			    w = this._clickTolerance(),
			    p = [r + w, r2 + w];
			this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
		},
	
		_update: function () {
			if (this._map) {
				this._updatePath();
			}
		},
	
		_updatePath: function () {
			this._renderer._updateCircle(this);
		},
	
		_empty: function () {
			return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
		},
	
		// Needed by the `Canvas` renderer for interactivity
		_containsPoint: function (p) {
			return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
		}
	});
	
	
	// @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
	// Instantiates a circle marker object given a geographical point, and an optional options object.
	function circleMarker(latlng, options) {
		return new CircleMarker(latlng, options);
	}
	
	/*
	 * @class Circle
	 * @aka L.Circle
	 * @inherits CircleMarker
	 *
	 * A class for drawing circle overlays on a map. Extends `CircleMarker`.
	 *
	 * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
	 *
	 * @example
	 *
	 * ```js
	 * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
	 * ```
	 */
	
	var Circle = CircleMarker.extend({
	
		initialize: function (latlng, options, legacyOptions) {
			if (typeof options === 'number') {
				// Backwards compatibility with 0.7.x factory (latlng, radius, options?)
				options = extend({}, legacyOptions, {radius: options});
			}
			setOptions(this, options);
			this._latlng = toLatLng(latlng);
	
			if (isNaN(this.options.radius)) { throw new Error('Circle radius cannot be NaN'); }
	
			// @section
			// @aka Circle options
			// @option radius: Number; Radius of the circle, in meters.
			this._mRadius = this.options.radius;
		},
	
		// @method setRadius(radius: Number): this
		// Sets the radius of a circle. Units are in meters.
		setRadius: function (radius) {
			this._mRadius = radius;
			return this.redraw();
		},
	
		// @method getRadius(): Number
		// Returns the current radius of a circle. Units are in meters.
		getRadius: function () {
			return this._mRadius;
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the `LatLngBounds` of the path.
		getBounds: function () {
			var half = [this._radius, this._radiusY || this._radius];
	
			return new LatLngBounds(
				this._map.layerPointToLatLng(this._point.subtract(half)),
				this._map.layerPointToLatLng(this._point.add(half)));
		},
	
		setStyle: Path.prototype.setStyle,
	
		_project: function () {
	
			var lng = this._latlng.lng,
			    lat = this._latlng.lat,
			    map = this._map,
			    crs = map.options.crs;
	
			if (crs.distance === Earth.distance) {
				var d = Math.PI / 180,
				    latR = (this._mRadius / Earth.R) / d,
				    top = map.project([lat + latR, lng]),
				    bottom = map.project([lat - latR, lng]),
				    p = top.add(bottom).divideBy(2),
				    lat2 = map.unproject(p).lat,
				    lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) /
				            (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
	
				if (isNaN(lngR) || lngR === 0) {
					lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
				}
	
				this._point = p.subtract(map.getPixelOrigin());
				this._radius = isNaN(lngR) ? 0 : p.x - map.project([lat2, lng - lngR]).x;
				this._radiusY = p.y - top.y;
	
			} else {
				var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));
	
				this._point = map.latLngToLayerPoint(this._latlng);
				this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
			}
	
			this._updateBounds();
		}
	});
	
	// @factory L.circle(latlng: LatLng, options?: Circle options)
	// Instantiates a circle object given a geographical point, and an options object
	// which contains the circle radius.
	// @alternative
	// @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
	// Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
	// Do not use in new applications or plugins.
	function circle(latlng, options, legacyOptions) {
		return new Circle(latlng, options, legacyOptions);
	}
	
	/*
	 * @class Polyline
	 * @aka L.Polyline
	 * @inherits Path
	 *
	 * A class for drawing polyline overlays on a map. Extends `Path`.
	 *
	 * @example
	 *
	 * ```js
	 * // create a red polyline from an array of LatLng points
	 * var latlngs = [
	 * 	[45.51, -122.68],
	 * 	[37.77, -122.43],
	 * 	[34.04, -118.2]
	 * ];
	 *
	 * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
	 *
	 * // zoom the map to the polyline
	 * map.fitBounds(polyline.getBounds());
	 * ```
	 *
	 * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
	 *
	 * ```js
	 * // create a red polyline from an array of arrays of LatLng points
	 * var latlngs = [
	 * 	[[45.51, -122.68],
	 * 	 [37.77, -122.43],
	 * 	 [34.04, -118.2]],
	 * 	[[40.78, -73.91],
	 * 	 [41.83, -87.62],
	 * 	 [32.76, -96.72]]
	 * ];
	 * ```
	 */
	
	
	var Polyline = Path.extend({
	
		// @section
		// @aka Polyline options
		options: {
			// @option smoothFactor: Number = 1.0
			// How much to simplify the polyline on each zoom level. More means
			// better performance and smoother look, and less means more accurate representation.
			smoothFactor: 1.0,
	
			// @option noClip: Boolean = false
			// Disable polyline clipping.
			noClip: false
		},
	
		initialize: function (latlngs, options) {
			setOptions(this, options);
			this._setLatLngs(latlngs);
		},
	
		// @method getLatLngs(): LatLng[]
		// Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
		getLatLngs: function () {
			return this._latlngs;
		},
	
		// @method setLatLngs(latlngs: LatLng[]): this
		// Replaces all the points in the polyline with the given array of geographical points.
		setLatLngs: function (latlngs) {
			this._setLatLngs(latlngs);
			return this.redraw();
		},
	
		// @method isEmpty(): Boolean
		// Returns `true` if the Polyline has no LatLngs.
		isEmpty: function () {
			return !this._latlngs.length;
		},
	
		// @method closestLayerPoint(p: Point): Point
		// Returns the point closest to `p` on the Polyline.
		closestLayerPoint: function (p) {
			var minDistance = Infinity,
			    minPoint = null,
			    closest = _sqClosestPointOnSegment,
			    p1, p2;
	
			for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
				var points = this._parts[j];
	
				for (var i = 1, len = points.length; i < len; i++) {
					p1 = points[i - 1];
					p2 = points[i];
	
					var sqDist = closest(p, p1, p2, true);
	
					if (sqDist < minDistance) {
						minDistance = sqDist;
						minPoint = closest(p, p1, p2);
					}
				}
			}
			if (minPoint) {
				minPoint.distance = Math.sqrt(minDistance);
			}
			return minPoint;
		},
	
		// @method getCenter(): LatLng
		// Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the polyline.
		getCenter: function () {
			// throws error when not yet added to map as this center calculation requires projected coordinates
			if (!this._map) {
				throw new Error('Must add layer to map before using getCenter()');
			}
	
			var i, halfDist, segDist, dist, p1, p2, ratio,
			    points = this._rings[0],
			    len = points.length;
	
			if (!len) { return null; }
	
			// polyline centroid algorithm; only uses the first ring if there are multiple
	
			for (i = 0, halfDist = 0; i < len - 1; i++) {
				halfDist += points[i].distanceTo(points[i + 1]) / 2;
			}
	
			// The line is so small in the current view that all points are on the same pixel.
			if (halfDist === 0) {
				return this._map.layerPointToLatLng(points[0]);
			}
	
			for (i = 0, dist = 0; i < len - 1; i++) {
				p1 = points[i];
				p2 = points[i + 1];
				segDist = p1.distanceTo(p2);
				dist += segDist;
	
				if (dist > halfDist) {
					ratio = (dist - halfDist) / segDist;
					return this._map.layerPointToLatLng([
						p2.x - ratio * (p2.x - p1.x),
						p2.y - ratio * (p2.y - p1.y)
					]);
				}
			}
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the `LatLngBounds` of the path.
		getBounds: function () {
			return this._bounds;
		},
	
		// @method addLatLng(latlng: LatLng, latlngs? LatLng[]): this
		// Adds a given point to the polyline. By default, adds to the first ring of
		// the polyline in case of a multi-polyline, but can be overridden by passing
		// a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
		addLatLng: function (latlng, latlngs) {
			latlngs = latlngs || this._defaultShape();
			latlng = toLatLng(latlng);
			latlngs.push(latlng);
			this._bounds.extend(latlng);
			return this.redraw();
		},
	
		_setLatLngs: function (latlngs) {
			this._bounds = new LatLngBounds();
			this._latlngs = this._convertLatLngs(latlngs);
		},
	
		_defaultShape: function () {
			return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
		},
	
		// recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
		_convertLatLngs: function (latlngs) {
			var result = [],
			    flat = isFlat(latlngs);
	
			for (var i = 0, len = latlngs.length; i < len; i++) {
				if (flat) {
					result[i] = toLatLng(latlngs[i]);
					this._bounds.extend(result[i]);
				} else {
					result[i] = this._convertLatLngs(latlngs[i]);
				}
			}
	
			return result;
		},
	
		_project: function () {
			var pxBounds = new Bounds();
			this._rings = [];
			this._projectLatlngs(this._latlngs, this._rings, pxBounds);
	
			if (this._bounds.isValid() && pxBounds.isValid()) {
				this._rawPxBounds = pxBounds;
				this._updateBounds();
			}
		},
	
		_updateBounds: function () {
			var w = this._clickTolerance(),
			    p = new Point(w, w);
			this._pxBounds = new Bounds([
				this._rawPxBounds.min.subtract(p),
				this._rawPxBounds.max.add(p)
			]);
		},
	
		// recursively turns latlngs into a set of rings with projected coordinates
		_projectLatlngs: function (latlngs, result, projectedBounds) {
			var flat = latlngs[0] instanceof LatLng,
			    len = latlngs.length,
			    i, ring;
	
			if (flat) {
				ring = [];
				for (i = 0; i < len; i++) {
					ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
					projectedBounds.extend(ring[i]);
				}
				result.push(ring);
			} else {
				for (i = 0; i < len; i++) {
					this._projectLatlngs(latlngs[i], result, projectedBounds);
				}
			}
		},
	
		// clip polyline by renderer bounds so that we have less to render for performance
		_clipPoints: function () {
			var bounds = this._renderer._bounds;
	
			this._parts = [];
			if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
				return;
			}
	
			if (this.options.noClip) {
				this._parts = this._rings;
				return;
			}
	
			var parts = this._parts,
			    i, j, k, len, len2, segment, points;
	
			for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
				points = this._rings[i];
	
				for (j = 0, len2 = points.length; j < len2 - 1; j++) {
					segment = clipSegment(points[j], points[j + 1], bounds, j, true);
	
					if (!segment) { continue; }
	
					parts[k] = parts[k] || [];
					parts[k].push(segment[0]);
	
					// if segment goes out of screen, or it's the last one, it's the end of the line part
					if ((segment[1] !== points[j + 1]) || (j === len2 - 2)) {
						parts[k].push(segment[1]);
						k++;
					}
				}
			}
		},
	
		// simplify each clipped part of the polyline for performance
		_simplifyPoints: function () {
			var parts = this._parts,
			    tolerance = this.options.smoothFactor;
	
			for (var i = 0, len = parts.length; i < len; i++) {
				parts[i] = simplify(parts[i], tolerance);
			}
		},
	
		_update: function () {
			if (!this._map) { return; }
	
			this._clipPoints();
			this._simplifyPoints();
			this._updatePath();
		},
	
		_updatePath: function () {
			this._renderer._updatePoly(this);
		},
	
		// Needed by the `Canvas` renderer for interactivity
		_containsPoint: function (p, closed) {
			var i, j, k, len, len2, part,
			    w = this._clickTolerance();
	
			if (!this._pxBounds || !this._pxBounds.contains(p)) { return false; }
	
			// hit detection for polylines
			for (i = 0, len = this._parts.length; i < len; i++) {
				part = this._parts[i];
	
				for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
					if (!closed && (j === 0)) { continue; }
	
					if (pointToSegmentDistance(p, part[k], part[j]) <= w) {
						return true;
					}
				}
			}
			return false;
		}
	});
	
	// @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
	// Instantiates a polyline object given an array of geographical points and
	// optionally an options object. You can create a `Polyline` object with
	// multiple separate lines (`MultiPolyline`) by passing an array of arrays
	// of geographic points.
	function polyline(latlngs, options) {
		return new Polyline(latlngs, options);
	}
	
	// Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
	Polyline._flat = _flat;
	
	/*
	 * @class Polygon
	 * @aka L.Polygon
	 * @inherits Polyline
	 *
	 * A class for drawing polygon overlays on a map. Extends `Polyline`.
	 *
	 * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
	 *
	 *
	 * @example
	 *
	 * ```js
	 * // create a red polygon from an array of LatLng points
	 * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
	 *
	 * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
	 *
	 * // zoom the map to the polygon
	 * map.fitBounds(polygon.getBounds());
	 * ```
	 *
	 * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
	 *
	 * ```js
	 * var latlngs = [
	 *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	 *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	 * ];
	 * ```
	 *
	 * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
	 *
	 * ```js
	 * var latlngs = [
	 *   [ // first polygon
	 *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	 *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	 *   ],
	 *   [ // second polygon
	 *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
	 *   ]
	 * ];
	 * ```
	 */
	
	var Polygon = Polyline.extend({
	
		options: {
			fill: true
		},
	
		isEmpty: function () {
			return !this._latlngs.length || !this._latlngs[0].length;
		},
	
		getCenter: function () {
			// throws error when not yet added to map as this center calculation requires projected coordinates
			if (!this._map) {
				throw new Error('Must add layer to map before using getCenter()');
			}
	
			var i, j, p1, p2, f, area, x, y, center,
			    points = this._rings[0],
			    len = points.length;
	
			if (!len) { return null; }
	
			// polygon centroid algorithm; only uses the first ring if there are multiple
	
			area = x = y = 0;
	
			for (i = 0, j = len - 1; i < len; j = i++) {
				p1 = points[i];
				p2 = points[j];
	
				f = p1.y * p2.x - p2.y * p1.x;
				x += (p1.x + p2.x) * f;
				y += (p1.y + p2.y) * f;
				area += f * 3;
			}
	
			if (area === 0) {
				// Polygon is so small that all points are on same pixel.
				center = points[0];
			} else {
				center = [x / area, y / area];
			}
			return this._map.layerPointToLatLng(center);
		},
	
		_convertLatLngs: function (latlngs) {
			var result = Polyline.prototype._convertLatLngs.call(this, latlngs),
			    len = result.length;
	
			// remove last point if it equals first one
			if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) {
				result.pop();
			}
			return result;
		},
	
		_setLatLngs: function (latlngs) {
			Polyline.prototype._setLatLngs.call(this, latlngs);
			if (isFlat(this._latlngs)) {
				this._latlngs = [this._latlngs];
			}
		},
	
		_defaultShape: function () {
			return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
		},
	
		_clipPoints: function () {
			// polygons need a different clipping algorithm so we redefine that
	
			var bounds = this._renderer._bounds,
			    w = this.options.weight,
			    p = new Point(w, w);
	
			// increase clip padding by stroke width to avoid stroke on clip edges
			bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
	
			this._parts = [];
			if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
				return;
			}
	
			if (this.options.noClip) {
				this._parts = this._rings;
				return;
			}
	
			for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
				clipped = clipPolygon(this._rings[i], bounds, true);
				if (clipped.length) {
					this._parts.push(clipped);
				}
			}
		},
	
		_updatePath: function () {
			this._renderer._updatePoly(this, true);
		},
	
		// Needed by the `Canvas` renderer for interactivity
		_containsPoint: function (p) {
			var inside = false,
			    part, p1, p2, i, j, k, len, len2;
	
			if (!this._pxBounds || !this._pxBounds.contains(p)) { return false; }
	
			// ray casting algorithm for detecting if point is in polygon
			for (i = 0, len = this._parts.length; i < len; i++) {
				part = this._parts[i];
	
				for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
					p1 = part[j];
					p2 = part[k];
	
					if (((p1.y > p.y) !== (p2.y > p.y)) && (p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
						inside = !inside;
					}
				}
			}
	
			// also check if it's on polygon stroke
			return inside || Polyline.prototype._containsPoint.call(this, p, true);
		}
	
	});
	
	
	// @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
	function polygon(latlngs, options) {
		return new Polygon(latlngs, options);
	}
	
	/*
	 * @class GeoJSON
	 * @aka L.GeoJSON
	 * @inherits FeatureGroup
	 *
	 * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
	 * GeoJSON data and display it on the map. Extends `FeatureGroup`.
	 *
	 * @example
	 *
	 * ```js
	 * L.geoJSON(data, {
	 * 	style: function (feature) {
	 * 		return {color: feature.properties.color};
	 * 	}
	 * }).bindPopup(function (layer) {
	 * 	return layer.feature.properties.description;
	 * }).addTo(map);
	 * ```
	 */
	
	var GeoJSON = FeatureGroup.extend({
	
		/* @section
		 * @aka GeoJSON options
		 *
		 * @option pointToLayer: Function = *
		 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
		 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
		 * The default is to spawn a default `Marker`:
		 * ```js
		 * function(geoJsonPoint, latlng) {
		 * 	return L.marker(latlng);
		 * }
		 * ```
		 *
		 * @option style: Function = *
		 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
		 * called internally when data is added.
		 * The default value is to not override any defaults:
		 * ```js
		 * function (geoJsonFeature) {
		 * 	return {}
		 * }
		 * ```
		 *
		 * @option onEachFeature: Function = *
		 * A `Function` that will be called once for each created `Feature`, after it has
		 * been created and styled. Useful for attaching events and popups to features.
		 * The default is to do nothing with the newly created layers:
		 * ```js
		 * function (feature, layer) {}
		 * ```
		 *
		 * @option filter: Function = *
		 * A `Function` that will be used to decide whether to include a feature or not.
		 * The default is to include all features:
		 * ```js
		 * function (geoJsonFeature) {
		 * 	return true;
		 * }
		 * ```
		 * Note: dynamically changing the `filter` option will have effect only on newly
		 * added data. It will _not_ re-evaluate already included features.
		 *
		 * @option coordsToLatLng: Function = *
		 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
		 * The default is the `coordsToLatLng` static method.
		 */
	
		initialize: function (geojson, options) {
			setOptions(this, options);
	
			this._layers = {};
	
			if (geojson) {
				this.addData(geojson);
			}
		},
	
		// @method addData( <GeoJSON> data ): this
		// Adds a GeoJSON object to the layer.
		addData: function (geojson) {
			var features = isArray(geojson) ? geojson : geojson.features,
			    i, len, feature;
	
			if (features) {
				for (i = 0, len = features.length; i < len; i++) {
					// only add this if geometry or geometries are set and not null
					feature = features[i];
					if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
						this.addData(feature);
					}
				}
				return this;
			}
	
			var options = this.options;
	
			if (options.filter && !options.filter(geojson)) { return this; }
	
			var layer = geometryToLayer(geojson, options);
			if (!layer) {
				return this;
			}
			layer.feature = asFeature(geojson);
	
			layer.defaultOptions = layer.options;
			this.resetStyle(layer);
	
			if (options.onEachFeature) {
				options.onEachFeature(geojson, layer);
			}
	
			return this.addLayer(layer);
		},
	
		// @method resetStyle( <Path> layer ): this
		// Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
		resetStyle: function (layer) {
			// reset any custom styles
			layer.options = extend({}, layer.defaultOptions);
			this._setLayerStyle(layer, this.options.style);
			return this;
		},
	
		// @method setStyle( <Function> style ): this
		// Changes styles of GeoJSON vector layers with the given style function.
		setStyle: function (style) {
			return this.eachLayer(function (layer) {
				this._setLayerStyle(layer, style);
			}, this);
		},
	
		_setLayerStyle: function (layer, style) {
			if (layer.setStyle) {
				if (typeof style === 'function') {
					style = style(layer.feature);
				}
				layer.setStyle(style);
			}
		}
	});
	
	// @section
	// There are several static functions which can be called without instantiating L.GeoJSON:
	
	// @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
	// Creates a `Layer` from a given GeoJSON feature. Can use a custom
	// [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
	// functions if provided as options.
	function geometryToLayer(geojson, options) {
	
		var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
		    coords = geometry ? geometry.coordinates : null,
		    layers = [],
		    pointToLayer = options && options.pointToLayer,
		    _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng,
		    latlng, latlngs, i, len;
	
		if (!coords && !geometry) {
			return null;
		}
	
		switch (geometry.type) {
		case 'Point':
			latlng = _coordsToLatLng(coords);
			return pointToLayer ? pointToLayer(geojson, latlng) : new Marker(latlng);
	
		case 'MultiPoint':
			for (i = 0, len = coords.length; i < len; i++) {
				latlng = _coordsToLatLng(coords[i]);
				layers.push(pointToLayer ? pointToLayer(geojson, latlng) : new Marker(latlng));
			}
			return new FeatureGroup(layers);
	
		case 'LineString':
		case 'MultiLineString':
			latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
			return new Polyline(latlngs, options);
	
		case 'Polygon':
		case 'MultiPolygon':
			latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
			return new Polygon(latlngs, options);
	
		case 'GeometryCollection':
			for (i = 0, len = geometry.geometries.length; i < len; i++) {
				var layer = geometryToLayer({
					geometry: geometry.geometries[i],
					type: 'Feature',
					properties: geojson.properties
				}, options);
	
				if (layer) {
					layers.push(layer);
				}
			}
			return new FeatureGroup(layers);
	
		default:
			throw new Error('Invalid GeoJSON object.');
		}
	}
	
	// @function coordsToLatLng(coords: Array): LatLng
	// Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
	// or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
	function coordsToLatLng(coords) {
		return new LatLng(coords[1], coords[0], coords[2]);
	}
	
	// @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
	// Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
	// `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
	// Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
	function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
		var latlngs = [];
	
		for (var i = 0, len = coords.length, latlng; i < len; i++) {
			latlng = levelsDeep ?
				coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) :
				(_coordsToLatLng || coordsToLatLng)(coords[i]);
	
			latlngs.push(latlng);
		}
	
		return latlngs;
	}
	
	// @function latLngToCoords(latlng: LatLng, precision?: Number): Array
	// Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
	function latLngToCoords(latlng, precision) {
		precision = typeof precision === 'number' ? precision : 6;
		return latlng.alt !== undefined ?
			[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision), formatNum(latlng.alt, precision)] :
			[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision)];
	}
	
	// @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean): Array
	// Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
	// `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
	function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
		var coords = [];
	
		for (var i = 0, len = latlngs.length; i < len; i++) {
			coords.push(levelsDeep ?
				latLngsToCoords(latlngs[i], levelsDeep - 1, closed, precision) :
				latLngToCoords(latlngs[i], precision));
		}
	
		if (!levelsDeep && closed) {
			coords.push(coords[0]);
		}
	
		return coords;
	}
	
	function getFeature(layer, newGeometry) {
		return layer.feature ?
			extend({}, layer.feature, {geometry: newGeometry}) :
			asFeature(newGeometry);
	}
	
	// @function asFeature(geojson: Object): Object
	// Normalize GeoJSON geometries/features into GeoJSON features.
	function asFeature(geojson) {
		if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') {
			return geojson;
		}
	
		return {
			type: 'Feature',
			properties: {},
			geometry: geojson
		};
	}
	
	var PointToGeoJSON = {
		toGeoJSON: function (precision) {
			return getFeature(this, {
				type: 'Point',
				coordinates: latLngToCoords(this.getLatLng(), precision)
			});
		}
	};
	
	// @namespace Marker
	// @method toGeoJSON(precision?: Number): Object
	// `precision` is the number of decimal places for coordinates.
	// The default value is 6 places.
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
	Marker.include(PointToGeoJSON);
	
	// @namespace CircleMarker
	// @method toGeoJSON(precision?: Number): Object
	// `precision` is the number of decimal places for coordinates.
	// The default value is 6 places.
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
	Circle.include(PointToGeoJSON);
	CircleMarker.include(PointToGeoJSON);
	
	
	// @namespace Polyline
	// @method toGeoJSON(precision?: Number): Object
	// `precision` is the number of decimal places for coordinates.
	// The default value is 6 places.
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
	Polyline.include({
		toGeoJSON: function (precision) {
			var multi = !isFlat(this._latlngs);
	
			var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
	
			return getFeature(this, {
				type: (multi ? 'Multi' : '') + 'LineString',
				coordinates: coords
			});
		}
	});
	
	// @namespace Polygon
	// @method toGeoJSON(precision?: Number): Object
	// `precision` is the number of decimal places for coordinates.
	// The default value is 6 places.
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
	Polygon.include({
		toGeoJSON: function (precision) {
			var holes = !isFlat(this._latlngs),
			    multi = holes && !isFlat(this._latlngs[0]);
	
			var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
	
			if (!holes) {
				coords = [coords];
			}
	
			return getFeature(this, {
				type: (multi ? 'Multi' : '') + 'Polygon',
				coordinates: coords
			});
		}
	});
	
	
	// @namespace LayerGroup
	LayerGroup.include({
		toMultiPoint: function (precision) {
			var coords = [];
	
			this.eachLayer(function (layer) {
				coords.push(layer.toGeoJSON(precision).geometry.coordinates);
			});
	
			return getFeature(this, {
				type: 'MultiPoint',
				coordinates: coords
			});
		},
	
		// @method toGeoJSON(precision?: Number): Object
		// `precision` is the number of decimal places for coordinates.
		// The default value is 6 places.
		// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
		toGeoJSON: function (precision) {
	
			var type = this.feature && this.feature.geometry && this.feature.geometry.type;
	
			if (type === 'MultiPoint') {
				return this.toMultiPoint(precision);
			}
	
			var isGeometryCollection = type === 'GeometryCollection',
			    jsons = [];
	
			this.eachLayer(function (layer) {
				if (layer.toGeoJSON) {
					var json = layer.toGeoJSON(precision);
					if (isGeometryCollection) {
						jsons.push(json.geometry);
					} else {
						var feature = asFeature(json);
						// Squash nested feature collections
						if (feature.type === 'FeatureCollection') {
							jsons.push.apply(jsons, feature.features);
						} else {
							jsons.push(feature);
						}
					}
				}
			});
	
			if (isGeometryCollection) {
				return getFeature(this, {
					geometries: jsons,
					type: 'GeometryCollection'
				});
			}
	
			return {
				type: 'FeatureCollection',
				features: jsons
			};
		}
	});
	
	// @namespace GeoJSON
	// @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
	// Creates a GeoJSON layer. Optionally accepts an object in
	// [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
	// (you can alternatively add it later with `addData` method) and an `options` object.
	function geoJSON(geojson, options) {
		return new GeoJSON(geojson, options);
	}
	
	// Backward compatibility.
	var geoJson = geoJSON;
	
	/*
	 * @class ImageOverlay
	 * @aka L.ImageOverlay
	 * @inherits Interactive layer
	 *
	 * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * var imageUrl = 'http://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
	 * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
	 * L.imageOverlay(imageUrl, imageBounds).addTo(map);
	 * ```
	 */
	
	var ImageOverlay = Layer.extend({
	
		// @section
		// @aka ImageOverlay options
		options: {
			// @option opacity: Number = 1.0
			// The opacity of the image overlay.
			opacity: 1,
	
			// @option alt: String = ''
			// Text for the `alt` attribute of the image (useful for accessibility).
			alt: '',
	
			// @option interactive: Boolean = false
			// If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
			interactive: false,
	
			// @option crossOrigin: Boolean|String = false
			// Whether the crossOrigin attribute will be added to the image.
			// If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
			// Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
			crossOrigin: false,
	
			// @option errorOverlayUrl: String = ''
			// URL to the overlay image to show in place of the overlay that failed to load.
			errorOverlayUrl: '',
	
			// @option zIndex: Number = 1
			// The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
			zIndex: 1,
	
			// @option className: String = ''
			// A custom class name to assign to the image. Empty by default.
			className: ''
		},
	
		initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
			this._url = url;
			this._bounds = toLatLngBounds(bounds);
	
			setOptions(this, options);
		},
	
		onAdd: function () {
			if (!this._image) {
				this._initImage();
	
				if (this.options.opacity < 1) {
					this._updateOpacity();
				}
			}
	
			if (this.options.interactive) {
				addClass(this._image, 'leaflet-interactive');
				this.addInteractiveTarget(this._image);
			}
	
			this.getPane().appendChild(this._image);
			this._reset();
		},
	
		onRemove: function () {
			remove(this._image);
			if (this.options.interactive) {
				this.removeInteractiveTarget(this._image);
			}
		},
	
		// @method setOpacity(opacity: Number): this
		// Sets the opacity of the overlay.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
	
			if (this._image) {
				this._updateOpacity();
			}
			return this;
		},
	
		setStyle: function (styleOpts) {
			if (styleOpts.opacity) {
				this.setOpacity(styleOpts.opacity);
			}
			return this;
		},
	
		// @method bringToFront(): this
		// Brings the layer to the top of all overlays.
		bringToFront: function () {
			if (this._map) {
				toFront(this._image);
			}
			return this;
		},
	
		// @method bringToBack(): this
		// Brings the layer to the bottom of all overlays.
		bringToBack: function () {
			if (this._map) {
				toBack(this._image);
			}
			return this;
		},
	
		// @method setUrl(url: String): this
		// Changes the URL of the image.
		setUrl: function (url) {
			this._url = url;
	
			if (this._image) {
				this._image.src = url;
			}
			return this;
		},
	
		// @method setBounds(bounds: LatLngBounds): this
		// Update the bounds that this ImageOverlay covers
		setBounds: function (bounds) {
			this._bounds = toLatLngBounds(bounds);
	
			if (this._map) {
				this._reset();
			}
			return this;
		},
	
		getEvents: function () {
			var events = {
				zoom: this._reset,
				viewreset: this._reset
			};
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
	
			return events;
		},
	
		// @method setZIndex(value: Number): this
		// Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
		setZIndex: function (value) {
			this.options.zIndex = value;
			this._updateZIndex();
			return this;
		},
	
		// @method getBounds(): LatLngBounds
		// Get the bounds that this ImageOverlay covers
		getBounds: function () {
			return this._bounds;
		},
	
		// @method getElement(): HTMLElement
		// Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
		// used by this overlay.
		getElement: function () {
			return this._image;
		},
	
		_initImage: function () {
			var wasElementSupplied = this._url.tagName === 'IMG';
			var img = this._image = wasElementSupplied ? this._url : create$1('img');
	
			addClass(img, 'leaflet-image-layer');
			if (this._zoomAnimated) { addClass(img, 'leaflet-zoom-animated'); }
			if (this.options.className) { addClass(img, this.options.className); }
	
			img.onselectstart = falseFn;
			img.onmousemove = falseFn;
	
			// @event load: Event
			// Fired when the ImageOverlay layer has loaded its image
			img.onload = bind(this.fire, this, 'load');
			img.onerror = bind(this._overlayOnError, this, 'error');
	
			if (this.options.crossOrigin || this.options.crossOrigin === '') {
				img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
			}
	
			if (this.options.zIndex) {
				this._updateZIndex();
			}
	
			if (wasElementSupplied) {
				this._url = img.src;
				return;
			}
	
			img.src = this._url;
			img.alt = this.options.alt;
		},
	
		_animateZoom: function (e) {
			var scale = this._map.getZoomScale(e.zoom),
			    offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
	
			setTransform(this._image, offset, scale);
		},
	
		_reset: function () {
			var image = this._image,
			    bounds = new Bounds(
			        this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
			        this._map.latLngToLayerPoint(this._bounds.getSouthEast())),
			    size = bounds.getSize();
	
			setPosition(image, bounds.min);
	
			image.style.width  = size.x + 'px';
			image.style.height = size.y + 'px';
		},
	
		_updateOpacity: function () {
			setOpacity(this._image, this.options.opacity);
		},
	
		_updateZIndex: function () {
			if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) {
				this._image.style.zIndex = this.options.zIndex;
			}
		},
	
		_overlayOnError: function () {
			// @event error: Event
			// Fired when the ImageOverlay layer fails to load its image
			this.fire('error');
	
			var errorUrl = this.options.errorOverlayUrl;
			if (errorUrl && this._url !== errorUrl) {
				this._url = errorUrl;
				this._image.src = errorUrl;
			}
		}
	});
	
	// @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
	// Instantiates an image overlay object given the URL of the image and the
	// geographical bounds it is tied to.
	var imageOverlay = function (url, bounds, options) {
		return new ImageOverlay(url, bounds, options);
	};
	
	/*
	 * @class VideoOverlay
	 * @aka L.VideoOverlay
	 * @inherits ImageOverlay
	 *
	 * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
	 *
	 * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
	 * HTML5 element.
	 *
	 * @example
	 *
	 * ```js
	 * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
	 * 	videoBounds = [[ 32, -130], [ 13, -100]];
	 * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
	 * ```
	 */
	
	var VideoOverlay = ImageOverlay.extend({
	
		// @section
		// @aka VideoOverlay options
		options: {
			// @option autoplay: Boolean = true
			// Whether the video starts playing automatically when loaded.
			autoplay: true,
	
			// @option loop: Boolean = true
			// Whether the video will loop back to the beginning when played.
			loop: true,
	
			// @option keepAspectRatio: Boolean = true
			// Whether the video will save aspect ratio after the projection.
			// Relevant for supported browsers. Browser compatibility- https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit
			keepAspectRatio: true
		},
	
		_initImage: function () {
			var wasElementSupplied = this._url.tagName === 'VIDEO';
			var vid = this._image = wasElementSupplied ? this._url : create$1('video');
	
			addClass(vid, 'leaflet-image-layer');
			if (this._zoomAnimated) { addClass(vid, 'leaflet-zoom-animated'); }
	
			vid.onselectstart = falseFn;
			vid.onmousemove = falseFn;
	
			// @event load: Event
			// Fired when the video has finished loading the first frame
			vid.onloadeddata = bind(this.fire, this, 'load');
	
			if (wasElementSupplied) {
				var sourceElements = vid.getElementsByTagName('source');
				var sources = [];
				for (var j = 0; j < sourceElements.length; j++) {
					sources.push(sourceElements[j].src);
				}
	
				this._url = (sourceElements.length > 0) ? sources : [vid.src];
				return;
			}
	
			if (!isArray(this._url)) { this._url = [this._url]; }
	
			if (!this.options.keepAspectRatio && vid.style.hasOwnProperty('objectFit')) { vid.style['objectFit'] = 'fill'; }
			vid.autoplay = !!this.options.autoplay;
			vid.loop = !!this.options.loop;
			for (var i = 0; i < this._url.length; i++) {
				var source = create$1('source');
				source.src = this._url[i];
				vid.appendChild(source);
			}
		}
	
		// @method getElement(): HTMLVideoElement
		// Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
		// used by this overlay.
	});
	
	
	// @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
	// Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
	// geographical bounds it is tied to.
	
	function videoOverlay(video, bounds, options) {
		return new VideoOverlay(video, bounds, options);
	}
	
	/*
	 * @class SVGOverlay
	 * @aka L.SVGOverlay
	 * @inherits ImageOverlay
	 *
	 * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
	 *
	 * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
	 *
	 * @example
	 *
	 * ```js
	 * var element = '<svg width="200" height="200" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><image xlink:href="https://mdn.mozillademos.org/files/6457/mdn_logo_only_color.png" height="200" width="200"/></svg>',
	 * 		 elementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
	 * L.svgOverlay(element, elementBounds).addTo(map);
	 * ```
	 */
	
	var SVGOverlay = ImageOverlay.extend({
		_initImage: function () {
			var el = this._image = this._url;
	
			addClass(el, 'leaflet-image-layer');
			if (this._zoomAnimated) { addClass(el, 'leaflet-zoom-animated'); }
	
			el.onselectstart = falseFn;
			el.onmousemove = falseFn;
		}
	
		// @method getElement(): SVGElement
		// Returns the instance of [`SVGElement`](https://developer.mozilla.org/docs/Web/API/SVGElement)
		// used by this overlay.
	});
	
	
	// @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
	// Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
	// A viewBox attribute is required on the SVG element to zoom in and out properly.
	
	function svgOverlay(el, bounds, options) {
		return new SVGOverlay(el, bounds, options);
	}
	
	/*
	 * @class DivOverlay
	 * @inherits Layer
	 * @aka L.DivOverlay
	 * Base model for L.Popup and L.Tooltip. Inherit from it for custom popup like plugins.
	 */
	
	// @namespace DivOverlay
	var DivOverlay = Layer.extend({
	
		// @section
		// @aka DivOverlay options
		options: {
			// @option offset: Point = Point(0, 7)
			// The offset of the popup position. Useful to control the anchor
			// of the popup when opening it on some overlays.
			offset: [0, 7],
	
			// @option className: String = ''
			// A custom CSS class name to assign to the popup.
			className: '',
	
			// @option pane: String = 'popupPane'
			// `Map pane` where the popup will be added.
			pane: 'popupPane'
		},
	
		initialize: function (options, source) {
			setOptions(this, options);
	
			this._source = source;
		},
	
		onAdd: function (map) {
			this._zoomAnimated = map._zoomAnimated;
	
			if (!this._container) {
				this._initLayout();
			}
	
			if (map._fadeAnimated) {
				setOpacity(this._container, 0);
			}
	
			clearTimeout(this._removeTimeout);
			this.getPane().appendChild(this._container);
			this.update();
	
			if (map._fadeAnimated) {
				setOpacity(this._container, 1);
			}
	
			this.bringToFront();
		},
	
		onRemove: function (map) {
			if (map._fadeAnimated) {
				setOpacity(this._container, 0);
				this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
			} else {
				remove(this._container);
			}
		},
	
		// @namespace Popup
		// @method getLatLng: LatLng
		// Returns the geographical point of popup.
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setLatLng(latlng: LatLng): this
		// Sets the geographical point where the popup will open.
		setLatLng: function (latlng) {
			this._latlng = toLatLng(latlng);
			if (this._map) {
				this._updatePosition();
				this._adjustPan();
			}
			return this;
		},
	
		// @method getContent: String|HTMLElement
		// Returns the content of the popup.
		getContent: function () {
			return this._content;
		},
	
		// @method setContent(htmlContent: String|HTMLElement|Function): this
		// Sets the HTML content of the popup. If a function is passed the source layer will be passed to the function. The function should return a `String` or `HTMLElement` to be used in the popup.
		setContent: function (content) {
			this._content = content;
			this.update();
			return this;
		},
	
		// @method getElement: String|HTMLElement
		// Alias for [getContent()](#popup-getcontent)
		getElement: function () {
			return this._container;
		},
	
		// @method update: null
		// Updates the popup content, layout and position. Useful for updating the popup after something inside changed, e.g. image loaded.
		update: function () {
			if (!this._map) { return; }
	
			this._container.style.visibility = 'hidden';
	
			this._updateContent();
			this._updateLayout();
			this._updatePosition();
	
			this._container.style.visibility = '';
	
			this._adjustPan();
		},
	
		getEvents: function () {
			var events = {
				zoom: this._updatePosition,
				viewreset: this._updatePosition
			};
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
			return events;
		},
	
		// @method isOpen: Boolean
		// Returns `true` when the popup is visible on the map.
		isOpen: function () {
			return !!this._map && this._map.hasLayer(this);
		},
	
		// @method bringToFront: this
		// Brings this popup in front of other popups (in the same map pane).
		bringToFront: function () {
			if (this._map) {
				toFront(this._container);
			}
			return this;
		},
	
		// @method bringToBack: this
		// Brings this popup to the back of other popups (in the same map pane).
		bringToBack: function () {
			if (this._map) {
				toBack(this._container);
			}
			return this;
		},
	
		_prepareOpen: function (parent, layer, latlng) {
			if (!(layer instanceof Layer)) {
				latlng = layer;
				layer = parent;
			}
	
			if (layer instanceof FeatureGroup) {
				for (var id in parent._layers) {
					layer = parent._layers[id];
					break;
				}
			}
	
			if (!latlng) {
				if (layer.getCenter) {
					latlng = layer.getCenter();
				} else if (layer.getLatLng) {
					latlng = layer.getLatLng();
				} else {
					throw new Error('Unable to get source layer LatLng.');
				}
			}
	
			// set overlay source to this layer
			this._source = layer;
	
			// update the overlay (content, layout, ect...)
			this.update();
	
			return latlng;
		},
	
		_updateContent: function () {
			if (!this._content) { return; }
	
			var node = this._contentNode;
			var content = (typeof this._content === 'function') ? this._content(this._source || this) : this._content;
	
			if (typeof content === 'string') {
				node.innerHTML = content;
			} else {
				while (node.hasChildNodes()) {
					node.removeChild(node.firstChild);
				}
				node.appendChild(content);
			}
			this.fire('contentupdate');
		},
	
		_updatePosition: function () {
			if (!this._map) { return; }
	
			var pos = this._map.latLngToLayerPoint(this._latlng),
			    offset = toPoint(this.options.offset),
			    anchor = this._getAnchor();
	
			if (this._zoomAnimated) {
				setPosition(this._container, pos.add(anchor));
			} else {
				offset = offset.add(pos).add(anchor);
			}
	
			var bottom = this._containerBottom = -offset.y,
			    left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
	
			// bottom position the popup in case the height of the popup changes (images loading etc)
			this._container.style.bottom = bottom + 'px';
			this._container.style.left = left + 'px';
		},
	
		_getAnchor: function () {
			return [0, 0];
		}
	
	});
	
	/*
	 * @class Popup
	 * @inherits DivOverlay
	 * @aka L.Popup
	 * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
	 * open popups while making sure that only one popup is open at one time
	 * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
	 *
	 * @example
	 *
	 * If you want to just bind a popup to marker click and then open it, it's really easy:
	 *
	 * ```js
	 * marker.bindPopup(popupContent).openPopup();
	 * ```
	 * Path overlays like polylines also have a `bindPopup` method.
	 * Here's a more complicated way to open a popup on a map:
	 *
	 * ```js
	 * var popup = L.popup()
	 * 	.setLatLng(latlng)
	 * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
	 * 	.openOn(map);
	 * ```
	 */
	
	
	// @namespace Popup
	var Popup = DivOverlay.extend({
	
		// @section
		// @aka Popup options
		options: {
			// @option maxWidth: Number = 300
			// Max width of the popup, in pixels.
			maxWidth: 300,
	
			// @option minWidth: Number = 50
			// Min width of the popup, in pixels.
			minWidth: 50,
	
			// @option maxHeight: Number = null
			// If set, creates a scrollable container of the given height
			// inside a popup if its content exceeds it.
			maxHeight: null,
	
			// @option autoPan: Boolean = true
			// Set it to `false` if you don't want the map to do panning animation
			// to fit the opened popup.
			autoPan: true,
	
			// @option autoPanPaddingTopLeft: Point = null
			// The margin between the popup and the top left corner of the map
			// view after autopanning was performed.
			autoPanPaddingTopLeft: null,
	
			// @option autoPanPaddingBottomRight: Point = null
			// The margin between the popup and the bottom right corner of the map
			// view after autopanning was performed.
			autoPanPaddingBottomRight: null,
	
			// @option autoPanPadding: Point = Point(5, 5)
			// Equivalent of setting both top left and bottom right autopan padding to the same value.
			autoPanPadding: [5, 5],
	
			// @option keepInView: Boolean = false
			// Set it to `true` if you want to prevent users from panning the popup
			// off of the screen while it is open.
			keepInView: false,
	
			// @option closeButton: Boolean = true
			// Controls the presence of a close button in the popup.
			closeButton: true,
	
			// @option autoClose: Boolean = true
			// Set it to `false` if you want to override the default behavior of
			// the popup closing when another popup is opened.
			autoClose: true,
	
			// @option closeOnEscapeKey: Boolean = true
			// Set it to `false` if you want to override the default behavior of
			// the ESC key for closing of the popup.
			closeOnEscapeKey: true,
	
			// @option closeOnClick: Boolean = *
			// Set it if you want to override the default behavior of the popup closing when user clicks
			// on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
	
			// @option className: String = ''
			// A custom CSS class name to assign to the popup.
			className: ''
		},
	
		// @namespace Popup
		// @method openOn(map: Map): this
		// Adds the popup to the map and closes the previous one. The same as `map.openPopup(popup)`.
		openOn: function (map) {
			map.openPopup(this);
			return this;
		},
	
		onAdd: function (map) {
			DivOverlay.prototype.onAdd.call(this, map);
	
			// @namespace Map
			// @section Popup events
			// @event popupopen: PopupEvent
			// Fired when a popup is opened in the map
			map.fire('popupopen', {popup: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Popup events
				// @event popupopen: PopupEvent
				// Fired when a popup bound to this layer is opened
				this._source.fire('popupopen', {popup: this}, true);
				// For non-path layers, we toggle the popup when clicking
				// again the layer, so prevent the map to reopen it.
				if (!(this._source instanceof Path)) {
					this._source.on('preclick', stopPropagation);
				}
			}
		},
	
		onRemove: function (map) {
			DivOverlay.prototype.onRemove.call(this, map);
	
			// @namespace Map
			// @section Popup events
			// @event popupclose: PopupEvent
			// Fired when a popup in the map is closed
			map.fire('popupclose', {popup: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Popup events
				// @event popupclose: PopupEvent
				// Fired when a popup bound to this layer is closed
				this._source.fire('popupclose', {popup: this}, true);
				if (!(this._source instanceof Path)) {
					this._source.off('preclick', stopPropagation);
				}
			}
		},
	
		getEvents: function () {
			var events = DivOverlay.prototype.getEvents.call(this);
	
			if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
				events.preclick = this._close;
			}
	
			if (this.options.keepInView) {
				events.moveend = this._adjustPan;
			}
	
			return events;
		},
	
		_close: function () {
			if (this._map) {
				this._map.closePopup(this);
			}
		},
	
		_initLayout: function () {
			var prefix = 'leaflet-popup',
			    container = this._container = create$1('div',
				prefix + ' ' + (this.options.className || '') +
				' leaflet-zoom-animated');
	
			var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
			this._contentNode = create$1('div', prefix + '-content', wrapper);
	
			disableClickPropagation(wrapper);
			disableScrollPropagation(this._contentNode);
			on(wrapper, 'contextmenu', stopPropagation);
	
			this._tipContainer = create$1('div', prefix + '-tip-container', container);
			this._tip = create$1('div', prefix + '-tip', this._tipContainer);
	
			if (this.options.closeButton) {
				var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
				closeButton.href = '#close';
				closeButton.innerHTML = '&#215;';
	
				on(closeButton, 'click', this._onCloseButtonClick, this);
			}
		},
	
		_updateLayout: function () {
			var container = this._contentNode,
			    style = container.style;
	
			style.width = '';
			style.whiteSpace = 'nowrap';
	
			var width = container.offsetWidth;
			width = Math.min(width, this.options.maxWidth);
			width = Math.max(width, this.options.minWidth);
	
			style.width = (width + 1) + 'px';
			style.whiteSpace = '';
	
			style.height = '';
	
			var height = container.offsetHeight,
			    maxHeight = this.options.maxHeight,
			    scrolledClass = 'leaflet-popup-scrolled';
	
			if (maxHeight && height > maxHeight) {
				style.height = maxHeight + 'px';
				addClass(container, scrolledClass);
			} else {
				removeClass(container, scrolledClass);
			}
	
			this._containerWidth = this._container.offsetWidth;
		},
	
		_animateZoom: function (e) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
			    anchor = this._getAnchor();
			setPosition(this._container, pos.add(anchor));
		},
	
		_adjustPan: function () {
			if (!this.options.autoPan) { return; }
			if (this._map._panAnim) { this._map._panAnim.stop(); }
	
			var map = this._map,
			    marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0,
			    containerHeight = this._container.offsetHeight + marginBottom,
			    containerWidth = this._containerWidth,
			    layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
	
			layerPos._add(getPosition(this._container));
	
			var containerPos = map.layerPointToContainerPoint(layerPos),
			    padding = toPoint(this.options.autoPanPadding),
			    paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding),
			    paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding),
			    size = map.getSize(),
			    dx = 0,
			    dy = 0;
	
			if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
				dx = containerPos.x + containerWidth - size.x + paddingBR.x;
			}
			if (containerPos.x - dx - paddingTL.x < 0) { // left
				dx = containerPos.x - paddingTL.x;
			}
			if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
				dy = containerPos.y + containerHeight - size.y + paddingBR.y;
			}
			if (containerPos.y - dy - paddingTL.y < 0) { // top
				dy = containerPos.y - paddingTL.y;
			}
	
			// @namespace Map
			// @section Popup events
			// @event autopanstart: Event
			// Fired when the map starts autopanning when opening a popup.
			if (dx || dy) {
				map
				    .fire('autopanstart')
				    .panBy([dx, dy]);
			}
		},
	
		_onCloseButtonClick: function (e) {
			this._close();
			stop(e);
		},
	
		_getAnchor: function () {
			// Where should we anchor the popup on the source layer?
			return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
		}
	
	});
	
	// @namespace Popup
	// @factory L.popup(options?: Popup options, source?: Layer)
	// Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
	var popup = function (options, source) {
		return new Popup(options, source);
	};
	
	
	/* @namespace Map
	 * @section Interaction Options
	 * @option closePopupOnClick: Boolean = true
	 * Set it to `false` if you don't want popups to close when user clicks the map.
	 */
	Map.mergeOptions({
		closePopupOnClick: true
	});
	
	
	// @namespace Map
	// @section Methods for Layers and Controls
	Map.include({
		// @method openPopup(popup: Popup): this
		// Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
		// @alternative
		// @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
		// Creates a popup with the specified content and options and opens it in the given point on a map.
		openPopup: function (popup, latlng, options) {
			if (!(popup instanceof Popup)) {
				popup = new Popup(options).setContent(popup);
			}
	
			if (latlng) {
				popup.setLatLng(latlng);
			}
	
			if (this.hasLayer(popup)) {
				return this;
			}
	
			if (this._popup && this._popup.options.autoClose) {
				this.closePopup();
			}
	
			this._popup = popup;
			return this.addLayer(popup);
		},
	
		// @method closePopup(popup?: Popup): this
		// Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
		closePopup: function (popup) {
			if (!popup || popup === this._popup) {
				popup = this._popup;
				this._popup = null;
			}
			if (popup) {
				this.removeLayer(popup);
			}
			return this;
		}
	});
	
	/*
	 * @namespace Layer
	 * @section Popup methods example
	 *
	 * All layers share a set of methods convenient for binding popups to it.
	 *
	 * ```js
	 * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
	 * layer.openPopup();
	 * layer.closePopup();
	 * ```
	 *
	 * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
	 */
	
	// @section Popup methods
	Layer.include({
	
		// @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
		// Binds a popup to the layer with the passed `content` and sets up the
		// necessary event listeners. If a `Function` is passed it will receive
		// the layer as the first argument and should return a `String` or `HTMLElement`.
		bindPopup: function (content, options) {
	
			if (content instanceof Popup) {
				setOptions(content, options);
				this._popup = content;
				content._source = this;
			} else {
				if (!this._popup || options) {
					this._popup = new Popup(options, this);
				}
				this._popup.setContent(content);
			}
	
			if (!this._popupHandlersAdded) {
				this.on({
					click: this._openPopup,
					keypress: this._onKeyPress,
					remove: this.closePopup,
					move: this._movePopup
				});
				this._popupHandlersAdded = true;
			}
	
			return this;
		},
	
		// @method unbindPopup(): this
		// Removes the popup previously bound with `bindPopup`.
		unbindPopup: function () {
			if (this._popup) {
				this.off({
					click: this._openPopup,
					keypress: this._onKeyPress,
					remove: this.closePopup,
					move: this._movePopup
				});
				this._popupHandlersAdded = false;
				this._popup = null;
			}
			return this;
		},
	
		// @method openPopup(latlng?: LatLng): this
		// Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
		openPopup: function (layer, latlng) {
			if (this._popup && this._map) {
				latlng = this._popup._prepareOpen(this, layer, latlng);
	
				// open the popup on the map
				this._map.openPopup(this._popup, latlng);
			}
	
			return this;
		},
	
		// @method closePopup(): this
		// Closes the popup bound to this layer if it is open.
		closePopup: function () {
			if (this._popup) {
				this._popup._close();
			}
			return this;
		},
	
		// @method togglePopup(): this
		// Opens or closes the popup bound to this layer depending on its current state.
		togglePopup: function (target) {
			if (this._popup) {
				if (this._popup._map) {
					this.closePopup();
				} else {
					this.openPopup(target);
				}
			}
			return this;
		},
	
		// @method isPopupOpen(): boolean
		// Returns `true` if the popup bound to this layer is currently open.
		isPopupOpen: function () {
			return (this._popup ? this._popup.isOpen() : false);
		},
	
		// @method setPopupContent(content: String|HTMLElement|Popup): this
		// Sets the content of the popup bound to this layer.
		setPopupContent: function (content) {
			if (this._popup) {
				this._popup.setContent(content);
			}
			return this;
		},
	
		// @method getPopup(): Popup
		// Returns the popup bound to this layer.
		getPopup: function () {
			return this._popup;
		},
	
		_openPopup: function (e) {
			var layer = e.layer || e.target;
	
			if (!this._popup) {
				return;
			}
	
			if (!this._map) {
				return;
			}
	
			// prevent map click
			stop(e);
	
			// if this inherits from Path its a vector and we can just
			// open the popup at the new location
			if (layer instanceof Path) {
				this.openPopup(e.layer || e.target, e.latlng);
				return;
			}
	
			// otherwise treat it like a marker and figure out
			// if we should toggle it open/closed
			if (this._map.hasLayer(this._popup) && this._popup._source === layer) {
				this.closePopup();
			} else {
				this.openPopup(layer, e.latlng);
			}
		},
	
		_movePopup: function (e) {
			this._popup.setLatLng(e.latlng);
		},
	
		_onKeyPress: function (e) {
			if (e.originalEvent.keyCode === 13) {
				this._openPopup(e);
			}
		}
	});
	
	/*
	 * @class Tooltip
	 * @inherits DivOverlay
	 * @aka L.Tooltip
	 * Used to display small texts on top of map layers.
	 *
	 * @example
	 *
	 * ```js
	 * marker.bindTooltip("my tooltip text").openTooltip();
	 * ```
	 * Note about tooltip offset. Leaflet takes two options in consideration
	 * for computing tooltip offsetting:
	 * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
	 *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
	 *   move it to the bottom. Negatives will move to the left and top.
	 * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
	 *   should adapt this value if you use a custom icon.
	 */
	
	
	// @namespace Tooltip
	var Tooltip = DivOverlay.extend({
	
		// @section
		// @aka Tooltip options
		options: {
			// @option pane: String = 'tooltipPane'
			// `Map pane` where the tooltip will be added.
			pane: 'tooltipPane',
	
			// @option offset: Point = Point(0, 0)
			// Optional offset of the tooltip position.
			offset: [0, 0],
	
			// @option direction: String = 'auto'
			// Direction where to open the tooltip. Possible values are: `right`, `left`,
			// `top`, `bottom`, `center`, `auto`.
			// `auto` will dynamically switch between `right` and `left` according to the tooltip
			// position on the map.
			direction: 'auto',
	
			// @option permanent: Boolean = false
			// Whether to open the tooltip permanently or only on mouseover.
			permanent: false,
	
			// @option sticky: Boolean = false
			// If true, the tooltip will follow the mouse instead of being fixed at the feature center.
			sticky: false,
	
			// @option interactive: Boolean = false
			// If true, the tooltip will listen to the feature events.
			interactive: false,
	
			// @option opacity: Number = 0.9
			// Tooltip container opacity.
			opacity: 0.9
		},
	
		onAdd: function (map) {
			DivOverlay.prototype.onAdd.call(this, map);
			this.setOpacity(this.options.opacity);
	
			// @namespace Map
			// @section Tooltip events
			// @event tooltipopen: TooltipEvent
			// Fired when a tooltip is opened in the map.
			map.fire('tooltipopen', {tooltip: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Tooltip events
				// @event tooltipopen: TooltipEvent
				// Fired when a tooltip bound to this layer is opened.
				this._source.fire('tooltipopen', {tooltip: this}, true);
			}
		},
	
		onRemove: function (map) {
			DivOverlay.prototype.onRemove.call(this, map);
	
			// @namespace Map
			// @section Tooltip events
			// @event tooltipclose: TooltipEvent
			// Fired when a tooltip in the map is closed.
			map.fire('tooltipclose', {tooltip: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Tooltip events
				// @event tooltipclose: TooltipEvent
				// Fired when a tooltip bound to this layer is closed.
				this._source.fire('tooltipclose', {tooltip: this}, true);
			}
		},
	
		getEvents: function () {
			var events = DivOverlay.prototype.getEvents.call(this);
	
			if (touch && !this.options.permanent) {
				events.preclick = this._close;
			}
	
			return events;
		},
	
		_close: function () {
			if (this._map) {
				this._map.closeTooltip(this);
			}
		},
	
		_initLayout: function () {
			var prefix = 'leaflet-tooltip',
			    className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
			this._contentNode = this._container = create$1('div', className);
		},
	
		_updateLayout: function () {},
	
		_adjustPan: function () {},
	
		_setPosition: function (pos) {
			var map = this._map,
			    container = this._container,
			    centerPoint = map.latLngToContainerPoint(map.getCenter()),
			    tooltipPoint = map.layerPointToContainerPoint(pos),
			    direction = this.options.direction,
			    tooltipWidth = container.offsetWidth,
			    tooltipHeight = container.offsetHeight,
			    offset = toPoint(this.options.offset),
			    anchor = this._getAnchor();
	
			if (direction === 'top') {
				pos = pos.add(toPoint(-tooltipWidth / 2 + offset.x, -tooltipHeight + offset.y + anchor.y, true));
			} else if (direction === 'bottom') {
				pos = pos.subtract(toPoint(tooltipWidth / 2 - offset.x, -offset.y, true));
			} else if (direction === 'center') {
				pos = pos.subtract(toPoint(tooltipWidth / 2 + offset.x, tooltipHeight / 2 - anchor.y + offset.y, true));
			} else if (direction === 'right' || direction === 'auto' && tooltipPoint.x < centerPoint.x) {
				direction = 'right';
				pos = pos.add(toPoint(offset.x + anchor.x, anchor.y - tooltipHeight / 2 + offset.y, true));
			} else {
				direction = 'left';
				pos = pos.subtract(toPoint(tooltipWidth + anchor.x - offset.x, tooltipHeight / 2 - anchor.y - offset.y, true));
			}
	
			removeClass(container, 'leaflet-tooltip-right');
			removeClass(container, 'leaflet-tooltip-left');
			removeClass(container, 'leaflet-tooltip-top');
			removeClass(container, 'leaflet-tooltip-bottom');
			addClass(container, 'leaflet-tooltip-' + direction);
			setPosition(container, pos);
		},
	
		_updatePosition: function () {
			var pos = this._map.latLngToLayerPoint(this._latlng);
			this._setPosition(pos);
		},
	
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
	
			if (this._container) {
				setOpacity(this._container, opacity);
			}
		},
	
		_animateZoom: function (e) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
			this._setPosition(pos);
		},
	
		_getAnchor: function () {
			// Where should we anchor the tooltip on the source layer?
			return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
		}
	
	});
	
	// @namespace Tooltip
	// @factory L.tooltip(options?: Tooltip options, source?: Layer)
	// Instantiates a Tooltip object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
	var tooltip = function (options, source) {
		return new Tooltip(options, source);
	};
	
	// @namespace Map
	// @section Methods for Layers and Controls
	Map.include({
	
		// @method openTooltip(tooltip: Tooltip): this
		// Opens the specified tooltip.
		// @alternative
		// @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
		// Creates a tooltip with the specified content and options and open it.
		openTooltip: function (tooltip, latlng, options) {
			if (!(tooltip instanceof Tooltip)) {
				tooltip = new Tooltip(options).setContent(tooltip);
			}
	
			if (latlng) {
				tooltip.setLatLng(latlng);
			}
	
			if (this.hasLayer(tooltip)) {
				return this;
			}
	
			return this.addLayer(tooltip);
		},
	
		// @method closeTooltip(tooltip?: Tooltip): this
		// Closes the tooltip given as parameter.
		closeTooltip: function (tooltip) {
			if (tooltip) {
				this.removeLayer(tooltip);
			}
			return this;
		}
	
	});
	
	/*
	 * @namespace Layer
	 * @section Tooltip methods example
	 *
	 * All layers share a set of methods convenient for binding tooltips to it.
	 *
	 * ```js
	 * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
	 * layer.openTooltip();
	 * layer.closeTooltip();
	 * ```
	 */
	
	// @section Tooltip methods
	Layer.include({
	
		// @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
		// Binds a tooltip to the layer with the passed `content` and sets up the
		// necessary event listeners. If a `Function` is passed it will receive
		// the layer as the first argument and should return a `String` or `HTMLElement`.
		bindTooltip: function (content, options) {
	
			if (content instanceof Tooltip) {
				setOptions(content, options);
				this._tooltip = content;
				content._source = this;
			} else {
				if (!this._tooltip || options) {
					this._tooltip = new Tooltip(options, this);
				}
				this._tooltip.setContent(content);
	
			}
	
			this._initTooltipInteractions();
	
			if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
				this.openTooltip();
			}
	
			return this;
		},
	
		// @method unbindTooltip(): this
		// Removes the tooltip previously bound with `bindTooltip`.
		unbindTooltip: function () {
			if (this._tooltip) {
				this._initTooltipInteractions(true);
				this.closeTooltip();
				this._tooltip = null;
			}
			return this;
		},
	
		_initTooltipInteractions: function (remove$$1) {
			if (!remove$$1 && this._tooltipHandlersAdded) { return; }
			var onOff = remove$$1 ? 'off' : 'on',
			    events = {
				remove: this.closeTooltip,
				move: this._moveTooltip
			    };
			if (!this._tooltip.options.permanent) {
				events.mouseover = this._openTooltip;
				events.mouseout = this.closeTooltip;
				if (this._tooltip.options.sticky) {
					events.mousemove = this._moveTooltip;
				}
				if (touch) {
					events.click = this._openTooltip;
				}
			} else {
				events.add = this._openTooltip;
			}
			this[onOff](events);
			this._tooltipHandlersAdded = !remove$$1;
		},
	
		// @method openTooltip(latlng?: LatLng): this
		// Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
		openTooltip: function (layer, latlng) {
			if (this._tooltip && this._map) {
				latlng = this._tooltip._prepareOpen(this, layer, latlng);
	
				// open the tooltip on the map
				this._map.openTooltip(this._tooltip, latlng);
	
				// Tooltip container may not be defined if not permanent and never
				// opened.
				if (this._tooltip.options.interactive && this._tooltip._container) {
					addClass(this._tooltip._container, 'leaflet-clickable');
					this.addInteractiveTarget(this._tooltip._container);
				}
			}
	
			return this;
		},
	
		// @method closeTooltip(): this
		// Closes the tooltip bound to this layer if it is open.
		closeTooltip: function () {
			if (this._tooltip) {
				this._tooltip._close();
				if (this._tooltip.options.interactive && this._tooltip._container) {
					removeClass(this._tooltip._container, 'leaflet-clickable');
					this.removeInteractiveTarget(this._tooltip._container);
				}
			}
			return this;
		},
	
		// @method toggleTooltip(): this
		// Opens or closes the tooltip bound to this layer depending on its current state.
		toggleTooltip: function (target) {
			if (this._tooltip) {
				if (this._tooltip._map) {
					this.closeTooltip();
				} else {
					this.openTooltip(target);
				}
			}
			return this;
		},
	
		// @method isTooltipOpen(): boolean
		// Returns `true` if the tooltip bound to this layer is currently open.
		isTooltipOpen: function () {
			return this._tooltip.isOpen();
		},
	
		// @method setTooltipContent(content: String|HTMLElement|Tooltip): this
		// Sets the content of the tooltip bound to this layer.
		setTooltipContent: function (content) {
			if (this._tooltip) {
				this._tooltip.setContent(content);
			}
			return this;
		},
	
		// @method getTooltip(): Tooltip
		// Returns the tooltip bound to this layer.
		getTooltip: function () {
			return this._tooltip;
		},
	
		_openTooltip: function (e) {
			var layer = e.layer || e.target;
	
			if (!this._tooltip || !this._map) {
				return;
			}
			this.openTooltip(layer, this._tooltip.options.sticky ? e.latlng : undefined);
		},
	
		_moveTooltip: function (e) {
			var latlng = e.latlng, containerPoint, layerPoint;
			if (this._tooltip.options.sticky && e.originalEvent) {
				containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
				layerPoint = this._map.containerPointToLayerPoint(containerPoint);
				latlng = this._map.layerPointToLatLng(layerPoint);
			}
			this._tooltip.setLatLng(latlng);
		}
	});
	
	/*
	 * @class DivIcon
	 * @aka L.DivIcon
	 * @inherits Icon
	 *
	 * Represents a lightweight icon for markers that uses a simple `<div>`
	 * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
	 *
	 * @example
	 * ```js
	 * var myIcon = L.divIcon({className: 'my-div-icon'});
	 * // you can set .my-div-icon styles in CSS
	 *
	 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	 * ```
	 *
	 * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
	 */
	
	var DivIcon = Icon.extend({
		options: {
			// @section
			// @aka DivIcon options
			iconSize: [12, 12], // also can be set through CSS
	
			// iconAnchor: (Point),
			// popupAnchor: (Point),
	
			// @option html: String|HTMLElement = ''
			// Custom HTML code to put inside the div element, empty by default. Alternatively,
			// an instance of `HTMLElement`.
			html: false,
	
			// @option bgPos: Point = [0, 0]
			// Optional relative position of the background, in pixels
			bgPos: null,
	
			className: 'leaflet-div-icon'
		},
	
		createIcon: function (oldIcon) {
			var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
			    options = this.options;
	
			if (options.html instanceof Element) {
				empty(div);
				div.appendChild(options.html);
			} else {
				div.innerHTML = options.html !== false ? options.html : '';
			}
	
			if (options.bgPos) {
				var bgPos = toPoint(options.bgPos);
				div.style.backgroundPosition = (-bgPos.x) + 'px ' + (-bgPos.y) + 'px';
			}
			this._setIconStyles(div, 'icon');
	
			return div;
		},
	
		createShadow: function () {
			return null;
		}
	});
	
	// @factory L.divIcon(options: DivIcon options)
	// Creates a `DivIcon` instance with the given options.
	function divIcon(options) {
		return new DivIcon(options);
	}
	
	Icon.Default = IconDefault;
	
	/*
	 * @class GridLayer
	 * @inherits Layer
	 * @aka L.GridLayer
	 *
	 * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
	 * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
	 *
	 *
	 * @section Synchronous usage
	 * @example
	 *
	 * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
	 *
	 * ```js
	 * var CanvasLayer = L.GridLayer.extend({
	 *     createTile: function(coords){
	 *         // create a <canvas> element for drawing
	 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	 *
	 *         // setup tile width and height according to the options
	 *         var size = this.getTileSize();
	 *         tile.width = size.x;
	 *         tile.height = size.y;
	 *
	 *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
	 *         var ctx = tile.getContext('2d');
	 *
	 *         // return the tile so it can be rendered on screen
	 *         return tile;
	 *     }
	 * });
	 * ```
	 *
	 * @section Asynchronous usage
	 * @example
	 *
	 * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
	 *
	 * ```js
	 * var CanvasLayer = L.GridLayer.extend({
	 *     createTile: function(coords, done){
	 *         var error;
	 *
	 *         // create a <canvas> element for drawing
	 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	 *
	 *         // setup tile width and height according to the options
	 *         var size = this.getTileSize();
	 *         tile.width = size.x;
	 *         tile.height = size.y;
	 *
	 *         // draw something asynchronously and pass the tile to the done() callback
	 *         setTimeout(function() {
	 *             done(error, tile);
	 *         }, 1000);
	 *
	 *         return tile;
	 *     }
	 * });
	 * ```
	 *
	 * @section
	 */
	
	
	var GridLayer = Layer.extend({
	
		// @section
		// @aka GridLayer options
		options: {
			// @option tileSize: Number|Point = 256
			// Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
			tileSize: 256,
	
			// @option opacity: Number = 1.0
			// Opacity of the tiles. Can be used in the `createTile()` function.
			opacity: 1,
	
			// @option updateWhenIdle: Boolean = (depends)
			// Load new tiles only when panning ends.
			// `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
			// `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
			// [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
			updateWhenIdle: mobile,
	
			// @option updateWhenZooming: Boolean = true
			// By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
			updateWhenZooming: true,
	
			// @option updateInterval: Number = 200
			// Tiles will not update more than once every `updateInterval` milliseconds when panning.
			updateInterval: 200,
	
			// @option zIndex: Number = 1
			// The explicit zIndex of the tile layer.
			zIndex: 1,
	
			// @option bounds: LatLngBounds = undefined
			// If set, tiles will only be loaded inside the set `LatLngBounds`.
			bounds: null,
	
			// @option minZoom: Number = 0
			// The minimum zoom level down to which this layer will be displayed (inclusive).
			minZoom: 0,
	
			// @option maxZoom: Number = undefined
			// The maximum zoom level up to which this layer will be displayed (inclusive).
			maxZoom: undefined,
	
			// @option maxNativeZoom: Number = undefined
			// Maximum zoom number the tile source has available. If it is specified,
			// the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
			// from `maxNativeZoom` level and auto-scaled.
			maxNativeZoom: undefined,
	
			// @option minNativeZoom: Number = undefined
			// Minimum zoom number the tile source has available. If it is specified,
			// the tiles on all zoom levels lower than `minNativeZoom` will be loaded
			// from `minNativeZoom` level and auto-scaled.
			minNativeZoom: undefined,
	
			// @option noWrap: Boolean = false
			// Whether the layer is wrapped around the antimeridian. If `true`, the
			// GridLayer will only be displayed once at low zoom levels. Has no
			// effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
			// in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
			// tiles outside the CRS limits.
			noWrap: false,
	
			// @option pane: String = 'tilePane'
			// `Map pane` where the grid layer will be added.
			pane: 'tilePane',
	
			// @option className: String = ''
			// A custom class name to assign to the tile layer. Empty by default.
			className: '',
	
			// @option keepBuffer: Number = 2
			// When panning the map, keep this many rows and columns of tiles before unloading them.
			keepBuffer: 2
		},
	
		initialize: function (options) {
			setOptions(this, options);
		},
	
		onAdd: function () {
			this._initContainer();
	
			this._levels = {};
			this._tiles = {};
	
			this._resetView();
			this._update();
		},
	
		beforeAdd: function (map) {
			map._addZoomLimit(this);
		},
	
		onRemove: function (map) {
			this._removeAllTiles();
			remove(this._container);
			map._removeZoomLimit(this);
			this._container = null;
			this._tileZoom = undefined;
		},
	
		// @method bringToFront: this
		// Brings the tile layer to the top of all tile layers.
		bringToFront: function () {
			if (this._map) {
				toFront(this._container);
				this._setAutoZIndex(Math.max);
			}
			return this;
		},
	
		// @method bringToBack: this
		// Brings the tile layer to the bottom of all tile layers.
		bringToBack: function () {
			if (this._map) {
				toBack(this._container);
				this._setAutoZIndex(Math.min);
			}
			return this;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTML element that contains the tiles for this layer.
		getContainer: function () {
			return this._container;
		},
	
		// @method setOpacity(opacity: Number): this
		// Changes the [opacity](#gridlayer-opacity) of the grid layer.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			this._updateOpacity();
			return this;
		},
	
		// @method setZIndex(zIndex: Number): this
		// Changes the [zIndex](#gridlayer-zindex) of the grid layer.
		setZIndex: function (zIndex) {
			this.options.zIndex = zIndex;
			this._updateZIndex();
	
			return this;
		},
	
		// @method isLoading: Boolean
		// Returns `true` if any tile in the grid layer has not finished loading.
		isLoading: function () {
			return this._loading;
		},
	
		// @method redraw: this
		// Causes the layer to clear all the tiles and request them again.
		redraw: function () {
			if (this._map) {
				this._removeAllTiles();
				this._update();
			}
			return this;
		},
	
		getEvents: function () {
			var events = {
				viewprereset: this._invalidateAll,
				viewreset: this._resetView,
				zoom: this._resetView,
				moveend: this._onMoveEnd
			};
	
			if (!this.options.updateWhenIdle) {
				// update tiles on move, but not more often than once per given interval
				if (!this._onMove) {
					this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
				}
	
				events.move = this._onMove;
			}
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
	
			return events;
		},
	
		// @section Extension methods
		// Layers extending `GridLayer` shall reimplement the following method.
		// @method createTile(coords: Object, done?: Function): HTMLElement
		// Called only internally, must be overridden by classes extending `GridLayer`.
		// Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
		// is specified, it must be called when the tile has finished loading and drawing.
		createTile: function () {
			return document.createElement('div');
		},
	
		// @section
		// @method getTileSize: Point
		// Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
		getTileSize: function () {
			var s = this.options.tileSize;
			return s instanceof Point ? s : new Point(s, s);
		},
	
		_updateZIndex: function () {
			if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) {
				this._container.style.zIndex = this.options.zIndex;
			}
		},
	
		_setAutoZIndex: function (compare) {
			// go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
	
			var layers = this.getPane().children,
			    edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
	
			for (var i = 0, len = layers.length, zIndex; i < len; i++) {
	
				zIndex = layers[i].style.zIndex;
	
				if (layers[i] !== this._container && zIndex) {
					edgeZIndex = compare(edgeZIndex, +zIndex);
				}
			}
	
			if (isFinite(edgeZIndex)) {
				this.options.zIndex = edgeZIndex + compare(-1, 1);
				this._updateZIndex();
			}
		},
	
		_updateOpacity: function () {
			if (!this._map) { return; }
	
			// IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
			if (ielt9) { return; }
	
			setOpacity(this._container, this.options.opacity);
	
			var now = +new Date(),
			    nextFrame = false,
			    willPrune = false;
	
			for (var key in this._tiles) {
				var tile = this._tiles[key];
				if (!tile.current || !tile.loaded) { continue; }
	
				var fade = Math.min(1, (now - tile.loaded) / 200);
	
				setOpacity(tile.el, fade);
				if (fade < 1) {
					nextFrame = true;
				} else {
					if (tile.active) {
						willPrune = true;
					} else {
						this._onOpaqueTile(tile);
					}
					tile.active = true;
				}
			}
	
			if (willPrune && !this._noPrune) { this._pruneTiles(); }
	
			if (nextFrame) {
				cancelAnimFrame(this._fadeFrame);
				this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
			}
		},
	
		_onOpaqueTile: falseFn,
	
		_initContainer: function () {
			if (this._container) { return; }
	
			this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
			this._updateZIndex();
	
			if (this.options.opacity < 1) {
				this._updateOpacity();
			}
	
			this.getPane().appendChild(this._container);
		},
	
		_updateLevels: function () {
	
			var zoom = this._tileZoom,
			    maxZoom = this.options.maxZoom;
	
			if (zoom === undefined) { return undefined; }
	
			for (var z in this._levels) {
				if (this._levels[z].el.children.length || z === zoom) {
					this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
					this._onUpdateLevel(z);
				} else {
					remove(this._levels[z].el);
					this._removeTilesAtZoom(z);
					this._onRemoveLevel(z);
					delete this._levels[z];
				}
			}
	
			var level = this._levels[zoom],
			    map = this._map;
	
			if (!level) {
				level = this._levels[zoom] = {};
	
				level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
				level.el.style.zIndex = maxZoom;
	
				level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
				level.zoom = zoom;
	
				this._setZoomTransform(level, map.getCenter(), map.getZoom());
	
				// force the browser to consider the newly added element for transition
				falseFn(level.el.offsetWidth);
	
				this._onCreateLevel(level);
			}
	
			this._level = level;
	
			return level;
		},
	
		_onUpdateLevel: falseFn,
	
		_onRemoveLevel: falseFn,
	
		_onCreateLevel: falseFn,
	
		_pruneTiles: function () {
			if (!this._map) {
				return;
			}
	
			var key, tile;
	
			var zoom = this._map.getZoom();
			if (zoom > this.options.maxZoom ||
				zoom < this.options.minZoom) {
				this._removeAllTiles();
				return;
			}
	
			for (key in this._tiles) {
				tile = this._tiles[key];
				tile.retain = tile.current;
			}
	
			for (key in this._tiles) {
				tile = this._tiles[key];
				if (tile.current && !tile.active) {
					var coords = tile.coords;
					if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
						this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
					}
				}
			}
	
			for (key in this._tiles) {
				if (!this._tiles[key].retain) {
					this._removeTile(key);
				}
			}
		},
	
		_removeTilesAtZoom: function (zoom) {
			for (var key in this._tiles) {
				if (this._tiles[key].coords.z !== zoom) {
					continue;
				}
				this._removeTile(key);
			}
		},
	
		_removeAllTiles: function () {
			for (var key in this._tiles) {
				this._removeTile(key);
			}
		},
	
		_invalidateAll: function () {
			for (var z in this._levels) {
				remove(this._levels[z].el);
				this._onRemoveLevel(z);
				delete this._levels[z];
			}
			this._removeAllTiles();
	
			this._tileZoom = undefined;
		},
	
		_retainParent: function (x, y, z, minZoom) {
			var x2 = Math.floor(x / 2),
			    y2 = Math.floor(y / 2),
			    z2 = z - 1,
			    coords2 = new Point(+x2, +y2);
			coords2.z = +z2;
	
			var key = this._tileCoordsToKey(coords2),
			    tile = this._tiles[key];
	
			if (tile && tile.active) {
				tile.retain = true;
				return true;
	
			} else if (tile && tile.loaded) {
				tile.retain = true;
			}
	
			if (z2 > minZoom) {
				return this._retainParent(x2, y2, z2, minZoom);
			}
	
			return false;
		},
	
		_retainChildren: function (x, y, z, maxZoom) {
	
			for (var i = 2 * x; i < 2 * x + 2; i++) {
				for (var j = 2 * y; j < 2 * y + 2; j++) {
	
					var coords = new Point(i, j);
					coords.z = z + 1;
	
					var key = this._tileCoordsToKey(coords),
					    tile = this._tiles[key];
	
					if (tile && tile.active) {
						tile.retain = true;
						continue;
	
					} else if (tile && tile.loaded) {
						tile.retain = true;
					}
	
					if (z + 1 < maxZoom) {
						this._retainChildren(i, j, z + 1, maxZoom);
					}
				}
			}
		},
	
		_resetView: function (e) {
			var animating = e && (e.pinch || e.flyTo);
			this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
		},
	
		_animateZoom: function (e) {
			this._setView(e.center, e.zoom, true, e.noUpdate);
		},
	
		_clampZoom: function (zoom) {
			var options = this.options;
	
			if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) {
				return options.minNativeZoom;
			}
	
			if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) {
				return options.maxNativeZoom;
			}
	
			return zoom;
		},
	
		_setView: function (center, zoom, noPrune, noUpdate) {
			var tileZoom = this._clampZoom(Math.round(zoom));
			if ((this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom) ||
			    (this.options.minZoom !== undefined && tileZoom < this.options.minZoom)) {
				tileZoom = undefined;
			}
	
			var tileZoomChanged = this.options.updateWhenZooming && (tileZoom !== this._tileZoom);
	
			if (!noUpdate || tileZoomChanged) {
	
				this._tileZoom = tileZoom;
	
				if (this._abortLoading) {
					this._abortLoading();
				}
	
				this._updateLevels();
				this._resetGrid();
	
				if (tileZoom !== undefined) {
					this._update(center);
				}
	
				if (!noPrune) {
					this._pruneTiles();
				}
	
				// Flag to prevent _updateOpacity from pruning tiles during
				// a zoom anim or a pinch gesture
				this._noPrune = !!noPrune;
			}
	
			this._setZoomTransforms(center, zoom);
		},
	
		_setZoomTransforms: function (center, zoom) {
			for (var i in this._levels) {
				this._setZoomTransform(this._levels[i], center, zoom);
			}
		},
	
		_setZoomTransform: function (level, center, zoom) {
			var scale = this._map.getZoomScale(zoom, level.zoom),
			    translate = level.origin.multiplyBy(scale)
			        .subtract(this._map._getNewPixelOrigin(center, zoom)).round();
	
			if (any3d) {
				setTransform(level.el, translate, scale);
			} else {
				setPosition(level.el, translate);
			}
		},
	
		_resetGrid: function () {
			var map = this._map,
			    crs = map.options.crs,
			    tileSize = this._tileSize = this.getTileSize(),
			    tileZoom = this._tileZoom;
	
			var bounds = this._map.getPixelWorldBounds(this._tileZoom);
			if (bounds) {
				this._globalTileRange = this._pxBoundsToTileRange(bounds);
			}
	
			this._wrapX = crs.wrapLng && !this.options.noWrap && [
				Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
				Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
			];
			this._wrapY = crs.wrapLat && !this.options.noWrap && [
				Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
				Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
			];
		},
	
		_onMoveEnd: function () {
			if (!this._map || this._map._animatingZoom) { return; }
	
			this._update();
		},
	
		_getTiledPixelBounds: function (center) {
			var map = this._map,
			    mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(),
			    scale = map.getZoomScale(mapZoom, this._tileZoom),
			    pixelCenter = map.project(center, this._tileZoom).floor(),
			    halfSize = map.getSize().divideBy(scale * 2);
	
			return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
		},
	
		// Private method to load tiles in the grid's active zoom level according to map bounds
		_update: function (center) {
			var map = this._map;
			if (!map) { return; }
			var zoom = this._clampZoom(map.getZoom());
	
			if (center === undefined) { center = map.getCenter(); }
			if (this._tileZoom === undefined) { return; }	// if out of minzoom/maxzoom
	
			var pixelBounds = this._getTiledPixelBounds(center),
			    tileRange = this._pxBoundsToTileRange(pixelBounds),
			    tileCenter = tileRange.getCenter(),
			    queue = [],
			    margin = this.options.keepBuffer,
			    noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([margin, -margin]),
			                              tileRange.getTopRight().add([margin, -margin]));
	
			// Sanity check: panic if the tile range contains Infinity somewhere.
			if (!(isFinite(tileRange.min.x) &&
			      isFinite(tileRange.min.y) &&
			      isFinite(tileRange.max.x) &&
			      isFinite(tileRange.max.y))) { throw new Error('Attempted to load an infinite number of tiles'); }
	
			for (var key in this._tiles) {
				var c = this._tiles[key].coords;
				if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) {
					this._tiles[key].current = false;
				}
			}
	
			// _update just loads more tiles. If the tile zoom level differs too much
			// from the map's, let _setView reset levels and prune old tiles.
			if (Math.abs(zoom - this._tileZoom) > 1) { this._setView(center, zoom); return; }
	
			// create a queue of coordinates to load tiles from
			for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
				for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
					var coords = new Point(i, j);
					coords.z = this._tileZoom;
	
					if (!this._isValidTile(coords)) { continue; }
	
					var tile = this._tiles[this._tileCoordsToKey(coords)];
					if (tile) {
						tile.current = true;
					} else {
						queue.push(coords);
					}
				}
			}
	
			// sort tile queue to load tiles in order of their distance to center
			queue.sort(function (a, b) {
				return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
			});
	
			if (queue.length !== 0) {
				// if it's the first batch of tiles to load
				if (!this._loading) {
					this._loading = true;
					// @event loading: Event
					// Fired when the grid layer starts loading tiles.
					this.fire('loading');
				}
	
				// create DOM fragment to append tiles in one batch
				var fragment = document.createDocumentFragment();
	
				for (i = 0; i < queue.length; i++) {
					this._addTile(queue[i], fragment);
				}
	
				this._level.el.appendChild(fragment);
			}
		},
	
		_isValidTile: function (coords) {
			var crs = this._map.options.crs;
	
			if (!crs.infinite) {
				// don't load tile if it's out of bounds and not wrapped
				var bounds = this._globalTileRange;
				if ((!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x)) ||
				    (!crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y))) { return false; }
			}
	
			if (!this.options.bounds) { return true; }
	
			// don't load tile if it doesn't intersect the bounds in options
			var tileBounds = this._tileCoordsToBounds(coords);
			return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
		},
	
		_keyToBounds: function (key) {
			return this._tileCoordsToBounds(this._keyToTileCoords(key));
		},
	
		_tileCoordsToNwSe: function (coords) {
			var map = this._map,
			    tileSize = this.getTileSize(),
			    nwPoint = coords.scaleBy(tileSize),
			    sePoint = nwPoint.add(tileSize),
			    nw = map.unproject(nwPoint, coords.z),
			    se = map.unproject(sePoint, coords.z);
			return [nw, se];
		},
	
		// converts tile coordinates to its geographical bounds
		_tileCoordsToBounds: function (coords) {
			var bp = this._tileCoordsToNwSe(coords),
			    bounds = new LatLngBounds(bp[0], bp[1]);
	
			if (!this.options.noWrap) {
				bounds = this._map.wrapLatLngBounds(bounds);
			}
			return bounds;
		},
		// converts tile coordinates to key for the tile cache
		_tileCoordsToKey: function (coords) {
			return coords.x + ':' + coords.y + ':' + coords.z;
		},
	
		// converts tile cache key to coordinates
		_keyToTileCoords: function (key) {
			var k = key.split(':'),
			    coords = new Point(+k[0], +k[1]);
			coords.z = +k[2];
			return coords;
		},
	
		_removeTile: function (key) {
			var tile = this._tiles[key];
			if (!tile) { return; }
	
			remove(tile.el);
	
			delete this._tiles[key];
	
			// @event tileunload: TileEvent
			// Fired when a tile is removed (e.g. when a tile goes off the screen).
			this.fire('tileunload', {
				tile: tile.el,
				coords: this._keyToTileCoords(key)
			});
		},
	
		_initTile: function (tile) {
			addClass(tile, 'leaflet-tile');
	
			var tileSize = this.getTileSize();
			tile.style.width = tileSize.x + 'px';
			tile.style.height = tileSize.y + 'px';
	
			tile.onselectstart = falseFn;
			tile.onmousemove = falseFn;
	
			// update opacity on tiles in IE7-8 because of filter inheritance problems
			if (ielt9 && this.options.opacity < 1) {
				setOpacity(tile, this.options.opacity);
			}
	
			// without this hack, tiles disappear after zoom on Chrome for Android
			// https://github.com/Leaflet/Leaflet/issues/2078
			if (android && !android23) {
				tile.style.WebkitBackfaceVisibility = 'hidden';
			}
		},
	
		_addTile: function (coords, container) {
			var tilePos = this._getTilePos(coords),
			    key = this._tileCoordsToKey(coords);
	
			var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
	
			this._initTile(tile);
	
			// if createTile is defined with a second argument ("done" callback),
			// we know that tile is async and will be ready later; otherwise
			if (this.createTile.length < 2) {
				// mark tile as ready, but delay one frame for opacity animation to happen
				requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
			}
	
			setPosition(tile, tilePos);
	
			// save tile in cache
			this._tiles[key] = {
				el: tile,
				coords: coords,
				current: true
			};
	
			container.appendChild(tile);
			// @event tileloadstart: TileEvent
			// Fired when a tile is requested and starts loading.
			this.fire('tileloadstart', {
				tile: tile,
				coords: coords
			});
		},
	
		_tileReady: function (coords, err, tile) {
			if (err) {
				// @event tileerror: TileErrorEvent
				// Fired when there is an error loading a tile.
				this.fire('tileerror', {
					error: err,
					tile: tile,
					coords: coords
				});
			}
	
			var key = this._tileCoordsToKey(coords);
	
			tile = this._tiles[key];
			if (!tile) { return; }
	
			tile.loaded = +new Date();
			if (this._map._fadeAnimated) {
				setOpacity(tile.el, 0);
				cancelAnimFrame(this._fadeFrame);
				this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
			} else {
				tile.active = true;
				this._pruneTiles();
			}
	
			if (!err) {
				addClass(tile.el, 'leaflet-tile-loaded');
	
				// @event tileload: TileEvent
				// Fired when a tile loads.
				this.fire('tileload', {
					tile: tile.el,
					coords: coords
				});
			}
	
			if (this._noTilesToLoad()) {
				this._loading = false;
				// @event load: Event
				// Fired when the grid layer loaded all visible tiles.
				this.fire('load');
	
				if (ielt9 || !this._map._fadeAnimated) {
					requestAnimFrame(this._pruneTiles, this);
				} else {
					// Wait a bit more than 0.2 secs (the duration of the tile fade-in)
					// to trigger a pruning.
					setTimeout(bind(this._pruneTiles, this), 250);
				}
			}
		},
	
		_getTilePos: function (coords) {
			return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
		},
	
		_wrapCoords: function (coords) {
			var newCoords = new Point(
				this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x,
				this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
			newCoords.z = coords.z;
			return newCoords;
		},
	
		_pxBoundsToTileRange: function (bounds) {
			var tileSize = this.getTileSize();
			return new Bounds(
				bounds.min.unscaleBy(tileSize).floor(),
				bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1]));
		},
	
		_noTilesToLoad: function () {
			for (var key in this._tiles) {
				if (!this._tiles[key].loaded) { return false; }
			}
			return true;
		}
	});
	
	// @factory L.gridLayer(options?: GridLayer options)
	// Creates a new instance of GridLayer with the supplied options.
	function gridLayer(options) {
		return new GridLayer(options);
	}
	
	/*
	 * @class TileLayer
	 * @inherits GridLayer
	 * @aka L.TileLayer
	 * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'}).addTo(map);
	 * ```
	 *
	 * @section URL template
	 * @example
	 *
	 * A string of the following form:
	 *
	 * ```
	 * 'http://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
	 * ```
	 *
	 * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
	 *
	 * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
	 *
	 * ```
	 * L.tileLayer('http://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
	 * ```
	 */
	
	
	var TileLayer = GridLayer.extend({
	
		// @section
		// @aka TileLayer options
		options: {
			// @option minZoom: Number = 0
			// The minimum zoom level down to which this layer will be displayed (inclusive).
			minZoom: 0,
	
			// @option maxZoom: Number = 18
			// The maximum zoom level up to which this layer will be displayed (inclusive).
			maxZoom: 18,
	
			// @option subdomains: String|String[] = 'abc'
			// Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
			subdomains: 'abc',
	
			// @option errorTileUrl: String = ''
			// URL to the tile image to show in place of the tile that failed to load.
			errorTileUrl: '',
	
			// @option zoomOffset: Number = 0
			// The zoom number used in tile URLs will be offset with this value.
			zoomOffset: 0,
	
			// @option tms: Boolean = false
			// If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
			tms: false,
	
			// @option zoomReverse: Boolean = false
			// If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
			zoomReverse: false,
	
			// @option detectRetina: Boolean = false
			// If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
			detectRetina: false,
	
			// @option crossOrigin: Boolean|String = false
			// Whether the crossOrigin attribute will be added to the tiles.
			// If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
			// Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
			crossOrigin: false
		},
	
		initialize: function (url, options) {
	
			this._url = url;
	
			options = setOptions(this, options);
	
			// detecting retina displays, adjusting tileSize and zoom levels
			if (options.detectRetina && retina && options.maxZoom > 0) {
	
				options.tileSize = Math.floor(options.tileSize / 2);
	
				if (!options.zoomReverse) {
					options.zoomOffset++;
					options.maxZoom--;
				} else {
					options.zoomOffset--;
					options.minZoom++;
				}
	
				options.minZoom = Math.max(0, options.minZoom);
			}
	
			if (typeof options.subdomains === 'string') {
				options.subdomains = options.subdomains.split('');
			}
	
			// for https://github.com/Leaflet/Leaflet/issues/137
			if (!android) {
				this.on('tileunload', this._onTileRemove);
			}
		},
	
		// @method setUrl(url: String, noRedraw?: Boolean): this
		// Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
		// If the URL does not change, the layer will not be redrawn unless
		// the noRedraw parameter is set to false.
		setUrl: function (url, noRedraw) {
			if (this._url === url && noRedraw === undefined) {
				noRedraw = true;
			}
	
			this._url = url;
	
			if (!noRedraw) {
				this.redraw();
			}
			return this;
		},
	
		// @method createTile(coords: Object, done?: Function): HTMLElement
		// Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
		// to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
		// callback is called when the tile has been loaded.
		createTile: function (coords, done) {
			var tile = document.createElement('img');
	
			on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
			on(tile, 'error', bind(this._tileOnError, this, done, tile));
	
			if (this.options.crossOrigin || this.options.crossOrigin === '') {
				tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
			}
	
			/*
			 Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
			 http://www.w3.org/TR/WCAG20-TECHS/H67
			*/
			tile.alt = '';
	
			/*
			 Set role="presentation" to force screen readers to ignore this
			 https://www.w3.org/TR/wai-aria/roles#textalternativecomputation
			*/
			tile.setAttribute('role', 'presentation');
	
			tile.src = this.getTileUrl(coords);
	
			return tile;
		},
	
		// @section Extension methods
		// @uninheritable
		// Layers extending `TileLayer` might reimplement the following method.
		// @method getTileUrl(coords: Object): String
		// Called only internally, returns the URL for a tile given its coordinates.
		// Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
		getTileUrl: function (coords) {
			var data = {
				r: retina ? '@2x' : '',
				s: this._getSubdomain(coords),
				x: coords.x,
				y: coords.y,
				z: this._getZoomForUrl()
			};
			if (this._map && !this._map.options.crs.infinite) {
				var invertedY = this._globalTileRange.max.y - coords.y;
				if (this.options.tms) {
					data['y'] = invertedY;
				}
				data['-y'] = invertedY;
			}
	
			return template(this._url, extend(data, this.options));
		},
	
		_tileOnLoad: function (done, tile) {
			// For https://github.com/Leaflet/Leaflet/issues/3332
			if (ielt9) {
				setTimeout(bind(done, this, null, tile), 0);
			} else {
				done(null, tile);
			}
		},
	
		_tileOnError: function (done, tile, e) {
			var errorUrl = this.options.errorTileUrl;
			if (errorUrl && tile.getAttribute('src') !== errorUrl) {
				tile.src = errorUrl;
			}
			done(e, tile);
		},
	
		_onTileRemove: function (e) {
			e.tile.onload = null;
		},
	
		_getZoomForUrl: function () {
			var zoom = this._tileZoom,
			maxZoom = this.options.maxZoom,
			zoomReverse = this.options.zoomReverse,
			zoomOffset = this.options.zoomOffset;
	
			if (zoomReverse) {
				zoom = maxZoom - zoom;
			}
	
			return zoom + zoomOffset;
		},
	
		_getSubdomain: function (tilePoint) {
			var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
			return this.options.subdomains[index];
		},
	
		// stops loading all tiles in the background layer
		_abortLoading: function () {
			var i, tile;
			for (i in this._tiles) {
				if (this._tiles[i].coords.z !== this._tileZoom) {
					tile = this._tiles[i].el;
	
					tile.onload = falseFn;
					tile.onerror = falseFn;
	
					if (!tile.complete) {
						tile.src = emptyImageUrl;
						remove(tile);
						delete this._tiles[i];
					}
				}
			}
		},
	
		_removeTile: function (key) {
			var tile = this._tiles[key];
			if (!tile) { return; }
	
			// Cancels any pending http requests associated with the tile
			// unless we're on Android's stock browser,
			// see https://github.com/Leaflet/Leaflet/issues/137
			if (!androidStock) {
				tile.el.setAttribute('src', emptyImageUrl);
			}
	
			return GridLayer.prototype._removeTile.call(this, key);
		},
	
		_tileReady: function (coords, err, tile) {
			if (!this._map || (tile && tile.getAttribute('src') === emptyImageUrl)) {
				return;
			}
	
			return GridLayer.prototype._tileReady.call(this, coords, err, tile);
		}
	});
	
	
	// @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
	// Instantiates a tile layer object given a `URL template` and optionally an options object.
	
	function tileLayer(url, options) {
		return new TileLayer(url, options);
	}
	
	/*
	 * @class TileLayer.WMS
	 * @inherits TileLayer
	 * @aka L.TileLayer.WMS
	 * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
	 *
	 * @example
	 *
	 * ```js
	 * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
	 * 	layers: 'nexrad-n0r-900913',
	 * 	format: 'image/png',
	 * 	transparent: true,
	 * 	attribution: "Weather data © 2012 IEM Nexrad"
	 * });
	 * ```
	 */
	
	var TileLayerWMS = TileLayer.extend({
	
		// @section
		// @aka TileLayer.WMS options
		// If any custom options not documented here are used, they will be sent to the
		// WMS server as extra parameters in each request URL. This can be useful for
		// [non-standard vendor WMS parameters](http://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
		defaultWmsParams: {
			service: 'WMS',
			request: 'GetMap',
	
			// @option layers: String = ''
			// **(required)** Comma-separated list of WMS layers to show.
			layers: '',
	
			// @option styles: String = ''
			// Comma-separated list of WMS styles.
			styles: '',
	
			// @option format: String = 'image/jpeg'
			// WMS image format (use `'image/png'` for layers with transparency).
			format: 'image/jpeg',
	
			// @option transparent: Boolean = false
			// If `true`, the WMS service will return images with transparency.
			transparent: false,
	
			// @option version: String = '1.1.1'
			// Version of the WMS service to use
			version: '1.1.1'
		},
	
		options: {
			// @option crs: CRS = null
			// Coordinate Reference System to use for the WMS requests, defaults to
			// map CRS. Don't change this if you're not sure what it means.
			crs: null,
	
			// @option uppercase: Boolean = false
			// If `true`, WMS request parameter keys will be uppercase.
			uppercase: false
		},
	
		initialize: function (url, options) {
	
			this._url = url;
	
			var wmsParams = extend({}, this.defaultWmsParams);
	
			// all keys that are not TileLayer options go to WMS params
			for (var i in options) {
				if (!(i in this.options)) {
					wmsParams[i] = options[i];
				}
			}
	
			options = setOptions(this, options);
	
			var realRetina = options.detectRetina && retina ? 2 : 1;
			var tileSize = this.getTileSize();
			wmsParams.width = tileSize.x * realRetina;
			wmsParams.height = tileSize.y * realRetina;
	
			this.wmsParams = wmsParams;
		},
	
		onAdd: function (map) {
	
			this._crs = this.options.crs || map.options.crs;
			this._wmsVersion = parseFloat(this.wmsParams.version);
	
			var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
			this.wmsParams[projectionKey] = this._crs.code;
	
			TileLayer.prototype.onAdd.call(this, map);
		},
	
		getTileUrl: function (coords) {
	
			var tileBounds = this._tileCoordsToNwSe(coords),
			    crs = this._crs,
			    bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])),
			    min = bounds.min,
			    max = bounds.max,
			    bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ?
			    [min.y, min.x, max.y, max.x] :
			    [min.x, min.y, max.x, max.y]).join(','),
			    url = TileLayer.prototype.getTileUrl.call(this, coords);
			return url +
				getParamString(this.wmsParams, url, this.options.uppercase) +
				(this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
		},
	
		// @method setParams(params: Object, noRedraw?: Boolean): this
		// Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
		setParams: function (params, noRedraw) {
	
			extend(this.wmsParams, params);
	
			if (!noRedraw) {
				this.redraw();
			}
	
			return this;
		}
	});
	
	
	// @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
	// Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
	function tileLayerWMS(url, options) {
		return new TileLayerWMS(url, options);
	}
	
	TileLayer.WMS = TileLayerWMS;
	tileLayer.wms = tileLayerWMS;
	
	/*
	 * @class Renderer
	 * @inherits Layer
	 * @aka L.Renderer
	 *
	 * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
	 * DOM container of the renderer, its bounds, and its zoom animation.
	 *
	 * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
	 * itself can be added or removed to the map. All paths use a renderer, which can
	 * be implicit (the map will decide the type of renderer and use it automatically)
	 * or explicit (using the [`renderer`](#path-renderer) option of the path).
	 *
	 * Do not use this class directly, use `SVG` and `Canvas` instead.
	 *
	 * @event update: Event
	 * Fired when the renderer updates its bounds, center and zoom, for example when
	 * its map has moved
	 */
	
	var Renderer = Layer.extend({
	
		// @section
		// @aka Renderer options
		options: {
			// @option padding: Number = 0.1
			// How much to extend the clip area around the map view (relative to its size)
			// e.g. 0.1 would be 10% of map view in each direction
			padding: 0.1,
	
			// @option tolerance: Number = 0
			// How much to extend click tolerance round a path/object on the map
			tolerance : 0
		},
	
		initialize: function (options) {
			setOptions(this, options);
			stamp(this);
			this._layers = this._layers || {};
		},
	
		onAdd: function () {
			if (!this._container) {
				this._initContainer(); // defined by renderer implementations
	
				if (this._zoomAnimated) {
					addClass(this._container, 'leaflet-zoom-animated');
				}
			}
	
			this.getPane().appendChild(this._container);
			this._update();
			this.on('update', this._updatePaths, this);
		},
	
		onRemove: function () {
			this.off('update', this._updatePaths, this);
			this._destroyContainer();
		},
	
		getEvents: function () {
			var events = {
				viewreset: this._reset,
				zoom: this._onZoom,
				moveend: this._update,
				zoomend: this._onZoomEnd
			};
			if (this._zoomAnimated) {
				events.zoomanim = this._onAnimZoom;
			}
			return events;
		},
	
		_onAnimZoom: function (ev) {
			this._updateTransform(ev.center, ev.zoom);
		},
	
		_onZoom: function () {
			this._updateTransform(this._map.getCenter(), this._map.getZoom());
		},
	
		_updateTransform: function (center, zoom) {
			var scale = this._map.getZoomScale(zoom, this._zoom),
			    position = getPosition(this._container),
			    viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding),
			    currentCenterPoint = this._map.project(this._center, zoom),
			    destCenterPoint = this._map.project(center, zoom),
			    centerOffset = destCenterPoint.subtract(currentCenterPoint),
	
			    topLeftOffset = viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);
	
			if (any3d) {
				setTransform(this._container, topLeftOffset, scale);
			} else {
				setPosition(this._container, topLeftOffset);
			}
		},
	
		_reset: function () {
			this._update();
			this._updateTransform(this._center, this._zoom);
	
			for (var id in this._layers) {
				this._layers[id]._reset();
			}
		},
	
		_onZoomEnd: function () {
			for (var id in this._layers) {
				this._layers[id]._project();
			}
		},
	
		_updatePaths: function () {
			for (var id in this._layers) {
				this._layers[id]._update();
			}
		},
	
		_update: function () {
			// Update pixel bounds of renderer container (for positioning/sizing/clipping later)
			// Subclasses are responsible of firing the 'update' event.
			var p = this.options.padding,
			    size = this._map.getSize(),
			    min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
	
			this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
	
			this._center = this._map.getCenter();
			this._zoom = this._map.getZoom();
		}
	});
	
	/*
	 * @class Canvas
	 * @inherits Renderer
	 * @aka L.Canvas
	 *
	 * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	 * Inherits `Renderer`.
	 *
	 * Due to [technical limitations](http://caniuse.com/#search=canvas), Canvas is not
	 * available in all web browsers, notably IE8, and overlapping geometries might
	 * not display properly in some edge cases.
	 *
	 * @example
	 *
	 * Use Canvas by default for all paths in the map:
	 *
	 * ```js
	 * var map = L.map('map', {
	 * 	renderer: L.canvas()
	 * });
	 * ```
	 *
	 * Use a Canvas renderer with extra padding for specific vector geometries:
	 *
	 * ```js
	 * var map = L.map('map');
	 * var myRenderer = L.canvas({ padding: 0.5 });
	 * var line = L.polyline( coordinates, { renderer: myRenderer } );
	 * var circle = L.circle( center, { renderer: myRenderer } );
	 * ```
	 */
	
	var Canvas = Renderer.extend({
		getEvents: function () {
			var events = Renderer.prototype.getEvents.call(this);
			events.viewprereset = this._onViewPreReset;
			return events;
		},
	
		_onViewPreReset: function () {
			// Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
			this._postponeUpdatePaths = true;
		},
	
		onAdd: function () {
			Renderer.prototype.onAdd.call(this);
	
			// Redraw vectors since canvas is cleared upon removal,
			// in case of removing the renderer itself from the map.
			this._draw();
		},
	
		_initContainer: function () {
			var container = this._container = document.createElement('canvas');
	
			on(container, 'mousemove', throttle(this._onMouseMove, 32, this), this);
			on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
			on(container, 'mouseout', this._handleMouseOut, this);
	
			this._ctx = container.getContext('2d');
		},
	
		_destroyContainer: function () {
			cancelAnimFrame(this._redrawRequest);
			delete this._ctx;
			remove(this._container);
			off(this._container);
			delete this._container;
		},
	
		_updatePaths: function () {
			if (this._postponeUpdatePaths) { return; }
	
			var layer;
			this._redrawBounds = null;
			for (var id in this._layers) {
				layer = this._layers[id];
				layer._update();
			}
			this._redraw();
		},
	
		_update: function () {
			if (this._map._animatingZoom && this._bounds) { return; }
	
			Renderer.prototype._update.call(this);
	
			var b = this._bounds,
			    container = this._container,
			    size = b.getSize(),
			    m = retina ? 2 : 1;
	
			setPosition(container, b.min);
	
			// set canvas size (also clearing it); use double size on retina
			container.width = m * size.x;
			container.height = m * size.y;
			container.style.width = size.x + 'px';
			container.style.height = size.y + 'px';
	
			if (retina) {
				this._ctx.scale(2, 2);
			}
	
			// translate so we use the same path coordinates after canvas element moves
			this._ctx.translate(-b.min.x, -b.min.y);
	
			// Tell paths to redraw themselves
			this.fire('update');
		},
	
		_reset: function () {
			Renderer.prototype._reset.call(this);
	
			if (this._postponeUpdatePaths) {
				this._postponeUpdatePaths = false;
				this._updatePaths();
			}
		},
	
		_initPath: function (layer) {
			this._updateDashArray(layer);
			this._layers[stamp(layer)] = layer;
	
			var order = layer._order = {
				layer: layer,
				prev: this._drawLast,
				next: null
			};
			if (this._drawLast) { this._drawLast.next = order; }
			this._drawLast = order;
			this._drawFirst = this._drawFirst || this._drawLast;
		},
	
		_addPath: function (layer) {
			this._requestRedraw(layer);
		},
	
		_removePath: function (layer) {
			var order = layer._order;
			var next = order.next;
			var prev = order.prev;
	
			if (next) {
				next.prev = prev;
			} else {
				this._drawLast = prev;
			}
			if (prev) {
				prev.next = next;
			} else {
				this._drawFirst = next;
			}
	
			delete layer._order;
	
			delete this._layers[stamp(layer)];
	
			this._requestRedraw(layer);
		},
	
		_updatePath: function (layer) {
			// Redraw the union of the layer's old pixel
			// bounds and the new pixel bounds.
			this._extendRedrawBounds(layer);
			layer._project();
			layer._update();
			// The redraw will extend the redraw bounds
			// with the new pixel bounds.
			this._requestRedraw(layer);
		},
	
		_updateStyle: function (layer) {
			this._updateDashArray(layer);
			this._requestRedraw(layer);
		},
	
		_updateDashArray: function (layer) {
			if (typeof layer.options.dashArray === 'string') {
				var parts = layer.options.dashArray.split(/[, ]+/),
				    dashArray = [],
				    dashValue,
				    i;
				for (i = 0; i < parts.length; i++) {
					dashValue = Number(parts[i]);
					// Ignore dash array containing invalid lengths
					if (isNaN(dashValue)) { return; }
					dashArray.push(dashValue);
				}
				layer.options._dashArray = dashArray;
			} else {
				layer.options._dashArray = layer.options.dashArray;
			}
		},
	
		_requestRedraw: function (layer) {
			if (!this._map) { return; }
	
			this._extendRedrawBounds(layer);
			this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
		},
	
		_extendRedrawBounds: function (layer) {
			if (layer._pxBounds) {
				var padding = (layer.options.weight || 0) + 1;
				this._redrawBounds = this._redrawBounds || new Bounds();
				this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
				this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
			}
		},
	
		_redraw: function () {
			this._redrawRequest = null;
	
			if (this._redrawBounds) {
				this._redrawBounds.min._floor();
				this._redrawBounds.max._ceil();
			}
	
			this._clear(); // clear layers in redraw bounds
			this._draw(); // draw layers
	
			this._redrawBounds = null;
		},
	
		_clear: function () {
			var bounds = this._redrawBounds;
			if (bounds) {
				var size = bounds.getSize();
				this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
			} else {
				this._ctx.clearRect(0, 0, this._container.width, this._container.height);
			}
		},
	
		_draw: function () {
			var layer, bounds = this._redrawBounds;
			this._ctx.save();
			if (bounds) {
				var size = bounds.getSize();
				this._ctx.beginPath();
				this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
				this._ctx.clip();
			}
	
			this._drawing = true;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (!bounds || (layer._pxBounds && layer._pxBounds.intersects(bounds))) {
					layer._updatePath();
				}
			}
	
			this._drawing = false;
	
			this._ctx.restore();  // Restore state before clipping.
		},
	
		_updatePoly: function (layer, closed) {
			if (!this._drawing) { return; }
	
			var i, j, len2, p,
			    parts = layer._parts,
			    len = parts.length,
			    ctx = this._ctx;
	
			if (!len) { return; }
	
			ctx.beginPath();
	
			for (i = 0; i < len; i++) {
				for (j = 0, len2 = parts[i].length; j < len2; j++) {
					p = parts[i][j];
					ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
				}
				if (closed) {
					ctx.closePath();
				}
			}
	
			this._fillStroke(ctx, layer);
	
			// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
		},
	
		_updateCircle: function (layer) {
	
			if (!this._drawing || layer._empty()) { return; }
	
			var p = layer._point,
			    ctx = this._ctx,
			    r = Math.max(Math.round(layer._radius), 1),
			    s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
	
			if (s !== 1) {
				ctx.save();
				ctx.scale(1, s);
			}
	
			ctx.beginPath();
			ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
	
			if (s !== 1) {
				ctx.restore();
			}
	
			this._fillStroke(ctx, layer);
		},
	
		_fillStroke: function (ctx, layer) {
			var options = layer.options;
	
			if (options.fill) {
				ctx.globalAlpha = options.fillOpacity;
				ctx.fillStyle = options.fillColor || options.color;
				ctx.fill(options.fillRule || 'evenodd');
			}
	
			if (options.stroke && options.weight !== 0) {
				if (ctx.setLineDash) {
					ctx.setLineDash(layer.options && layer.options._dashArray || []);
				}
				ctx.globalAlpha = options.opacity;
				ctx.lineWidth = options.weight;
				ctx.strokeStyle = options.color;
				ctx.lineCap = options.lineCap;
				ctx.lineJoin = options.lineJoin;
				ctx.stroke();
			}
		},
	
		// Canvas obviously doesn't have mouse events for individual drawn objects,
		// so we emulate that by calculating what's under the mouse on mousemove/click manually
	
		_onClick: function (e) {
			var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (layer.options.interactive && layer._containsPoint(point) && !this._map._draggableMoved(layer)) {
					clickedLayer = layer;
				}
			}
			if (clickedLayer)  {
				fakeStop(e);
				this._fireEvent([clickedLayer], e);
			}
		},
	
		_onMouseMove: function (e) {
			if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) { return; }
	
			var point = this._map.mouseEventToLayerPoint(e);
			this._handleMouseHover(e, point);
		},
	
	
		_handleMouseOut: function (e) {
			var layer = this._hoveredLayer;
			if (layer) {
				// if we're leaving the layer, fire mouseout
				removeClass(this._container, 'leaflet-interactive');
				this._fireEvent([layer], e, 'mouseout');
				this._hoveredLayer = null;
			}
		},
	
		_handleMouseHover: function (e, point) {
			var layer, candidateHoveredLayer;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (layer.options.interactive && layer._containsPoint(point)) {
					candidateHoveredLayer = layer;
				}
			}
	
			if (candidateHoveredLayer !== this._hoveredLayer) {
				this._handleMouseOut(e);
	
				if (candidateHoveredLayer) {
					addClass(this._container, 'leaflet-interactive'); // change cursor
					this._fireEvent([candidateHoveredLayer], e, 'mouseover');
					this._hoveredLayer = candidateHoveredLayer;
				}
			}
	
			if (this._hoveredLayer) {
				this._fireEvent([this._hoveredLayer], e);
			}
		},
	
		_fireEvent: function (layers, e, type) {
			this._map._fireDOMEvent(e, type || e.type, layers);
		},
	
		_bringToFront: function (layer) {
			var order = layer._order;
	
			if (!order) { return; }
	
			var next = order.next;
			var prev = order.prev;
	
			if (next) {
				next.prev = prev;
			} else {
				// Already last
				return;
			}
			if (prev) {
				prev.next = next;
			} else if (next) {
				// Update first entry unless this is the
				// single entry
				this._drawFirst = next;
			}
	
			order.prev = this._drawLast;
			this._drawLast.next = order;
	
			order.next = null;
			this._drawLast = order;
	
			this._requestRedraw(layer);
		},
	
		_bringToBack: function (layer) {
			var order = layer._order;
	
			if (!order) { return; }
	
			var next = order.next;
			var prev = order.prev;
	
			if (prev) {
				prev.next = next;
			} else {
				// Already first
				return;
			}
			if (next) {
				next.prev = prev;
			} else if (prev) {
				// Update last entry unless this is the
				// single entry
				this._drawLast = prev;
			}
	
			order.prev = null;
	
			order.next = this._drawFirst;
			this._drawFirst.prev = order;
			this._drawFirst = order;
	
			this._requestRedraw(layer);
		}
	});
	
	// @factory L.canvas(options?: Renderer options)
	// Creates a Canvas renderer with the given options.
	function canvas$1(options) {
		return canvas ? new Canvas(options) : null;
	}
	
	/*
	 * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
	 */
	
	
	var vmlCreate = (function () {
		try {
			document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
			return function (name) {
				return document.createElement('<lvml:' + name + ' class="lvml">');
			};
		} catch (e) {
			return function (name) {
				return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
			};
		}
	})();
	
	
	/*
	 * @class SVG
	 *
	 *
	 * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
	 * with old versions of Internet Explorer.
	 */
	
	// mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
	var vmlMixin = {
	
		_initContainer: function () {
			this._container = create$1('div', 'leaflet-vml-container');
		},
	
		_update: function () {
			if (this._map._animatingZoom) { return; }
			Renderer.prototype._update.call(this);
			this.fire('update');
		},
	
		_initPath: function (layer) {
			var container = layer._container = vmlCreate('shape');
	
			addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
	
			container.coordsize = '1 1';
	
			layer._path = vmlCreate('path');
			container.appendChild(layer._path);
	
			this._updateStyle(layer);
			this._layers[stamp(layer)] = layer;
		},
	
		_addPath: function (layer) {
			var container = layer._container;
			this._container.appendChild(container);
	
			if (layer.options.interactive) {
				layer.addInteractiveTarget(container);
			}
		},
	
		_removePath: function (layer) {
			var container = layer._container;
			remove(container);
			layer.removeInteractiveTarget(container);
			delete this._layers[stamp(layer)];
		},
	
		_updateStyle: function (layer) {
			var stroke = layer._stroke,
			    fill = layer._fill,
			    options = layer.options,
			    container = layer._container;
	
			container.stroked = !!options.stroke;
			container.filled = !!options.fill;
	
			if (options.stroke) {
				if (!stroke) {
					stroke = layer._stroke = vmlCreate('stroke');
				}
				container.appendChild(stroke);
				stroke.weight = options.weight + 'px';
				stroke.color = options.color;
				stroke.opacity = options.opacity;
	
				if (options.dashArray) {
					stroke.dashStyle = isArray(options.dashArray) ?
					    options.dashArray.join(' ') :
					    options.dashArray.replace(/( *, *)/g, ' ');
				} else {
					stroke.dashStyle = '';
				}
				stroke.endcap = options.lineCap.replace('butt', 'flat');
				stroke.joinstyle = options.lineJoin;
	
			} else if (stroke) {
				container.removeChild(stroke);
				layer._stroke = null;
			}
	
			if (options.fill) {
				if (!fill) {
					fill = layer._fill = vmlCreate('fill');
				}
				container.appendChild(fill);
				fill.color = options.fillColor || options.color;
				fill.opacity = options.fillOpacity;
	
			} else if (fill) {
				container.removeChild(fill);
				layer._fill = null;
			}
		},
	
		_updateCircle: function (layer) {
			var p = layer._point.round(),
			    r = Math.round(layer._radius),
			    r2 = Math.round(layer._radiusY || r);
	
			this._setPath(layer, layer._empty() ? 'M0 0' :
				'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + (65535 * 360));
		},
	
		_setPath: function (layer, path) {
			layer._path.v = path;
		},
	
		_bringToFront: function (layer) {
			toFront(layer._container);
		},
	
		_bringToBack: function (layer) {
			toBack(layer._container);
		}
	};
	
	var create$2 = vml ? vmlCreate : svgCreate;
	
	/*
	 * @class SVG
	 * @inherits Renderer
	 * @aka L.SVG
	 *
	 * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
	 * Inherits `Renderer`.
	 *
	 * Due to [technical limitations](http://caniuse.com/#search=svg), SVG is not
	 * available in all web browsers, notably Android 2.x and 3.x.
	 *
	 * Although SVG is not available on IE7 and IE8, these browsers support
	 * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
	 * (a now deprecated technology), and the SVG renderer will fall back to VML in
	 * this case.
	 *
	 * @example
	 *
	 * Use SVG by default for all paths in the map:
	 *
	 * ```js
	 * var map = L.map('map', {
	 * 	renderer: L.svg()
	 * });
	 * ```
	 *
	 * Use a SVG renderer with extra padding for specific vector geometries:
	 *
	 * ```js
	 * var map = L.map('map');
	 * var myRenderer = L.svg({ padding: 0.5 });
	 * var line = L.polyline( coordinates, { renderer: myRenderer } );
	 * var circle = L.circle( center, { renderer: myRenderer } );
	 * ```
	 */
	
	var SVG = Renderer.extend({
	
		getEvents: function () {
			var events = Renderer.prototype.getEvents.call(this);
			events.zoomstart = this._onZoomStart;
			return events;
		},
	
		_initContainer: function () {
			this._container = create$2('svg');
	
			// makes it possible to click through svg root; we'll reset it back in individual paths
			this._container.setAttribute('pointer-events', 'none');
	
			this._rootGroup = create$2('g');
			this._container.appendChild(this._rootGroup);
		},
	
		_destroyContainer: function () {
			remove(this._container);
			off(this._container);
			delete this._container;
			delete this._rootGroup;
			delete this._svgSize;
		},
	
		_onZoomStart: function () {
			// Drag-then-pinch interactions might mess up the center and zoom.
			// In this case, the easiest way to prevent this is re-do the renderer
			//   bounds and padding when the zooming starts.
			this._update();
		},
	
		_update: function () {
			if (this._map._animatingZoom && this._bounds) { return; }
	
			Renderer.prototype._update.call(this);
	
			var b = this._bounds,
			    size = b.getSize(),
			    container = this._container;
	
			// set size of svg-container if changed
			if (!this._svgSize || !this._svgSize.equals(size)) {
				this._svgSize = size;
				container.setAttribute('width', size.x);
				container.setAttribute('height', size.y);
			}
	
			// movement: update container viewBox so that we don't have to change coordinates of individual layers
			setPosition(container, b.min);
			container.setAttribute('viewBox', [b.min.x, b.min.y, size.x, size.y].join(' '));
	
			this.fire('update');
		},
	
		// methods below are called by vector layers implementations
	
		_initPath: function (layer) {
			var path = layer._path = create$2('path');
	
			// @namespace Path
			// @option className: String = null
			// Custom class name set on an element. Only for SVG renderer.
			if (layer.options.className) {
				addClass(path, layer.options.className);
			}
	
			if (layer.options.interactive) {
				addClass(path, 'leaflet-interactive');
			}
	
			this._updateStyle(layer);
			this._layers[stamp(layer)] = layer;
		},
	
		_addPath: function (layer) {
			if (!this._rootGroup) { this._initContainer(); }
			this._rootGroup.appendChild(layer._path);
			layer.addInteractiveTarget(layer._path);
		},
	
		_removePath: function (layer) {
			remove(layer._path);
			layer.removeInteractiveTarget(layer._path);
			delete this._layers[stamp(layer)];
		},
	
		_updatePath: function (layer) {
			layer._project();
			layer._update();
		},
	
		_updateStyle: function (layer) {
			var path = layer._path,
			    options = layer.options;
	
			if (!path) { return; }
	
			if (options.stroke) {
				path.setAttribute('stroke', options.color);
				path.setAttribute('stroke-opacity', options.opacity);
				path.setAttribute('stroke-width', options.weight);
				path.setAttribute('stroke-linecap', options.lineCap);
				path.setAttribute('stroke-linejoin', options.lineJoin);
	
				if (options.dashArray) {
					path.setAttribute('stroke-dasharray', options.dashArray);
				} else {
					path.removeAttribute('stroke-dasharray');
				}
	
				if (options.dashOffset) {
					path.setAttribute('stroke-dashoffset', options.dashOffset);
				} else {
					path.removeAttribute('stroke-dashoffset');
				}
			} else {
				path.setAttribute('stroke', 'none');
			}
	
			if (options.fill) {
				path.setAttribute('fill', options.fillColor || options.color);
				path.setAttribute('fill-opacity', options.fillOpacity);
				path.setAttribute('fill-rule', options.fillRule || 'evenodd');
			} else {
				path.setAttribute('fill', 'none');
			}
		},
	
		_updatePoly: function (layer, closed) {
			this._setPath(layer, pointsToPath(layer._parts, closed));
		},
	
		_updateCircle: function (layer) {
			var p = layer._point,
			    r = Math.max(Math.round(layer._radius), 1),
			    r2 = Math.max(Math.round(layer._radiusY), 1) || r,
			    arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
	
			// drawing a circle with two half-arcs
			var d = layer._empty() ? 'M0 0' :
				'M' + (p.x - r) + ',' + p.y +
				arc + (r * 2) + ',0 ' +
				arc + (-r * 2) + ',0 ';
	
			this._setPath(layer, d);
		},
	
		_setPath: function (layer, path) {
			layer._path.setAttribute('d', path);
		},
	
		// SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
		_bringToFront: function (layer) {
			toFront(layer._path);
		},
	
		_bringToBack: function (layer) {
			toBack(layer._path);
		}
	});
	
	if (vml) {
		SVG.include(vmlMixin);
	}
	
	// @namespace SVG
	// @factory L.svg(options?: Renderer options)
	// Creates a SVG renderer with the given options.
	function svg$1(options) {
		return svg || vml ? new SVG(options) : null;
	}
	
	Map.include({
		// @namespace Map; @method getRenderer(layer: Path): Renderer
		// Returns the instance of `Renderer` that should be used to render the given
		// `Path`. It will ensure that the `renderer` options of the map and paths
		// are respected, and that the renderers do exist on the map.
		getRenderer: function (layer) {
			// @namespace Path; @option renderer: Renderer
			// Use this specific instance of `Renderer` for this path. Takes
			// precedence over the map's [default renderer](#map-renderer).
			var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
	
			if (!renderer) {
				renderer = this._renderer = this._createRenderer();
			}
	
			if (!this.hasLayer(renderer)) {
				this.addLayer(renderer);
			}
			return renderer;
		},
	
		_getPaneRenderer: function (name) {
			if (name === 'overlayPane' || name === undefined) {
				return false;
			}
	
			var renderer = this._paneRenderers[name];
			if (renderer === undefined) {
				renderer = this._createRenderer({pane: name});
				this._paneRenderers[name] = renderer;
			}
			return renderer;
		},
	
		_createRenderer: function (options) {
			// @namespace Map; @option preferCanvas: Boolean = false
			// Whether `Path`s should be rendered on a `Canvas` renderer.
			// By default, all `Path`s are rendered in a `SVG` renderer.
			return (this.options.preferCanvas && canvas$1(options)) || svg$1(options);
		}
	});
	
	/*
	 * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
	 */
	
	/*
	 * @class Rectangle
	 * @aka L.Rectangle
	 * @inherits Polygon
	 *
	 * A class for drawing rectangle overlays on a map. Extends `Polygon`.
	 *
	 * @example
	 *
	 * ```js
	 * // define rectangle geographical bounds
	 * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
	 *
	 * // create an orange rectangle
	 * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
	 *
	 * // zoom the map to the rectangle bounds
	 * map.fitBounds(bounds);
	 * ```
	 *
	 */
	
	
	var Rectangle = Polygon.extend({
		initialize: function (latLngBounds, options) {
			Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
		},
	
		// @method setBounds(latLngBounds: LatLngBounds): this
		// Redraws the rectangle with the passed bounds.
		setBounds: function (latLngBounds) {
			return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
		},
	
		_boundsToLatLngs: function (latLngBounds) {
			latLngBounds = toLatLngBounds(latLngBounds);
			return [
				latLngBounds.getSouthWest(),
				latLngBounds.getNorthWest(),
				latLngBounds.getNorthEast(),
				latLngBounds.getSouthEast()
			];
		}
	});
	
	
	// @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
	function rectangle(latLngBounds, options) {
		return new Rectangle(latLngBounds, options);
	}
	
	SVG.create = create$2;
	SVG.pointsToPath = pointsToPath;
	
	GeoJSON.geometryToLayer = geometryToLayer;
	GeoJSON.coordsToLatLng = coordsToLatLng;
	GeoJSON.coordsToLatLngs = coordsToLatLngs;
	GeoJSON.latLngToCoords = latLngToCoords;
	GeoJSON.latLngsToCoords = latLngsToCoords;
	GeoJSON.getFeature = getFeature;
	GeoJSON.asFeature = asFeature;
	
	/*
	 * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
	 * (zoom to a selected bounding box), enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @option boxZoom: Boolean = true
		// Whether the map can be zoomed to a rectangular area specified by
		// dragging the mouse while pressing the shift key.
		boxZoom: true
	});
	
	var BoxZoom = Handler.extend({
		initialize: function (map) {
			this._map = map;
			this._container = map._container;
			this._pane = map._panes.overlayPane;
			this._resetStateTimeout = 0;
			map.on('unload', this._destroy, this);
		},
	
		addHooks: function () {
			on(this._container, 'mousedown', this._onMouseDown, this);
		},
	
		removeHooks: function () {
			off(this._container, 'mousedown', this._onMouseDown, this);
		},
	
		moved: function () {
			return this._moved;
		},
	
		_destroy: function () {
			remove(this._pane);
			delete this._pane;
		},
	
		_resetState: function () {
			this._resetStateTimeout = 0;
			this._moved = false;
		},
	
		_clearDeferredResetState: function () {
			if (this._resetStateTimeout !== 0) {
				clearTimeout(this._resetStateTimeout);
				this._resetStateTimeout = 0;
			}
		},
	
		_onMouseDown: function (e) {
			if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }
	
			// Clear the deferred resetState if it hasn't executed yet, otherwise it
			// will interrupt the interaction and orphan a box element in the container.
			this._clearDeferredResetState();
			this._resetState();
	
			disableTextSelection();
			disableImageDrag();
	
			this._startPoint = this._map.mouseEventToContainerPoint(e);
	
			on(document, {
				contextmenu: stop,
				mousemove: this._onMouseMove,
				mouseup: this._onMouseUp,
				keydown: this._onKeyDown
			}, this);
		},
	
		_onMouseMove: function (e) {
			if (!this._moved) {
				this._moved = true;
	
				this._box = create$1('div', 'leaflet-zoom-box', this._container);
				addClass(this._container, 'leaflet-crosshair');
	
				this._map.fire('boxzoomstart');
			}
	
			this._point = this._map.mouseEventToContainerPoint(e);
	
			var bounds = new Bounds(this._point, this._startPoint),
			    size = bounds.getSize();
	
			setPosition(this._box, bounds.min);
	
			this._box.style.width  = size.x + 'px';
			this._box.style.height = size.y + 'px';
		},
	
		_finish: function () {
			if (this._moved) {
				remove(this._box);
				removeClass(this._container, 'leaflet-crosshair');
			}
	
			enableTextSelection();
			enableImageDrag();
	
			off(document, {
				contextmenu: stop,
				mousemove: this._onMouseMove,
				mouseup: this._onMouseUp,
				keydown: this._onKeyDown
			}, this);
		},
	
		_onMouseUp: function (e) {
			if ((e.which !== 1) && (e.button !== 1)) { return; }
	
			this._finish();
	
			if (!this._moved) { return; }
			// Postpone to next JS tick so internal click event handling
			// still see it as "moved".
			this._clearDeferredResetState();
			this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
	
			var bounds = new LatLngBounds(
			        this._map.containerPointToLatLng(this._startPoint),
			        this._map.containerPointToLatLng(this._point));
	
			this._map
				.fitBounds(bounds)
				.fire('boxzoomend', {boxZoomBounds: bounds});
		},
	
		_onKeyDown: function (e) {
			if (e.keyCode === 27) {
				this._finish();
			}
		}
	});
	
	// @section Handlers
	// @property boxZoom: Handler
	// Box (shift-drag with mouse) zoom handler.
	Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
	
	/*
	 * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	
	Map.mergeOptions({
		// @option doubleClickZoom: Boolean|String = true
		// Whether the map can be zoomed in by double clicking on it and
		// zoomed out by double clicking while holding shift. If passed
		// `'center'`, double-click zoom will zoom to the center of the
		//  view regardless of where the mouse was.
		doubleClickZoom: true
	});
	
	var DoubleClickZoom = Handler.extend({
		addHooks: function () {
			this._map.on('dblclick', this._onDoubleClick, this);
		},
	
		removeHooks: function () {
			this._map.off('dblclick', this._onDoubleClick, this);
		},
	
		_onDoubleClick: function (e) {
			var map = this._map,
			    oldZoom = map.getZoom(),
			    delta = map.options.zoomDelta,
			    zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
	
			if (map.options.doubleClickZoom === 'center') {
				map.setZoom(zoom);
			} else {
				map.setZoomAround(e.containerPoint, zoom);
			}
		}
	});
	
	// @section Handlers
	//
	// Map properties include interaction handlers that allow you to control
	// interaction behavior in runtime, enabling or disabling certain features such
	// as dragging or touch zoom (see `Handler` methods). For example:
	//
	// ```js
	// map.doubleClickZoom.disable();
	// ```
	//
	// @property doubleClickZoom: Handler
	// Double click zoom handler.
	Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
	
	/*
	 * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @option dragging: Boolean = true
		// Whether the map be draggable with mouse/touch or not.
		dragging: true,
	
		// @section Panning Inertia Options
		// @option inertia: Boolean = *
		// If enabled, panning of the map will have an inertia effect where
		// the map builds momentum while dragging and continues moving in
		// the same direction for some time. Feels especially nice on touch
		// devices. Enabled by default unless running on old Android devices.
		inertia: !android23,
	
		// @option inertiaDeceleration: Number = 3000
		// The rate with which the inertial movement slows down, in pixels/second².
		inertiaDeceleration: 3400, // px/s^2
	
		// @option inertiaMaxSpeed: Number = Infinity
		// Max speed of the inertial movement, in pixels/second.
		inertiaMaxSpeed: Infinity, // px/s
	
		// @option easeLinearity: Number = 0.2
		easeLinearity: 0.2,
	
		// TODO refactor, move to CRS
		// @option worldCopyJump: Boolean = false
		// With this option enabled, the map tracks when you pan to another "copy"
		// of the world and seamlessly jumps to the original one so that all overlays
		// like markers and vector layers are still visible.
		worldCopyJump: false,
	
		// @option maxBoundsViscosity: Number = 0.0
		// If `maxBounds` is set, this option will control how solid the bounds
		// are when dragging the map around. The default value of `0.0` allows the
		// user to drag outside the bounds at normal speed, higher values will
		// slow down map dragging outside bounds, and `1.0` makes the bounds fully
		// solid, preventing the user from dragging outside the bounds.
		maxBoundsViscosity: 0.0
	});
	
	var Drag = Handler.extend({
		addHooks: function () {
			if (!this._draggable) {
				var map = this._map;
	
				this._draggable = new Draggable(map._mapPane, map._container);
	
				this._draggable.on({
					dragstart: this._onDragStart,
					drag: this._onDrag,
					dragend: this._onDragEnd
				}, this);
	
				this._draggable.on('predrag', this._onPreDragLimit, this);
				if (map.options.worldCopyJump) {
					this._draggable.on('predrag', this._onPreDragWrap, this);
					map.on('zoomend', this._onZoomEnd, this);
	
					map.whenReady(this._onZoomEnd, this);
				}
			}
			addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
			this._draggable.enable();
			this._positions = [];
			this._times = [];
		},
	
		removeHooks: function () {
			removeClass(this._map._container, 'leaflet-grab');
			removeClass(this._map._container, 'leaflet-touch-drag');
			this._draggable.disable();
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		moving: function () {
			return this._draggable && this._draggable._moving;
		},
	
		_onDragStart: function () {
			var map = this._map;
	
			map._stop();
			if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
				var bounds = toLatLngBounds(this._map.options.maxBounds);
	
				this._offsetLimit = toBounds(
					this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),
					this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1)
						.add(this._map.getSize()));
	
				this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
			} else {
				this._offsetLimit = null;
			}
	
			map
			    .fire('movestart')
			    .fire('dragstart');
	
			if (map.options.inertia) {
				this._positions = [];
				this._times = [];
			}
		},
	
		_onDrag: function (e) {
			if (this._map.options.inertia) {
				var time = this._lastTime = +new Date(),
				    pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
	
				this._positions.push(pos);
				this._times.push(time);
	
				this._prunePositions(time);
			}
	
			this._map
			    .fire('move', e)
			    .fire('drag', e);
		},
	
		_prunePositions: function (time) {
			while (this._positions.length > 1 && time - this._times[0] > 50) {
				this._positions.shift();
				this._times.shift();
			}
		},
	
		_onZoomEnd: function () {
			var pxCenter = this._map.getSize().divideBy(2),
			    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);
	
			this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
			this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
		},
	
		_viscousLimit: function (value, threshold) {
			return value - (value - threshold) * this._viscosity;
		},
	
		_onPreDragLimit: function () {
			if (!this._viscosity || !this._offsetLimit) { return; }
	
			var offset = this._draggable._newPos.subtract(this._draggable._startPos);
	
			var limit = this._offsetLimit;
			if (offset.x < limit.min.x) { offset.x = this._viscousLimit(offset.x, limit.min.x); }
			if (offset.y < limit.min.y) { offset.y = this._viscousLimit(offset.y, limit.min.y); }
			if (offset.x > limit.max.x) { offset.x = this._viscousLimit(offset.x, limit.max.x); }
			if (offset.y > limit.max.y) { offset.y = this._viscousLimit(offset.y, limit.max.y); }
	
			this._draggable._newPos = this._draggable._startPos.add(offset);
		},
	
		_onPreDragWrap: function () {
			// TODO refactor to be able to adjust map pane position after zoom
			var worldWidth = this._worldWidth,
			    halfWidth = Math.round(worldWidth / 2),
			    dx = this._initialWorldOffset,
			    x = this._draggable._newPos.x,
			    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
			    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
			    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
	
			this._draggable._absPos = this._draggable._newPos.clone();
			this._draggable._newPos.x = newX;
		},
	
		_onDragEnd: function (e) {
			var map = this._map,
			    options = map.options,
	
			    noInertia = !options.inertia || this._times.length < 2;
	
			map.fire('dragend', e);
	
			if (noInertia) {
				map.fire('moveend');
	
			} else {
				this._prunePositions(+new Date());
	
				var direction = this._lastPos.subtract(this._positions[0]),
				    duration = (this._lastTime - this._times[0]) / 1000,
				    ease = options.easeLinearity,
	
				    speedVector = direction.multiplyBy(ease / duration),
				    speed = speedVector.distanceTo([0, 0]),
	
				    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
				    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),
	
				    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
				    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
	
				if (!offset.x && !offset.y) {
					map.fire('moveend');
	
				} else {
					offset = map._limitOffset(offset, map.options.maxBounds);
	
					requestAnimFrame(function () {
						map.panBy(offset, {
							duration: decelerationDuration,
							easeLinearity: ease,
							noMoveStart: true,
							animate: true
						});
					});
				}
			}
		}
	});
	
	// @section Handlers
	// @property dragging: Handler
	// Map dragging handler (by both mouse and touch).
	Map.addInitHook('addHandler', 'dragging', Drag);
	
	/*
	 * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
	 */
	
	// @namespace Map
	// @section Keyboard Navigation Options
	Map.mergeOptions({
		// @option keyboard: Boolean = true
		// Makes the map focusable and allows users to navigate the map with keyboard
		// arrows and `+`/`-` keys.
		keyboard: true,
	
		// @option keyboardPanDelta: Number = 80
		// Amount of pixels to pan when pressing an arrow key.
		keyboardPanDelta: 80
	});
	
	var Keyboard = Handler.extend({
	
		keyCodes: {
			left:    [37],
			right:   [39],
			down:    [40],
			up:      [38],
			zoomIn:  [187, 107, 61, 171],
			zoomOut: [189, 109, 54, 173]
		},
	
		initialize: function (map) {
			this._map = map;
	
			this._setPanDelta(map.options.keyboardPanDelta);
			this._setZoomDelta(map.options.zoomDelta);
		},
	
		addHooks: function () {
			var container = this._map._container;
	
			// make the container focusable by tabbing
			if (container.tabIndex <= 0) {
				container.tabIndex = '0';
			}
	
			on(container, {
				focus: this._onFocus,
				blur: this._onBlur,
				mousedown: this._onMouseDown
			}, this);
	
			this._map.on({
				focus: this._addHooks,
				blur: this._removeHooks
			}, this);
		},
	
		removeHooks: function () {
			this._removeHooks();
	
			off(this._map._container, {
				focus: this._onFocus,
				blur: this._onBlur,
				mousedown: this._onMouseDown
			}, this);
	
			this._map.off({
				focus: this._addHooks,
				blur: this._removeHooks
			}, this);
		},
	
		_onMouseDown: function () {
			if (this._focused) { return; }
	
			var body = document.body,
			    docEl = document.documentElement,
			    top = body.scrollTop || docEl.scrollTop,
			    left = body.scrollLeft || docEl.scrollLeft;
	
			this._map._container.focus();
	
			window.scrollTo(left, top);
		},
	
		_onFocus: function () {
			this._focused = true;
			this._map.fire('focus');
		},
	
		_onBlur: function () {
			this._focused = false;
			this._map.fire('blur');
		},
	
		_setPanDelta: function (panDelta) {
			var keys = this._panKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.left.length; i < len; i++) {
				keys[codes.left[i]] = [-1 * panDelta, 0];
			}
			for (i = 0, len = codes.right.length; i < len; i++) {
				keys[codes.right[i]] = [panDelta, 0];
			}
			for (i = 0, len = codes.down.length; i < len; i++) {
				keys[codes.down[i]] = [0, panDelta];
			}
			for (i = 0, len = codes.up.length; i < len; i++) {
				keys[codes.up[i]] = [0, -1 * panDelta];
			}
		},
	
		_setZoomDelta: function (zoomDelta) {
			var keys = this._zoomKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.zoomIn.length; i < len; i++) {
				keys[codes.zoomIn[i]] = zoomDelta;
			}
			for (i = 0, len = codes.zoomOut.length; i < len; i++) {
				keys[codes.zoomOut[i]] = -zoomDelta;
			}
		},
	
		_addHooks: function () {
			on(document, 'keydown', this._onKeyDown, this);
		},
	
		_removeHooks: function () {
			off(document, 'keydown', this._onKeyDown, this);
		},
	
		_onKeyDown: function (e) {
			if (e.altKey || e.ctrlKey || e.metaKey) { return; }
	
			var key = e.keyCode,
			    map = this._map,
			    offset;
	
			if (key in this._panKeys) {
				if (!map._panAnim || !map._panAnim._inProgress) {
					offset = this._panKeys[key];
					if (e.shiftKey) {
						offset = toPoint(offset).multiplyBy(3);
					}
	
					map.panBy(offset);
	
					if (map.options.maxBounds) {
						map.panInsideBounds(map.options.maxBounds);
					}
				}
			} else if (key in this._zoomKeys) {
				map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
	
			} else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) {
				map.closePopup();
	
			} else {
				return;
			}
	
			stop(e);
		}
	});
	
	// @section Handlers
	// @section Handlers
	// @property keyboard: Handler
	// Keyboard navigation handler.
	Map.addInitHook('addHandler', 'keyboard', Keyboard);
	
	/*
	 * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @section Mousewheel options
		// @option scrollWheelZoom: Boolean|String = true
		// Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
		// it will zoom to the center of the view regardless of where the mouse was.
		scrollWheelZoom: true,
	
		// @option wheelDebounceTime: Number = 40
		// Limits the rate at which a wheel can fire (in milliseconds). By default
		// user can't zoom via wheel more often than once per 40 ms.
		wheelDebounceTime: 40,
	
		// @option wheelPxPerZoomLevel: Number = 60
		// How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
		// mean a change of one full zoom level. Smaller values will make wheel-zooming
		// faster (and vice versa).
		wheelPxPerZoomLevel: 60
	});
	
	var ScrollWheelZoom = Handler.extend({
		addHooks: function () {
			on(this._map._container, 'mousewheel', this._onWheelScroll, this);
	
			this._delta = 0;
		},
	
		removeHooks: function () {
			off(this._map._container, 'mousewheel', this._onWheelScroll, this);
		},
	
		_onWheelScroll: function (e) {
			var delta = getWheelDelta(e);
	
			var debounce = this._map.options.wheelDebounceTime;
	
			this._delta += delta;
			this._lastMousePos = this._map.mouseEventToContainerPoint(e);
	
			if (!this._startTime) {
				this._startTime = +new Date();
			}
	
			var left = Math.max(debounce - (+new Date() - this._startTime), 0);
	
			clearTimeout(this._timer);
			this._timer = setTimeout(bind(this._performZoom, this), left);
	
			stop(e);
		},
	
		_performZoom: function () {
			var map = this._map,
			    zoom = map.getZoom(),
			    snap = this._map.options.zoomSnap || 0;
	
			map._stop(); // stop panning and fly animations if any
	
			// map the delta with a sigmoid function to -4..4 range leaning on -1..1
			var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
			    d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2,
			    d4 = snap ? Math.ceil(d3 / snap) * snap : d3,
			    delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
	
			this._delta = 0;
			this._startTime = null;
	
			if (!delta) { return; }
	
			if (map.options.scrollWheelZoom === 'center') {
				map.setZoom(zoom + delta);
			} else {
				map.setZoomAround(this._lastMousePos, zoom + delta);
			}
		}
	});
	
	// @section Handlers
	// @property scrollWheelZoom: Handler
	// Scroll wheel zoom handler.
	Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
	
	/*
	 * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @section Touch interaction options
		// @option tap: Boolean = true
		// Enables mobile hacks for supporting instant taps (fixing 200ms click
		// delay on iOS/Android) and touch holds (fired as `contextmenu` events).
		tap: true,
	
		// @option tapTolerance: Number = 15
		// The max number of pixels a user can shift his finger during touch
		// for it to be considered a valid tap.
		tapTolerance: 15
	});
	
	var Tap = Handler.extend({
		addHooks: function () {
			on(this._map._container, 'touchstart', this._onDown, this);
		},
	
		removeHooks: function () {
			off(this._map._container, 'touchstart', this._onDown, this);
		},
	
		_onDown: function (e) {
			if (!e.touches) { return; }
	
			preventDefault(e);
	
			this._fireClick = true;
	
			// don't simulate click or track longpress if more than 1 touch
			if (e.touches.length > 1) {
				this._fireClick = false;
				clearTimeout(this._holdTimeout);
				return;
			}
	
			var first = e.touches[0],
			    el = first.target;
	
			this._startPos = this._newPos = new Point(first.clientX, first.clientY);
	
			// if touching a link, highlight it
			if (el.tagName && el.tagName.toLowerCase() === 'a') {
				addClass(el, 'leaflet-active');
			}
	
			// simulate long hold but setting a timeout
			this._holdTimeout = setTimeout(bind(function () {
				if (this._isTapValid()) {
					this._fireClick = false;
					this._onUp();
					this._simulateEvent('contextmenu', first);
				}
			}, this), 1000);
	
			this._simulateEvent('mousedown', first);
	
			on(document, {
				touchmove: this._onMove,
				touchend: this._onUp
			}, this);
		},
	
		_onUp: function (e) {
			clearTimeout(this._holdTimeout);
	
			off(document, {
				touchmove: this._onMove,
				touchend: this._onUp
			}, this);
	
			if (this._fireClick && e && e.changedTouches) {
	
				var first = e.changedTouches[0],
				    el = first.target;
	
				if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
					removeClass(el, 'leaflet-active');
				}
	
				this._simulateEvent('mouseup', first);
	
				// simulate click if the touch didn't move too much
				if (this._isTapValid()) {
					this._simulateEvent('click', first);
				}
			}
		},
	
		_isTapValid: function () {
			return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
		},
	
		_onMove: function (e) {
			var first = e.touches[0];
			this._newPos = new Point(first.clientX, first.clientY);
			this._simulateEvent('mousemove', first);
		},
	
		_simulateEvent: function (type, e) {
			var simulatedEvent = document.createEvent('MouseEvents');
	
			simulatedEvent._simulated = true;
			e.target._simulatedClick = true;
	
			simulatedEvent.initMouseEvent(
			        type, true, true, window, 1,
			        e.screenX, e.screenY,
			        e.clientX, e.clientY,
			        false, false, false, false, 0, null);
	
			e.target.dispatchEvent(simulatedEvent);
		}
	});
	
	// @section Handlers
	// @property tap: Handler
	// Mobile touch hacks (quick tap and touch hold) handler.
	if (touch && !pointer) {
		Map.addInitHook('addHandler', 'tap', Tap);
	}
	
	/*
	 * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @section Touch interaction options
		// @option touchZoom: Boolean|String = *
		// Whether the map can be zoomed by touch-dragging with two fingers. If
		// passed `'center'`, it will zoom to the center of the view regardless of
		// where the touch events (fingers) were. Enabled for touch-capable web
		// browsers except for old Androids.
		touchZoom: touch && !android23,
	
		// @option bounceAtZoomLimits: Boolean = true
		// Set it to false if you don't want the map to zoom beyond min/max zoom
		// and then bounce back when pinch-zooming.
		bounceAtZoomLimits: true
	});
	
	var TouchZoom = Handler.extend({
		addHooks: function () {
			addClass(this._map._container, 'leaflet-touch-zoom');
			on(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		removeHooks: function () {
			removeClass(this._map._container, 'leaflet-touch-zoom');
			off(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		_onTouchStart: function (e) {
			var map = this._map;
			if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }
	
			var p1 = map.mouseEventToContainerPoint(e.touches[0]),
			    p2 = map.mouseEventToContainerPoint(e.touches[1]);
	
			this._centerPoint = map.getSize()._divideBy(2);
			this._startLatLng = map.containerPointToLatLng(this._centerPoint);
			if (map.options.touchZoom !== 'center') {
				this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
			}
	
			this._startDist = p1.distanceTo(p2);
			this._startZoom = map.getZoom();
	
			this._moved = false;
			this._zooming = true;
	
			map._stop();
	
			on(document, 'touchmove', this._onTouchMove, this);
			on(document, 'touchend', this._onTouchEnd, this);
	
			preventDefault(e);
		},
	
		_onTouchMove: function (e) {
			if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }
	
			var map = this._map,
			    p1 = map.mouseEventToContainerPoint(e.touches[0]),
			    p2 = map.mouseEventToContainerPoint(e.touches[1]),
			    scale = p1.distanceTo(p2) / this._startDist;
	
			this._zoom = map.getScaleZoom(scale, this._startZoom);
	
			if (!map.options.bounceAtZoomLimits && (
				(this._zoom < map.getMinZoom() && scale < 1) ||
				(this._zoom > map.getMaxZoom() && scale > 1))) {
				this._zoom = map._limitZoom(this._zoom);
			}
	
			if (map.options.touchZoom === 'center') {
				this._center = this._startLatLng;
				if (scale === 1) { return; }
			} else {
				// Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
				var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
				if (scale === 1 && delta.x === 0 && delta.y === 0) { return; }
				this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
			}
	
			if (!this._moved) {
				map._moveStart(true, false);
				this._moved = true;
			}
	
			cancelAnimFrame(this._animRequest);
	
			var moveFn = bind(map._move, map, this._center, this._zoom, {pinch: true, round: false});
			this._animRequest = requestAnimFrame(moveFn, this, true);
	
			preventDefault(e);
		},
	
		_onTouchEnd: function () {
			if (!this._moved || !this._zooming) {
				this._zooming = false;
				return;
			}
	
			this._zooming = false;
			cancelAnimFrame(this._animRequest);
	
			off(document, 'touchmove', this._onTouchMove);
			off(document, 'touchend', this._onTouchEnd);
	
			// Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
			if (this._map.options.zoomAnimation) {
				this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
			} else {
				this._map._resetView(this._center, this._map._limitZoom(this._zoom));
			}
		}
	});
	
	// @section Handlers
	// @property touchZoom: Handler
	// Touch zoom handler.
	Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
	
	Map.BoxZoom = BoxZoom;
	Map.DoubleClickZoom = DoubleClickZoom;
	Map.Drag = Drag;
	Map.Keyboard = Keyboard;
	Map.ScrollWheelZoom = ScrollWheelZoom;
	Map.Tap = Tap;
	Map.TouchZoom = TouchZoom;
	
	Object.freeze = freeze;
	
	exports.version = version;
	exports.Control = Control;
	exports.control = control;
	exports.Browser = Browser;
	exports.Evented = Evented;
	exports.Mixin = Mixin;
	exports.Util = Util;
	exports.Class = Class;
	exports.Handler = Handler;
	exports.extend = extend;
	exports.bind = bind;
	exports.stamp = stamp;
	exports.setOptions = setOptions;
	exports.DomEvent = DomEvent;
	exports.DomUtil = DomUtil;
	exports.PosAnimation = PosAnimation;
	exports.Draggable = Draggable;
	exports.LineUtil = LineUtil;
	exports.PolyUtil = PolyUtil;
	exports.Point = Point;
	exports.point = toPoint;
	exports.Bounds = Bounds;
	exports.bounds = toBounds;
	exports.Transformation = Transformation;
	exports.transformation = toTransformation;
	exports.Projection = index;
	exports.LatLng = LatLng;
	exports.latLng = toLatLng;
	exports.LatLngBounds = LatLngBounds;
	exports.latLngBounds = toLatLngBounds;
	exports.CRS = CRS;
	exports.GeoJSON = GeoJSON;
	exports.geoJSON = geoJSON;
	exports.geoJson = geoJson;
	exports.Layer = Layer;
	exports.LayerGroup = LayerGroup;
	exports.layerGroup = layerGroup;
	exports.FeatureGroup = FeatureGroup;
	exports.featureGroup = featureGroup;
	exports.ImageOverlay = ImageOverlay;
	exports.imageOverlay = imageOverlay;
	exports.VideoOverlay = VideoOverlay;
	exports.videoOverlay = videoOverlay;
	exports.SVGOverlay = SVGOverlay;
	exports.svgOverlay = svgOverlay;
	exports.DivOverlay = DivOverlay;
	exports.Popup = Popup;
	exports.popup = popup;
	exports.Tooltip = Tooltip;
	exports.tooltip = tooltip;
	exports.Icon = Icon;
	exports.icon = icon;
	exports.DivIcon = DivIcon;
	exports.divIcon = divIcon;
	exports.Marker = Marker;
	exports.marker = marker;
	exports.TileLayer = TileLayer;
	exports.tileLayer = tileLayer;
	exports.GridLayer = GridLayer;
	exports.gridLayer = gridLayer;
	exports.SVG = SVG;
	exports.svg = svg$1;
	exports.Renderer = Renderer;
	exports.Canvas = Canvas;
	exports.canvas = canvas$1;
	exports.Path = Path;
	exports.CircleMarker = CircleMarker;
	exports.circleMarker = circleMarker;
	exports.Circle = Circle;
	exports.circle = circle;
	exports.Polyline = Polyline;
	exports.polyline = polyline;
	exports.Polygon = Polygon;
	exports.polygon = polygon;
	exports.Rectangle = Rectangle;
	exports.rectangle = rectangle;
	exports.Map = Map;
	exports.map = createMap;
	
	var oldL = window.L;
	exports.noConflict = function() {
		window.L = oldL;
		return this;
	}
	
	// Always export us to window global (see #2364)
	window.L = exports;
	
	})));
	//# sourceMappingURL=leaflet-src.js.map


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(16);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.withLeaflet = exports.LeafletProvider = exports.LeafletConsumer = exports.useLeaflet = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(75));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var leafletContext = (0, _react.createContext)({});
	
	var useLeaflet = function useLeaflet() {
	  return (0, _react.useContext)(leafletContext);
	};
	
	exports.useLeaflet = useLeaflet;
	var LeafletConsumer = leafletContext.Consumer;
	exports.LeafletConsumer = LeafletConsumer;
	var LeafletProvider = leafletContext.Provider;
	exports.LeafletProvider = LeafletProvider;
	
	var withLeaflet = function withLeaflet(WrappedComponent) {
	  var WithLeafletComponent = function WithLeafletComponent(props, ref) {
	    return _react.default.createElement(LeafletConsumer, null, function (leaflet) {
	      return _react.default.createElement(WrappedComponent, (0, _extends2.default)({}, props, {
	        leaflet: leaflet,
	        ref: ref
	      }));
	    });
	  };
	
	  var name = // flowlint-next-line sketchy-null-string:off
	  WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  WithLeafletComponent.displayName = "Leaflet(" + name + ")";
	  var LeafletComponent = (0, _react.forwardRef)(WithLeafletComponent);
	  (0, _hoistNonReactStatics.default)(LeafletComponent, WrappedComponent);
	  return LeafletComponent;
	};
	
	exports.withLeaflet = withLeaflet;

/***/ },
/* 6 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireDefault(__webpack_require__(218));
	
	exports.Provider = _Provider["default"];
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(79));
	
	exports.connectAdvanced = _connectAdvanced["default"];
	
	var _Context = __webpack_require__(22);
	
	exports.ReactReduxContext = _Context.ReactReduxContext;
	
	var _connect = _interopRequireDefault(__webpack_require__(219));
	
	exports.connect = _connect["default"];
	
	var _useDispatch = __webpack_require__(225);
	
	exports.useDispatch = _useDispatch.useDispatch;
	exports.createDispatchHook = _useDispatch.createDispatchHook;
	
	var _useSelector = __webpack_require__(226);
	
	exports.useSelector = _useSelector.useSelector;
	exports.createSelectorHook = _useSelector.createSelectorHook;
	
	var _useStore = __webpack_require__(82);
	
	exports.useStore = _useStore.useStore;
	exports.createStoreHook = _useStore.createStoreHook;
	
	var _batch = __webpack_require__(83);
	
	var _reactBatchedUpdates = __webpack_require__(228);
	
	exports.batch = _reactBatchedUpdates.unstable_batchedUpdates;
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(84));
	
	exports.shallowEqual = _shallowEqual["default"];
	(0, _batch.setBatch)(_reactBatchedUpdates.unstable_batchedUpdates);

/***/ },
/* 8 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.9' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 9 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ },
/* 10 */
/***/ function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(117);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.selectGravestone = selectGravestone;
	exports.unselectGravestone = unselectGravestone;
	exports.changeCenterAndZoom = changeCenterAndZoom;
	exports.changeBounds = changeBounds;
	exports.loadGravestones = loadGravestones;
	exports.toggleAbout = toggleAbout;
	exports.toggleHillshade = toggleHillshade;
	exports.toggleContactUs = toggleContactUs;
	exports.geolocate = geolocate;
	exports.zoomToHeadstone = zoomToHeadstone;
	
	var _actionTypes = __webpack_require__(60);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _gravestones = __webpack_require__(186);
	
	var _gravestones2 = _interopRequireDefault(_gravestones);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function selectGravestone(d) {
	  return function (dispatch, getState) {
	    var id = d;
	    if (d && d.id) {
	      id = d.id;
	    }
	
	    dispatch({
	      type: _actionTypes2.default.SELECT_GRAVESTONE,
	      payload: id
	    });
	
	    // recenter if necessary
	
	    var _getState$gravestones = getState().gravestones.find(function (g) {
	      return g.id === id;
	    }),
	        lat = _getState$gravestones.lat,
	        lng = _getState$gravestones.lng;
	
	    var _getState = getState(),
	        bounds = _getState.bounds;
	
	    var _getNSWE2 = _getNSWE(bounds),
	        n = _getNSWE2.n,
	        s = _getNSWE2.s,
	        e = _getNSWE2.e,
	        w = _getNSWE2.w;
	
	    if (lat <= s || lat >= n || lng <= w || lng >= e) {
	      dispatch(changeCenterAndZoom([lat, lng], 20));
	    }
	  };
	}
	
	function unselectGravestone() {
	  return {
	    type: _actionTypes2.default.SELECT_GRAVESTONE,
	    payload: null
	  };
	}
	
	function changeCenterAndZoom(center, zoom) {
	  return {
	    type: _actionTypes2.default.CHANGE_CENTER_AND_ZOOM,
	    payload: {
	      center: center,
	      zoom: zoom
	    }
	  };
	}
	
	function changeBounds(bounds) {
	  return {
	    type: _actionTypes2.default.CHANGE_BOUNDS,
	    payload: bounds
	  };
	}
	
	function loadGravestones() {
	  var _this = this;
	
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch) {
	      var gravestones;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              // const query = 'select birth_day, birth_month, birth_year, death_day, death_month, death_year, findgrave_id, findgrave_id as id, first_name, last_name, latitude, longitude, maiden_name, middle_name from gravestones_materialized where latitude != 37.535835 or longitude != -77.385079';
	              // const url = `https://digitalscholarshiplab.cartodb.com/api/v2/sql?format=JSON&q=${encodeURI(query)}`;
	              // console.log(url);
	              // const response = await fetch(url);
	              // const json = await response.json();
	              //const gravestones = json.rows.map((r) => {
	              gravestones = _gravestones2.default.map(function (r) {
	                var first_name = r.nf,
	                    middle_name = r.nm,
	                    last_name = r.nl,
	                    birth_year = r.by,
	                    death_year = r.dy;
	
	                r.searchName = first_name + ' ' + (typeof middle_name !== 'undefined' ? middle_name : '') + ' ' + last_name + ' (' + (birth_year !== 0 ? birth_year : '') + '-' + death_year + ')';
	                return r;
	              });
	
	
	              dispatch({
	                type: _actionTypes2.default.LOAD_GRAVESTONES,
	                payload: gravestones
	              });
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	}
	
	function toggleAbout() {
	  return {
	    type: _actionTypes2.default.TOGGLE_ABOUT
	  };
	}
	
	function toggleHillshade() {
	  return {
	    type: _actionTypes2.default.TOGGLE_HILLSHADE
	  };
	}
	
	function toggleContactUs() {
	  return {
	    type: _actionTypes2.default.TOGGLE_CONTACT_US
	  };
	}
	
	function geolocate() {
	  return function (dispatch, getState) {
	    if (navigator.geolocation) {
	      navigator.geolocation.getCurrentPosition(function (position) {
	        // only select from position if a city isn't specified, a location isn't specified
	        dispatch({
	          type: _actionTypes2.default.LOCATED_USER,
	          payload: [position.coords.latitude, position.coords.longitude]
	        });
	      }, function (error) {
	        console.warn('geolocation error ' + error);
	      }, {
	        enableHighAccuracy: true,
	        timeout: 7500,
	        maximumAge: 100000
	      });
	    }
	  };
	}
	
	function zoomToHeadstone(eOrId) {
	  var id = _getEventId(eOrId, 'number');
	  return function (dispatch, getState) {
	    var _getState$gravestones2 = getState().gravestones.find(function (g) {
	      return g.id === id;
	    }),
	        lat = _getState$gravestones2.lat,
	        lng = _getState$gravestones2.lng;
	
	    dispatch(changeCenterAndZoom([lat, lng], 22));
	  };
	}
	
	function _getEventId(eOrId) {
	  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
	
	  var id = eOrId.id || eOrId;
	  if (!eOrId.id && (typeof eOrId === 'undefined' ? 'undefined' : _typeof(eOrId)) === 'object') {
	    var ct = eOrId.currentTarget || eOrId.target;
	    id = ct.id || ct.options.id;
	  }
	  return type === 'number' ? parseInt(id, 10) : id;
	}
	
	function _getNSWE(bounds) {
	  return {
	    n: Math.max(bounds[0][0], bounds[1][0]),
	    s: Math.min(bounds[0][0], bounds[1][0]),
	    e: Math.max(bounds[0][1], bounds[1][1]),
	    w: Math.min(bounds[0][1], bounds[1][1])
	  };
	}

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(191)();
	}


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(23)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 14 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _fastDeepEqual = _interopRequireDefault(__webpack_require__(74));
	
	var _MapLayer2 = _interopRequireDefault(__webpack_require__(21));
	
	var _pick = _interopRequireDefault(__webpack_require__(217));
	
	var OPTIONS = ['stroke', 'color', 'weight', 'opacity', 'lineCap', 'lineJoin', 'dashArray', 'dashOffset', 'fill', 'fillColor', 'fillOpacity', 'fillRule', 'bubblingMouseEvents', 'renderer', 'className', // Interactive Layer
	'interactive', // Layer
	'pane', 'attribution'];
	
	var Path =
	/*#__PURE__*/
	function (_MapLayer) {
	  (0, _inheritsLoose2.default)(Path, _MapLayer);
	
	  function Path(props) {
	    var _this;
	
	    _this = _MapLayer.call(this, props) || this;
	
	    if (_this.contextValue == null) {
	      _this.contextValue = (0, _extends2.default)({}, props.leaflet, {
	        popupContainer: _this.leafletElement
	      });
	    }
	
	    return _this;
	  }
	
	  var _proto = Path.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    _MapLayer.prototype.componentDidUpdate.call(this, prevProps);
	
	    this.setStyleIfChanged(prevProps, this.props);
	  };
	
	  _proto.getPathOptions = function getPathOptions(props) {
	    return (0, _pick.default)(props, OPTIONS);
	  };
	
	  _proto.setStyle = function setStyle(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    this.leafletElement.setStyle(options);
	  };
	
	  _proto.setStyleIfChanged = function setStyleIfChanged(fromProps, toProps) {
	    var nextStyle = this.getPathOptions(toProps);
	
	    if (!(0, _fastDeepEqual.default)(nextStyle, this.getPathOptions(fromProps))) {
	      this.setStyle(nextStyle);
	    }
	  };
	
	  return Path;
	}(_MapLayer2.default);
	
	exports.default = Path;

/***/ },
/* 16 */
/***/ function(module, exports) {

	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;
	  var cache = new WeakMap();
	
	  _getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };
	
	  return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }
	
	  var cache = _getRequireWildcardCache();
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	
	  if (obj != null) {
	    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	        if (desc && (desc.get || desc.set)) {
	          Object.defineProperty(newObj, key, desc);
	        } else {
	          newObj[key] = obj[key];
	        }
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;

/***/ },
/* 17 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(14);
	var core = __webpack_require__(8);
	var ctx = __webpack_require__(64);
	var hide = __webpack_require__(24);
	var has = __webpack_require__(19);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 19 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(29);
	var IE8_DOM_DEFINE = __webpack_require__(66);
	var toPrimitive = __webpack_require__(47);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(13) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(16);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(87));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _context = __webpack_require__(5);
	
	var _MapComponent2 = _interopRequireDefault(__webpack_require__(55));
	
	var MapLayer =
	/*#__PURE__*/
	function (_MapComponent) {
	  (0, _inheritsLoose2.default)(MapLayer, _MapComponent);
	
	  function MapLayer(props) {
	    var _this;
	
	    _this = _MapComponent.call(this, props) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "contextValue", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "leafletElement", void 0);
	    _this.leafletElement = _this.createLeafletElement(props);
	    return _this;
	  }
	
	  var _proto = MapLayer.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(_props) {
	    throw new Error('createLeafletElement() must be implemented');
	  };
	
	  _proto.updateLeafletElement = function updateLeafletElement(_fromProps, _toProps) {};
	
	  _proto.componentDidMount = function componentDidMount() {
	    _MapComponent.prototype.componentDidMount.call(this);
	
	    this.layerContainer.addLayer(this.leafletElement);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    _MapComponent.prototype.componentDidUpdate.call(this, prevProps);
	
	    if (this.props.attribution !== prevProps.attribution) {
	      var map = this.props.leaflet.map;
	
	      if (map != null && map.attributionControl != null) {
	        map.attributionControl.removeAttribution(prevProps.attribution);
	        map.attributionControl.addAttribution(this.props.attribution);
	      }
	    }
	
	    this.updateLeafletElement(prevProps, this.props);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    _MapComponent.prototype.componentWillUnmount.call(this);
	
	    this.layerContainer.removeLayer(this.leafletElement);
	  };
	
	  _proto.render = function render() {
	    var children = this.props.children;
	
	    if (children == null) {
	      return null;
	    }
	
	    return this.contextValue == null ? _react.default.createElement(_react.Fragment, null, children) : _react.default.createElement(_context.LeafletProvider, {
	      value: this.contextValue
	    }, children);
	  };
	
	  (0, _createClass2.default)(MapLayer, [{
	    key: "layerContainer",
	    get: function get() {
	      return this.props.leaflet.layerContainer || this.props.leaflet.map;
	    }
	  }]);
	  return MapLayer;
	}(_MapComponent2.default);
	
	exports.default = MapLayer;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = exports.ReactReduxContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var ReactReduxContext = _react["default"].createContext(null);
	
	exports.ReactReduxContext = ReactReduxContext;
	var _default = ReactReduxContext;
	exports["default"] = _default;

/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(20);
	var createDesc = __webpack_require__(34);
	module.exports = __webpack_require__(13) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 25 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(67);
	var defined = __webpack_require__(38);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(45)('wks');
	var uid = __webpack_require__(36);
	var Symbol = __webpack_require__(14).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.showInset = exports.getGravestonesParsed = exports.getSearchOptions = exports.getSelectedInfo = exports.getPerimeter = undefined;
	
	var _reselect = __webpack_require__(234);
	
	var _eastEndPerimeter = __webpack_require__(187);
	
	var _eastEndPerimeter2 = _interopRequireDefault(_eastEndPerimeter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSelectedGravestone = function getSelectedGravestone(state) {
	  return state.selectedGravestone;
	};
	var getGravestones = function getGravestones(state) {
	  return state.gravestones;
	};
	var getBounds = function getBounds(state) {
	  return state.bounds;
	};
	var getZoom = function getZoom(state) {
	  return state.zoom;
	};
	
	var getPerimeter = exports.getPerimeter = function getPerimeter() {
	  return _eastEndPerimeter2.default;
	};
	
	var getSelectedInfo = exports.getSelectedInfo = (0, _reselect.createSelector)([getSelectedGravestone, getGravestones], function (selectedGravestone, gravestones) {
	  var gravestone = gravestones.find(function (g) {
	    return g.id === selectedGravestone;
	  });
	  if (gravestone) {
	    var first_name = gravestone.nf,
	        middle_name = gravestone.nm,
	        last_name = gravestone.nl,
	        birth_year = gravestone.by,
	        birth_month = gravestone.bm,
	        birth_day = gravestone.bd,
	        death_year = gravestone.dy,
	        death_month = gravestone.dm,
	        death_day = gravestone.dd,
	        id = gravestone.id,
	        n = gravestone.n,
	        t = gravestone.t;
	
	
	    var prettyDate = function prettyDate(date) {
	      var months = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	      if (date.year === 0) {
	        return '';
	      }
	
	      if (date.day !== null && date.month !== null && date.year !== null && date.day !== '' && date.month !== '' && date.year !== '') {
	        return months[date.month] + ' ' + date.day + ', ' + date.year;
	      }
	
	      if (date.month !== null && date.year !== null && date.month !== '' && date.year !== '') {
	        return months[date.month] + ' ' + date.year;
	      }
	
	      if (date.year !== null && date.year !== '') {
	        return date.year;
	      }
	
	      return 'unspecified';
	    };
	
	    var name = first_name + ' ' + (typeof middle_name !== 'undefined' ? middle_name : '') + ' ' + last_name;
	    var dob = prettyDate({
	      year: birth_year,
	      month: birth_month,
	      day: birth_day
	    });
	    var dod = prettyDate({
	      year: death_year,
	      month: death_month,
	      day: death_day
	    });
	
	    return {
	      name: name,
	      dob: dob,
	      dod: dod,
	      id: id,
	      n: t !== 'Highly Accurate' ? n : false
	    };
	  }
	  return false;
	});
	
	var getSearchOptions = exports.getSearchOptions = (0, _reselect.createSelector)([getGravestones], function (gravestones) {
	  return gravestones.filter(function (g) {
	    return g.lat && g.id && !g.t.includes('Duplicate');
	  }).map(function (g) {
	    return {
	      name: g.searchName,
	      id: g.id
	    };
	  }).sort(function (a, b) {
	    if (a.name < b.name) {
	      return -1;
	    } else if (a.name > b.name) {
	      return 1;
	    }
	    return 0;
	  });
	});
	
	var getGravestonesParsed = exports.getGravestonesParsed = (0, _reselect.createSelector)([getGravestones, getSelectedGravestone, getZoom], function (gravestones, selectedGravestone, zoom) {
	  return gravestones.filter(function (g) {
	    return g.lat && g.id;
	  }).map(function (g) {
	    var death_year = g.dy,
	        id = g.id,
	        t = g.t;
	
	    var radius = 1 - (1 - 0.05) * ((zoom - 15) / (26 - 15));
	    //let radius = 0.3;
	
	
	    var fill = t === 'Highly Accurate' ? '#8D5649' : '#D8241F';
	    if (t === 'Highly Accurate') {
	      if (death_year < 2002 && death_year >= 1980) {
	        fill = '#1b9e77';
	      } else if (death_year < 1980 && death_year >= 1970) {
	        fill = '#d95f02';
	      } else if (death_year < 1970 && death_year >= 1960) {
	        fill = '#7570b3';
	      } else if (death_year < 1960 && death_year >= 1950) {
	        fill = '#e7298a';
	      } else if (death_year < 1950 && death_year >= 1940) {
	        fill = '#66a61e';
	      } else if (death_year < 1940 && death_year >= 1920) {
	        fill = '#e6ab02';
	      } else if (death_year && death_year < 1920) {
	        fill = '#666666';
	      }
	    }
	
	    var fillOpacity = 0.75;
	    var opacity = 1;
	    var weight = 0.5;
	    if (selectedGravestone && id !== selectedGravestone) {
	      fillOpacity = 0.2;
	      opacity = 0.2;
	    }
	    if (selectedGravestone && id === selectedGravestone) {
	      fillOpacity = 0.9;
	      weight = 1.5;
	    }
	
	    return {
	      center: [g.lat, g.lng],
	      radius: radius,
	      opacity: opacity,
	      weight: weight,
	      fill: fill,
	      fillOpacity: fillOpacity,
	      id: g.id,
	      key: 'gravetone-' + g.id + (g.t === 'Duplicate' ? '-duplicate' : '')
	    };
	  });
	});
	
	var showInset = exports.showInset = (0, _reselect.createSelector)([getBounds], function (bounds) {
	  // do a rough calculation to figure out how much of the visible bounds overlaps the rough perimeter of East End
	  var lngMin = -77.39003419876099;
	  var lngMax = -77.38542884588242;
	  var latMin = 37.535295961999424;
	  var latMax = 37.53819278876113;
	  var eeArea = (lngMax - lngMin) * (latMax - latMin);
	
	  var _getNSWE2 = _getNSWE(bounds),
	      n = _getNSWE2.n,
	      s = _getNSWE2.s,
	      e = _getNSWE2.e,
	      w = _getNSWE2.w;
	
	  w = w > lngMin ? w : lngMin;
	  e = e < lngMax ? e : lngMax;
	  n = n < latMax ? n : latMax;
	  s = s > latMin ? s : latMin;
	
	  var overlapArea = (n - s) * (e - w);
	  return overlapArea / eeArea <= 0.7;
	});
	
	function _getNSWE(bounds) {
	  return {
	    n: Math.max(bounds[0][0], bounds[1][0]),
	    s: Math.min(bounds[0][0], bounds[1][0]),
	    e: Math.max(bounds[0][1], bounds[1][1]),
	    w: Math.min(bounds[0][1], bounds[1][1])
	  };
	}

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(25);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _leaflet = __webpack_require__(4);
	
	var _react = __webpack_require__(2);
	
	var MapControl =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(MapControl, _Component);
	
	  function MapControl(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "leafletElement", void 0);
	    _this.leafletElement = _this.createLeafletElement(_this.props);
	    return _this;
	  }
	
	  var _proto = MapControl.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(_props) {
	    throw new Error('createLeafletElement() must be implemented');
	  };
	
	  _proto.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
	    if (toProps.position !== fromProps.position) {
	      this.leafletElement.setPosition(toProps.position);
	    }
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.leafletElement.addTo(this.props.leaflet.map);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    this.updateLeafletElement(prevProps, this.props);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.leafletElement.remove();
	  };
	
	  _proto.render = function render() {
	    return null;
	  };
	
	  return MapControl;
	}(_react.Component);
	
	exports.default = MapControl;

/***/ },
/* 31 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(72);
	var enumBugKeys = __webpack_require__(39);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 33 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 34 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(38);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 36 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = exports.EVENTS_RE = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = __webpack_require__(2);
	
	var EVENTS_RE = /^on(.+)$/i;
	exports.EVENTS_RE = EVENTS_RE;
	
	var MapEvented =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(MapEvented, _Component);
	
	  function MapEvented(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_leafletEvents", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "leafletElement", void 0);
	    _this._leafletEvents = _this.extractLeafletEvents(props);
	    return _this;
	  }
	
	  var _proto = MapEvented.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.bindLeafletEvents(this._leafletEvents);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(_prevProps) {
	    this._leafletEvents = this.bindLeafletEvents(this.extractLeafletEvents(this.props), this._leafletEvents);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    var _this2 = this;
	
	    var el = this.leafletElement;
	    if (!el) return;
	    Object.keys(this._leafletEvents).forEach(function (ev) {
	      el.off(ev, _this2._leafletEvents[ev]);
	    });
	  };
	
	  _proto.extractLeafletEvents = function extractLeafletEvents(props) {
	    return Object.keys(props).reduce(function (res, prop) {
	      if (EVENTS_RE.test(prop)) {
	        if (props[prop] != null) {
	          var _key = prop.replace(EVENTS_RE, function (match, p) {
	            return p.toLowerCase();
	          });
	
	          res[_key] = props[prop];
	        }
	      }
	
	      return res;
	    }, {});
	  };
	
	  _proto.bindLeafletEvents = function bindLeafletEvents(next, prev) {
	    if (next === void 0) {
	      next = {};
	    }
	
	    if (prev === void 0) {
	      prev = {};
	    }
	
	    var el = this.leafletElement;
	    if (el == null || el.on == null) return {};
	    var diff = (0, _extends2.default)({}, prev);
	    Object.keys(prev).forEach(function (ev) {
	      if (next[ev] == null || prev[ev] !== next[ev]) {
	        delete diff[ev];
	        el.off(ev, prev[ev]);
	      }
	    });
	    Object.keys(next).forEach(function (ev) {
	      if (prev[ev] == null || next[ev] !== prev[ev]) {
	        diff[ev] = next[ev];
	        el.on(ev, next[ev]);
	      }
	    });
	    return diff;
	  };
	
	  _proto.fireLeafletEvent = function fireLeafletEvent(type, data) {
	    var el = this.leafletElement;
	    if (el) el.fire(type, data);
	  };
	
	  return MapEvented;
	}(_react.Component);
	
	exports.default = MapEvented;

/***/ },
/* 38 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 39 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 40 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(29);
	var dPs = __webpack_require__(150);
	var enumBugKeys = __webpack_require__(39);
	var IE_PROTO = __webpack_require__(44)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(65)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(144).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 42 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(20).f;
	var has = __webpack_require__(19);
	var TAG = __webpack_require__(27)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(45)('keys');
	var uid = __webpack_require__(36);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(8);
	var global = __webpack_require__(14);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(31) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 46 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(25);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(14);
	var core = __webpack_require__(8);
	var LIBRARY = __webpack_require__(31);
	var wksExt = __webpack_require__(49);
	var defineProperty = __webpack_require__(20).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(27);


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 51 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(193);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _reactDom = __webpack_require__(52);
	
	var _MapComponent2 = _interopRequireDefault(__webpack_require__(55));
	
	var _updateClassName = _interopRequireDefault(__webpack_require__(57));
	
	var DivOverlay =
	/*#__PURE__*/
	function (_MapComponent) {
	  (0, _inheritsLoose2.default)(DivOverlay, _MapComponent);
	
	  function DivOverlay(props) {
	    var _this;
	
	    _this = _MapComponent.call(this, props) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClose", function () {
	      if (_this.props.onClose) {
	        _this.props.onClose();
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onOpen", function () {
	      _this.forceUpdate(); // Re-render now that leafletElement is created
	
	
	      if (_this.props.onOpen) {
	        _this.props.onOpen();
	      }
	    });
	    _this.leafletElement = _this.createLeafletElement(props);
	    return _this;
	  }
	
	  var _proto = DivOverlay.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(_props) {
	    throw new Error('createLeafletElement() must be implemented');
	  };
	
	  _proto.updateLeafletElement = function updateLeafletElement(_prevProps, _props) {};
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    (0, _updateClassName.default)(this.leafletElement._container, prevProps.className, this.props.className);
	    this.updateLeafletElement(prevProps, this.props);
	
	    if (this.leafletElement.isOpen()) {
	      this.leafletElement.update();
	      this.onRender();
	    }
	  };
	
	  _proto.onRender = function onRender() {};
	
	  _proto.render = function render() {
	    if (this.leafletElement._contentNode) {
	      return (0, _reactDom.createPortal)(this.props.children, this.leafletElement._contentNode);
	    }
	
	    return null;
	  };
	
	  return DivOverlay;
	}(_MapComponent2.default);
	
	exports.default = DivOverlay;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _leaflet = __webpack_require__(4);
	
	var _MapLayer2 = _interopRequireDefault(__webpack_require__(21));
	
	var GridLayer =
	/*#__PURE__*/
	function (_MapLayer) {
	  (0, _inheritsLoose2.default)(GridLayer, _MapLayer);
	
	  function GridLayer() {
	    return _MapLayer.apply(this, arguments) || this;
	  }
	
	  var _proto = GridLayer.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    return new _leaflet.GridLayer(this.getOptions(props));
	  };
	
	  _proto.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
	    var opacity = toProps.opacity,
	        zIndex = toProps.zIndex;
	
	    if (opacity !== fromProps.opacity) {
	      this.leafletElement.setOpacity(opacity);
	    }
	
	    if (zIndex !== fromProps.zIndex) {
	      this.leafletElement.setZIndex(zIndex);
	    }
	  };
	
	  _proto.getOptions = function getOptions(props) {
	    var options = _MapLayer.prototype.getOptions.call(this, props);
	
	    return props.leaflet.map == null ? options : // $FlowFixMe: object spread type
	    (0, _extends2.default)({
	      maxZoom: props.leaflet.map.options.maxZoom,
	      minZoom: props.leaflet.map.options.minZoom
	    }, options);
	  };
	
	  _proto.render = function render() {
	    return null;
	  };
	
	  return GridLayer;
	}(_MapLayer2.default);
	
	exports.default = GridLayer;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _MapEvented2 = _interopRequireDefault(__webpack_require__(37));
	
	var MapComponent =
	/*#__PURE__*/
	function (_MapEvented) {
	  (0, _inheritsLoose2.default)(MapComponent, _MapEvented);
	
	  function MapComponent() {
	    return _MapEvented.apply(this, arguments) || this;
	  }
	
	  var _proto = MapComponent.prototype;
	
	  _proto.getOptions = function getOptions(props) {
	    if (props.pane != null) {
	      return props;
	    }
	
	    if (props.leaflet != null && props.leaflet.pane != null) {
	      return (0, _extends2.default)({}, props, {
	        pane: props.leaflet.pane
	      });
	    }
	
	    return props;
	  };
	
	  return MapComponent;
	}(_MapEvented2.default);
	
	exports.default = MapComponent;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(16);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.ControlledLayer = exports.ZoomControl = exports.WMSTileLayer = exports.VideoOverlay = exports.Tooltip = exports.TileLayer = exports.ScaleControl = exports.Rectangle = exports.Popup = exports.Polyline = exports.Polygon = exports.Path = exports.Pane = exports.Marker = exports.MapLayer = exports.MapEvented = exports.MapControl = exports.MapComponent = exports.Map = exports.LayersControl = exports.LayerGroup = exports.ImageOverlay = exports.GridLayer = exports.GeoJSON = exports.FeatureGroup = exports.DivOverlay = exports.CircleMarker = exports.Circle = exports.AttributionControl = exports.useLeaflet = exports.withLeaflet = exports.LeafletProvider = exports.LeafletConsumer = void 0;
	
	var _context = __webpack_require__(5);
	
	exports.LeafletConsumer = _context.LeafletConsumer;
	exports.LeafletProvider = _context.LeafletProvider;
	exports.withLeaflet = _context.withLeaflet;
	exports.useLeaflet = _context.useLeaflet;
	
	var _AttributionControl = _interopRequireDefault(__webpack_require__(196));
	
	exports.AttributionControl = _AttributionControl.default;
	
	var _Circle = _interopRequireDefault(__webpack_require__(197));
	
	exports.Circle = _Circle.default;
	
	var _CircleMarker = _interopRequireDefault(__webpack_require__(198));
	
	exports.CircleMarker = _CircleMarker.default;
	
	var _DivOverlay = _interopRequireDefault(__webpack_require__(53));
	
	exports.DivOverlay = _DivOverlay.default;
	
	var _FeatureGroup = _interopRequireDefault(__webpack_require__(199));
	
	exports.FeatureGroup = _FeatureGroup.default;
	
	var _GeoJSON = _interopRequireDefault(__webpack_require__(200));
	
	exports.GeoJSON = _GeoJSON.default;
	
	var _GridLayer = _interopRequireDefault(__webpack_require__(54));
	
	exports.GridLayer = _GridLayer.default;
	
	var _ImageOverlay = _interopRequireDefault(__webpack_require__(201));
	
	exports.ImageOverlay = _ImageOverlay.default;
	
	var _LayerGroup = _interopRequireDefault(__webpack_require__(202));
	
	exports.LayerGroup = _LayerGroup.default;
	
	var _LayersControl = _interopRequireWildcard(__webpack_require__(203));
	
	exports.LayersControl = _LayersControl.default;
	exports.ControlledLayer = _LayersControl.ControlledLayer;
	
	var _Map = _interopRequireDefault(__webpack_require__(204));
	
	exports.Map = _Map.default;
	
	var _MapComponent = _interopRequireDefault(__webpack_require__(55));
	
	exports.MapComponent = _MapComponent.default;
	
	var _MapControl = _interopRequireDefault(__webpack_require__(30));
	
	exports.MapControl = _MapControl.default;
	
	var _MapEvented = _interopRequireDefault(__webpack_require__(37));
	
	exports.MapEvented = _MapEvented.default;
	
	var _MapLayer = _interopRequireDefault(__webpack_require__(21));
	
	exports.MapLayer = _MapLayer.default;
	
	var _Marker = _interopRequireDefault(__webpack_require__(205));
	
	exports.Marker = _Marker.default;
	
	var _Pane = _interopRequireDefault(__webpack_require__(206));
	
	exports.Pane = _Pane.default;
	
	var _Path = _interopRequireDefault(__webpack_require__(15));
	
	exports.Path = _Path.default;
	
	var _Polygon = _interopRequireDefault(__webpack_require__(207));
	
	exports.Polygon = _Polygon.default;
	
	var _Polyline = _interopRequireDefault(__webpack_require__(208));
	
	exports.Polyline = _Polyline.default;
	
	var _Popup = _interopRequireDefault(__webpack_require__(209));
	
	exports.Popup = _Popup.default;
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(210));
	
	exports.Rectangle = _Rectangle.default;
	
	var _ScaleControl = _interopRequireDefault(__webpack_require__(211));
	
	exports.ScaleControl = _ScaleControl.default;
	
	var _TileLayer = _interopRequireDefault(__webpack_require__(212));
	
	exports.TileLayer = _TileLayer.default;
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(213));
	
	exports.Tooltip = _Tooltip.default;
	
	var _VideoOverlay = _interopRequireDefault(__webpack_require__(214));
	
	exports.VideoOverlay = _VideoOverlay.default;
	
	var _WMSTileLayer = _interopRequireDefault(__webpack_require__(215));
	
	exports.WMSTileLayer = _WMSTileLayer.default;
	
	var _ZoomControl = _interopRequireDefault(__webpack_require__(216));
	
	exports.ZoomControl = _ZoomControl.default;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.removeClassName = exports.addClassName = void 0;
	
	var _leaflet = __webpack_require__(4);
	
	var splitClassName = function splitClassName(className) {
	  if (className === void 0) {
	    className = '';
	  }
	
	  return className.split(' ').filter(Boolean);
	};
	
	var addClassName = function addClassName(container, className) {
	  splitClassName(className).forEach(function (cls) {
	    _leaflet.DomUtil.addClass(container, cls);
	  });
	};
	
	exports.addClassName = addClassName;
	
	var removeClassName = function removeClassName(container, className) {
	  splitClassName(className).forEach(function (cls) {
	    _leaflet.DomUtil.removeClass(container, cls);
	  });
	};
	
	exports.removeClassName = removeClassName;
	
	var _default = function _default(container, prevClassName, nextClassName) {
	  if (container != null && nextClassName !== prevClassName) {
	    if (prevClassName != null && prevClassName.length > 0) {
	      removeClassName(container, prevClassName);
	    }
	
	    if (nextClassName != null && nextClassName.length > 0) {
	      addClassName(container, nextClassName);
	    }
	  }
	};
	
	exports.default = _default;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _batch = __webpack_require__(83);
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  var batch = (0, _batch.getBatch)(); // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	
	  var current = [];
	  var next = [];
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      batch(function () {
	        for (var i = 0; i < listeners.length; i++) {
	          listeners[i]();
	        }
	      });
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription =
	/*#__PURE__*/
	function () {
	  function Subscription(store, parentSub) {
	    this.store = store;
	    this.parentSub = parentSub;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
	  }
	
	  var _proto = Subscription.prototype;
	
	  _proto.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  _proto.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  _proto.handleChangeWrapper = function handleChangeWrapper() {
	    if (this.onStateChange) {
	      this.onStateChange();
	    }
	  };
	
	  _proto.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  _proto.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  _proto.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports["default"] = Subscription;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var $$observable = _interopDefault(__webpack_require__(237));
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var randomString = function randomString() {
	  return Math.random().toString(36).substring(7).split('').join('.');
	};
	
	var ActionTypes = {
	  INIT: "@@redux/INIT" + randomString(),
	  REPLACE: "@@redux/REPLACE" + randomString(),
	  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
	    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
	  }
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = obj;
	
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
	    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
	  }
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	  /**
	   * This makes a shallow copy of currentListeners so we can use
	   * nextListeners as a temporary list while dispatching.
	   *
	   * This prevents any bugs around consumers calling
	   * subscribe/unsubscribe in the middle of a dispatch.
	   */
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	
	
	  function getState() {
	    if (isDispatching) {
	      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	
	
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected the listener to be a function.');
	    }
	
	    if (isDispatching) {
	      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
	    }
	
	    var isSubscribed = true;
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
	      }
	
	      isSubscribed = false;
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	
	
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	
	
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
	    // Any reducers that existed in both the new and old rootReducer
	    // will receive the previous state. This effectively populates
	    // the new state tree with any relevant data from the old one.
	
	    dispatch({
	      type: ActionTypes.REPLACE
	    });
	  }
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	
	
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object' || observer === null) {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  } // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	
	
	  dispatch({
	    type: ActionTypes.INIT
	  });
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	
	}
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
	  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, {
	      type: ActionTypes.INIT
	    });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
	    }
	
	    if (typeof reducer(undefined, {
	      type: ActionTypes.PROBE_UNKNOWN_ACTION()
	    }) === 'undefined') {
	      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
	    }
	  });
	}
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	
	
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning("No reducer provided for key \"" + key + "\"");
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	
	  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
	  // keys multiple times.
	
	  var unexpectedKeyCache;
	
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError;
	
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination(state, action) {
	    if (state === void 0) {
	      state = {};
	    }
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass an action creator as the first argument,
	 * and get a dispatch wrapped function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	
	
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
	  }
	
	  var boundActionCreators = {};
	
	  for (var key in actionCreators) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	
	  return boundActionCreators;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
	  }
	
	  if (enumerableOnly) keys = keys.filter(function (sym) {
	    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	  });
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(source, true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(source).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      var store = createStore.apply(void 0, arguments);
	
	      var _dispatch = function dispatch() {
	        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(void 0, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(void 0, chain)(store.dispatch);
	      return _objectSpread2({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	/*
	 * This is a dummy function to check if the function name has been altered by minification.
	 * If the function has been minified and NODE_ENV !== 'production', warn the user.
	 */
	
	function isCrushed() {}
	
	if (false) {
	  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;
	exports.applyMiddleware = applyMiddleware;
	exports.bindActionCreators = bindActionCreators;
	exports.combineReducers = combineReducers;
	exports.compose = compose;
	exports.createStore = createStore;


/***/ },
/* 60 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionTypes = {
	  LOAD_GRAVESTONES: 'LOAD_GRAVESTONES',
	  SELECT_GRAVESTONE: 'SELECT_GRAVESTONE',
	  CHANGE_CENTER_AND_ZOOM: 'CHANGE_CENTER_AND_ZOOM',
	  CHANGE_BOUNDS: 'CHANGE_BOUNDS',
	  TOGGLE_ABOUT: 'TOGGLE_ABOUT',
	  TOGGLE_CONTACT_US: 'TOGGLE_CONTACT_US',
	  LOCATED_USER: 'LOCATED_USER',
	  ZOOM_TO_HEADSTONE: 'ZOOM_TO_HEADSTONE',
	  TOGGLE_HILLSHADE: 'TOGGLE_HILLSHADE'
	};
	
	exports.default = actionTypes;

/***/ },
/* 61 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var hash = window.location.hash;
	
	var hashValues = {};
	hash.replace(/^#\/?|\/$/g, '').split('&').forEach(function (pair) {
	  var _pair$split = pair.split('='),
	      _pair$split2 = _slicedToArray(_pair$split, 2),
	      key = _pair$split2[0],
	      value = _pair$split2[1];
	
	  hashValues[key] = value;
	});
	
	var zoom = 17;
	var lat = 37.53668110395066;
	var lng = -77.38776039797814;
	if (hashValues.loc) {
	  var _hashValues$loc$split = hashValues.loc.split('/').map(function (str) {
	    return parseFloat(str);
	  });
	
	  var _hashValues$loc$split2 = _slicedToArray(_hashValues$loc$split, 3);
	
	  zoom = _hashValues$loc$split2[0];
	  lat = _hashValues$loc$split2[1];
	  lng = _hashValues$loc$split2[2];
	}
	
	exports.default = {
	  selectedGravestone: hashValues.selectedGravestone ? parseInt(hashValues.selectedGravestone, 10) : null,
	  gravestones: [],
	  zoom: zoom,
	  center: [lat, lng],
	  bounds: [[37.53959224331248, -77.38536715507509], [37.53376455436679, -77.39015221595766]],
	  aboutOpen: false,
	  contactUsOpen: false,
	  userLocation: null,
	  hillshadeOn: false
	};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(126);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(125);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 63 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(140);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(25);
	var document = __webpack_require__(14).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(13) && !__webpack_require__(23)(function () {
	  return Object.defineProperty(__webpack_require__(65)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(63);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(31);
	var $export = __webpack_require__(18);
	var redefine = __webpack_require__(73);
	var hide = __webpack_require__(24);
	var Iterators = __webpack_require__(40);
	var $iterCreate = __webpack_require__(146);
	var setToStringTag = __webpack_require__(43);
	var getPrototypeOf = __webpack_require__(71);
	var ITERATOR = __webpack_require__(27)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(33);
	var createDesc = __webpack_require__(34);
	var toIObject = __webpack_require__(26);
	var toPrimitive = __webpack_require__(47);
	var has = __webpack_require__(19);
	var IE8_DOM_DEFINE = __webpack_require__(66);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(13) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(72);
	var hiddenKeys = __webpack_require__(39).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(19);
	var toObject = __webpack_require__(35);
	var IE_PROTO = __webpack_require__(44)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(19);
	var toIObject = __webpack_require__(26);
	var arrayIndexOf = __webpack_require__(142)(false);
	var IE_PROTO = __webpack_require__(44)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(24);


/***/ },
/* 74 */
/***/ function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	
	module.exports = function equal(a, b) {
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (!equal(a[key], b[key])) return false;
	    }
	
	    return true;
	  }
	
	  return a!==a && b!==b;
	};


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var ReactIs = __webpack_require__(77);
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextType: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromError: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var FORWARD_REF_STATICS = {
	    '$$typeof': true,
	    render: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true
	};
	
	var MEMO_STATICS = {
	    '$$typeof': true,
	    compare: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true,
	    type: true
	};
	
	var TYPE_STATICS = {};
	TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;
	
	function getStatics(component) {
	    if (ReactIs.isMemo(component)) {
	        return MEMO_STATICS;
	    }
	    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') {
	        // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        var targetStatics = getStatics(targetComponent);
	        var sourceStatics = getStatics(sourceComponent);
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try {
	                    // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(88);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(195);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 78 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = omit;
	
	function omit(obj) {
	  for (var _len = arguments.length, keysToOmit = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    keysToOmit[_key - 1] = arguments[_key];
	  }
	
	  return Object.keys(obj).reduce(function (acc, key) {
	    if (keysToOmit.indexOf(key) === -1) {
	      acc[key] = obj[key];
	    }
	
	    return acc;
	  }, {});
	}

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(16);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = connectAdvanced;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(17));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(75));
	
	var _invariant = _interopRequireDefault(__webpack_require__(50));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(77);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(58));
	
	var _Context = __webpack_require__(22);
	
	// Define some constant arrays just to avoid re-creating these
	var EMPTY_ARRAY = [];
	var NO_SUBSCRIPTION_ARRAY = [null, null];
	
	var stringifyComponent = function stringifyComponent(Comp) {
	  try {
	    return JSON.stringify(Comp);
	  } catch (err) {
	    return String(Comp);
	  }
	};
	
	function storeStateUpdatesReducer(state, action) {
	  var updateCount = state[1];
	  return [action.payload, updateCount + 1];
	}
	
	var initStateUpdates = function initStateUpdates() {
	  return [null, 0];
	}; // React currently throws a warning when using useLayoutEffect on the server.
	// To get around it, we can conditionally useEffect on the server (no-op) and
	// useLayoutEffect in the browser. We need useLayoutEffect because we want
	// `connect` to perform sync updates to a ref to save the latest props after
	// a render is actually committed to the DOM.
	
	
	var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      _ref2$forwardRef = _ref2.forwardRef,
	      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === void 0 ? _Context.ReactReduxContext : _ref2$context,
	      connectOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);
	  (0, _invariant["default"])(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
	  (0, _invariant["default"])(!withRef, 'withRef is removed. To access the wrapped instance, use a ref on the connected component');
	  var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
	  (0, _invariant["default"])(storeKey === 'store', 'storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
	  var Context = context;
	  return function wrapWithConnect(WrappedComponent) {
	    if (false) {
	      (0, _invariant["default"])((0, _reactIs.isValidElementType)(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
	    }
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2["default"])({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	    var pure = connectOptions.pure;
	
	    function createChildSelector(store) {
	      return selectorFactory(store.dispatch, selectorFactoryOptions);
	    } // If we aren't running in "pure" mode, we don't want to memoize values.
	    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
	    // that just executes the given callback immediately.
	
	
	    var usePureOnlyMemo = pure ? _react.useMemo : function (callback) {
	      return callback();
	    };
	
	    function ConnectFunction(props) {
	      var _useMemo = (0, _react.useMemo)(function () {
	        // Distinguish between actual "data" props that were passed to the wrapper component,
	        // and values needed to control behavior (forwarded refs, alternate context instances).
	        // To maintain the wrapperProps object reference, memoize this destructuring.
	        var forwardedRef = props.forwardedRef,
	            wrapperProps = (0, _objectWithoutPropertiesLoose2["default"])(props, ["forwardedRef"]);
	        return [props.context, forwardedRef, wrapperProps];
	      }, [props]),
	          propsContext = _useMemo[0],
	          forwardedRef = _useMemo[1],
	          wrapperProps = _useMemo[2];
	
	      var ContextToUse = (0, _react.useMemo)(function () {
	        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
	        // Memoize the check that determines which context instance we should use.
	        return propsContext && propsContext.Consumer && (0, _reactIs.isContextConsumer)(_react["default"].createElement(propsContext.Consumer, null)) ? propsContext : Context;
	      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available
	
	      var contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context
	
	      var didStoreComeFromProps = Boolean(props.store);
	      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
	      (0, _invariant["default"])(didStoreComeFromProps || didStoreComeFromContext, "Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
	      var store = props.store || contextValue.store;
	      var childPropsSelector = (0, _react.useMemo)(function () {
	        // The child props selector needs the store reference as an input.
	        // Re-create this selector whenever the store changes.
	        return createChildSelector(store);
	      }, [store]);
	
	      var _useMemo2 = (0, _react.useMemo)(function () {
	        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        var subscription = new _Subscription["default"](store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `subscription` will then be null. This can
	        // probably be avoided if Subscription's listeners logic is changed to not call listeners
	        // that have been unsubscribed in the  middle of the notification loop.
	
	        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
	        return [subscription, notifyNestedSubs];
	      }, [store, didStoreComeFromProps, contextValue]),
	          subscription = _useMemo2[0],
	          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
	      // and memoize that value to avoid unnecessary context updates.
	
	
	      var overriddenContextValue = (0, _react.useMemo)(function () {
	        if (didStoreComeFromProps) {
	          // This component is directly subscribed to a store from props.
	          // We don't want descendants reading from this store - pass down whatever
	          // the existing context value is from the nearest connected ancestor.
	          return contextValue;
	        } // Otherwise, put this component's subscription instance into context, so that
	        // connected descendants won't update until after this component is done
	
	
	        return (0, _extends2["default"])({}, contextValue, {
	          subscription: subscription
	        });
	      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
	      // causes a change to the calculated child component props (or we caught an error in mapState)
	
	      var _useReducer = (0, _react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
	          _useReducer$ = _useReducer[0],
	          previousStateUpdateResult = _useReducer$[0],
	          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
	
	
	      if (previousStateUpdateResult && previousStateUpdateResult.error) {
	        throw previousStateUpdateResult.error;
	      } // Set up refs to coordinate values between the subscription effect and the render logic
	
	
	      var lastChildProps = (0, _react.useRef)();
	      var lastWrapperProps = (0, _react.useRef)(wrapperProps);
	      var childPropsFromStoreUpdate = (0, _react.useRef)();
	      var renderIsScheduled = (0, _react.useRef)(false);
	      var actualChildProps = usePureOnlyMemo(function () {
	        // Tricky logic here:
	        // - This render may have been triggered by a Redux store update that produced new child props
	        // - However, we may have gotten new wrapper props after that
	        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
	        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
	        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
	        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
	          return childPropsFromStoreUpdate.current;
	        } // TODO We're reading the store directly in render() here. Bad idea?
	        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
	        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
	        // to determine what the child props should be.
	
	
	        return childPropsSelector(store.getState(), wrapperProps);
	      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
	      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
	      // just useEffect instead to avoid the warning, since neither will run anyway.
	
	      useIsomorphicLayoutEffect(function () {
	        // We want to capture the wrapper props and child props we used for later comparisons
	        lastWrapperProps.current = wrapperProps;
	        lastChildProps.current = actualChildProps;
	        renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
	
	        if (childPropsFromStoreUpdate.current) {
	          childPropsFromStoreUpdate.current = null;
	          notifyNestedSubs();
	        }
	      }); // Our re-subscribe logic only runs when the store/subscription setup changes
	
	      useIsomorphicLayoutEffect(function () {
	        // If we're not subscribed to the store, nothing to do here
	        if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
	
	        var didUnsubscribe = false;
	        var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
	
	        var checkForUpdates = function checkForUpdates() {
	          if (didUnsubscribe) {
	            // Don't run stale listeners.
	            // Redux doesn't guarantee unsubscriptions happen until next dispatch.
	            return;
	          }
	
	          var latestStoreState = store.getState();
	          var newChildProps, error;
	
	          try {
	            // Actually run the selector with the most recent store state and wrapper props
	            // to determine what the child props should be
	            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
	          } catch (e) {
	            error = e;
	            lastThrownError = e;
	          }
	
	          if (!error) {
	            lastThrownError = null;
	          } // If the child props haven't changed, nothing to do here - cascade the subscription update
	
	
	          if (newChildProps === lastChildProps.current) {
	            if (!renderIsScheduled.current) {
	              notifyNestedSubs();
	            }
	          } else {
	            // Save references to the new child props.  Note that we track the "child props from store update"
	            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
	            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
	            // forcing another re-render, which we don't want.
	            lastChildProps.current = newChildProps;
	            childPropsFromStoreUpdate.current = newChildProps;
	            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
	
	            forceComponentUpdateDispatch({
	              type: 'STORE_UPDATED',
	              payload: {
	                latestStoreState: latestStoreState,
	                error: error
	              }
	            });
	          }
	        }; // Actually subscribe to the nearest connected ancestor (or store)
	
	
	        subscription.onStateChange = checkForUpdates;
	        subscription.trySubscribe(); // Pull data from the store after first render in case the store has
	        // changed since we began.
	
	        checkForUpdates();
	
	        var unsubscribeWrapper = function unsubscribeWrapper() {
	          didUnsubscribe = true;
	          subscription.tryUnsubscribe();
	          subscription.onStateChange = null;
	
	          if (lastThrownError) {
	            // It's possible that we caught an error due to a bad mapState function, but the
	            // parent re-rendered without this component and we're about to unmount.
	            // This shouldn't happen as long as we do top-down subscriptions correctly, but
	            // if we ever do those wrong, this throw will surface the error in our tests.
	            // In that case, throw the error from here so it doesn't get lost.
	            throw lastThrownError;
	          }
	        };
	
	        return unsubscribeWrapper;
	      }, [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
	      // We memoize the elements for the rendered child component as an optimization.
	
	      var renderedWrappedComponent = (0, _react.useMemo)(function () {
	        return _react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, actualChildProps, {
	          ref: forwardedRef
	        }));
	      }, [forwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
	      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
	
	      var renderedChild = (0, _react.useMemo)(function () {
	        if (shouldHandleStateChanges) {
	          // If this component is subscribed to store updates, we need to pass its own
	          // subscription instance down to our descendants. That means rendering the same
	          // Context instance, and putting a different value into the context.
	          return _react["default"].createElement(ContextToUse.Provider, {
	            value: overriddenContextValue
	          }, renderedWrappedComponent);
	        }
	
	        return renderedWrappedComponent;
	      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
	      return renderedChild;
	    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
	
	
	    var Connect = pure ? _react["default"].memo(ConnectFunction) : ConnectFunction;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	
	    if (forwardRef) {
	      var forwarded = _react["default"].forwardRef(function forwardConnectRef(props, ref) {
	        return _react["default"].createElement(Connect, (0, _extends2["default"])({}, props, {
	          forwardedRef: ref
	        }));
	      });
	
	      forwarded.displayName = displayName;
	      forwarded.WrappedComponent = WrappedComponent;
	      return (0, _hoistNonReactStatics["default"])(forwarded, WrappedComponent);
	    }
	
	    return (0, _hoistNonReactStatics["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(85));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	//
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	//
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject["default"])(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.useReduxContext = useReduxContext;
	
	var _react = __webpack_require__(2);
	
	var _invariant = _interopRequireDefault(__webpack_require__(50));
	
	var _Context = __webpack_require__(22);
	
	/**
	 * A hook to access the value of the `ReactReduxContext`. This is a low-level
	 * hook that you should usually not need to call directly.
	 *
	 * @returns {any} the value of the `ReactReduxContext`
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useReduxContext } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const { store } = useReduxContext()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	function useReduxContext() {
	  var contextValue = (0, _react.useContext)(_Context.ReactReduxContext);
	  (0, _invariant["default"])(contextValue, 'could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
	  return contextValue;
	}

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createStoreHook = createStoreHook;
	exports.useStore = void 0;
	
	var _react = __webpack_require__(2);
	
	var _Context = __webpack_require__(22);
	
	var _useReduxContext2 = __webpack_require__(81);
	
	/**
	 * Hook factory, which creates a `useStore` hook bound to a given context.
	 *
	 * @param {Function} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useStore` hook bound to the specified context.
	 */
	function createStoreHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useStore() {
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store;
	
	    return store;
	  };
	}
	/**
	 * A hook to access the redux store.
	 *
	 * @returns {any} the redux store
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useStore } from 'react-redux'
	 *
	 * export const ExampleComponent = () => {
	 *   const store = useStore()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	
	
	var useStore = createStoreHook();
	exports.useStore = useStore;

/***/ },
/* 83 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.getBatch = exports.setBatch = void 0;
	
	// Default to a dummy "batch" implementation that just runs the callback
	function defaultNoopBatch(callback) {
	  callback();
	}
	
	var batch = defaultNoopBatch; // Allow injecting another batching function later
	
	var setBatch = function setBatch(newBatch) {
	  return batch = newBatch;
	}; // Supply a getter just to skip dealing with ESM bindings
	
	
	exports.setBatch = setBatch;
	
	var getBatch = function getBatch() {
	  return batch;
	};
	
	exports.getBatch = getBatch;

/***/ },
/* 84 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(227));
	
	var _warning = _interopRequireDefault(__webpack_require__(86));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject["default"])(value)) {
	    (0, _warning["default"])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ },
/* 86 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ },
/* 87 */
/***/ function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;

/***/ },
/* 88 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(7);
	
	var _App = __webpack_require__(90);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _actions = __webpack_require__(11);
	
	var _selectors = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    selectedGravestone: state.selectedGravestone,
	    aboutOpen: state.aboutOpen,
	    contactUsOpen: state.contactUsOpen,
	    showInset: (0, _selectors.showInset)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    loadGravestones: function loadGravestones() {
	      return dispatch((0, _actions.loadGravestones)());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_App2.default);

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Masthead = __webpack_require__(107);
	
	var _Masthead2 = _interopRequireDefault(_Masthead);
	
	var _Search = __webpack_require__(109);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Headstone = __webpack_require__(97);
	
	var _Headstone2 = _interopRequireDefault(_Headstone);
	
	var _Map = __webpack_require__(105);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _InsetMap = __webpack_require__(102);
	
	var _InsetMap2 = _interopRequireDefault(_InsetMap);
	
	var _About = __webpack_require__(91);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _ContactUs = __webpack_require__(93);
	
	var _ContactUs2 = _interopRequireDefault(_ContactUs);
	
	var _Legend = __webpack_require__(104);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Footer = __webpack_require__(95);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Welcome = __webpack_require__(111);
	
	var _Welcome2 = _interopRequireDefault(_Welcome);
	
	var _Icons = __webpack_require__(101);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	var _HillshadeToggle = __webpack_require__(99);
	
	var _HillshadeToggle2 = _interopRequireDefault(_HillshadeToggle);
	
	__webpack_require__(169);
	
	__webpack_require__(170);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var App = function App(props) {
	  props.loadGravestones();
	
	  var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
	
	  return _react2.default.createElement(
	    'div',
	    { className: iOS ? 'App ios' : 'App' },
	    _react2.default.createElement(_Welcome2.default, null),
	    _react2.default.createElement(_Masthead2.default, null),
	    props.aboutOpen && _react2.default.createElement(_About2.default, null),
	    props.contactUsOpen && _react2.default.createElement(_ContactUs2.default, null),
	    !props.aboutOpen && !props.contactUsOpen && _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(_Map2.default, null),
	      _react2.default.createElement(_Legend2.default, null),
	      props.selectedGravestone ? _react2.default.createElement(_Headstone2.default, null) : _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_Search2.default, null),
	        _react2.default.createElement(_HillshadeToggle2.default, null)
	      ),
	      props.showInset && _react2.default.createElement(_InsetMap2.default, null)
	    ),
	    _react2.default.createElement(_Icons2.default, null),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = App;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(7);
	
	var _About = __webpack_require__(92);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _actions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = {
	  toggleAbout: _actions.toggleAbout
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_About2.default);

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About(_ref) {
	  var toggleAbout = _ref.toggleAbout;
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'about' },
	    _react2.default.createElement(
	      'button',
	      {
	        onClick: toggleAbout,
	        className: 'close'
	      },
	      'x'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This map was created by the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://engage.richmond.edu/cbl/faculty-fellowships/east-end-cemetery-collaboratory.html', target: '_blank' },
	        'East End Cemetery Collaboratory'
	      ),
	      ', a partnership of the University of Richmond, Virginia Commonwealth University, and the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://friendsofeastend.com/', target: '_blank' },
	        'Friends of East End Cemetery'
	      ),
	      '. The Collaboratory brings together university faculty and community members to document and curate African American history and culture in Richmond through cemetery restoration and research.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The digital infrastructure for the map was built by Robert K. Nelson and Justin Madron/UR ',
	      _react2.default.createElement(
	        'a',
	        { href: '//dsl.richmond.edu/', target: '_blank' },
	        'Digital Scholarship Lab'
	      ),
	      ', Stephanie Spera/UR ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://geography.richmond.edu/', target: '_blank' },
	        'Department of Geography and the Environment'
	      ),
	      ', and Beth Zizzamia and Taylor Holden/UR ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://geography.richmond.edu/spatial-analysis-lab/index.html', target: '_blank' },
	        'Spatial Analysis Lab'
	      ),
	      '. The hillshade layer (not operable on mobile devices) was created by UR student Matt Franklin and Steph Spera using a digital surface model, which highlights depressions identified from small changes in elevation across the cemetery.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Data was collected by John Shuck, Erin Hollaway Palmer, and Melissa Pocock/Friends of East End Cemetery, Kristine Grayson and Elizabeth Baughan/University of Richmond, and hundreds of students and volunteers across departments and institutions.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Support for the Collaboratory is provided by UR\u2019s ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://engage.richmond.edu/', target: '_blank' },
	        'Bonner Center for Civic Engagement'
	      ),
	      ', VCU\u2019s ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://community.vcu.edu/', target: '_blank' },
	        'Center for Community Engagement and Impact'
	      ),
	      ', the UR ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://as.richmond.edu/about-school/programs/community/themed-years/2019-2020-This-Ground/index.html', target: '_blank' },
	        'School of Arts & Sciences Contested Spaces theme year'
	      ),
	      ' and the UR ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://provost.richmond.edu/academic-initiatives/cie.html', target: '_blank' },
	        'Creativity, Innovation, and Entrepreneurship (CIE) Initiative'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'figure',
	      null,
	      _react2.default.createElement('img', { src: 'static/20200416_East_End_Cemetery_120871.jpg', alt: 'East End' }),
	      _react2.default.createElement(
	        'figcaption',
	        null,
	        'East End Cemetery, 16 April 2020; photograph by Brian Palmer/',
	        _react2.default.createElement(
	          'a',
	          { href: 'brianpalmer.photos', target: '_blank' },
	          'brianpalmer.photos'
	        )
	      )
	    )
	  );
	};
	
	exports.default = About;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(7);
	
	var _ContactUs = __webpack_require__(94);
	
	var _ContactUs2 = _interopRequireDefault(_ContactUs);
	
	var _actions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = {
	  toggleContactUs: _actions.toggleContactUs
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ContactUs2.default);

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactUs = function ContactUs(_ref) {
	  var toggleContactUs = _ref.toggleContactUs;
	
	
	  var handleSubmit = function handleSubmit(evt) {
	    evt.preventDefault();
	
	    var xhr = new XMLHttpRequest(),
	        params = [encodeURIComponent('Form_ID') + '=' + encodeURIComponent('eastend_contact_us'), encodeURIComponent('Owner_ID') + '=' + encodeURIComponent('rnelson2'), encodeURIComponent('send_submit') + '=' + encodeURIComponent('data'), encodeURIComponent('send_submit_to') + '=' + encodeURIComponent('rnelson2, jkeefer, ebaughan'), encodeURIComponent('project') + '=' + encodeURIComponent('eastend_contact_form'), encodeURIComponent('name') + '=' + encodeURIComponent(evt.target.name.value), encodeURIComponent('email') + '=' + encodeURIComponent(evt.target.email.value), encodeURIComponent('message') + '=' + encodeURIComponent(evt.target.message.value)].join('&');
	
	    xhr.onreadystatechange = function () {
	      if (xhr.readyState === 4 && xhr.status === 200) {
	        document.getElementsByClassName("contactUsForm")[0].innerHTML = "<p>We have received your message. Thank you for contacting us.</p>";
	      }
	    };
	
	    xhr.open("POST", 'https://webapps.richmond.edu/URPoster/URPoster.php');
	    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	    xhr.send(params);
	
	    return false;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'contactUs' },
	    _react2.default.createElement(
	      'button',
	      {
	        onClick: toggleContactUs,
	        className: 'close'
	      },
	      'x'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Contact Us'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'contactUsForm' },
	      _react2.default.createElement(
	        'form',
	        { name: 'eastend_contact_us', onSubmit: handleSubmit },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'name' },
	          'Name'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('input', { type: 'text', maxLength: 50, name: 'name' })
	        ),
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'email' },
	          'Email'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('input', { type: 'text', maxLength: 50, name: 'email' })
	        ),
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'email' },
	          'Message'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('textarea', { name: 'message' })
	        ),
	        _react2.default.createElement('input', { type: 'submit' })
	      )
	    )
	  );
	};
	
	exports.default = ContactUs;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(7);
	
	var _Footer = __webpack_require__(96);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _actions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = {
	  toggleAbout: _actions.toggleAbout,
	  toggleContactUs: _actions.toggleContactUs
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Footer2.default);

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(_ref) {
	  var toggleAbout = _ref.toggleAbout,
	      toggleContactUs = _ref.toggleContactUs;
	
	  return _react2.default.createElement(
	    'footer',
	    null,
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        {
	          onClick: toggleAbout
	        },
	        'About the map'
	      ),
	      _react2.default.createElement(
	        'li',
	        {
	          onClick: toggleContactUs
	        },
	        'Contact us'
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	
	
	Footer.propTypes = {
	  aboutOpen: _propTypes2.default.bool,
	  toggleAbout: _propTypes2.default.func
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(7);
	
	var _Headstone = __webpack_require__(98);
	
	var _Headstone2 = _interopRequireDefault(_Headstone);
	
	var _selectors = __webpack_require__(28);
	
	var _actions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return Object.assign({}, (0, _selectors.getSelectedInfo)(state));
	};
	
	var mapDispatchToProps = {
	  unselectGravestone: _actions.unselectGravestone
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Headstone2.default);

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ZoomToButton = __webpack_require__(112);
	
	var _ZoomToButton2 = _interopRequireDefault(_ZoomToButton);
	
	__webpack_require__(174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var gravestone = function gravestone(_ref) {
	  var name = _ref.name,
	      dob = _ref.dob,
	      dod = _ref.dod,
	      id = _ref.id,
	      unselectGravestone = _ref.unselectGravestone,
	      n = _ref.n;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      id: 'headstoneInfo'
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'overflowContainer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'buttons' },
	        _react2.default.createElement(_ZoomToButton2.default, null),
	        _react2.default.createElement(
	          'button',
	          {
	            onClick: unselectGravestone,
	            className: 'close'
	          },
	          _react2.default.createElement(
	            'svg',
	            {
	              width: 25,
	              height: 25
	            },
	            _react2.default.createElement(
	              'g',
	              { transform: 'rotate(45 12.5 12.5)' },
	              _react2.default.createElement('line', {
	                x1: '15%',
	                x2: '85%',
	                y1: '50%',
	                y2: '50%',
	                strokeWidth: '7.5%',
	                stroke: '#262626'
	              }),
	              _react2.default.createElement('line', {
	                x1: '50%',
	                x2: '50%',
	                y1: '15%',
	                y2: '85%',
	                strokeWidth: '7.5%',
	                stroke: '#262626'
	              })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        name
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'lifespan' },
	        dob + ' - ' + dod
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'findAGrave' },
	        'A photo of the grave marker and more information is available on the ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.findagrave.com/memorial/' + id, target: '_blank', rel: 'noopener noreferrer' },
	          'Find A Grave'
	        ),
	        ' website.'
	      ),
	      n && _react2.default.createElement(
	        'p',
	        null,
	        n
	      )
	    )
	  );
	};
	
	exports.default = gravestone;
	
	
	gravestone.propTypes = {
	  name: _propTypes2.default.string,
	  dob: _propTypes2.default.string,
	  dod: _propTypes2.default.string,
	  id: _propTypes2.default.number,
	  unselectGravestone: _propTypes2.default.func
	};
	
	gravestone.defaultProps = {};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(7);
	
	var _HillshadeToggle = __webpack_require__(100);
	
	var _HillshadeToggle2 = _interopRequireDefault(_HillshadeToggle);
	
	var _actions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    hillshadeOn: state.hillshadeOn
	  };
	};
	
	var mapDispatchToProps = {
	  toggleHillshade: _actions.toggleHillshade
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_HillshadeToggle2.default);

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HillshadeToggle = function HillshadeToggle(_ref) {
	  var hillshadeOn = _ref.hillshadeOn,
	      toggleHillshade = _ref.toggleHillshade;
	
	  return _react2.default.createElement(
	    'button',
	    {
	      onClick: toggleHillshade,
	      className: 'hillshadeToggle'
	    },
	    hillshadeOn ? 'Hide hillshade layer' : 'Show hillshade layer'
	  );
	};
	
	exports.default = HillshadeToggle;
	
	
	HillshadeToggle.propTypes = {
	  hillshadeOn: _propTypes2.default.bool.isRequired,
	  toggleHillshade: _propTypes2.default.func.isRequired
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _foee = __webpack_require__(241);
	
	var _foee2 = _interopRequireDefault(_foee);
	
	var _FOEESmallWhite = __webpack_require__(240);
	
	var _FOEESmallWhite2 = _interopRequireDefault(_FOEESmallWhite);
	
	var _shield_ur = __webpack_require__(184);
	
	var _shield_ur2 = _interopRequireDefault(_shield_ur);
	
	var _vcuMobile = __webpack_require__(242);
	
	var _vcuMobile2 = _interopRequireDefault(_vcuMobile);
	
	__webpack_require__(176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Icons = function Icons() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'icons' },
	    _react2.default.createElement(
	      'a',
	      {
	        href: 'https://www.richmond.edu/',
	        target: '_blank'
	      },
	      _react2.default.createElement('img', { src: _shield_ur2.default, alt: 'University of Richmond Shield' })
	    ),
	    _react2.default.createElement(
	      'a',
	      {
	        href: 'https://www.vcu.edu/',
	        target: '_blank'
	      },
	      _react2.default.createElement('img', { src: _vcuMobile2.default, alt: 'Virginia Commonwealth University Seal' })
	    ),
	    _react2.default.createElement(
	      'a',
	      {
	        href: 'https://friendsofeastend.com/',
	        target: '_blank'
	      },
	      _react2.default.createElement('img', { src: _foee2.default, alt: 'Friends of East End Logo', className: 'foeeblack' }),
	      _react2.default.createElement('img', { src: _FOEESmallWhite2.default, alt: 'Friends of East End Logo', className: 'foeewhite' })
	    )
	  );
	};
	
	exports.default = Icons;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(7);
	
	var _InsetMap = __webpack_require__(103);
	
	var _InsetMap2 = _interopRequireDefault(_InsetMap);
	
	var _selectors = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    bounds: state.bounds,
	    perimeter: (0, _selectors.getPerimeter)()
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(_InsetMap2.default);

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLeaflet = __webpack_require__(56);
	
	__webpack_require__(177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InsetMap = function InsetMap(_ref) {
	  var perimeter = _ref.perimeter,
	      bounds = _ref.bounds;
	
	  return _react2.default.createElement(
	    _reactLeaflet.Map,
	    {
	      id: 'inset_map',
	      zoom: 15,
	      center: [37.53668110395066, -77.38776039797814],
	      maxZoom: 24,
	      minZoom: 13,
	      zoomControl: false,
	      attributionControl: false
	    },
	    _react2.default.createElement(_reactLeaflet.TileLayer, {
	      url: '//s3.amazonaws.com/dsl-general/eastend2020/{z}/{x}/{y}.png',
	      maxNativeZoom: 25,
	      maxZoom: 25,
	      detectRetina: true
	    }),
	    _react2.default.createElement(_reactLeaflet.GeoJSON, {
	      data: perimeter,
	      color: 'silver',
	      weight: 0.5,
	      fillColor: 'silver',
	      fillOpacity: 1,
	      className: 'perimeter'
	    }),
	    _react2.default.createElement(_reactLeaflet.Rectangle, {
	      bounds: bounds,
	      color: '#262626',
	      weight: 2
	    })
	  );
	};
	
	exports.default = InsetMap;
	
	
	InsetMap.propTypes = {
	  bounds: _propTypes2.default.arrayOf(_propTypes2.default.array),
	  perimeter: _propTypes2.default.object
	};
	
	InsetMap.defaultProps = {};

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	__webpack_require__(178);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Legend = function Legend() {
	  var colors = [{
	    deathLabel: '1980-2002',
	    color: '#1b9e77'
	  }, {
	    deathLabel: '1970-1980',
	    color: '#d95f02'
	  }, {
	    deathLabel: '1960-1970',
	    color: '#7570b3'
	  }, {
	    deathLabel: '1950-1960',
	    color: '#e7298a'
	  }, {
	    deathLabel: '1940-1950',
	    color: '#66a61e'
	  }, {
	    deathLabel: '1920-1940',
	    color: '#e6ab02'
	  }, {
	    deathLabel: 'before 1920',
	    color: '#666666'
	  }, {
	    deathLabel: 'unknown date',
	    color: '#8D5649'
	  }, {
	    deathLabel: 'uncertain location',
	    color: '#D8241F'
	  }];
	
	  return React.createElement(
	    'div',
	    { id: 'legend' },
	    'Date of death',
	    React.createElement('br', null),
	    colors.reverse().map(function (d) {
	      return React.createElement(
	        'div',
	        {
	          key: d.deathLabel
	        },
	        React.createElement(
	          'svg',
	          {
	            width: 16,
	            height: 12
	          },
	          React.createElement('circle', {
	            cx: 6,
	            cy: 6,
	            r: 5,
	            stroke: 'black',
	            fill: d.color
	          })
	        ),
	        d.deathLabel
	      );
	    })
	  );
	};
	
	exports.default = Legend;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(7);
	
	var _Map = __webpack_require__(106);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _actions = __webpack_require__(11);
	
	var _selectors = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var zoom = state.zoom,
	      center = state.center,
	      bounds = state.bounds,
	      selectedGravestone = state.selectedGravestone,
	      userLocation = state.userLocation;
	
	  return {
	    gravestones: (0, _selectors.getGravestonesParsed)(state),
	    selectedGravestone: selectedGravestone,
	    zoom: zoom,
	    center: center,
	    bounds: bounds,
	    perimeter: (0, _selectors.getPerimeter)(),
	    userLocation: userLocation,
	    showInset: (0, _selectors.showInset)(state),
	    hillshadeOn: state.hillshadeOn
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    selectGravestone: _actions.selectGravestone,
	    changeCenterAndZoom: _actions.changeCenterAndZoom,
	    changeBounds: _actions.changeBounds,
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Map2.default);

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ReactLeafletLocate = __webpack_require__(108);
	
	var _ReactLeafletLocate2 = _interopRequireDefault(_ReactLeafletLocate);
	
	__webpack_require__(179);
	
	var _leaflet = __webpack_require__(4);
	
	var L = _interopRequireWildcard(_leaflet);
	
	var _reactLeaflet = __webpack_require__(56);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//export default class TheMap extends React.Component {
	var TheMap = function TheMap(_ref) {
	  var zoom = _ref.zoom,
	      center = _ref.center,
	      bounds = _ref.bounds,
	      gravestones = _ref.gravestones,
	      userLocation = _ref.userLocation,
	      icon = _ref.icon,
	      hillshadeOn = _ref.hillshadeOn,
	      perimeter = _ref.perimeter,
	      selectedGravestone = _ref.selectedGravestone,
	      dispatch = _ref.dispatch,
	      changeCenterAndZoom = _ref.changeCenterAndZoom,
	      changeBounds = _ref.changeBounds,
	      selectGravestone = _ref.selectGravestone;
	
	  var theRef = (0, _react.useRef)(null);
	
	  var onMapMoved = function onMapMoved() {
	    var theMap = theRef.current.leafletElement;
	    var newZoom = theMap.getZoom();
	    var newCenterLatLng = theMap.getCenter();
	    var newCenter = [newCenterLatLng.lat, newCenterLatLng.lng];
	
	    var oldCenterLatLng = L.latLng(center);
	
	    var newCenterProjected = theMap.latLngToLayerPoint(newCenterLatLng);
	    var oldCenterProjected = theMap.latLngToLayerPoint(oldCenterLatLng);
	
	    if (newZoom !== zoom || newCenterProjected.x !== oldCenterProjected.x || newCenterProjected.y !== oldCenterProjected.y) {
	      dispatch(changeCenterAndZoom(newCenter, newZoom));
	    }
	
	    var boundsObj = theMap.getBounds();
	    var newBounds = [[boundsObj._northEast.lat, boundsObj._northEast.lng], [boundsObj._southWest.lat, boundsObj._southWest.lng]];
	    if (bounds[0][0] !== newBounds[0][0] || bounds[0][1] !== newBounds[0][1] || bounds[1][0] !== newBounds[1][0] || bounds[1][1] !== newBounds[1][1]) {
	      dispatch(changeBounds(newBounds));
	    }
	  };
	
	  // call useEffect to initialize preliminary view on mount
	  (0, _react.useEffect)(function () {
	    onMapMoved();
	  }, []);
	
	  var onMarkerClicked = function onMarkerClicked(e) {
	    var id = e.target.options.id;
	
	    if (parseInt(selectedGravestone, 10) === parseInt(id, 10)) {
	      id = null;
	    }
	    dispatch(selectGravestone(id));
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactLeaflet.Map,
	      {
	        className: 'the_map',
	        id: 'the_map',
	        boundsOptions: { maxZoom: 22 },
	        center: center,
	        zoom: zoom,
	        maxZoom: 24,
	        minZoom: 16,
	        maxBounds: [[37.532394232849335, -77.39232258405536], [37.54, -77.38342452328654]],
	        zoomControl: false,
	        ref: theRef,
	        onMoveEnd: onMapMoved
	      },
	      hillshadeOn ? _react2.default.createElement(_reactLeaflet.TileLayer, {
	        url: '//s3.amazonaws.com/dsl-general/eastendHillshade/{z}/{x}/{y}.png',
	        maxNativeZoom: 22,
	        maxZoom: 25,
	        detectRetina: true
	      }) : _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_reactLeaflet.TileLayer, {
	          url: '//gis.henrico.us/arcgis/rest/services/Henrico_Hybrid_Map/MapServer/tile/{z}/{y}/{x}',
	          maxNativeZoom: 19,
	          maxZoom: 25,
	          detectRetina: true
	        }),
	        _react2.default.createElement(_reactLeaflet.TileLayer, { url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager_only_labels/{z}/{x}/{y}.png' }),
	        _react2.default.createElement(_reactLeaflet.TileLayer, {
	          url: '//s3.amazonaws.com/dsl-general/eastend2020/{z}/{x}/{y}.png',
	          maxNativeZoom: 22,
	          maxZoom: 25,
	          detectRetina: true
	        }),
	        _react2.default.createElement(_reactLeaflet.GeoJSON, {
	          data: perimeter,
	          color: '#262626',
	          weight: 0.5,
	          fillColor: '#262626',
	          fillOpacity: 0.5,
	          className: 'perimeter'
	        })
	      ),
	      gravestones.map(function (g) {
	        return _react2.default.createElement(_reactLeaflet.Circle, {
	          center: g.center,
	          radius: g.radius,
	          fillColor: g.fill,
	          fillOpacity: !hillshadeOn ? g.fillOpacity : g.fillOpacity / 2,
	          color: 'black',
	          weight: g.weight,
	          opacity: g.opacity,
	          onClick: onMarkerClicked,
	          id: g.id,
	          key: g.key
	        });
	      }),
	      userLocation && _react2.default.createElement(_reactLeaflet.Marker, {
	        position: userLocation,
	        icon: icon,
	        className: 'userLocation'
	      }),
	      _react2.default.createElement(_reactLeaflet.ZoomControl, {
	        position: 'bottomright'
	      }),
	      _react2.default.createElement(_ReactLeafletLocate2.default, {
	        options: {
	          position: 'bottomright'
	        }
	      })
	    )
	  );
	};
	
	exports.default = TheMap;
	
	
	TheMap.propTypes = {
	  zoom: _propTypes2.default.number.isRequired,
	  center: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	  bounds: _propTypes2.default.arrayOf(_propTypes2.default.array).isRequired,
	  gravestones: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  userLocation: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  selectedGravestone: _propTypes2.default.number,
	  selectGravestone: _propTypes2.default.func.isRequired,
	  changeCenterAndZoom: _propTypes2.default.func.isRequired,
	  changeBounds: _propTypes2.default.func.isRequired,
	  perimeter: _propTypes2.default.object,
	  icon: _propTypes2.default.object
	};
	
	TheMap.defaultProps = {
	  selectedHeadstone: null,
	  icon: L.icon({
	    iconUrl: './userLocation.svg',
	    iconSize: [50, 50],
	    iconAnchor: [25, 25]
	  })
	};

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	__webpack_require__(180);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Masthead = function Masthead() {
	  return React.createElement(
	    'header',
	    {
	      id: 'masthead'
	    },
	    React.createElement(
	      'h1',
	      null,
	      'East End Cemetery'
	    )
	  );
	};
	
	exports.default = Masthead;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _reactLeaflet = __webpack_require__(56);
	
	var _leaflet = __webpack_require__(188);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LocateControl = function (_Component) {
	  _inherits(LocateControl, _Component);
	
	  function LocateControl() {
	    _classCallCheck(this, LocateControl);
	
	    return _possibleConstructorReturn(this, (LocateControl.__proto__ || Object.getPrototypeOf(LocateControl)).apply(this, arguments));
	  }
	
	  _createClass(LocateControl, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _props = this.props,
	          options = _props.options,
	          startDirectly = _props.startDirectly;
	      var map = this.props.leaflet.map;
	
	
	      var lc = new _leaflet2.default(options);
	      lc.addTo(map);
	
	      if (startDirectly) {
	        // request location update and set location
	        lc.start();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return LocateControl;
	}(_react.Component);
	
	exports.default = (0, _reactLeaflet.withLeaflet)(LocateControl);

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(7);
	
	var _Search = __webpack_require__(110);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _actions = __webpack_require__(11);
	
	var _selectors = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    options: (0, _selectors.getSearchOptions)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  selectGravestone: _actions.selectGravestone
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Search2.default);

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFuzzy = __webpack_require__(194);
	
	var _reactFuzzy2 = _interopRequireDefault(_reactFuzzy);
	
	__webpack_require__(181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Search = function Search(_ref) {
	  var options = _ref.options,
	      selectGravestone = _ref.selectGravestone;
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'search' },
	    _react2.default.createElement(_reactFuzzy2.default, {
	      className: 'searchStones',
	      list: options,
	      keys: ['name'],
	      onSelect: selectGravestone,
	      width: '100%',
	      maxResults: 100,
	      placeholder: 'Search by name or date',
	      threshold: 0.3,
	      resultsTemplate: function resultsTemplate(options, state, styles, clickHandler) {
	        return state.results.map(function (val, i) {
	          return _react2.default.createElement(
	            'div',
	            {
	              key: 'searchResultFor' + i,
	              onClick: function onClick() {
	                return clickHandler(i);
	              },
	              className: 'result'
	            },
	            val.name
	          );
	        });
	      }
	    })
	  );
	};
	
	exports.default = Search;
	
	
	Search.propTypes = {
	  options: _propTypes2.default.arrayOf(_propTypes2.default.object)
	};
	
	Search.defaultProps = {};

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EastEndCemetery_white = __webpack_require__(239);
	
	var _EastEndCemetery_white2 = _interopRequireDefault(_EastEndCemetery_white);
	
	__webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Welcome = function Welcome() {
	  var _useState = (0, _react.useState)(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      welcomeIsOpen = _useState2[0],
	      setWelcomeIsOpen = _useState2[1];
	
	  if (!welcomeIsOpen) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    {
	      id: 'welcome'
	    },
	    _react2.default.createElement('img', { src: _EastEndCemetery_white2.default, alt: 'East End Cemetery logo' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'East End Cemetery (est. 1897) is a historic African American burial ground in Henrico County and the city of Richmond, Virginia. From 2013 to 2020, volunteers led by the Friends of East End worked to reclaim the 16-acre cemetery from nature and neglect.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Years in the making, this map pinpoints the locations of grave markers at East End using GIS technology and drone imagery. As of July 2021, more than 3,300 markers had been mapped, with points indicating their precise positions in the cemetery. Points will continue to be added as markers are found.'
	    ),
	    _react2.default.createElement(
	      'button',
	      {
	        onClick: function onClick() {
	          return setWelcomeIsOpen(false);
	        }
	      },
	      'Explore the Map'
	    )
	  );
	};
	
	exports.default = Welcome;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(7);
	
	var _ZoomToButton = __webpack_require__(113);
	
	var _ZoomToButton2 = _interopRequireDefault(_ZoomToButton);
	
	var _actions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    id: state.selectedGravestone
	  };
	};
	
	var mapDispatchToProps = {
	  zoomToHeadstone: _actions.zoomToHeadstone
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ZoomToButton2.default);

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ZoomTo = function ZoomTo(_ref) {
	  var id = _ref.id,
	      zoomToHeadstone = _ref.zoomToHeadstone;
	  return _react2.default.createElement(
	    'button',
	    {
	      onClick: zoomToHeadstone,
	      id: id,
	      className: 'zoomToButton'
	    },
	    _react2.default.createElement(
	      'svg',
	      {
	        width: 25,
	        height: 25
	      },
	      _react2.default.createElement(
	        'g',
	        { transform: 'translate(' + 25 / 2 + ' ' + 25 / 2 + ')' },
	        _react2.default.createElement('line', {
	          x1: 30 / -3,
	          x2: 30 / 3,
	          y1: 0,
	          y2: 0,
	          stroke: '#262626',
	          strokeWidth: 30 / 15
	        }),
	        _react2.default.createElement('line', {
	          x1: 0,
	          x2: 0,
	          y1: 30 / -3,
	          y2: 30 / 3,
	          stroke: '#262626',
	          strokeWidth: 30 / 15
	        }),
	        _react2.default.createElement('circle', {
	          cx: 0,
	          cy: 0,
	          r: 30 / 4.5,
	          fill: '#f5f5f5',
	          fillOpacity: 1,
	          stroke: '#262626',
	          strokeWidth: 30 / 15
	        }),
	        _react2.default.createElement('circle', {
	          cx: 0,
	          cy: 0,
	          r: 30 / 8,
	          fill: '#262626'
	        })
	      )
	    )
	  );
	};
	
	exports.default = ZoomTo;
	
	
	ZoomTo.propTypes = {
	  id: _propTypes2.default.number.isRequired,
	  zoomToHeadstone: _propTypes2.default.func
	};
	
	ZoomTo.defaultProps = {
	  onClick: function onClick() {
	    return false;
	  }
	};

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(7);
	
	var _store = __webpack_require__(115);
	
	var _store2 = _interopRequireDefault(_store);
	
	__webpack_require__(183);
	
	var _App = __webpack_require__(89);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: (0, _store2.default)() },
	  _react2.default.createElement(_App2.default, null)
	), document.getElementById('root'));

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(59);
	
	var _reduxBatchedActions = __webpack_require__(231);
	
	var _reduxThunk = __webpack_require__(233);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(116);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _initialState = __webpack_require__(61);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _reduxLogger = __webpack_require__(232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logger = (0, _reduxLogger.createLogger)({
	  collapsed: true,
	  duration: true
	});
	
	var hashManager = function hashManager(store) {
	  return function (next) {
	    return function (action) {
	      var theNext = next(action);
	
	      var _store$getState = store.getState(),
	          zoom = _store$getState.zoom,
	          center = _store$getState.center,
	          selectedGravestone = _store$getState.selectedGravestone;
	
	      var newHash = {
	        loc: zoom + '/' + center[0] + '/' + center[1],
	        selectedGravestone: selectedGravestone
	      };
	      var hash = '#' + Object.keys(newHash).filter(function (k) {
	        return newHash[k];
	      }).map(function (k) {
	        return k + '=' + newHash[k];
	      }).join('&');
	      if (document.location.hash !== hash) {
	        document.location.assign(hash);
	      }
	      return theNext;
	    };
	  };
	};
	
	function configureStore() {
	  return (0, _redux.createStore)(_reducers2.default, _initialState2.default, (0, _redux.applyMiddleware)(_reduxBatchedActions.batchDispatchMiddleware, _reduxThunk2.default, logger, hashManager));
	}

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(59);
	
	var _actionTypes = __webpack_require__(60);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _initialState = __webpack_require__(61);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var zoom = function zoom() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default;
	  var action = arguments[1];
	
	  if (action.type === _actionTypes2.default.ZOOM) {
	    return action.payload;
	  } else if (action.type === _actionTypes2.default.CHANGE_CENTER_AND_ZOOM) {
	    return action.payload.zoom;
	  }
	  return state;
	};
	
	var center = function center() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default;
	  var action = arguments[1];
	
	  if (action.type === _actionTypes2.default.CHANGE_CENTER) {
	    return action.payload;
	  } else if (action.type === _actionTypes2.default.CHANGE_CENTER_AND_ZOOM) {
	    return action.payload.center;
	  }
	  return state;
	};
	
	var bounds = function bounds() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default;
	  var action = arguments[1];
	
	  if (action.type === _actionTypes2.default.CHANGE_BOUNDS) {
	    return action.payload;
	  }
	  return state;
	};
	
	var selectedGravestone = function selectedGravestone() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var action = arguments[1];
	  return action.type === _actionTypes2.default.SELECT_GRAVESTONE ? action.payload : state;
	};
	
	var gravestones = function gravestones() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default;
	  var action = arguments[1];
	
	  return action.type === _actionTypes2.default.LOAD_GRAVESTONES ? action.payload : state;
	};
	
	var aboutOpen = function aboutOpen() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default;
	  var action = arguments[1];
	
	  if (action.type === _actionTypes2.default.TOGGLE_ABOUT) {
	    return !state;
	  }
	  if (action.type === _actionTypes2.default.TOGGLE_CONTACT_US) {
	    return false;
	  }
	  return state;
	};
	
	var contactUsOpen = function contactUsOpen() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default;
	  var action = arguments[1];
	
	  if (action.type === _actionTypes2.default.TOGGLE_CONTACT_US) {
	    return !state;
	  }
	  if (action.type === _actionTypes2.default.TOGGLE_ABOUT) {
	    return false;
	  }
	  return state;
	};
	
	var userLocation = function userLocation() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default;
	  var action = arguments[1];
	
	  return action.type === _actionTypes2.default.LOCATED_USER ? action.payload : state;
	};
	
	var hillshadeOn = function hillshadeOn() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default;
	  var action = arguments[1];
	
	  return action.type === _actionTypes2.default.TOGGLE_HILLSHADE ? !state : state;
	};
	
	var combinedReducer = (0, _redux.combineReducers)({
	  selectedGravestone: selectedGravestone,
	  gravestones: gravestones,
	  zoom: zoom,
	  center: center,
	  bounds: bounds,
	  aboutOpen: aboutOpen,
	  contactUsOpen: contactUsOpen,
	  userLocation: userLocation,
	  hillshadeOn: hillshadeOn
	});
	
	exports.default = combinedReducer;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(118);


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(119);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 119 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(133), __esModule: true };

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(134), __esModule: true };

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(135), __esModule: true };

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(136), __esModule: true };

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(137), __esModule: true };

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(138), __esModule: true };

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(139), __esModule: true };

/***/ },
/* 127 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(122);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(120);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(124);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(121);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(62);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(62);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(158);
	module.exports = __webpack_require__(8).Object.assign;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(159);
	var $Object = __webpack_require__(8).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(160);
	var $Object = __webpack_require__(8).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(161);
	module.exports = __webpack_require__(8).Object.getPrototypeOf;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(162);
	module.exports = __webpack_require__(8).Object.setPrototypeOf;


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(165);
	__webpack_require__(163);
	__webpack_require__(166);
	__webpack_require__(167);
	module.exports = __webpack_require__(8).Symbol;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(164);
	__webpack_require__(168);
	module.exports = __webpack_require__(49).f('iterator');


/***/ },
/* 140 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 141 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(26);
	var toLength = __webpack_require__(156);
	var toAbsoluteIndex = __webpack_require__(155);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(32);
	var gOPS = __webpack_require__(42);
	var pIE = __webpack_require__(33);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(14).document;
	module.exports = document && document.documentElement;


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(63);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(41);
	var descriptor = __webpack_require__(34);
	var setToStringTag = __webpack_require__(43);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(24)(IteratorPrototype, __webpack_require__(27)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 147 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(36)('meta');
	var isObject = __webpack_require__(25);
	var has = __webpack_require__(19);
	var setDesc = __webpack_require__(20).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(23)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(13);
	var getKeys = __webpack_require__(32);
	var gOPS = __webpack_require__(42);
	var pIE = __webpack_require__(33);
	var toObject = __webpack_require__(35);
	var IObject = __webpack_require__(67);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(23)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(20);
	var anObject = __webpack_require__(29);
	var getKeys = __webpack_require__(32);
	
	module.exports = __webpack_require__(13) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(26);
	var gOPN = __webpack_require__(70).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(18);
	var core = __webpack_require__(8);
	var fails = __webpack_require__(23);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(25);
	var anObject = __webpack_require__(29);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(64)(Function.call, __webpack_require__(69).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(46);
	var defined = __webpack_require__(38);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(46);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(46);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(141);
	var step = __webpack_require__(147);
	var Iterators = __webpack_require__(40);
	var toIObject = __webpack_require__(26);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(68)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(18);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(149) });


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(18);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(41) });


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(18);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(13), 'Object', { defineProperty: __webpack_require__(20).f });


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(35);
	var $getPrototypeOf = __webpack_require__(71);
	
	__webpack_require__(152)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(18);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(153).set });


/***/ },
/* 163 */
/***/ function(module, exports) {



/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(154)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(68)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(14);
	var has = __webpack_require__(19);
	var DESCRIPTORS = __webpack_require__(13);
	var $export = __webpack_require__(18);
	var redefine = __webpack_require__(73);
	var META = __webpack_require__(148).KEY;
	var $fails = __webpack_require__(23);
	var shared = __webpack_require__(45);
	var setToStringTag = __webpack_require__(43);
	var uid = __webpack_require__(36);
	var wks = __webpack_require__(27);
	var wksExt = __webpack_require__(49);
	var wksDefine = __webpack_require__(48);
	var enumKeys = __webpack_require__(143);
	var isArray = __webpack_require__(145);
	var anObject = __webpack_require__(29);
	var isObject = __webpack_require__(25);
	var toObject = __webpack_require__(35);
	var toIObject = __webpack_require__(26);
	var toPrimitive = __webpack_require__(47);
	var createDesc = __webpack_require__(34);
	var _create = __webpack_require__(41);
	var gOPNExt = __webpack_require__(151);
	var $GOPD = __webpack_require__(69);
	var $GOPS = __webpack_require__(42);
	var $DP = __webpack_require__(20);
	var $keys = __webpack_require__(32);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(70).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(33).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(31)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(24)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(48)('asyncIterator');


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(48)('observable');


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(157);
	var global = __webpack_require__(14);
	var hide = __webpack_require__(24);
	var Iterators = __webpack_require__(40);
	var TO_STRING_TAG = __webpack_require__(27)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 169 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 170 */
169,
/* 171 */
169,
/* 172 */
169,
/* 173 */
169,
/* 174 */
169,
/* 175 */
169,
/* 176 */
169,
/* 177 */
169,
/* 178 */
169,
/* 179 */
169,
/* 180 */
169,
/* 181 */
169,
/* 182 */
169,
/* 183 */
169,
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/shield_ur.a27a7594.svg";

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Fuse.js v3.4.5 - Lightweight fuzzy-search (http://fusejs.io)
	 * 
	 * Copyright (c) 2012-2017 Kirollos Risk (http://kiro.me)
	 * All Rights Reserved. Apache Software License 2.0
	 * 
	 * http://www.apache.org/licenses/LICENSE-2.0
	 */
	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("Fuse",[],t):"object"==typeof exports?exports.Fuse=t():e.Fuse=t()}(this,function(){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=1)}([function(e,t){e.exports=function(e){return Array.isArray?Array.isArray(e):"[object Array]"===Object.prototype.toString.call(e)}},function(e,t,n){function r(e){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function o(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var i=n(2),a=n(8),s=n(0),c=function(){function e(t,n){var r=n.location,o=void 0===r?0:r,i=n.distance,s=void 0===i?100:i,c=n.threshold,h=void 0===c?.6:c,l=n.maxPatternLength,u=void 0===l?32:l,f=n.caseSensitive,d=void 0!==f&&f,v=n.tokenSeparator,p=void 0===v?/ +/g:v,g=n.findAllMatches,y=void 0!==g&&g,m=n.minMatchCharLength,k=void 0===m?1:m,S=n.id,x=void 0===S?null:S,b=n.keys,M=void 0===b?[]:b,_=n.shouldSort,L=void 0===_||_,w=n.getFn,A=void 0===w?a:w,C=n.sortFn,I=void 0===C?function(e,t){return e.score-t.score}:C,O=n.tokenize,j=void 0!==O&&O,P=n.matchAllTokens,F=void 0!==P&&P,T=n.includeMatches,z=void 0!==T&&T,E=n.includeScore,K=void 0!==E&&E,$=n.verbose,J=void 0!==$&&$;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.options={location:o,distance:s,threshold:h,maxPatternLength:u,isCaseSensitive:d,tokenSeparator:p,findAllMatches:y,minMatchCharLength:k,id:x,keys:M,includeMatches:z,includeScore:K,shouldSort:L,getFn:A,sortFn:I,verbose:J,tokenize:j,matchAllTokens:F},this.setCollection(t)}var t,n,c;return t=e,(n=[{key:"setCollection",value:function(e){return this.list=e,e}},{key:"search",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{limit:!1};this._log('---------\nSearch pattern: "'.concat(e,'"'));var n=this._prepareSearchers(e),r=n.tokenSearchers,o=n.fullSearcher,i=this._search(r,o),a=i.weights,s=i.results;return this._computeScore(a,s),this.options.shouldSort&&this._sort(s),t.limit&&"number"==typeof t.limit&&(s=s.slice(0,t.limit)),this._format(s)}},{key:"_prepareSearchers",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=[];if(this.options.tokenize)for(var n=e.split(this.options.tokenSeparator),r=0,o=n.length;r<o;r+=1)t.push(new i(n[r],this.options));return{tokenSearchers:t,fullSearcher:new i(e,this.options)}}},{key:"_search",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1?arguments[1]:void 0,n=this.list,r={},o=[];if("string"==typeof n[0]){for(var i=0,a=n.length;i<a;i+=1)this._analyze({key:"",value:n[i],record:i,index:i},{resultMap:r,results:o,tokenSearchers:e,fullSearcher:t});return{weights:null,results:o}}for(var s={},c=0,h=n.length;c<h;c+=1)for(var l=n[c],u=0,f=this.options.keys.length;u<f;u+=1){var d=this.options.keys[u];if("string"!=typeof d){if(s[d.name]={weight:1-d.weight||1},d.weight<=0||d.weight>1)throw new Error("Key weight has to be > 0 and <= 1");d=d.name}else s[d]={weight:1};this._analyze({key:d,value:this.options.getFn(l,d),record:l,index:c},{resultMap:r,results:o,tokenSearchers:e,fullSearcher:t})}return{weights:s,results:o}}},{key:"_analyze",value:function(e,t){var n=e.key,r=e.arrayIndex,o=void 0===r?-1:r,i=e.value,a=e.record,c=e.index,h=t.tokenSearchers,l=void 0===h?[]:h,u=t.fullSearcher,f=void 0===u?[]:u,d=t.resultMap,v=void 0===d?{}:d,p=t.results,g=void 0===p?[]:p;if(null!=i){var y=!1,m=-1,k=0;if("string"==typeof i){this._log("\nKey: ".concat(""===n?"-":n));var S=f.search(i);if(this._log('Full text: "'.concat(i,'", score: ').concat(S.score)),this.options.tokenize){for(var x=i.split(this.options.tokenSeparator),b=[],M=0;M<l.length;M+=1){var _=l[M];this._log('\nPattern: "'.concat(_.pattern,'"'));for(var L=!1,w=0;w<x.length;w+=1){var A=x[w],C=_.search(A),I={};C.isMatch?(I[A]=C.score,y=!0,L=!0,b.push(C.score)):(I[A]=1,this.options.matchAllTokens||b.push(1)),this._log('Token: "'.concat(A,'", score: ').concat(I[A]))}L&&(k+=1)}m=b[0];for(var O=b.length,j=1;j<O;j+=1)m+=b[j];m/=O,this._log("Token score average:",m)}var P=S.score;m>-1&&(P=(P+m)/2),this._log("Score average:",P);var F=!this.options.tokenize||!this.options.matchAllTokens||k>=l.length;if(this._log("\nCheck Matches: ".concat(F)),(y||S.isMatch)&&F){var T=v[c];T?T.output.push({key:n,arrayIndex:o,value:i,score:P,matchedIndices:S.matchedIndices}):(v[c]={item:a,output:[{key:n,arrayIndex:o,value:i,score:P,matchedIndices:S.matchedIndices}]},g.push(v[c]))}}else if(s(i))for(var z=0,E=i.length;z<E;z+=1)this._analyze({key:n,arrayIndex:z,value:i[z],record:a,index:c},{resultMap:v,results:g,tokenSearchers:l,fullSearcher:f})}}},{key:"_computeScore",value:function(e,t){this._log("\n\nComputing score:\n");for(var n=0,r=t.length;n<r;n+=1){for(var o=t[n].output,i=o.length,a=1,s=1,c=0;c<i;c+=1){var h=e?e[o[c].key].weight:1,l=(1===h?o[c].score:o[c].score||.001)*h;1!==h?s=Math.min(s,l):(o[c].nScore=l,a*=l)}t[n].score=1===s?a:s,this._log(t[n])}}},{key:"_sort",value:function(e){this._log("\n\nSorting...."),e.sort(this.options.sortFn)}},{key:"_format",value:function(e){var t=[];if(this.options.verbose){var n=[];this._log("\n\nOutput:\n\n",JSON.stringify(e,function(e,t){if("object"===r(t)&&null!==t){if(-1!==n.indexOf(t))return;n.push(t)}return t})),n=null}var o=[];this.options.includeMatches&&o.push(function(e,t){var n=e.output;t.matches=[];for(var r=0,o=n.length;r<o;r+=1){var i=n[r];if(0!==i.matchedIndices.length){var a={indices:i.matchedIndices,value:i.value};i.key&&(a.key=i.key),i.hasOwnProperty("arrayIndex")&&i.arrayIndex>-1&&(a.arrayIndex=i.arrayIndex),t.matches.push(a)}}}),this.options.includeScore&&o.push(function(e,t){t.score=e.score});for(var i=0,a=e.length;i<a;i+=1){var s=e[i];if(this.options.id&&(s.item=this.options.getFn(s.item,this.options.id)[0]),o.length){for(var c={item:s.item},h=0,l=o.length;h<l;h+=1)o[h](s,c);t.push(c)}else t.push(s.item)}return t}},{key:"_log",value:function(){var e;this.options.verbose&&(e=console).log.apply(e,arguments)}}])&&o(t.prototype,n),c&&o(t,c),e}();e.exports=c},function(e,t,n){function r(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var o=n(3),i=n(4),a=n(7),s=function(){function e(t,n){var r=n.location,o=void 0===r?0:r,i=n.distance,s=void 0===i?100:i,c=n.threshold,h=void 0===c?.6:c,l=n.maxPatternLength,u=void 0===l?32:l,f=n.isCaseSensitive,d=void 0!==f&&f,v=n.tokenSeparator,p=void 0===v?/ +/g:v,g=n.findAllMatches,y=void 0!==g&&g,m=n.minMatchCharLength,k=void 0===m?1:m;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.options={location:o,distance:s,threshold:h,maxPatternLength:u,isCaseSensitive:d,tokenSeparator:p,findAllMatches:y,minMatchCharLength:k},this.pattern=this.options.isCaseSensitive?t:t.toLowerCase(),this.pattern.length<=u&&(this.patternAlphabet=a(this.pattern))}var t,n,s;return t=e,(n=[{key:"search",value:function(e){if(this.options.isCaseSensitive||(e=e.toLowerCase()),this.pattern===e)return{isMatch:!0,score:0,matchedIndices:[[0,e.length-1]]};var t=this.options,n=t.maxPatternLength,r=t.tokenSeparator;if(this.pattern.length>n)return o(e,this.pattern,r);var a=this.options,s=a.location,c=a.distance,h=a.threshold,l=a.findAllMatches,u=a.minMatchCharLength;return i(e,this.pattern,this.patternAlphabet,{location:s,distance:c,threshold:h,findAllMatches:l,minMatchCharLength:u})}}])&&r(t.prototype,n),s&&r(t,s),e}();e.exports=s},function(e,t){var n=/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;e.exports=function(e,t){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:/ +/g,o=new RegExp(t.replace(n,"\\$&").replace(r,"|")),i=e.match(o),a=!!i,s=[];if(a)for(var c=0,h=i.length;c<h;c+=1){var l=i[c];s.push([e.indexOf(l),l.length-1])}return{score:a?.5:1,isMatch:a,matchedIndices:s}}},function(e,t,n){var r=n(5),o=n(6);e.exports=function(e,t,n,i){for(var a=i.location,s=void 0===a?0:a,c=i.distance,h=void 0===c?100:c,l=i.threshold,u=void 0===l?.6:l,f=i.findAllMatches,d=void 0!==f&&f,v=i.minMatchCharLength,p=void 0===v?1:v,g=s,y=e.length,m=u,k=e.indexOf(t,g),S=t.length,x=[],b=0;b<y;b+=1)x[b]=0;if(-1!==k){var M=r(t,{errors:0,currentLocation:k,expectedLocation:g,distance:h});if(m=Math.min(M,m),-1!==(k=e.lastIndexOf(t,g+S))){var _=r(t,{errors:0,currentLocation:k,expectedLocation:g,distance:h});m=Math.min(_,m)}}k=-1;for(var L=[],w=1,A=S+y,C=1<<S-1,I=0;I<S;I+=1){for(var O=0,j=A;O<j;){r(t,{errors:I,currentLocation:g+j,expectedLocation:g,distance:h})<=m?O=j:A=j,j=Math.floor((A-O)/2+O)}A=j;var P=Math.max(1,g-j+1),F=d?y:Math.min(g+j,y)+S,T=Array(F+2);T[F+1]=(1<<I)-1;for(var z=F;z>=P;z-=1){var E=z-1,K=n[e.charAt(E)];if(K&&(x[E]=1),T[z]=(T[z+1]<<1|1)&K,0!==I&&(T[z]|=(L[z+1]|L[z])<<1|1|L[z+1]),T[z]&C&&(w=r(t,{errors:I,currentLocation:E,expectedLocation:g,distance:h}))<=m){if(m=w,(k=E)<=g)break;P=Math.max(1,2*g-k)}}if(r(t,{errors:I+1,currentLocation:g,expectedLocation:g,distance:h})>m)break;L=T}return{isMatch:k>=0,score:0===w?.001:w,matchedIndices:o(x,p)}}},function(e,t){e.exports=function(e,t){var n=t.errors,r=void 0===n?0:n,o=t.currentLocation,i=void 0===o?0:o,a=t.expectedLocation,s=void 0===a?0:a,c=t.distance,h=void 0===c?100:c,l=r/e.length,u=Math.abs(s-i);return h?l+u/h:u?1:l}},function(e,t){e.exports=function(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=[],r=-1,o=-1,i=0,a=e.length;i<a;i+=1){var s=e[i];s&&-1===r?r=i:s||-1===r||((o=i-1)-r+1>=t&&n.push([r,o]),r=-1)}return e[i-1]&&i-r>=t&&n.push([r,i-1]),n}},function(e,t){e.exports=function(e){for(var t={},n=e.length,r=0;r<n;r+=1)t[e.charAt(r)]=0;for(var o=0;o<n;o+=1)t[e.charAt(o)]|=1<<n-o-1;return t}},function(e,t,n){var r=n(0);e.exports=function(e,t){return function e(t,n,o){if(n){var i=n.indexOf("."),a=n,s=null;-1!==i&&(a=n.slice(0,i),s=n.slice(i+1));var c=t[a];if(null!=c)if(s||"string"!=typeof c&&"number"!=typeof c)if(r(c))for(var h=0,l=c.length;h<l;h+=1)e(c[h],s,o);else s&&e(c,s,o);else o.push(c.toString())}else o.push(t);return o}(e,t,[])}}])});

/***/ },
/* 186 */
/***/ function(module, exports) {

	module.exports = [
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Baby Girl",
			"nl": "Unknown",
			"url": "https://www.findagrave.com/memorial/155270310/baby_girl-unknown",
			"id": 155270310,
			"lng": -77.38704686,
			"lat": 37.53784583,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 8,
			"dd": 30,
			"by": 1963,
			"bd": 31,
			"bm": 3,
			"nm": "",
			"nf": "Lola",
			"nl": "Abernathy",
			"url": "https://findagrave.com/memorial/169041371",
			"id": 169041371,
			"lng": -77.386152508,
			"lat": 37.537460999,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 3,
			"dd": 18,
			"by": 1964,
			"bd": 20,
			"bm": 12,
			"nm": "",
			"nf": "Darrell",
			"nl": "Adams",
			"url": "https://findagrave.com/memorial/142796944",
			"id": 142796944,
			"lng": -77.386068908,
			"lat": 37.537454709,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 8,
			"dd": 15,
			"by": 1920,
			"bd": 5,
			"bm": 6,
			"nm": "Lobo",
			"nf": "Robert",
			"nl": "Adams",
			"url": "https://findagrave.com/memorial/185378955",
			"id": 185378955,
			"lng": -77.3874743,
			"lat": 37.537668402,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 9,
			"dd": 28,
			"by": 1884,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rosa",
			"nl": "Adams",
			"url": "https://findagrave.com/memorial/154283374",
			"id": 154283374,
			"lng": -77.386854074,
			"lat": 37.535531612,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 1,
			"dd": 15,
			"by": 1880,
			"bd": 25,
			"bm": 5,
			"nm": "J.",
			"nf": "William",
			"nl": "Adams",
			"url": "https://findagrave.com/memorial/114466920",
			"id": 114466920,
			"lng": -77.385820357,
			"lat": 37.536833578,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 4,
			"dd": 28,
			"by": 1911,
			"bd": 18,
			"bm": 5,
			"nm": "Simms",
			"nf": "Estelle",
			"nl": "Aikens",
			"url": "https://findagrave.com/memorial/155506511",
			"id": 155506511,
			"lng": -77.38736667,
			"lat": 37.537384737,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 5,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Matt",
			"nl": "Alberts",
			"url": "https://findagrave.com/memorial/188810577",
			"id": 188810577,
			"lng": -77.38800633,
			"lat": 37.53702129,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 1,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Jane",
			"nf": "Mary",
			"nl": "Albright",
			"url": "https://findagrave.com/memorial/154264550",
			"id": 154264550,
			"lng": -77.387250785,
			"lat": 37.535530537,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 1,
			"dd": 22,
			"by": 1896,
			"bd": 7,
			"bm": 7,
			"nm": "Emily",
			"nf": "Alease",
			"nl": "Alexander",
			"url": "https://findagrave.com/memorial/154043010",
			"id": 154043010,
			"lng": -77.386712322,
			"lat": 37.537518334,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 9,
			"dd": 8,
			"by": 1885,
			"bd": 23,
			"bm": 2,
			"nm": "",
			"nf": "Artress",
			"nl": "Alexander",
			"url": "https://findagrave.com/memorial/144064095",
			"id": 144064095,
			"lng": -77.385975648,
			"lat": 37.537194428,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 5,
			"dd": 27,
			"by": 1916,
			"bd": 12,
			"bm": 1,
			"nm": "",
			"nf": "James",
			"nl": "Alford",
			"url": "https://findagrave.com/memorial/146682148",
			"id": 146682148,
			"lng": -77.386173332,
			"lat": 37.535749862,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 3,
			"dd": 20,
			"by": 1880,
			"bd": 23,
			"bm": 9,
			"nm": "M.",
			"nf": "Alberta",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/128096187",
			"id": 128096187,
			"lng": -77.385617374,
			"lat": 37.537021978,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 7,
			"dd": 10,
			"by": 1912,
			"bd": 12,
			"bm": 4,
			"nm": "",
			"nf": "Albertha",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/173471630",
			"id": 173471630,
			"lng": -77.387303081,
			"lat": 37.537097442,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 9,
			"dd": 13,
			"by": 1898,
			"bd": 20,
			"bm": 9,
			"nm": "Mitchell",
			"nf": "Alvin",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/168676299",
			"id": 168676299,
			"lng": -77.386309719,
			"lat": 37.537085595,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 11,
			"dd": 12,
			"by": 1900,
			"bd": 5,
			"bm": 6,
			"nm": "A.",
			"nf": "Andrew",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/173773043",
			"id": 173773043,
			"lng": -77.38715277,
			"lat": 37.5371808,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 8,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "David",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/154283390",
			"id": 154283390,
			"lng": -77.387000669,
			"lat": 37.535458599,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 6,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ethel",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/170839007",
			"id": 170839007,
			"lng": -77.38650962,
			"lat": 37.53715816,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 11,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Fannie",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/130967985",
			"id": 130967985,
			"lng": -77.38564077,
			"lat": 37.53722248,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 2,
			"dd": 24,
			"by": 1890,
			"bd": 3,
			"bm": 4,
			"nm": "H.",
			"nf": "Flemming",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/155506520",
			"id": 155506520,
			"lng": -77.38734121,
			"lat": 37.5374229,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 12,
			"dd": 12,
			"by": 1910,
			"bd": 10,
			"bm": 7,
			"nm": "",
			"nf": "Fred",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/150078571",
			"id": 150078571,
			"lng": -77.38702856,
			"lat": 37.53708191,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 5,
			"dd": 20,
			"by": 1890,
			"bd": 25,
			"bm": 12,
			"nm": "Lee H.",
			"nf": "Ida",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/155506529",
			"id": 155506529,
			"lng": -77.38734052,
			"lat": 37.53743073,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 5,
			"dd": 25,
			"by": 1913,
			"bd": 8,
			"bm": 6,
			"nm": "Clayton",
			"nf": "James",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/149201559",
			"id": 149201559,
			"lng": -77.38627182,
			"lat": 37.5352661,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 1,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Joshua",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/161171179",
			"id": 161171179,
			"lng": -77.38651589,
			"lat": 37.53701817,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 5,
			"dd": 8,
			"by": 1907,
			"bd": 2,
			"bm": 1,
			"nm": "",
			"nf": "Joshua",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/156612745",
			"id": 156612745,
			"lng": -77.38638818,
			"lat": 37.53715143,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 8,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lena",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/154283397",
			"id": 154283397,
			"lng": -77.38700275,
			"lat": 37.53545274,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 5,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "Leola",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/169397068",
			"id": 169397068,
			"lng": -77.38659257,
			"lat": 37.53686137,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 11,
			"dd": 30,
			"by": 1902,
			"bd": 17,
			"bm": 11,
			"nm": "",
			"nf": "Louise",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/11125428",
			"id": 11125428,
			"lng": -77.38671742,
			"lat": 37.53691496,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 10,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Jane",
			"nf": "Mary",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/160921611",
			"id": 160921611,
			"lng": -77.38670395,
			"lat": 37.53671223,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 11,
			"dd": 24,
			"by": 1930,
			"bd": 6,
			"bm": 2,
			"nm": "",
			"nf": "Mildred",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/186917529",
			"id": 186917529,
			"lng": -77.38748132,
			"lat": 37.53694017,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 5,
			"dd": 31,
			"by": 1880,
			"bd": 31,
			"bm": 10,
			"nm": "",
			"nf": "Missouri",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/163904711",
			"id": 163904711,
			"lng": -77.3868874,
			"lat": 37.53682034,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 8,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sarah",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/166485803",
			"id": 166485803,
			"lng": -77.38781943,
			"lat": 37.53712426,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 7,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sarah",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/154259086",
			"id": 154259086,
			"lng": -77.38647383,
			"lat": 37.53559144,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 1,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sophia",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/166104941",
			"id": 166104941,
			"lng": -77.38741381,
			"lat": 37.53652972,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 1,
			"dd": 31,
			"by": 1921,
			"bd": 16,
			"bm": 4,
			"nm": "Deborah",
			"nf": "Susie",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/138561608",
			"id": 138561608,
			"lng": -77.38630235,
			"lat": 37.53664748,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 3,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Lee",
			"nf": "Washington",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/130691678",
			"id": 130691678,
			"lng": -77.38564209,
			"lat": 37.5372126,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 4,
			"dd": 1,
			"by": 1885,
			"bd": 30,
			"bm": 6,
			"nm": "E.",
			"nf": "Arthur",
			"nl": "Alston",
			"url": "https://findagrave.com/memorial/155979473",
			"id": 155979473,
			"lng": -77.38711659,
			"lat": 37.53548975,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 2,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Major",
			"nl": "Alston",
			"url": "https://findagrave.com/memorial/185357147",
			"id": 185357147,
			"lng": -77.38737713,
			"lat": 37.536761,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 11,
			"dd": 29,
			"by": 1904,
			"bd": 16,
			"bm": 9,
			"nm": "",
			"nf": "Mary",
			"nl": "Alston",
			"url": "https://findagrave.com/memorial/138561615",
			"id": 138561615,
			"lng": -77.38625432,
			"lat": 37.53712471,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 12,
			"dd": 3,
			"by": 1898,
			"bd": 12,
			"bm": 12,
			"nm": "",
			"nf": "Charles",
			"nl": "Ampey",
			"url": "https://findagrave.com/memorial/132641032",
			"id": 132641032,
			"lng": -77.38576418,
			"lat": 37.53725065,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1999,
			"dm": 4,
			"dd": 18,
			"by": 1929,
			"bd": 24,
			"bm": 6,
			"nm": "",
			"nf": "Emily",
			"nl": "Ampey",
			"url": "https://findagrave.com/memorial/76587674",
			"id": 76587674,
			"lng": -77.38630228,
			"lat": 37.53720626,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 1,
			"dd": 9,
			"by": 1940,
			"bd": 20,
			"bm": 9,
			"nm": "Charles",
			"nf": "Irving",
			"nl": "Ampey",
			"url": "https://findagrave.com/memorial/176097671",
			"id": 176097671,
			"lng": -77.3873405,
			"lat": 37.53691827,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 9,
			"dd": 1,
			"by": 1889,
			"bd": 12,
			"bm": 12,
			"nm": "",
			"nf": "Georgianna",
			"nl": "Ampy",
			"url": "https://findagrave.com/memorial/157897043",
			"id": 157897043,
			"lng": -77.38676425,
			"lat": 37.53753151,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 6,
			"dd": 27,
			"by": 1906,
			"bd": 7,
			"bm": 7,
			"nm": "",
			"nf": "Annie",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/185246554",
			"id": 185246554,
			"lng": -77.38724838,
			"lat": 37.5373334,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 4,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Augustus",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/155782155",
			"id": 155782155,
			"lng": -77.38718282,
			"lat": 37.53561478,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 7,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Betty",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/155761138",
			"id": 155761138,
			"lng": -77.38788343,
			"lat": 37.53709855,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 6,
			"dd": 17,
			"by": 1891,
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Clarence",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/186818159",
			"id": 186818159,
			"lng": -77.38743342,
			"lat": 37.53696405,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 1,
			"dd": 18,
			"by": 1905,
			"bd": 13,
			"bm": 10,
			"nm": "Alice",
			"nf": "Elizabeth",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/159661364",
			"id": 159661364,
			"lng": -77.38617335,
			"lat": 37.53738936,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 12,
			"dd": 30,
			"by": 1964,
			"bd": 19,
			"bm": 4,
			"nm": "",
			"nf": "Felecia",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/159661367",
			"id": 159661367,
			"lng": -77.38614304,
			"lat": 37.53733202,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 6,
			"dd": 7,
			"by": "",
			"bd": 27,
			"bm": 7,
			"nm": "",
			"nf": "Helen",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/166117080",
			"id": 166117080,
			"lng": -77.38713036,
			"lat": 37.53679647,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 1,
			"dd": 3,
			"by": 1914,
			"bd": 28,
			"bm": 5,
			"nm": "",
			"nf": "James",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/145989312",
			"id": 145989312,
			"lng": -77.38644618,
			"lat": 37.53662879,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 9,
			"dd": 23,
			"by": 1889,
			"bd": 10,
			"bm": 1,
			"nm": "J.",
			"nf": "John",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/185151317",
			"id": 185151317,
			"lng": -77.38698254,
			"lat": 37.53759098,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1907,
			"dm": 7,
			"dd": 31,
			"by": 1852,
			"bd": "",
			"bm": 4,
			"nm": "T.",
			"nf": "John",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/149165811",
			"id": 149165811,
			"lng": -77.3860733,
			"lat": 37.53579743,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1980,
			"dm": 10,
			"dd": 20,
			"by": 1901,
			"bd": 8,
			"bm": 3,
			"nm": "",
			"nf": "Joseph",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/150493579",
			"id": 150493579,
			"lng": -77.38641609,
			"lat": 37.53602378,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 9,
			"dd": 9,
			"by": 1935,
			"bd": 13,
			"bm": 6,
			"nm": "",
			"nf": "June",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/141798885",
			"id": 141798885,
			"lng": -77.3865886,
			"lat": 37.53722798,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 1,
			"dd": 20,
			"by": 1871,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lillie",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/148748100",
			"id": 148748100,
			"lng": -77.38785109,
			"lat": 37.53718468,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 2,
			"dd": 2,
			"by": 1894,
			"bd": 5,
			"bm": 7,
			"nm": "",
			"nf": "Lloyd",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/160921637",
			"id": 160921637,
			"lng": -77.38689756,
			"lat": 37.53673152,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 2,
			"dd": 25,
			"by": 1900,
			"bd": 20,
			"bm": 7,
			"nm": "",
			"nf": "Manuel",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/142525992",
			"id": 142525992,
			"lng": -77.38657298,
			"lat": 37.53705205,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 7,
			"dd": 12,
			"by": 1879,
			"bd": 1,
			"bm": 5,
			"nm": "",
			"nf": "Mary",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/187370085",
			"id": 187370085,
			"lng": -77.38741958,
			"lat": 37.53746467,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 4,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Mary",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/175611691",
			"id": 175611691,
			"lng": -77.38764801,
			"lat": 37.53708527,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 3,
			"dd": 10,
			"by": 1900,
			"bd": 1,
			"bm": 8,
			"nm": "",
			"nf": "Mary",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/177354152",
			"id": 177354152,
			"lng": -77.38631575,
			"lat": 37.53743338,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 7,
			"dd": 20,
			"by": 1914,
			"bd": 25,
			"bm": 12,
			"nm": "",
			"nf": "Matt",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/158889108",
			"id": 158889108,
			"lng": -77.3872501,
			"lat": 37.53751837,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 8,
			"dd": 10,
			"by": 1892,
			"bd": 27,
			"bm": 11,
			"nm": "R.",
			"nf": "Melvin",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/166485972",
			"id": 166485972,
			"lng": -77.38783059,
			"lat": 37.53714395,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 6,
			"dd": 27,
			"by": 1860,
			"bd": "",
			"bm": 5,
			"nm": "B.",
			"nf": "Sydney",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/149165815",
			"id": 149165815,
			"lng": -77.38606602,
			"lat": 37.53580241,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 2,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "William",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/126772032",
			"id": 126772032,
			"lng": -77.38786004,
			"lat": 37.53714408,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 12,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "Robert",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/192407019",
			"id": 192407019,
			"lng": -77.38791943,
			"lat": 37.53686916,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 2,
			"dd": 20,
			"by": 1902,
			"bd": 16,
			"bm": 3,
			"nm": "",
			"nf": "Gilbert",
			"nl": "Andrews",
			"url": "https://findagrave.com/memorial/176060580",
			"id": 176060580,
			"lng": -77.38746026,
			"lat": 37.53731666,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 8,
			"dd": 15,
			"by": 1910,
			"bd": 5,
			"bm": 6,
			"nm": "",
			"nf": "Percy",
			"nl": "Anthony",
			"url": "https://findagrave.com/memorial/173314347",
			"id": 173314347,
			"lng": -77.38710767,
			"lat": 37.53725475,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 3,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Charles",
			"nl": "Archer",
			"url": "https://findagrave.com/memorial/146187826",
			"id": 146187826,
			"lng": -77.38641016,
			"lat": 37.53670082,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 7,
			"dd": 27,
			"by": 1882,
			"bd": 16,
			"bm": 8,
			"nm": "",
			"nf": "Mary",
			"nl": "Archer",
			"url": "https://findagrave.com/memorial/161636470",
			"id": 161636470,
			"lng": -77.38685589,
			"lat": 37.53743117,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 6,
			"dd": 29,
			"by": 1940,
			"bd": 25,
			"bm": 10,
			"nm": "Delores",
			"nf": "Eva",
			"nl": "Arnette",
			"url": "https://findagrave.com/memorial/142438621",
			"id": 142438621,
			"lng": -77.38568456,
			"lat": 37.53730474,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 11,
			"dd": 11,
			"by": 1937,
			"bd": 10,
			"bm": 11,
			"nm": "",
			"nf": "Victoria",
			"nl": "Arrington",
			"url": "https://findagrave.com/memorial/145167317",
			"id": 145167317,
			"lng": -77.38634087,
			"lat": 37.5371575,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 6,
			"dd": 28,
			"by": 1920,
			"bd": 25,
			"bm": 8,
			"nm": "Raymond",
			"nf": "James",
			"nl": "Ashby",
			"url": "https://findagrave.com/memorial/172297786",
			"id": 172297786,
			"lng": -77.38629476,
			"lat": 37.53529717,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 11,
			"dd": 19,
			"by": 1895,
			"bd": 5,
			"bm": 7,
			"nm": "",
			"nf": "Lottie",
			"nl": "Ashley",
			"url": "https://findagrave.com/memorial/171733155",
			"id": 171733155,
			"lng": -77.38692512,
			"lat": 37.53724435,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 12,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Abbie",
			"nl": "Athey",
			"url": "https://findagrave.com/memorial/175696515",
			"id": 175696515,
			"lng": -77.38628828,
			"lat": 37.53681136,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 4,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "Hallie",
			"nl": "Atkinson",
			"url": "https://findagrave.com/memorial/76605558",
			"id": 76605558,
			"lng": -77.38552523,
			"lat": 37.53725019,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 8,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "William",
			"nl": "Atkinson",
			"url": "https://findagrave.com/memorial/38456780",
			"id": 38456780,
			"lng": -77.38547405,
			"lat": 37.53724834,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 2,
			"dd": 6,
			"by": 1887,
			"bd": 27,
			"bm": 10,
			"nm": "",
			"nf": "Frances",
			"nl": "Austin",
			"url": "https://findagrave.com/memorial/169713729",
			"id": 169713729,
			"lng": -77.38669879,
			"lat": 37.53696597,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 5,
			"dd": 17,
			"by": 1872,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Kate",
			"nl": "Austin",
			"url": "https://findagrave.com/memorial/145325092",
			"id": 145325092,
			"lng": -77.385852,
			"lat": 37.53707617,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 11,
			"dd": 17,
			"by": 1882,
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Sallie",
			"nl": "Austin",
			"url": "https://findagrave.com/memorial/154283404",
			"id": 154283404,
			"lng": -77.38692811,
			"lat": 37.5354951,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 12,
			"dd": 8,
			"by": 1898,
			"bd": 24,
			"bm": 12,
			"nm": "",
			"nf": "Ada",
			"nl": "Averett",
			"url": "https://findagrave.com/memorial/155506552",
			"id": 155506552,
			"lng": -77.38746267,
			"lat": 37.53751453,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 5,
			"dd": 9,
			"by": 1863,
			"bd": "",
			"bm": 5,
			"nm": "P.",
			"nf": "Ellen",
			"nl": "Bacchus",
			"url": "https://findagrave.com/memorial/143631812",
			"id": 143631812,
			"lng": -77.38619154,
			"lat": 37.53566247,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 8,
			"dd": 21,
			"by": 1909,
			"bd": 22,
			"bm": 3,
			"nm": "",
			"nf": "David",
			"nl": "Bagby",
			"url": "https://findagrave.com/memorial/141446339",
			"id": 141446339,
			"lng": -77.38730132,
			"lat": 37.53776046,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 1,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Griffin",
			"nl": "Bagby",
			"url": "https://findagrave.com/memorial/181401036",
			"id": 181401036,
			"lng": -77.38797224,
			"lat": 37.53774761,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 5,
			"dd": 2,
			"by": 1909,
			"bd": 22,
			"bm": 3,
			"nm": "",
			"nf": "Jonathan",
			"nl": "Bagby",
			"url": "https://findagrave.com/memorial/142438629",
			"id": 142438629,
			"lng": -77.38728282,
			"lat": 37.53785175,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 4,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "Martha",
			"nl": "Bagby",
			"url": "https://findagrave.com/memorial/143201742",
			"id": 143201742,
			"lng": -77.386355,
			"lat": 37.53536247,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 12,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Anderson",
			"nl": "Bailey",
			"url": "https://findagrave.com/memorial/150677860",
			"id": 150677860,
			"lng": -77.38628134,
			"lat": 37.53569381,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 4,
			"dd": 12,
			"by": 1958,
			"bd": 27,
			"bm": 11,
			"nm": "",
			"nf": "Carl",
			"nl": "Bailey",
			"url": "https://findagrave.com/memorial/183909854",
			"id": 183909854,
			"lng": -77.3864159,
			"lat": 37.53671334,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 2,
			"dd": 28,
			"by": 1853,
			"bd": 1,
			"bm": 12,
			"nm": "",
			"nf": "Charles",
			"nl": "Bailey",
			"url": "https://findagrave.com/memorial/146187836",
			"id": 146187836,
			"lng": -77.38653226,
			"lat": 37.53576103,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 2,
			"dd": 25,
			"by": 1882,
			"bd": "",
			"bm": "",
			"nm": "T.",
			"nf": "Clarence",
			"nl": "Bailey",
			"url": "https://findagrave.com/memorial/142797026",
			"id": 142797026,
			"lng": -77.38609388,
			"lat": 37.53737503,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 1,
			"dd": 23,
			"by": 1917,
			"bd": 19,
			"bm": 1,
			"nm": "Aubrey",
			"nf": "George",
			"nl": "Bailey",
			"url": "https://findagrave.com/memorial/137429999",
			"id": 137429999,
			"lng": -77.38586716,
			"lat": 37.53700924,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 12,
			"dd": 28,
			"by": 1896,
			"bd": 10,
			"bm": 3,
			"nm": "",
			"nf": "Lucinda",
			"nl": "Bailey",
			"url": "https://findagrave.com/memorial/127096005",
			"id": 127096005,
			"lng": -77.38633269,
			"lat": 37.53661136,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 4,
			"dd": 19,
			"by": 1921,
			"bd": 20,
			"bm": 5,
			"nm": "",
			"nf": "William",
			"nl": "Bailey",
			"url": "https://findagrave.com/memorial/161636472",
			"id": 161636472,
			"lng": -77.38605719,
			"lat": 37.53632383,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 3,
			"dd": 10,
			"by": 1908,
			"bd": 1,
			"bm": 8,
			"nm": "R.",
			"nf": "William",
			"nl": "Bailey",
			"url": "https://findagrave.com/memorial/166075720",
			"id": 166075720,
			"lng": -77.38595788,
			"lat": 37.53629337,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 2,
			"dd": 19,
			"by": 1916,
			"bd": "16 (not present in the FindaGrave Record)",
			"bm": 2,
			"nm": "Lee",
			"nf": "Cary",
			"nl": "Baize",
			"url": "https://findagrave.com/memorial/177286503",
			"id": 177286503,
			"lng": -77.38745146,
			"lat": 37.53726877,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 12,
			"dd": 30,
			"by": 1913,
			"bd": 6,
			"bm": 7,
			"nm": "",
			"nf": "Horace",
			"nl": "Baker",
			"url": "https://findagrave.com/memorial/181157220",
			"id": 181157220,
			"lng": -77.38802949,
			"lat": 37.53740608,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 1,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Royal",
			"nl": "Baker",
			"url": "https://findagrave.com/memorial/167872241",
			"id": 167872241,
			"lng": -77.38778631,
			"lat": 37.53704845,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 5,
			"dd": 31,
			"by": 1884,
			"bd": 15,
			"bm": 9,
			"nm": "",
			"nf": "Susie",
			"nl": "Baker",
			"url": "https://findagrave.com/memorial/136304101",
			"id": 136304101,
			"lng": -77.38600216,
			"lat": 37.53694609,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 11,
			"dd": 16,
			"by": 1890,
			"bd": 29,
			"bm": 10,
			"nm": "Edward",
			"nf": "Alson",
			"nl": "Baldwin",
			"url": "https://findagrave.com/memorial/188056080",
			"id": 188056080,
			"lng": -77.38649411,
			"lat": 37.53573501,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 8,
			"dd": 27,
			"by": 1900,
			"bd": 28,
			"bm": 6,
			"nm": "Scott",
			"nf": "Hester",
			"nl": "Ball",
			"url": "https://findagrave.com/memorial/141798896",
			"id": 141798896,
			"lng": -77.38670048,
			"lat": 37.53725993,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 12,
			"dd": 1,
			"by": 1895,
			"bd": 8,
			"bm": 7,
			"nm": "Leoniss",
			"nf": "Luther",
			"nl": "Ball",
			"url": "https://findagrave.com/memorial/129208520",
			"id": 129208520,
			"lng": -77.38596928,
			"lat": 37.53665982,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 3,
			"dd": 22,
			"by": 1873,
			"bd": 8,
			"bm": 7,
			"nm": "",
			"nf": "Spencer",
			"nl": "Ball",
			"url": "https://findagrave.com/memorial/123850429",
			"id": 123850429,
			"lng": -77.38601518,
			"lat": 37.53667007,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 10,
			"dd": 27,
			"by": 1916,
			"bd": 19,
			"bm": 5,
			"nm": "E.",
			"nf": "Sudie",
			"nl": "Ball",
			"url": "https://findagrave.com/memorial/146772734",
			"id": 146772734,
			"lng": -77.38632573,
			"lat": 37.5371314,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 12,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Bessie",
			"nl": "Ballard",
			"url": "https://findagrave.com/memorial/155475128",
			"id": 155475128,
			"lng": -77.38731407,
			"lat": 37.53550834,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 10,
			"dd": 31,
			"by": 1898,
			"bd": 16,
			"bm": 3,
			"nm": "M.",
			"nf": "Dora",
			"nl": "Ballard",
			"url": "https://findagrave.com/memorial/140290776",
			"id": 140290776,
			"lng": -77.38731949,
			"lat": 37.53547529,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 12,
			"dd": 25,
			"by": 1902,
			"bd": 5,
			"bm": 5,
			"nm": "L.",
			"nf": "John",
			"nl": "Ballard",
			"url": "https://findagrave.com/memorial/155476025",
			"id": 155476025,
			"lng": -77.38731646,
			"lat": 37.53549571,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 9,
			"dd": 9,
			"by": 1877,
			"bd": 15,
			"bm": 6,
			"nm": "Lee",
			"nf": "John",
			"nl": "Ballard",
			"url": "https://findagrave.com/memorial/144314796",
			"id": 144314796,
			"lng": -77.38731698,
			"lat": 37.53548628,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1911,
			"dm": 1,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lillie",
			"nl": "Ballard",
			"url": "https://findagrave.com/memorial/145989328",
			"id": 145989328,
			"lng": -77.38656111,
			"lat": 37.53636889,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 3,
			"dd": 30,
			"by": 1911,
			"bd": 18,
			"bm": 2,
			"nm": "H.",
			"nf": "Lillie",
			"nl": "Ballard",
			"url": "https://findagrave.com/memorial/145989355",
			"id": 145989355,
			"lng": -77.386565,
			"lat": 37.53635302,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 8,
			"dd": 7,
			"by": 1916,
			"bd": 25,
			"bm": 7,
			"nm": "L.",
			"nf": "Reese",
			"nl": "Ballard",
			"url": "https://findagrave.com/memorial/155476130",
			"id": 155476130,
			"lng": -77.38731031,
			"lat": 37.53551279,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 8,
			"dd": 7,
			"by": 1905,
			"bd": 21,
			"bm": 2,
			"nm": "B.",
			"nf": "William",
			"nl": "Ballard",
			"url": "https://findagrave.com/memorial/155476528",
			"id": 155476528,
			"lng": -77.38731528,
			"lat": 37.53550447,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 12,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bettie",
			"nl": "Banks",
			"url": "https://findagrave.com/memorial/146207037",
			"id": 146207037,
			"lng": -77.38587384,
			"lat": 37.53671536,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 12,
			"dd": 30,
			"by": 1910,
			"bd": 11,
			"bm": 11,
			"nm": "Henry",
			"nf": "Charles",
			"nl": "Banks",
			"url": "https://findagrave.com/memorial/159661368",
			"id": 159661368,
			"lng": -77.38627279,
			"lat": 37.5374963,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 8,
			"dd": 9,
			"by": 1912,
			"bd": 5,
			"bm": 2,
			"nm": "",
			"nf": "Clara",
			"nl": "Banks",
			"url": "https://findagrave.com/memorial/163905083",
			"id": 163905083,
			"lng": -77.38688963,
			"lat": 37.53685307,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 8,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Della",
			"nl": "Banks",
			"url": "https://findagrave.com/memorial/139403081",
			"id": 139403081,
			"lng": -77.38774514,
			"lat": 37.53691511,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 5,
			"dd": 10,
			"by": 1901,
			"bd": 1,
			"bm": 6,
			"nm": "",
			"nf": "Ethel",
			"nl": "Banks",
			"url": "https://findagrave.com/memorial/158942408",
			"id": 158942408,
			"lng": -77.38740843,
			"lat": 37.53758288,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 1,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Fannie",
			"nl": "Banks",
			"url": "https://findagrave.com/memorial/148747921",
			"id": 148747921,
			"lng": -77.38800376,
			"lat": 37.53711593,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 7,
			"dd": 4,
			"by": 1901,
			"bd": 14,
			"bm": 5,
			"nm": "",
			"nf": "Howard",
			"nl": "Banks",
			"url": "https://findagrave.com/memorial/160048558",
			"id": 160048558,
			"lng": -77.38649694,
			"lat": 37.53751082,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 6,
			"dd": 28,
			"by": 1870,
			"bd": 15,
			"bm": 3,
			"nm": "L.",
			"nf": "John",
			"nl": "Banks",
			"url": "https://findagrave.com/memorial/163441495",
			"id": 163441495,
			"lng": -77.38672354,
			"lat": 37.53684282,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 4,
			"dd": 17,
			"by": 1927,
			"bd": 28,
			"bm": 12,
			"nm": "M.",
			"nf": "Leroy",
			"nl": "Banks",
			"url": "https://findagrave.com/memorial/179569572",
			"id": 179569572,
			"lng": -77.38792101,
			"lat": 37.53779008,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 3,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Marvin",
			"nl": "Banks",
			"url": "https://findagrave.com/memorial/175822202",
			"id": 175822202,
			"lng": -77.3877,
			"lat": 37.53715109,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 1,
			"dd": 4,
			"by": 1866,
			"bd": "",
			"bm": 4,
			"nm": "",
			"nf": "Rebecca",
			"nl": "Hunter",
			"url": "https://findagrave.com/memorial/127568675",
			"id": 127568675,
			"lng": -77.38606074,
			"lat": 37.53709056,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 4,
			"dd": 2,
			"by": 1872,
			"bd": "",
			"bm": 1,
			"nm": "",
			"nf": "Ruth",
			"nl": "Banks",
			"url": "https://findagrave.com/memorial/163441497",
			"id": 163441497,
			"lng": -77.38675516,
			"lat": 37.53684493,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 7,
			"dd": 2,
			"by": 1898,
			"bd": 2,
			"bm": 3,
			"nm": "",
			"nf": "Susie",
			"nl": "Banks",
			"url": "https://findagrave.com/memorial/187744243",
			"id": 187744243,
			"lng": -77.38772867,
			"lat": 37.53696413,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 9,
			"dd": 17,
			"by": 1896,
			"bd": 12,
			"bm": 9,
			"nm": "",
			"nf": "Warren",
			"nl": "Banks",
			"url": "https://findagrave.com/memorial/137835683",
			"id": 137835683,
			"lng": -77.38628599,
			"lat": 37.53707121,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 1,
			"dd": 2,
			"by": 1890,
			"bd": 18,
			"bm": 12,
			"nm": "Henry",
			"nf": "William",
			"nl": "Banks",
			"url": "https://findagrave.com/memorial/157757348",
			"id": 157757348,
			"lng": -77.38683088,
			"lat": 37.53751322,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 6,
			"dd": 15,
			"by": 1897,
			"bd": 27,
			"bm": 10,
			"nm": "",
			"nf": "Beatrice",
			"nl": "Barber",
			"url": "https://findagrave.com/memorial/149485469",
			"id": 149485469,
			"lng": -77.38640245,
			"lat": 37.53683285,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 11,
			"dd": 7,
			"by": 1874,
			"bd": 6,
			"bm": 2,
			"nm": "",
			"nf": "Benjamin",
			"nl": "Barksdale",
			"url": "https://findagrave.com/memorial/180916152",
			"id": 180916152,
			"lng": -77.38706268,
			"lat": 37.53707689,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 11,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jordan",
			"nl": "Barksdale",
			"url": "https://findagrave.com/memorial/177020494",
			"id": 177020494,
			"lng": -77.38790236,
			"lat": 37.53717345,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 7,
			"dd": 4,
			"by": 1911,
			"bd": 12,
			"bm": 6,
			"nm": "Henry",
			"nf": "John",
			"nl": "Barley",
			"url": "https://findagrave.com/memorial/172411382",
			"id": 172411382,
			"lng": -77.38635817,
			"lat": 37.5352667,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 8,
			"dd": 6,
			"by": 1915,
			"bd": 16,
			"bm": 12,
			"nm": "",
			"nf": "Ruth",
			"nl": "Barley",
			"url": "https://findagrave.com/memorial/173773053",
			"id": 173773053,
			"lng": -77.38719958,
			"lat": 37.53736708,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 9,
			"dd": 14,
			"by": 1886,
			"bd": 25,
			"bm": 6,
			"nm": "Daniel",
			"nf": "William",
			"nl": "Barley",
			"url": "https://findagrave.com/memorial/177772011",
			"id": 177772011,
			"lng": -77.38778727,
			"lat": 37.53745746,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 10,
			"dd": 5,
			"by": 1865,
			"bd": 1,
			"bm": 6,
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Barnes",
			"url": "https://findagrave.com/memorial/177154704",
			"id": 177154704,
			"lng": -77.38781444,
			"lat": 37.53742331,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 5,
			"dd": 28,
			"by": 1905,
			"bd": 31,
			"bm": 5,
			"nm": "",
			"nf": "Grace",
			"nl": "Barnes",
			"url": "https://findagrave.com/memorial/172031008",
			"id": 172031008,
			"lng": -77.38708486,
			"lat": 37.53747068,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 5,
			"dd": 25,
			"by": 1898,
			"bd": 15,
			"bm": 6,
			"nm": "",
			"nf": "Joseph",
			"nl": "Barnes",
			"url": "https://findagrave.com/memorial/163611727",
			"id": 163611727,
			"lng": -77.38743941,
			"lat": 37.53748055,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 12,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Laura",
			"nl": "Barnes",
			"url": "https://findagrave.com/memorial/154294633",
			"id": 154294633,
			"lng": -77.38699425,
			"lat": 37.53544592,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1906,
			"dm": 11,
			"dd": 8,
			"by": 1863,
			"bd": 12,
			"bm": 8,
			"nm": "",
			"nf": "Parthenia",
			"nl": "Barnes",
			"url": "https://findagrave.com/memorial/126772043",
			"id": 126772043,
			"lng": -77.38671301,
			"lat": 37.5365639,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 8,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "William",
			"nl": "Barnes",
			"url": "https://findagrave.com/memorial/154294636",
			"id": 154294636,
			"lng": -77.3869897,
			"lat": 37.53544842,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 1,
			"dd": 29,
			"by": 1879,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "George",
			"nl": "Barnum",
			"url": "https://findagrave.com/memorial/177019007",
			"id": 177019007,
			"lng": -77.38785517,
			"lat": 37.5371546,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 10,
			"dd": 30,
			"by": 1910,
			"bd": 1,
			"bm": 12,
			"nm": "M.",
			"nf": "Lucille",
			"nl": "Barton",
			"url": "https://findagrave.com/memorial/152748049",
			"id": 152748049,
			"lng": -77.38640393,
			"lat": 37.53737588,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 6,
			"dd": 22,
			"by": 1852,
			"bd": 15,
			"bm": 7,
			"nm": "J.",
			"nf": "Richard",
			"nl": "Bass",
			"url": "https://findagrave.com/memorial/144314810",
			"id": 144314810,
			"lng": -77.38628618,
			"lat": 37.5359694,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 3,
			"dd": 1,
			"by": 1864,
			"bd": 30,
			"bm": 12,
			"nm": "F.",
			"nf": "Rosetta",
			"nl": "Bass",
			"url": "https://findagrave.com/memorial/144367825",
			"id": 144367825,
			"lng": -77.38628935,
			"lat": 37.53595949,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 11,
			"dd": 17,
			"by": 1892,
			"bd": 24,
			"bm": 9,
			"nm": "Henry",
			"nf": "James",
			"nl": "Bates",
			"url": "https://findagrave.com/memorial/117431728",
			"id": 117431728,
			"lng": -77.38552049,
			"lat": 37.53720593,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 3,
			"dd": 2,
			"by": 1866,
			"bd": 4,
			"bm": 9,
			"nm": "E.",
			"nf": "Martha",
			"nl": "Bates",
			"url": "https://findagrave.com/memorial/145593243",
			"id": 145593243,
			"lng": -77.38553631,
			"lat": 37.53720232,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 9,
			"dd": 4,
			"by": 1895,
			"bd": 28,
			"bm": 2,
			"nm": "",
			"nf": "Rosa",
			"nl": "Bates",
			"url": "https://findagrave.com/memorial/117804333",
			"id": 117804333,
			"lng": -77.38552008,
			"lat": 37.5372003,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 4,
			"dd": 13,
			"by": 1900,
			"bd": 15,
			"bm": 10,
			"nm": "",
			"nf": "Russell",
			"nl": "Bates",
			"url": "https://findagrave.com/memorial/142438652",
			"id": 142438652,
			"lng": -77.38725494,
			"lat": 37.53785747,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 5,
			"dd": 20,
			"by": 1911,
			"bd": 31,
			"bm": 1,
			"nm": "",
			"nf": "Sidney",
			"nl": "Bates",
			"url": "https://findagrave.com/memorial/169904891",
			"id": 169904891,
			"lng": -77.38655139,
			"lat": 37.5371267,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1986,
			"dm": 11,
			"dd": 3,
			"by": 1910,
			"bd": 5,
			"bm": 5,
			"nm": "P.",
			"nf": "Bettie",
			"nl": "Battle",
			"url": "https://findagrave.com/memorial/122020758",
			"id": 122020758,
			"lng": -77.38604075,
			"lat": 37.53659515,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 10,
			"dd": 24,
			"by": 1905,
			"bd": 10,
			"bm": 10,
			"nm": "",
			"nf": "Robert",
			"nl": "Battle",
			"url": "https://findagrave.com/memorial/127719207",
			"id": 127719207,
			"lng": -77.38604624,
			"lat": 37.53658345,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 6,
			"dd": 21,
			"by": 1914,
			"bd": 2,
			"bm": 11,
			"nm": "",
			"nf": "Isaac",
			"nl": "Baxter",
			"url": "https://findagrave.com/memorial/191402806",
			"id": 191402806,
			"lng": -77.38594577,
			"lat": 37.53740221,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 9,
			"dd": 15,
			"by": 1872,
			"bd": 3,
			"bm": 2,
			"nm": "",
			"nf": "John",
			"nl": "Baxter",
			"url": "https://findagrave.com/memorial/145167322",
			"id": 145167322,
			"lng": -77.38632394,
			"lat": 37.53710413,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 6,
			"dd": 11,
			"by": 1912,
			"bd": 5,
			"bm": 11,
			"nm": "",
			"nf": "Geneva",
			"nl": "Baylor",
			"url": "https://findagrave.com/memorial/179551236",
			"id": 179551236,
			"lng": -77.38802081,
			"lat": 37.53776476,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 1,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Elizabeth",
			"nf": "Georgiana",
			"nl": "Baylor",
			"url": "https://findagrave.com/memorial/155979485",
			"id": 155979485,
			"lng": -77.3870974,
			"lat": 37.53553492,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 3,
			"dd": 6,
			"by": 1933,
			"bd": 16,
			"bm": 3,
			"nm": "C.",
			"nf": "Hazel",
			"nl": "Beard",
			"url": "https://findagrave.com/memorial/155021576",
			"id": 155021576,
			"lng": -77.38679668,
			"lat": 37.53730653,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 9,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Dinah",
			"nl": "Beasley",
			"url": "https://findagrave.com/memorial/192019522",
			"id": 192019522,
			"lng": -77.38783935,
			"lat": 37.53738851,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 4,
			"dd": 20,
			"by": 1923,
			"bd": 11,
			"bm": 4,
			"nm": "",
			"nf": "Roosevelt",
			"nl": "Beasley",
			"url": "https://findagrave.com/memorial/175610056",
			"id": 175610056,
			"lng": -77.38769341,
			"lat": 37.53709952,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 5,
			"dd": 31,
			"by": 1928,
			"bd": 17,
			"bm": 4,
			"nm": "Jones n",
			"nf": "Beatrice",
			"nl": "Bell",
			"url": "https://findagrave.com/memorial/173078680",
			"id": 173078680,
			"lng": -77.38702979,
			"lat": 37.53734539,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 6,
			"dd": 24,
			"by": 1905,
			"bd": 1,
			"bm": 6,
			"nm": "M.",
			"nf": "Estelle",
			"nl": "Bell",
			"url": "https://findagrave.com/memorial/125583653",
			"id": 125583653,
			"lng": -77.3861058,
			"lat": 37.53701256,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 9,
			"dd": 22,
			"by": 1921,
			"bd": 27,
			"bm": 9,
			"nm": "Alton",
			"nf": "James",
			"nl": "Bell",
			"url": "https://findagrave.com/memorial/76587692",
			"id": 76587692,
			"lng": -77.38610063,
			"lat": 37.53702482,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 2,
			"dd": 5,
			"by": 1909,
			"bd": 27,
			"bm": 1,
			"nm": "Evelyn",
			"nf": "Jessie",
			"nl": "Bell",
			"url": "https://findagrave.com/memorial/127545284",
			"id": 127545284,
			"lng": -77.38607642,
			"lat": 37.53708588,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 2,
			"dd": 3,
			"by": 1877,
			"bd": 22,
			"bm": 2,
			"nm": "Elizabeth",
			"nf": "Josephine",
			"nl": "Bell",
			"url": "https://findagrave.com/memorial/127428902",
			"id": 127428902,
			"lng": -77.38610566,
			"lat": 37.53709125,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1985,
			"dm": 5,
			"dd": 31,
			"by": 1896,
			"bd": 10,
			"bm": 1,
			"nm": "Bernard",
			"nf": "Robert",
			"nl": "Bell",
			"url": "https://findagrave.com/memorial/76587708",
			"id": 76587708,
			"lng": -77.3860974,
			"lat": 37.53703154,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 10,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Bell",
			"url": "https://findagrave.com/memorial/158436729",
			"id": 158436729,
			"lng": -77.38644264,
			"lat": 37.53679123,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 9,
			"dd": 6,
			"by": 1877,
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "Lucy",
			"nl": "Benjamin",
			"url": "https://findagrave.com/memorial/145989478",
			"id": 145989478,
			"lng": -77.38656249,
			"lat": 37.53638041,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 1,
			"dd": 25,
			"by": 1871,
			"bd": 4,
			"bm": 5,
			"nm": "William",
			"nf": "Walker",
			"nl": "Benjamin",
			"url": "https://findagrave.com/memorial/122020764",
			"id": 122020764,
			"lng": -77.3865615,
			"lat": 37.53638971,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 10,
			"dd": 4,
			"by": 1902,
			"bd": 7,
			"bm": 10,
			"nm": "Mae",
			"nf": "Annie",
			"nl": "Bennett",
			"url": "https://findagrave.com/memorial/138181463",
			"id": 138181463,
			"lng": -77.38641058,
			"lat": 37.53696611,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 10,
			"dd": 24,
			"by": 1917,
			"bd": 15,
			"bm": 3,
			"nm": "M. Pulliam",
			"nf": "Beulah",
			"nl": "Bennett",
			"url": "https://findagrave.com/memorial/150348902",
			"id": 150348902,
			"lng": -77.38651543,
			"lat": 37.53725238,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 1,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "George",
			"nl": "Bennett",
			"url": "https://findagrave.com/memorial/155734401",
			"id": 155734401,
			"lng": -77.38644586,
			"lat": 37.53709541,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 1,
			"dd": 29,
			"by": 1891,
			"bd": 1,
			"bm": 3,
			"nm": "",
			"nf": "Minerva",
			"nl": "Bennett",
			"url": "https://findagrave.com/memorial/183587358",
			"id": 183587358,
			"lng": -77.38635135,
			"lat": 37.53663508,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 5,
			"dd": 23,
			"by": 1911,
			"bd": 30,
			"bm": 4,
			"nm": "P.",
			"nf": "Andrew",
			"nl": "Bentley",
			"url": "https://findagrave.com/memorial/153100485",
			"id": 153100485,
			"lng": -77.38622349,
			"lat": 37.5355303,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 4,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Annie",
			"nl": "Berkley",
			"url": "https://findagrave.com/memorial/141193839",
			"id": 141193839,
			"lng": -77.38629433,
			"lat": 37.5367255,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 2,
			"dd": 16,
			"by": 1892,
			"bd": 20,
			"bm": 1,
			"nm": "A.",
			"nf": "James",
			"nl": "Berkley",
			"url": "https://findagrave.com/memorial/166047356",
			"id": 166047356,
			"lng": -77.38646763,
			"lat": 37.53670074,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 9,
			"dd": 20,
			"by": 1896,
			"bd": 21,
			"bm": 9,
			"nm": "",
			"nf": "Frank",
			"nl": "Berry",
			"url": "https://findagrave.com/memorial/184094495",
			"id": 184094495,
			"lng": -77.38718879,
			"lat": 37.53758411,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 4,
			"dd": 29,
			"by": 1882,
			"bd": "",
			"bm": 9,
			"nm": "",
			"nf": "Frank",
			"nl": "Berry",
			"url": "https://findagrave.com/memorial/185715888",
			"id": 185715888,
			"lng": -77.3877196,
			"lat": 37.53740832,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 3,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lelia",
			"nl": "Berry",
			"url": "https://findagrave.com/memorial/156452656",
			"id": 156452656,
			"lng": -77.38638385,
			"lat": 37.5357604,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 7,
			"dd": 15,
			"by": 1896,
			"bd": 5,
			"bm": 4,
			"nm": "",
			"nf": "Della",
			"nl": "Best",
			"url": "https://findagrave.com/memorial/187342798",
			"id": 187342798,
			"lng": -77.38620565,
			"lat": 37.53735448,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 1,
			"dd": 7,
			"by": 1873,
			"bd": 21,
			"bm": 10,
			"nm": "C.",
			"nf": "Mattie",
			"nl": "Beverley",
			"url": "https://findagrave.com/memorial/145838160",
			"id": 145838160,
			"lng": -77.38676148,
			"lat": 37.53575478,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 2,
			"dd": 6,
			"by": 1885,
			"bd": 9,
			"bm": 10,
			"nm": "Adgers",
			"nf": "Clannie",
			"nl": "Beverly",
			"url": "https://findagrave.com/memorial/122785947",
			"id": 122785947,
			"lng": -77.38621194,
			"lat": 37.53634869,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 3,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Elmer",
			"nl": "Beverly",
			"url": "https://findagrave.com/memorial/128012909",
			"id": 128012909,
			"lng": -77.38621257,
			"lat": 37.53635677,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 2,
			"dd": 26,
			"by": 1888,
			"bd": "",
			"bm": 11,
			"nm": "Elizabeth",
			"nf": "Ollie",
			"nl": "Beverly",
			"url": "https://findagrave.com/memorial/127994249",
			"id": 127994249,
			"lng": -77.386213,
			"lat": 37.53635677,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 2,
			"dd": 1,
			"by": 1913,
			"bd": 17,
			"bm": 8,
			"nm": "Myrtle",
			"nf": "Sallie",
			"nl": "Beverly",
			"url": "https://findagrave.com/memorial/127994649",
			"id": 127994649,
			"lng": -77.38621235,
			"lat": 37.53635675,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 1,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Rosa",
			"nl": "Bickley",
			"url": "https://findagrave.com/memorial/138561623",
			"id": 138561623,
			"lng": -77.38630591,
			"lat": 37.53662765,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 7,
			"dd": 5,
			"by": 1921,
			"bd": 12,
			"bm": 2,
			"nm": "Bullocks",
			"nf": "Ernest",
			"nl": "Billups",
			"url": "https://findagrave.com/memorial/173314362",
			"id": 173314362,
			"lng": -77.38700718,
			"lat": 37.53720717,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 5,
			"dd": 30,
			"by": 1876,
			"bd": 25,
			"bm": 11,
			"nm": "",
			"nf": "Marcellus",
			"nl": "Bingham",
			"url": "https://findagrave.com/memorial/187342805",
			"id": 187342805,
			"lng": -77.38698467,
			"lat": 37.53686915,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 11,
			"dd": 25,
			"by": 1887,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Frank",
			"nl": "Birchett",
			"url": "https://findagrave.com/memorial/145638774",
			"id": 145638774,
			"lng": -77.38633287,
			"lat": 37.53737518,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 9,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rosa",
			"nl": "Blakey",
			"url": "https://findagrave.com/memorial/169485823",
			"id": 169485823,
			"lng": -77.3876919,
			"lat": 37.53697562,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 6,
			"dd": 9,
			"by": 1905,
			"bd": 12,
			"bm": 8,
			"nm": "",
			"nf": "Fannie",
			"nl": "Bland",
			"url": "https://findagrave.com/memorial/184092019",
			"id": 184092019,
			"lng": -77.38590062,
			"lat": 37.53688693,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 8,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Thomas",
			"nf": "James",
			"nl": "Bland",
			"url": "https://findagrave.com/memorial/185378497",
			"id": 185378497,
			"lng": -77.3869628,
			"lat": 37.53761527,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 11,
			"dd": 24,
			"by": 1889,
			"bd": 14,
			"bm": 5,
			"nm": "Elbert",
			"nf": "Louis",
			"nl": "Bland",
			"url": "https://findagrave.com/memorial/144367834",
			"id": 144367834,
			"lng": -77.38633612,
			"lat": 37.537366,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 7,
			"dd": 30,
			"by": 1901,
			"bd": 19,
			"bm": 12,
			"nm": "",
			"nf": "Raymond",
			"nl": "Bland",
			"url": "https://findagrave.com/memorial/160921643",
			"id": 160921643,
			"lng": -77.38678307,
			"lat": 37.53677142,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 4,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Hannah",
			"nl": "Boisseau",
			"url": "https://findagrave.com/memorial/119240738",
			"id": 119240738,
			"lng": -77.38591717,
			"lat": 37.53672769,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 4,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "William",
			"nl": "Boisseau",
			"url": "https://findagrave.com/memorial/146207044",
			"id": 146207044,
			"lng": -77.38586504,
			"lat": 37.53673821,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 2,
			"dd": 13,
			"by": 1908,
			"bd": 22,
			"bm": 6,
			"nm": "W.",
			"nf": "William",
			"nl": "Boisseau",
			"url": "https://findagrave.com/memorial/119240758",
			"id": 119240758,
			"lng": -77.38591198,
			"lat": 37.53673917,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 12,
			"by": 1909,
			"bd": 2,
			"bm": 5,
			"nm": "C.",
			"nf": "William",
			"nl": "Bolding",
			"url": "https://findagrave.com/memorial/185652129",
			"id": 185652129,
			"lng": -77.38741713,
			"lat": 37.53735268,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 19,
			"by": 1903,
			"bd": 2,
			"bm": 3,
			"nm": "",
			"nf": "Willie",
			"nl": "Bolling",
			"url": "https://findagrave.com/memorial/177279883",
			"id": 177279883,
			"lng": -77.38732404,
			"lat": 37.53723569,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 9,
			"dd": 29,
			"by": 1922,
			"bd": 17,
			"bm": 2,
			"nm": "Virginia",
			"nf": "Dorothy",
			"nl": "Booker",
			"url": "https://findagrave.com/memorial/169456739",
			"id": 169456739,
			"lng": -77.38781661,
			"lat": 37.53700397,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 7,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Gertrude",
			"nl": "Booker",
			"url": "https://findagrave.com/memorial/155507981",
			"id": 155507981,
			"lng": -77.38765422,
			"lat": 37.53771551,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 9,
			"dd": 25,
			"by": 1890,
			"bd": 2,
			"bm": 6,
			"nm": "W.",
			"nf": "Henry",
			"nl": "Booker",
			"url": "https://findagrave.com/memorial/123587168",
			"id": 123587168,
			"lng": -77.38591131,
			"lat": 37.53669275,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 10,
			"dd": 17,
			"by": 1917,
			"bd": 5,
			"bm": 11,
			"nm": "Mae",
			"nf": "Katie",
			"nl": "Booker",
			"url": "https://findagrave.com/memorial/159760618",
			"id": 159760618,
			"lng": -77.38622792,
			"lat": 37.5375237,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 2,
			"dd": 25,
			"by": 1892,
			"bd": 22,
			"bm": 6,
			"nm": "",
			"nf": "Lucy",
			"nl": "Booker",
			"url": "https://findagrave.com/memorial/127988059",
			"id": 127988059,
			"lng": -77.38591744,
			"lat": 37.53669451,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 1,
			"dd": 16,
			"by": 1887,
			"bd": 10,
			"bm": 5,
			"nm": "",
			"nf": "Mary",
			"nl": "Booker",
			"url": "https://findagrave.com/memorial/144188784",
			"id": 144188784,
			"lng": -77.38746433,
			"lat": 37.53778918,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 9,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Spencer",
			"nl": "Booker",
			"url": "https://findagrave.com/memorial/161097120",
			"id": 161097120,
			"lng": -77.38708659,
			"lat": 37.53705032,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 1,
			"dd": 13,
			"by": 1871,
			"bd": 10,
			"bm": 3,
			"nm": "",
			"nf": "William",
			"nl": "Booker",
			"url": "https://findagrave.com/memorial/156932637",
			"id": 156932637,
			"lng": -77.38696908,
			"lat": 37.5374805,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 2,
			"dd": 24,
			"by": 1885,
			"bd": 28,
			"bm": 2,
			"nm": "",
			"nf": "Rachel",
			"nl": "Boone",
			"url": "https://findagrave.com/memorial/119240774",
			"id": 119240774,
			"lng": -77.38579756,
			"lat": 37.53669961,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 2,
			"dd": 24,
			"by": 1891,
			"bd": 14,
			"bm": 3,
			"nm": "Lee",
			"nf": "Rose",
			"nl": "Bosher",
			"url": "https://findagrave.com/memorial/147852958",
			"id": 147852958,
			"lng": -77.38698276,
			"lat": 37.53713191,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 7,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Roberta",
			"nl": "Bossieux",
			"url": "https://findagrave.com/memorial/125805373",
			"id": 125805373,
			"lng": -77.38593053,
			"lat": 37.53618782,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 5,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sarah",
			"nl": "Bossieux",
			"url": "https://findagrave.com/memorial/188438663",
			"id": 188438663,
			"lng": -77.38790011,
			"lat": 37.537028,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 6,
			"dd": 20,
			"by": 1893,
			"bd": 5,
			"bm": 8,
			"nm": "Mae",
			"nf": "Annie",
			"nl": "Boulware",
			"url": "https://findagrave.com/memorial/117180381",
			"id": 117180381,
			"lng": -77.38580608,
			"lat": 37.53708224,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 12,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Dorothy",
			"nl": "Boulware",
			"url": "https://findagrave.com/memorial/145325103",
			"id": 145325103,
			"lng": -77.38582242,
			"lat": 37.53707805,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 8,
			"dd": 29,
			"by": 1883,
			"bd": 9,
			"bm": 7,
			"nm": "David",
			"nf": "Samuel",
			"nl": "Boulware",
			"url": "https://findagrave.com/memorial/117180413",
			"id": 117180413,
			"lng": -77.38581129,
			"lat": 37.53708347,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 2,
			"dd": 25,
			"by": 1917,
			"bd": 7,
			"bm": 12,
			"nm": "J.",
			"nf": "Samuel",
			"nl": "Boulware",
			"url": "https://findagrave.com/memorial/145325116",
			"id": 145325116,
			"lng": -77.38582516,
			"lat": 37.53707051,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 2,
			"dd": 7,
			"by": 1880,
			"bd": 25,
			"bm": 12,
			"nm": "T.",
			"nf": "Silas",
			"nl": "Boulware",
			"url": "https://findagrave.com/memorial/122786030",
			"id": 122786030,
			"lng": -77.38575025,
			"lat": 37.53701619,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 9,
			"dd": 1,
			"by": 1881,
			"bd": 12,
			"bm": 10,
			"nm": "",
			"nf": "Victoria",
			"nl": "Bowen",
			"url": "https://findagrave.com/memorial/134454159",
			"id": 134454159,
			"lng": -77.38727275,
			"lat": 37.53650334,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 5,
			"dd": 14,
			"by": 1885,
			"bd": 15,
			"bm": 9,
			"nm": "A.",
			"nf": "Daniel",
			"nl": "Bowler",
			"url": "https://findagrave.com/memorial/155507986",
			"id": 155507986,
			"lng": -77.38761385,
			"lat": 37.53762055,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 5,
			"dd": 30,
			"by": 1876,
			"bd": 18,
			"bm": 11,
			"nm": "",
			"nf": "Gezlla",
			"nl": "Bowler",
			"url": "https://findagrave.com/memorial/149165818",
			"id": 149165818,
			"lng": -77.38610749,
			"lat": 37.53575801,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": 7,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Marcus",
			"nl": "Bowles",
			"url": "https://findagrave.com/memorial/158436744",
			"id": 158436744,
			"lng": -77.38663986,
			"lat": 37.53601496,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 4,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nannie",
			"nl": "Bowles",
			"url": "https://findagrave.com/memorial/143631816",
			"id": 143631816,
			"lng": -77.38602098,
			"lat": 37.53592362,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 6,
			"dd": 30,
			"by": 1878,
			"bd": 1,
			"bm": 1,
			"nm": "",
			"nf": "Emma",
			"nl": "Bowls",
			"url": "https://findagrave.com/memorial/170604687",
			"id": 170604687,
			"lng": -77.38684641,
			"lat": 37.53695973,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 12,
			"dd": 9,
			"by": 1873,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Washington",
			"nl": "Bowman",
			"url": "https://findagrave.com/memorial/125292189",
			"id": 125292189,
			"lng": -77.38801493,
			"lat": 37.53717515,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 6,
			"dd": 29,
			"by": 1885,
			"bd": 29,
			"bm": 3,
			"nm": "Estelle",
			"nf": "Alice",
			"nl": "Bowser",
			"url": "https://findagrave.com/memorial/24865504",
			"id": 24865504,
			"lng": -77.38595954,
			"lat": 37.53645164,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1906,
			"dm": 7,
			"dd": 20,
			"by": 1881,
			"bd": 1,
			"bm": 12,
			"nm": "Logan",
			"nf": "Lena",
			"nl": "Bowser",
			"url": "https://findagrave.com/memorial/24865519",
			"id": 24865519,
			"lng": -77.38593859,
			"lat": 37.53643615,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 7,
			"dd": 5,
			"by": 1880,
			"bd": 10,
			"bm": 8,
			"nm": "Barrington Herndon",
			"nf": "Oswald",
			"nl": "Bowser",
			"url": "https://findagrave.com/memorial/24865396",
			"id": 24865396,
			"lng": -77.38595691,
			"lat": 37.53646039,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 2,
			"dd": 7,
			"by": 1855,
			"bd": 7,
			"bm": 1,
			"nm": "L.",
			"nf": "Rosa",
			"nl": "Bowser",
			"url": "https://findagrave.com/memorial/11255726",
			"id": 11255726,
			"lng": -77.38596423,
			"lat": 37.53643617,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 2,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Louise",
			"nl": "Boxley",
			"url": "https://findagrave.com/memorial/178924797",
			"id": 178924797,
			"lng": -77.38729994,
			"lat": 37.5362712,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 6,
			"dd": 14,
			"by": 1884,
			"bd": 3,
			"bm": 8,
			"nm": "",
			"nf": "Alec",
			"nl": "Boyd",
			"url": "https://findagrave.com/memorial/144102041",
			"id": 144102041,
			"lng": -77.38595788,
			"lat": 37.53738979,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 4,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bettie",
			"nl": "Boyd",
			"url": "https://findagrave.com/memorial/176712949",
			"id": 176712949,
			"lng": -77.38755811,
			"lat": 37.5371711,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 4,
			"dd": 13,
			"by": 1963,
			"bd": 23,
			"bm": 9,
			"nm": "",
			"nf": "Danny",
			"nl": "Boyd",
			"url": "https://findagrave.com/memorial/142797031",
			"id": 142797031,
			"lng": -77.38604308,
			"lat": 37.53745135,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 4,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Robert",
			"nl": "Boyd",
			"url": "https://findagrave.com/memorial/176712609",
			"id": 176712609,
			"lng": -77.38755536,
			"lat": 37.5371802,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 3,
			"dd": 1,
			"by": 1910,
			"bd": 27,
			"bm": 7,
			"nm": "",
			"nf": "Virginia",
			"nl": "Boyd",
			"url": "https://findagrave.com/memorial/148455098",
			"id": 148455098,
			"lng": -77.38611957,
			"lat": 37.53618416,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 8,
			"dd": 17,
			"by": 1908,
			"bd": 21,
			"bm": 11,
			"nm": "",
			"nf": "Troy",
			"nl": "Braddy",
			"url": "https://findagrave.com/memorial/148285631",
			"id": 148285631,
			"lng": -77.38636972,
			"lat": 37.53730884,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 3,
			"dd": 8,
			"by": 1880,
			"bd": 14,
			"bm": 10,
			"nm": "James",
			"nf": "Daniel",
			"nl": "Bradford",
			"url": "https://findagrave.com/memorial/154243868",
			"id": 154243868,
			"lng": -77.38644476,
			"lat": 37.53550778,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 1,
			"dd": 22,
			"by": 1883,
			"bd": 3,
			"bm": 9,
			"nm": "Louise",
			"nf": "Edith",
			"nl": "Bradford",
			"url": "https://findagrave.com/memorial/154243791",
			"id": 154243791,
			"lng": -77.38645368,
			"lat": 37.53550887,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 12,
			"dd": 26,
			"by": 1900,
			"bd": 28,
			"bm": 6,
			"nm": "",
			"nf": "Louise",
			"nl": "Bradford",
			"url": "https://findagrave.com/memorial/191417543",
			"id": 191417543,
			"lng": -77.38640975,
			"lat": 37.53746151,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 6,
			"dd": 13,
			"by": 1924,
			"bd": 5,
			"bm": 2,
			"nm": "",
			"nf": "Josephine",
			"nl": "Bradley",
			"url": "https://findagrave.com/memorial/173078146",
			"id": 173078146,
			"lng": -77.38729704,
			"lat": 37.53737239,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 7,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mamie",
			"nl": "Bradley",
			"url": "https://findagrave.com/memorial/178152871",
			"id": 178152871,
			"lng": -77.38776302,
			"lat": 37.53716022,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1981,
			"dm": 2,
			"dd": 15,
			"by": 1898,
			"bd": 25,
			"bm": 8,
			"nm": "",
			"nf": "Sadie",
			"nl": "Bradley",
			"url": "https://findagrave.com/memorial/130692295",
			"id": 130692295,
			"lng": -77.38568732,
			"lat": 37.53718615,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 7,
			"dd": 31,
			"by": 1883,
			"bd": "",
			"bm": "",
			"nm": "F.",
			"nf": "Mary",
			"nl": "Bradshaw",
			"url": "https://findagrave.com/memorial/170129833",
			"id": 170129833,
			"lng": -77.38678534,
			"lat": 37.53690326,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 2,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mattie",
			"nl": "Bradshaw",
			"url": "https://findagrave.com/memorial/134454168",
			"id": 134454168,
			"lng": -77.3864825,
			"lat": 37.53699742,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 3,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Aaron",
			"nl": "Branch",
			"url": "https://findagrave.com/memorial/174688582",
			"id": 174688582,
			"lng": -77.38763138,
			"lat": 37.53710381,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 11,
			"dd": 10,
			"by": 1891,
			"bd": 24,
			"bm": 12,
			"nm": "Hundley",
			"nf": "George",
			"nl": "Branch",
			"url": "https://findagrave.com/memorial/160921652",
			"id": 160921652,
			"lng": -77.38649185,
			"lat": 37.53684997,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 2,
			"dd": 11,
			"by": 1862,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Henry",
			"nl": "Branch",
			"url": "https://findagrave.com/memorial/186818072",
			"id": 186818072,
			"lng": -77.3873942,
			"lat": 37.53768038,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 5,
			"dd": 22,
			"by": "",
			"bd": 1,
			"bm": 10,
			"nm": "R.",
			"nf": "John",
			"nl": "Branch",
			"url": "https://findagrave.com/memorial/185958399",
			"id": 185958399,
			"lng": -77.38633588,
			"lat": 37.53595919,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 1,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Mary",
			"nl": "Branch",
			"url": "https://findagrave.com/memorial/166514675",
			"id": 166514675,
			"lng": -77.38764057,
			"lat": 37.53690764,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 3,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Talley",
			"nf": "Rosa",
			"nl": "Branch",
			"url": "https://findagrave.com/memorial/130539003",
			"id": 130539003,
			"lng": -77.38638439,
			"lat": 37.536911,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 5,
			"dd": 31,
			"by": 1962,
			"bd": 31,
			"bm": 7,
			"nm": "Melvin",
			"nf": "Eugene",
			"nl": "Brandon",
			"url": "https://findagrave.com/memorial/169042185",
			"id": 169042185,
			"lng": -77.38608591,
			"lat": 37.53748039,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 7,
			"dd": 9,
			"by": 1865,
			"bd": 1,
			"bm": 6,
			"nm": "",
			"nf": "Annie",
			"nl": "Branic",
			"url": "https://findagrave.com/memorial/76587717",
			"id": 76587717,
			"lng": -77.38610486,
			"lat": 37.53671729,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 12,
			"dd": 11,
			"by": 1861,
			"bd": "",
			"bm": 11,
			"nm": "Ann",
			"nf": "Celia",
			"nl": "Braxton",
			"url": "https://findagrave.com/memorial/152528294",
			"id": 152528294,
			"lng": -77.38587576,
			"lat": 37.53641688,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 5,
			"dd": 22,
			"by": 1859,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Cordelia",
			"nl": "Braxton",
			"url": "https://findagrave.com/memorial/170129962",
			"id": 170129962,
			"lng": -77.38780701,
			"lat": 37.5371943,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 12,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Edmonia",
			"nl": "Braxton",
			"url": "https://findagrave.com/memorial/184094505",
			"id": 184094505,
			"lng": -77.38712884,
			"lat": 37.53758751,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 6,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Eliza",
			"nl": "Braxton",
			"url": "https://findagrave.com/memorial/177768005",
			"id": 177768005,
			"lng": -77.38781207,
			"lat": 37.53717287,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 6,
			"dd": 23,
			"by": 1885,
			"bd": 18,
			"bm": 2,
			"nm": "E.",
			"nf": "Florence",
			"nl": "Braxton",
			"url": "https://findagrave.com/memorial/142438664",
			"id": 142438664,
			"lng": -77.38578961,
			"lat": 37.53734967,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 7,
			"dd": 28,
			"by": 1887,
			"bd": 19,
			"bm": 7,
			"nm": "Nelson",
			"nf": "George",
			"nl": "Braxton",
			"url": "https://findagrave.com/memorial/170129841",
			"id": 170129841,
			"lng": -77.38681968,
			"lat": 37.53693768,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 4,
			"dd": 16,
			"by": 1878,
			"bd": 3,
			"bm": 5,
			"nm": "",
			"nf": "Laura",
			"nl": "Braxton",
			"url": "https://findagrave.com/memorial/125514725",
			"id": 125514725,
			"lng": -77.38591563,
			"lat": 37.53700167,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 10,
			"dd": 10,
			"by": 1899,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucy",
			"nl": "Braxton",
			"url": "https://findagrave.com/memorial/173773061",
			"id": 173773061,
			"lng": -77.38722719,
			"lat": 37.53740573,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 5,
			"dd": 27,
			"by": 1890,
			"bd": 8,
			"bm": 2,
			"nm": "Thompson",
			"nf": "Noah",
			"nl": "Braxton",
			"url": "https://findagrave.com/memorial/145989498",
			"id": 145989498,
			"lng": -77.38579526,
			"lat": 37.53689077,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 4,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Draper",
			"nf": "Pearl",
			"nl": "Braxton",
			"url": "https://findagrave.com/memorial/158677664",
			"id": 158677664,
			"lng": -77.3868061,
			"lat": 37.53763431,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 7,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Peter",
			"nl": "Braxton",
			"url": "https://findagrave.com/memorial/158432048",
			"id": 158432048,
			"lng": -77.38696767,
			"lat": 37.53757515,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 7,
			"dd": 12,
			"by": 1905,
			"bd": 5,
			"bm": 10,
			"nm": "T. H.",
			"nf": "Sadie",
			"nl": "Braxton",
			"url": "https://findagrave.com/memorial/159885887",
			"id": 159885887,
			"lng": -77.3878215,
			"lat": 37.53752514,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 12,
			"dd": 8,
			"by": 1897,
			"bd": 9,
			"bm": 2,
			"nm": "Lee",
			"nf": "Vance",
			"nl": "Braxton",
			"url": "https://findagrave.com/memorial/173773068",
			"id": 173773068,
			"lng": -77.38722769,
			"lat": 37.53739752,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 6,
			"dd": 24,
			"by": 1904,
			"bd": 7,
			"bm": 9,
			"nm": "B.",
			"nf": "William",
			"nl": "Braxton",
			"url": "https://findagrave.com/memorial/125514734",
			"id": 125514734,
			"lng": -77.38590345,
			"lat": 37.5369993,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1980,
			"dm": 3,
			"dd": 15,
			"by": 1904,
			"bd": 18,
			"bm": 9,
			"nm": "",
			"nf": "Mamie",
			"nl": "Brevard",
			"url": "https://findagrave.com/memorial/162131916",
			"id": 162131916,
			"lng": -77.3858136,
			"lat": 37.53714517,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 6,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mattie",
			"nl": "Brewer",
			"url": "https://findagrave.com/memorial/188244618",
			"id": 188244618,
			"lng": -77.38797241,
			"lat": 37.53718665,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 5,
			"dd": 13,
			"by": 1907,
			"bd": 30,
			"bm": 8,
			"nm": "",
			"nf": "George",
			"nl": "Brice",
			"url": "https://findagrave.com/memorial/144820106",
			"id": 144820106,
			"lng": -77.38555936,
			"lat": 37.53727335,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 5,
			"dd": 20,
			"by": 1936,
			"bd": 22,
			"bm": 5,
			"nm": "",
			"nf": "John",
			"nl": "Bridy",
			"url": "https://findagrave.com/memorial/169905215",
			"id": 169905215,
			"lng": -77.38657192,
			"lat": 37.53712932,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 7,
			"dd": 23,
			"by": 1945,
			"bd": 25,
			"bm": 4,
			"nm": "",
			"nf": "Willie",
			"nl": "Bridy",
			"url": "https://findagrave.com/memorial/149486781",
			"id": 149486781,
			"lng": -77.3865306,
			"lat": 37.53684862,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 9,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Carrie",
			"nl": "Briggs",
			"url": "https://findagrave.com/memorial/183697430",
			"id": 183697430,
			"lng": -77.38703147,
			"lat": 37.53693675,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 12,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A. J.",
			"nf": "Charles",
			"nl": "Briggs",
			"url": "https://findagrave.com/memorial/144367998",
			"id": 144367998,
			"lng": -77.38640601,
			"lat": 37.53578473,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1907,
			"dm": 1,
			"dd": 7,
			"by": 1850,
			"bd": "",
			"bm": 12,
			"nm": "",
			"nf": "Lavinia",
			"nl": "Briggs",
			"url": "https://findagrave.com/memorial/127853281",
			"id": 127853281,
			"lng": -77.38638064,
			"lat": 37.53653427,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 10,
			"dd": 8,
			"by": 1927,
			"bd": 16,
			"bm": 6,
			"nm": "",
			"nf": "Leroy",
			"nl": "Briggs",
			"url": "https://findagrave.com/memorial/155507997",
			"id": 155507997,
			"lng": -77.38768934,
			"lat": 37.53762692,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1907,
			"dm": 9,
			"dd": 21,
			"by": 1889,
			"bd": 12,
			"bm": 10,
			"nm": "Virginia",
			"nf": "Pearl",
			"nl": "Briggs",
			"url": "https://findagrave.com/memorial/148460015",
			"id": 148460015,
			"lng": -77.38625397,
			"lat": 37.53543908,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 5,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Thomas",
			"nl": "Briggs",
			"url": "https://findagrave.com/memorial/170604694",
			"id": 170604694,
			"lng": -77.38686001,
			"lat": 37.53695119,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 1,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Watson",
			"nl": "Briggs",
			"url": "https://findagrave.com/memorial/132046752",
			"id": 132046752,
			"lng": -77.38775248,
			"lat": 37.53656306,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 4,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "George",
			"nl": "Bright",
			"url": "https://findagrave.com/memorial/159880468",
			"id": 159880468,
			"lng": -77.38789485,
			"lat": 37.53697667,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 5,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Jane",
			"nf": "Sarah",
			"nl": "Bright",
			"url": "https://findagrave.com/memorial/166104345",
			"id": 166104345,
			"lng": -77.38708012,
			"lat": 37.53663349,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 5,
			"dd": 16,
			"by": 1883,
			"bd": 10,
			"bm": 5,
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Brinkley",
			"url": "https://findagrave.com/memorial/173785238",
			"id": 173785238,
			"lng": -77.38735105,
			"lat": 37.53713026,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 9,
			"dd": 15,
			"by": 1887,
			"bd": 1,
			"bm": 7,
			"nm": "",
			"nf": "Frederick",
			"nl": "Brinkley",
			"url": "https://findagrave.com/memorial/173782098",
			"id": 173782098,
			"lng": -77.38736365,
			"lat": 37.53710221,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 8,
			"dd": 28,
			"by": 1931,
			"bd": 12,
			"bm": 9,
			"nm": "Mae",
			"nf": "Aurelia",
			"nl": "Bristow",
			"url": "https://findagrave.com/memorial/153511873",
			"id": 153511873,
			"lng": -77.38659511,
			"lat": 37.53719829,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 6,
			"dd": 4,
			"by": 1917,
			"bd": 3,
			"bm": 5,
			"nm": "",
			"nf": "Madie",
			"nl": "Britton",
			"url": "https://findagrave.com/memorial/185958402",
			"id": 185958402,
			"lng": -77.38635075,
			"lat": 37.53595851,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 12,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mildred",
			"nl": "Britton",
			"url": "https://findagrave.com/memorial/173908763",
			"id": 173908763,
			"lng": -77.38758349,
			"lat": 37.53716322,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 4,
			"dd": 15,
			"by": 1917,
			"bd": 12,
			"bm": 9,
			"nm": "Elizabeth",
			"nf": "Mary",
			"nl": "Brockenborough",
			"url": "https://findagrave.com/memorial/157623533",
			"id": 157623533,
			"lng": -77.38666958,
			"lat": 37.53745504,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 4,
			"dd": 14,
			"by": 1895,
			"bd": 12,
			"bm": 10,
			"nm": "",
			"nf": "Samuel",
			"nl": "Bronson",
			"url": "https://findagrave.com/memorial/136171610",
			"id": 136171610,
			"lng": -77.38593256,
			"lat": 37.53633114,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 6,
			"dd": 27,
			"by": 1895,
			"bd": 15,
			"bm": 9,
			"nm": "",
			"nf": "Addie",
			"nl": "Bronston",
			"url": "https://findagrave.com/memorial/142106148",
			"id": 142106148,
			"lng": -77.38572557,
			"lat": 37.53743358,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 6,
			"dd": 8,
			"by": 1896,
			"bd": 20,
			"bm": 12,
			"nm": "",
			"nf": "Alexander",
			"nl": "Brooks",
			"url": "https://findagrave.com/memorial/177490457",
			"id": 177490457,
			"lng": -77.38775402,
			"lat": 37.53735893,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 10,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "baby",
			"nl": "Brooks",
			"url": "https://findagrave.com/memorial/163925085",
			"id": 163925085,
			"lng": -77.38667852,
			"lat": 37.53681506,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 12,
			"dd": 2,
			"by": 1922,
			"bd": 10,
			"bm": 11,
			"nm": "P.",
			"nf": "Benjamin",
			"nl": "Brooks",
			"url": "https://findagrave.com/memorial/138561629",
			"id": 138561629,
			"lng": -77.38627257,
			"lat": 37.53658141,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 9,
			"dd": 30,
			"by": 1920,
			"bd": 7,
			"bm": 12,
			"nm": "M.",
			"nf": "Jerry",
			"nl": "Brooks",
			"url": "https://findagrave.com/memorial/154037657",
			"id": 154037657,
			"lng": -77.38656836,
			"lat": 37.53718545,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 6,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lillian",
			"nl": "Brooks",
			"url": "https://findagrave.com/memorial/186818009",
			"id": 186818009,
			"lng": -77.38740721,
			"lat": 37.53771295,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1905,
			"dm": 11,
			"dd": 30,
			"by": 1832,
			"bd": 25,
			"bm": 12,
			"nm": "",
			"nf": "Lucy",
			"nl": "Brooks",
			"url": "https://findagrave.com/memorial/145989513",
			"id": 145989513,
			"lng": -77.38664219,
			"lat": 37.53656031,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 12,
			"dd": 2,
			"by": 1900,
			"bd": 29,
			"bm": 9,
			"nm": "W.",
			"nf": "Maria",
			"nl": "Brooks",
			"url": "https://findagrave.com/memorial/145638778",
			"id": 145638778,
			"lng": -77.38628152,
			"lat": 37.53738095,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 6,
			"dd": 17,
			"by": 1892,
			"bd": 19,
			"bm": 5,
			"nm": "",
			"nf": "Mary",
			"nl": "Brooks",
			"url": "https://findagrave.com/memorial/153511883",
			"id": 153511883,
			"lng": -77.38678694,
			"lat": 37.53728263,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 2,
			"dd": 7,
			"by": 1886,
			"bd": 15,
			"bm": 9,
			"nm": "M.",
			"nf": "William",
			"nl": "Brooks",
			"url": "https://findagrave.com/memorial/153511891",
			"id": 153511891,
			"lng": -77.38678048,
			"lat": 37.53729362,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 5,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "Alice",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/171733158",
			"id": 171733158,
			"lng": -77.38688228,
			"lat": 37.53710454,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 3,
			"dd": 31,
			"by": 1924,
			"bd": 18,
			"bm": 6,
			"nm": "Beatrice",
			"nf": "Alma",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/166823755",
			"id": 166823755,
			"lng": -77.38802531,
			"lat": 37.53749292,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 10,
			"dd": 1,
			"by": 1963,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alvin",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/187342810",
			"id": 187342810,
			"lng": -77.38610008,
			"lat": 37.53746972,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 2,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Anna",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/129208522",
			"id": 129208522,
			"lng": -77.3863226,
			"lat": 37.53687216,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 5,
			"dd": 14,
			"by": 1888,
			"bd": 4,
			"bm": 5,
			"nm": "Mae",
			"nf": "Annie",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/169136555",
			"id": 169136555,
			"lng": -77.38568605,
			"lat": 37.53745067,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 6,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Archie",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/167182269",
			"id": 167182269,
			"lng": -77.38661121,
			"lat": 37.53680765,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 3,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ause",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/176055714",
			"id": 176055714,
			"lng": -77.38733921,
			"lat": 37.5370769,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 10,
			"dd": 30,
			"by": 1883,
			"bd": "",
			"bm": "",
			"nm": "S.",
			"nf": "Carrie",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/136171619",
			"id": 136171619,
			"lng": -77.3864407,
			"lat": 37.53640389,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 5,
			"dd": 25,
			"by": 1880,
			"bd": 2,
			"bm": 7,
			"nm": "C.",
			"nf": "Claude",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/127428916",
			"id": 127428916,
			"lng": -77.3864734,
			"lat": 37.53641214,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 3,
			"dd": 13,
			"by": 1897,
			"bd": "",
			"bm": 7,
			"nm": "",
			"nf": "Clinton",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/136171628",
			"id": 136171628,
			"lng": -77.38645007,
			"lat": 37.53637064,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 9,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Diana",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/166515917",
			"id": 166515917,
			"lng": -77.38766861,
			"lat": 37.53704162,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 8,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Dora",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/183194444",
			"id": 183194444,
			"lng": -77.38731455,
			"lat": 37.53705118,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 8,
			"dd": 30,
			"by": 1914,
			"bd": 4,
			"bm": 9,
			"nm": "William",
			"nf": "Eddie",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/182090440",
			"id": 182090440,
			"lng": -77.38665365,
			"lat": 37.53767373,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 11,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Guy",
			"nf": "Edward",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/174622135",
			"id": 174622135,
			"lng": -77.38693885,
			"lat": 37.53725971,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1909,
			"dm": 7,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/149771181",
			"id": 149771181,
			"lng": -77.38623861,
			"lat": 37.53590252,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ellen",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/187342816",
			"id": 187342816,
			"lng": -77.38775862,
			"lat": 37.53628293,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 5,
			"dd": 5,
			"by": 1862,
			"bd": 31,
			"bm": 8,
			"nm": "M.",
			"nf": "Ellen",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/138561645",
			"id": 138561645,
			"lng": -77.38647645,
			"lat": 37.53634744,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 10,
			"dd": 20,
			"by": 1904,
			"bd": 2,
			"bm": 6,
			"nm": "L.",
			"nf": "Ernest",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/178723689",
			"id": 178723689,
			"lng": -77.38784941,
			"lat": 37.5374161,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 8,
			"dd": 4,
			"by": 1875,
			"bd": 13,
			"bm": 3,
			"nm": "P.",
			"nf": "Eugertha",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/154534360",
			"id": 154534360,
			"lng": -77.38639427,
			"lat": 37.53565259,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 7,
			"dd": 12,
			"by": 1920,
			"bd": "",
			"bm": "",
			"nm": "Louise",
			"nf": "Eva",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/117431772",
			"id": 117431772,
			"lng": -77.38549161,
			"lat": 37.53732971,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 6,
			"dd": 13,
			"by": 1976,
			"bd": 13,
			"bm": 6,
			"nm": "Edward",
			"nf": "Frederick",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/158025880",
			"id": 158025880,
			"lng": -77.38617947,
			"lat": 37.53728303,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 4,
			"dd": 28,
			"by": 1895,
			"bd": 15,
			"bm": 6,
			"nm": "",
			"nf": "Garcine",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/170814996",
			"id": 170814996,
			"lng": -77.38636697,
			"lat": 37.53675939,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 1,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Garfield",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/144314822",
			"id": 144314822,
			"lng": -77.38773249,
			"lat": 37.53796106,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 3,
			"dd": 21,
			"by": 1882,
			"bd": 5,
			"bm": 5,
			"nm": "",
			"nf": "Henretta",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/113750730",
			"id": 113750730,
			"lng": -77.3862588,
			"lat": 37.53686852,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 6,
			"dd": 16,
			"by": 1895,
			"bd": 4,
			"bm": 3,
			"nm": "",
			"nf": "Henry",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/158433848",
			"id": 158433848,
			"lng": -77.38677797,
			"lat": 37.53758714,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 11,
			"dd": 27,
			"by": 1950,
			"bd": 16,
			"bm": 7,
			"nm": "Eugene",
			"nf": "Horace",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/158432440",
			"id": 158432440,
			"lng": -77.38684881,
			"lat": 37.53761059,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 4,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ida",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/175421370",
			"id": 175421370,
			"lng": -77.38751393,
			"lat": 37.53712788,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 9,
			"dd": 30,
			"by": 1900,
			"bd": 15,
			"bm": 3,
			"nm": "",
			"nf": "Isaiah",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/185564826",
			"id": 185564826,
			"lng": -77.38678859,
			"lat": 37.53678565,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 2,
			"dd": 11,
			"by": 1888,
			"bd": 5,
			"bm": 7,
			"nm": "",
			"nf": "Jacob",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/151943361",
			"id": 151943361,
			"lng": -77.38666508,
			"lat": 37.5357489,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 6,
			"dd": 15,
			"by": 1901,
			"bd": 8,
			"bm": 8,
			"nm": "",
			"nf": "James",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/173773076",
			"id": 173773076,
			"lng": -77.38728536,
			"lat": 37.53734959,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 6,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "James",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/129208525",
			"id": 129208525,
			"lng": -77.3863265,
			"lat": 37.53686305,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1984,
			"dm": 10,
			"dd": 27,
			"by": 1909,
			"bd": 28,
			"bm": 10,
			"nm": "L.",
			"nf": "James",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/115720549",
			"id": 115720549,
			"lng": -77.38603742,
			"lat": 37.53711824,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 7,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jennie",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/151692128",
			"id": 151692128,
			"lng": -77.38659352,
			"lat": 37.53541846,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 5,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "John",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/159880279",
			"id": 159880279,
			"lng": -77.38772097,
			"lat": 37.53721898,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 3,
			"dd": 9,
			"by": 1874,
			"bd": 7,
			"bm": 5,
			"nm": "Allen",
			"nf": "John",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/117180425",
			"id": 117180425,
			"lng": -77.38589827,
			"lat": 37.53718454,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 6,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Joseph",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/188269709",
			"id": 188269709,
			"lng": -77.38791593,
			"lat": 37.53710242,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 12,
			"dd": 24,
			"by": 1875,
			"bd": 1,
			"bm": 5,
			"nm": "Henry",
			"nf": "Joseph",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/145167325",
			"id": 145167325,
			"lng": -77.38623928,
			"lat": 37.53715146,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 5,
			"dd": 5,
			"by": 1895,
			"bd": 23,
			"bm": 6,
			"nm": "L.",
			"nf": "Joseph",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/138366518",
			"id": 138366518,
			"lng": -77.38626978,
			"lat": 37.53674523,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 7,
			"dd": 26,
			"by": 1894,
			"bd": 6,
			"bm": 10,
			"nm": "N.",
			"nf": "Lemuel",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/169810309",
			"id": 169810309,
			"lng": -77.38681202,
			"lat": 37.53698607,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 9,
			"dd": 22,
			"by": 1878,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lena",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/132046761",
			"id": 132046761,
			"lng": -77.38779337,
			"lat": 37.53648618,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 3,
			"dd": 26,
			"by": 1887,
			"bd": 10,
			"bm": 4,
			"nm": "",
			"nf": "Lizzie",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/161003050",
			"id": 161003050,
			"lng": -77.38705929,
			"lat": 37.53706176,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 10,
			"dd": 4,
			"by": 1895,
			"bd": 8,
			"bm": 7,
			"nm": "",
			"nf": "Louise",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/142441900",
			"id": 142441900,
			"lng": -77.38589878,
			"lat": 37.53727187,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 11,
			"dd": 30,
			"by": 1895,
			"bd": 11,
			"bm": 5,
			"nm": "",
			"nf": "Mable",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/159885477",
			"id": 159885477,
			"lng": -77.38785019,
			"lat": 37.53751602,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 10,
			"dd": 10,
			"by": 1870,
			"bd": 22,
			"bm": 12,
			"nm": "",
			"nf": "Maria",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/176984239",
			"id": 176984239,
			"lng": -77.38747742,
			"lat": 37.53554401,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 6,
			"dd": 2,
			"by": 1892,
			"bd": 21,
			"bm": 1,
			"nm": "P.",
			"nf": "Marion",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/130692313",
			"id": 130692313,
			"lng": -77.38568338,
			"lat": 37.53716334,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 5,
			"dd": 5,
			"by": 1859,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Martha",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/155963906",
			"id": 155963906,
			"lng": -77.38706447,
			"lat": 37.53562085,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 9,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Martha",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/158625994",
			"id": 158625994,
			"lng": -77.38662164,
			"lat": 37.53574441,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 5,
			"dd": 28,
			"by": 1892,
			"bd": 22,
			"bm": 10,
			"nm": "Ellen",
			"nf": "Mary",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/173920098",
			"id": 173920098,
			"lng": -77.38732188,
			"lat": 37.53734388,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 9,
			"dd": 29,
			"by": 1906,
			"bd": 27,
			"bm": 10,
			"nm": "M.",
			"nf": "Mary",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/138926455",
			"id": 138926455,
			"lng": -77.38642213,
			"lat": 37.53653931,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 3,
			"dd": 8,
			"by": 1847,
			"bd": 4,
			"bm": 7,
			"nm": "E.",
			"nf": "Mary",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/127428923",
			"id": 127428923,
			"lng": -77.38646472,
			"lat": 37.53643825,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1912,
			"dm": 1,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Jane",
			"nf": "Mary",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/127096037",
			"id": 127096037,
			"lng": -77.38628924,
			"lat": 37.5364219,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 2,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "P.",
			"nf": "Mary",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/125805382",
			"id": 125805382,
			"lng": -77.38610167,
			"lat": 37.53736395,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 7,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Matthew",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/154534088",
			"id": 154534088,
			"lng": -77.3864354,
			"lat": 37.53565843,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 2,
			"dd": 8,
			"by": 1896,
			"bd": "",
			"bm": 7,
			"nm": "",
			"nf": "Nye",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/184094516",
			"id": 184094516,
			"lng": -77.38717197,
			"lat": 37.53758085,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 11,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Pattie",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/177768008",
			"id": 177768008,
			"lng": -77.38770358,
			"lat": 37.53755623,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1913,
			"dm": 6,
			"dd": 25,
			"by": 1840,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Peter",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/155508011",
			"id": 155508011,
			"lng": -77.38667705,
			"lat": 37.53603037,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 5,
			"dd": 10,
			"by": 1904,
			"bd": 9,
			"bm": 4,
			"nm": "",
			"nf": "Philip",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/169193076",
			"id": 169193076,
			"lng": -77.38557124,
			"lat": 37.53727536,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 1,
			"dd": 15,
			"by": 1897,
			"bd": 12,
			"bm": 11,
			"nm": "Emanuel",
			"nf": "Philip",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/142441907",
			"id": 142441907,
			"lng": -77.38586258,
			"lat": 37.53728405,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 6,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Phyllis",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/145325126",
			"id": 145325126,
			"lng": -77.3855433,
			"lat": 37.53732269,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 2,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Priscilla",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/174713087",
			"id": 174713087,
			"lng": -77.3879365,
			"lat": 37.53704621,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 2,
			"dd": 25,
			"by": 1903,
			"bd": 12,
			"bm": 5,
			"nm": "Ella",
			"nf": "Queen",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/144314838",
			"id": 144314838,
			"lng": -77.3874775,
			"lat": 37.53737589,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 5,
			"dd": 4,
			"by": 1925,
			"bd": 1,
			"bm": 12,
			"nm": "",
			"nf": "Richard",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/173076196",
			"id": 173076196,
			"lng": -77.38694739,
			"lat": 37.53733883,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 1,
			"dd": 11,
			"by": 1874,
			"bd": 12,
			"bm": 8,
			"nm": "E.",
			"nf": "Robert",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/127428936",
			"id": 127428936,
			"lng": -77.38648296,
			"lat": 37.53642615,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 1,
			"dd": 15,
			"by": 1879,
			"bd": 15,
			"bm": 11,
			"nm": "Hayes",
			"nf": "Sadie",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/117804345",
			"id": 117804345,
			"lng": -77.38589129,
			"lat": 37.53718156,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 9,
			"dd": 8,
			"by": 1871,
			"bd": 28,
			"bm": 10,
			"nm": "E.",
			"nf": "Sara",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/122027252",
			"id": 122027252,
			"lng": -77.38645956,
			"lat": 37.53642321,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 5,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Susan",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/129208531",
			"id": 129208531,
			"lng": -77.38632472,
			"lat": 37.5368675,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1906,
			"dm": 4,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Susie",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/182556656",
			"id": 182556656,
			"lng": -77.38758795,
			"lat": 37.53647658,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 4,
			"dd": 16,
			"by": 1868,
			"bd": 15,
			"bm": 6,
			"nm": "B.",
			"nf": "Susie",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/173848381",
			"id": 173848381,
			"lng": -77.38736207,
			"lat": 37.5371397,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1911,
			"dm": 12,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "F.",
			"nf": "Virginia",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/127719215",
			"id": 127719215,
			"lng": -77.38627134,
			"lat": 37.53639727,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1986,
			"dm": 2,
			"dd": 3,
			"by": 1914,
			"bd": 13,
			"bm": 12,
			"nm": "",
			"nf": "Vivian",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/115720563",
			"id": 115720563,
			"lng": -77.38603438,
			"lat": 37.53712497,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 10,
			"dd": 23,
			"by": 1966,
			"bd": 25,
			"bm": 6,
			"nm": "",
			"nf": "Walter",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/144064197",
			"id": 144064197,
			"lng": -77.38597862,
			"lat": 37.53744668,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 2,
			"dd": 2,
			"by": 1901,
			"bd": 22,
			"bm": 7,
			"nm": "H.",
			"nf": "William",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/125514741",
			"id": 125514741,
			"lng": -77.38645103,
			"lat": 37.53636599,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1901,
			"dm": 3,
			"dd": 1,
			"by": 1845,
			"bd": "",
			"bm": 5,
			"nm": "F.",
			"nf": "William",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/127428943",
			"id": 127428943,
			"lng": -77.38646146,
			"lat": 37.53644756,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 5,
			"dd": 7,
			"by": 1902,
			"bd": 14,
			"bm": 12,
			"nm": "F.",
			"nf": "William",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/136171634",
			"id": 136171634,
			"lng": -77.38644696,
			"lat": 37.53641,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 7,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "N.",
			"nf": "William",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/138561664",
			"id": 138561664,
			"lng": -77.38645781,
			"lat": 37.53634501,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 10,
			"dd": 8,
			"by": 1889,
			"bd": "",
			"bm": 3,
			"nm": "",
			"nf": "William",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/114466942",
			"id": 114466942,
			"lng": -77.38630124,
			"lat": 37.53687548,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 2,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Willianna",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/154014296",
			"id": 154014296,
			"lng": -77.3867688,
			"lat": 37.53539476,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 8,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Willie",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/145084176",
			"id": 145084176,
			"lng": -77.38736104,
			"lat": 37.53782654,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 11,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Hayes",
			"nf": "Kate",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/192327153",
			"id": 192327153,
			"lng": -77.38675716,
			"lat": 37.53542134,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 3,
			"dd": 1,
			"by": 1903,
			"bd": 6,
			"bm": 5,
			"nm": "",
			"nf": "Arnita",
			"nl": "Brunson",
			"url": "https://findagrave.com/memorial/188162219",
			"id": 188162219,
			"lng": -77.38794325,
			"lat": 37.53724199,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 2,
			"dd": 9,
			"by": 1897,
			"bd": "",
			"bm": "",
			"nm": "Perry",
			"nf": "Andrew",
			"nl": "Bryant",
			"url": "https://findagrave.com/memorial/183587371",
			"id": 183587371,
			"lng": -77.38634538,
			"lat": 37.5366458,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 9,
			"dd": 23,
			"by": 1897,
			"bd": 15,
			"bm": 7,
			"nm": "Edward",
			"nf": "James",
			"nl": "Bryant",
			"url": "https://findagrave.com/memorial/168362525",
			"id": 168362525,
			"lng": -77.38680201,
			"lat": 37.53741173,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Fannie",
			"nl": "Bryson",
			"url": "https://findagrave.com/memorial/189218484",
			"id": 189218484,
			"lng": -77.38740916,
			"lat": 37.53738536,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 11,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Lawrence",
			"nf": "Ernest",
			"nl": "Buchanan",
			"url": "https://findagrave.com/memorial/137332633",
			"id": 137332633,
			"lng": -77.38605562,
			"lat": 37.53692548,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 8,
			"dd": 22,
			"by": 1919,
			"bd": 23,
			"bm": 5,
			"nm": "E.",
			"nf": "Ernesteen",
			"nl": "Buchanan",
			"url": "https://findagrave.com/memorial/145084178",
			"id": 145084178,
			"lng": -77.38605071,
			"lat": 37.53693549,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 7,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Buchanan",
			"url": "https://findagrave.com/memorial/177763310",
			"id": 177763310,
			"lng": -77.38775158,
			"lat": 37.5374264,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 9,
			"dd": 12,
			"by": 1917,
			"bd": 23,
			"bm": 6,
			"nm": "Otto",
			"nf": "James",
			"nl": "Bullock",
			"url": "https://findagrave.com/memorial/76587728",
			"id": 76587728,
			"lng": -77.38613105,
			"lat": 37.53671356,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 4,
			"dd": 17,
			"by": 1884,
			"bd": 12,
			"bm": 6,
			"nm": "Jim",
			"nf": "Moses",
			"nl": "Bullock",
			"url": "https://findagrave.com/memorial/158942421",
			"id": 158942421,
			"lng": -77.38688997,
			"lat": 37.53745088,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 10,
			"dd": 14,
			"by": 1918,
			"bd": 18,
			"bm": 1,
			"nm": "Plummer",
			"nf": "William",
			"nl": "Bullock",
			"url": "https://findagrave.com/memorial/183245305",
			"id": 183245305,
			"lng": -77.38723156,
			"lat": 37.53707092,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1913,
			"dm": 1,
			"dd": 9,
			"by": 1859,
			"bd": 22,
			"bm": 8,
			"nm": "",
			"nf": "Edward",
			"nl": "Bunn",
			"url": "https://findagrave.com/memorial/149251886",
			"id": 149251886,
			"lng": -77.38641257,
			"lat": 37.53553133,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 4,
			"dd": 4,
			"by": 1882,
			"bd": 5,
			"bm": 9,
			"nm": "",
			"nf": "Mann",
			"nl": "Burchett",
			"url": "https://findagrave.com/memorial/125292203",
			"id": 125292203,
			"lng": -77.38592776,
			"lat": 37.53687946,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 11,
			"dd": 29,
			"by": 1933,
			"bd": 28,
			"bm": 10,
			"nm": "Henry",
			"nf": "William",
			"nl": "Burchett",
			"url": "https://findagrave.com/memorial/128399800",
			"id": 128399800,
			"lng": -77.38618906,
			"lat": 37.53726111,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 11,
			"dd": 5,
			"by": 1883,
			"bd": 23,
			"bm": 9,
			"nm": "",
			"nf": "Thomas",
			"nl": "Burhunce",
			"url": "https://findagrave.com/memorial/148285642",
			"id": 148285642,
			"lng": -77.38648403,
			"lat": 37.53723476,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 9,
			"dd": 10,
			"by": 1963,
			"bd": 10,
			"bm": 7,
			"nm": "D.",
			"nf": "Cynthia",
			"nl": "Burnette",
			"url": "https://findagrave.com/memorial/169065891",
			"id": 169065891,
			"lng": -77.3862265,
			"lat": 37.53750738,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 1,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Robert",
			"nl": "Burnette",
			"url": "https://findagrave.com/memorial/146339012",
			"id": 146339012,
			"lng": -77.38638304,
			"lat": 37.53709366,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 2,
			"dd": 1,
			"by": 1924,
			"bd": 27,
			"bm": 7,
			"nm": "",
			"nf": "Gladys",
			"nl": "Burns",
			"url": "https://findagrave.com/memorial/155508023",
			"id": 155508023,
			"lng": -77.38762114,
			"lat": 37.53769596,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 4,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Charles",
			"nl": "Burrell",
			"url": "https://findagrave.com/memorial/143825686",
			"id": 143825686,
			"lng": -77.38595068,
			"lat": 37.53725378,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 2,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Pattie",
			"nl": "Burrell",
			"url": "https://findagrave.com/memorial/120725998",
			"id": 120725998,
			"lng": -77.38577615,
			"lat": 37.53688669,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 3,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Alice K.",
			"nf": "Sarah",
			"nl": "Burrell",
			"url": "https://findagrave.com/memorial/155979496",
			"id": 155979496,
			"lng": -77.38710714,
			"lat": 37.53551454,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 7,
			"dd": 14,
			"by": 1894,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Burrell",
			"url": "https://findagrave.com/memorial/142106150",
			"id": 142106150,
			"lng": -77.38669538,
			"lat": 37.53668164,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 7,
			"dd": 21,
			"by": 1888,
			"bd": 26,
			"bm": 10,
			"nm": "Lee",
			"nf": "Bertha",
			"nl": "Burton",
			"url": "https://findagrave.com/memorial/38426041",
			"id": 38426041,
			"lng": -77.38615208,
			"lat": 37.53569214,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 3,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bettie",
			"nl": "Burton",
			"url": "https://findagrave.com/memorial/171733166",
			"id": 171733166,
			"lng": -77.3871497,
			"lat": 37.53668364,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 8,
			"dd": 12,
			"by": 1891,
			"bd": 24,
			"bm": 1,
			"nm": "Jane",
			"nf": "Charlotte",
			"nl": "Burton",
			"url": "https://findagrave.com/memorial/38425986",
			"id": 38425986,
			"lng": -77.38615303,
			"lat": 37.53568871,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 3,
			"dd": 19,
			"by": 1878,
			"bd": 27,
			"bm": 5,
			"nm": "Powell",
			"nf": "Hattie",
			"nl": "Burton",
			"url": "https://findagrave.com/memorial/173803808",
			"id": 173803808,
			"lng": -77.38753481,
			"lat": 37.53707234,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 3,
			"dd": 12,
			"by": 1859,
			"bd": "",
			"bm": 1,
			"nm": "",
			"nf": "Jack",
			"nl": "Burton",
			"url": "https://findagrave.com/memorial/143631821",
			"id": 143631821,
			"lng": -77.38610856,
			"lat": 37.5356912,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 3,
			"dd": 4,
			"by": 1896,
			"bd": 5,
			"bm": 1,
			"nm": "Bernard",
			"nf": "Louis",
			"nl": "Burton",
			"url": "https://findagrave.com/memorial/159845252",
			"id": 159845252,
			"lng": -77.38798387,
			"lat": 37.53751714,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 10,
			"dd": 28,
			"by": 1859,
			"bd": "",
			"bm": 12,
			"nm": "Mary",
			"nf": "Jane",
			"nl": "Burton",
			"url": "https://findagrave.com/memorial/143631830",
			"id": 143631830,
			"lng": -77.3861288,
			"lat": 37.53569542,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 10,
			"dd": 22,
			"by": 1922,
			"bd": 25,
			"bm": 8,
			"nm": "E.",
			"nf": "Pauline",
			"nl": "Burton",
			"url": "https://findagrave.com/memorial/177153819",
			"id": 177153819,
			"lng": -77.38781387,
			"lat": 37.53698926,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 10,
			"dd": 7,
			"by": 1852,
			"bd": "",
			"bm": 6,
			"nm": "",
			"nf": "Phyllis",
			"nl": "Burton",
			"url": "https://findagrave.com/memorial/119327969",
			"id": 119327969,
			"lng": -77.38551389,
			"lat": 37.53731766,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 12,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Adell",
			"nl": "Butler",
			"url": "https://findagrave.com/memorial/166047722",
			"id": 166047722,
			"lng": -77.38649363,
			"lat": 37.53669441,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 7,
			"dd": 20,
			"by": 1911,
			"bd": 17,
			"bm": 3,
			"nm": "",
			"nf": "Alice",
			"nl": "Butler",
			"url": "https://findagrave.com/memorial/137835700",
			"id": 137835700,
			"lng": -77.38626588,
			"lat": 37.53703051,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 3,
			"dd": 14,
			"by": 1877,
			"bd": 12,
			"bm": 12,
			"nm": "",
			"nf": "Charles",
			"nl": "Butler",
			"url": "https://findagrave.com/memorial/117431857",
			"id": 117431857,
			"lng": -77.38581373,
			"lat": 37.53672669,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 11,
			"dd": 14,
			"by": 1912,
			"bd": 12,
			"bm": 3,
			"nm": "",
			"nf": "Charles",
			"nl": "Butler",
			"url": "https://findagrave.com/memorial/120726051",
			"id": 120726051,
			"lng": -77.38585774,
			"lat": 37.53673649,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 2,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Eddie",
			"nl": "Butler",
			"url": "https://findagrave.com/memorial/188301220",
			"id": 188301220,
			"lng": -77.38792156,
			"lat": 37.53705714,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 8,
			"dd": 4,
			"by": 1877,
			"bd": "",
			"bm": "",
			"nm": "Curtis",
			"nf": "Emma",
			"nl": "Butler",
			"url": "https://findagrave.com/memorial/117431795",
			"id": 117431795,
			"lng": -77.38581732,
			"lat": 37.53672783,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 11,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Harrison",
			"nl": "Butler",
			"url": "https://findagrave.com/memorial/144314847",
			"id": 144314847,
			"lng": -77.38705715,
			"lat": 37.5354991,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 10,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Robert",
			"nf": "Henry",
			"nl": "Butler",
			"url": "https://findagrave.com/memorial/161180413",
			"id": 161180413,
			"lng": -77.38721303,
			"lat": 37.53717832,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 5,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "V.",
			"nf": "James",
			"nl": "Butler",
			"url": "https://findagrave.com/memorial/160039313",
			"id": 160039313,
			"lng": -77.38679622,
			"lat": 37.5375057,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 6,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Alfred",
			"nf": "John",
			"nl": "Butler",
			"url": "https://findagrave.com/memorial/173807096",
			"id": 173807096,
			"lng": -77.38745271,
			"lat": 37.53710132,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 1,
			"dd": "",
			"by": 1903,
			"bd": "",
			"bm": 12,
			"nm": "A.",
			"nf": "Laurence",
			"nl": "Butler",
			"url": "https://findagrave.com/memorial/119593476",
			"id": 119593476,
			"lng": -77.38574528,
			"lat": 37.53669847,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 4,
			"dd": 7,
			"by": 1893,
			"bd": 1,
			"bm": 8,
			"nm": "Ellen",
			"nf": "Louise",
			"nl": "Butler",
			"url": "https://findagrave.com/memorial/116341545",
			"id": 116341545,
			"lng": -77.38747248,
			"lat": 37.53717479,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 11,
			"dd": 11,
			"by": 1904,
			"bd": 20,
			"bm": 12,
			"nm": "",
			"nf": "Maurice",
			"nl": "Butler",
			"url": "https://findagrave.com/memorial/117431873",
			"id": 117431873,
			"lng": -77.38585939,
			"lat": 37.53672819,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 2,
			"dd": 8,
			"by": 1905,
			"bd": 5,
			"bm": 11,
			"nm": "M.",
			"nf": "Vernell",
			"nl": "Butler",
			"url": "https://findagrave.com/memorial/138181469",
			"id": 138181469,
			"lng": -77.38647289,
			"lat": 37.53697715,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 11,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lillie",
			"nl": "Bynum",
			"url": "https://findagrave.com/memorial/144013794",
			"id": 144013794,
			"lng": -77.38742085,
			"lat": 37.53761935,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 2,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Elaine",
			"nf": "Rita",
			"nl": "Byrd",
			"url": "https://findagrave.com/memorial/156934441",
			"id": 156934441,
			"lng": -77.38708581,
			"lat": 37.53764742,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 5,
			"dd": 24,
			"by": 1889,
			"bd": 11,
			"bm": 6,
			"nm": "Burrell",
			"nf": "Susan",
			"nl": "Byrd",
			"url": "https://findagrave.com/memorial/143825843",
			"id": 143825843,
			"lng": -77.38594432,
			"lat": 37.53726489,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 8,
			"dd": 16,
			"by": 1923,
			"bd": 1,
			"bm": 3,
			"nm": "Edmond",
			"nf": "Landon",
			"nl": "Byrd",
			"url": "https://findagrave.com/memorial/192391489",
			"id": 192391489,
			"lng": -77.38762023,
			"lat": 37.53754203,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 7,
			"dd": 8,
			"by": 1881,
			"bd": 19,
			"bm": 10,
			"nm": "",
			"nf": "Nora",
			"nl": "Byron",
			"url": "https://findagrave.com/memorial/183193844",
			"id": 183193844,
			"lng": -77.38724976,
			"lat": 37.53706014,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 1,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jennie",
			"nl": "Caesar",
			"url": "https://findagrave.com/memorial/122786273",
			"id": 122786273,
			"lng": -77.3858758,
			"lat": 37.53645878,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 9,
			"dd": 23,
			"by": 1935,
			"bd": 5,
			"bm": 12,
			"nm": "Lee",
			"nf": "Willie",
			"nl": "Caldwell",
			"url": "https://findagrave.com/memorial/161636474",
			"id": 161636474,
			"lng": -77.38611117,
			"lat": 37.53632553,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 7,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Eva",
			"nl": "Calhoun",
			"url": "https://findagrave.com/memorial/142106152",
			"id": 142106152,
			"lng": -77.386749,
			"lat": 37.53670232,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 2,
			"dd": 18,
			"by": 1929,
			"bd": 24,
			"bm": 10,
			"nm": "Arthur",
			"nf": "Charles",
			"nl": "Callaham",
			"url": "https://findagrave.com/memorial/166812416",
			"id": 166812416,
			"lng": -77.38804315,
			"lat": 37.53751547,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 11,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Stubbs",
			"nf": "Robert",
			"nl": "Callahan",
			"url": "https://findagrave.com/memorial/176986675",
			"id": 176986675,
			"lng": -77.38784045,
			"lat": 37.53744319,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 13,
			"by": 1947,
			"bd": 12,
			"bm": 9,
			"nm": "Jean",
			"nf": "Thelma",
			"nl": "Callahan",
			"url": "https://findagrave.com/memorial/187347874",
			"id": 187347874,
			"lng": -77.3874418,
			"lat": 37.53740127,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1909,
			"dm": 3,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alice",
			"nl": "Calloway",
			"url": "https://findagrave.com/memorial/173209804",
			"id": 173209804,
			"lng": -77.38742291,
			"lat": 37.53673055,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 7,
			"dd": 13,
			"by": 1886,
			"bd": "",
			"bm": 10,
			"nm": "",
			"nf": "Earnestine",
			"nl": "Calloway",
			"url": "https://findagrave.com/memorial/127853297",
			"id": 127853297,
			"lng": -77.38649203,
			"lat": 37.53652416,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 1,
			"dd": 7,
			"by": 1885,
			"bd": 10,
			"bm": 11,
			"nm": "D.",
			"nf": "Samuel",
			"nl": "Calloway",
			"url": "https://findagrave.com/memorial/122027267",
			"id": 122027267,
			"lng": -77.38647876,
			"lat": 37.53655603,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 9,
			"dd": 1,
			"by": 1920,
			"bd": 30,
			"bm": 1,
			"nm": "",
			"nf": "Horace",
			"nl": "Calvin",
			"url": "https://findagrave.com/memorial/127988069",
			"id": 127988069,
			"lng": -77.385619,
			"lat": 37.53705374,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 5,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "William",
			"nl": "Calvin",
			"url": "https://findagrave.com/memorial/150348911",
			"id": 150348911,
			"lng": -77.38595713,
			"lat": 37.53636233,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 12,
			"dd": 7,
			"by": 1901,
			"bd": 23,
			"bm": 11,
			"nm": "Archie",
			"nf": "Benjamin",
			"nl": "Cameron",
			"url": "https://findagrave.com/memorial/150493590",
			"id": 150493590,
			"lng": -77.38640306,
			"lat": 37.53595518,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 10,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Wesley",
			"nf": "James",
			"nl": "Cameron",
			"url": "https://findagrave.com/memorial/174622136",
			"id": 174622136,
			"lng": -77.38696627,
			"lat": 37.5371292,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 2,
			"dd": 2,
			"by": 1963,
			"bd": 18,
			"bm": 9,
			"nm": "J.",
			"nf": "James",
			"nl": "Camp",
			"url": "https://findagrave.com/memorial/159411324",
			"id": 159411324,
			"lng": -77.38617867,
			"lat": 37.53750668,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 7,
			"dd": 21,
			"by": 1957,
			"bd": 12,
			"bm": 9,
			"nm": "",
			"nf": "Juanita",
			"nl": "Campbell",
			"url": "https://findagrave.com/memorial/145594992",
			"id": 145594992,
			"lng": -77.38609634,
			"lat": 37.53747919,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 4,
			"dd": 16,
			"by": 1888,
			"bd": 24,
			"bm": 7,
			"nm": "B.",
			"nf": "Theresa",
			"nl": "Capers",
			"url": "https://findagrave.com/memorial/126456372",
			"id": 126456372,
			"lng": -77.38583158,
			"lat": 37.53641127,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 12,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Thomas",
			"nl": "Capers",
			"url": "https://findagrave.com/memorial/126456382",
			"id": 126456382,
			"lng": -77.38583344,
			"lat": 37.53640616,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 10,
			"dd": 28,
			"by": 1895,
			"bd": 25,
			"bm": 12,
			"nm": "",
			"nf": "Charles",
			"nl": "Capies",
			"url": "https://findagrave.com/memorial/176986901",
			"id": 176986901,
			"lng": -77.3878428,
			"lat": 37.53742544,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 8,
			"dd": 22,
			"by": 1905,
			"bd": 13,
			"bm": 9,
			"nm": "",
			"nf": "Alpheus",
			"nl": "Carey",
			"url": "https://findagrave.com/memorial/185658244",
			"id": 185658244,
			"lng": -77.38724006,
			"lat": 37.53774567,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 8,
			"dd": 6,
			"by": 1927,
			"bd": 2,
			"bm": 10,
			"nm": "Henry",
			"nf": "Rudolph",
			"nl": "Carey",
			"url": "https://findagrave.com/memorial/138181476",
			"id": 138181476,
			"lng": -77.38676042,
			"lat": 37.53688157,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 7,
			"dd": 21,
			"by": 1917,
			"bd": 5,
			"bm": 7,
			"nm": "Hampton",
			"nf": "Walter",
			"nl": "Carey",
			"url": "https://findagrave.com/memorial/173156018",
			"id": 173156018,
			"lng": -77.38726968,
			"lat": 37.53720749,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 8,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bessie",
			"nl": "Carpenter",
			"url": "https://findagrave.com/memorial/76587741",
			"id": 76587741,
			"lng": -77.38618368,
			"lat": 37.53719112,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 12,
			"dd": 30,
			"by": 1910,
			"bd": 10,
			"bm": 6,
			"nm": "H.",
			"nf": "Joseph",
			"nl": "Carpenter",
			"url": "https://findagrave.com/memorial/178266029",
			"id": 178266029,
			"lng": -77.38803743,
			"lat": 37.53742953,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 1,
			"dd": 4,
			"by": 1914,
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Cornelia",
			"nl": "Carr",
			"url": "https://findagrave.com/memorial/149165835",
			"id": 149165835,
			"lng": -77.38620755,
			"lat": 37.53595415,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 9,
			"dd": 28,
			"by": 1858,
			"bd": 15,
			"bm": 3,
			"nm": "",
			"nf": "Ida",
			"nl": "Carr",
			"url": "https://findagrave.com/memorial/149439649",
			"id": 149439649,
			"lng": -77.3860361,
			"lat": 37.53584379,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 10,
			"dd": 4,
			"by": 1882,
			"bd": 10,
			"bm": 1,
			"nm": "J.",
			"nf": "Ella",
			"nl": "Carrington",
			"url": "https://findagrave.com/memorial/127545794",
			"id": 127545794,
			"lng": -77.38624183,
			"lat": 37.5369435,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 10,
			"dd": 23,
			"by": 1875,
			"bd": 12,
			"bm": 7,
			"nm": "L.",
			"nf": "Julian",
			"nl": "Carrington",
			"url": "https://findagrave.com/memorial/127545785",
			"id": 127545785,
			"lng": -77.38624095,
			"lat": 37.53694621,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 11,
			"dd": 29,
			"by": 1908,
			"bd": 12,
			"bm": 7,
			"nm": "",
			"nf": "Rose",
			"nl": "Carrington",
			"url": "https://findagrave.com/memorial/162641861",
			"id": 162641861,
			"lng": -77.38683784,
			"lat": 37.53703527,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 12,
			"dd": 16,
			"by": 1933,
			"bd": 14,
			"bm": 2,
			"nm": "",
			"nf": "Geraldine",
			"nl": "Carroll",
			"url": "https://findagrave.com/memorial/172409718",
			"id": 172409718,
			"lng": -77.38643064,
			"lat": 37.53530458,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 1,
			"dd": 17,
			"by": 1918,
			"bd": 2,
			"bm": 8,
			"nm": "",
			"nf": "Melvin",
			"nl": "Carroll",
			"url": "https://findagrave.com/memorial/170405395",
			"id": 170405395,
			"lng": -77.38600475,
			"lat": 37.53630945,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 2,
			"dd": 13,
			"by": 1897,
			"bd": 17,
			"bm": 4,
			"nm": "F.",
			"nf": "Joseph",
			"nl": "Carson",
			"url": "https://findagrave.com/memorial/176115625",
			"id": 176115625,
			"lng": -77.38608123,
			"lat": 37.53636299,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 7,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Lee",
			"nf": "Bessie",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/174712858",
			"id": 174712858,
			"lng": -77.38760747,
			"lat": 37.53692398,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 3,
			"dd": 31,
			"by": 1839,
			"bd": 2,
			"bm": 3,
			"nm": "",
			"nf": "Bettie",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/151131226",
			"id": 151131226,
			"lng": -77.38673064,
			"lat": 37.53540629,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 8,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "S.",
			"nf": "Bremmer",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/172682198",
			"id": 172682198,
			"lng": -77.38698253,
			"lat": 37.53719375,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 11,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Catherine",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/171762818",
			"id": 171762818,
			"lng": -77.38689133,
			"lat": 37.53666678,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 7,
			"dd": 20,
			"by": 1880,
			"bd": 5,
			"bm": 7,
			"nm": "Boyd",
			"nf": "Charles",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/38425322",
			"id": 38425322,
			"lng": -77.38611214,
			"lat": 37.53572143,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 6,
			"dd": 13,
			"by": 1915,
			"bd": 6,
			"bm": 4,
			"nm": "N.",
			"nf": "David",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/166386383",
			"id": 166386383,
			"lng": -77.38747311,
			"lat": 37.5368498,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 7,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Delia",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/176270298",
			"id": 176270298,
			"lng": -77.38746936,
			"lat": 37.53687328,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 6,
			"dd": 25,
			"by": 1873,
			"bd": 22,
			"bm": 2,
			"nm": "Blackburn",
			"nf": "George",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/140624937",
			"id": 140624937,
			"lng": -77.38662147,
			"lat": 37.5356883,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 6,
			"dd": 18,
			"by": 1870,
			"bd": 1,
			"bm": 3,
			"nm": "W.",
			"nf": "George",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/132641043",
			"id": 132641043,
			"lng": -77.38549253,
			"lat": 37.53722073,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 2002,
			"dm": 6,
			"dd": 27,
			"by": 1932,
			"bd": 13,
			"bm": 8,
			"nm": "E.",
			"nf": "Gladys",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/114466951",
			"id": 114466951,
			"lng": -77.38631047,
			"lat": 37.5368613,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 10,
			"dd": 5,
			"by": 1924,
			"bd": 25,
			"bm": 3,
			"nm": "",
			"nf": "Helen",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/169397240",
			"id": 169397240,
			"lng": -77.38653525,
			"lat": 37.53689605,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 9,
			"dd": 15,
			"by": 1884,
			"bd": 25,
			"bm": 2,
			"nm": "Harvey",
			"nf": "James",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/178405026",
			"id": 178405026,
			"lng": -77.3864097,
			"lat": 37.53629826,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 5,
			"dd": 31,
			"by": 1905,
			"bd": 13,
			"bm": 5,
			"nm": "H.",
			"nf": "James",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/113750893",
			"id": 113750893,
			"lng": -77.38628206,
			"lat": 37.53687407,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": "",
			"dd": "",
			"by": 1900,
			"bd": "",
			"bm": "",
			"nm": "R.",
			"nf": "John",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/161171355",
			"id": 161171355,
			"lng": -77.38644841,
			"lat": 37.53708408,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 8,
			"dd": 1,
			"by": 1914,
			"bd": 14,
			"bm": 9,
			"nm": "",
			"nf": "Joseph",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/125094142",
			"id": 125094142,
			"lng": -77.38673544,
			"lat": 37.53705135,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 2,
			"dd": 22,
			"by": 1905,
			"bd": 13,
			"bm": 5,
			"nm": "",
			"nf": "Josephine",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/185739207",
			"id": 185739207,
			"lng": -77.38749209,
			"lat": 37.53736965,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 8,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Junius",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/187745588",
			"id": 187745588,
			"lng": -77.38781612,
			"lat": 37.53695039,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 5,
			"dd": 31,
			"by": 1901,
			"bd": 11,
			"bm": 5,
			"nm": "Cordelia",
			"nf": "Katharine",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/140624962",
			"id": 140624962,
			"lng": -77.38662371,
			"lat": 37.53568302,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 4,
			"dd": 16,
			"by": 1903,
			"bd": 25,
			"bm": 3,
			"nm": "E.",
			"nf": "Katie",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/158678010",
			"id": 158678010,
			"lng": -77.38679383,
			"lat": 37.53757086,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": 1893,
			"bd": 29,
			"bm": 3,
			"nm": "Anna",
			"nf": "Lee",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/140624952",
			"id": 140624952,
			"lng": -77.38662068,
			"lat": 37.53569612,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 6,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Louise",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/161096986",
			"id": 161096986,
			"lng": -77.38715191,
			"lat": 37.53703487,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 2,
			"dd": 14,
			"by": 1883,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucy",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/150910944",
			"id": 150910944,
			"lng": -77.38675228,
			"lat": 37.53582902,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 9,
			"dd": 28,
			"by": 1910,
			"bd": 24,
			"bm": 3,
			"nm": "",
			"nf": "Margaret",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/142441918",
			"id": 142441918,
			"lng": -77.38587427,
			"lat": 37.53728715,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 6,
			"dd": 27,
			"by": 1875,
			"bd": 5,
			"bm": 5,
			"nm": "Elizabeth",
			"nf": "Mary",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/140624947",
			"id": 140624947,
			"lng": -77.38663392,
			"lat": 37.53570545,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 10,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mildred",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/113750900",
			"id": 113750900,
			"lng": -77.38628096,
			"lat": 37.53686451,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 10,
			"dd": 27,
			"by": 1898,
			"bd": 6,
			"bm": 5,
			"nm": "Louise",
			"nf": "Nannie",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/177123343",
			"id": 177123343,
			"lng": -77.38637971,
			"lat": 37.53736649,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 3,
			"dd": 30,
			"by": 1879,
			"bd": 2,
			"bm": 6,
			"nm": "",
			"nf": "Narcissa",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/38425727",
			"id": 38425727,
			"lng": -77.38610313,
			"lat": 37.53572779,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 7,
			"dd": 21,
			"by": 1872,
			"bd": 3,
			"bm": 11,
			"nm": "",
			"nf": "Nathaniel",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/191435949",
			"id": 191435949,
			"lng": -77.38660223,
			"lat": 37.53716715,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 1,
			"dd": 22,
			"by": 1967,
			"bd": 21,
			"bm": 9,
			"nm": "",
			"nf": "Orlandus",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/153380966",
			"id": 153380966,
			"lng": -77.38592224,
			"lat": 37.53744228,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 1,
			"dd": 1,
			"by": 1936,
			"bd": 27,
			"bm": 1,
			"nm": "L.",
			"nf": "Raymond",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/188245250",
			"id": 188245250,
			"lng": -77.38805253,
			"lat": 37.53735602,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 9,
			"dd": 28,
			"by": 1881,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Samuel",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/177037009",
			"id": 177037009,
			"lng": -77.38801016,
			"lat": 37.53724772,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 4,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Thomas",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/172214454",
			"id": 172214454,
			"lng": -77.38749958,
			"lat": 37.53684597,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1907,
			"dm": 9,
			"dd": 8,
			"by": 1906,
			"bd": 20,
			"bm": 9,
			"nm": "Gwyndoline",
			"nf": "V.",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/149165842",
			"id": 149165842,
			"lng": -77.38610608,
			"lat": 37.53574968,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 4,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Viola",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/142441926",
			"id": 142441926,
			"lng": -77.38578523,
			"lat": 37.53728784,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 6,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Irene",
			"nl": "Cary",
			"url": "https://findagrave.com/memorial/150919751",
			"id": 150919751,
			"lng": -77.38618178,
			"lat": 37.53556488,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1912,
			"dm": 10,
			"dd": 1,
			"by": 1885,
			"bd": 16,
			"bm": 9,
			"nm": "E.",
			"nf": "James",
			"nl": "Cary",
			"url": "https://findagrave.com/memorial/156656231",
			"id": 156656231,
			"lng": -77.38655535,
			"lat": 37.53584775,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 3,
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Louvenia",
			"nf": "Eunice",
			"nl": "Caster",
			"url": "https://findagrave.com/memorial/168775127",
			"id": 168775127,
			"lng": -77.38627104,
			"lat": 37.53697434,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 7,
			"dd": 8,
			"by": 1930,
			"bd": 7,
			"bm": 8,
			"nm": "H.",
			"nf": "James",
			"nl": "Caster",
			"url": "https://findagrave.com/memorial/133448289",
			"id": 133448289,
			"lng": -77.38624801,
			"lat": 37.53697045,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1912,
			"dm": 3,
			"dd": 20,
			"by": 1869,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Dora",
			"nl": "Catlett",
			"url": "https://findagrave.com/memorial/182683456",
			"id": 182683456,
			"lng": -77.38759341,
			"lat": 37.53655356,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 8,
			"dd": 6,
			"by": 1868,
			"bd": 15,
			"bm": 4,
			"nm": "",
			"nf": "Eugene",
			"nl": "Catlett",
			"url": "https://findagrave.com/memorial/134359150",
			"id": 134359150,
			"lng": -77.38763612,
			"lat": 37.53655949,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 7,
			"dd": 15,
			"by": 1926,
			"bd": 7,
			"bm": 6,
			"nm": "",
			"nf": "Irene",
			"nl": "Catlett",
			"url": "https://findagrave.com/memorial/182683525",
			"id": 182683525,
			"lng": -77.38761755,
			"lat": 37.53655643,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": "",
			"dd": "",
			"by": 1967,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "baby girl",
			"nl": "Caul??",
			"url": "https://findagrave.com/memorial/145838169",
			"id": 145838169,
			"lng": -77.38593373,
			"lat": 37.53744446,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 10,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Anna",
			"nl": "Cave",
			"url": "https://findagrave.com/memorial/153511895",
			"id": 153511895,
			"lng": -77.38641643,
			"lat": 37.53736772,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 10,
			"dd": 22,
			"by": 1910,
			"bd": 19,
			"bm": 9,
			"nm": "",
			"nf": "Eddie",
			"nl": "Cepers",
			"url": "https://findagrave.com/memorial/126652572",
			"id": 126652572,
			"lng": -77.38597362,
			"lat": 37.53637644,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 12,
			"dd": 5,
			"by": 1877,
			"bd": 20,
			"bm": 4,
			"nm": "",
			"nf": "Mary",
			"nl": "Cephas",
			"url": "https://findagrave.com/memorial/178089650",
			"id": 178089650,
			"lng": -77.38662766,
			"lat": 37.53537578,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 2,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Pauline",
			"nl": "Cephas",
			"url": "https://findagrave.com/memorial/142526002",
			"id": 142526002,
			"lng": -77.38657408,
			"lat": 37.53704517,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 2,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucinda",
			"nl": "Chaffin",
			"url": "https://findagrave.com/memorial/175609592",
			"id": 175609592,
			"lng": -77.38762914,
			"lat": 37.53712682,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 8,
			"dd": 2,
			"by": 1898,
			"bd": 22,
			"bm": 4,
			"nm": "",
			"nf": "Royall",
			"nl": "Chaffin",
			"url": "https://findagrave.com/memorial/187347880",
			"id": 187347880,
			"lng": -77.38783043,
			"lat": 37.53715296,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 4,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Carrie",
			"nl": "Chambers",
			"url": "https://findagrave.com/memorial/179551998",
			"id": 179551998,
			"lng": -77.38802798,
			"lat": 37.53775501,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 10,
			"dd": 8,
			"by": 1880,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Chambers",
			"url": "https://findagrave.com/memorial/150883180",
			"id": 150883180,
			"lng": -77.38657123,
			"lat": 37.53585991,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 1,
			"dd": 16,
			"by": 1894,
			"bd": "",
			"bm": "",
			"nm": "Eliza",
			"nf": "Mary",
			"nl": "Chambers",
			"url": "https://findagrave.com/memorial/147853130",
			"id": 147853130,
			"lng": -77.38637173,
			"lat": 37.53718423,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 6,
			"dd": 24,
			"by": 1869,
			"bd": 6,
			"bm": 4,
			"nm": "Fannie",
			"nf": "Susie",
			"nl": "Chambers",
			"url": "https://findagrave.com/memorial/172031011",
			"id": 172031011,
			"lng": -77.38683307,
			"lat": 37.53717712,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 6,
			"dd": 7,
			"by": 1922,
			"bd": 31,
			"bm": 10,
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Chancler",
			"url": "https://findagrave.com/memorial/147853139",
			"id": 147853139,
			"lng": -77.38595353,
			"lat": 37.53635649,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 4,
			"dd": 17,
			"by": 1907,
			"bd": 10,
			"bm": 10,
			"nm": "",
			"nf": "John",
			"nl": "Chancler",
			"url": "https://findagrave.com/memorial/149352529",
			"id": 149352529,
			"lng": -77.38647874,
			"lat": 37.53711632,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 5,
			"dd": 15,
			"by": 1965,
			"bd": 9,
			"bm": 5,
			"nm": "Keith",
			"nf": "Haywood",
			"nl": "Chandler",
			"url": "https://findagrave.com/memorial/145638779",
			"id": 145638779,
			"lng": -77.38608963,
			"lat": 37.5374239,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 8,
			"dd": 7,
			"by": 1965,
			"bd": 28,
			"bm": 5,
			"nm": "Denise",
			"nf": "Joan",
			"nl": "Chandler",
			"url": "https://findagrave.com/memorial/144102630",
			"id": 144102630,
			"lng": -77.38609557,
			"lat": 37.53740908,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 9,
			"dd": 9,
			"by": 1871,
			"bd": "",
			"bm": 9,
			"nm": "Arthur",
			"nf": "Benjamin",
			"nl": "Chapman",
			"url": "https://findagrave.com/memorial/127460963",
			"id": 127460963,
			"lng": -77.38647298,
			"lat": 37.53646052,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 7,
			"dd": 13,
			"by": 1869,
			"bd": 27,
			"bm": 5,
			"nm": "L.",
			"nf": "Cora",
			"nl": "Chapman",
			"url": "https://findagrave.com/memorial/127460973",
			"id": 127460973,
			"lng": -77.3864512,
			"lat": 37.53645417,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 10,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Maggie",
			"nl": "Chapman",
			"url": "https://findagrave.com/memorial/149696105",
			"id": 149696105,
			"lng": -77.3869072,
			"lat": 37.53663817,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 3,
			"dd": 16,
			"by": 1919,
			"bd": 4,
			"bm": 10,
			"nm": "C.",
			"nf": "Raymond",
			"nl": "Chapman",
			"url": "https://findagrave.com/memorial/150078581",
			"id": 150078581,
			"lng": -77.38655922,
			"lat": 37.53695589,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 8,
			"dd": 15,
			"by": 1910,
			"bd": 19,
			"bm": 10,
			"nm": "McKline",
			"nf": "Haywood",
			"nl": "Charity",
			"url": "https://findagrave.com/memorial/158889110",
			"id": 158889110,
			"lng": -77.38708505,
			"lat": 37.5374072,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 6,
			"dd": 23,
			"by": 1885,
			"bd": 16,
			"bm": 9,
			"nm": "Pleasant",
			"nf": "Joseph",
			"nl": "Charity",
			"url": "https://findagrave.com/memorial/158731874",
			"id": 158731874,
			"lng": -77.38706672,
			"lat": 37.5375177,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1911,
			"dm": 10,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Sarah",
			"nl": "Chatman",
			"url": "https://findagrave.com/memorial/144542850",
			"id": 144542850,
			"lng": -77.3868994,
			"lat": 37.5366357,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 7,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "baby girl",
			"nl": "Cheatham",
			"url": "https://findagrave.com/memorial/142106157",
			"id": 142106157,
			"lng": -77.38615686,
			"lat": 37.53745659,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 1,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Edgar",
			"nl": "Cheatham",
			"url": "https://findagrave.com/memorial/175839463",
			"id": 175839463,
			"lng": -77.38767936,
			"lat": 37.53713963,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1906,
			"dm": 4,
			"dd": 23,
			"by": 1905,
			"bd": 5,
			"bm": 11,
			"nm": "M.",
			"nf": "Felicia",
			"nl": "Cheatham",
			"url": "https://findagrave.com/memorial/127096242",
			"id": 127096242,
			"lng": -77.38650994,
			"lat": 37.53655287,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 4,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Lansing",
			"nf": "Howard",
			"nl": "Cheatham",
			"url": "https://findagrave.com/memorial/187824855",
			"id": 187824855,
			"lng": -77.38757757,
			"lat": 37.53713242,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 12,
			"dd": 18,
			"by": 1862,
			"bd": 30,
			"bm": 1,
			"nm": "M.",
			"nf": "James",
			"nl": "Cheatham",
			"url": "https://findagrave.com/memorial/127096194",
			"id": 127096194,
			"lng": -77.38650928,
			"lat": 37.53655496,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 7,
			"dd": 7,
			"by": 1901,
			"bd": 28,
			"bm": 8,
			"nm": "Ann",
			"nf": "Lucy",
			"nl": "Cheatham",
			"url": "https://findagrave.com/memorial/127096230",
			"id": 127096230,
			"lng": -77.38650962,
			"lat": 37.53655385,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 8,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Mary",
			"nl": "Cheatham",
			"url": "https://findagrave.com/memorial/142526022",
			"id": 142526022,
			"lng": -77.38642529,
			"lat": 37.53544124,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 10,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Matilda",
			"nl": "Cheatham",
			"url": "https://findagrave.com/memorial/177018343",
			"id": 177018343,
			"lng": -77.38799005,
			"lat": 37.53722554,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 9,
			"dd": 7,
			"by": 1897,
			"bd": 14,
			"bm": 2,
			"nm": "Lee",
			"nf": "Rosa",
			"nl": "Cheatham",
			"url": "https://findagrave.com/memorial/126868501",
			"id": 126868501,
			"lng": -77.38594155,
			"lat": 37.53664146,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 10,
			"dd": 4,
			"by": 1885,
			"bd": 14,
			"bm": 7,
			"nm": "LeRoy",
			"nf": "Andrew",
			"nl": "Cheesman",
			"url": "https://findagrave.com/memorial/144820112",
			"id": 144820112,
			"lng": -77.3862968,
			"lat": 37.53728205,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 3,
			"dd": 17,
			"by": 1885,
			"bd": 17,
			"bm": 7,
			"nm": "",
			"nf": "Madeline",
			"nl": "Cheesman",
			"url": "https://findagrave.com/memorial/154228729",
			"id": 154228729,
			"lng": -77.3863112,
			"lat": 37.53742369,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 10,
			"dd": 4,
			"by": 1872,
			"bd": 2,
			"bm": 2,
			"nm": "P.",
			"nf": "William",
			"nl": "Cheesman",
			"url": "https://findagrave.com/memorial/184094521",
			"id": 184094521,
			"lng": -77.38717986,
			"lat": 37.53761611,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 12,
			"dd": 18,
			"by": 1964,
			"bd": 13,
			"bm": 10,
			"nm": "Foitane",
			"nf": "Benjamin",
			"nl": "Cherry",
			"url": "https://findagrave.com/memorial/145638782",
			"id": 145638782,
			"lng": -77.38597292,
			"lat": 37.53746974,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 1,
			"dd": 29,
			"by": 1963,
			"bd": 2,
			"bm": 12,
			"nm": "Marie",
			"nf": "Zeegintis",
			"nl": "Childs",
			"url": "https://findagrave.com/memorial/169041553",
			"id": 169041553,
			"lng": -77.386116,
			"lat": 37.53746398,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 6,
			"dd": 14,
			"by": 1899,
			"bd": 25,
			"bm": 10,
			"nm": "",
			"nf": "Alexander",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/173920109",
			"id": 173920109,
			"lng": -77.38729493,
			"lat": 37.5373823,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 12,
			"dd": 14,
			"by": 1875,
			"bd": 15,
			"bm": 3,
			"nm": "",
			"nf": "Alice",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/175327979",
			"id": 175327979,
			"lng": -77.387409,
			"lat": 37.5370717,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 4,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Allen",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/176769152",
			"id": 176769152,
			"lng": -77.38774521,
			"lat": 37.53703393,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 5,
			"dd": 1,
			"by": 1878,
			"bd": 16,
			"bm": 8,
			"nm": "A.",
			"nf": "Bernard",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/155021582",
			"id": 155021582,
			"lng": -77.38711652,
			"lat": 37.53769444,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 9,
			"dd": 28,
			"by": 1928,
			"bd": 14,
			"bm": 4,
			"nm": "L.",
			"nf": "Eleanor",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/116948299",
			"id": 116948299,
			"lng": -77.38574652,
			"lat": 37.53670692,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 5,
			"dd": 30,
			"by": 1900,
			"bd": 25,
			"bm": 8,
			"nm": "Garfield",
			"nf": "Ernest",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/116948323",
			"id": 116948323,
			"lng": -77.38575143,
			"lat": 37.53669902,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 3,
			"dd": 11,
			"by": 1900,
			"bd": 15,
			"bm": 6,
			"nm": "",
			"nf": "Gus",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/163518411",
			"id": 163518411,
			"lng": -77.3861823,
			"lat": 37.53727676,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": 1934,
			"bd": 8,
			"bm": 7,
			"nm": "Henry",
			"nf": "James",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/144102584",
			"id": 144102584,
			"lng": -77.3862359,
			"lat": 37.53747617,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 8,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Cooper",
			"nf": "Jennie",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/125514752",
			"id": 125514752,
			"lng": -77.38603583,
			"lat": 37.53690787,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 30,
			"by": 1959,
			"bd": 5,
			"bm": 11,
			"nm": "Alexander",
			"nf": "John",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/153863147",
			"id": 153863147,
			"lng": -77.38622422,
			"lat": 37.53749753,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 2,
			"dd": 2,
			"by": 1880,
			"bd": "",
			"bm": "",
			"nm": "G.",
			"nf": "John",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/151450674",
			"id": 151450674,
			"lng": -77.38676086,
			"lat": 37.53545612,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 2,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "John",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/144188794",
			"id": 144188794,
			"lng": -77.38751354,
			"lat": 37.53739165,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 7,
			"dd": 29,
			"by": 1843,
			"bd": 15,
			"bm": 8,
			"nm": "",
			"nf": "Josephine",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/127988076",
			"id": 127988076,
			"lng": -77.3864463,
			"lat": 37.53652466,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 7,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Kate",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/160907606",
			"id": 160907606,
			"lng": -77.38696774,
			"lat": 37.53703128,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 1,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lizzie",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/127853319",
			"id": 127853319,
			"lng": -77.38607063,
			"lat": 37.53655487,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 10,
			"dd": 21,
			"by": 1870,
			"bd": 12,
			"bm": 12,
			"nm": "",
			"nf": "Lucy",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/144102592",
			"id": 144102592,
			"lng": -77.38717282,
			"lat": 37.53777823,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 12,
			"dd": 9,
			"by": 1898,
			"bd": 15,
			"bm": 10,
			"nm": "Eliza",
			"nf": "Odell",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/136107502",
			"id": 136107502,
			"lng": -77.38563833,
			"lat": 37.53733484,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 10,
			"dd": 20,
			"by": 1900,
			"bd": 10,
			"bm": 5,
			"nm": "A.",
			"nf": "Raymond",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/160053463",
			"id": 160053463,
			"lng": -77.38654251,
			"lat": 37.53746472,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 7,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "P.",
			"nf": "Robert",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/176060167",
			"id": 176060167,
			"lng": -77.38732909,
			"lat": 37.53705996,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 30,
			"by": 1963,
			"bd": 15,
			"bm": 8,
			"nm": "V.",
			"nf": "Sheila",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/153863739",
			"id": 153863739,
			"lng": -77.38622712,
			"lat": 37.53749185,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 11,
			"dd": 3,
			"by": 1906,
			"bd": 15,
			"bm": 12,
			"nm": "",
			"nf": "Susie",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/114080828",
			"id": 114080828,
			"lng": -77.38577451,
			"lat": 37.536711,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 30,
			"by": 1958,
			"bd": 19,
			"bm": 2,
			"nm": "Ann",
			"nf": "Vanessa",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/153378637",
			"id": 153378637,
			"lng": -77.38623061,
			"lat": 37.53748566,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1912,
			"dm": 8,
			"dd": 10,
			"by": 1842,
			"bd": 25,
			"bm": 12,
			"nm": "",
			"nf": "Wallace",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/127853333",
			"id": 127853333,
			"lng": -77.38644875,
			"lat": 37.536517,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 11,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Bernard",
			"nf": "William",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/169281846",
			"id": 169281846,
			"lng": -77.38647075,
			"lat": 37.53683075,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 6,
			"dd": 5,
			"by": 1898,
			"bd": 25,
			"bm": 12,
			"nm": "Major",
			"nf": "William",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/159760631",
			"id": 159760631,
			"lng": -77.38761005,
			"lat": 37.53786706,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 8,
			"dd": 15,
			"by": 1919,
			"bd": 19,
			"bm": 3,
			"nm": "C.",
			"nf": "Willie",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/150493598",
			"id": 150493598,
			"lng": -77.38637675,
			"lat": 37.53595936,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 12,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Blanche",
			"nl": "Claiborne",
			"url": "https://findagrave.com/memorial/144013799",
			"id": 144013799,
			"lng": -77.38725785,
			"lat": 37.53783867,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 10,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Jefferson",
			"nf": "Charles",
			"nl": "Claiborne",
			"url": "https://findagrave.com/memorial/173510614",
			"id": 173510614,
			"lng": -77.38752476,
			"lat": 37.53711045,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1909,
			"dm": 12,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "John",
			"nl": "Claiborne",
			"url": "https://findagrave.com/memorial/146339032",
			"id": 146339032,
			"lng": -77.38665322,
			"lat": 37.53584396,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 3,
			"dd": 10,
			"by": 1869,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Claiborne",
			"url": "https://findagrave.com/memorial/183587435",
			"id": 183587435,
			"lng": -77.38690585,
			"lat": 37.53694939,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 3,
			"dd": 31,
			"by": 1922,
			"bd": 15,
			"bm": 8,
			"nm": "H.",
			"nf": "Ruth",
			"nl": "Clanton",
			"url": "https://findagrave.com/memorial/143825848",
			"id": 143825848,
			"lng": -77.38603349,
			"lat": 37.53731477,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 12,
			"dd": 15,
			"by": 1917,
			"bd": 4,
			"bm": 1,
			"nm": "",
			"nf": "Samuel",
			"nl": "Clanton",
			"url": "https://findagrave.com/memorial/144314855",
			"id": 144314855,
			"lng": -77.38757101,
			"lat": 37.53732254,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1907,
			"dm": 4,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Bell",
			"nl": "Clark",
			"url": "https://findagrave.com/memorial/133716093",
			"id": 133716093,
			"lng": -77.385977,
			"lat": 37.53613809,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 10,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Emma",
			"nl": "Clark",
			"url": "https://findagrave.com/memorial/129208534",
			"id": 129208534,
			"lng": -77.38591912,
			"lat": 37.53678367,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 10,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Eva",
			"nl": "Clark",
			"url": "https://findagrave.com/memorial/183909858",
			"id": 183909858,
			"lng": -77.38686322,
			"lat": 37.53688233,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1912,
			"dm": 7,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Evelina",
			"nl": "Clark",
			"url": "https://findagrave.com/memorial/149250576",
			"id": 149250576,
			"lng": -77.38645196,
			"lat": 37.53559765,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 1,
			"dd": 12,
			"by": 1892,
			"bd": 24,
			"bm": 7,
			"nm": "",
			"nf": "Martha",
			"nl": "Clark",
			"url": "https://findagrave.com/memorial/127568636",
			"id": 127568636,
			"lng": -77.386048,
			"lat": 37.53707755,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 3,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Lipscomb",
			"nf": "Susie",
			"nl": "Clark",
			"url": "https://findagrave.com/memorial/125514780",
			"id": 125514780,
			"lng": -77.386167,
			"lat": 37.53680844,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 5,
			"dd": 30,
			"by": 1881,
			"bd": 8,
			"bm": 3,
			"nm": "",
			"nf": "Wilbur",
			"nl": "Clark",
			"url": "https://findagrave.com/memorial/127568640",
			"id": 127568640,
			"lng": -77.38606482,
			"lat": 37.53708243,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 10,
			"dd": 13,
			"by": 1875,
			"bd": 21,
			"bm": 7,
			"nm": "",
			"nf": "Alberta",
			"nl": "Clarke",
			"url": "https://findagrave.com/memorial/125408433",
			"id": 125408433,
			"lng": -77.38770943,
			"lat": 37.53674727,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": "",
			"dd": "",
			"by": 1834,
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Ann",
			"nl": "Clarke",
			"url": "https://findagrave.com/memorial/131428496",
			"id": 131428496,
			"lng": -77.38760175,
			"lat": 37.53661973,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 2,
			"dd": 22,
			"by": 1926,
			"bd": "",
			"bm": "",
			"nm": "Lee Violet",
			"nf": "Annie",
			"nl": "Clarke",
			"url": "https://findagrave.com/memorial/158625556",
			"id": 158625556,
			"lng": -77.38668532,
			"lat": 37.53570207,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 3,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Benjamin",
			"nl": "Clarke",
			"url": "https://findagrave.com/memorial/133716100",
			"id": 133716100,
			"lng": -77.38597167,
			"lat": 37.53614299,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 3,
			"dd": 31,
			"by": 1951,
			"bd": 21,
			"bm": 9,
			"nm": "Alvin",
			"nf": "Edric",
			"nl": "Clarke",
			"url": "https://findagrave.com/memorial/138040757",
			"id": 138040757,
			"lng": -77.38659982,
			"lat": 37.53696705,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 10,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "Ellen",
			"nl": "Clarke",
			"url": "https://findagrave.com/memorial/125805398",
			"id": 125805398,
			"lng": -77.38597206,
			"lat": 37.53615094,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 8,
			"dd": 10,
			"by": 1875,
			"bd": 14,
			"bm": 5,
			"nm": "Mary",
			"nf": "Elsie",
			"nl": "Clarke",
			"url": "https://findagrave.com/memorial/156480497",
			"id": 156480497,
			"lng": -77.38645007,
			"lat": 37.535746,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 12,
			"dd": 17,
			"by": 1873,
			"bd": 2,
			"bm": 3,
			"nm": "",
			"nf": "James",
			"nl": "Clarke",
			"url": "https://findagrave.com/memorial/185564840",
			"id": 185564840,
			"lng": -77.38616261,
			"lat": 37.53680721,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 3,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Clarke",
			"url": "https://findagrave.com/memorial/169479171",
			"id": 169479171,
			"lng": -77.38771809,
			"lat": 37.53709877,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 10,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "Clarke",
			"url": "https://findagrave.com/memorial/146012146",
			"id": 146012146,
			"lng": -77.38772874,
			"lat": 37.53675392,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 2,
			"dd": 22,
			"by": 1900,
			"bd": 23,
			"bm": 10,
			"nm": "H.",
			"nf": "John",
			"nl": "Clarke",
			"url": "https://findagrave.com/memorial/125514760",
			"id": 125514760,
			"lng": -77.38617195,
			"lat": 37.53680957,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 3,
			"dd": 31,
			"by": 1904,
			"bd": 1,
			"bm": 9,
			"nm": "E.",
			"nf": "Lonnie",
			"nl": "Clarke",
			"url": "https://findagrave.com/memorial/153410137",
			"id": 153410137,
			"lng": -77.38595548,
			"lat": 37.53686846,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 6,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Turpin",
			"nf": "Philip",
			"nl": "Clarke",
			"url": "https://findagrave.com/memorial/144542865",
			"id": 144542865,
			"lng": -77.38645116,
			"lat": 37.53573701,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 4,
			"dd": 11,
			"by": 1906,
			"bd": "",
			"bm": "",
			"nm": "Egbert",
			"nf": "Ramon",
			"nl": "Clarke",
			"url": "https://findagrave.com/memorial/144820121",
			"id": 144820121,
			"lng": -77.38644764,
			"lat": 37.53575724,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": "",
			"dd": "",
			"by": 1853,
			"bd": "",
			"bm": "",
			"nm": "P.",
			"nf": "Sallie",
			"nl": "Clarke",
			"url": "https://findagrave.com/memorial/125514770",
			"id": 125514770,
			"lng": -77.3875876,
			"lat": 37.53662646,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 2,
			"dd": 19,
			"by": 1851,
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Susan",
			"nl": "Clarke",
			"url": "https://findagrave.com/memorial/154270046",
			"id": 154270046,
			"lng": -77.38645915,
			"lat": 37.53556964,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 8,
			"dd": 23,
			"by": 1897,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Albert",
			"nl": "Clay",
			"url": "https://findagrave.com/memorial/185435769",
			"id": 185435769,
			"lng": -77.38717725,
			"lat": 37.53581451,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1913,
			"dm": 2,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Edward",
			"nl": "Clay",
			"url": "https://findagrave.com/memorial/191555703",
			"id": 191555703,
			"lng": -77.38646402,
			"lat": 37.5358758,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 12,
			"dd": 17,
			"by": 1895,
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Rosa",
			"nl": "Clay",
			"url": "https://findagrave.com/memorial/160433828",
			"id": 160433828,
			"lng": -77.386102,
			"lat": 37.53646218,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 8,
			"dd": 8,
			"by": 1887,
			"bd": 20,
			"bm": 12,
			"nm": "E.",
			"nf": "Mary",
			"nl": "Clayton",
			"url": "https://findagrave.com/memorial/114080850",
			"id": 114080850,
			"lng": -77.38576537,
			"lat": 37.53672474,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 11,
			"dd": 17,
			"by": 1877,
			"bd": 12,
			"bm": 1,
			"nm": "",
			"nf": "William",
			"nl": "Clements",
			"url": "https://findagrave.com/memorial/120610671",
			"id": 120610671,
			"lng": -77.38720978,
			"lat": 37.53744011,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 9,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Willie",
			"nl": "Clements",
			"url": "https://findagrave.com/memorial/139424324",
			"id": 139424324,
			"lng": -77.38797314,
			"lat": 37.53708627,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 7,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Annie",
			"nl": "Clemmons",
			"url": "https://findagrave.com/memorial/143631831",
			"id": 143631831,
			"lng": -77.38597693,
			"lat": 37.53603949,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 7,
			"dd": 24,
			"by": 1896,
			"bd": 12,
			"bm": 5,
			"nm": "Grims",
			"nf": "James",
			"nl": "Cole",
			"url": "https://findagrave.com/memorial/116728676",
			"id": 116728676,
			"lng": -77.3867207,
			"lat": 37.53705637,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 10,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alice",
			"nl": "Coleman",
			"url": "https://findagrave.com/memorial/191383491",
			"id": 191383491,
			"lng": -77.38787018,
			"lat": 37.53692616,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 2,
			"dd": 26,
			"by": 1916,
			"bd": 12,
			"bm": 10,
			"nm": "",
			"nf": "Archie",
			"nl": "Coleman",
			"url": "https://findagrave.com/memorial/142446624",
			"id": 142446624,
			"lng": -77.38739455,
			"lat": 37.53783807,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": "",
			"dd": "",
			"by": 1905,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Christ",
			"nl": "Coleman",
			"url": "https://findagrave.com/memorial/170839506",
			"id": 170839506,
			"lng": -77.38647654,
			"lat": 37.53712605,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 6,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Ann",
			"nf": "Esther",
			"nl": "Coleman",
			"url": "https://findagrave.com/memorial/151648400",
			"id": 151648400,
			"lng": -77.38619746,
			"lat": 37.53571355,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 11,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Hester",
			"nl": "Coleman",
			"url": "https://findagrave.com/memorial/130692443",
			"id": 130692443,
			"lng": -77.3857458,
			"lat": 37.53713475,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 5,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Coleman",
			"url": "https://findagrave.com/memorial/184514630",
			"id": 184514630,
			"lng": -77.38754018,
			"lat": 37.53679225,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1995,
			"dm": 12,
			"dd": 4,
			"by": 1914,
			"bd": 15,
			"bm": 6,
			"nm": "",
			"nf": "Jessie",
			"nl": "Coleman",
			"url": "https://findagrave.com/memorial/38454719",
			"id": 38454719,
			"lng": -77.38570747,
			"lat": 37.53687988,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 6,
			"dd": 22,
			"by": 1905,
			"bd": 15,
			"bm": 3,
			"nm": "",
			"nf": "Johnnie",
			"nl": "Coleman",
			"url": "https://findagrave.com/memorial/180054364",
			"id": 180054364,
			"lng": -77.38628583,
			"lat": 37.53529291,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 4,
			"dd": 12,
			"by": 1887,
			"bd": 11,
			"bm": 4,
			"nm": "",
			"nf": "Lelia",
			"nl": "Coleman",
			"url": "https://findagrave.com/memorial/128632059",
			"id": 128632059,
			"lng": -77.38572183,
			"lat": 37.537138,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 7,
			"dd": 20,
			"by": 1879,
			"bd": 10,
			"bm": 9,
			"nm": "M.",
			"nf": "Peter",
			"nl": "Coleman",
			"url": "https://findagrave.com/memorial/151648552",
			"id": 151648552,
			"lng": -77.38616316,
			"lat": 37.5356925,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 10,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Virgie",
			"nl": "Coleman",
			"url": "https://findagrave.com/memorial/128399807",
			"id": 128399807,
			"lng": -77.38563072,
			"lat": 37.53701455,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 12,
			"dd": 8,
			"by": 1896,
			"bd": 16,
			"bm": 12,
			"nm": "",
			"nf": "Alexander",
			"nl": "Coles",
			"url": "https://findagrave.com/memorial/144013896",
			"id": 144013896,
			"lng": -77.3871689,
			"lat": 37.53780031,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 6,
			"dd": 11,
			"by": 1894,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alfred",
			"nl": "Coles",
			"url": "https://findagrave.com/memorial/155984783",
			"id": 155984783,
			"lng": -77.38719131,
			"lat": 37.53553077,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 2,
			"dd": 20,
			"by": 1880,
			"bd": 6,
			"bm": 8,
			"nm": "William",
			"nf": "Archer",
			"nl": "Coles",
			"url": "https://findagrave.com/memorial/156119497",
			"id": 156119497,
			"lng": -77.38609608,
			"lat": 37.53701954,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 11,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Christie",
			"nl": "Coles",
			"url": "https://findagrave.com/memorial/141655616",
			"id": 141655616,
			"lng": -77.38670685,
			"lat": 37.53740275,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 1,
			"dd": 22,
			"by": 1922,
			"bd": 28,
			"bm": 9,
			"nm": "Lawrence",
			"nf": "Frank",
			"nl": "Coles",
			"url": "https://findagrave.com/memorial/156119500",
			"id": 156119500,
			"lng": -77.38609858,
			"lat": 37.53701479,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 12,
			"dd": 28,
			"by": 1881,
			"bd": "",
			"bm": 5,
			"nm": "B.",
			"nf": "Georgia",
			"nl": "Coles",
			"url": "https://findagrave.com/memorial/146339046",
			"id": 146339046,
			"lng": -77.38569072,
			"lat": 37.53685337,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1985,
			"dm": 2,
			"dd": 15,
			"by": 1925,
			"bd": 9,
			"bm": 10,
			"nm": "Bell",
			"nf": "Harold",
			"nl": "Coles",
			"url": "https://findagrave.com/memorial/76587748",
			"id": 76587748,
			"lng": -77.38606638,
			"lat": 37.53702401,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 10,
			"dd": 19,
			"by": 1912,
			"bd": 11,
			"bm": 8,
			"nm": "Sadie",
			"nf": "Irietta",
			"nl": "Coles",
			"url": "https://findagrave.com/memorial/151889958",
			"id": 151889958,
			"lng": -77.38666898,
			"lat": 37.53572762,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 8,
			"dd": 22,
			"by": 1912,
			"bd": 15,
			"bm": 5,
			"nm": "Eddie",
			"nf": "John",
			"nl": "Coles",
			"url": "https://findagrave.com/memorial/144314863",
			"id": 144314863,
			"lng": -77.38648717,
			"lat": 37.53531647,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 8,
			"dd": 5,
			"by": 1891,
			"bd": 15,
			"bm": 7,
			"nm": "",
			"nf": "Joshua",
			"nl": "Coles",
			"url": "https://findagrave.com/memorial/155767945",
			"id": 155767945,
			"lng": -77.3871767,
			"lat": 37.53553041,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1980,
			"dm": 5,
			"dd": 8,
			"by": 1894,
			"bd": 6,
			"bm": 9,
			"nm": "",
			"nf": "Mary",
			"nl": "Coles",
			"url": "https://findagrave.com/memorial/76587762",
			"id": 76587762,
			"lng": -77.38609094,
			"lat": 37.53703303,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 3,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mildred",
			"nl": "Coles",
			"url": "https://findagrave.com/memorial/155984790",
			"id": 155984790,
			"lng": -77.38717131,
			"lat": 37.53551644,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 9,
			"dd": 18,
			"by": 1883,
			"bd": 5,
			"bm": 10,
			"nm": "A.",
			"nf": "William",
			"nl": "Coles",
			"url": "https://findagrave.com/memorial/141655626",
			"id": 141655626,
			"lng": -77.38670993,
			"lat": 37.53738961,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 7,
			"dd": 10,
			"by": 1886,
			"bd": 21,
			"bm": 11,
			"nm": "",
			"nf": "Rosa",
			"nl": "Collier",
			"url": "https://findagrave.com/memorial/156215155",
			"id": 156215155,
			"lng": -77.38662228,
			"lat": 37.53552299,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 8,
			"dd": 15,
			"by": 1897,
			"bd": 27,
			"bm": 11,
			"nm": "Camper",
			"nf": "Joseph",
			"nl": "Collins",
			"url": "https://findagrave.com/memorial/170129848",
			"id": 170129848,
			"lng": -77.3868115,
			"lat": 37.53696226,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 2,
			"dd": 21,
			"by": 1894,
			"bd": 17,
			"bm": 11,
			"nm": "W.",
			"nf": "Joseph",
			"nl": "Collins",
			"url": "https://findagrave.com/memorial/136304115",
			"id": 136304115,
			"lng": -77.3858725,
			"lat": 37.5369927,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 11,
			"dd": 29,
			"by": 1924,
			"bd": 15,
			"bm": 2,
			"nm": "",
			"nf": "Allen",
			"nl": "Commander",
			"url": "https://findagrave.com/memorial/147853150",
			"id": 147853150,
			"lng": -77.38604107,
			"lat": 37.53627062,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 4,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "George",
			"nl": "Conway",
			"url": "https://findagrave.com/memorial/134359107",
			"id": 134359107,
			"lng": -77.38596067,
			"lat": 37.53606955,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 2,
			"dd": 12,
			"by": 1898,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Conway",
			"url": "https://findagrave.com/memorial/143825855",
			"id": 143825855,
			"lng": -77.38597703,
			"lat": 37.53606328,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 1,
			"dd": 22,
			"by": 1875,
			"bd": 24,
			"bm": 12,
			"nm": "",
			"nf": "Martha",
			"nl": "Cook",
			"url": "https://findagrave.com/memorial/142598402",
			"id": 142598402,
			"lng": -77.38693177,
			"lat": 37.53709948,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 6,
			"dd": 14,
			"by": 1904,
			"bd": 16,
			"bm": 7,
			"nm": "",
			"nf": "Victoria",
			"nl": "Cook",
			"url": "https://findagrave.com/memorial/183697440",
			"id": 183697440,
			"lng": -77.38661372,
			"lat": 37.53749898,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 3,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Cooke",
			"url": "https://findagrave.com/memorial/184360373",
			"id": 184360373,
			"lng": -77.38790611,
			"lat": 37.53688984,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 7,
			"dd": 16,
			"by": 1896,
			"bd": 17,
			"bm": 12,
			"nm": "McCoy",
			"nf": "Leon",
			"nl": "Cooke",
			"url": "https://findagrave.com/memorial/142446642",
			"id": 142446642,
			"lng": -77.38590285,
			"lat": 37.53726029,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 4,
			"dd": 23,
			"by": 1869,
			"bd": 22,
			"bm": 5,
			"nm": "E.",
			"nf": "Sarah",
			"nl": "Cooke",
			"url": "https://findagrave.com/memorial/142446658",
			"id": 142446658,
			"lng": -77.38586647,
			"lat": 37.53724861,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 6,
			"dd": 14,
			"by": 1861,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "George",
			"nl": "Coombs",
			"url": "https://findagrave.com/memorial/176712121",
			"id": 176712121,
			"lng": -77.38767082,
			"lat": 37.53712375,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 12,
			"dd": 12,
			"by": 1901,
			"bd": 7,
			"bm": 3,
			"nm": "",
			"nf": "Bertha",
			"nl": "Cooper",
			"url": "https://findagrave.com/memorial/145084180",
			"id": 145084180,
			"lng": -77.38555012,
			"lat": 37.53721379,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 9,
			"dd": 3,
			"by": 1902,
			"bd": 26,
			"bm": 5,
			"nm": "",
			"nf": "Cornelius",
			"nl": "Cooper",
			"url": "https://findagrave.com/memorial/76587771",
			"id": 76587771,
			"lng": -77.38615212,
			"lat": 37.5369988,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 6,
			"dd": 5,
			"by": 1878,
			"bd": 12,
			"bm": 4,
			"nm": "W.",
			"nf": "George",
			"nl": "Cooper",
			"url": "https://findagrave.com/memorial/135741634",
			"id": 135741634,
			"lng": -77.38600161,
			"lat": 37.53689722,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 1,
			"dd": 21,
			"by": 1916,
			"bd": 2,
			"bm": 7,
			"nm": "W.",
			"nf": "Herbert",
			"nl": "Cooper",
			"url": "https://findagrave.com/memorial/125514791",
			"id": 125514791,
			"lng": -77.38604251,
			"lat": 37.53690089,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 12,
			"dd": 24,
			"by": 1898,
			"bd": 5,
			"bm": 3,
			"nm": "",
			"nf": "James",
			"nl": "Cooper",
			"url": "https://findagrave.com/memorial/134454175",
			"id": 134454175,
			"lng": -77.38611266,
			"lat": 37.53699907,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 10,
			"dd": 11,
			"by": 1896,
			"bd": 17,
			"bm": 5,
			"nm": "",
			"nf": "Jessie",
			"nl": "Cooper",
			"url": "https://findagrave.com/memorial/146772740",
			"id": 146772740,
			"lng": -77.3863721,
			"lat": 37.53729744,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 6,
			"dd": 6,
			"by": 1885,
			"bd": 12,
			"bm": 5,
			"nm": "",
			"nf": "Lauretta",
			"nl": "Cooper",
			"url": "https://findagrave.com/memorial/158889118",
			"id": 158889118,
			"lng": -77.38778455,
			"lat": 37.53768533,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 10,
			"dd": 10,
			"by": 1923,
			"bd": 8,
			"bm": 9,
			"nm": "",
			"nf": "Leroy",
			"nl": "Cooper",
			"url": "https://findagrave.com/memorial/168728798",
			"id": 168728798,
			"lng": -77.38637031,
			"lat": 37.53709743,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 2,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Cooper",
			"url": "https://findagrave.com/memorial/139146794",
			"id": 139146794,
			"lng": -77.38601447,
			"lat": 37.53633711,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 9,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Minnie",
			"nl": "Cooper",
			"url": "https://findagrave.com/memorial/149696165",
			"id": 149696165,
			"lng": -77.38657577,
			"lat": 37.53659107,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 12,
			"dd": 12,
			"by": 1893,
			"bd": 26,
			"bm": 2,
			"nm": "Lanzy",
			"nf": "Newton",
			"nl": "Cooper",
			"url": "https://findagrave.com/memorial/117180453",
			"id": 117180453,
			"lng": -77.38603792,
			"lat": 37.53688446,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 10,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Isabelle",
			"nf": "Sarah",
			"nl": "Cooper",
			"url": "https://findagrave.com/memorial/153410141",
			"id": 153410141,
			"lng": -77.38576808,
			"lat": 37.53685955,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 7,
			"dd": 7,
			"by": 1888,
			"bd": 2,
			"bm": 10,
			"nm": "",
			"nf": "Zephaninah",
			"nl": "Cooper",
			"url": "https://findagrave.com/memorial/125514804",
			"id": 125514804,
			"lng": -77.38602223,
			"lat": 37.53689634,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 4,
			"dd": 28,
			"by": 1862,
			"bd": "",
			"bm": 1,
			"nm": "M.",
			"nf": "Maggie",
			"nl": "Copeland",
			"url": "https://findagrave.com/memorial/150786801",
			"id": 150786801,
			"lng": -77.38640955,
			"lat": 37.53553125,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 4,
			"dd": 11,
			"by": 1889,
			"bd": 10,
			"bm": 5,
			"nm": "Morton",
			"nf": "Robert",
			"nl": "Copeland",
			"url": "https://findagrave.com/memorial/158942431",
			"id": 158942431,
			"lng": -77.38759547,
			"lat": 37.53762752,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1987,
			"dm": 11,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Dorothy",
			"nl": "Corbett",
			"url": "https://findagrave.com/memorial/113750909",
			"id": 113750909,
			"lng": -77.38625549,
			"lat": 37.536875,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 1,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Benjamin",
			"nl": "Corbin",
			"url": "https://findagrave.com/memorial/160933689",
			"id": 160933689,
			"lng": -77.38669653,
			"lat": 37.53674785,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 11,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Henrietta",
			"nl": "Corbin",
			"url": "https://findagrave.com/memorial/136304126",
			"id": 136304126,
			"lng": -77.38612455,
			"lat": 37.53637483,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 6,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lillian",
			"nl": "Corbin",
			"url": "https://findagrave.com/memorial/160933691",
			"id": 160933691,
			"lng": -77.38669231,
			"lat": 37.53675504,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 1,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jesse",
			"nl": "Corley",
			"url": "https://findagrave.com/memorial/158889122",
			"id": 158889122,
			"lng": -77.38746867,
			"lat": 37.53760492,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 1,
			"dd": 8,
			"by": 1920,
			"bd": 19,
			"bm": 11,
			"nm": "L.",
			"nf": "Mamie",
			"nl": "Corley",
			"url": "https://findagrave.com/memorial/122786292",
			"id": 122786292,
			"lng": -77.38572565,
			"lat": 37.53700717,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1986,
			"dm": 3,
			"dd": 12,
			"by": 1932,
			"bd": 12,
			"bm": 8,
			"nm": "Yvonne",
			"nf": "Grace",
			"nl": "Cosby",
			"url": "https://findagrave.com/memorial/38456405",
			"id": 38456405,
			"lng": -77.38550607,
			"lat": 37.53725754,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 12,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Lewis",
			"nl": "Cosby",
			"url": "https://findagrave.com/memorial/169425937",
			"id": 169425937,
			"lng": -77.38739271,
			"lat": 37.5367442,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 10,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "D.",
			"nf": "Phillis",
			"nl": "Cosby",
			"url": "https://findagrave.com/memorial/144102600",
			"id": 144102600,
			"lng": -77.3858897,
			"lat": 37.53739153,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 5,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alice",
			"nl": "Cotten",
			"url": "https://findagrave.com/memorial/119393044",
			"id": 119393044,
			"lng": -77.38589397,
			"lat": 37.53663852,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 7,
			"dd": 1,
			"by": 1903,
			"bd": 11,
			"bm": 3,
			"nm": "H.",
			"nf": "Mary",
			"nl": "Council",
			"url": "https://findagrave.com/memorial/148285645",
			"id": 148285645,
			"lng": -77.386379,
			"lat": 37.53716193,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 7,
			"dd": 2,
			"by": 1899,
			"bd": 16,
			"bm": 2,
			"nm": "Ronald",
			"nf": "Roland",
			"nl": "Council",
			"url": "https://findagrave.com/memorial/125805557",
			"id": 125805557,
			"lng": -77.38602122,
			"lat": 37.53740219,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 5,
			"dd": 12,
			"by": 1919,
			"bd": 9,
			"bm": 4,
			"nm": "",
			"nf": "Sammie",
			"nl": "Cousar",
			"url": "https://findagrave.com/memorial/151261179",
			"id": 151261179,
			"lng": -77.38676529,
			"lat": 37.53763724,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 4,
			"dd": 24,
			"by": 1904,
			"bd": "",
			"bm": 11,
			"nm": "Horace",
			"nf": "Joseph",
			"nl": "Cousins",
			"url": "https://findagrave.com/memorial/191656663",
			"id": 191656663,
			"lng": -77.38652817,
			"lat": 37.53578267,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 2,
			"dd": 20,
			"by": 1865,
			"bd": "",
			"bm": 3,
			"nm": "Gaines",
			"nf": "Elizabeth",
			"nl": "Cousins",
			"url": "https://findagrave.com/memorial/182367259",
			"id": 182367259,
			"lng": -77.38648734,
			"lat": 37.53562415,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 11,
			"dd": 1,
			"by": 1860,
			"bd": "",
			"bm": 3,
			"nm": "",
			"nf": "King",
			"nl": "Cousins",
			"url": "https://findagrave.com/memorial/182367292",
			"id": 182367292,
			"lng": -77.38648825,
			"lat": 37.53561459,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 12,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Leroy",
			"nl": "Cousins",
			"url": "https://findagrave.com/memorial/153896426",
			"id": 153896426,
			"lng": -77.3864756,
			"lat": 37.53744767,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 11,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Martha",
			"nl": "Cousins",
			"url": "https://findagrave.com/memorial/144542880",
			"id": 144542880,
			"lng": -77.38652822,
			"lat": 37.53576964,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 12,
			"dd": "",
			"by": 1907,
			"bd": 1,
			"bm": 10,
			"nm": "S.",
			"nf": "Willie",
			"nl": "Cowens",
			"url": "https://findagrave.com/memorial/150493611",
			"id": 150493611,
			"lng": -77.38640918,
			"lat": 37.5360029,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1912,
			"dm": 7,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Albert",
			"nl": "Cox",
			"url": "https://findagrave.com/memorial/149250655",
			"id": 149250655,
			"lng": -77.38697381,
			"lat": 37.53592528,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 3,
			"dd": 18,
			"by": 1933,
			"bd": 2,
			"bm": 6,
			"nm": "",
			"nf": "Estelle",
			"nl": "Cox",
			"url": "https://findagrave.com/memorial/170814999",
			"id": 170814999,
			"lng": -77.38632079,
			"lat": 37.53669159,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 11,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Hattie",
			"nl": "Cox",
			"url": "https://findagrave.com/memorial/184708256",
			"id": 184708256,
			"lng": -77.38654366,
			"lat": 37.53763277,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 3,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Cox",
			"url": "https://findagrave.com/memorial/173470969",
			"id": 173470969,
			"lng": -77.38729916,
			"lat": 37.53712727,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 12,
			"dd": 16,
			"by": 1866,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sully",
			"nl": "Cox",
			"url": "https://findagrave.com/memorial/152256452",
			"id": 152256452,
			"lng": -77.38650835,
			"lat": 37.53559345,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 11,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "Uriah",
			"nl": "Cox",
			"url": "https://findagrave.com/memorial/148748075",
			"id": 148748075,
			"lng": -77.38800639,
			"lat": 37.53719787,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 3,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "D.",
			"nf": "William",
			"nl": "Cox",
			"url": "https://findagrave.com/memorial/120610680",
			"id": 120610680,
			"lng": -77.38588749,
			"lat": 37.53665904,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 11,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "William",
			"nl": "Coy",
			"url": "https://findagrave.com/memorial/174706685",
			"id": 174706685,
			"lng": -77.38761546,
			"lat": 37.53690254,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 2,
			"dd": 8,
			"by": 1884,
			"bd": 2,
			"bm": 10,
			"nm": "H.",
			"nf": "William",
			"nl": "Coy",
			"url": "https://findagrave.com/memorial/155021589",
			"id": 155021589,
			"lng": -77.38669742,
			"lat": 37.53751714,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 2,
			"dd": 17,
			"by": 1861,
			"bd": "",
			"bm": 4,
			"nm": "",
			"nf": "Kate",
			"nl": "Craddock",
			"url": "https://findagrave.com/memorial/125805568",
			"id": 125805568,
			"lng": -77.38595711,
			"lat": 37.53618971,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 8,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Craddock",
			"url": "https://findagrave.com/memorial/150946390",
			"id": 150946390,
			"lng": -77.38722602,
			"lat": 37.53629231,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 9,
			"dd": 9,
			"by": 1892,
			"bd": 28,
			"bm": 9,
			"nm": "Mae",
			"nf": "Lillie",
			"nl": "Craig",
			"url": "https://findagrave.com/memorial/185649300",
			"id": 185649300,
			"lng": -77.38751223,
			"lat": 37.53693712,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 8,
			"dd": 26,
			"by": 1911,
			"bd": 25,
			"bm": 10,
			"nm": "",
			"nf": "Bernice",
			"nl": "Crawford",
			"url": "https://findagrave.com/memorial/173314365",
			"id": 173314365,
			"lng": -77.38706578,
			"lat": 37.53724873,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 4,
			"dd": 20,
			"by": 1924,
			"bd": 15,
			"bm": 8,
			"nm": "McKinley",
			"nf": "John",
			"nl": "Crawford",
			"url": "https://findagrave.com/memorial/158942449",
			"id": 158942449,
			"lng": -77.38689418,
			"lat": 37.537441,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 1,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Massie",
			"nl": "Crawford",
			"url": "https://findagrave.com/memorial/183254052",
			"id": 183254052,
			"lng": -77.38738176,
			"lat": 37.53704057,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 7,
			"dd": 20,
			"by": 1886,
			"bd": 5,
			"bm": 2,
			"nm": "",
			"nf": "Edward",
			"nl": "Crawley",
			"url": "https://findagrave.com/memorial/179694191",
			"id": 179694191,
			"lng": -77.38799666,
			"lat": 37.5376375,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 7,
			"dd": 8,
			"by": 1889,
			"bd": 25,
			"bm": 12,
			"nm": "",
			"nf": "Frank",
			"nl": "Crawley",
			"url": "https://findagrave.com/memorial/144013899",
			"id": 144013899,
			"lng": -77.3873594,
			"lat": 37.53779696,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 1,
			"dd": 13,
			"by": 1888,
			"bd": 30,
			"bm": 6,
			"nm": "Roane",
			"nf": "Lillie",
			"nl": "Crawley",
			"url": "https://findagrave.com/memorial/174696206",
			"id": 174696206,
			"lng": -77.38753693,
			"lat": 37.53706067,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 7,
			"dd": 5,
			"by": 1919,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Blanche",
			"nl": "Crittenton",
			"url": "https://findagrave.com/memorial/178412472",
			"id": 178412472,
			"lng": -77.3860308,
			"lat": 37.53640294,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 4,
			"dd": 21,
			"by": 1922,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Gladys",
			"nl": "Crittenton",
			"url": "https://findagrave.com/memorial/175822563",
			"id": 175822563,
			"lng": -77.3864095,
			"lat": 37.53672106,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1981,
			"dm": 1,
			"dd": 7,
			"by": 1905,
			"bd": 7,
			"bm": 2,
			"nm": "",
			"nf": "Edna",
			"nl": "Cross",
			"url": "https://findagrave.com/memorial/142526030",
			"id": 142526030,
			"lng": -77.38560062,
			"lat": 37.5371889,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 4,
			"dd": 1,
			"by": 1904,
			"bd": 4,
			"bm": 3,
			"nm": "",
			"nf": "Bennie",
			"nl": "Crossen",
			"url": "https://findagrave.com/memorial/153864384",
			"id": 153864384,
			"lng": -77.386268,
			"lat": 37.53741964,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 9,
			"dd": 25,
			"by": 1964,
			"bd": 28,
			"bm": 12,
			"nm": "Jean",
			"nf": "Doris",
			"nl": "Crowell",
			"url": "https://findagrave.com/memorial/155984794",
			"id": 155984794,
			"lng": -77.38603618,
			"lat": 37.53746727,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 4,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Josephine",
			"nl": "Crumbley",
			"url": "https://findagrave.com/memorial/128632108",
			"id": 128632108,
			"lng": -77.38620261,
			"lat": 37.5366361,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 9,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Eliza",
			"nl": "Crump",
			"url": "https://findagrave.com/memorial/134359114",
			"id": 134359114,
			"lng": -77.38600114,
			"lat": 37.53608026,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 9,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ella",
			"nl": "Crump",
			"url": "https://findagrave.com/memorial/145084181",
			"id": 145084181,
			"lng": -77.38645824,
			"lat": 37.53537765,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 6,
			"dd": 26,
			"by": 1858,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Junius",
			"nl": "Crump",
			"url": "https://findagrave.com/memorial/149165849",
			"id": 149165849,
			"lng": -77.38645833,
			"lat": 37.53538465,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 10,
			"dd": 4,
			"by": 1922,
			"bd": 21,
			"bm": 6,
			"nm": "Everett",
			"nf": "Lawrence",
			"nl": "Crump",
			"url": "https://findagrave.com/memorial/190867105",
			"id": 190867105,
			"lng": -77.38644886,
			"lat": 37.53735713,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1912,
			"dm": 12,
			"dd": 26,
			"by": 1912,
			"bd": 17,
			"bm": 8,
			"nm": "",
			"nf": "Louise",
			"nl": "Crump",
			"url": "https://findagrave.com/memorial/175622317",
			"id": 175622317,
			"lng": -77.38679873,
			"lat": 37.53643753,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 12,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "Percy",
			"nl": "Crump",
			"url": "https://findagrave.com/memorial/185647879",
			"id": 185647879,
			"lng": -77.38774957,
			"lat": 37.53705664,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 12,
			"dd": 19,
			"by": 1896,
			"bd": 17,
			"bm": 5,
			"nm": "",
			"nf": "Sarah",
			"nl": "Crump",
			"url": "https://findagrave.com/memorial/173743441",
			"id": 173743441,
			"lng": -77.38733804,
			"lat": 37.53714474,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 5,
			"dd": 9,
			"by": 1939,
			"bd": 3,
			"bm": 4,
			"nm": "V.",
			"nf": "Mildred",
			"nl": "Cubby",
			"url": "https://findagrave.com/memorial/142446667",
			"id": 142446667,
			"lng": -77.38567818,
			"lat": 37.53741609,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 5,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Coleman",
			"nf": "Arthur",
			"nl": "Culmer",
			"url": "https://findagrave.com/memorial/150348920",
			"id": 150348920,
			"lng": -77.38598462,
			"lat": 37.53636588,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 7,
			"dd": 9,
			"by": 1949,
			"bd": 5,
			"bm": 6,
			"nm": "Jean",
			"nf": "Bobbie",
			"nl": "Cumberbatch",
			"url": "https://findagrave.com/memorial/150493620",
			"id": 150493620,
			"lng": -77.38631989,
			"lat": 37.53601984,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 12,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Winston",
			"nl": "Cunningham",
			"url": "https://findagrave.com/memorial/146012155",
			"id": 146012155,
			"lng": -77.38656617,
			"lat": 37.53634637,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 7,
			"dd": 5,
			"by": 1881,
			"bd": 22,
			"bm": 6,
			"nm": "Stokes",
			"nf": "Florence",
			"nl": "Curtis",
			"url": "https://findagrave.com/memorial/177428901",
			"id": 177428901,
			"lng": -77.38744568,
			"lat": 37.53695842,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 11,
			"dd": 15,
			"by": 1925,
			"bd": 4,
			"bm": 1,
			"nm": "Jane",
			"nf": "Mary",
			"nl": "Curtis",
			"url": "https://findagrave.com/memorial/158438093",
			"id": 158438093,
			"lng": -77.38771101,
			"lat": 37.53757045,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 7,
			"dd": 22,
			"by": 1852,
			"bd": "",
			"bm": 12,
			"nm": "",
			"nf": "Nancy",
			"nl": "Custalo",
			"url": "https://findagrave.com/memorial/143631857",
			"id": 143631857,
			"lng": -77.38619295,
			"lat": 37.53566019,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1907,
			"dm": 9,
			"dd": 7,
			"by": 1845,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Custalo",
			"url": "https://findagrave.com/memorial/143631869",
			"id": 143631869,
			"lng": -77.38619286,
			"lat": 37.53566802,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 4,
			"dd": 17,
			"by": 1880,
			"bd": 3,
			"bm": 12,
			"nm": "",
			"nf": "Ruth",
			"nl": "D'antignac",
			"url": "https://findagrave.com/memorial/145084189",
			"id": 145084189,
			"lng": -77.38643165,
			"lat": 37.53552067,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 12,
			"dd": 24,
			"by": 1912,
			"bd": 25,
			"bm": 12,
			"nm": "B.",
			"nf": "Allen",
			"nl": "Dabney",
			"url": "https://findagrave.com/memorial/125517852",
			"id": 125517852,
			"lng": -77.3857728,
			"lat": 37.53660099,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 9,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Betsy",
			"nl": "Dabney",
			"url": "https://findagrave.com/memorial/184360143",
			"id": 184360143,
			"lng": -77.38780499,
			"lat": 37.53692677,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 12,
			"dd": 21,
			"by": 1910,
			"bd": 26,
			"bm": 5,
			"nm": "E.",
			"nf": "Blanche",
			"nl": "Dabney",
			"url": "https://findagrave.com/memorial/122027276",
			"id": 122027276,
			"lng": -77.38578604,
			"lat": 37.53659522,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 11,
			"dd": 28,
			"by": 1894,
			"bd": 22,
			"bm": 11,
			"nm": "Oliver",
			"nf": "David",
			"nl": "Dabney",
			"url": "https://findagrave.com/memorial/137968564",
			"id": 137968564,
			"lng": -77.3867386,
			"lat": 37.53700113,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 6,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Frances",
			"nl": "Dabney",
			"url": "https://findagrave.com/memorial/132764916",
			"id": 132764916,
			"lng": -77.38754038,
			"lat": 37.53661476,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 5,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mildred",
			"nl": "Dabney",
			"url": "https://findagrave.com/memorial/162307276",
			"id": 162307276,
			"lng": -77.38660901,
			"lat": 37.53662919,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 1,
			"dd": 12,
			"by": 1893,
			"bd": 9,
			"bm": 2,
			"nm": "",
			"nf": "Minnie",
			"nl": "Dabney",
			"url": "https://findagrave.com/memorial/184482565",
			"id": 184482565,
			"lng": -77.38730487,
			"lat": 37.53765175,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 7,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Thomas",
			"nl": "Dabney",
			"url": "https://findagrave.com/memorial/188244937",
			"id": 188244937,
			"lng": -77.38796954,
			"lat": 37.53717543,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 12,
			"dd": 8,
			"by": 1912,
			"bd": 29,
			"bm": 6,
			"nm": "H.",
			"nf": "William",
			"nl": "Dabney",
			"url": "https://findagrave.com/memorial/143201776",
			"id": 143201776,
			"lng": -77.38640588,
			"lat": 37.53573745,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 9,
			"dd": 7,
			"by": 1921,
			"bd": 22,
			"bm": 5,
			"nm": "A.",
			"nf": "William",
			"nl": "Dabney",
			"url": "https://findagrave.com/memorial/151265302",
			"id": 151265302,
			"lng": -77.38676632,
			"lat": 37.53752429,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 11,
			"dd": 8,
			"by": 1887,
			"bd": 15,
			"bm": 11,
			"nm": "",
			"nf": "William",
			"nl": "Dabney",
			"url": "https://findagrave.com/memorial/144820122",
			"id": 144820122,
			"lng": -77.3864476,
			"lat": 37.53574973,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 8,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "F.",
			"nf": "John",
			"nl": "Dance",
			"url": "https://findagrave.com/memorial/146012160",
			"id": 146012160,
			"lng": -77.38662657,
			"lat": 37.53659228,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 2,
			"dd": 5,
			"by": 1877,
			"bd": 25,
			"bm": 5,
			"nm": "Wilbert",
			"nf": "Alpheus",
			"nl": "Dandridge",
			"url": "https://findagrave.com/memorial/111589836",
			"id": 111589836,
			"lng": -77.38610096,
			"lat": 37.5367509,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 6,
			"dd": 17,
			"by": 1885,
			"bd": 8,
			"bm": 4,
			"nm": "Ellis",
			"nf": "Bessie",
			"nl": "Dandridge",
			"url": "https://findagrave.com/memorial/111589839",
			"id": 111589839,
			"lng": -77.38609875,
			"lat": 37.53675592,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 2,
			"dd": 22,
			"by": 1895,
			"bd": 18,
			"bm": 10,
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Dandridge",
			"url": "https://findagrave.com/memorial/185390202",
			"id": 185390202,
			"lng": -77.38742531,
			"lat": 37.53764624,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 2,
			"dd": 2,
			"by": 1898,
			"bd": 10,
			"bm": 3,
			"nm": "B.",
			"nf": "Ethel",
			"nl": "Dandridge",
			"url": "https://findagrave.com/memorial/150493626",
			"id": 150493626,
			"lng": -77.3865722,
			"lat": 37.53592211,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 7,
			"dd": 8,
			"by": 1880,
			"bd": 4,
			"bm": 3,
			"nm": "Lee",
			"nf": "George",
			"nl": "Dandridge",
			"url": "https://findagrave.com/memorial/144105270",
			"id": 144105270,
			"lng": -77.38642681,
			"lat": 37.53753182,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 4,
			"dd": 6,
			"by": 1910,
			"bd": 6,
			"bm": 8,
			"nm": "Hazelwood",
			"nf": "Haywood",
			"nl": "Dandridge",
			"url": "https://findagrave.com/memorial/155984799",
			"id": 155984799,
			"lng": -77.38598812,
			"lat": 37.53688084,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 10,
			"dd": 20,
			"by": 1886,
			"bd": 12,
			"bm": 1,
			"nm": "",
			"nf": "Katie",
			"nl": "Dandridge",
			"url": "https://findagrave.com/memorial/174783395",
			"id": 174783395,
			"lng": -77.38747891,
			"lat": 37.53715449,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 4,
			"dd": 8,
			"by": 1889,
			"bd": 10,
			"bm": 10,
			"nm": "D.",
			"nf": "Lillie",
			"nl": "Dandridge",
			"url": "https://findagrave.com/memorial/183697447",
			"id": 183697447,
			"lng": -77.38703537,
			"lat": 37.53694937,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 8,
			"dd": 25,
			"by": 1912,
			"bd": 8,
			"bm": 6,
			"nm": "",
			"nf": "Lillie",
			"nl": "Dandridge",
			"url": "https://findagrave.com/memorial/185305572",
			"id": 185305572,
			"lng": -77.38702074,
			"lat": 37.53758016,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": "",
			"dd": "",
			"by": 1914,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lorenzo",
			"nl": "Dandridge",
			"url": "https://findagrave.com/memorial/115720616",
			"id": 115720616,
			"lng": -77.38612113,
			"lat": 37.53676523,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1898,
			"dm": 11,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Matilda",
			"nl": "Dandridge",
			"url": "https://findagrave.com/memorial/126456396",
			"id": 126456396,
			"lng": -77.38651627,
			"lat": 37.53587667,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 4,
			"dd": 17,
			"by": "",
			"bd": 12,
			"bm": 2,
			"nm": "Fleming",
			"nf": "Carrie",
			"nl": "Daniel",
			"url": "https://findagrave.com/memorial/158481175",
			"id": 158481175,
			"lng": -77.38678945,
			"lat": 37.53759883,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": "",
			"dd": "",
			"by": 1964,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "David",
			"nl": "Daniel",
			"url": "https://findagrave.com/memorial/159411337",
			"id": 159411337,
			"lng": -77.38615973,
			"lat": 37.53745235,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 8,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "Eugene",
			"nl": "Daniel",
			"url": "https://findagrave.com/memorial/176570422",
			"id": 176570422,
			"lng": -77.38720303,
			"lat": 37.53756494,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 11,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Mack",
			"nf": "John",
			"nl": "Daniel",
			"url": "https://findagrave.com/memorial/130967993",
			"id": 130967993,
			"lng": -77.38563312,
			"lat": 37.53724525,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 5,
			"dd": 16,
			"by": 1883,
			"bd": 15,
			"bm": 3,
			"nm": "L.",
			"nf": "Maggie",
			"nl": "Daniel",
			"url": "https://findagrave.com/memorial/130968010",
			"id": 130968010,
			"lng": -77.38562801,
			"lat": 37.53725466,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 12,
			"dd": 13,
			"by": 1900,
			"bd": 3,
			"bm": 6,
			"nm": "",
			"nf": "Mary",
			"nl": "Daniel",
			"url": "https://findagrave.com/memorial/167336921",
			"id": 167336921,
			"lng": -77.38686707,
			"lat": 37.53732829,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 7,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Patricia",
			"nl": "Daniel",
			"url": "https://findagrave.com/memorial/142448395",
			"id": 142448395,
			"lng": -77.38567772,
			"lat": 37.53742553,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 12,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Annie",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/188298644",
			"id": 188298644,
			"lng": -77.38792835,
			"lat": 37.53712282,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 11,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "baby girl",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/145638789",
			"id": 145638789,
			"lng": -77.386108,
			"lat": 37.53743086,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 6,
			"dd": 5,
			"by": 1905,
			"bd": 24,
			"bm": 11,
			"nm": "L.",
			"nf": "Bessie",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/187347884",
			"id": 187347884,
			"lng": -77.38726227,
			"lat": 37.53730059,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 11,
			"dd": 11,
			"by": 1879,
			"bd": 25,
			"bm": 9,
			"nm": "M.",
			"nf": "Bettie",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/162643310",
			"id": 162643310,
			"lng": -77.3871634,
			"lat": 37.53707924,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 7,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Boss",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/174711234",
			"id": 174711234,
			"lng": -77.38761038,
			"lat": 37.53691006,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 2,
			"dd": 1,
			"by": 1878,
			"bd": 20,
			"bm": 1,
			"nm": "",
			"nf": "Charles",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/115976009",
			"id": 115976009,
			"lng": -77.38616699,
			"lat": 37.53678157,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 5,
			"dd": 22,
			"by": 1964,
			"bd": 19,
			"bm": 4,
			"nm": "",
			"nf": "Donell",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/169042639",
			"id": 169042639,
			"lng": -77.38616624,
			"lat": 37.53747021,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 4,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Edward",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/174858483",
			"id": 174858483,
			"lng": -77.38743132,
			"lat": 37.53709233,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 10,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Fannie",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/154294638",
			"id": 154294638,
			"lng": -77.3868844,
			"lat": 37.53544664,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 7,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M. C. M.",
			"nf": "Fleming",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/187898175",
			"id": 187898175,
			"lng": -77.38798054,
			"lat": 37.53715654,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 5,
			"dd": 29,
			"by": 1964,
			"bd": 8,
			"bm": 5,
			"nm": "",
			"nf": "Franklin",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/153379930",
			"id": 153379930,
			"lng": -77.38618522,
			"lat": 37.5374728,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 10,
			"dd": 11,
			"by": 1920,
			"bd": 30,
			"bm": 9,
			"nm": "C.",
			"nf": "Gertrude",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/177762462",
			"id": 177762462,
			"lng": -77.38785706,
			"lat": 37.53739685,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 7,
			"dd": 31,
			"by": 1918,
			"bd": 23,
			"bm": 12,
			"nm": "Jessie",
			"nf": "James",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/130378900",
			"id": 130378900,
			"lng": -77.38582197,
			"lat": 37.53636303,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 1,
			"dd": 6,
			"by": 1896,
			"bd": 26,
			"bm": 2,
			"nm": "A. M.",
			"nf": "John",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/159661372",
			"id": 159661372,
			"lng": -77.3868972,
			"lat": 37.5371202,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 8,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Julia",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/129208549",
			"id": 129208549,
			"lng": -77.3861741,
			"lat": 37.53679455,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 10,
			"dd": 7,
			"by": 1968,
			"bd": 20,
			"bm": 7,
			"nm": "D.",
			"nf": "Lasandra",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/159661370",
			"id": 159661370,
			"lng": -77.38590507,
			"lat": 37.53740751,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 9,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Laura",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/169422611",
			"id": 169422611,
			"lng": -77.38766224,
			"lat": 37.53696169,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 9,
			"dd": 15,
			"by": 1881,
			"bd": "",
			"bm": 4,
			"nm": "C.",
			"nf": "Lucy",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/153375778",
			"id": 153375778,
			"lng": -77.38613451,
			"lat": 37.53574444,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 7,
			"dd": 23,
			"by": 1884,
			"bd": 14,
			"bm": 5,
			"nm": "J.",
			"nf": "Mabel",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/150786817",
			"id": 150786817,
			"lng": -77.38643486,
			"lat": 37.53551032,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 7,
			"dd": 10,
			"by": 1930,
			"bd": 1,
			"bm": 10,
			"nm": "Roberta",
			"nf": "Marion",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/184094526",
			"id": 184094526,
			"lng": -77.38722017,
			"lat": 37.5374999,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 11,
			"dd": 4,
			"by": 1839,
			"bd": 5,
			"bm": 6,
			"nm": "",
			"nf": "Martha",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/123696598",
			"id": 123696598,
			"lng": -77.38618706,
			"lat": 37.53683365,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 4,
			"dd": 30,
			"by": 1885,
			"bd": 25,
			"bm": 4,
			"nm": "",
			"nf": "Minnie",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/185647258",
			"id": 185647258,
			"lng": -77.38752691,
			"lat": 37.53697793,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 7,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nettie",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/177760815",
			"id": 177760815,
			"lng": -77.38785079,
			"lat": 37.53736975,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 12,
			"dd": 12,
			"by": 1896,
			"bd": 22,
			"bm": 3,
			"nm": "",
			"nf": "Rebecca",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/154509662",
			"id": 154509662,
			"lng": -77.38635414,
			"lat": 37.53746504,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 5,
			"dd": 23,
			"by": 1905,
			"bd": 16,
			"bm": 9,
			"nm": "Henry",
			"nf": "Robert",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/155512337",
			"id": 155512337,
			"lng": -77.38761711,
			"lat": 37.53764824,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 8,
			"dd": 15,
			"by": 1899,
			"bd": 29,
			"bm": 6,
			"nm": "",
			"nf": "Rosa",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/155512345",
			"id": 155512345,
			"lng": -77.38752854,
			"lat": 37.53762887,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 10,
			"dd": 29,
			"by": 1876,
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Sophia",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/159661371",
			"id": 159661371,
			"lng": -77.38690069,
			"lat": 37.53712157,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 7,
			"dd": 2,
			"by": 1918,
			"bd": 20,
			"bm": 2,
			"nm": "Ambrose",
			"nf": "Thomas",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/187351664",
			"id": 187351664,
			"lng": -77.38727512,
			"lat": 37.53740126,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 2,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H",
			"nf": "Viola",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/170839581",
			"id": 170839581,
			"lng": -77.38653516,
			"lat": 37.53703808,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 2,
			"dd": 14,
			"by": 1883,
			"bd": 12,
			"bm": 3,
			"nm": "T.",
			"nf": "Virginia",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/144013901",
			"id": 144013901,
			"lng": -77.38738723,
			"lat": 37.53769203,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1913,
			"dm": 9,
			"dd": 2,
			"by": 1862,
			"bd": 8,
			"bm": 9,
			"nm": "H.",
			"nf": "William",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/146682150",
			"id": 146682150,
			"lng": -77.38617467,
			"lat": 37.53576551,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 12,
			"dd": 31,
			"by": 1909,
			"bd": 2,
			"bm": 7,
			"nm": "",
			"nf": "Willie",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/175449704",
			"id": 175449704,
			"lng": -77.38748666,
			"lat": 37.53702002,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 11,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Willie",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/144105277",
			"id": 144105277,
			"lng": -77.38592037,
			"lat": 37.53730408,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 7,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "George",
			"nl": "Dawson",
			"url": "https://findagrave.com/memorial/136304139",
			"id": 136304139,
			"lng": -77.38618588,
			"lat": 37.53635532,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 11,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "Day",
			"url": "https://findagrave.com/memorial/151976238",
			"id": 151976238,
			"lng": -77.38553561,
			"lat": 37.53736529,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 10,
			"dd": 29,
			"by": 1889,
			"bd": 28,
			"bm": 1,
			"nm": "",
			"nf": "Sidney",
			"nl": "Dean",
			"url": "https://findagrave.com/memorial/141446349",
			"id": 141446349,
			"lng": -77.38728663,
			"lat": 37.53777046,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 7,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Pearl",
			"nl": "Deas",
			"url": "https://findagrave.com/memorial/120146981",
			"id": 120146981,
			"lng": -77.38599508,
			"lat": 37.53672937,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 10,
			"dd": 23,
			"by": 1910,
			"bd": 10,
			"bm": 3,
			"nm": "",
			"nf": "Arthur",
			"nl": "Dennis",
			"url": "https://findagrave.com/memorial/159852034",
			"id": 159852034,
			"lng": -77.38741323,
			"lat": 37.53755679,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 10,
			"dd": 12,
			"by": 1902,
			"bd": 25,
			"bm": 8,
			"nm": "",
			"nf": "Joseph",
			"nl": "Dennis",
			"url": "https://findagrave.com/memorial/158891057",
			"id": 158891057,
			"lng": -77.38740921,
			"lat": 37.53756648,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 11,
			"dd": 15,
			"by": 1924,
			"bd": 31,
			"bm": 1,
			"nm": "Agatha Williams",
			"nf": "Louise",
			"nl": "Dennis",
			"url": "https://findagrave.com/memorial/183697455",
			"id": 183697455,
			"lng": -77.38723923,
			"lat": 37.53706317,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 12,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Dennis",
			"url": "https://findagrave.com/memorial/811.502",
			"id": 207129734,
			"lng": -77.38659355,
			"lat": 37.53671056,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 3,
			"dd": 3,
			"by": 1875,
			"bd": 14,
			"bm": 10,
			"nm": "D.",
			"nf": "Samuel",
			"nl": "Dennis",
			"url": "https://findagrave.com/memorial/174697075",
			"id": 174697075,
			"lng": -77.3874154,
			"lat": 37.5370205,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 1,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Samuel",
			"nl": "Dennis",
			"url": "https://findagrave.com/memorial/146012163",
			"id": 146012163,
			"lng": -77.38660448,
			"lat": 37.53667865,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 1,
			"dd": 29,
			"by": 1854,
			"bd": 12,
			"bm": 10,
			"nm": "",
			"nf": "Abraham",
			"nl": "Dickens",
			"url": "https://findagrave.com/memorial/159760640",
			"id": 159760640,
			"lng": -77.3878496,
			"lat": 37.53782483,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1913,
			"dm": 11,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "Catherine",
			"nl": "Dickerson",
			"url": "https://findagrave.com/memorial/178249229",
			"id": 178249229,
			"lng": -77.38601904,
			"lat": 37.53645,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 11,
			"dd": 23,
			"by": 1888,
			"bd": 11,
			"bm": 4,
			"nm": "T.",
			"nf": "James",
			"nl": "Dickerson",
			"url": "https://findagrave.com/memorial/125518387",
			"id": 125518387,
			"lng": -77.385848,
			"lat": 37.53701305,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 7,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Margaret",
			"nl": "Dickerson",
			"url": "https://findagrave.com/memorial/137430005",
			"id": 137430005,
			"lng": -77.38586652,
			"lat": 37.53701863,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 1,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Matthew",
			"nl": "Dickerson",
			"url": "https://findagrave.com/memorial/150836536",
			"id": 150836536,
			"lng": -77.38599019,
			"lat": 37.53646365,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": 11,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sarah",
			"nl": "Dickerson",
			"url": "https://findagrave.com/memorial/152529073",
			"id": 152529073,
			"lng": -77.38601742,
			"lat": 37.5364604,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 2,
			"dd": 25,
			"by": 1962,
			"bd": 24,
			"bm": 10,
			"nm": "Portee",
			"nf": "Milton Lee",
			"nl": "Dix",
			"url": "https://findagrave.com/memorial/164110779",
			"id": 164110779,
			"lng": -77.38648713,
			"lat": 37.53707582,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 2,
			"dd": 27,
			"by": 1880,
			"bd": "",
			"bm": 11,
			"nm": "",
			"nf": "Carl",
			"nl": "Dixon",
			"url": "https://findagrave.com/memorial/117431888",
			"id": 117431888,
			"lng": -77.38547845,
			"lat": 37.5372979,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 9,
			"dd": 24,
			"by": 1912,
			"bd": 16,
			"bm": 7,
			"nm": "",
			"nf": "David",
			"nl": "Dixon",
			"url": "https://findagrave.com/memorial/163611734",
			"id": 163611734,
			"lng": -77.3875606,
			"lat": 37.5375854,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 1,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Edward",
			"nl": "Dixon",
			"url": "https://findagrave.com/memorial/175409066",
			"id": 175409066,
			"lng": -77.38742179,
			"lat": 37.53714664,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1909,
			"dm": 12,
			"dd": 13,
			"by": 1850,
			"bd": "",
			"bm": 7,
			"nm": "",
			"nf": "Otway",
			"nl": "Dixon",
			"url": "https://findagrave.com/memorial/144315624",
			"id": 144315624,
			"lng": -77.38661126,
			"lat": 37.53576682,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 6,
			"dd": 4,
			"by": 1880,
			"bd": 19,
			"bm": 9,
			"nm": "Allen",
			"nf": "Walter",
			"nl": "Dixon",
			"url": "https://findagrave.com/memorial/146339053",
			"id": 146339053,
			"lng": -77.3854777,
			"lat": 37.53731902,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 12,
			"dd": 12,
			"by": 1927,
			"bd": 11,
			"bm": 6,
			"nm": "Ross",
			"nf": "Wilbur",
			"nl": "Dixon",
			"url": "https://findagrave.com/memorial/177970580",
			"id": 177970580,
			"lng": -77.38800269,
			"lat": 37.53743042,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 12,
			"dd": 25,
			"by": 1949,
			"bd": 7,
			"bm": 8,
			"nm": "",
			"nf": "Willie",
			"nl": "Dobson",
			"url": "https://findagrave.com/memorial/178412477",
			"id": 178412477,
			"lng": -77.38608454,
			"lat": 37.53629657,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 8,
			"dd": 26,
			"by": 1914,
			"bd": 17,
			"bm": 10,
			"nm": "D.",
			"nf": "John",
			"nl": "Dockery",
			"url": "https://findagrave.com/memorial/136304148",
			"id": 136304148,
			"lng": -77.38594741,
			"lat": 37.53701972,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 6,
			"dd": 10,
			"by": 1914,
			"bd": 6,
			"bm": 10,
			"nm": "",
			"nf": "Lessie",
			"nl": "Dockery",
			"url": "https://findagrave.com/memorial/173314374",
			"id": 173314374,
			"lng": -77.38701308,
			"lat": 37.53719745,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 7,
			"dd": 17,
			"by": 1909,
			"bd": 3,
			"bm": 7,
			"nm": "Collonial",
			"nf": "Louis",
			"nl": "Dockery",
			"url": "https://findagrave.com/memorial/139146810",
			"id": 139146810,
			"lng": -77.38726968,
			"lat": 37.53720749,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 2,
			"dd": 12,
			"by": 1876,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Laura",
			"nl": "Donald",
			"url": "https://findagrave.com/memorial/161052004",
			"id": 161052004,
			"lng": -77.38711218,
			"lat": 37.537047,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 11,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Sarah",
			"nl": "Dorsey",
			"url": "https://findagrave.com/memorial/126456526",
			"id": 126456526,
			"lng": -77.38666148,
			"lat": 37.53585385,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 12,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Thelma",
			"nl": "Drew",
			"url": "https://findagrave.com/memorial/119240789",
			"id": 119240789,
			"lng": -77.38591552,
			"lat": 37.53679288,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 12,
			"dd": 23,
			"by": 1884,
			"bd": 17,
			"bm": 7,
			"nm": "",
			"nf": "Timothy",
			"nl": "Drinkwater",
			"url": "https://findagrave.com/memorial/153866424",
			"id": 153866424,
			"lng": -77.38622114,
			"lat": 37.5373548,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 9,
			"dd": 13,
			"by": 1903,
			"bd": 27,
			"bm": 11,
			"nm": "",
			"nf": "Edward",
			"nl": "Dudley",
			"url": "https://findagrave.com/memorial/185390204",
			"id": 185390204,
			"lng": -77.38760889,
			"lat": 37.53779534,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1911,
			"dm": 7,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Tazewell",
			"nl": "Dudley",
			"url": "https://findagrave.com/memorial/125806300",
			"id": 125806300,
			"lng": -77.38608521,
			"lat": 37.53595131,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 1,
			"dd": 1,
			"by": 1875,
			"bd": 10,
			"bm": 10,
			"nm": "",
			"nf": "Elnora",
			"nl": "Dungee",
			"url": "https://findagrave.com/memorial/125806315",
			"id": 125806315,
			"lng": -77.38579064,
			"lat": 37.53653006,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 12,
			"dd": 27,
			"by": 1870,
			"bd": "",
			"bm": 4,
			"nm": "A.",
			"nf": "Martha",
			"nl": "Dunn",
			"url": "https://findagrave.com/memorial/139146820",
			"id": 139146820,
			"lng": -77.38773167,
			"lat": 37.53690268,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 5,
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Lowell",
			"nl": "Dupree",
			"url": "https://findagrave.com/memorial/144105280",
			"id": 144105280,
			"lng": -77.3858999,
			"lat": 37.53744636,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 12,
			"dd": 24,
			"by": 1914,
			"bd": 29,
			"bm": 1,
			"nm": "",
			"nf": "Samuel",
			"nl": "Earl",
			"url": "https://findagrave.com/memorial/184480111",
			"id": 184480111,
			"lng": -77.38730708,
			"lat": 37.53763282,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 9,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Celia",
			"nl": "Earley",
			"url": "https://findagrave.com/memorial/144542886",
			"id": 144542886,
			"lng": -77.3865093,
			"lat": 37.53571072,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 5,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "O.",
			"nf": "James",
			"nl": "Early",
			"url": "https://findagrave.com/memorial/144542901",
			"id": 144542901,
			"lng": -77.38647715,
			"lat": 37.53571057,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 9,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bettie",
			"nl": "Easley",
			"url": "https://findagrave.com/memorial/176768251",
			"id": 176768251,
			"lng": -77.38776282,
			"lat": 37.53712627,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 6,
			"dd": 16,
			"by": 1921,
			"bd": 6,
			"bm": 4,
			"nm": "",
			"nf": "Howard",
			"nl": "Easley",
			"url": "https://findagrave.com/memorial/170723940",
			"id": 170723940,
			"lng": -77.38600892,
			"lat": 37.53628347,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 10,
			"dd": 28,
			"by": 1893,
			"bd": 30,
			"bm": 12,
			"nm": "Henry",
			"nf": "James",
			"nl": "Easley",
			"url": "https://findagrave.com/memorial/183194054",
			"id": 183194054,
			"lng": -77.38737611,
			"lat": 37.53706014,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 11,
			"dd": 11,
			"by": 1857,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alice",
			"nl": "East",
			"url": "https://findagrave.com/memorial/155759128",
			"id": 155759128,
			"lng": -77.38589264,
			"lat": 37.53643936,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 8,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Irvin",
			"nl": "East",
			"url": "https://findagrave.com/memorial/155757768",
			"id": 155757768,
			"lng": -77.38589295,
			"lat": 37.53644761,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 7,
			"dd": 13,
			"by": 1925,
			"bd": 12,
			"bm": 8,
			"nm": "L.",
			"nf": "Carroll",
			"nl": "Eddleton",
			"url": "https://findagrave.com/memorial/158891067",
			"id": 158891067,
			"lng": -77.38707445,
			"lat": 37.53768886,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 7,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Harrison",
			"nl": "Edmondson",
			"url": "https://findagrave.com/memorial/150786831",
			"id": 150786831,
			"lng": -77.38642352,
			"lat": 37.5355311,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 4,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alease",
			"nl": "Edwards",
			"url": "https://findagrave.com/memorial/175401444",
			"id": 175401444,
			"lng": -77.38755594,
			"lat": 37.53694263,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 11,
			"dd": 1,
			"by": 1918,
			"bd": 14,
			"bm": 7,
			"nm": "V.",
			"nf": "Fannie",
			"nl": "Edwards",
			"url": "https://findagrave.com/memorial/148285662",
			"id": 148285662,
			"lng": -77.38645999,
			"lat": 37.53543664,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 10,
			"dd": 6,
			"by": 1873,
			"bd": 5,
			"bm": 5,
			"nm": "",
			"nf": "Hattie",
			"nl": "Edwards",
			"url": "https://findagrave.com/memorial/154294641",
			"id": 154294641,
			"lng": -77.38686012,
			"lat": 37.53555338,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 3,
			"dd": 27,
			"by": 1858,
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Lucy",
			"nl": "Edwards",
			"url": "https://findagrave.com/memorial/113626444",
			"id": 113626444,
			"lng": -77.38582198,
			"lat": 37.5368281,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 8,
			"dd": 5,
			"by": 1910,
			"bd": 17,
			"bm": 11,
			"nm": "Bell",
			"nf": "Martin",
			"nl": "Edwards",
			"url": "https://findagrave.com/memorial/180231848",
			"id": 180231848,
			"lng": -77.38723157,
			"lat": 37.53690493,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 10,
			"dd": 29,
			"by": 1953,
			"bd": 31,
			"bm": 3,
			"nm": "Esterine",
			"nf": "Royall",
			"nl": "Edwards",
			"url": "https://findagrave.com/memorial/173166589",
			"id": 173166589,
			"lng": -77.38699825,
			"lat": 37.53722945,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 11,
			"dd": 14,
			"by": 1888,
			"bd": 16,
			"bm": 6,
			"nm": "S.",
			"nf": "William",
			"nl": "Edwards",
			"url": "https://findagrave.com/memorial/127460977",
			"id": 127460977,
			"lng": -77.3858007,
			"lat": 37.53660122,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 7,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Caroline",
			"nl": "Eldridge",
			"url": "https://findagrave.com/memorial/184277132",
			"id": 184277132,
			"lng": -77.38758096,
			"lat": 37.53743251,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 2,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bettie",
			"nl": "Ellett",
			"url": "https://findagrave.com/memorial/175614966",
			"id": 175614966,
			"lng": -77.38802703,
			"lat": 37.53718992,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 10,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Catherine",
			"nl": "Ellett",
			"url": "https://findagrave.com/memorial/134454186",
			"id": 134454186,
			"lng": -77.38568831,
			"lat": 37.53688701,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 5,
			"dd": 23,
			"by": 1887,
			"bd": 10,
			"bm": 7,
			"nm": "",
			"nf": "Cabell",
			"nl": "Ellis",
			"url": "https://findagrave.com/memorial/160933697",
			"id": 160933697,
			"lng": -77.38641646,
			"lat": 37.536786,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 7,
			"dd": 10,
			"by": 1945,
			"bd": 26,
			"bm": 5,
			"nm": "",
			"nf": "Dawson",
			"nl": "Ellis",
			"url": "https://findagrave.com/memorial/125806326",
			"id": 125806326,
			"lng": -77.38601926,
			"lat": 37.53742498,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 8,
			"dd": 12,
			"by": 1865,
			"bd": 13,
			"bm": 7,
			"nm": "",
			"nf": "James",
			"nl": "Ellis",
			"url": "https://findagrave.com/memorial/144542922",
			"id": 144542922,
			"lng": -77.3865397,
			"lat": 37.5356719,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 11,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucinda",
			"nl": "Ellis",
			"url": "https://findagrave.com/memorial/185763553",
			"id": 185763553,
			"lng": -77.38768296,
			"lat": 37.53692067,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 8,
			"dd": 3,
			"by": 1942,
			"bd": 19,
			"bm": 4,
			"nm": "",
			"nf": "Nathaniel",
			"nl": "Ellis",
			"url": "https://findagrave.com/memorial/155512360",
			"id": 155512360,
			"lng": -77.38654461,
			"lat": 37.5367659,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 10,
			"dd": 17,
			"by": 1893,
			"bd": 26,
			"bm": 5,
			"nm": "H.",
			"nf": "Wirt",
			"nl": "Ellis",
			"url": "https://findagrave.com/memorial/177545576",
			"id": 177545576,
			"lng": -77.38694052,
			"lat": 37.5354804,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 9,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Ann",
			"nf": "Lucy",
			"nl": "Epps",
			"url": "https://findagrave.com/memorial/133716111",
			"id": 133716111,
			"lng": -77.38594107,
			"lat": 37.53613523,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 2,
			"dd": 11,
			"by": 1882,
			"bd": 3,
			"bm": 6,
			"nm": "",
			"nf": "Mathews",
			"nl": "Epps",
			"url": "https://findagrave.com/memorial/130426335",
			"id": 130426335,
			"lng": -77.3860724,
			"lat": 37.53586315,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 4,
			"dd": 14,
			"by": 1844,
			"bd": "",
			"bm": 5,
			"nm": "",
			"nf": "Sarah",
			"nl": "Epps",
			"url": "https://findagrave.com/memorial/156187912",
			"id": 156187912,
			"lng": -77.38645527,
			"lat": 37.53540704,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 6,
			"dd": 12,
			"by": 1903,
			"bd": 19,
			"bm": 7,
			"nm": "",
			"nf": "Susie",
			"nl": "Epps",
			"url": "https://findagrave.com/memorial/122027340",
			"id": 122027340,
			"lng": -77.38594231,
			"lat": 37.53655484,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 9,
			"dd": 17,
			"by": 1903,
			"bd": 17,
			"bm": 7,
			"nm": "Roosevelt",
			"nf": "Walter",
			"nl": "Epps",
			"url": "https://findagrave.com/memorial/122027352",
			"id": 122027352,
			"lng": -77.38594077,
			"lat": 37.53655834,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 8,
			"dd": 2,
			"by": 1892,
			"bd": 1,
			"bm": 11,
			"nm": "L. M.",
			"nf": "Alma",
			"nl": "Evans",
			"url": "https://findagrave.com/memorial/144820785",
			"id": 144820785,
			"lng": -77.38652804,
			"lat": 37.5356957,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 11,
			"dd": 18,
			"by": 1908,
			"bd": 25,
			"bm": 11,
			"nm": "W.",
			"nf": "Charles",
			"nl": "Evans",
			"url": "https://findagrave.com/memorial/173664285",
			"id": 173664285,
			"lng": -77.3872262,
			"lat": 37.53741349,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 12,
			"dd": 4,
			"by": 1928,
			"bd": 21,
			"bm": 4,
			"nm": "W.",
			"nf": "Constance",
			"nl": "Evans",
			"url": "https://findagrave.com/memorial/129208551",
			"id": 129208551,
			"lng": -77.38635145,
			"lat": 37.5369953,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 1,
			"dd": 24,
			"by": 1965,
			"bd": 20,
			"bm": 8,
			"nm": "",
			"nf": "Diane",
			"nl": "Evans",
			"url": "https://findagrave.com/memorial/159411349",
			"id": 159411349,
			"lng": -77.38606252,
			"lat": 37.53747758,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1987,
			"dm": 3,
			"dd": 25,
			"by": 1932,
			"bd": 13,
			"bm": 10,
			"nm": "",
			"nf": "Florence",
			"nl": "Evans",
			"url": "https://findagrave.com/memorial/127719218",
			"id": 127719218,
			"lng": -77.38608749,
			"lat": 37.53655631,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 7,
			"dd": 7,
			"by": 1899,
			"bd": 24,
			"bm": 10,
			"nm": "L.",
			"nf": "Hazel",
			"nl": "Evans",
			"url": "https://findagrave.com/memorial/120610682",
			"id": 120610682,
			"lng": -77.38721712,
			"lat": 37.53743033,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 12,
			"dd": 28,
			"by": 1891,
			"bd": 1,
			"bm": 1,
			"nm": "P.",
			"nf": "Ida",
			"nl": "Evans",
			"url": "https://findagrave.com/memorial/160053469",
			"id": 160053469,
			"lng": -77.38659387,
			"lat": 37.53747743,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1906,
			"dm": 9,
			"dd": 29,
			"by": 1877,
			"bd": 3,
			"bm": 4,
			"nm": "",
			"nf": "Jacob",
			"nl": "Evans",
			"url": "https://findagrave.com/memorial/185390213",
			"id": 185390213,
			"lng": -77.38754879,
			"lat": 37.53654671,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 8,
			"dd": 12,
			"by": 1917,
			"bd": 29,
			"bm": 8,
			"nm": "",
			"nf": "Margie",
			"nl": "Evans",
			"url": "https://findagrave.com/memorial/123850448",
			"id": 123850448,
			"lng": -77.38602633,
			"lat": 37.53668066,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1899,
			"dm": 1,
			"dd": 23,
			"by": 1858,
			"bd": 22,
			"bm": 1,
			"nm": "Bruce",
			"nf": "Robert",
			"nl": "Evans",
			"url": "https://findagrave.com/memorial/145838350",
			"id": 145838350,
			"lng": -77.38652956,
			"lat": 37.53569772,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 11,
			"dd": 12,
			"by": 1858,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sarah",
			"nl": "Evans",
			"url": "https://findagrave.com/memorial/119328003",
			"id": 119328003,
			"lng": -77.38552586,
			"lat": 37.53731097,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 1,
			"dd": 12,
			"by": 1905,
			"bd": 8,
			"bm": 10,
			"nm": "Mae",
			"nf": "Annie",
			"nl": "Everett",
			"url": "https://findagrave.com/memorial/144315633",
			"id": 144315633,
			"lng": -77.38768229,
			"lat": 37.53765377,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 4,
			"dd": 22,
			"by": 1857,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "Ewell",
			"url": "https://findagrave.com/memorial/154228740",
			"id": 154228740,
			"lng": -77.38666305,
			"lat": 37.53554944,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 6,
			"dd": 16,
			"by": 1947,
			"bd": 11,
			"bm": 3,
			"nm": "Ann",
			"nf": "Barbra",
			"nl": "Faison",
			"url": "https://findagrave.com/memorial/173773133",
			"id": 173773133,
			"lng": -77.38733127,
			"lat": 37.53739818,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 7,
			"dd": 31,
			"by": 1909,
			"bd": 12,
			"bm": 11,
			"nm": "Henry",
			"nf": "Wilbur",
			"nl": "Faison",
			"url": "https://findagrave.com/memorial/142221483",
			"id": 142221483,
			"lng": -77.38664272,
			"lat": 37.5371714,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 7,
			"dd": 17,
			"by": 1908,
			"bd": 8,
			"bm": 8,
			"nm": "Lisvell",
			"nf": "Matt",
			"nl": "Farrar",
			"url": "https://findagrave.com/memorial/151265418",
			"id": 151265418,
			"lng": -77.38652068,
			"lat": 37.53676974,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 10,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "S.",
			"nf": "Ulysses",
			"nl": "Farrow",
			"url": "https://findagrave.com/memorial/167182278",
			"id": 167182278,
			"lng": -77.3867652,
			"lat": 37.53682523,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 4,
			"dd": 3,
			"by": 1875,
			"bd": 2,
			"bm": 4,
			"nm": "Jackson",
			"nf": "Henry",
			"nl": "Faulk",
			"url": "https://findagrave.com/memorial/146682156",
			"id": 146682156,
			"lng": -77.38622281,
			"lat": 37.5358335,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 6,
			"dd": 15,
			"by": 1861,
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "Charles",
			"nl": "Fauntleroy",
			"url": "https://findagrave.com/memorial/151085424",
			"id": 151085424,
			"lng": -77.38673656,
			"lat": 37.53568102,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 9,
			"dd": 29,
			"by": 1848,
			"bd": "",
			"bm": "",
			"nm": "Henry",
			"nf": "John",
			"nl": "Fauntleroy",
			"url": "https://findagrave.com/memorial/150866183",
			"id": 150866183,
			"lng": -77.38672863,
			"lat": 37.53582708,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 10,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Annie",
			"nl": "Felder",
			"url": "https://findagrave.com/memorial/177284422",
			"id": 177284422,
			"lng": -77.3873912,
			"lat": 37.53728471,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 8,
			"by": 1888,
			"bd": 3,
			"bm": 3,
			"nm": "D.",
			"nf": "Samuel",
			"nl": "Felder",
			"url": "https://findagrave.com/memorial/177280192",
			"id": 177280192,
			"lng": -77.38741685,
			"lat": 37.53728398,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 8,
			"dd": 13,
			"by": 1889,
			"bd": 11,
			"bm": 11,
			"nm": "A.",
			"nf": "Louise",
			"nl": "Fells",
			"url": "https://findagrave.com/memorial/156119504",
			"id": 156119504,
			"lng": -77.38613456,
			"lat": 37.53695955,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 3,
			"dd": 19,
			"by": 1887,
			"bd": 14,
			"bm": 1,
			"nm": "Philip",
			"nf": "William",
			"nl": "Fells",
			"url": "https://findagrave.com/memorial/156126310",
			"id": 156126310,
			"lng": -77.3860531,
			"lat": 37.53694458,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 11,
			"dd": 9,
			"by": 1905,
			"bd": 16,
			"bm": 5,
			"nm": "",
			"nf": "Bessie",
			"nl": "Feltz",
			"url": "https://findagrave.com/memorial/154509674",
			"id": 154509674,
			"lng": -77.38638853,
			"lat": 37.5374119,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 8,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "Fenderson",
			"url": "https://findagrave.com/memorial/175469648",
			"id": 175469648,
			"lng": -77.38733099,
			"lat": 37.53701739,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 8,
			"dd": 30,
			"by": 1899,
			"bd": 26,
			"bm": 12,
			"nm": "",
			"nf": "Guy",
			"nl": "Ferguson",
			"url": "https://findagrave.com/memorial/144105287",
			"id": 144105287,
			"lng": -77.38760125,
			"lat": 37.53759741,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 10,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lewis",
			"nl": "Ferrell",
			"url": "https://findagrave.com/memorial/161097218",
			"id": 161097218,
			"lng": -77.38708965,
			"lat": 37.53704339,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 12,
			"dd": 24,
			"by": 1925,
			"bd": 7,
			"bm": 3,
			"nm": "Juanita",
			"nf": "Mary",
			"nl": "Fessenton",
			"url": "https://findagrave.com/memorial/153946517",
			"id": 153946517,
			"lng": -77.38632911,
			"lat": 37.5374785,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 2,
			"dd": 19,
			"by": 1974,
			"bd": 24,
			"bm": 1,
			"nm": "Rosaette",
			"nf": "Tonya",
			"nl": "Fields",
			"url": "https://findagrave.com/memorial/142526897",
			"id": 142526897,
			"lng": -77.38591255,
			"lat": 37.5373508,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 5,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Annie",
			"nl": "Finney",
			"url": "https://findagrave.com/memorial/145325136",
			"id": 145325136,
			"lng": -77.385586,
			"lat": 37.53725614,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 2,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Robert",
			"nl": "Fisher",
			"url": "https://findagrave.com/memorial/175449958",
			"id": 175449958,
			"lng": -77.38748925,
			"lat": 37.53699904,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 5,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Fisher",
			"url": "https://findagrave.com/memorial/164624182",
			"id": 164624182,
			"lng": -77.38645735,
			"lat": 37.53567207,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 2,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Mary",
			"nl": "Fitzgerald",
			"url": "https://findagrave.com/memorial/145084193",
			"id": 145084193,
			"lng": -77.38742566,
			"lat": 37.53782747,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 4,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mattie",
			"nl": "Fitzgerald",
			"url": "https://findagrave.com/memorial/125408441",
			"id": 125408441,
			"lng": -77.38728676,
			"lat": 37.53694354,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 12,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Anna",
			"nl": "Fleming",
			"url": "https://findagrave.com/memorial/173897359",
			"id": 173897359,
			"lng": -77.38762173,
			"lat": 37.5371732,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 2,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Ann",
			"nf": "Eliza",
			"nl": "Fleming",
			"url": "https://findagrave.com/memorial/188299223",
			"id": 188299223,
			"lng": -77.38791968,
			"lat": 37.53706984,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 5,
			"dd": 26,
			"by": 1895,
			"bd": 6,
			"bm": 9,
			"nm": "T.",
			"nf": "Estelle",
			"nl": "Fleming",
			"url": "https://findagrave.com/memorial/152552926",
			"id": 152552926,
			"lng": -77.38659225,
			"lat": 37.53738469,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 10,
			"dd": 15,
			"by": 1910,
			"bd": 8,
			"bm": 8,
			"nm": "Lee",
			"nf": "Harold",
			"nl": "Fleming",
			"url": "https://findagrave.com/memorial/151265587",
			"id": 151265587,
			"lng": -77.3870195,
			"lat": 37.53703325,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 7,
			"dd": 3,
			"by": 1933,
			"bd": 19,
			"bm": 6,
			"nm": "Ronald",
			"nf": "James",
			"nl": "Fleming",
			"url": "https://findagrave.com/memorial/76587778",
			"id": 76587778,
			"lng": -77.3860925,
			"lat": 37.53702553,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 7,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Fleming",
			"url": "https://findagrave.com/memorial/181427144",
			"id": 181427144,
			"lng": -77.38799484,
			"lat": 37.53775696,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 7,
			"dd": 10,
			"by": 1873,
			"bd": 16,
			"bm": 9,
			"nm": "R.",
			"nf": "Shedrick",
			"nl": "Fleming",
			"url": "https://findagrave.com/memorial/153162680",
			"id": 153162680,
			"lng": -77.386133,
			"lat": 37.53695389,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 2,
			"dd": 6,
			"by": 1910,
			"bd": 3,
			"bm": 3,
			"nm": "",
			"nf": "Johnnie",
			"nl": "Flood",
			"url": "https://findagrave.com/memorial/139424351",
			"id": 139424351,
			"lng": -77.38631813,
			"lat": 37.53635795,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 3,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Flood",
			"url": "https://findagrave.com/memorial/187351673",
			"id": 187351673,
			"lng": -77.38785804,
			"lat": 37.53709122,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 6,
			"dd": 24,
			"by": 1901,
			"bd": 5,
			"bm": 8,
			"nm": "",
			"nf": "Pearl",
			"nl": "Flowers",
			"url": "https://findagrave.com/memorial/180521722",
			"id": 180521722,
			"lng": -77.38809568,
			"lat": 37.53753137,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 1,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Willie",
			"nl": "Floyd",
			"url": "https://findagrave.com/memorial/155123737",
			"id": 155123737,
			"lng": -77.38668663,
			"lat": 37.53713597,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 5,
			"dd": 17,
			"by": 1899,
			"bd": 15,
			"bm": 7,
			"nm": "",
			"nf": "Mack",
			"nl": "Fogle",
			"url": "https://findagrave.com/memorial/158676911",
			"id": 158676911,
			"lng": -77.3868794,
			"lat": 37.53747288,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 10,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "Alfred",
			"nl": "Folkes",
			"url": "https://findagrave.com/memorial/149439659",
			"id": 149439659,
			"lng": -77.38611653,
			"lat": 37.53589903,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 6,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Annie",
			"nl": "Folkes",
			"url": "https://findagrave.com/memorial/38425507",
			"id": 38425507,
			"lng": -77.3861288,
			"lat": 37.53574683,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 4,
			"dd": 17,
			"by": 1901,
			"bd": 15,
			"bm": 3,
			"nm": "",
			"nf": "Marcia",
			"nl": "Forcey",
			"url": "https://findagrave.com/memorial/175882989",
			"id": 175882989,
			"lng": -77.38636976,
			"lat": 37.53673049,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rosa",
			"nl": "Forcey",
			"url": "https://findagrave.com/memorial/187342818",
			"id": 187342818,
			"lng": -77.38775866,
			"lat": 37.53628097,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 10,
			"dd": 2,
			"by": 1865,
			"bd": "",
			"bm": 2,
			"nm": "Eliza",
			"nf": "Annie",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/138564996",
			"id": 138564996,
			"lng": -77.38644242,
			"lat": 37.53692178,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 12,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bernard",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/134454192",
			"id": 134454192,
			"lng": -77.38647837,
			"lat": 37.53699644,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 2,
			"dd": 24,
			"by": 1862,
			"bd": "",
			"bm": 2,
			"nm": "",
			"nf": "Beverly",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/138565000",
			"id": 138565000,
			"lng": -77.38644528,
			"lat": 37.53691602,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 1,
			"dd": 10,
			"by": 1888,
			"bd": 2,
			"bm": 2,
			"nm": "Thomas",
			"nf": "Beverly",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/76587792",
			"id": 76587792,
			"lng": -77.38638416,
			"lat": 37.53700583,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 7,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Grimes",
			"nf": "Charles",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/117804400",
			"id": 117804400,
			"lng": -77.38665649,
			"lat": 37.53738408,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 5,
			"dd": 20,
			"by": 1880,
			"bd": 3,
			"bm": 7,
			"nm": "M.",
			"nf": "Estelle",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/161053094",
			"id": 161053094,
			"lng": -77.38720177,
			"lat": 37.53707869,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 6,
			"dd": 25,
			"by": 1904,
			"bd": 2,
			"bm": 3,
			"nm": "",
			"nf": "Irene",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/142221487",
			"id": 142221487,
			"lng": -77.38665388,
			"lat": 37.53713178,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 3,
			"dd": 13,
			"by": 1896,
			"bd": 14,
			"bm": 12,
			"nm": "Harold",
			"nf": "James",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/138565008",
			"id": 138565008,
			"lng": -77.38645092,
			"lat": 37.53690358,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 10,
			"dd": 7,
			"by": 1921,
			"bd": 29,
			"bm": 10,
			"nm": "Reginald",
			"nf": "James",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/146920646",
			"id": 146920646,
			"lng": -77.38639025,
			"lat": 37.53698965,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 1,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/161053145",
			"id": 161053145,
			"lng": -77.38721016,
			"lat": 37.53708508,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 6,
			"dd": 10,
			"by": 1901,
			"bd": 28,
			"bm": 2,
			"nm": "",
			"nf": "Joseph",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/119391249",
			"id": 119391249,
			"lng": -77.38590594,
			"lat": 37.53660858,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 12,
			"dd": 28,
			"by": 1900,
			"bd": 10,
			"bm": 1,
			"nm": "",
			"nf": "Mary",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/145594999",
			"id": 145594999,
			"lng": -77.3863032,
			"lat": 37.53729983,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 3,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rosa",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/119391281",
			"id": 119391281,
			"lng": -77.38590006,
			"lat": 37.53662293,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 4,
			"dd": 2,
			"by": 1907,
			"bd": 17,
			"bm": 9,
			"nm": "",
			"nf": "Samuel",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/161947678",
			"id": 161947678,
			"lng": -77.38639086,
			"lat": 37.53712819,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 4,
			"dd": 25,
			"by": 1923,
			"bd": 4,
			"bm": 7,
			"nm": "Henry",
			"nf": "William",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/172033331",
			"id": 172033331,
			"lng": -77.38735247,
			"lat": 37.53682755,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 3,
			"dd": 28,
			"by": 1881,
			"bd": 1,
			"bm": 9,
			"nm": "",
			"nf": "William",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/119391300",
			"id": 119391300,
			"lng": -77.38587018,
			"lat": 37.53662646,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 2,
			"dd": 15,
			"by": 1892,
			"bd": "",
			"bm": 5,
			"nm": "Oscar",
			"nf": "William",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/138565018",
			"id": 138565018,
			"lng": -77.38642419,
			"lat": 37.53690464,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 8,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Eddie",
			"nl": "Foster",
			"url": "https://findagrave.com/memorial/186894216",
			"id": 186894216,
			"lng": -77.38752072,
			"lat": 37.53687419,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 2,
			"dd": 16,
			"by": 1909,
			"bd": 17,
			"bm": 8,
			"nm": "",
			"nf": "Eva",
			"nl": "Foster",
			"url": "https://findagrave.com/memorial/144558508",
			"id": 144558508,
			"lng": -77.38749697,
			"lat": 37.53734563,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 8,
			"dd": 13,
			"by": 1912,
			"bd": 18,
			"bm": 7,
			"nm": "",
			"nf": "George",
			"nl": "Foster",
			"url": "https://findagrave.com/memorial/172068399",
			"id": 172068399,
			"lng": -77.38692313,
			"lat": 37.53717126,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 4,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mitchell",
			"nl": "Fountain",
			"url": "https://findagrave.com/memorial/150035999",
			"id": 150035999,
			"lng": -77.38720295,
			"lat": 37.53547796,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1986,
			"dm": 11,
			"dd": 26,
			"by": 1903,
			"bd": 11,
			"bm": 6,
			"nm": "E.",
			"nf": "William",
			"nl": "Fountain",
			"url": "https://findagrave.com/memorial/38455978",
			"id": 38455978,
			"lng": -77.38578184,
			"lat": 37.53699647,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 5,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Anthony",
			"nl": "Fowlkes",
			"url": "https://findagrave.com/memorial/156045959",
			"id": 156045959,
			"lng": -77.38607774,
			"lat": 37.53589516,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 8,
			"dd": 31,
			"by": 1924,
			"bd": 6,
			"bm": 12,
			"nm": "Elizabeth",
			"nf": "Alease",
			"nl": "Fox",
			"url": "https://findagrave.com/memorial/148648708",
			"id": 148648708,
			"lng": -77.38701246,
			"lat": 37.53697596,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 11,
			"dd": 17,
			"by": 1878,
			"bd": 20,
			"bm": 1,
			"nm": "",
			"nf": "John",
			"nl": "Fox",
			"url": "https://findagrave.com/memorial/172043643",
			"id": 172043643,
			"lng": -77.38690938,
			"lat": 37.53724827,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 2,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alexander",
			"nl": "Franklin",
			"url": "https://findagrave.com/memorial/185493770",
			"id": 185493770,
			"lng": -77.38659403,
			"lat": 37.53594488,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 12,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Carrie",
			"nl": "Franklin",
			"url": "https://findagrave.com/memorial/76587804",
			"id": 76587804,
			"lng": -77.38547053,
			"lat": 37.53735102,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 4,
			"dd": 24,
			"by": 1913,
			"bd": 17,
			"bm": 4,
			"nm": "D.",
			"nf": "Leroy",
			"nl": "Franklin",
			"url": "https://findagrave.com/memorial/169042949",
			"id": 169042949,
			"lng": -77.38616075,
			"lat": 37.53741279,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 3,
			"dd": 13,
			"by": 1894,
			"bd": 20,
			"bm": 4,
			"nm": "",
			"nf": "Frank",
			"nl": "Frasure",
			"url": "https://findagrave.com/memorial/141193901",
			"id": 141193901,
			"lng": -77.3862801,
			"lat": 37.53668509,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 9,
			"dd": 12,
			"by": 1900,
			"bd": 19,
			"bm": 8,
			"nm": "",
			"nf": "Viola",
			"nl": "Frasure",
			"url": "https://findagrave.com/memorial/184094531",
			"id": 184094531,
			"lng": -77.38720488,
			"lat": 37.53757747,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 9,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Charles",
			"nl": "Fravier",
			"url": "https://findagrave.com/memorial/185564844",
			"id": 185564844,
			"lng": -77.3873161,
			"lat": 37.53685474,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 6,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Elnora",
			"nl": "Frazier",
			"url": "https://findagrave.com/memorial/155123917",
			"id": 155123917,
			"lng": -77.38666619,
			"lat": 37.53711345,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 12,
			"dd": 26,
			"by": 1883,
			"bd": 4,
			"bm": 7,
			"nm": "E.",
			"nf": "Leroy",
			"nl": "Frazier",
			"url": "https://findagrave.com/memorial/119240867",
			"id": 119240867,
			"lng": -77.38584394,
			"lat": 37.5368527,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 8,
			"dd": 3,
			"by": 1932,
			"bd": 26,
			"bm": 1,
			"nm": "R.",
			"nf": "Dorothy",
			"nl": "Freeman",
			"url": "https://findagrave.com/memorial/171761581",
			"id": 171761581,
			"lng": -77.38695709,
			"lat": 37.53705827,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 11,
			"dd": 24,
			"by": 1962,
			"bd": 14,
			"bm": 10,
			"nm": "F.",
			"nf": "Princella",
			"nl": "Freeman",
			"url": "https://findagrave.com/memorial/191503822",
			"id": 191503822,
			"lng": -77.38614808,
			"lat": 37.53751409,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 5,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Thomas",
			"nl": "Freeman",
			"url": "https://findagrave.com/memorial/186818136",
			"id": 186818136,
			"lng": -77.38723236,
			"lat": 37.53698769,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 5,
			"dd": 22,
			"by": 1901,
			"bd": "",
			"bm": 3,
			"nm": "",
			"nf": "Louise",
			"nl": "French",
			"url": "https://findagrave.com/memorial/139146848",
			"id": 139146848,
			"lng": -77.38780075,
			"lat": 37.53696202,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 12,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucy",
			"nl": "French",
			"url": "https://findagrave.com/memorial/166483161",
			"id": 166483161,
			"lng": -77.38726772,
			"lat": 37.5363109,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 2,
			"dd": 13,
			"by": 1931,
			"bd": 16,
			"bm": 4,
			"nm": "G.",
			"nf": "Julia",
			"nl": "Fuller",
			"url": "https://findagrave.com/memorial/153627702",
			"id": 153627702,
			"lng": -77.38630726,
			"lat": 37.53747015,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 9,
			"dd": 22,
			"by": 1884,
			"bd": 17,
			"bm": 12,
			"nm": "",
			"nf": "Mutt",
			"nl": "Fuller",
			"url": "https://findagrave.com/memorial/158891074",
			"id": 158891074,
			"lng": -77.38711204,
			"lat": 37.53750554,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 8,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nancy",
			"nl": "Fuller",
			"url": "https://findagrave.com/memorial/146012164",
			"id": 146012164,
			"lng": -77.38775299,
			"lat": 37.53668613,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 1,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Fuller",
			"url": "https://findagrave.com/memorial/146207059",
			"id": 146207059,
			"lng": -77.38587684,
			"lat": 37.53677522,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 11,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Hermina",
			"nl": "Fulton",
			"url": "https://findagrave.com/memorial/145595007",
			"id": 145595007,
			"lng": -77.38587031,
			"lat": 37.53734345,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 7,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Fulton",
			"url": "https://findagrave.com/memorial/145595012",
			"id": 145595012,
			"lng": -77.38587358,
			"lat": 37.53734448,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 5,
			"dd": 15,
			"by": 1886,
			"bd": 7,
			"bm": 3,
			"nm": "",
			"nf": "Jane",
			"nl": "Gabbin",
			"url": "https://findagrave.com/memorial/144105299",
			"id": 144105299,
			"lng": -77.38588815,
			"lat": 37.53739333,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 9,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Frank",
			"nl": "Gaddy",
			"url": "https://findagrave.com/memorial/176983670",
			"id": 176983670,
			"lng": -77.38749883,
			"lat": 37.53560601,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 4,
			"dd": 11,
			"by": 1871,
			"bd": 2,
			"bm": 3,
			"nm": "C.",
			"nf": "Mary",
			"nl": "Gaines",
			"url": "https://findagrave.com/memorial/176466887",
			"id": 176466887,
			"lng": -77.38717136,
			"lat": 37.5369388,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 7,
			"dd": 23,
			"by": 1879,
			"bd": 18,
			"bm": 12,
			"nm": "H. Allen",
			"nf": "William",
			"nl": "Gaines",
			"url": "https://findagrave.com/memorial/176466599",
			"id": 176466599,
			"lng": -77.38717175,
			"lat": 37.53694675,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 6,
			"dd": 19,
			"by": 1873,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Florence",
			"nl": "Gaines",
			"url": "https://findagrave.com/memorial/192637700",
			"id": 192637700,
			"lng": -77.38660003,
			"lat": 37.53736996,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 8,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Gardner",
			"url": "https://findagrave.com/memorial/151460478",
			"id": 151460478,
			"lng": -77.38800488,
			"lat": 37.53730351,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 9,
			"dd": 12,
			"by": 1950,
			"bd": 27,
			"bm": 3,
			"nm": "E.",
			"nf": "Carneal",
			"nl": "Garlick",
			"url": "https://findagrave.com/memorial/176570431",
			"id": 176570431,
			"lng": -77.38722312,
			"lat": 37.53752839,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 2,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Edward",
			"nf": "Willie",
			"nl": "Garner",
			"url": "https://findagrave.com/memorial/144189279",
			"id": 144189279,
			"lng": -77.38749514,
			"lat": 37.53741592,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 5,
			"dd": 7,
			"by": 1881,
			"bd": 21,
			"bm": 11,
			"nm": "E.",
			"nf": "Archie",
			"nl": "Garnett",
			"url": "https://findagrave.com/memorial/145084195",
			"id": 145084195,
			"lng": -77.38632636,
			"lat": 37.53730358,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 11,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Correlia",
			"nl": "Garnett",
			"url": "https://findagrave.com/memorial/139146860",
			"id": 139146860,
			"lng": -77.38798197,
			"lat": 37.53700034,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 5,
			"dd": 4,
			"by": 1858,
			"bd": 25,
			"bm": 12,
			"nm": "",
			"nf": "James",
			"nl": "Garnett",
			"url": "https://findagrave.com/memorial/115976029",
			"id": 115976029,
			"lng": -77.38570182,
			"lat": 37.53672178,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 5,
			"dd": 10,
			"by": 1888,
			"bd": 26,
			"bm": 12,
			"nm": "F.",
			"nf": "James",
			"nl": "Garnett",
			"url": "https://findagrave.com/memorial/117307716",
			"id": 117307716,
			"lng": -77.38571962,
			"lat": 37.53673848,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 2,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Josephine",
			"nl": "Garnett",
			"url": "https://findagrave.com/memorial/176983375",
			"id": 176983375,
			"lng": -77.38748792,
			"lat": 37.53567164,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 5,
			"dd": 8,
			"by": 1897,
			"bd": 2,
			"bm": 1,
			"nm": "",
			"nf": "Lewis",
			"nl": "Garnett",
			"url": "https://findagrave.com/memorial/117449099",
			"id": 117449099,
			"lng": -77.38573246,
			"lat": 37.53671632,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 4,
			"dd": 3,
			"by": 1860,
			"bd": 5,
			"bm": 5,
			"nm": "",
			"nf": "Virginia",
			"nl": "Garnett",
			"url": "https://findagrave.com/memorial/117449105",
			"id": 117449105,
			"lng": -77.38572721,
			"lat": 37.53672705,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 4,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Russell",
			"nl": "Gates",
			"url": "https://findagrave.com/memorial/144370207",
			"id": 144370207,
			"lng": -77.38705004,
			"lat": 37.53780921,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 8,
			"dd": 23,
			"by": 1892,
			"bd": 22,
			"bm": 8,
			"nm": "A.",
			"nf": "Florence",
			"nl": "Gatewood",
			"url": "https://findagrave.com/memorial/145638795",
			"id": 145638795,
			"lng": -77.38559228,
			"lat": 37.53722361,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 7,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mildred",
			"nl": "Gatewood",
			"url": "https://findagrave.com/memorial/161171365",
			"id": 161171365,
			"lng": -77.38702389,
			"lat": 37.53704767,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 2,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Samuel",
			"nl": "Gatewood",
			"url": "https://findagrave.com/memorial/169904896",
			"id": 169904896,
			"lng": -77.38682852,
			"lat": 37.53709348,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 9,
			"dd": 29,
			"by": 1960,
			"bd": 30,
			"bm": 6,
			"nm": "",
			"nf": "Ronnie",
			"nl": "Gay",
			"url": "https://findagrave.com/memorial/153625634",
			"id": 153625634,
			"lng": -77.38645577,
			"lat": 37.5376325,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 5,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Amanda",
			"nl": "Gayles",
			"url": "https://findagrave.com/memorial/120147040",
			"id": 120147040,
			"lng": -77.38599313,
			"lat": 37.53673764,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 4,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ezekiel",
			"nl": "Gayles",
			"url": "https://findagrave.com/memorial/188439060",
			"id": 188439060,
			"lng": -77.38800374,
			"lat": 37.53703539,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 6,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Josephine",
			"nl": "Gayles",
			"url": "https://findagrave.com/memorial/169425026",
			"id": 169425026,
			"lng": -77.38729796,
			"lat": 37.53674743,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 4,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "Evelyna",
			"nl": "Geiger",
			"url": "https://findagrave.com/memorial/176570439",
			"id": 176570439,
			"lng": -77.38692751,
			"lat": 37.5375213,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 9,
			"dd": 4,
			"by": 1897,
			"bd": "",
			"bm": "",
			"nm": "V.",
			"nf": "Ruth",
			"nl": "General",
			"url": "https://findagrave.com/memorial/137835705",
			"id": 137835705,
			"lng": -77.38625153,
			"lat": 37.53707881,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 3,
			"dd": 25,
			"by": 1918,
			"bd": 5,
			"bm": 3,
			"nm": "G.",
			"nf": "Susie",
			"nl": "General",
			"url": "https://findagrave.com/memorial/143022066",
			"id": 143022066,
			"lng": -77.38605633,
			"lat": 37.53733002,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 12,
			"dd": "",
			"by": 1894,
			"bd": 13,
			"bm": 2,
			"nm": "W.",
			"nf": "Sylvester",
			"nl": "General",
			"url": "https://findagrave.com/memorial/137835760",
			"id": 137835760,
			"lng": -77.38625042,
			"lat": 37.5370811,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 2,
			"dd": 16,
			"by": 1916,
			"bd": 21,
			"bm": 5,
			"nm": "T.",
			"nf": "Willie",
			"nl": "General",
			"url": "https://findagrave.com/memorial/128632132",
			"id": 128632132,
			"lng": -77.38621979,
			"lat": 37.5366222,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 12,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Claudie",
			"nl": "Gentry",
			"url": "https://findagrave.com/memorial/143696154",
			"id": 143696154,
			"lng": -77.38600565,
			"lat": 37.53606099,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 9,
			"dd": 25,
			"by": 1885,
			"bd": 9,
			"bm": 6,
			"nm": "",
			"nf": "Rosa",
			"nl": "Gerst",
			"url": "https://findagrave.com/memorial/141798909",
			"id": 141798909,
			"lng": -77.38670899,
			"lat": 37.53725441,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 3,
			"dd": 20,
			"by": 1939,
			"bd": 23,
			"bm": 11,
			"nm": "J.",
			"nf": "Albert",
			"nl": "Ghee",
			"url": "https://findagrave.com/memorial/144370216",
			"id": 144370216,
			"lng": -77.38606551,
			"lat": 37.53731722,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 6,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bessie",
			"nl": "Gibbs",
			"url": "https://findagrave.com/memorial/150037935",
			"id": 150037935,
			"lng": -77.3862292,
			"lat": 37.53614389,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 12,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "James",
			"nl": "Gibbs",
			"url": "https://findagrave.com/memorial/143632565",
			"id": 143632565,
			"lng": -77.3861201,
			"lat": 37.53585064,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 7,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Daisy",
			"nl": "Gibson",
			"url": "https://findagrave.com/memorial/155514218",
			"id": 155514218,
			"lng": -77.38757899,
			"lat": 37.53769471,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 8,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Laura",
			"nl": "Giggetts",
			"url": "https://findagrave.com/memorial/137430011",
			"id": 137430011,
			"lng": -77.38594056,
			"lat": 37.53704109,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": "",
			"dd": "",
			"by": 1903,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Martha",
			"nl": "Gilliam",
			"url": "https://findagrave.com/memorial/154039270",
			"id": 154039270,
			"lng": -77.38635726,
			"lat": 37.53712897,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 5,
			"dd": 28,
			"by": 1899,
			"bd": 3,
			"bm": 2,
			"nm": "",
			"nf": "Amos",
			"nl": "Gladney",
			"url": "https://findagrave.com/memorial/144105308",
			"id": 144105308,
			"lng": -77.38736431,
			"lat": 37.53791335,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 2,
			"dd": 12,
			"by": 1890,
			"bd": 19,
			"bm": 1,
			"nm": "J.",
			"nf": "Loving",
			"nl": "Glaspy",
			"url": "https://findagrave.com/memorial/155514228",
			"id": 155514228,
			"lng": -77.38757897,
			"lat": 37.5377762,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 2,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Charlotte",
			"nl": "Glenn",
			"url": "https://findagrave.com/memorial/185739565",
			"id": 185739565,
			"lng": -77.38780184,
			"lat": 37.53712664,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 7,
			"dd": 23,
			"by": 1910,
			"bd": 1,
			"bm": 1,
			"nm": "",
			"nf": "Leroy",
			"nl": "Glenn",
			"url": "https://findagrave.com/memorial/137835763",
			"id": 137835763,
			"lng": -77.38630305,
			"lat": 37.53704031,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 4,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Annie",
			"nl": "Godfrey",
			"url": "https://findagrave.com/memorial/127131707",
			"id": 127131707,
			"lng": -77.38610526,
			"lat": 37.53636561,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 3,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jasper",
			"nl": "Goforth",
			"url": "https://findagrave.com/memorial/177152036",
			"id": 177152036,
			"lng": -77.38792258,
			"lat": 37.53701233,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 6,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Goings",
			"url": "https://findagrave.com/memorial/188267878",
			"id": 188267878,
			"lng": -77.38787804,
			"lat": 37.5371516,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 2,
			"dd": 25,
			"by": 1878,
			"bd": 15,
			"bm": 9,
			"nm": "",
			"nf": "Gideon",
			"nl": "Goldsberry",
			"url": "https://findagrave.com/memorial/175409420",
			"id": 175409420,
			"lng": -77.3874174,
			"lat": 37.53702981,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 6,
			"dd": 14,
			"by": "",
			"bd": 19,
			"bm": 4,
			"nm": "",
			"nf": "Louise",
			"nl": "Goldsberry",
			"url": "https://findagrave.com/memorial/175411173",
			"id": 175411173,
			"lng": -77.38763045,
			"lat": 37.53727034,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 8,
			"dd": 7,
			"by": 1914,
			"bd": 1,
			"bm": 12,
			"nm": "Ann",
			"nf": "Cora",
			"nl": "Goode",
			"url": "https://findagrave.com/memorial/158942456",
			"id": 158942456,
			"lng": -77.38688944,
			"lat": 37.53747999,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 5,
			"dd": 4,
			"by": 1924,
			"bd": 20,
			"bm": 9,
			"nm": "L.",
			"nf": "Ernest",
			"nl": "Goode",
			"url": "https://findagrave.com/memorial/144105313",
			"id": 144105313,
			"lng": -77.38645008,
			"lat": 37.53755164,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 5,
			"dd": 10,
			"by": 1908,
			"bd": 28,
			"bm": 6,
			"nm": "O.",
			"nf": "Frederick",
			"nl": "Goode",
			"url": "https://findagrave.com/memorial/142448405",
			"id": 142448405,
			"lng": -77.38563597,
			"lat": 37.53738415,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 5,
			"dd": 26,
			"by": 1872,
			"bd": 28,
			"bm": 6,
			"nm": "",
			"nf": "Lewis",
			"nl": "Goode",
			"url": "https://findagrave.com/memorial/176986415",
			"id": 176986415,
			"lng": -77.38797799,
			"lat": 37.53721126,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 9,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Steele Jones",
			"nf": "Lula",
			"nl": "Goode",
			"url": "https://findagrave.com/memorial/176720253",
			"id": 176720253,
			"lng": -77.38795768,
			"lat": 37.53730125,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 4,
			"dd": 11,
			"by": 1904,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Oliver",
			"nl": "Goode",
			"url": "https://findagrave.com/memorial/142448408",
			"id": 142448408,
			"lng": -77.38565602,
			"lat": 37.53739428,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 1,
			"dd": 1,
			"by": 1935,
			"bd": 21,
			"bm": 1,
			"nm": "Lee",
			"nf": "Robert",
			"nl": "Goode",
			"url": "https://findagrave.com/memorial/164021573",
			"id": 164021573,
			"lng": -77.38755592,
			"lat": 37.53735311,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 3,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Samuel",
			"nl": "Goode",
			"url": "https://findagrave.com/memorial/142448418",
			"id": 142448418,
			"lng": -77.3856166,
			"lat": 37.5373808,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 9,
			"dd": 3,
			"by": 1965,
			"bd": 26,
			"bm": 1,
			"nm": "Tyrone",
			"nf": "Timothy",
			"nl": "Goode",
			"url": "https://findagrave.com/memorial/153100495",
			"id": 153100495,
			"lng": -77.38604419,
			"lat": 37.53748182,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 10,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Joseph",
			"nl": "Goodwin",
			"url": "https://findagrave.com/memorial/151104683",
			"id": 151104683,
			"lng": -77.3867537,
			"lat": 37.53545514,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": "",
			"dd": "",
			"by": 1886,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Salome",
			"nl": "Goodwyn",
			"url": "https://findagrave.com/memorial/141657452",
			"id": 141657452,
			"lng": -77.38666164,
			"lat": 37.53730562,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 2,
			"dd": 13,
			"by": 1897,
			"bd": 4,
			"bm": 12,
			"nm": "",
			"nf": "Cubic",
			"nl": "Gordon",
			"url": "https://findagrave.com/memorial/158891083",
			"id": 158891083,
			"lng": -77.38750407,
			"lat": 37.53758163,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 7,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Douglas",
			"nl": "Gordon",
			"url": "https://findagrave.com/memorial/144558511",
			"id": 144558511,
			"lng": -77.38656777,
			"lat": 37.53570835,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 3,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Mary",
			"nl": "Gordon",
			"url": "https://findagrave.com/memorial/150037583",
			"id": 150037583,
			"lng": -77.38741291,
			"lat": 37.53659347,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 4,
			"dd": 5,
			"by": 1919,
			"bd": "",
			"bm": 10,
			"nm": "Rosetta",
			"nf": "Mary",
			"nl": "Gordon",
			"url": "https://findagrave.com/memorial/177284774",
			"id": 177284774,
			"lng": -77.38734573,
			"lat": 37.5372835,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 4,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Percy",
			"nl": "Gordon",
			"url": "https://findagrave.com/memorial/185390231",
			"id": 185390231,
			"lng": -77.38739135,
			"lat": 37.53657707,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 11,
			"dd": 12,
			"by": 1939,
			"bd": 19,
			"bm": 10,
			"nm": "Mae",
			"nf": "Shirley",
			"nl": "Gordon",
			"url": "https://findagrave.com/memorial/176713424",
			"id": 176713424,
			"lng": -77.38748322,
			"lat": 37.53707616,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 4,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jennie",
			"nl": "Goss",
			"url": "https://findagrave.com/memorial/167269942",
			"id": 167269942,
			"lng": -77.38657732,
			"lat": 37.53741448,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 3,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Anna",
			"nl": "Gossett",
			"url": "https://findagrave.com/memorial/175585474",
			"id": 175585474,
			"lng": -77.38717305,
			"lat": 37.53700693,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 10,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Katie",
			"nl": "Graham",
			"url": "https://findagrave.com/memorial/154037716",
			"id": 154037716,
			"lng": -77.38652897,
			"lat": 37.53719211,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 3,
			"dd": 6,
			"by": 1935,
			"bd": 2,
			"bm": 8,
			"nm": "L.",
			"nf": "Lynwood",
			"nl": "Graham",
			"url": "https://findagrave.com/memorial/156930841",
			"id": 156930841,
			"lng": -77.38644106,
			"lat": 37.5371134,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 3,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Mattie",
			"nl": "Graham",
			"url": "https://findagrave.com/memorial/166382255",
			"id": 166382255,
			"lng": -77.3875046,
			"lat": 37.53672638,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 10,
			"dd": 29,
			"by": 1919,
			"bd": 13,
			"bm": 5,
			"nm": "",
			"nf": "Alice",
			"nl": "Gramby",
			"url": "https://findagrave.com/memorial/155514238",
			"id": 155514238,
			"lng": -77.38765528,
			"lat": 37.53754475,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 11,
			"dd": 29,
			"by": 1897,
			"bd": 19,
			"bm": 10,
			"nm": "",
			"nf": "Joseph",
			"nl": "Grammer",
			"url": "https://findagrave.com/memorial/177099244",
			"id": 177099244,
			"lng": -77.38777427,
			"lat": 37.53722263,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 8,
			"dd": 27,
			"by": 1893,
			"bd": 5,
			"bm": 3,
			"nm": "",
			"nf": "Erna",
			"nl": "Granderson",
			"url": "https://findagrave.com/memorial/146013313",
			"id": 146013313,
			"lng": -77.38656234,
			"lat": 37.53640121,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 7,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Christopher",
			"nl": "Grantham",
			"url": "https://findagrave.com/memorial/177565589",
			"id": 177565589,
			"lng": -77.38746965,
			"lat": 37.53549472,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 5,
			"dd": 19,
			"by": 1895,
			"bd": 3,
			"bm": 5,
			"nm": "",
			"nf": "Lillie",
			"nl": "Grandison",
			"url": "https://findagrave.com/memorial/154509715",
			"id": 154509715,
			"lng": -77.38682954,
			"lat": 37.53732714,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 1,
			"dd": 29,
			"by": 1903,
			"bd": 23,
			"bm": 7,
			"nm": "",
			"nf": "Willie",
			"nl": "Grant",
			"url": "https://findagrave.com/memorial/117208876",
			"id": 117208876,
			"lng": -77.38560157,
			"lat": 37.53710139,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 7,
			"dd": 13,
			"by": 1880,
			"bd": 20,
			"bm": 3,
			"nm": "",
			"nf": "Henry",
			"nl": "Granton",
			"url": "https://findagrave.com/memorial/146920657",
			"id": 146920657,
			"lng": -77.38583885,
			"lat": 37.53677579,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 10,
			"dd": 23,
			"by": 1878,
			"bd": 30,
			"bm": 11,
			"nm": "",
			"nf": "Cora",
			"nl": "Graves",
			"url": "https://findagrave.com/memorial/151104689",
			"id": 151104689,
			"lng": -77.38670798,
			"lat": 37.53559073,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 2,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "George",
			"nl": "Graves",
			"url": "https://findagrave.com/memorial/127568669",
			"id": 127568669,
			"lng": -77.38772558,
			"lat": 37.53648788,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 1,
			"dd": 28,
			"by": 1891,
			"bd": 26,
			"bm": 9,
			"nm": "J.",
			"nf": "Julia",
			"nl": "Graves",
			"url": "https://findagrave.com/memorial/176770846",
			"id": 176770846,
			"lng": -77.3874633,
			"lat": 37.53725011,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 10,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Walter",
			"nl": "Graves",
			"url": "https://findagrave.com/memorial/135631946",
			"id": 135631946,
			"lng": -77.38599466,
			"lat": 37.53691022,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 5,
			"dd": 15,
			"by": 1879,
			"bd": 9,
			"bm": 8,
			"nm": "Henry",
			"nf": "William",
			"nl": "Graves",
			"url": "https://findagrave.com/memorial/167182283",
			"id": 167182283,
			"lng": -77.38659258,
			"lat": 37.53691168,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 6,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ella",
			"nl": "Gray",
			"url": "https://findagrave.com/memorial/145638801",
			"id": 145638801,
			"lng": -77.38583736,
			"lat": 37.53704681,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 2,
			"dd": 14,
			"by": 1863,
			"bd": "",
			"bm": 12,
			"nm": "",
			"nf": "Hattie",
			"nl": "Gray",
			"url": "https://findagrave.com/memorial/125820813",
			"id": 125820813,
			"lng": -77.38621371,
			"lat": 37.53589791,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 2,
			"dd": 3,
			"by": 1922,
			"bd": 22,
			"bm": 1,
			"nm": "",
			"nf": "Irma",
			"nl": "Gray",
			"url": "https://findagrave.com/memorial/160335425",
			"id": 160335425,
			"lng": -77.38609337,
			"lat": 37.53634692,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 8,
			"dd": 30,
			"by": 1916,
			"bd": 10,
			"bm": 7,
			"nm": "Frank",
			"nf": "Purcell",
			"nl": "Gray",
			"url": "https://findagrave.com/memorial/129209843",
			"id": 129209843,
			"lng": -77.38624243,
			"lat": 37.53684581,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 6,
			"dd": 5,
			"by": 1860,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Randolph",
			"nl": "Gray",
			"url": "https://findagrave.com/memorial/125820808",
			"id": 125820808,
			"lng": -77.38620698,
			"lat": 37.53589921,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 7,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sheppard",
			"nl": "Gray",
			"url": "https://findagrave.com/memorial/188268351",
			"id": 188268351,
			"lng": -77.38787868,
			"lat": 37.53713524,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 1,
			"dd": 27,
			"by": 1892,
			"bd": "",
			"bm": "",
			"nm": "I.",
			"nf": "Alenzia",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/144315639",
			"id": 144315639,
			"lng": -77.38752593,
			"lat": 37.53735762,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 2,
			"dd": 15,
			"by": 1868,
			"bd": "",
			"bm": 5,
			"nm": "",
			"nf": "Archie",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/154294645",
			"id": 154294645,
			"lng": -77.38699538,
			"lat": 37.53558145,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 7,
			"dd": 29,
			"by": 1894,
			"bd": 16,
			"bm": 2,
			"nm": "",
			"nf": "Ben",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/179193103",
			"id": 179193103,
			"lng": -77.3867019,
			"lat": 37.53764426,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 10,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bettie",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/151108164",
			"id": 151108164,
			"lng": -77.38666366,
			"lat": 37.53549088,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 2,
			"dd": 23,
			"by": 1872,
			"bd": "",
			"bm": 8,
			"nm": "",
			"nf": "Carrie",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/121031150",
			"id": 121031150,
			"lng": -77.38590289,
			"lat": 37.53655457,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 9,
			"dd": 3,
			"by": 1868,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Eliza",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/154515969",
			"id": 154515969,
			"lng": -77.38652211,
			"lat": 37.53561926,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 3,
			"dd": 10,
			"by": 1880,
			"bd": 27,
			"bm": 2,
			"nm": "Beatrice",
			"nf": "Emma",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/138366538",
			"id": 138366538,
			"lng": -77.38680389,
			"lat": 37.53688437,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 7,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Fannie",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/169465043",
			"id": 169465043,
			"lng": -77.38766047,
			"lat": 37.53699687,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 1,
			"dd": 22,
			"by": 1868,
			"bd": 30,
			"bm": 10,
			"nm": "H.",
			"nf": "John",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/155514253",
			"id": 155514253,
			"lng": -77.38701567,
			"lat": 37.53554233,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 11,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Lawson",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/127881078",
			"id": 127881078,
			"lng": -77.38604818,
			"lat": 37.53657167,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1991,
			"dm": 1,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "D.",
			"nf": "Maggie",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/128632158",
			"id": 128632158,
			"lng": -77.38613367,
			"lat": 37.5366394,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 3,
			"dd": 8,
			"by": 1903,
			"bd": 25,
			"bm": 11,
			"nm": "",
			"nf": "Mary",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/158525865",
			"id": 158525865,
			"lng": -77.38673914,
			"lat": 37.53769524,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 1,
			"dd": 20,
			"by": 1894,
			"bd": 12,
			"bm": 2,
			"nm": "V.",
			"nf": "Mattie",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/151039623",
			"id": 151039623,
			"lng": -77.3869956,
			"lat": 37.53556747,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 11,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Virginia",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/171937820",
			"id": 171937820,
			"lng": -77.38697138,
			"lat": 37.53727038,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 12,
			"dd": 24,
			"by": 1942,
			"bd": 1,
			"bm": 3,
			"nm": "Clifton",
			"nf": "Walter",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/184319229",
			"id": 184319229,
			"lng": -77.38708009,
			"lat": 37.53760068,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 10,
			"dd": 11,
			"by": 1903,
			"bd": 2,
			"bm": 11,
			"nm": "Avis",
			"nf": "Evelyn",
			"nl": "Griffin",
			"url": "https://findagrave.com/memorial/117208905",
			"id": 117208905,
			"lng": -77.38556282,
			"lat": 37.5371159,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 7,
			"dd": 6,
			"by": 1875,
			"bd": 1,
			"bm": 9,
			"nm": "Valentine",
			"nf": "Joseph",
			"nl": "Griffin",
			"url": "https://findagrave.com/memorial/117208912",
			"id": 117208912,
			"lng": -77.38554084,
			"lat": 37.53709676,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 1,
			"dd": 30,
			"by": 1853,
			"bd": 9,
			"bm": 10,
			"nm": "R.",
			"nf": "Joshua",
			"nl": "Griffin",
			"url": "https://findagrave.com/memorial/150836254",
			"id": 150836254,
			"lng": -77.38629837,
			"lat": 37.5354715,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 8,
			"dd": 29,
			"by": 1935,
			"bd": 10,
			"bm": 8,
			"nm": "Sylvester",
			"nf": "Leon",
			"nl": "Griffin",
			"url": "https://findagrave.com/memorial/173773143",
			"id": 173773143,
			"lng": -77.38715239,
			"lat": 37.5373121,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1904,
			"dm": 4,
			"dd": 12,
			"by": 1854,
			"bd": "",
			"bm": 12,
			"nm": "A.",
			"nf": "Minerva",
			"nl": "Griffin",
			"url": "https://findagrave.com/memorial/148460578",
			"id": 148460578,
			"lng": -77.38632752,
			"lat": 37.53545767,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 2,
			"dd": 5,
			"by": 1964,
			"bd": 2,
			"bm": 10,
			"nm": "Leon",
			"nf": "Roosevelt",
			"nl": "Griffin",
			"url": "https://findagrave.com/memorial/191503826",
			"id": 191503826,
			"lng": -77.38607781,
			"lat": 37.53747,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 5,
			"dd": 5,
			"by": 1882,
			"bd": 28,
			"bm": 6,
			"nm": "Donnas",
			"nf": "Sie",
			"nl": "Griffis",
			"url": "https://findagrave.com/memorial/185715929",
			"id": 185715929,
			"lng": -77.38772937,
			"lat": 37.53738575,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1913,
			"dm": 1,
			"dd": 17,
			"by": 1859,
			"bd": 9,
			"bm": 8,
			"nm": "Thomas",
			"nf": "Henry",
			"nl": "Grimes",
			"url": "https://findagrave.com/memorial/149251652",
			"id": 149251652,
			"lng": -77.38620481,
			"lat": 37.53606397,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 10,
			"dd": 5,
			"by": 1893,
			"bd": 31,
			"bm": 8,
			"nm": "T.",
			"nf": "Henry",
			"nl": "Grymes",
			"url": "https://findagrave.com/memorial/171101256",
			"id": 171101256,
			"lng": -77.38620745,
			"lat": 37.53604442,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 12,
			"dd": 14,
			"by": 1963,
			"bd": 10,
			"bm": 11,
			"nm": "",
			"nf": "Stephen",
			"nl": "Hagins",
			"url": "https://findagrave.com/memorial/159411360",
			"id": 159411360,
			"lng": -77.38615271,
			"lat": 37.53748474,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 7,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Fred",
			"nl": "Hall",
			"url": "https://findagrave.com/memorial/125518395",
			"id": 125518395,
			"lng": -77.38621613,
			"lat": 37.53685221,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 11,
			"dd": 9,
			"by": 1909,
			"bd": 10,
			"bm": 11,
			"nm": "Dyous",
			"nf": "Minnie",
			"nl": "Hall",
			"url": "https://findagrave.com/memorial/183587440",
			"id": 183587440,
			"lng": -77.38695522,
			"lat": 37.5372392,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 17,
			"by": 1940,
			"bd": 10,
			"bm": 7,
			"nm": "",
			"nf": "Rosemarie",
			"nl": "Hall",
			"url": "https://findagrave.com/memorial/177284023",
			"id": 177284023,
			"lng": -77.38735403,
			"lat": 37.53725929,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1909,
			"dm": 2,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alice",
			"nl": "Hamilton",
			"url": "https://findagrave.com/memorial/148450710",
			"id": 148450710,
			"lng": -77.38637767,
			"lat": 37.5357077,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1909,
			"dm": 6,
			"dd": 28,
			"by": 1858,
			"bd": "",
			"bm": 1,
			"nm": "Jane",
			"nf": "Mary",
			"nl": "Hamilton",
			"url": "https://findagrave.com/memorial/150033720",
			"id": 150033720,
			"lng": -77.38627997,
			"lat": 37.53585103,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": "",
			"dd": "",
			"by": 1894,
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Tim",
			"nl": "Hamilton",
			"url": "https://findagrave.com/memorial/144315648",
			"id": 144315648,
			"lng": -77.38614294,
			"lat": 37.53726021,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 6,
			"dd": 22,
			"by": 1854,
			"bd": 25,
			"bm": 12,
			"nm": "Henry",
			"nf": "William",
			"nl": "Hamilton",
			"url": "https://findagrave.com/memorial/150033728",
			"id": 150033728,
			"lng": -77.38627826,
			"lat": 37.53585716,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 11,
			"dd": 4,
			"by": 1879,
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Walter",
			"nl": "Hamm",
			"url": "https://findagrave.com/memorial/185658247",
			"id": 185658247,
			"lng": -77.38782138,
			"lat": 37.53724237,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 6,
			"dd": 23,
			"by": 1873,
			"bd": 25,
			"bm": 10,
			"nm": "",
			"nf": "Susie",
			"nl": "Hammond",
			"url": "https://findagrave.com/memorial/185392422",
			"id": 185392422,
			"lng": -77.3874951,
			"lat": 37.53761249,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 6,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Rufus",
			"nf": "Thomas",
			"nl": "Hammond",
			"url": "https://findagrave.com/memorial/185377784",
			"id": 185377784,
			"lng": -77.38672325,
			"lat": 37.53761334,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 5,
			"dd": 2,
			"by": 1897,
			"bd": 27,
			"bm": 8,
			"nm": "H.",
			"nf": "William",
			"nl": "Hammond",
			"url": "https://findagrave.com/memorial/163847049",
			"id": 163847049,
			"lng": -77.38755706,
			"lat": 37.53743631,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 7,
			"dd": 21,
			"by": 1907,
			"bd": 12,
			"bm": 4,
			"nm": "",
			"nf": "Virginia",
			"nl": "Hancock",
			"url": "https://findagrave.com/memorial/137430038",
			"id": 137430038,
			"lng": -77.38597584,
			"lat": 37.5370665,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 12,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "James",
			"nl": "Hardin",
			"url": "https://findagrave.com/memorial/144143005",
			"id": 144143005,
			"lng": -77.38595464,
			"lat": 37.5372959,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 5,
			"dd": 20,
			"by": 1912,
			"bd": 19,
			"bm": 1,
			"nm": "",
			"nf": "Blufort",
			"nl": "Hardy",
			"url": "https://findagrave.com/memorial/155515675",
			"id": 155515675,
			"lng": -77.38755294,
			"lat": 37.53747961,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 10,
			"dd": 10,
			"by": 1916,
			"bd": 3,
			"bm": 12,
			"nm": "S.",
			"nf": "Charles",
			"nl": "Hargrove",
			"url": "https://findagrave.com/memorial/154037786",
			"id": 154037786,
			"lng": -77.38652614,
			"lat": 37.5372013,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 6,
			"dd": 23,
			"by": 1898,
			"bd": 22,
			"bm": 11,
			"nm": "",
			"nf": "George",
			"nl": "Hargrove",
			"url": "https://findagrave.com/memorial/161180417",
			"id": 161180417,
			"lng": -77.38721794,
			"lat": 37.53716534,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 8,
			"dd": 19,
			"by": 1900,
			"bd": 11,
			"bm": 7,
			"nm": "",
			"nf": "James",
			"nl": "Hargrove",
			"url": "https://findagrave.com/memorial/139146877",
			"id": 139146877,
			"lng": -77.38785644,
			"lat": 37.53695809,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 5,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rosa",
			"nl": "Hargrove",
			"url": "https://findagrave.com/memorial/145595967",
			"id": 145595967,
			"lng": -77.38588245,
			"lat": 37.53740055,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 5,
			"dd": 22,
			"by": 1877,
			"bd": 23,
			"bm": 11,
			"nm": "James",
			"nf": "Stephen",
			"nl": "Hargrove",
			"url": "https://findagrave.com/memorial/158679365",
			"id": 158679365,
			"lng": -77.38707979,
			"lat": 37.53747392,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 10,
			"dd": 3,
			"by": 1915,
			"bd": 4,
			"bm": 3,
			"nm": "",
			"nf": "Lindsay",
			"nl": "Harkless",
			"url": "https://findagrave.com/memorial/141800929",
			"id": 141800929,
			"lng": -77.38655054,
			"lat": 37.53722056,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 7,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Ella",
			"nl": "Harper",
			"url": "https://findagrave.com/memorial/151108172",
			"id": 151108172,
			"lng": -77.38660053,
			"lat": 37.53545044,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 1,
			"dd": 13,
			"by": 1967,
			"bd": 8,
			"bm": 12,
			"nm": "",
			"nf": "Eugenia",
			"nl": "Harper",
			"url": "https://findagrave.com/memorial/124564894",
			"id": 124564894,
			"lng": -77.3859238,
			"lat": 37.53744958,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 7,
			"dd": 29,
			"by": 1901,
			"bd": "",
			"bm": "",
			"nm": "Archer",
			"nf": "Frank",
			"nl": "Harper",
			"url": "https://findagrave.com/memorial/138181480",
			"id": 138181480,
			"lng": -77.38638229,
			"lat": 37.53706617,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 9,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "James",
			"nl": "Harper",
			"url": "https://findagrave.com/memorial/151108176",
			"id": 151108176,
			"lng": -77.38656515,
			"lat": 37.53545667,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1905,
			"dm": 12,
			"dd": 21,
			"by": 1825,
			"bd": "",
			"bm": 3,
			"nm": "",
			"nf": "Adaline",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/132641390",
			"id": 132641390,
			"lng": -77.38775524,
			"lat": 37.53651694,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 10,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Armistead",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/156119513",
			"id": 156119513,
			"lng": -77.38612163,
			"lat": 37.53695309,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 3,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bettie",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/185392427",
			"id": 185392427,
			"lng": -77.3877793,
			"lat": 37.53655488,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 12,
			"dd": 1,
			"by": 1887,
			"bd": 3,
			"bm": 10,
			"nm": "L.",
			"nf": "Carrington",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/175585497",
			"id": 175585497,
			"lng": -77.3874193,
			"lat": 37.53627501,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 5,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "F.",
			"nf": "Catherine",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/151108184",
			"id": 151108184,
			"lng": -77.38650926,
			"lat": 37.53543585,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 3,
			"dd": 20,
			"by": 1893,
			"bd": 1,
			"bm": 4,
			"nm": "",
			"nf": "Clinton",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/164024392",
			"id": 164024392,
			"lng": -77.38641507,
			"lat": 37.53710963,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 10,
			"dd": 26,
			"by": 1872,
			"bd": 15,
			"bm": 11,
			"nm": "",
			"nf": "David",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/113633256",
			"id": 113633256,
			"lng": -77.38588236,
			"lat": 37.53697788,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 12,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/122027543",
			"id": 122027543,
			"lng": -77.38592501,
			"lat": 37.5364987,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 12,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Emma",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/183587447",
			"id": 183587447,
			"lng": -77.38691609,
			"lat": 37.53694125,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 2,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "T",
			"nf": "Emma",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/170839568",
			"id": 170839568,
			"lng": -77.38650209,
			"lat": 37.53705668,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": "",
			"dd": "",
			"by": 1908,
			"bd": "",
			"bm": "",
			"nm": "R.",
			"nf": "George",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/129209851",
			"id": 129209851,
			"lng": -77.38602905,
			"lat": 37.53674407,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 8,
			"dd": 13,
			"by": 1912,
			"bd": "",
			"bm": 3,
			"nm": "",
			"nf": "Gertrude",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/172031021",
			"id": 172031021,
			"lng": -77.38663378,
			"lat": 37.53720043,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 2,
			"dd": 3,
			"by": 1901,
			"bd": 5,
			"bm": 3,
			"nm": "G.",
			"nf": "Gladys",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/136107558",
			"id": 136107558,
			"lng": -77.38564036,
			"lat": 37.53732534,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1912,
			"dm": 12,
			"dd": 13,
			"by": 1899,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Gladyst",
			"nl": "Foster",
			"url": "https://findagrave.com/memorial/185392436",
			"id": 185392436,
			"lng": -77.38779385,
			"lat": 37.53646304,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 1,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Henry",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/157969004",
			"id": 157969004,
			"lng": -77.38633886,
			"lat": 37.53571717,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 1,
			"dd": 10,
			"by": 1919,
			"bd": 20,
			"bm": 10,
			"nm": "",
			"nf": "Herman",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/172296830",
			"id": 172296830,
			"lng": -77.38641702,
			"lat": 37.5353279,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 6,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Isabella",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/169483648",
			"id": 169483648,
			"lng": -77.38787616,
			"lat": 37.5370274,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 1,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Isaiah",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/119240880",
			"id": 119240880,
			"lng": -77.38583466,
			"lat": 37.53687874,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 8,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/24865524",
			"id": 24865524,
			"lng": -77.38588098,
			"lat": 37.53648163,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 11,
			"dd": 24,
			"by": 1941,
			"bd": 25,
			"bm": 2,
			"nm": "Ann",
			"nf": "Jean",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/168728638",
			"id": 168728638,
			"lng": -77.38635037,
			"lat": 37.53715606,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 1,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Julia",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/154264051",
			"id": 154264051,
			"lng": -77.38645854,
			"lat": 37.53557717,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 8,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Leonard",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/129209861",
			"id": 129209861,
			"lng": -77.38588512,
			"lat": 37.53697071,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 3,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Lillie",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/169397253",
			"id": 169397253,
			"lng": -77.38632712,
			"lat": 37.53684152,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 10,
			"dd": 2,
			"by": 1895,
			"bd": 16,
			"bm": 10,
			"nm": "",
			"nf": "Lottie",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/136304874",
			"id": 136304874,
			"lng": -77.38587394,
			"lat": 37.53707328,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 3,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucious",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/184048824",
			"id": 184048824,
			"lng": -77.38640521,
			"lat": 37.53668624,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 10,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Lucy",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/169397261",
			"id": 169397261,
			"lng": -77.38630223,
			"lat": 37.53683029,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 7,
			"dd": 8,
			"by": 1897,
			"bd": 26,
			"bm": 5,
			"nm": "",
			"nf": "Lula",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/185377429",
			"id": 185377429,
			"lng": -77.3867381,
			"lat": 37.53759293,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 5,
			"dd": 4,
			"by": 1908,
			"bd": 28,
			"bm": 9,
			"nm": "",
			"nf": "Maria",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/157757353",
			"id": 157757353,
			"lng": -77.38571971,
			"lat": 37.53734716,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 1,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Ellen",
			"nf": "Martha",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/151041067",
			"id": 151041067,
			"lng": -77.38625143,
			"lat": 37.53589327,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 8,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Mary",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/181956325",
			"id": 181956325,
			"lng": -77.38777671,
			"lat": 37.53642309,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 2,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Mary",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/184512317",
			"id": 184512317,
			"lng": -77.38766158,
			"lat": 37.53675879,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 2,
			"dd": 13,
			"by": 1895,
			"bd": 18,
			"bm": 12,
			"nm": "",
			"nf": "Mary",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/184483920",
			"id": 184483920,
			"lng": -77.38733521,
			"lat": 37.53766813,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 1,
			"dd": 10,
			"by": 1899,
			"bd": 23,
			"bm": 10,
			"nm": "Wellington",
			"nf": "Moses",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/136107567",
			"id": 136107567,
			"lng": -77.38565867,
			"lat": 37.53734194,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 3,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rebecca",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/128672339",
			"id": 128672339,
			"lng": -77.38612527,
			"lat": 37.53662598,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 4,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Richard",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/187354308",
			"id": 187354308,
			"lng": -77.38701281,
			"lat": 37.53660756,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 3,
			"dd": 13,
			"by": 1855,
			"bd": 10,
			"bm": 1,
			"nm": "",
			"nf": "Robert",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/185392442",
			"id": 185392442,
			"lng": -77.38773458,
			"lat": 37.53651479,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 12,
			"dd": 12,
			"by": 1874,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Robert",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/171761593",
			"id": 171761593,
			"lng": -77.38720472,
			"lat": 37.53672445,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 10,
			"dd": 6,
			"by": 1932,
			"bd": 4,
			"bm": 1,
			"nm": "",
			"nf": "Robert",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/173077979",
			"id": 173077979,
			"lng": -77.38705941,
			"lat": 37.53733123,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 6,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "Robert",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/136304879",
			"id": 136304879,
			"lng": -77.38589839,
			"lat": 37.53704431,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 4,
			"dd": 7,
			"by": 1870,
			"bd": "",
			"bm": 10,
			"nm": "L.",
			"nf": "Rosa",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/125408451",
			"id": 125408451,
			"lng": -77.38778421,
			"lat": 37.53633956,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 7,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Samuel",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/169483298",
			"id": 169483298,
			"lng": -77.38766077,
			"lat": 37.53707397,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 1,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Alice",
			"nf": "Sarah",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/172081905",
			"id": 172081905,
			"lng": -77.38739178,
			"lat": 37.53667821,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 1,
			"dd": 23,
			"by": 1872,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sarah",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/164022533",
			"id": 164022533,
			"lng": -77.38654102,
			"lat": 37.53702476,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": "",
			"dd": "",
			"by": 1872,
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Susie",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/175421165",
			"id": 175421165,
			"lng": -77.38751899,
			"lat": 37.53711967,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 12,
			"dd": 23,
			"by": 1968,
			"bd": 10,
			"bm": 11,
			"nm": "L.",
			"nf": "Tammy",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/159663319",
			"id": 159663319,
			"lng": -77.38590352,
			"lat": 37.53741689,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 11,
			"dd": 3,
			"by": 1923,
			"bd": 7,
			"bm": 1,
			"nm": "J.",
			"nf": "Thelma",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/185958406",
			"id": 185958406,
			"lng": -77.38638349,
			"lat": 37.53593313,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 7,
			"dd": 30,
			"by": 1921,
			"bd": 5,
			"bm": 11,
			"nm": "",
			"nf": "Thomas",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/156453282",
			"id": 156453282,
			"lng": -77.3863813,
			"lat": 37.53577352,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 7,
			"dd": 17,
			"by": 1932,
			"bd": 5,
			"bm": 8,
			"nm": "",
			"nf": "Thomas",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/177286672",
			"id": 177286672,
			"lng": -77.38728972,
			"lat": 37.53725168,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 12,
			"dd": 26,
			"by": 1925,
			"bd": 25,
			"bm": 12,
			"nm": "Robert",
			"nf": "Thomas",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/123587189",
			"id": 123587189,
			"lng": -77.38601486,
			"lat": 37.53637475,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 11,
			"dd": 11,
			"by": 1930,
			"bd": 4,
			"bm": 3,
			"nm": "A.",
			"nf": "Vernon",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/153511905",
			"id": 153511905,
			"lng": -77.38677611,
			"lat": 37.53734851,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 1,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Walter",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/138565033",
			"id": 138565033,
			"lng": -77.38627802,
			"lat": 37.5366092,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 8,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Washington",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/126652589",
			"id": 126652589,
			"lng": -77.38591169,
			"lat": 37.53648462,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1911,
			"dm": 11,
			"dd": 24,
			"by": 1878,
			"bd": "",
			"bm": 7,
			"nm": "B.",
			"nf": "Wellington",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/150786876",
			"id": 150786876,
			"lng": -77.38652317,
			"lat": 37.53545106,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 7,
			"dd": 30,
			"by": 1901,
			"bd": 9,
			"bm": 10,
			"nm": "",
			"nf": "Wilbur",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/185648652",
			"id": 185648652,
			"lng": -77.38752984,
			"lat": 37.53695236,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1906,
			"dm": 3,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "William",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/132641394",
			"id": 132641394,
			"lng": -77.3877434,
			"lat": 37.5365499,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 3,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "William",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/185392455",
			"id": 185392455,
			"lng": -77.38778322,
			"lat": 37.5365485,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 9,
			"dd": 14,
			"by": 1905,
			"bd": 4,
			"bm": 8,
			"nm": "Thomas",
			"nf": "William",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/142448424",
			"id": 142448424,
			"lng": -77.38570174,
			"lat": 37.5373611,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 12,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Willie",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/144143010",
			"id": 144143010,
			"lng": -77.38652648,
			"lat": 37.53760345,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 6,
			"dd": 8,
			"by": 1885,
			"bd": 4,
			"bm": 7,
			"nm": "Lee",
			"nf": "Willie",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/173844095",
			"id": 173844095,
			"lng": -77.387574,
			"lat": 37.5370745,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 9,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alexander",
			"nl": "Harrison",
			"url": "https://findagrave.com/memorial/148867291",
			"id": 148867291,
			"lng": -77.38798702,
			"lat": 37.53706332,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": "",
			"dd": "",
			"by": 1900,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Emmanuel",
			"nl": "Harrison",
			"url": "https://findagrave.com/memorial/173793283",
			"id": 173793283,
			"lng": -77.38712785,
			"lat": 37.53714945,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 11,
			"dd": 7,
			"by": 1915,
			"bd": 20,
			"bm": 6,
			"nm": "V.",
			"nf": "Rosetta",
			"nl": "Harrison",
			"url": "https://findagrave.com/memorial/159411378",
			"id": 159411378,
			"lng": -77.38636007,
			"lat": 37.53753367,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 10,
			"dd": 6,
			"by": 1899,
			"bd": 8,
			"bm": 5,
			"nm": "",
			"nf": "Annie",
			"nl": "Hartwell",
			"url": "https://findagrave.com/memorial/163950347",
			"id": 163950347,
			"lng": -77.38672009,
			"lat": 37.53688354,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 2,
			"dd": 27,
			"by": 1893,
			"bd": 13,
			"bm": 4,
			"nm": "",
			"nf": "Benjamin",
			"nl": "Hartwell",
			"url": "https://findagrave.com/memorial/161002450",
			"id": 161002450,
			"lng": -77.38712374,
			"lat": 37.53703231,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 6,
			"dd": 8,
			"by": 1862,
			"bd": "",
			"bm": 10,
			"nm": "",
			"nf": "Clem",
			"nl": "Harvey",
			"url": "https://findagrave.com/memorial/143825857",
			"id": 143825857,
			"lng": -77.38674956,
			"lat": 37.5366807,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 5,
			"dd": 14,
			"by": 1953,
			"bd": 8,
			"bm": 12,
			"nm": "Edward",
			"nf": "Eugene",
			"nl": "Harvey",
			"url": "https://findagrave.com/memorial/125518406",
			"id": 125518406,
			"lng": -77.38622053,
			"lat": 37.53683954,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 8,
			"dd": 9,
			"by": 1914,
			"bd": 16,
			"bm": 8,
			"nm": "Lee",
			"nf": "Harriet",
			"nl": "Harvey",
			"url": "https://findagrave.com/memorial/161180422",
			"id": 161180422,
			"lng": -77.38721268,
			"lat": 37.537165,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 1,
			"dd": 26,
			"by": 1888,
			"bd": 8,
			"bm": 6,
			"nm": "",
			"nf": "Henrietta",
			"nl": "Harvey",
			"url": "https://findagrave.com/memorial/168145998",
			"id": 168145998,
			"lng": -77.38628256,
			"lat": 37.53717486,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 5,
			"dd": 30,
			"by": 1904,
			"bd": 1,
			"bm": 2,
			"nm": "B.",
			"nf": "Julia",
			"nl": "Harvey",
			"url": "https://findagrave.com/memorial/149354950",
			"id": 149354950,
			"lng": -77.38618292,
			"lat": 37.53599257,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 5,
			"dd": 29,
			"by": 1911,
			"bd": 17,
			"bm": 11,
			"nm": "Elsie",
			"nf": "Mary",
			"nl": "Harvey",
			"url": "https://findagrave.com/memorial/147853159",
			"id": 147853159,
			"lng": -77.38630595,
			"lat": 37.53718002,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 1,
			"dd": 18,
			"by": 1889,
			"bd": 18,
			"bm": 2,
			"nm": "",
			"nf": "Mazy",
			"nl": "Harvey",
			"url": "https://findagrave.com/memorial/148285670",
			"id": 148285670,
			"lng": -77.38639029,
			"lat": 37.53725277,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 10,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Patience",
			"nl": "Harvey",
			"url": "https://findagrave.com/memorial/146013333",
			"id": 146013333,
			"lng": -77.38575189,
			"lat": 37.53669059,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 4,
			"dd": 28,
			"by": 1915,
			"bd": 12,
			"bm": 8,
			"nm": "Clara",
			"nf": "Lois",
			"nl": "Haskins",
			"url": "https://findagrave.com/memorial/156929749",
			"id": 156929749,
			"lng": -77.38643832,
			"lat": 37.53713288,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 3,
			"dd": 3,
			"by": 1893,
			"bd": 27,
			"bm": 9,
			"nm": "Lewis",
			"nf": "William",
			"nl": "Haskins",
			"url": "https://findagrave.com/memorial/156612117",
			"id": 156612117,
			"lng": -77.38643435,
			"lat": 37.53714313,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 3,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nannie",
			"nl": "Haskins",
			"url": "https://findagrave.com/memorial/192423394",
			"id": 192423394,
			"lng": -77.38744333,
			"lat": 37.53716019,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 6,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "Luther",
			"nl": "Hasty",
			"url": "https://findagrave.com/memorial/150981962",
			"id": 150981962,
			"lng": -77.38676685,
			"lat": 37.53552659,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 7,
			"dd": 22,
			"by": 1883,
			"bd": 4,
			"bm": 7,
			"nm": "Lenton",
			"nf": "Marcellus",
			"nl": "Hatcher",
			"url": "https://findagrave.com/memorial/177750771",
			"id": 177750771,
			"lng": -77.38774509,
			"lat": 37.53744773,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1909,
			"dm": 12,
			"dd": 29,
			"by": 1907,
			"bd": 13,
			"bm": 4,
			"nm": "Lee",
			"nf": "Rosa",
			"nl": "Hatcher",
			"url": "https://findagrave.com/memorial/125634266",
			"id": 125634266,
			"lng": -77.38681448,
			"lat": 37.53651884,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 4,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nebraska",
			"nl": "Hawkins",
			"url": "https://findagrave.com/memorial/175610407",
			"id": 175610407,
			"lng": -77.38771914,
			"lat": 37.53705192,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 11,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rebecca",
			"nl": "Hawthorne",
			"url": "https://findagrave.com/memorial/148285686",
			"id": 148285686,
			"lng": -77.38644453,
			"lat": 37.53723847,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 1,
			"dd": 7,
			"by": 1854,
			"bd": "",
			"bm": 5,
			"nm": "",
			"nf": "Arthur",
			"nl": "Hayes",
			"url": "https://findagrave.com/memorial/150035721",
			"id": 150035721,
			"lng": -77.38624285,
			"lat": 37.5355506,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 7,
			"dd": 4,
			"by": 1882,
			"bd": 23,
			"bm": 5,
			"nm": "",
			"nf": "Edward",
			"nl": "Hayes",
			"url": "https://findagrave.com/memorial/135631960",
			"id": 135631960,
			"lng": -77.38568813,
			"lat": 37.53686863,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 3,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Henrietta",
			"nl": "Hayes",
			"url": "https://findagrave.com/memorial/188466151",
			"id": 188466151,
			"lng": -77.38774748,
			"lat": 37.53685774,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 11,
			"dd": 11,
			"by": 1892,
			"bd": 20,
			"bm": 1,
			"nm": "",
			"nf": "Laura",
			"nl": "Hayes",
			"url": "https://findagrave.com/memorial/135631969",
			"id": 135631969,
			"lng": -77.38568601,
			"lat": 37.53687674,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 8,
			"dd": 11,
			"by": 1884,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alfred",
			"nl": "Haywood",
			"url": "https://findagrave.com/memorial/159760652",
			"id": 159760652,
			"lng": -77.38641064,
			"lat": 37.53751482,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 11,
			"dd": 20,
			"by": 1911,
			"bd": 3,
			"bm": 1,
			"nm": "",
			"nf": "Ollie",
			"nl": "Hazell",
			"url": "https://findagrave.com/memorial/133448296",
			"id": 133448296,
			"lng": -77.38625594,
			"lat": 37.53695657,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 4,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Albert",
			"nf": "Prince",
			"nl": "Heath",
			"url": "https://findagrave.com/memorial/175822882",
			"id": 175822882,
			"lng": -77.38640712,
			"lat": 37.53673483,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 8,
			"dd": 23,
			"by": 1905,
			"bd": 11,
			"bm": 12,
			"nm": "E.",
			"nf": "Bernice",
			"nl": "Hedgeman",
			"url": "https://findagrave.com/memorial/148460413",
			"id": 148460413,
			"lng": -77.38627929,
			"lat": 37.53544882,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 7,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Blanch",
			"nf": "Lavinia",
			"nl": "Hedgeman",
			"url": "https://findagrave.com/memorial/182568993",
			"id": 182568993,
			"lng": -77.38627051,
			"lat": 37.53545649,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 5,
			"dd": 8,
			"by": 1882,
			"bd": 14,
			"bm": 5,
			"nm": "Tony",
			"nf": "Alice",
			"nl": "Henderson",
			"url": "https://findagrave.com/memorial/190229668",
			"id": 190229668,
			"lng": -77.38763725,
			"lat": 37.53723038,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 9,
			"dd": 30,
			"by": 1967,
			"bd": 24,
			"bm": 8,
			"nm": "",
			"nf": "Brenda",
			"nl": "Henderson",
			"url": "https://findagrave.com/memorial/142797041",
			"id": 142797041,
			"lng": -77.38604917,
			"lat": 37.53747636,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 7,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Cora",
			"nl": "Henderson",
			"url": "https://findagrave.com/memorial/180521726",
			"id": 180521726,
			"lng": -77.38800119,
			"lat": 37.53762931,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 12,
			"dd": 19,
			"by": 1866,
			"bd": 25,
			"bm": 11,
			"nm": "H.",
			"nf": "John",
			"nl": "Henderson",
			"url": "https://findagrave.com/memorial/188064738",
			"id": 188064738,
			"lng": -77.38664469,
			"lat": 37.53558155,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 4,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "T.",
			"nf": "John",
			"nl": "Henderson",
			"url": "https://findagrave.com/memorial/137430045",
			"id": 137430045,
			"lng": -77.38593901,
			"lat": 37.53712367,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 6,
			"dd": 12,
			"by": 1893,
			"bd": 14,
			"bm": 2,
			"nm": "B.",
			"nf": "Joseph",
			"nl": "Henderson",
			"url": "https://findagrave.com/memorial/140290798",
			"id": 140290798,
			"lng": -77.38594257,
			"lat": 37.5366611,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 8,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Joseph",
			"nl": "Henderson",
			"url": "https://findagrave.com/memorial/166235133",
			"id": 166235133,
			"lng": -77.38590802,
			"lat": 37.53665162,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 5,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Lizzie",
			"nl": "Henderson",
			"url": "https://findagrave.com/memorial/137430052",
			"id": 137430052,
			"lng": -77.3859452,
			"lat": 37.53711279,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 1,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Louvinia",
			"nl": "Henderson",
			"url": "https://findagrave.com/memorial/154201278",
			"id": 154201278,
			"lng": -77.3862421,
			"lat": 37.53537812,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 5,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "T.",
			"nf": "Samuel",
			"nl": "Henderson",
			"url": "https://findagrave.com/memorial/139146891",
			"id": 139146891,
			"lng": -77.38614576,
			"lat": 37.53658091,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 12,
			"dd": 25,
			"by": 1895,
			"bd": "",
			"bm": 4,
			"nm": "B.",
			"nf": "Walter",
			"nl": "Henderson",
			"url": "https://findagrave.com/memorial/158679743",
			"id": 158679743,
			"lng": -77.38680328,
			"lat": 37.53742031,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 1,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Charles",
			"nl": "Henley",
			"url": "https://findagrave.com/memorial/171956202",
			"id": 171956202,
			"lng": -77.38726844,
			"lat": 37.53672451,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 4,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Charlotte",
			"nl": "Henry",
			"url": "https://findagrave.com/memorial/132641398",
			"id": 132641398,
			"lng": -77.38782431,
			"lat": 37.53640815,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 11,
			"dd": 28,
			"by": 1968,
			"bd": 9,
			"bm": 11,
			"nm": "Linwood",
			"nf": "Frederick",
			"nl": "Henry",
			"url": "https://findagrave.com/memorial/159663324",
			"id": 159663324,
			"lng": -77.38590643,
			"lat": 37.53741151,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 1,
			"dd": 28,
			"by": 1868,
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "James",
			"nl": "Henry",
			"url": "https://findagrave.com/memorial/173461773",
			"id": 173461773,
			"lng": -77.38727156,
			"lat": 37.53712213,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 5,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Maria",
			"nl": "Henry",
			"url": "https://findagrave.com/memorial/143201785",
			"id": 143201785,
			"lng": -77.38599251,
			"lat": 37.5373227,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 3,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "William",
			"nl": "Henry",
			"url": "https://findagrave.com/memorial/158922804",
			"id": 158922804,
			"lng": -77.3874965,
			"lat": 37.53759741,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 2,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nathaniel",
			"nl": "Henson",
			"url": "https://findagrave.com/memorial/141193915",
			"id": 141193915,
			"lng": -77.38627933,
			"lat": 37.53664764,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 10,
			"dd": 27,
			"by": 1944,
			"bd": 14,
			"bm": 1,
			"nm": "J.",
			"nf": "Bertha",
			"nl": "Herring",
			"url": "https://findagrave.com/memorial/136171644",
			"id": 136171644,
			"lng": -77.38575815,
			"lat": 37.53730781,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1912,
			"dm": 9,
			"dd": 19,
			"by": 1889,
			"bd": 6,
			"bm": 8,
			"nm": "I",
			"nf": "Alice",
			"nl": "Hewin",
			"url": "https://findagrave.com/memorial/149168053",
			"id": 149168053,
			"lng": -77.38643254,
			"lat": 37.53540601,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 5,
			"dd": 2,
			"by": 1867,
			"bd": "",
			"bm": 7,
			"nm": "R.",
			"nf": "Alice",
			"nl": "Hewin",
			"url": "https://findagrave.com/memorial/143058146",
			"id": 143058146,
			"lng": -77.38644615,
			"lat": 37.53539339,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1911,
			"dm": 1,
			"dd": 14,
			"by": 1887,
			"bd": 31,
			"bm": 8,
			"nm": "T.",
			"nf": "Beverly",
			"nl": "Hewin",
			"url": "https://findagrave.com/memorial/149168058",
			"id": 149168058,
			"lng": -77.38641785,
			"lat": 37.53539213,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 2,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Beverly",
			"nl": "Hewlett",
			"url": "https://findagrave.com/memorial/144143013",
			"id": 144143013,
			"lng": -77.38591285,
			"lat": 37.53741989,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 4,
			"dd": 27,
			"by": 1923,
			"bd": 28,
			"bm": 7,
			"nm": "L.",
			"nf": "Dorothy",
			"nl": "Hewlett",
			"url": "https://findagrave.com/memorial/135631975",
			"id": 135631975,
			"lng": -77.38610239,
			"lat": 37.5370548,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 3,
			"dd": 14,
			"by": 1870,
			"bd": 24,
			"bm": 11,
			"nm": "",
			"nf": "Kate",
			"nl": "Hewlett",
			"url": "https://findagrave.com/memorial/134474418",
			"id": 134474418,
			"lng": -77.3874955,
			"lat": 37.53655766,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 7,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Ann",
			"nf": "Lucy",
			"nl": "Hewlett",
			"url": "https://findagrave.com/memorial/158450780",
			"id": 158450780,
			"lng": -77.38777221,
			"lat": 37.53724188,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 12,
			"dd": 11,
			"by": 1888,
			"bd": 11,
			"bm": 9,
			"nm": "E.",
			"nf": "Martha",
			"nl": "Hewlett",
			"url": "https://findagrave.com/memorial/166222833",
			"id": 166222833,
			"lng": -77.38709476,
			"lat": 37.53661986,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 6,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Richard",
			"nl": "Hewlett",
			"url": "https://findagrave.com/memorial/185392463",
			"id": 185392463,
			"lng": -77.38750111,
			"lat": 37.53658214,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 11,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "William",
			"nl": "Hewlett",
			"url": "https://findagrave.com/memorial/158450775",
			"id": 158450775,
			"lng": -77.38776533,
			"lat": 37.53723009,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 4,
			"dd": 13,
			"by": 1898,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bill",
			"nl": "Hicks",
			"url": "https://findagrave.com/memorial/169823402",
			"id": 169823402,
			"lng": -77.38678407,
			"lat": 37.53711507,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 5,
			"dd": 2,
			"by": 1894,
			"bd": 4,
			"bm": 2,
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Hicks",
			"url": "https://findagrave.com/memorial/127460986",
			"id": 127460986,
			"lng": -77.3859807,
			"lat": 37.53735009,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 6,
			"dd": 5,
			"by": 1891,
			"bd": 25,
			"bm": 5,
			"nm": "",
			"nf": "Ella",
			"nl": "Hicks",
			"url": "https://findagrave.com/memorial/155322619",
			"id": 155322619,
			"lng": -77.38712156,
			"lat": 37.5371787,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 4,
			"dd": 7,
			"by": 1891,
			"bd": 4,
			"bm": 9,
			"nm": "Lee",
			"nf": "Matthew",
			"nl": "Hicks",
			"url": "https://findagrave.com/memorial/155318977",
			"id": 155318977,
			"lng": -77.38711631,
			"lat": 37.53718776,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 3,
			"dd": 9,
			"by": 1907,
			"bd": 15,
			"bm": 9,
			"nm": "",
			"nf": "Pearl",
			"nl": "Hicks",
			"url": "https://findagrave.com/memorial/147853170",
			"id": 147853170,
			"lng": -77.38601076,
			"lat": 37.53633199,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 1,
			"dd": 15,
			"by": 1893,
			"bd": 14,
			"bm": 5,
			"nm": "J.",
			"nf": "Sarah",
			"nl": "Hicks",
			"url": "https://findagrave.com/memorial/191380199",
			"id": 191380199,
			"lng": -77.38772911,
			"lat": 37.53794134,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 8,
			"dd": 28,
			"by": 1897,
			"bd": 18,
			"bm": 1,
			"nm": "C.",
			"nf": "Spencer",
			"nl": "Hicks",
			"url": "https://findagrave.com/memorial/125634282",
			"id": 125634282,
			"lng": -77.38732818,
			"lat": 37.53743799,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 11,
			"dd": 19,
			"by": 1910,
			"bd": 15,
			"bm": 6,
			"nm": "",
			"nf": "Bertha",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/150493634",
			"id": 150493634,
			"lng": -77.38599442,
			"lat": 37.53632761,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 8,
			"dd": 29,
			"by": "",
			"bd": 20,
			"bm": 10,
			"nm": "Lee",
			"nf": "Fitzhugh",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/166397290",
			"id": 166397290,
			"lng": -77.38746525,
			"lat": 37.53670178,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1980,
			"dm": 4,
			"dd": 4,
			"by": 1919,
			"bd": 6,
			"bm": 7,
			"nm": "Cora",
			"nf": "Flocelia",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/158942474",
			"id": 158942474,
			"lng": -77.38746494,
			"lat": 37.53759441,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 4,
			"dd": 3,
			"by": 1915,
			"bd": 16,
			"bm": 10,
			"nm": "O. R.",
			"nf": "Gertrude",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/161563073",
			"id": 161563073,
			"lng": -77.38676434,
			"lat": 37.53743176,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 8,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jacob",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/177119120",
			"id": 177119120,
			"lng": -77.38797776,
			"lat": 37.53711543,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 9,
			"dd": 30,
			"by": 1891,
			"bd": 11,
			"bm": 11,
			"nm": "R.",
			"nf": "John",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/146013338",
			"id": 146013338,
			"lng": -77.38656047,
			"lat": 37.53641271,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 5,
			"dd": 27,
			"by": 1916,
			"bd": 22,
			"bm": 5,
			"nm": "Irvin",
			"nf": "Joseph",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/158922809",
			"id": 158922809,
			"lng": -77.38746986,
			"lat": 37.53757805,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 11,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Junius",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/173166606",
			"id": 173166606,
			"lng": -77.38759098,
			"lat": 37.5372678,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 8,
			"dd": 5,
			"by": 1908,
			"bd": 3,
			"bm": 5,
			"nm": "",
			"nf": "Leonetta",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/167254347",
			"id": 167254347,
			"lng": -77.3868126,
			"lat": 37.53712917,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 8,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucy",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/172076699",
			"id": 172076699,
			"lng": -77.38695152,
			"lat": 37.53716568,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 9,
			"dd": 9,
			"by": 1875,
			"bd": 3,
			"bm": 1,
			"nm": "",
			"nf": "Margaret",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/167272740",
			"id": 167272740,
			"lng": -77.38655871,
			"lat": 37.53741484,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 5,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Frances",
			"nf": "Mary",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/166398563",
			"id": 166398563,
			"lng": -77.38750886,
			"lat": 37.53668707,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 8,
			"dd": 6,
			"by": 1909,
			"bd": 16,
			"bm": 1,
			"nm": "Sue",
			"nf": "Mary",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/125094175",
			"id": 125094175,
			"lng": -77.38604879,
			"lat": 37.53663245,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 3,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Millie",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/144558531",
			"id": 144558531,
			"lng": -77.38656887,
			"lat": 37.53570212,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 2,
			"dd": 5,
			"by": 1884,
			"bd": 17,
			"bm": 10,
			"nm": "",
			"nf": "Moses",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/175449631",
			"id": 175449631,
			"lng": -77.38747637,
			"lat": 37.53729882,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1903,
			"dm": 8,
			"dd": 2,
			"by": 1840,
			"bd": 3,
			"bm": 9,
			"nm": "",
			"nf": "Nathaniel",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/166396445",
			"id": 166396445,
			"lng": -77.38748104,
			"lat": 37.53671186,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 12,
			"dd": 8,
			"by": 1946,
			"bd": 12,
			"bm": 11,
			"nm": "Leonard",
			"nf": "Reginald",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/158679638",
			"id": 158679638,
			"lng": -77.3868374,
			"lat": 37.53745111,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 8,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Robert",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/173209743",
			"id": 173209743,
			"lng": -77.38744429,
			"lat": 37.536811,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 7,
			"dd": 1,
			"by": 1906,
			"bd": 12,
			"bm": 1,
			"nm": "Edward Roosevelt",
			"nf": "Robert",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/167074274",
			"id": 167074274,
			"lng": -77.38682595,
			"lat": 37.53712081,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 1,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sallie",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/176134064",
			"id": 176134064,
			"lng": -77.38767146,
			"lat": 37.53716223,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 6,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Anderson",
			"nf": "William",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/161636481",
			"id": 161636481,
			"lng": -77.3868656,
			"lat": 37.5375069,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 2,
			"dd": 11,
			"by": 1871,
			"bd": 15,
			"bm": 11,
			"nm": "",
			"nf": "Willianna",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/169822163",
			"id": 169822163,
			"lng": -77.38677835,
			"lat": 37.53710612,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 8,
			"dd": 15,
			"by": 1880,
			"bd": 27,
			"bm": 5,
			"nm": "",
			"nf": "Lucy",
			"nl": "Hilliard",
			"url": "https://findagrave.com/memorial/191436619",
			"id": 191436619,
			"lng": -77.38659754,
			"lat": 37.53717622,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 7,
			"dd": 10,
			"by": 1928,
			"bd": 13,
			"bm": 9,
			"nm": "Lee",
			"nf": "Sarah",
			"nl": "Hilliard",
			"url": "https://findagrave.com/memorial/173076610",
			"id": 173076610,
			"lng": -77.38704997,
			"lat": 37.5373478,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 1,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jesse",
			"nl": "Hilton",
			"url": "https://findagrave.com/memorial/159880557",
			"id": 159880557,
			"lng": -77.38792285,
			"lat": 37.53696925,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 6,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Minnie",
			"nl": "Hilton",
			"url": "https://findagrave.com/memorial/138565040",
			"id": 138565040,
			"lng": -77.3861755,
			"lat": 37.53662794,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 3,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Susie",
			"nl": "Hilton",
			"url": "https://findagrave.com/memorial/177152407",
			"id": 177152407,
			"lng": -77.3879283,
			"lat": 37.53702248,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 3,
			"dd": 6,
			"by": 1884,
			"bd": 28,
			"bm": 12,
			"nm": "",
			"nf": "Effie",
			"nl": "Hinton",
			"url": "https://findagrave.com/memorial/176570454",
			"id": 176570454,
			"lng": -77.38700192,
			"lat": 37.53748535,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 1,
			"dd": 29,
			"by": 1914,
			"bd": 24,
			"bm": 7,
			"nm": "E.",
			"nf": "Mary",
			"nl": "Hinton",
			"url": "https://findagrave.com/memorial/158922811",
			"id": 158922811,
			"lng": -77.38747089,
			"lat": 37.5375732,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 1,
			"dd": 25,
			"by": 1908,
			"bd": 26,
			"bm": 12,
			"nm": "Alexander",
			"nf": "Walter",
			"nl": "Hinton",
			"url": "https://findagrave.com/memorial/192390609",
			"id": 192390609,
			"lng": -77.38766199,
			"lat": 37.53745513,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 5,
			"dd": 5,
			"by": 1910,
			"bd": 19,
			"bm": 8,
			"nm": "",
			"nf": "Manson",
			"nl": "Hobbs",
			"url": "https://findagrave.com/memorial/144820792",
			"id": 144820792,
			"lng": -77.38556112,
			"lat": 37.53728475,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 3,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Barlow",
			"nl": "Hobson",
			"url": "https://findagrave.com/memorial/182349905",
			"id": 182349905,
			"lng": -77.38639418,
			"lat": 37.53562286,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 6,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "John",
			"nl": "Hobson",
			"url": "https://findagrave.com/memorial/150037864",
			"id": 150037864,
			"lng": -77.38739578,
			"lat": 37.53667106,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 3,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Mary",
			"nl": "Hodge",
			"url": "https://findagrave.com/memorial/182546686",
			"id": 182546686,
			"lng": -77.38754205,
			"lat": 37.53668961,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 4,
			"dd": 13,
			"by": 1910,
			"bd": 13,
			"bm": 1,
			"nm": "David",
			"nf": "Abraham",
			"nl": "Hodges",
			"url": "https://findagrave.com/memorial/159411394",
			"id": 159411394,
			"lng": -77.38632807,
			"lat": 37.53674133,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 9,
			"dd": 3,
			"by": 1900,
			"bd": 17,
			"bm": 7,
			"nm": "",
			"nf": "John",
			"nl": "Hodges",
			"url": "https://findagrave.com/memorial/169397273",
			"id": 169397273,
			"lng": -77.38652051,
			"lat": 37.53681318,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 2,
			"dd": 19,
			"by": 1909,
			"bd": 10,
			"bm": 10,
			"nm": "",
			"nf": "Martha",
			"nl": "Hodges",
			"url": "https://findagrave.com/memorial/161171380",
			"id": 161171380,
			"lng": -77.38653443,
			"lat": 37.53703351,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 2,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Emma",
			"nl": "Holland",
			"url": "https://findagrave.com/memorial/176059055",
			"id": 176059055,
			"lng": -77.38746454,
			"lat": 37.53699037,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 12,
			"dd": 28,
			"by": 1967,
			"bd": 16,
			"bm": 10,
			"nm": "",
			"nf": "Yolana",
			"nl": "Holland",
			"url": "https://findagrave.com/memorial/152794725",
			"id": 152794725,
			"lng": -77.38595043,
			"lat": 37.53746544,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 3,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "baby boy",
			"nl": "Holliday",
			"url": "https://findagrave.com/memorial/142448446",
			"id": 142448446,
			"lng": -77.38729632,
			"lat": 37.5379062,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 7,
			"dd": 1,
			"by": 1907,
			"bd": 23,
			"bm": 6,
			"nm": "C.",
			"nf": "Myrteen",
			"nl": "Holliday",
			"url": "https://findagrave.com/memorial/137430067",
			"id": 137430067,
			"lng": -77.3859538,
			"lat": 37.53711962,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 8,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Charles",
			"nl": "Holloway",
			"url": "https://findagrave.com/memorial/125312945",
			"id": 125312945,
			"lng": -77.38592822,
			"lat": 37.53689718,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 1,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Georgiana",
			"nl": "Holloway",
			"url": "https://findagrave.com/memorial/125312961",
			"id": 125312961,
			"lng": -77.38592628,
			"lat": 37.5369043,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 2,
			"dd": 11,
			"by": 1903,
			"bd": 7,
			"bm": 1,
			"nm": "M.",
			"nf": "Strawdia",
			"nl": "Holman",
			"url": "https://findagrave.com/memorial/161171406",
			"id": 161171406,
			"lng": -77.38726638,
			"lat": 37.53710037,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1895,
			"dm": 7,
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "E.",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/128012860",
			"id": 128012860,
			"lng": -77.38621138,
			"lat": 37.53635668,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": "",
			"dd": "",
			"by": 1877,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Emmett",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/143632575",
			"id": 143632575,
			"lng": -77.38601901,
			"lat": 37.53599552,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 3,
			"dd": 21,
			"by": 1913,
			"bd": 11,
			"bm": 1,
			"nm": "Emily",
			"nf": "Helen",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/174622142",
			"id": 174622142,
			"lng": -77.38689024,
			"lat": 37.53645466,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 8,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "T.",
			"nf": "Henry",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/178249242",
			"id": 178249242,
			"lng": -77.38682678,
			"lat": 37.53541817,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 11,
			"dd": 18,
			"by": 1910,
			"bd": 28,
			"bm": 10,
			"nm": "Edward",
			"nf": "James",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/130968028",
			"id": 130968028,
			"lng": -77.38567934,
			"lat": 37.53718703,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 12,
			"dd": 13,
			"by": 1881,
			"bd": 14,
			"bm": 4,
			"nm": "",
			"nf": "John",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/166568172",
			"id": 166568172,
			"lng": -77.38803454,
			"lat": 37.53766479,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 9,
			"dd": 15,
			"by": 1889,
			"bd": 14,
			"bm": 10,
			"nm": "C.",
			"nf": "Junius",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/144370332",
			"id": 144370332,
			"lng": -77.38749788,
			"lat": 37.53778075,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 11,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Mamie",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/155782740",
			"id": 155782740,
			"lng": -77.38723485,
			"lat": 37.53560015,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 9,
			"dd": 12,
			"by": 1904,
			"bd": 20,
			"bm": 7,
			"nm": "Louisa",
			"nf": "Marie",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/127719224",
			"id": 127719224,
			"lng": -77.38783647,
			"lat": 37.53639148,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 10,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "Myrtle",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/128012889",
			"id": 128012889,
			"lng": -77.38621187,
			"lat": 37.53635672,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 7,
			"dd": 9,
			"by": 1884,
			"bd": 12,
			"bm": 2,
			"nm": "Henry",
			"nf": "Owen",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/147323477",
			"id": 147323477,
			"lng": -77.38757033,
			"lat": 37.53745137,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 7,
			"dd": 10,
			"by": 1862,
			"bd": "",
			"bm": 5,
			"nm": "Henry",
			"nf": "Patrick",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/127994553",
			"id": 127994553,
			"lng": -77.38621211,
			"lat": 37.53635674,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 12,
			"dd": 9,
			"by": 1872,
			"bd": 24,
			"bm": 8,
			"nm": "",
			"nf": "Rosa",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/130692450",
			"id": 130692450,
			"lng": -77.3856758,
			"lat": 37.53719387,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 6,
			"dd": 16,
			"by": 1869,
			"bd": 7,
			"bm": 3,
			"nm": "Cooper",
			"nf": "Sallie",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/128012920",
			"id": 128012920,
			"lng": -77.38621351,
			"lat": 37.53635678,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1906,
			"dm": 9,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sarah",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/128012874",
			"id": 128012874,
			"lng": -77.38621162,
			"lat": 37.5363567,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": "",
			"dd": "",
			"by": 1852,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Susan",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/143632569",
			"id": 143632569,
			"lng": -77.38601702,
			"lat": 37.53599505,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 6,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "William",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/161052876",
			"id": 161052876,
			"lng": -77.38706227,
			"lat": 37.53702389,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 5,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "William",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/130692467",
			"id": 130692467,
			"lng": -77.38568203,
			"lat": 37.53717822,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 10,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Willie",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/155123310",
			"id": 155123310,
			"lng": -77.38656332,
			"lat": 37.5371962,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 4,
			"dd": 8,
			"by": 1913,
			"bd": 17,
			"bm": 9,
			"nm": "",
			"nf": "Wydell",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/151312617",
			"id": 151312617,
			"lng": -77.38697211,
			"lat": 37.53738332,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 7,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Essex",
			"nl": "Holtz",
			"url": "https://findagrave.com/memorial/136304889",
			"id": 136304889,
			"lng": -77.38635807,
			"lat": 37.53634641,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 7,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Lucy",
			"nl": "Holtz",
			"url": "https://findagrave.com/memorial/136304911",
			"id": 136304911,
			"lng": -77.3863596,
			"lat": 37.53634574,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 8,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Holtz",
			"url": "https://findagrave.com/memorial/136304899",
			"id": 136304899,
			"lng": -77.38635792,
			"lat": 37.5363475,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 11,
			"dd": 8,
			"by": 1863,
			"bd": 8,
			"bm": 4,
			"nm": "",
			"nf": "Sylvia",
			"nl": "Hood",
			"url": "https://findagrave.com/memorial/153100504",
			"id": 153100504,
			"lng": -77.38672849,
			"lat": 37.53546415,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 1,
			"dd": 13,
			"by": 1869,
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "Albert",
			"nl": "Hooper",
			"url": "https://findagrave.com/memorial/155515682",
			"id": 155515682,
			"lng": -77.3862961,
			"lat": 37.53600439,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 9,
			"dd": 13,
			"by": 1872,
			"bd": 12,
			"bm": 11,
			"nm": "H.",
			"nf": "Charles",
			"nl": "Hooper",
			"url": "https://findagrave.com/memorial/179090999",
			"id": 179090999,
			"lng": -77.38596964,
			"lat": 37.53644028,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 8,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Mary",
			"nl": "Hooper",
			"url": "https://findagrave.com/memorial/155515691",
			"id": 155515691,
			"lng": -77.38626369,
			"lat": 37.53600364,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Edward",
			"nl": "Hopkins",
			"url": "https://findagrave.com/memorial/187354314",
			"id": 187354314,
			"lng": -77.38741625,
			"lat": 37.53736473,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 5,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "G.",
			"nf": "Henry",
			"nl": "Hopkins",
			"url": "https://findagrave.com/memorial/146682158",
			"id": 146682158,
			"lng": -77.38616906,
			"lat": 37.535762,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 1,
			"dd": 18,
			"by": 1899,
			"bd": "",
			"bm": 9,
			"nm": "",
			"nf": "Landon",
			"nl": "Hopkins",
			"url": "https://findagrave.com/memorial/177545577",
			"id": 177545577,
			"lng": -77.38705582,
			"lat": 37.53776419,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 4,
			"dd": 12,
			"by": 1964,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Matthew",
			"nl": "Hopkins",
			"url": "https://findagrave.com/memorial/191417550",
			"id": 191417550,
			"lng": -77.38620583,
			"lat": 37.53749144,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 4,
			"dd": 22,
			"by": 1898,
			"bd": 15,
			"bm": 2,
			"nm": "",
			"nf": "Nolia",
			"nl": "Hopkins",
			"url": "#REF!",
			"id": 162203614,
			"lng": -77.38784183,
			"lat": 37.53699016,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 1,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Willie",
			"nl": "Hopkins",
			"url": "https://findagrave.com/memorial/125518422",
			"id": 125518422,
			"lng": -77.38646684,
			"lat": 37.53638947,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 4,
			"dd": 11,
			"by": 1899,
			"bd": 20,
			"bm": 3,
			"nm": "Louise",
			"nf": "Marian",
			"nl": "Hopper",
			"url": "https://findagrave.com/memorial/145838355",
			"id": 145838355,
			"lng": -77.38663404,
			"lat": 37.53578513,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 9,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "William",
			"nl": "Hopper",
			"url": "https://findagrave.com/memorial/146339080",
			"id": 146339080,
			"lng": -77.38663255,
			"lat": 37.53579442,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 6,
			"dd": 15,
			"by": 1920,
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Ralph",
			"nl": "House",
			"url": "https://findagrave.com/memorial/127995644",
			"id": 127995644,
			"lng": -77.38621278,
			"lat": 37.53635676,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 5,
			"dd": 7,
			"by": 1894,
			"bd": "",
			"bm": 6,
			"nm": "B.",
			"nf": "Verna",
			"nl": "House",
			"url": "https://findagrave.com/memorial/127995635",
			"id": 127995635,
			"lng": -77.38621325,
			"lat": 37.53635677,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 2,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ellen",
			"nl": "Houston",
			"url": "https://findagrave.com/memorial/176765627",
			"id": 176765627,
			"lng": -77.3877127,
			"lat": 37.53716578,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1909,
			"dm": 8,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "George",
			"nl": "Howard",
			"url": "https://findagrave.com/memorial/182626171",
			"id": 182626171,
			"lng": -77.38637506,
			"lat": 37.53574438,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 9,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "George",
			"nl": "Howard",
			"url": "https://findagrave.com/memorial/148518230",
			"id": 148518230,
			"lng": -77.38688342,
			"lat": 37.53542788,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 5,
			"dd": 11,
			"by": 1882,
			"bd": 24,
			"bm": 10,
			"nm": "",
			"nf": "Georgia",
			"nl": "Howard",
			"url": "https://findagrave.com/memorial/187354318",
			"id": 187354318,
			"lng": -77.38687068,
			"lat": 37.53747975,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 1,
			"dd": 24,
			"by": 1883,
			"bd": 2,
			"bm": 11,
			"nm": "Winston",
			"nf": "Isaiah",
			"nl": "Howard",
			"url": "https://findagrave.com/memorial/135631980",
			"id": 135631980,
			"lng": -77.3860861,
			"lat": 37.53704428,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 8,
			"dd": 6,
			"by": 1864,
			"bd": 9,
			"bm": 5,
			"nm": "Elizabeth",
			"nf": "Pollie",
			"nl": "Howard",
			"url": "https://findagrave.com/memorial/143201852",
			"id": 143201852,
			"lng": -77.38640533,
			"lat": 37.53574039,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 12,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Silas",
			"nl": "Howard",
			"url": "https://findagrave.com/memorial/141194062",
			"id": 141194062,
			"lng": -77.38646028,
			"lat": 37.53660554,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 9,
			"dd": 17,
			"by": 1897,
			"bd": 6,
			"bm": 3,
			"nm": "",
			"nf": "Florence",
			"nl": "Howerton",
			"url": "https://findagrave.com/memorial/151108196",
			"id": 151108196,
			"lng": -77.38666108,
			"lat": 37.53549949,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 7,
			"dd": 20,
			"by": 1904,
			"bd": 2,
			"bm": 6,
			"nm": "Clarence",
			"nf": "Frederick",
			"nl": "Howerton",
			"url": "https://findagrave.com/memorial/152005269",
			"id": 152005269,
			"lng": -77.3858049,
			"lat": 37.53716664,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 5,
			"dd": 3,
			"by": 1901,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Willie",
			"nl": "Howerton",
			"url": "https://findagrave.com/memorial/142797047",
			"id": 142797047,
			"lng": -77.38605546,
			"lat": 37.53735116,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 12,
			"dd": 1,
			"by": 1913,
			"bd": 29,
			"bm": 7,
			"nm": "",
			"nf": "Clarence",
			"nl": "Hubbard",
			"url": "https://findagrave.com/memorial/151265651",
			"id": 151265651,
			"lng": -77.38752924,
			"lat": 37.5378006,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 10,
			"dd": 28,
			"by": 1909,
			"bd": 26,
			"bm": 5,
			"nm": "",
			"nf": "James",
			"nl": "Hubbard",
			"url": "https://findagrave.com/memorial/150677868",
			"id": 150677868,
			"lng": -77.38644742,
			"lat": 37.53533267,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 3,
			"dd": 29,
			"by": 1905,
			"bd": 25,
			"bm": 12,
			"nm": "",
			"nf": "Julia",
			"nl": "Hubbard",
			"url": "https://findagrave.com/memorial/158922813",
			"id": 158922813,
			"lng": -77.38777767,
			"lat": 37.53769322,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 12,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lindell",
			"nl": "Hubbard",
			"url": "https://findagrave.com/memorial/145638802",
			"id": 145638802,
			"lng": -77.38595744,
			"lat": 37.53745151,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 3,
			"dd": 4,
			"by": 1886,
			"bd": 9,
			"bm": 1,
			"nm": "",
			"nf": "Minnie",
			"nl": "Hubbard",
			"url": "https://findagrave.com/memorial/167182288",
			"id": 167182288,
			"lng": -77.38673943,
			"lat": 37.53678615,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 10,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Phillip",
			"nl": "Hubbard",
			"url": "https://findagrave.com/memorial/184319387",
			"id": 184319387,
			"lng": -77.38717894,
			"lat": 37.5376287,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 12,
			"dd": 9,
			"by": 1882,
			"bd": "",
			"bm": "",
			"nm": "Christian",
			"nf": "Virginia",
			"nl": "Hubbard",
			"url": "https://findagrave.com/memorial/171145798",
			"id": 171145798,
			"lng": -77.38704899,
			"lat": 37.53758848,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 5,
			"dd": 7,
			"by": 1908,
			"bd": 2,
			"bm": 6,
			"nm": "Henry",
			"nf": "James",
			"nl": "Hudson",
			"url": "https://findagrave.com/memorial/155769342",
			"id": 155769342,
			"lng": -77.3872562,
			"lat": 37.53551727,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 3,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Henry",
			"nf": "John",
			"nl": "Hudson",
			"url": "https://findagrave.com/memorial/166116750",
			"id": 166116750,
			"lng": -77.38703309,
			"lat": 37.53677233,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 12,
			"dd": 20,
			"by": 1897,
			"bd": 2,
			"bm": 2,
			"nm": "McKinley",
			"nf": "Mack",
			"nl": "Hudson",
			"url": "https://findagrave.com/memorial/125518489",
			"id": 125518489,
			"lng": -77.38563305,
			"lat": 37.53728916,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 6,
			"dd": 6,
			"by": 1869,
			"bd": "",
			"bm": 6,
			"nm": "E.",
			"nf": "Mary",
			"nl": "Hudson",
			"url": "https://findagrave.com/memorial/151108209",
			"id": 151108209,
			"lng": -77.38656674,
			"lat": 37.53543448,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 7,
			"dd": 7,
			"by": 1914,
			"bd": 3,
			"bm": 8,
			"nm": "",
			"nf": "Sandy",
			"nl": "Hudson",
			"url": "https://findagrave.com/memorial/125820817",
			"id": 125820817,
			"lng": -77.38601719,
			"lat": 37.5374114,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 4,
			"dd": 19,
			"by": 1937,
			"bd": 1,
			"bm": 7,
			"nm": "May",
			"nf": "Trula",
			"nl": "Hudson",
			"url": "https://findagrave.com/memorial/138366545",
			"id": 138366545,
			"lng": -77.38679026,
			"lat": 37.53702428,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 8,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "Walter",
			"nl": "Hudson",
			"url": "https://findagrave.com/memorial/151108216",
			"id": 151108216,
			"lng": -77.38656671,
			"lat": 37.53542479,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 11,
			"dd": 30,
			"by": 1875,
			"bd": 11,
			"bm": 5,
			"nm": "Henry",
			"nf": "James",
			"nl": "Huggins",
			"url": "https://findagrave.com/memorial/157164962",
			"id": 157164962,
			"lng": -77.38648783,
			"lat": 37.53583372,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 4,
			"dd": 19,
			"by": 1882,
			"bd": 22,
			"bm": 2,
			"nm": "B.",
			"nf": "Laura",
			"nl": "Huggins",
			"url": "https://findagrave.com/memorial/157964800",
			"id": 157964800,
			"lng": -77.38632842,
			"lat": 37.53581014,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 5,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Charles",
			"nl": "Hunt",
			"url": "https://findagrave.com/memorial/166355510",
			"id": 166355510,
			"lng": -77.38751555,
			"lat": 37.53688918,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 4,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucy",
			"nl": "Hunt",
			"url": "https://findagrave.com/memorial/171763329",
			"id": 171763329,
			"lng": -77.38715831,
			"lat": 37.53675738,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 3,
			"dd": 28,
			"by": 1942,
			"bd": 5,
			"bm": 7,
			"nm": "Robert",
			"nf": "Wirt",
			"nl": "Hunt",
			"url": "https://findagrave.com/memorial/6071627",
			"id": 6071627,
			"lng": -77.38586018,
			"lat": 37.53655076,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 6,
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Homer",
			"nl": "Huntley",
			"url": "https://findagrave.com/memorial/140290809",
			"id": 140290809,
			"lng": -77.38604045,
			"lat": 37.5363971,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 1,
			"dd": 28,
			"by": 1887,
			"bd": 18,
			"bm": 1,
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Hurdle",
			"url": "https://findagrave.com/memorial/117208920",
			"id": 117208920,
			"lng": -77.38560449,
			"lat": 37.53710201,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 8,
			"dd": 31,
			"by": 1933,
			"bd": 5,
			"bm": 11,
			"nm": "Beatrice",
			"nf": "Vivian",
			"nl": "Hutcheson",
			"url": "https://findagrave.com/memorial/173793332",
			"id": 173793332,
			"lng": -77.38711524,
			"lat": 37.53727236,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 1,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Regina",
			"nl": "Hutchinson",
			"url": "https://findagrave.com/memorial/119240891",
			"id": 119240891,
			"lng": -77.38583599,
			"lat": 37.53687315,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 1,
			"dd": 6,
			"by": 1904,
			"bd": 25,
			"bm": 11,
			"nm": "",
			"nf": "Lucy",
			"nl": "Ingram",
			"url": "https://findagrave.com/memorial/156119514",
			"id": 156119514,
			"lng": -77.38642189,
			"lat": 37.53722813,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 5,
			"dd": 17,
			"by": 1856,
			"bd": "",
			"bm": 4,
			"nm": "A.",
			"nf": "Ella",
			"nl": "Isham",
			"url": "https://findagrave.com/memorial/150788960",
			"id": 150788960,
			"lng": -77.38632808,
			"lat": 37.53562069,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 1,
			"dd": 12,
			"by": 1820,
			"bd": 4,
			"bm": 7,
			"nm": "Ann",
			"nf": "Virginia",
			"nl": "Isham",
			"url": "https://findagrave.com/memorial/150788970",
			"id": 150788970,
			"lng": -77.38632642,
			"lat": 37.53562937,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 8,
			"dd": 5,
			"by": 1845,
			"bd": "",
			"bm": 5,
			"nm": "H.",
			"nf": "William",
			"nl": "Isham",
			"url": "https://findagrave.com/memorial/150788981",
			"id": 150788981,
			"lng": -77.38631374,
			"lat": 37.53562017,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 1,
			"dd": 6,
			"by": 1876,
			"bd": 30,
			"bm": 1,
			"nm": "H.",
			"nf": "William",
			"nl": "Isham",
			"url": "https://findagrave.com/memorial/150788990",
			"id": 150788990,
			"lng": -77.38631138,
			"lat": 37.53562781,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 10,
			"dd": 30,
			"by": 1889,
			"bd": 9,
			"bm": 11,
			"nm": "",
			"nf": "Alberta",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/113626462",
			"id": 113626462,
			"lng": -77.3877837,
			"lat": 37.53709479,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 11,
			"dd": 15,
			"by": 1899,
			"bd": "",
			"bm": 5,
			"nm": "V.",
			"nf": "Andrew",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/129209867",
			"id": 129209867,
			"lng": -77.38608511,
			"lat": 37.53680405,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 4,
			"dd": 21,
			"by": 1887,
			"bd": 25,
			"bm": 12,
			"nm": "Rase",
			"nf": "Asbury",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/138567072",
			"id": 138567072,
			"lng": -77.38645383,
			"lat": 37.53689807,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 2,
			"dd": 1,
			"by": 1969,
			"bd": 25,
			"bm": 11,
			"nm": "",
			"nf": "baby boy",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/179854702",
			"id": 179854702,
			"lng": -77.38589359,
			"lat": 37.53744267,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 12,
			"dd": 16,
			"by": 1841,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Benjamin",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/154222275",
			"id": 154222275,
			"lng": -77.38657069,
			"lat": 37.5355814,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 11,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bernard",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/111589845",
			"id": 111589845,
			"lng": -77.38732867,
			"lat": 37.53754528,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 7,
			"dd": 2,
			"by": 1930,
			"bd": 24,
			"bm": 7,
			"nm": "Asbury",
			"nf": "Clifton",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/130538938",
			"id": 130538938,
			"lng": -77.38640522,
			"lat": 37.53701354,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 10,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Cora",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/140290940",
			"id": 140290940,
			"lng": -77.38661454,
			"lat": 37.53556272,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 11,
			"dd": 15,
			"by": 1922,
			"bd": 17,
			"bm": 2,
			"nm": "James",
			"nf": "David",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/189776221",
			"id": 189776221,
			"lng": -77.38712473,
			"lat": 37.53754792,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 8,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "S.",
			"nf": "Donald",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/144143017",
			"id": 144143017,
			"lng": -77.38611867,
			"lat": 37.53741764,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 4,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Eddie",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/159880460",
			"id": 159880460,
			"lng": -77.38781366,
			"lat": 37.53702276,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 9,
			"dd": 7,
			"by": 1903,
			"bd": 14,
			"bm": 3,
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/158924491",
			"id": 158924491,
			"lng": -77.3865957,
			"lat": 37.53757495,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": 1863,
			"bd": "",
			"bm": 9,
			"nm": "",
			"nf": "Flora",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/149168063",
			"id": 149168063,
			"lng": -77.38629181,
			"lat": 37.53541847,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 3,
			"dd": 23,
			"by": 1896,
			"bd": 15,
			"bm": 9,
			"nm": "",
			"nf": "Floyd",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/151266445",
			"id": 151266445,
			"lng": -77.38715571,
			"lat": 37.53764422,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 4,
			"dd": 9,
			"by": 1875,
			"bd": 4,
			"bm": 3,
			"nm": "",
			"nf": "Georgianna",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/174858865",
			"id": 174858865,
			"lng": -77.38743184,
			"lat": 37.53705735,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 6,
			"dd": 14,
			"by": 1916,
			"bd": 15,
			"bm": 5,
			"nm": "Beatrice",
			"nf": "Gladys",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/184094538",
			"id": 184094538,
			"lng": -77.38732339,
			"lat": 37.53757069,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": "",
			"dd": "",
			"by": 1902,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Hallie",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/138567085",
			"id": 138567085,
			"lng": -77.38626606,
			"lat": 37.53659015,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 8,
			"dd": 24,
			"by": 1901,
			"bd": 22,
			"bm": 6,
			"nm": "",
			"nf": "Horace",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/142449367",
			"id": 142449367,
			"lng": -77.38745002,
			"lat": 37.53790318,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 3,
			"dd": 17,
			"by": 1903,
			"bd": 1,
			"bm": 1,
			"nm": "B.",
			"nf": "Ida",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/113750917",
			"id": 113750917,
			"lng": -77.38614947,
			"lat": 37.53691004,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 10,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Belle",
			"nf": "Ida",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/160639667",
			"id": 160639667,
			"lng": -77.38604127,
			"lat": 37.5368157,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 3,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Henry",
			"nf": "James",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/122786308",
			"id": 122786308,
			"lng": -77.38571223,
			"lat": 37.53698756,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 12,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jeanette",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/140290958",
			"id": 140290958,
			"lng": -77.38661519,
			"lat": 37.53557084,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 5,
			"dd": 1,
			"by": 1891,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jennie",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/184693849",
			"id": 184693849,
			"lng": -77.38639703,
			"lat": 37.53754553,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 1,
			"dd": 15,
			"by": 1910,
			"bd": 12,
			"bm": 10,
			"nm": "Lee",
			"nf": "John",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/176769430",
			"id": 176769430,
			"lng": -77.38748467,
			"lat": 37.53726496,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 10,
			"dd": 23,
			"by": 1895,
			"bd": 16,
			"bm": 11,
			"nm": "Ann",
			"nf": "Julia",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/191417556",
			"id": 191417556,
			"lng": -77.386409,
			"lat": 37.53747381,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 4,
			"dd": 3,
			"by": 1930,
			"bd": 25,
			"bm": 10,
			"nm": "",
			"nf": "Julia",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/38456036",
			"id": 38456036,
			"lng": -77.38577242,
			"lat": 37.53697218,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 5,
			"dd": 8,
			"by": 1900,
			"bd": 24,
			"bm": 9,
			"nm": "",
			"nf": "Kate",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/130538951",
			"id": 130538951,
			"lng": -77.38639318,
			"lat": 37.53697847,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 10,
			"dd": 14,
			"by": 1897,
			"bd": 10,
			"bm": 6,
			"nm": "",
			"nf": "Leanna",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/134378279",
			"id": 134378279,
			"lng": -77.3864,
			"lat": 37.53736082,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 2,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lee",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/127569715",
			"id": 127569715,
			"lng": -77.38577424,
			"lat": 37.53707913,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 11,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Malinda",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/187881417",
			"id": 187881417,
			"lng": -77.38761485,
			"lat": 37.53699305,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 1,
			"dd": 25,
			"by": 1854,
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Maria",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/154222161",
			"id": 154222161,
			"lng": -77.3865719,
			"lat": 37.53555043,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 5,
			"dd": 1,
			"by": 1875,
			"bd": 5,
			"bm": 5,
			"nm": "E.",
			"nf": "Mary",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/176134498",
			"id": 176134498,
			"lng": -77.387647,
			"lat": 37.5371545,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 3,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "T.",
			"nf": "Mary",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/145085195",
			"id": 145085195,
			"lng": -77.38761095,
			"lat": 37.53721565,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 2,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/151459721",
			"id": 151459721,
			"lng": -77.38804971,
			"lat": 37.53731936,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 8,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Mary",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/161636482",
			"id": 161636482,
			"lng": -77.38650298,
			"lat": 37.53657605,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 6,
			"dd": 1,
			"by": 1912,
			"bd": "",
			"bm": "",
			"nm": "Esther",
			"nf": "Mary",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/125520647",
			"id": 125520647,
			"lng": -77.38625498,
			"lat": 37.53677506,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 4,
			"dd": 29,
			"by": 1910,
			"bd": 4,
			"bm": 6,
			"nm": "T.",
			"nf": "Melvin",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/125583724",
			"id": 125583724,
			"lng": -77.38624934,
			"lat": 37.53678701,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 10,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nathaniel",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/170838903",
			"id": 170838903,
			"lng": -77.38644032,
			"lat": 37.53719596,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 2,
			"dd": 23,
			"by": 1867,
			"bd": 18,
			"bm": 8,
			"nm": "",
			"nf": "Nelson",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/156126599",
			"id": 156126599,
			"lng": -77.38614147,
			"lat": 37.53693571,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 2,
			"dd": 28,
			"by": 1916,
			"bd": 28,
			"bm": 1,
			"nm": "",
			"nf": "Nicholas",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/153512662",
			"id": 153512662,
			"lng": -77.38668296,
			"lat": 37.53719783,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 10,
			"dd": 4,
			"by": 1919,
			"bd": 9,
			"bm": 5,
			"nm": "",
			"nf": "Oscar",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/188244328",
			"id": 188244328,
			"lng": -77.38805292,
			"lat": 37.5373943,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 11,
			"dd": 29,
			"by": 1912,
			"bd": 17,
			"bm": 6,
			"nm": "",
			"nf": "Pearl",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/168128975",
			"id": 168128975,
			"lng": -77.38690851,
			"lat": 37.53725911,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 1,
			"dd": 2,
			"by": 1891,
			"bd": 18,
			"bm": 2,
			"nm": "",
			"nf": "Rebecca",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/148285699",
			"id": 148285699,
			"lng": -77.38640142,
			"lat": 37.53720326,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": 1850,
			"bd": "",
			"bm": 1,
			"nm": "",
			"nf": "Richard",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/149168068",
			"id": 149168068,
			"lng": -77.38628923,
			"lat": 37.53542546,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 4,
			"dd": 4,
			"by": 1920,
			"bd": 28,
			"bm": 5,
			"nm": "Lee",
			"nf": "Rosa",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/84788791",
			"id": 84788791,
			"lng": -77.38773621,
			"lat": 37.537423,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 9,
			"dd": 1,
			"by": 1961,
			"bd": 9,
			"bm": 7,
			"nm": "W.",
			"nf": "Vernon",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/161636483",
			"id": 161636483,
			"lng": -77.38602476,
			"lat": 37.53631506,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 4,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Vinia",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/130693438",
			"id": 130693438,
			"lng": -77.38577921,
			"lat": 37.53707049,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 8,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "William",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/175402532",
			"id": 175402532,
			"lng": -77.38743116,
			"lat": 37.53706886,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 10,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Van",
			"nf": "William",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/140290947",
			"id": 140290947,
			"lng": -77.3866148,
			"lat": 37.53556683,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 3,
			"dd": 26,
			"by": 1906,
			"bd": 6,
			"bm": 11,
			"nm": "H.",
			"nf": "William",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/143825862",
			"id": 143825862,
			"lng": -77.3860393,
			"lat": 37.53730791,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 7,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Willie",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/175401624",
			"id": 175401624,
			"lng": -77.38756957,
			"lat": 37.53693457,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 2,
			"dd": 2,
			"by": 1922,
			"bd": 27,
			"bm": 11,
			"nm": "Mae",
			"nf": "Willie",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/160277977",
			"id": 160277977,
			"lng": -77.38608269,
			"lat": 37.53636305,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 11,
			"dd": 19,
			"by": 1888,
			"bd": 1,
			"bm": 4,
			"nm": "",
			"nf": "Wilson",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/145596013",
			"id": 145596013,
			"lng": -77.38630538,
			"lat": 37.53734785,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 1,
			"dd": 26,
			"by": 1921,
			"bd": 28,
			"bm": 5,
			"nm": "",
			"nf": "Trust",
			"nl": "Jacobs",
			"url": "https://findagrave.com/memorial/155517942",
			"id": 155517942,
			"lng": -77.38765589,
			"lat": 37.537454,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 9,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Eddie",
			"nl": "James",
			"url": "https://findagrave.com/memorial/145085208",
			"id": 145085208,
			"lng": -77.38782323,
			"lat": 37.5372641,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 6,
			"dd": 30,
			"by": 1963,
			"bd": 22,
			"bm": 8,
			"nm": "Bouvia",
			"nf": "Faye",
			"nl": "James",
			"url": "https://findagrave.com/memorial/151940959",
			"id": 151940959,
			"lng": -77.38598392,
			"lat": 37.53748226,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 12,
			"dd": 16,
			"by": 1926,
			"bd": 9,
			"bm": 10,
			"nm": "Lorraine",
			"nf": "Gladys",
			"nl": "James",
			"url": "https://findagrave.com/memorial/125820823",
			"id": 125820823,
			"lng": -77.3862498,
			"lat": 37.53735033,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 12,
			"dd": 16,
			"by": 1900,
			"bd": 24,
			"bm": 7,
			"nm": "Kearney",
			"nf": "Helen",
			"nl": "James",
			"url": "https://findagrave.com/memorial/152794731",
			"id": 152794731,
			"lng": -77.38657852,
			"lat": 37.53735686,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 3,
			"dd": 28,
			"by": 1889,
			"bd": 1,
			"bm": 12,
			"nm": "",
			"nf": "Lucy",
			"nl": "James",
			"url": "https://findagrave.com/memorial/144143019",
			"id": 144143019,
			"lng": -77.38656743,
			"lat": 37.53760652,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1912,
			"dm": 9,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mahaley",
			"nl": "James",
			"url": "https://findagrave.com/memorial/155517954",
			"id": 155517954,
			"lng": -77.38702545,
			"lat": 37.53599269,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 3,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Maria",
			"nl": "James",
			"url": "https://findagrave.com/memorial/141194075",
			"id": 141194075,
			"lng": -77.38627278,
			"lat": 37.53666503,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 12,
			"dd": 15,
			"by": 1888,
			"bd": 7,
			"bm": 6,
			"nm": "",
			"nf": "Matilda",
			"nl": "James",
			"url": "https://findagrave.com/memorial/177020045",
			"id": 177020045,
			"lng": -77.38793677,
			"lat": 37.53726636,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1906,
			"dm": 1,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Maud",
			"nl": "James",
			"url": "https://findagrave.com/memorial/125408480",
			"id": 125408480,
			"lng": -77.38778585,
			"lat": 37.53651619,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 3,
			"dd": 18,
			"by": 1894,
			"bd": 4,
			"bm": 7,
			"nm": "",
			"nf": "Richard",
			"nl": "James",
			"url": "https://findagrave.com/memorial/186818085",
			"id": 186818085,
			"lng": -77.3871282,
			"lat": 37.5369082,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 4,
			"dd": 23,
			"by": 1882,
			"bd": 27,
			"bm": 12,
			"nm": "",
			"nf": "Virginia",
			"nl": "James",
			"url": "https://findagrave.com/memorial/117449108",
			"id": 117449108,
			"lng": -77.38786882,
			"lat": 37.53721171,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1906,
			"dm": 7,
			"dd": 5,
			"by": 1858,
			"bd": 4,
			"bm": 3,
			"nm": "Madison",
			"nf": "James",
			"nl": "Jasper",
			"url": "https://findagrave.com/memorial/38427941",
			"id": 38427941,
			"lng": -77.38592873,
			"lat": 37.53643189,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 2,
			"dd": 1,
			"by": 1891,
			"bd": 17,
			"bm": 8,
			"nm": "Manning",
			"nf": "Joseph",
			"nl": "Jasper",
			"url": "https://findagrave.com/memorial/38455502",
			"id": 38455502,
			"lng": -77.38575181,
			"lat": 37.53695091,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 10,
			"dd": 27,
			"by": 1889,
			"bd": 22,
			"bm": 12,
			"nm": "S.",
			"nf": "Lelia",
			"nl": "Jasper",
			"url": "https://findagrave.com/memorial/38455332",
			"id": 38455332,
			"lng": -77.38575511,
			"lat": 37.53694197,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1985,
			"dm": 4,
			"dd": 30,
			"by": 1897,
			"bd": 2,
			"bm": 7,
			"nm": "H.",
			"nf": "Earsell",
			"nl": "Jeffers",
			"url": "https://findagrave.com/memorial/126456538",
			"id": 126456538,
			"lng": -77.38580441,
			"lat": 37.53649178,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 3,
			"dd": 13,
			"by": 1903,
			"bd": 25,
			"bm": 2,
			"nm": "Ruth",
			"nf": "Eliza",
			"nl": "Jefferson",
			"url": "https://findagrave.com/memorial/126586610",
			"id": 126586610,
			"lng": -77.387781,
			"lat": 37.53782597,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 11,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "George",
			"nl": "Jefferson",
			"url": "https://findagrave.com/memorial/144143021",
			"id": 144143021,
			"lng": -77.38592722,
			"lat": 37.53728528,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 9,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "John",
			"nl": "Jefferson",
			"url": "https://findagrave.com/memorial/185715188",
			"id": 185715188,
			"lng": -77.38801127,
			"lat": 37.53699516,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 8,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Marie",
			"nl": "Jefferson",
			"url": "https://findagrave.com/memorial/174859738",
			"id": 174859738,
			"lng": -77.38747258,
			"lat": 37.53707104,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 2,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Jefferson",
			"url": "https://findagrave.com/memorial/174657542",
			"id": 174657542,
			"lng": -77.38763047,
			"lat": 37.53711571,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 12,
			"dd": 16,
			"by": 1889,
			"bd": 1,
			"bm": 7,
			"nm": "",
			"nf": "Nancy",
			"nl": "Jefferson",
			"url": "https://findagrave.com/memorial/176247076",
			"id": 176247076,
			"lng": -77.38763382,
			"lat": 37.53734632,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 12,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nancy",
			"nl": "Jefferson",
			"url": "https://findagrave.com/memorial/150493643",
			"id": 150493643,
			"lng": -77.38638672,
			"lat": 37.53602564,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 8,
			"dd": 24,
			"by": 1900,
			"bd": 1,
			"bm": 3,
			"nm": "O.",
			"nf": "Rufus",
			"nl": "Jefferson",
			"url": "https://findagrave.com/memorial/153512666",
			"id": 153512666,
			"lng": -77.38663031,
			"lat": 37.5372101,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 3,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "Watt",
			"nl": "Jefferson",
			"url": "https://findagrave.com/memorial/188566984",
			"id": 188566984,
			"lng": -77.38674258,
			"lat": 37.53657872,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 2,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Jefferson",
			"url": "https://findagrave.com/memorial/117209001",
			"id": 117209001,
			"lng": -77.38583584,
			"lat": 37.53672267,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 12,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Winfree",
			"nl": "Jefferson",
			"url": "https://findagrave.com/memorial/181956331",
			"id": 181956331,
			"lng": -77.38628014,
			"lat": 37.53569995,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1984,
			"dm": 7,
			"dd": 10,
			"by": 1914,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rosa",
			"nl": "Jeffiers",
			"url": "https://findagrave.com/memorial/122794799",
			"id": 122794799,
			"lng": -77.38590076,
			"lat": 37.53694836,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 6,
			"dd": 1,
			"by": 1891,
			"bd": "",
			"bm": "",
			"nm": "R.",
			"nf": "Charlie",
			"nl": "Jeffries",
			"url": "https://findagrave.com/memorial/146013345",
			"id": 146013345,
			"lng": -77.38659195,
			"lat": 37.5367,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 9,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Hattie",
			"nl": "Jeffries",
			"url": "https://findagrave.com/memorial/185378279",
			"id": 185378279,
			"lng": -77.38649302,
			"lat": 37.53760806,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 3,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Jeffries",
			"url": "https://findagrave.com/memorial/176468244",
			"id": 176468244,
			"lng": -77.38733783,
			"lat": 37.53705726,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 5,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Viola",
			"nl": "Jeffries",
			"url": "https://findagrave.com/memorial/142449470",
			"id": 142449470,
			"lng": -77.38744732,
			"lat": 37.53787848,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 2,
			"dd": 28,
			"by": 1900,
			"bd": 6,
			"bm": 3,
			"nm": "",
			"nf": "Edna",
			"nl": "Jenkins",
			"url": "https://findagrave.com/memorial/177500645",
			"id": 177500645,
			"lng": -77.38794283,
			"lat": 37.53731295,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "George",
			"nl": "Jenkins",
			"url": "https://findagrave.com/memorial/159603611",
			"id": 159603611,
			"lng": -77.38715266,
			"lat": 37.53748082,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 11,
			"dd": 25,
			"by": 1866,
			"bd": "",
			"bm": 3,
			"nm": "",
			"nf": "Kate",
			"nl": "Jenkins",
			"url": "https://findagrave.com/memorial/113750928",
			"id": 113750928,
			"lng": -77.38569033,
			"lat": 37.53683854,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 8,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucy",
			"nl": "Jenkins",
			"url": "https://findagrave.com/memorial/134359185",
			"id": 134359185,
			"lng": -77.38596381,
			"lat": 37.53615847,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 5,
			"dd": 19,
			"by": 1892,
			"bd": "",
			"bm": 9,
			"nm": "Nathaniel",
			"nf": "Magnus",
			"nl": "Jenkins",
			"url": "https://findagrave.com/memorial/113750936",
			"id": 113750936,
			"lng": -77.3856867,
			"lat": 37.5368465,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 8,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Major",
			"nl": "Jenkins",
			"url": "https://findagrave.com/memorial/131428507",
			"id": 131428507,
			"lng": -77.3856963,
			"lat": 37.53682346,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 2,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A. E.",
			"nf": "Sallie",
			"nl": "Jenkins",
			"url": "https://findagrave.com/memorial/154515401",
			"id": 154515401,
			"lng": -77.38662967,
			"lat": 37.53563858,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 4,
			"dd": 24,
			"by": 1894,
			"bd": 27,
			"bm": 1,
			"nm": "Arthur Corbin",
			"nf": "John",
			"nl": "Jernigan",
			"url": "https://findagrave.com/memorial/152531974",
			"id": 152531974,
			"lng": -77.38586594,
			"lat": 37.53642125,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 9,
			"dd": 21,
			"by": 1964,
			"bd": 9,
			"bm": 7,
			"nm": "Lynn",
			"nf": "Vickie",
			"nl": "Jeter",
			"url": "https://findagrave.com/memorial/170815001",
			"id": 170815001,
			"lng": -77.38630076,
			"lat": 37.53680469,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 9,
			"dd": 3,
			"by": 1895,
			"bd": 7,
			"bm": 9,
			"nm": "",
			"nf": "Adelle",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/162642078",
			"id": 162642078,
			"lng": -77.3867575,
			"lat": 37.5370844,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 4,
			"dd": 11,
			"by": 1939,
			"bd": 22,
			"bm": 5,
			"nm": "",
			"nf": "Adelle",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/162164386",
			"id": 162164386,
			"lng": -77.38612275,
			"lat": 37.53629108,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 2,
			"dd": 4,
			"by": 1921,
			"bd": 21,
			"bm": 10,
			"nm": "",
			"nf": "Albert",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/185739192",
			"id": 185739192,
			"lng": -77.38752218,
			"lat": 37.53737844,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 9,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "P.",
			"nf": "Alexander",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/136173071",
			"id": 136173071,
			"lng": -77.38641651,
			"lat": 37.53643085,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 8,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Alyce",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/125520655",
			"id": 125520655,
			"lng": -77.38588223,
			"lat": 37.53702047,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 5,
			"dd": 9,
			"by": 1933,
			"bd": 8,
			"bm": 5,
			"nm": "",
			"nf": "Annanias",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/160941306",
			"id": 160941306,
			"lng": -77.38689127,
			"lat": 37.53700731,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 1,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Annie",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/148747970",
			"id": 148747970,
			"lng": -77.38801534,
			"lat": 37.53712711,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 9,
			"dd": 9,
			"by": 1925,
			"bd": 6,
			"bm": 7,
			"nm": "M.",
			"nf": "Bessie",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/153512671",
			"id": 153512671,
			"lng": -77.38680865,
			"lat": 37.53731451,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 6,
			"dd": 6,
			"by": 1917,
			"bd": 27,
			"bm": 9,
			"nm": "",
			"nf": "Betsy",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/172687171",
			"id": 172687171,
			"lng": -77.38728712,
			"lat": 37.53731936,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 11,
			"dd": 6,
			"by": 1893,
			"bd": 12,
			"bm": 8,
			"nm": "Antionette",
			"nf": "Bettie",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/155517956",
			"id": 155517956,
			"lng": -77.38634677,
			"lat": 37.53638398,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 7,
			"dd": 9,
			"by": 1887,
			"bd": 10,
			"bm": 4,
			"nm": "",
			"nf": "Betty",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/142221493",
			"id": 142221493,
			"lng": -77.3866477,
			"lat": 37.53715376,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 1,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Catherine",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/155292257",
			"id": 155292257,
			"lng": -77.38660718,
			"lat": 37.53568036,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 2,
			"dd": 17,
			"by": 1893,
			"bd": "",
			"bm": 12,
			"nm": "",
			"nf": "Clarance",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/163950338",
			"id": 163950338,
			"lng": -77.38681416,
			"lat": 37.5367359,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 3,
			"dd": 14,
			"by": 1931,
			"bd": 18,
			"bm": 3,
			"nm": "",
			"nf": "Clarence",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/128400032",
			"id": 128400032,
			"lng": -77.38562742,
			"lat": 37.53704426,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 10,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Colindus",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/127483499",
			"id": 127483499,
			"lng": -77.38593841,
			"lat": 37.53731198,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 3,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Collins",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/176768898",
			"id": 176768898,
			"lng": -77.38769693,
			"lat": 37.53687453,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 2,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "R.",
			"nf": "Edwin",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/124564899",
			"id": 124564899,
			"lng": -77.38587574,
			"lat": 37.53746293,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": 5,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Eliza",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/149201568",
			"id": 149201568,
			"lng": -77.38625596,
			"lat": 37.53544115,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 12,
			"dd": 20,
			"by": 1906,
			"bd": 26,
			"bm": 11,
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/158678134",
			"id": 158678134,
			"lng": -77.38668486,
			"lat": 37.53758345,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 8,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/146013350",
			"id": 146013350,
			"lng": -77.38650581,
			"lat": 37.53663419,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 2,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/120147052",
			"id": 120147052,
			"lng": -77.3859814,
			"lat": 37.5367546,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 3,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/128400018",
			"id": 128400018,
			"lng": -77.38568959,
			"lat": 37.53699682,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 4,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Elmira",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/113750945",
			"id": 113750945,
			"lng": -77.38569734,
			"lat": 37.53683788,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 10,
			"dd": 27,
			"by": 1898,
			"bd": 17,
			"bm": 7,
			"nm": "",
			"nf": "Emma",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/138366551",
			"id": 138366551,
			"lng": -77.38623257,
			"lat": 37.5367351,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 11,
			"dd": 12,
			"by": 1942,
			"bd": 17,
			"bm": 2,
			"nm": "",
			"nf": "Evelyn",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/148285720",
			"id": 148285720,
			"lng": -77.38646355,
			"lat": 37.53725812,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 11,
			"dd": 6,
			"by": 1920,
			"bd": 25,
			"bm": 4,
			"nm": "J.",
			"nf": "Evelyn",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/136304921",
			"id": 136304921,
			"lng": -77.38618819,
			"lat": 37.53634788,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 5,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ewell",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/140623857",
			"id": 140623857,
			"lng": -77.38683179,
			"lat": 37.53545403,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 12,
			"dd": 10,
			"by": 1898,
			"bd": 10,
			"bm": 11,
			"nm": "1944nton",
			"nf": "Fleming",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/175328114",
			"id": 175328114,
			"lng": -77.38740581,
			"lat": 37.53708991,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 3,
			"dd": 30,
			"by": 1908,
			"bd": 27,
			"bm": 7,
			"nm": "",
			"nf": "Florence",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/152006128",
			"id": 152006128,
			"lng": -77.38581602,
			"lat": 37.53722116,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 10,
			"dd": 14,
			"by": 1920,
			"bd": 25,
			"bm": 3,
			"nm": "",
			"nf": "Florence",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/192019526",
			"id": 192019526,
			"lng": -77.38781234,
			"lat": 37.53744652,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 3,
			"dd": 3,
			"by": 1892,
			"bd": 7,
			"bm": 8,
			"nm": "W.",
			"nf": "Fred",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/141194091",
			"id": 141194091,
			"lng": -77.3863687,
			"lat": 37.53666659,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 4,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Geneva",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/158679293",
			"id": 158679293,
			"lng": -77.38695547,
			"lat": 37.53743516,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 5,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Geneva",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/155477294",
			"id": 155477294,
			"lng": -77.38731097,
			"lat": 37.53551938,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": "",
			"dd": "",
			"by": 1914,
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "George",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/144315666",
			"id": 144315666,
			"lng": -77.38641835,
			"lat": 37.5353029,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 4,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Georgia",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/175609734",
			"id": 175609734,
			"lng": -77.3876349,
			"lat": 37.53709433,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 12,
			"dd": 14,
			"by": 1858,
			"bd": 22,
			"bm": 2,
			"nm": "L.",
			"nf": "Hannah",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/136107589",
			"id": 136107589,
			"lng": -77.38613595,
			"lat": 37.53692099,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 9,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "D.",
			"nf": "Helen",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/166382775",
			"id": 166382775,
			"lng": -77.3874795,
			"lat": 37.53672161,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 12,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "James",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/177354181",
			"id": 177354181,
			"lng": -77.38634052,
			"lat": 37.5374685,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 1,
			"dd": 11,
			"by": 1884,
			"bd": 22,
			"bm": 5,
			"nm": "",
			"nf": "James",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/175421244",
			"id": 175421244,
			"lng": -77.38739998,
			"lat": 37.53724082,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 11,
			"dd": 24,
			"by": 1892,
			"bd": 24,
			"bm": 10,
			"nm": "Edward",
			"nf": "James",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/125634287",
			"id": 125634287,
			"lng": -77.38621973,
			"lat": 37.53676116,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 7,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/139424383",
			"id": 139424383,
			"lng": -77.38714106,
			"lat": 37.53546241,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1907,
			"dm": 4,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "Joseph",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/125408496",
			"id": 125408496,
			"lng": -77.38708842,
			"lat": 37.5362555,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 1,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Josephine",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/167467393",
			"id": 167467393,
			"lng": -77.38785469,
			"lat": 37.53726085,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1882,
			"dm": 1,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Josephine",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/125520670",
			"id": 125520670,
			"lng": -77.38642964,
			"lat": 37.53643927,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 8,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Ellen",
			"nf": "Lena",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/161052809",
			"id": 161052809,
			"lng": -77.38716574,
			"lat": 37.5370137,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 6,
			"dd": 23,
			"by": 1932,
			"bd": 8,
			"bm": 7,
			"nm": "B.",
			"nf": "Lenora",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/123850460",
			"id": 123850460,
			"lng": -77.38597475,
			"lat": 37.53668393,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 4,
			"dd": 11,
			"by": 1886,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Linwood",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/154296434",
			"id": 154296434,
			"lng": -77.38710443,
			"lat": 37.53547785,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 11,
			"dd": 10,
			"by": 1903,
			"bd": 3,
			"bm": 3,
			"nm": "Elizabeth",
			"nf": "Louise",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/167325683",
			"id": 167325683,
			"lng": -77.38689818,
			"lat": 37.53729082,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 8,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucinda",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/187354563",
			"id": 187354563,
			"lng": -77.38782631,
			"lat": 37.53708905,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 6,
			"dd": 24,
			"by": 1890,
			"bd": 11,
			"bm": 12,
			"nm": "",
			"nf": "Lucy",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/158734643",
			"id": 158734643,
			"lng": -77.38703517,
			"lat": 37.53752961,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 6,
			"dd": 28,
			"by": 1857,
			"bd": 10,
			"bm": 4,
			"nm": "Catherine",
			"nf": "Lucy",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/154296445",
			"id": 154296445,
			"lng": -77.38648084,
			"lat": 37.53552452,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1900,
			"dm": 7,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Ann",
			"nf": "Margaret",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/155517966",
			"id": 155517966,
			"lng": -77.386616,
			"lat": 37.53558036,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 7,
			"dd": 23,
			"by": 1900,
			"bd": 17,
			"bm": 4,
			"nm": "O.",
			"nf": "Maria",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/183697461",
			"id": 183697461,
			"lng": -77.38713967,
			"lat": 37.53695861,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 1,
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "R.",
			"nf": "Marvella",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/157309889",
			"id": 157309889,
			"lng": -77.38642862,
			"lat": 37.53704769,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 11,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/145638850",
			"id": 145638850,
			"lng": -77.38783772,
			"lat": 37.5372368,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 5,
			"dd": 14,
			"by": 1871,
			"bd": 20,
			"bm": 7,
			"nm": "F.",
			"nf": "Mary",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/125408514",
			"id": 125408514,
			"lng": -77.38721971,
			"lat": 37.5362771,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 9,
			"dd": 11,
			"by": 1891,
			"bd": 18,
			"bm": 1,
			"nm": "Spencer",
			"nf": "Mary",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/158678309",
			"id": 158678309,
			"lng": -77.38686499,
			"lat": 37.53766766,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 12,
			"dd": 6,
			"by": 1884,
			"bd": 6,
			"bm": 1,
			"nm": "Louise",
			"nf": "Mary",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/154296452",
			"id": 154296452,
			"lng": -77.38680719,
			"lat": 37.53547446,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 4,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "F.",
			"nf": "Mary",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/174622145",
			"id": 174622145,
			"lng": -77.38586431,
			"lat": 37.53643042,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 11,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Minnie",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/182115890",
			"id": 182115890,
			"lng": -77.38661858,
			"lat": 37.53741526,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 9,
			"dd": 25,
			"by": 1885,
			"bd": 10,
			"bm": 4,
			"nm": "E.",
			"nf": "Missouria",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/169397284",
			"id": 169397284,
			"lng": -77.38651878,
			"lat": 37.53682298,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 2,
			"dd": 4,
			"by": 1939,
			"bd": "",
			"bm": "",
			"nm": "Watson",
			"nf": "Nannie Anne",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/173107347",
			"id": 173107347,
			"lng": -77.38700848,
			"lat": 37.53737196,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 5,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Neal",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/145638851",
			"id": 145638851,
			"lng": -77.38590519,
			"lat": 37.53744288,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 5,
			"dd": 11,
			"by": 1927,
			"bd": 11,
			"bm": 11,
			"nm": "",
			"nf": "Otto",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/176570459",
			"id": 176570459,
			"lng": -77.38701901,
			"lat": 37.53746614,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1980,
			"dm": 1,
			"dd": 22,
			"by": 1918,
			"bd": 11,
			"bm": 7,
			"nm": "E.",
			"nf": "Percy",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/153100511",
			"id": 153100511,
			"lng": -77.38657329,
			"lat": 37.53737124,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 1,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "Rachel",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/144013906",
			"id": 144013906,
			"lng": -77.38721557,
			"lat": 37.53763025,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 3,
			"dd": 21,
			"by": 1924,
			"bd": 4,
			"bm": 5,
			"nm": "E.",
			"nf": "Richard",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/141658033",
			"id": 141658033,
			"lng": -77.38664212,
			"lat": 37.53726646,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 3,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Robert",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/176097673",
			"id": 176097673,
			"lng": -77.38726263,
			"lat": 37.53687661,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 11,
			"dd": 18,
			"by": 1907,
			"bd": 11,
			"bm": 4,
			"nm": "A.",
			"nf": "Robert",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/169121717",
			"id": 169121717,
			"lng": -77.38635986,
			"lat": 37.53740465,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 8,
			"dd": 17,
			"by": 1922,
			"bd": 26,
			"bm": 10,
			"nm": "",
			"nf": "Rosa",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/173314382",
			"id": 173314382,
			"lng": -77.38710914,
			"lat": 37.53730952,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 12,
			"dd": 29,
			"by": 1903,
			"bd": 13,
			"bm": 2,
			"nm": "A.",
			"nf": "Ruby",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/167325969",
			"id": 167325969,
			"lng": -77.3868217,
			"lat": 37.53722301,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 2,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sarah",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/170951406",
			"id": 170951406,
			"lng": -77.38607534,
			"lat": 37.53618077,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 7,
			"dd": 30,
			"by": 1923,
			"bd": 31,
			"bm": 7,
			"nm": "",
			"nf": "Susie",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/133351410",
			"id": 133351410,
			"lng": -77.38757946,
			"lat": 37.53737627,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 10,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "O.",
			"nf": "Sydney",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/155289177",
			"id": 155289177,
			"lng": -77.3866355,
			"lat": 37.53565131,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 2,
			"dd": 5,
			"by": 1886,
			"bd": 3,
			"bm": 4,
			"nm": "Everette",
			"nf": "Thomas",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/178089641",
			"id": 178089641,
			"lng": -77.38779575,
			"lat": 37.53754064,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 3,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "R.",
			"nf": "Thomas",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/161052759",
			"id": 161052759,
			"lng": -77.38716518,
			"lat": 37.53702491,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 7,
			"dd": 2,
			"by": "",
			"bd": 7,
			"bm": 4,
			"nm": "",
			"nf": "Thomas",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/143201864",
			"id": 143201864,
			"lng": -77.38599113,
			"lat": 37.53739727,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 4,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Thomas",
			"nf": "William",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/183872295",
			"id": 183872295,
			"lng": -77.38732171,
			"lat": 37.536982,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 6,
			"dd": 5,
			"by": 1897,
			"bd": 4,
			"bm": 12,
			"nm": "H.",
			"nf": "William",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/138567105",
			"id": 138567105,
			"lng": -77.38622867,
			"lat": 37.53674206,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 1,
			"dd": 1,
			"by": 1840,
			"bd": 14,
			"bm": 5,
			"nm": "I.",
			"nf": "William",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/136107579",
			"id": 136107579,
			"lng": -77.38613762,
			"lat": 37.53691745,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 2,
			"dd": 26,
			"by": 1928,
			"bd": 3,
			"bm": 2,
			"nm": "I.",
			"nf": "William",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/136107602",
			"id": 136107602,
			"lng": -77.38613451,
			"lat": 37.53692419,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 2,
			"dd": 7,
			"by": 1905,
			"bd": 12,
			"bm": 2,
			"nm": "M.",
			"nf": "Wortha",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/157897056",
			"id": 157897056,
			"lng": -77.38674221,
			"lat": 37.53751877,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": 1,
			"dd": 25,
			"by": 1843,
			"bd": "",
			"bm": 7,
			"nm": "",
			"nf": "Alexander",
			"nl": "Jonathan",
			"url": "https://findagrave.com/memorial/139424431",
			"id": 139424431,
			"lng": -77.38670702,
			"lat": 37.53659837,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 5,
			"dd": 26,
			"by": 1915,
			"bd": 9,
			"bm": 7,
			"nm": "",
			"nf": "Alexander",
			"nl": "Jonathan",
			"url": "https://findagrave.com/memorial/146013359",
			"id": 146013359,
			"lng": -77.38667156,
			"lat": 37.53662029,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 9,
			"dd": 15,
			"by": 1872,
			"bd": "",
			"bm": 5,
			"nm": "G.",
			"nf": "Cora",
			"nl": "Jonathan",
			"url": "https://findagrave.com/memorial/145838602",
			"id": 145838602,
			"lng": -77.38670199,
			"lat": 37.53577989,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1913,
			"dm": 2,
			"dd": 5,
			"by": 1861,
			"bd": 7,
			"bm": 11,
			"nm": "F.",
			"nf": "Hezekiah",
			"nl": "Jonathan",
			"url": "https://findagrave.com/memorial/145838711",
			"id": 145838711,
			"lng": -77.38671706,
			"lat": 37.53578677,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 4,
			"dd": 7,
			"by": 1913,
			"bd": 13,
			"bm": 7,
			"nm": "Arthur",
			"nf": "Ovel",
			"nl": "Jonathan",
			"url": "https://findagrave.com/memorial/144188806",
			"id": 144188806,
			"lng": -77.38750785,
			"lat": 37.5374329,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 10,
			"dd": 30,
			"by": 1896,
			"bd": 18,
			"bm": 8,
			"nm": "Fulton",
			"nf": "Stanley",
			"nl": "Jonathan",
			"url": "https://findagrave.com/memorial/145838608",
			"id": 145838608,
			"lng": -77.38675228,
			"lat": 37.53575714,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1994,
			"dm": 10,
			"dd": 31,
			"by": 1900,
			"bd": 1,
			"bm": 5,
			"nm": "",
			"nf": "Alexander",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/123696706",
			"id": 123696706,
			"lng": -77.38636857,
			"lat": 37.5370398,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 2,
			"dd": 1,
			"by": 1895,
			"bd": 23,
			"bm": 8,
			"nm": "",
			"nf": "Alice",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/142464315",
			"id": 142464315,
			"lng": -77.38586875,
			"lat": 37.53728559,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 8,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Anna",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/139424472",
			"id": 139424472,
			"lng": -77.38789633,
			"lat": 37.53706704,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 9,
			"dd": 10,
			"by": 1895,
			"bd": 5,
			"bm": 6,
			"nm": "Walter",
			"nf": "Arthur",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/151108246",
			"id": 151108246,
			"lng": -77.38665449,
			"lat": 37.53552657,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 9,
			"dd": 29,
			"by": 1863,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Asa",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/140290823",
			"id": 140290823,
			"lng": -77.38664609,
			"lat": 37.53550662,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 9,
			"dd": 9,
			"by": 1898,
			"bd": 4,
			"bm": 7,
			"nm": "F.",
			"nf": "Benjamin",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/150078592",
			"id": 150078592,
			"lng": -77.38681696,
			"lat": 37.53707475,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 7,
			"dd": 28,
			"by": 1923,
			"bd": 9,
			"bm": 2,
			"nm": "Lee",
			"nf": "Bernard",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/136107614",
			"id": 136107614,
			"lng": -77.38610519,
			"lat": 37.53693982,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1903,
			"dm": 1,
			"dd": 13,
			"by": 1879,
			"bd": 25,
			"bm": 6,
			"nm": "",
			"nf": "Bettie",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/131428520",
			"id": 131428520,
			"lng": -77.38755994,
			"lat": 37.53653541,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 1,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Camilla",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/154277695",
			"id": 154277695,
			"lng": -77.3864822,
			"lat": 37.53551105,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 4,
			"dd": 20,
			"by": 1901,
			"bd": 19,
			"bm": 9,
			"nm": "T.",
			"nf": "Carlton",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/160433739",
			"id": 160433739,
			"lng": -77.38617208,
			"lat": 37.53637683,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 6,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Caroline",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/130538958",
			"id": 130538958,
			"lng": -77.38651134,
			"lat": 37.53692735,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 3,
			"dd": 20,
			"by": 1914,
			"bd": 15,
			"bm": 11,
			"nm": "",
			"nf": "Carrie",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/65522321",
			"id": 65522321,
			"lng": -77.38592843,
			"lat": 37.53656065,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 7,
			"dd": 19,
			"by": 1933,
			"bd": 1,
			"bm": 2,
			"nm": "Jordan",
			"nf": "Charles",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/111589849",
			"id": 111589849,
			"lng": -77.38732484,
			"lat": 37.53752533,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 11,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Joe",
			"nf": "Charles",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/178412485",
			"id": 178412485,
			"lng": -77.38603521,
			"lat": 37.53627629,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 3,
			"dd": 27,
			"by": 1884,
			"bd": 12,
			"bm": 12,
			"nm": "",
			"nf": "Charley",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/129211442",
			"id": 129211442,
			"lng": -77.38603122,
			"lat": 37.53670888,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 6,
			"dd": 10,
			"by": 1912,
			"bd": 16,
			"bm": 12,
			"nm": "Belle",
			"nf": "Cora",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/123696618",
			"id": 123696618,
			"lng": -77.38634429,
			"lat": 37.53703143,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 12,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Cornelia",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/146013368",
			"id": 146013368,
			"lng": -77.38773178,
			"lat": 37.53668415,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 5,
			"dd": 31,
			"by": 1888,
			"bd": 6,
			"bm": 9,
			"nm": "",
			"nf": "Cyrus",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/154514984",
			"id": 154514984,
			"lng": -77.38644061,
			"lat": 37.53565058,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 5,
			"dd": 28,
			"by": 1910,
			"bd": 10,
			"bm": 5,
			"nm": "Winston",
			"nf": "David",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/144315674",
			"id": 144315674,
			"lng": -77.38625195,
			"lat": 37.5352887,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 12,
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Douglas",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/138567111",
			"id": 138567111,
			"lng": -77.38636673,
			"lat": 37.53659197,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 1,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Agnes",
			"nf": "Elizabeth",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/151944040",
			"id": 151944040,
			"lng": -77.38665918,
			"lat": 37.53573637,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 2,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Etta",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/179574638",
			"id": 179574638,
			"lng": -77.38794363,
			"lat": 37.53774531,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 3,
			"dd": 9,
			"by": 1918,
			"bd": 15,
			"bm": 9,
			"nm": "",
			"nf": "Evelyn",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/125312983",
			"id": 125312983,
			"lng": -77.38591764,
			"lat": 37.53687174,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 12,
			"dd": 25,
			"by": 1940,
			"bd": 19,
			"bm": 5,
			"nm": "R.",
			"nf": "Franklin",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/123696711",
			"id": 123696711,
			"lng": -77.38637371,
			"lat": 37.53702691,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 2,
			"dd": 18,
			"by": 1907,
			"bd": 8,
			"bm": 11,
			"nm": "Bertha",
			"nf": "Geneva",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/185658251",
			"id": 185658251,
			"lng": -77.38610516,
			"lat": 37.53734292,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 1,
			"dd": 21,
			"by": 1937,
			"bd": 15,
			"bm": 4,
			"nm": "Ottis",
			"nf": "George",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/128400039",
			"id": 128400039,
			"lng": -77.3858963,
			"lat": 37.53689934,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 10,
			"dd": 15,
			"by": 1950,
			"bd": 29,
			"bm": 1,
			"nm": "Nelson",
			"nf": "Glenn",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/141800936",
			"id": 141800936,
			"lng": -77.38657822,
			"lat": 37.5372374,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 1,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "F.",
			"nf": "Henry",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/135631986",
			"id": 135631986,
			"lng": -77.38607724,
			"lat": 37.53706322,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 5,
			"dd": 9,
			"by": 1965,
			"bd": 5,
			"bm": 12,
			"nm": "Desalle",
			"nf": "Huron",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/164205395",
			"id": 164205395,
			"lng": -77.38556273,
			"lat": 37.537295,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 5,
			"dd": 14,
			"by": 1875,
			"bd": 2,
			"bm": 5,
			"nm": "",
			"nf": "Isaiah",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/138567127",
			"id": 138567127,
			"lng": -77.38648685,
			"lat": 37.53691484,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 5,
			"dd": 13,
			"by": 1924,
			"bd": 3,
			"bm": 9,
			"nm": "",
			"nf": "James",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/177214504",
			"id": 177214504,
			"lng": -77.38732579,
			"lat": 37.53674678,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1912,
			"dm": 2,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Edward",
			"nf": "James",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/151943567",
			"id": 151943567,
			"lng": -77.38665944,
			"lat": 37.53572881,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 3,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jessie",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/170839552",
			"id": 170839552,
			"lng": -77.38648595,
			"lat": 37.53708949,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 11,
			"dd": 5,
			"by": 1905,
			"bd": 18,
			"bm": 12,
			"nm": "",
			"nf": "Joe",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/117449109",
			"id": 117449109,
			"lng": -77.38709395,
			"lat": 37.53715069,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": "",
			"dd": "",
			"by": 1907,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Joe",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/147853387",
			"id": 147853387,
			"lng": -77.38705052,
			"lat": 37.53714099,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 6,
			"dd": 30,
			"by": 1892,
			"bd": 21,
			"bm": 3,
			"nm": "H.",
			"nf": "John",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/114466963",
			"id": 114466963,
			"lng": -77.38629643,
			"lat": 37.53688616,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 5,
			"dd": 27,
			"by": 1904,
			"bd": 28,
			"bm": 7,
			"nm": "H.",
			"nf": "John",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/178412488",
			"id": 178412488,
			"lng": -77.38606357,
			"lat": 37.53629053,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 3,
			"dd": 16,
			"by": 1915,
			"bd": 1,
			"bm": 3,
			"nm": "Edward",
			"nf": "Joseph",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/65522125",
			"id": 65522125,
			"lng": -77.38593402,
			"lat": 37.53655083,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": "",
			"dd": "",
			"by": 1966,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Joseph",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/145838715",
			"id": 145838715,
			"lng": -77.38593711,
			"lat": 37.53743985,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 8,
			"dd": 6,
			"by": 1900,
			"bd": 1,
			"bm": 3,
			"nm": "",
			"nf": "Josephine",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/166327350",
			"id": 166327350,
			"lng": -77.38700062,
			"lat": 37.53664402,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 4,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Kate",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/159880465",
			"id": 159880465,
			"lng": -77.38781577,
			"lat": 37.53703178,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 11,
			"dd": 20,
			"by": 1863,
			"bd": "",
			"bm": 1,
			"nm": "",
			"nf": "Lawson",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/142526934",
			"id": 142526934,
			"lng": -77.38650561,
			"lat": 37.53538924,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 2,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Leslie",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/175614661",
			"id": 175614661,
			"lng": -77.3874832,
			"lat": 37.53571034,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 4,
			"dd": 11,
			"by": 1883,
			"bd": 23,
			"bm": 10,
			"nm": "P.",
			"nf": "Lucy",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/147853404",
			"id": 147853404,
			"lng": -77.38704837,
			"lat": 37.5371494,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 11,
			"dd": 7,
			"by": 1916,
			"bd": 8,
			"bm": 1,
			"nm": "",
			"nf": "Luella",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/161636486",
			"id": 161636486,
			"lng": -77.38800252,
			"lat": 37.53737484,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 2,
			"dd": 6,
			"by": 1882,
			"bd": 4,
			"bm": 3,
			"nm": "",
			"nf": "Magnolia",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/144188891",
			"id": 144188891,
			"lng": -77.38731971,
			"lat": 37.53745984,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 10,
			"dd": 23,
			"by": 1896,
			"bd": 24,
			"bm": 12,
			"nm": "",
			"nf": "Martha",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/164026272",
			"id": 164026272,
			"lng": -77.38762911,
			"lat": 37.53731123,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 5,
			"dd": 30,
			"by": 1874,
			"bd": 16,
			"bm": 8,
			"nm": "A.",
			"nf": "Martha",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/142464326",
			"id": 142464326,
			"lng": -77.38588095,
			"lat": 37.53728808,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 9,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/176240017",
			"id": 176240017,
			"lng": -77.3872682,
			"lat": 37.53702312,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 8,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Mary",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/166330812",
			"id": 166330812,
			"lng": -77.38700992,
			"lat": 37.53664614,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 3,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Ann",
			"nf": "Mary",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/168837061",
			"id": 168837061,
			"lng": -77.38667889,
			"lat": 37.5369365,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1984,
			"dm": 12,
			"dd": 3,
			"by": 1895,
			"bd": 6,
			"bm": 10,
			"nm": "Louise",
			"nf": "Mary",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/120610687",
			"id": 120610687,
			"lng": -77.38584915,
			"lat": 37.53657783,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 5,
			"dd": 23,
			"by": 1903,
			"bd": 4,
			"bm": 12,
			"nm": "Lillian",
			"nf": "Mary",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/142464403",
			"id": 142464403,
			"lng": -77.38588732,
			"lat": 37.53728913,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 11,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "V.",
			"nf": "Mattie",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/121796876",
			"id": 121796876,
			"lng": -77.38583996,
			"lat": 37.53653502,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 2,
			"dd": 13,
			"by": 1920,
			"bd": 15,
			"bm": 1,
			"nm": "",
			"nf": "Nannie",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/159859035",
			"id": 159859035,
			"lng": -77.38802699,
			"lat": 37.5374629,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 9,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Patsey",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/166327409",
			"id": 166327409,
			"lng": -77.38700544,
			"lat": 37.53664518,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 1,
			"dd": 14,
			"by": 1907,
			"bd": 7,
			"bm": 8,
			"nm": "",
			"nf": "Pearl",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/177468850",
			"id": 177468850,
			"lng": -77.38753666,
			"lat": 37.53732474,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1911,
			"dm": 3,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Ann",
			"nf": "Pinkie",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/154512041",
			"id": 154512041,
			"lng": -77.38642751,
			"lat": 37.53567486,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 12,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "P.",
			"nf": "Primus",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/130538964",
			"id": 130538964,
			"lng": -77.38651053,
			"lat": 37.53693662,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 5,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rachel",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/207174222",
			"id": 207174222,
			"lng": -77.38631079,
			"lat": 37.53573589,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 7,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rebecca",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/140290827",
			"id": 140290827,
			"lng": -77.38664389,
			"lat": 37.53550633,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 7,
			"dd": 5,
			"by": 1850,
			"bd": "",
			"bm": 12,
			"nm": "M.",
			"nf": "Rebecca",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/150792655",
			"id": 150792655,
			"lng": -77.38621798,
			"lat": 37.53562106,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 5,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rebecca",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/160277979",
			"id": 160277979,
			"lng": -77.3861316,
			"lat": 37.53639772,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 7,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Robert",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/174698024",
			"id": 174698024,
			"lng": -77.38758824,
			"lat": 37.53705364,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 9,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "James",
			"nf": "Robert",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/156126613",
			"id": 156126613,
			"lng": -77.38612496,
			"lat": 37.53694359,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 1,
			"dd": 6,
			"by": 1896,
			"bd": 6,
			"bm": 8,
			"nm": "Robinson",
			"nf": "Sallie",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/144143025",
			"id": 144143025,
			"lng": -77.38619339,
			"lat": 37.5373204,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 1,
			"dd": 13,
			"by": 1888,
			"bd": 21,
			"bm": 8,
			"nm": "Lee",
			"nf": "Sallie",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/136107621",
			"id": 136107621,
			"lng": -77.38610233,
			"lat": 37.53694736,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 12,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "G.",
			"nf": "Samuel",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/171697340",
			"id": 171697340,
			"lng": -77.3862273,
			"lat": 37.53589804,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 11,
			"dd": 10,
			"by": 1878,
			"bd": 8,
			"bm": 12,
			"nm": "Wyatt",
			"nf": "Thomas",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/155517984",
			"id": 155517984,
			"lng": -77.3873167,
			"lat": 37.53747035,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 1,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Thomas",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/166327211",
			"id": 166327211,
			"lng": -77.38701476,
			"lat": 37.53664687,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 6,
			"dd": 9,
			"by": 1870,
			"bd": 12,
			"bm": 3,
			"nm": "Lorenzo",
			"nf": "Thomas",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/142464409",
			"id": 142464409,
			"lng": -77.38589246,
			"lat": 37.53729068,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 10,
			"dd": 20,
			"by": 1914,
			"bd": 25,
			"bm": 11,
			"nm": "",
			"nf": "Victoria",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/177123348",
			"id": 177123348,
			"lng": -77.3867004,
			"lat": 37.53688809,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 2,
			"dd": 14,
			"by": 1895,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Virginia",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/145085212",
			"id": 145085212,
			"lng": -77.38791737,
			"lat": 37.53740458,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 2,
			"dd": 5,
			"by": 1888,
			"bd": 30,
			"bm": 5,
			"nm": "",
			"nf": "Walter",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/153512681",
			"id": 153512681,
			"lng": -77.38666639,
			"lat": 37.53720144,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 11,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "Walter",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/126772094",
			"id": 126772094,
			"lng": -77.38584763,
			"lat": 37.53651288,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 2,
			"dd": 20,
			"by": 1959,
			"bd": 26,
			"bm": 4,
			"nm": "L.",
			"nf": "Wayne",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/128672355",
			"id": 128672355,
			"lng": -77.38623333,
			"lat": 37.53664642,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 3,
			"dd": 16,
			"by": 1877,
			"bd": 25,
			"bm": 7,
			"nm": "Allen",
			"nf": "William",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/123119728",
			"id": 123119728,
			"lng": -77.38719921,
			"lat": 37.53751442,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 10,
			"dd": 9,
			"by": 1881,
			"bd": 13,
			"bm": 11,
			"nm": "",
			"nf": "William",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/166358216",
			"id": 166358216,
			"lng": -77.38704707,
			"lat": 37.53687229,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 4,
			"dd": 10,
			"by": 1843,
			"bd": "",
			"bm": 12,
			"nm": "Howard",
			"nf": "William",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/150677872",
			"id": 150677872,
			"lng": -77.38621001,
			"lat": 37.53562531,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 7,
			"dd": 23,
			"by": 1918,
			"bd": 18,
			"bm": 12,
			"nm": "Robert",
			"nf": "Wirt",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/121628052",
			"id": 121628052,
			"lng": -77.38582644,
			"lat": 37.53653994,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 3,
			"dd": 21,
			"by": 1885,
			"bd": 10,
			"bm": 10,
			"nm": "Robert",
			"nf": "Wirt",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/121628036",
			"id": 121628036,
			"lng": -77.38581352,
			"lat": 37.53656867,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 5,
			"dd": 11,
			"by": 1884,
			"bd": 21,
			"bm": 12,
			"nm": "C.",
			"nf": "Albert",
			"nl": "Jordan",
			"url": "https://findagrave.com/memorial/38456254",
			"id": 38456254,
			"lng": -77.38552538,
			"lat": 37.53715884,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 5,
			"dd": 21,
			"by": 1911,
			"bd": 5,
			"bm": 10,
			"nm": "",
			"nf": "Alice",
			"nl": "Jordan",
			"url": "https://findagrave.com/memorial/153512976",
			"id": 153512976,
			"lng": -77.38672167,
			"lat": 37.53731208,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 1,
			"dd": 5,
			"by": 1914,
			"bd": 28,
			"bm": 3,
			"nm": "",
			"nf": "Clarence",
			"nl": "Jordan",
			"url": "https://findagrave.com/memorial/167324570",
			"id": 167324570,
			"lng": -77.38684949,
			"lat": 37.53728593,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 7,
			"dd": 27,
			"by": 1860,
			"bd": 23,
			"bm": 12,
			"nm": "",
			"nf": "Fannie",
			"nl": "Jordan",
			"url": "https://findagrave.com/memorial/144820802",
			"id": 144820802,
			"lng": -77.38554466,
			"lat": 37.53716455,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 7,
			"dd": 18,
			"by": 1892,
			"bd": 2,
			"bm": 2,
			"nm": "",
			"nf": "Hester",
			"nl": "Jordan",
			"url": "https://findagrave.com/memorial/167324168",
			"id": 167324168,
			"lng": -77.38687774,
			"lat": 37.53728502,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 5,
			"dd": 15,
			"by": 1912,
			"bd": 26,
			"bm": 2,
			"nm": "Edward",
			"nf": "James",
			"nl": "Jordan",
			"url": "https://findagrave.com/memorial/167324948",
			"id": 167324948,
			"lng": -77.38687571,
			"lat": 37.53729089,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 11,
			"dd": 2,
			"by": 1915,
			"bd": 18,
			"bm": 4,
			"nm": "R. B.",
			"nf": "Katherleen",
			"nl": "Jordan",
			"url": "https://findagrave.com/memorial/145085220",
			"id": 145085220,
			"lng": -77.38619065,
			"lat": 37.53732835,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 4,
			"dd": 29,
			"by": 1893,
			"bd": 28,
			"bm": 2,
			"nm": "",
			"nf": "Lilia",
			"nl": "Jordan",
			"url": "https://findagrave.com/memorial/153512987",
			"id": 153512987,
			"lng": -77.38672083,
			"lat": 37.53731687,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 8,
			"dd": 16,
			"by": 1903,
			"bd": 15,
			"bm": 8,
			"nm": "Roosevelt",
			"nf": "Ralph",
			"nl": "Jordan",
			"url": "https://findagrave.com/memorial/144820813",
			"id": 144820813,
			"lng": -77.38553919,
			"lat": 37.53718313,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 7,
			"dd": 30,
			"by": 1892,
			"bd": 6,
			"bm": 7,
			"nm": "",
			"nf": "Rogers",
			"nl": "Jordan",
			"url": "https://findagrave.com/memorial/177969282",
			"id": 177969282,
			"lng": -77.38801515,
			"lat": 37.53754636,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 3,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Samuel",
			"nl": "Jordan",
			"url": "https://findagrave.com/memorial/158679165",
			"id": 158679165,
			"lng": -77.38692102,
			"lat": 37.53742452,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 12,
			"dd": 30,
			"by": 1890,
			"bd": 28,
			"bm": 5,
			"nm": "Reed",
			"nf": "Sylvanus",
			"nl": "Jordan",
			"url": "https://findagrave.com/memorial/153512993",
			"id": 153512993,
			"lng": -77.38672274,
			"lat": 37.5373067,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 3,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Virginia",
			"nl": "Jordan",
			"url": "https://findagrave.com/memorial/186817876",
			"id": 186817876,
			"lng": -77.38738196,
			"lat": 37.53771484,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 6,
			"dd": 5,
			"by": 1886,
			"bd": 14,
			"bm": 2,
			"nm": "",
			"nf": "Alexander",
			"nl": "Jordon",
			"url": "https://findagrave.com/memorial/142464414",
			"id": 142464414,
			"lng": -77.38560432,
			"lat": 37.53734179,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 9,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Parthenia",
			"nl": "Joyner",
			"url": "https://findagrave.com/memorial/154296516",
			"id": 154296516,
			"lng": -77.38693007,
			"lat": 37.53544159,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 11,
			"dd": 6,
			"by": 1885,
			"bd": 27,
			"bm": 9,
			"nm": "",
			"nf": "Florence",
			"nl": "Judkins",
			"url": "https://findagrave.com/memorial/125820828",
			"id": 125820828,
			"lng": -77.38625932,
			"lat": 37.535763,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 8,
			"dd": 2,
			"by": 1908,
			"bd": 7,
			"bm": 3,
			"nm": "",
			"nf": "Lennie",
			"nl": "Keel",
			"url": "https://findagrave.com/memorial/141658048",
			"id": 141658048,
			"lng": -77.38666701,
			"lat": 37.53728528,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1986,
			"dm": 7,
			"dd": 15,
			"by": 1910,
			"bd": 2,
			"bm": 10,
			"nm": "",
			"nf": "Ruth",
			"nl": "Keel",
			"url": "https://findagrave.com/memorial/141800945",
			"id": 141800945,
			"lng": -77.38667205,
			"lat": 37.53727582,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 10,
			"dd": 14,
			"by": 1948,
			"bd": 27,
			"bm": 7,
			"nm": "Edward",
			"nf": "Richard",
			"nl": "Keels",
			"url": "https://findagrave.com/memorial/173156234",
			"id": 173156234,
			"lng": -77.38698708,
			"lat": 37.53730432,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 11,
			"dd": 23,
			"by": 1889,
			"bd": 8,
			"bm": 12,
			"nm": "",
			"nf": "Jessie",
			"nl": "Kelly",
			"url": "https://findagrave.com/memorial/130378933",
			"id": 130378933,
			"lng": -77.38597288,
			"lat": 37.5367789,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 7,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Rebecca",
			"nf": "Ann",
			"nl": "Kemp",
			"url": "https://findagrave.com/memorial/170118952",
			"id": 170118952,
			"lng": -77.38602152,
			"lat": 37.53605197,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1911,
			"dm": 3,
			"dd": 17,
			"by": 1888,
			"bd": 25,
			"bm": 8,
			"nm": "Burgess",
			"nf": "C.",
			"nl": "Kemp",
			"url": "https://findagrave.com/memorial/143865722",
			"id": 143865722,
			"lng": -77.38599497,
			"lat": 37.53608545,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1906,
			"dm": 8,
			"dd": 17,
			"by": 1887,
			"bd": 3,
			"bm": 6,
			"nm": "P.",
			"nf": "Hattie",
			"nl": "Kemp",
			"url": "https://findagrave.com/memorial/156285970",
			"id": 156285970,
			"lng": -77.38606107,
			"lat": 37.5360653,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 5,
			"dd": 22,
			"by": 1890,
			"bd": 31,
			"bm": 7,
			"nm": "",
			"nf": "Minnie",
			"nl": "Kemp",
			"url": "https://findagrave.com/memorial/142526955",
			"id": 142526955,
			"lng": -77.38646772,
			"lat": 37.53538708,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 6,
			"dd": 2,
			"by": 1893,
			"bd": 19,
			"bm": 4,
			"nm": "Allen",
			"nf": "Sidney",
			"nl": "Kemp",
			"url": "https://findagrave.com/memorial/170119393",
			"id": 170119393,
			"lng": -77.3860265,
			"lat": 37.53605329,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 5,
			"dd": 25,
			"by": 1912,
			"bd": 30,
			"bm": 12,
			"nm": "E.",
			"nf": "Louise",
			"nl": "Kendrick",
			"url": "https://findagrave.com/memorial/125312997",
			"id": 125312997,
			"lng": -77.38590069,
			"lat": 37.53695824,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 3,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "David",
			"nl": "Kenney",
			"url": "https://findagrave.com/memorial/155529323",
			"id": 155529323,
			"lng": -77.38732629,
			"lat": 37.53554215,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 6,
			"dd": 17,
			"by": 1877,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rosa",
			"nl": "Kenney",
			"url": "https://findagrave.com/memorial/155529325",
			"id": 155529325,
			"lng": -77.38732488,
			"lat": 37.53552822,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 4,
			"dd": 20,
			"by": 1888,
			"bd": 9,
			"bm": 2,
			"nm": "",
			"nf": "Artelia",
			"nl": "Kenny",
			"url": "https://findagrave.com/memorial/187587286",
			"id": 187587286,
			"lng": -77.387723,
			"lat": 37.53704145,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 11,
			"dd": 6,
			"by": 1901,
			"bd": 14,
			"bm": 9,
			"nm": "Brown Ings",
			"nf": "Leonia",
			"nl": "Ketter",
			"url": "https://findagrave.com/memorial/154509725",
			"id": 154509725,
			"lng": -77.38639502,
			"lat": 37.53739856,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 7,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Belle",
			"nl": "Kimbrough",
			"url": "https://findagrave.com/memorial/185392968",
			"id": 185392968,
			"lng": -77.38735083,
			"lat": 37.53770393,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 4,
			"dd": 22,
			"by": 1917,
			"bd": 4,
			"bm": 5,
			"nm": "Virginia",
			"nf": "Ruth",
			"nl": "Kinder",
			"url": "https://findagrave.com/memorial/161179727",
			"id": 161179727,
			"lng": -77.38608136,
			"lat": 37.53631625,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 10,
			"dd": 24,
			"by": 1905,
			"bd": 3,
			"bm": 3,
			"nm": "",
			"nf": "David",
			"nl": "King",
			"url": "https://findagrave.com/memorial/150637819",
			"id": 150637819,
			"lng": -77.38651681,
			"lat": 37.53724581,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 4,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "King",
			"url": "https://findagrave.com/memorial/168728876",
			"id": 168728876,
			"lng": -77.38637433,
			"lat": 37.53713511,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 4,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Overton",
			"nf": "Ralph",
			"nl": "King",
			"url": "https://findagrave.com/memorial/144558533",
			"id": 144558533,
			"lng": -77.38651015,
			"lat": 37.53567048,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 2,
			"dd": 8,
			"by": 1901,
			"bd": 19,
			"bm": 8,
			"nm": "L.",
			"nf": "Rosa",
			"nl": "King",
			"url": "https://findagrave.com/memorial/141194103",
			"id": 141194103,
			"lng": -77.3863931,
			"lat": 37.53663409,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 9,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sarah",
			"nl": "King",
			"url": "https://findagrave.com/memorial/146013372",
			"id": 146013372,
			"lng": -77.38773093,
			"lat": 37.53674319,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 8,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sarah",
			"nl": "King",
			"url": "https://findagrave.com/memorial/173806185",
			"id": 173806185,
			"lng": -77.3874564,
			"lat": 37.53709247,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1911,
			"dm": 1,
			"dd": 21,
			"by": 1874,
			"bd": 15,
			"bm": 10,
			"nm": "",
			"nf": "Taylor",
			"nl": "King",
			"url": "https://findagrave.com/memorial/134359193",
			"id": 134359193,
			"lng": -77.3876185,
			"lat": 37.53659149,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 3,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Giles",
			"nl": "Kinney",
			"url": "https://findagrave.com/memorial/176983576",
			"id": 176983576,
			"lng": -77.38748592,
			"lat": 37.5355374,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 11,
			"dd": 27,
			"by": 1930,
			"bd": 31,
			"bm": 1,
			"nm": "Troy",
			"nf": "Levan",
			"nl": "Kirven",
			"url": "https://findagrave.com/memorial/159885809",
			"id": 159885809,
			"lng": -77.38802144,
			"lat": 37.53739551,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 2,
			"dd": 8,
			"by": 1890,
			"bd": 25,
			"bm": 12,
			"nm": "",
			"nf": "Annie",
			"nl": "Kittrell",
			"url": "https://findagrave.com/memorial/159973279",
			"id": 159973279,
			"lng": -77.386444,
			"lat": 37.53745776,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1987,
			"dm": 1,
			"dd": 24,
			"by": 1938,
			"bd": 5,
			"bm": 7,
			"nm": "S",
			"nf": "Preston",
			"nl": "Kittrell",
			"url": "https://findagrave.com/memorial/190318871",
			"id": 190318871,
			"lng": -77.38666353,
			"lat": 37.53730584,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 2,
			"dd": 17,
			"by": 1915,
			"bd": 18,
			"bm": 11,
			"nm": "Robert",
			"nf": "Elmore",
			"nl": "Knight",
			"url": "https://findagrave.com/memorial/76604953",
			"id": 76604953,
			"lng": -77.3861271,
			"lat": 37.53672309,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1990,
			"dm": 6,
			"dd": 7,
			"by": 1929,
			"bd": 5,
			"bm": 1,
			"nm": "F.",
			"nf": "George",
			"nl": "Knight",
			"url": "https://findagrave.com/memorial/76604961",
			"id": 76604961,
			"lng": -77.3861072,
			"lat": 37.53670732,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 11,
			"dd": 5,
			"by": 1887,
			"bd": 11,
			"bm": 5,
			"nm": "R.",
			"nf": "George",
			"nl": "Knight",
			"url": "https://findagrave.com/memorial/76604969",
			"id": 76604969,
			"lng": -77.38609216,
			"lat": 37.5367401,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1986,
			"dm": 8,
			"dd": 30,
			"by": 1895,
			"bd": 15,
			"bm": 8,
			"nm": "B.",
			"nf": "Mary",
			"nl": "Knight",
			"url": "https://findagrave.com/memorial/76604982",
			"id": 76604982,
			"lng": -77.3860964,
			"lat": 37.53673231,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 1,
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Willie",
			"nl": "Knight",
			"url": "https://findagrave.com/memorial/127131714",
			"id": 127131714,
			"lng": -77.38607095,
			"lat": 37.53638445,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": "",
			"dd": "",
			"by": 1917,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Earl",
			"nl": "Lancaster",
			"url": "https://findagrave.com/memorial/118206431",
			"id": 118206431,
			"lng": -77.38584378,
			"lat": 37.53671192,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 6,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "Lancaster",
			"url": "https://findagrave.com/memorial/118206473",
			"id": 118206473,
			"lng": -77.38586491,
			"lat": 37.53669764,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 4,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "N",
			"nf": "Mattie",
			"nl": "Laney",
			"url": "https://findagrave.com/memorial/170839546",
			"id": 170839546,
			"lng": -77.38652437,
			"lat": 37.53711153,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 12,
			"dd": 12,
			"by": 1880,
			"bd": 13,
			"bm": 3,
			"nm": "Montgomery",
			"nf": "Benjamin",
			"nl": "Langhorn",
			"url": "https://findagrave.com/memorial/149355154",
			"id": 149355154,
			"lng": -77.38618265,
			"lat": 37.53597092,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 8,
			"dd": 3,
			"by": 1855,
			"bd": 3,
			"bm": 5,
			"nm": "S.",
			"nf": "Walter",
			"nl": "Langhorn",
			"url": "https://findagrave.com/memorial/122786317",
			"id": 122786317,
			"lng": -77.38589267,
			"lat": 37.53646127,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1913,
			"dm": 7,
			"dd": 1,
			"by": 1857,
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "Cornelius",
			"nl": "Langhorne",
			"url": "https://findagrave.com/memorial/125820905",
			"id": 125820905,
			"lng": -77.38620257,
			"lat": 37.53597348,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 8,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "Martha",
			"nl": "Langhorne",
			"url": "https://findagrave.com/memorial/125820911",
			"id": 125820911,
			"lng": -77.38619936,
			"lat": 37.53597274,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 7,
			"dd": 24,
			"by": 1921,
			"bd": 20,
			"bm": 8,
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Langon",
			"url": "https://findagrave.com/memorial/187354576",
			"id": 187354576,
			"lng": -77.38725314,
			"lat": 37.53725255,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 3,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Angie",
			"nl": "Law",
			"url": "https://findagrave.com/memorial/175843484",
			"id": 175843484,
			"lng": -77.38771299,
			"lat": 37.53713107,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 7,
			"dd": 25,
			"by": 1889,
			"bd": 10,
			"bm": 5,
			"nm": "",
			"nf": "Elliott",
			"nl": "Lawrence",
			"url": "https://findagrave.com/memorial/184278331",
			"id": 184278331,
			"lng": -77.38702318,
			"lat": 37.53757073,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 3,
			"dd": 10,
			"by": 1917,
			"bd": 4,
			"bm": 7,
			"nm": "",
			"nf": "Raymond",
			"nl": "Lawrence",
			"url": "https://findagrave.com/memorial/155529327",
			"id": 155529327,
			"lng": -77.38753407,
			"lat": 37.5376257,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 3,
			"dd": 27,
			"by": 1938,
			"bd": 5,
			"bm": 4,
			"nm": "E.",
			"nf": "Ernest",
			"nl": "Lawson",
			"url": "https://findagrave.com/memorial/170815131",
			"id": 170815131,
			"lng": -77.38628849,
			"lat": 37.53676131,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 9,
			"dd": 23,
			"by": 1871,
			"bd": 1,
			"bm": 1,
			"nm": "",
			"nf": "Martha",
			"nl": "Lawson",
			"url": "https://findagrave.com/memorial/184094545",
			"id": 184094545,
			"lng": -77.38708727,
			"lat": 37.53753281,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 1,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "S.",
			"nf": "Mary",
			"nl": "Lawson",
			"url": "https://findagrave.com/memorial/146343903",
			"id": 146343903,
			"lng": -77.38635522,
			"lat": 37.53576714,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 12,
			"dd": 25,
			"by": 1874,
			"bd": 27,
			"bm": 4,
			"nm": "V.",
			"nf": "Queen",
			"nl": "Lawson",
			"url": "https://findagrave.com/memorial/141446419",
			"id": 141446419,
			"lng": -77.38736377,
			"lat": 37.53760202,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 6,
			"dd": 2,
			"by": 1909,
			"bd": 10,
			"bm": 7,
			"nm": "Hampton",
			"nf": "Wade",
			"nl": "Le Grand",
			"url": "https://findagrave.com/memorial/158463640",
			"id": 158463640,
			"lng": -77.38677395,
			"lat": 37.53760147,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 5,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Albert",
			"nl": "Lee",
			"url": "https://findagrave.com/memorial/125313009",
			"id": 125313009,
			"lng": -77.38555926,
			"lat": 37.5371939,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 12,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Staunton",
			"nf": "Alberta",
			"nl": "Lee",
			"url": "https://findagrave.com/memorial/160934046",
			"id": 160934046,
			"lng": -77.3866984,
			"lat": 37.53673983,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 11,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "D.",
			"nf": "Catherine",
			"nl": "Lee",
			"url": "https://findagrave.com/memorial/139424710",
			"id": 139424710,
			"lng": -77.38680216,
			"lat": 37.53686216,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 12,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Celeste",
			"nl": "Lee",
			"url": "https://findagrave.com/memorial/166116779",
			"id": 166116779,
			"lng": -77.38760059,
			"lat": 37.53678284,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 2,
			"dd": 12,
			"by": 1899,
			"bd": 4,
			"bm": 10,
			"nm": "Leslie",
			"nf": "Charles",
			"nl": "Lee",
			"url": "https://findagrave.com/memorial/155529330",
			"id": 155529330,
			"lng": -77.38740856,
			"lat": 37.53748382,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1909,
			"dm": 12,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Edward",
			"nl": "Lee",
			"url": "https://findagrave.com/memorial/170815005",
			"id": 170815005,
			"lng": -77.38620265,
			"lat": 37.5355865,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 12,
			"dd": 22,
			"by": 1882,
			"bd": 22,
			"bm": 9,
			"nm": "",
			"nf": "Effie",
			"nl": "Lee",
			"url": "https://findagrave.com/memorial/130693691",
			"id": 130693691,
			"lng": -77.38564586,
			"lat": 37.53695079,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 3,
			"dd": 20,
			"by": 1875,
			"bd": 10,
			"bm": 7,
			"nm": "Jane",
			"nf": "Elsie",
			"nl": "Lee",
			"url": "https://findagrave.com/memorial/173481988",
			"id": 173481988,
			"lng": -77.387558,
			"lat": 37.53710183,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 11,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Major",
			"nf": "Emanuel",
			"nl": "Lee",
			"url": "https://findagrave.com/memorial/185645591",
			"id": 185645591,
			"lng": -77.38777532,
			"lat": 37.53707068,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 5,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "John",
			"nl": "Lee",
			"url": "https://findagrave.com/memorial/177226658",
			"id": 177226658,
			"lng": -77.38756598,
			"lat": 37.53678603,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 10,
			"dd": 30,
			"by": 1894,
			"bd": 25,
			"bm": 5,
			"nm": "Francis",
			"nf": "John",
			"nl": "Lee",
			"url": "https://findagrave.com/memorial/173077010",
			"id": 173077010,
			"lng": -77.38702866,
			"lat": 37.53732965,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 12,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lelie",
			"nl": "Lee",
			"url": "https://findagrave.com/memorial/145638852",
			"id": 145638852,
			"lng": -77.38556275,
			"lat": 37.53718139,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 10,
			"dd": 19,
			"by": 1915,
			"bd": 15,
			"bm": 5,
			"nm": "",
			"nf": "Mamie",
			"nl": "Lee",
			"url": "https://findagrave.com/memorial/148285740",
			"id": 148285740,
			"lng": -77.38637482,
			"lat": 37.53717311,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 10,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Percy",
			"nl": "Lee",
			"url": "https://findagrave.com/memorial/144820821",
			"id": 144820821,
			"lng": -77.3855347,
			"lat": 37.53723418,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 7,
			"by": 1889,
			"bd": 26,
			"bm": 10,
			"nm": "E.",
			"nf": "Robert",
			"nl": "Lee",
			"url": "https://findagrave.com/memorial/175408957",
			"id": 175408957,
			"lng": -77.38736106,
			"lat": 37.53724689,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 1,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sweeter",
			"nl": "Lee",
			"url": "https://findagrave.com/memorial/181956334",
			"id": 181956334,
			"lng": -77.38774495,
			"lat": 37.536425,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 5,
			"dd": 12,
			"by": 1921,
			"bd": 8,
			"bm": 6,
			"nm": "",
			"nf": "Clarence",
			"nl": "Leeper",
			"url": "https://findagrave.com/memorial/141194116",
			"id": 141194116,
			"lng": -77.38637308,
			"lat": 37.53678099,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 4,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sadie",
			"nl": "Leeper",
			"url": "https://findagrave.com/memorial/188245142",
			"id": 188245142,
			"lng": -77.38804372,
			"lat": 37.53733926,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 5,
			"dd": 15,
			"by": 1900,
			"bd": 17,
			"bm": 12,
			"nm": "Coward",
			"nf": "Lucille",
			"nl": "Leftenant",
			"url": "https://findagrave.com/memorial/158678985",
			"id": 158678985,
			"lng": -77.38707537,
			"lat": 37.53747329,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 6,
			"dd": 26,
			"by": 1895,
			"bd": 2,
			"bm": 7,
			"nm": "Fred",
			"nf": "Thaddeus",
			"nl": "Leftenant",
			"url": "https://findagrave.com/memorial/158678825",
			"id": 158678825,
			"lng": -77.38707241,
			"lat": 37.53748106,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 12,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Milledge",
			"nl": "Leggs",
			"url": "https://findagrave.com/memorial/160934052",
			"id": 160934052,
			"lng": -77.38673785,
			"lat": 37.53674534,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 4,
			"dd": 30,
			"by": 1869,
			"bd": 12,
			"bm": 2,
			"nm": "Alice",
			"nf": "Mary",
			"nl": "Lemas",
			"url": "https://findagrave.com/memorial/154201513",
			"id": 154201513,
			"lng": -77.3872493,
			"lat": 37.53546347,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 1,
			"dd": 5,
			"by": 1889,
			"bd": 15,
			"bm": 6,
			"nm": "Philex",
			"nf": "Albert",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/145838755",
			"id": 145838755,
			"lng": -77.38655857,
			"lat": 37.53567536,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 8,
			"dd": 18,
			"by": 1919,
			"bd": 25,
			"bm": 12,
			"nm": "Mae",
			"nf": "Annie",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/159762336",
			"id": 159762336,
			"lng": -77.38642401,
			"lat": 37.53750908,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 5,
			"dd": 16,
			"by": 1918,
			"bd": 7,
			"bm": 9,
			"nm": "H.",
			"nf": "Charles",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/145325148",
			"id": 145325148,
			"lng": -77.38593616,
			"lat": 37.53629213,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 7,
			"dd": 11,
			"by": 1902,
			"bd": 1,
			"bm": 6,
			"nm": "",
			"nf": "Dora",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/150637825",
			"id": 150637825,
			"lng": -77.38633635,
			"lat": 37.53600471,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 3,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Grant",
			"nf": "Harvey",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/155027259",
			"id": 155027259,
			"lng": -77.38650379,
			"lat": 37.53566305,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 11,
			"dd": 7,
			"by": 1890,
			"bd": 23,
			"bm": 2,
			"nm": "",
			"nf": "Hettie",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/128672366",
			"id": 128672366,
			"lng": -77.38742417,
			"lat": 37.53750145,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 11,
			"dd": 13,
			"by": 1962,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Janet",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/159414581",
			"id": 159414581,
			"lng": -77.38617464,
			"lat": 37.53752302,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 8,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/159886270",
			"id": 159886270,
			"lng": -77.38791123,
			"lat": 37.53765436,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 5,
			"dd": 12,
			"by": 1862,
			"bd": 27,
			"bm": 9,
			"nm": "Oliver",
			"nf": "John",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/149561058",
			"id": 149561058,
			"lng": -77.38626024,
			"lat": 37.53597245,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 1,
			"dd": 1,
			"by": 1917,
			"bd": 18,
			"bm": 9,
			"nm": "A.",
			"nf": "John",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/144143918",
			"id": 144143918,
			"lng": -77.38623094,
			"lat": 37.53741611,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 11,
			"dd": 29,
			"by": 1885,
			"bd": 25,
			"bm": 5,
			"nm": "Edward",
			"nf": "John",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/125313042",
			"id": 125313042,
			"lng": -77.38590221,
			"lat": 37.53687834,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 8,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Kate",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/141446446",
			"id": 141446446,
			"lng": -77.38737265,
			"lat": 37.53778991,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 2,
			"dd": 14,
			"by": 1870,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Kate",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/149561068",
			"id": 149561068,
			"lng": -77.38625948,
			"lat": 37.53597934,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 8,
			"dd": 9,
			"by": 1893,
			"bd": "",
			"bm": "",
			"nm": "S.",
			"nf": "Leroy",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/166383668",
			"id": 166383668,
			"lng": -77.38760846,
			"lat": 37.5367084,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 4,
			"dd": 15,
			"by": 1891,
			"bd": 3,
			"bm": 11,
			"nm": "",
			"nf": "Lettie",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/155529333",
			"id": 155529333,
			"lng": -77.3875335,
			"lat": 37.53748672,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 10,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Luvenia",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/125820926",
			"id": 125820926,
			"lng": -77.38626191,
			"lat": 37.53596201,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 7,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/151049343",
			"id": 151049343,
			"lng": -77.38707931,
			"lat": 37.53559621,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 7,
			"dd": 5,
			"by": 1948,
			"bd": 12,
			"bm": 11,
			"nm": "Alice",
			"nf": "Mary",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/139424718",
			"id": 139424718,
			"lng": -77.38673172,
			"lat": 37.53680189,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 7,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Nathaniel",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/150038034",
			"id": 150038034,
			"lng": -77.38691299,
			"lat": 37.5357404,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": "",
			"dd": "",
			"by": 1912,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rebecca",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/145085226",
			"id": 145085226,
			"lng": -77.38741761,
			"lat": 37.53788643,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1904,
			"dm": 4,
			"dd": 17,
			"by": 1891,
			"bd": 1,
			"bm": 7,
			"nm": "S.",
			"nf": "Robert",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/125408674",
			"id": 125408674,
			"lng": -77.38760391,
			"lat": 37.53673091,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 8,
			"dd": 23,
			"by": 1963,
			"bd": 21,
			"bm": 8,
			"nm": "Ronnell",
			"nf": "Ronald",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/159414599",
			"id": 159414599,
			"lng": -77.38609575,
			"lat": 37.53748785,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 5,
			"dd": 23,
			"by": 1909,
			"bd": 2,
			"bm": 11,
			"nm": "",
			"nf": "Rosetta",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/152794735",
			"id": 152794735,
			"lng": -77.38590633,
			"lat": 37.53745587,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 12,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ryland",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/146682163",
			"id": 146682163,
			"lng": -77.38622417,
			"lat": 37.53586047,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1912,
			"dm": 12,
			"dd": 29,
			"by": 1870,
			"bd": 17,
			"bm": 5,
			"nm": "L.",
			"nf": "Samuel",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/157165343",
			"id": 157165343,
			"lng": -77.38646816,
			"lat": 37.53587492,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 1,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Ann",
			"nf": "Sarah",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/146682164",
			"id": 146682164,
			"lng": -77.38622381,
			"lat": 37.53586386,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 11,
			"dd": 26,
			"by": 1903,
			"bd": 6,
			"bm": 7,
			"nm": "",
			"nf": "Siles",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/160048193",
			"id": 160048193,
			"lng": -77.38647127,
			"lat": 37.5374806,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 4,
			"dd": 8,
			"by": 1870,
			"bd": 24,
			"bm": 12,
			"nm": "",
			"nf": "Tom",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/141194127",
			"id": 141194127,
			"lng": -77.38633191,
			"lat": 37.53673017,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 8,
			"dd": 7,
			"by": 1953,
			"bd": 6,
			"bm": 8,
			"nm": "",
			"nf": "Walter",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/175820492",
			"id": 175820492,
			"lng": -77.38643935,
			"lat": 37.53676734,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 10,
			"dd": 27,
			"by": 1918,
			"bd": 16,
			"bm": 10,
			"nm": "",
			"nf": "Welton",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/187354583",
			"id": 187354583,
			"lng": -77.38743319,
			"lat": 37.53749037,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 7,
			"dd": 16,
			"by": 1905,
			"bd": 12,
			"bm": 12,
			"nm": "",
			"nf": "Elliott",
			"nl": "Libron",
			"url": "https://findagrave.com/memorial/133137510",
			"id": 133137510,
			"lng": -77.3869788,
			"lat": 37.53706357,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1905,
			"dm": 10,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Frances",
			"nl": "Liggons",
			"url": "https://findagrave.com/memorial/155529341",
			"id": 155529341,
			"lng": -77.38701701,
			"lat": 37.53640998,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 4,
			"dd": 6,
			"by": 1919,
			"bd": 30,
			"bm": 8,
			"nm": "",
			"nf": "James",
			"nl": "Liggon",
			"url": "https://findagrave.com/memorial/183587462",
			"id": 183587462,
			"lng": -77.38664346,
			"lat": 37.53709604,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 11,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jesse",
			"nl": "Light",
			"url": "https://findagrave.com/memorial/123587202",
			"id": 123587202,
			"lng": -77.38578518,
			"lat": 37.5369087,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 6,
			"dd": 11,
			"by": 1907,
			"bd": 25,
			"bm": 11,
			"nm": "Bernard",
			"nf": "George",
			"nl": "Lindsay",
			"url": "https://findagrave.com/memorial/152527314",
			"id": 152527314,
			"lng": -77.38583583,
			"lat": 37.53722722,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 7,
			"dd": 5,
			"by": 1883,
			"bd": 16,
			"bm": 10,
			"nm": "Henry",
			"nf": "William",
			"nl": "Lindsay",
			"url": "https://findagrave.com/memorial/142468273",
			"id": 142468273,
			"lng": -77.38581257,
			"lat": 37.53723348,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 10,
			"dd": 14,
			"by": 1817,
			"bd": "",
			"bm": 9,
			"nm": "",
			"nf": "Caroline",
			"nl": "Lindsey",
			"url": "https://findagrave.com/memorial/151945883",
			"id": 151945883,
			"lng": -77.38661337,
			"lat": 37.53572923,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 6,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Clarence",
			"nl": "Linson",
			"url": "https://findagrave.com/memorial/186818175",
			"id": 186818175,
			"lng": -77.38758979,
			"lat": 37.53708953,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 5,
			"dd": 15,
			"by": 1920,
			"bd": 21,
			"bm": 1,
			"nm": "James",
			"nf": "Robert",
			"nl": "Lipscombe",
			"url": "https://findagrave.com/memorial/156929080",
			"id": 156929080,
			"lng": -77.38642621,
			"lat": 37.53715305,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 1,
			"dd": 18,
			"by": 1904,
			"bd": 25,
			"bm": 10,
			"nm": "Jo",
			"nf": "Artie",
			"nl": "Lloyd",
			"url": "https://findagrave.com/memorial/143865729",
			"id": 143865729,
			"lng": -77.38596171,
			"lat": 37.53723021,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 6,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Lloyd",
			"url": "https://findagrave.com/memorial/176529368",
			"id": 176529368,
			"lng": -77.38801455,
			"lat": 37.53761883,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 10,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Joseph",
			"nl": "Lloyd",
			"url": "https://findagrave.com/memorial/144143928",
			"id": 144143928,
			"lng": -77.38595623,
			"lat": 37.53723987,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 12,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Locket",
			"url": "https://findagrave.com/memorial/188298789",
			"id": 188298789,
			"lng": -77.38794865,
			"lat": 37.53708652,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 12,
			"dd": 17,
			"by": 1904,
			"bd": 28,
			"bm": 10,
			"nm": "",
			"nf": "Edward",
			"nl": "Lockett",
			"url": "https://findagrave.com/memorial/138567137",
			"id": 138567137,
			"lng": -77.38650882,
			"lat": 37.53690928,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 11,
			"dd": 10,
			"by": 1900,
			"bd": 4,
			"bm": 7,
			"nm": "",
			"nf": "William",
			"nl": "Lockhart",
			"url": "https://findagrave.com/memorial/178249246",
			"id": 178249246,
			"lng": -77.38759952,
			"lat": 37.53744395,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "George",
			"nl": "Lofton",
			"url": "https://findagrave.com/memorial/175585502",
			"id": 175585502,
			"lng": -77.38722261,
			"lat": 37.53654949,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": 1,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nellie",
			"nl": "Lofton",
			"url": "https://findagrave.com/memorial/175585515",
			"id": 175585515,
			"lng": -77.38698857,
			"lat": 37.53624852,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 11,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Logan",
			"url": "https://findagrave.com/memorial/145638853",
			"id": 145638853,
			"lng": -77.38632529,
			"lat": 37.53739023,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1911,
			"dm": 12,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "Lewis",
			"nl": "Lomax",
			"url": "https://findagrave.com/memorial/158626752",
			"id": 158626752,
			"lng": -77.38668121,
			"lat": 37.53570351,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 6,
			"dd": 1,
			"by": 1882,
			"bd": 31,
			"bm": 3,
			"nm": "",
			"nf": "Mary",
			"nl": "Lomax",
			"url": "https://findagrave.com/memorial/158924508",
			"id": 158924508,
			"lng": -77.38753339,
			"lat": 37.53757836,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 8,
			"dd": 5,
			"by": 1888,
			"bd": 7,
			"bm": 7,
			"nm": "H.",
			"nf": "Millard",
			"nl": "Lomax",
			"url": "https://findagrave.com/memorial/158924509",
			"id": 158924509,
			"lng": -77.38753697,
			"lat": 37.53757904,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 8,
			"dd": 18,
			"by": 1931,
			"bd": 17,
			"bm": 1,
			"nm": "",
			"nf": "Arlene",
			"nl": "Long",
			"url": "https://findagrave.com/memorial/181401042",
			"id": 181401042,
			"lng": -77.38623566,
			"lat": 37.53681037,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 8,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Love",
			"url": "https://findagrave.com/memorial/114399874",
			"id": 114399874,
			"lng": -77.38571646,
			"lat": 37.53680456,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": 4,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Henry",
			"nf": "William",
			"nl": "Loving",
			"url": "https://findagrave.com/memorial/171769798",
			"id": 171769798,
			"lng": -77.38720752,
			"lat": 37.53666997,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 1,
			"dd": 11,
			"by": 1875,
			"bd": 1,
			"bm": 2,
			"nm": "",
			"nf": "Lillie",
			"nl": "Lovings",
			"url": "https://findagrave.com/memorial/149439667",
			"id": 149439667,
			"lng": -77.38617718,
			"lat": 37.5360055,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 10,
			"dd": 29,
			"by": 1902,
			"bd": 7,
			"bm": 3,
			"nm": "A.",
			"nf": "Leslie",
			"nl": "Lucas",
			"url": "https://findagrave.com/memorial/144143931",
			"id": 144143931,
			"lng": -77.38647925,
			"lat": 37.53743586,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 2,
			"dd": 16,
			"by": 1889,
			"bd": 27,
			"bm": 11,
			"nm": "",
			"nf": "Martha",
			"nl": "Lucas",
			"url": "https://findagrave.com/memorial/179570202",
			"id": 179570202,
			"lng": -77.38794149,
			"lat": 37.53775442,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 8,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Matthew",
			"nl": "Lucas",
			"url": "https://findagrave.com/memorial/151108236",
			"id": 151108236,
			"lng": -77.3867193,
			"lat": 37.53565316,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 4,
			"dd": 18,
			"by": 1906,
			"bd": 2,
			"bm": 2,
			"nm": "",
			"nf": "Fannie",
			"nl": "Lucky",
			"url": "https://findagrave.com/memorial/184477064",
			"id": 184477064,
			"lng": -77.38794512,
			"lat": 37.53697402,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 3,
			"dd": 9,
			"by": 1918,
			"bd": 6,
			"bm": 12,
			"nm": "Izear",
			"nf": "James",
			"nl": "Lyons",
			"url": "https://findagrave.com/memorial/150349046",
			"id": 150349046,
			"lng": -77.38571183,
			"lat": 37.53712464,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 11,
			"dd": 21,
			"by": 1922,
			"bd": 5,
			"bm": 9,
			"nm": "",
			"nf": "Rosa",
			"nl": "Lyons",
			"url": "https://findagrave.com/memorial/154228754",
			"id": 154228754,
			"lng": -77.38634358,
			"lat": 37.53742563,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1984,
			"dm": 3,
			"dd": 3,
			"by": 1901,
			"bd": 4,
			"bm": 10,
			"nm": "",
			"nf": "Annie",
			"nl": "Mack",
			"url": "https://findagrave.com/memorial/153512997",
			"id": 153512997,
			"lng": -77.38670494,
			"lat": 37.53722455,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 6,
			"dd": 12,
			"by": 1885,
			"bd": 7,
			"bm": 6,
			"nm": "",
			"nf": "Bonnie",
			"nl": "Mack",
			"url": "https://findagrave.com/memorial/187366457",
			"id": 187366457,
			"lng": -77.38727343,
			"lat": 37.53728082,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 10,
			"dd": 17,
			"by": 1899,
			"bd": 22,
			"bm": 1,
			"nm": "",
			"nf": "Flegg",
			"nl": "Mack",
			"url": "https://findagrave.com/memorial/141924953",
			"id": 141924953,
			"lng": -77.38670503,
			"lat": 37.53721331,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 1,
			"dd": 31,
			"by": 1904,
			"bd": 15,
			"bm": 5,
			"nm": "",
			"nf": "Livingston",
			"nl": "Mack",
			"url": "https://findagrave.com/memorial/160335435",
			"id": 160335435,
			"lng": -77.38608672,
			"lat": 37.53633252,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 12,
			"dd": 14,
			"by": 1885,
			"bd": 30,
			"bm": 8,
			"nm": "",
			"nf": "Mollie",
			"nl": "Majors",
			"url": "https://findagrave.com/memorial/146019955",
			"id": 146019955,
			"lng": -77.38673795,
			"lat": 37.5357494,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 12,
			"dd": 14,
			"by": 1861,
			"bd": "",
			"bm": 3,
			"nm": "",
			"nf": "Henry",
			"nl": "Mallory",
			"url": "https://findagrave.com/memorial/113626488",
			"id": 113626488,
			"lng": -77.38642901,
			"lat": 37.5365137,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 3,
			"dd": 1,
			"by": 1897,
			"bd": 31,
			"bm": 1,
			"nm": "",
			"nf": "Henry",
			"nl": "Mallory",
			"url": "https://findagrave.com/memorial/138926465",
			"id": 138926465,
			"lng": -77.38642175,
			"lat": 37.53652992,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 11,
			"dd": 20,
			"by": 1898,
			"bd": 15,
			"bm": 6,
			"nm": "Bell",
			"nf": "Lula",
			"nl": "Mallory",
			"url": "https://findagrave.com/memorial/127881088",
			"id": 127881088,
			"lng": -77.38638273,
			"lat": 37.53652182,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 3,
			"dd": 14,
			"by": 1875,
			"bd": "",
			"bm": 4,
			"nm": "",
			"nf": "Lula",
			"nl": "Mallory",
			"url": "https://findagrave.com/memorial/127881085",
			"id": 127881085,
			"lng": -77.38638752,
			"lat": 37.53650345,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 11,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Adolphus",
			"nl": "Malone",
			"url": "https://findagrave.com/memorial/135631994",
			"id": 135631994,
			"lng": -77.38609959,
			"lat": 37.53708016,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 4,
			"dd": 27,
			"by": 1925,
			"bd": 15,
			"bm": 6,
			"nm": "Alvin",
			"nf": "James",
			"nl": "Malone",
			"url": "https://findagrave.com/memorial/152794739",
			"id": 152794739,
			"lng": -77.38699264,
			"lat": 37.53744555,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 9,
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "N.",
			"nf": "Charles",
			"nl": "Mangum",
			"url": "https://findagrave.com/memorial/153899323",
			"id": 153899323,
			"lng": -77.38653303,
			"lat": 37.53739475,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 7,
			"dd": 6,
			"by": 1877,
			"bd": 15,
			"bm": 12,
			"nm": "Hiram",
			"nf": "James",
			"nl": "Mann",
			"url": "https://findagrave.com/memorial/156126621",
			"id": 156126621,
			"lng": -77.38599492,
			"lat": 37.53703389,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 8,
			"dd": 16,
			"by": 1918,
			"bd": 6,
			"bm": 6,
			"nm": "",
			"nf": "Roosevelt",
			"nl": "Manning",
			"url": "https://findagrave.com/memorial/154199631",
			"id": 154199631,
			"lng": -77.38633539,
			"lat": 37.53525876,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 8,
			"dd": 4,
			"by": 1880,
			"bd": 25,
			"bm": 12,
			"nm": "",
			"nf": "Lewis",
			"nl": "Manson",
			"url": "https://findagrave.com/memorial/157622958",
			"id": 157622958,
			"lng": -77.38674188,
			"lat": 37.53744845,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 2,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Roberta",
			"nl": "Manson",
			"url": "https://findagrave.com/memorial/175328218",
			"id": 175328218,
			"lng": -77.38741551,
			"lat": 37.53703942,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 1,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Luvenia",
			"nl": "Marks",
			"url": "https://findagrave.com/memorial/147853440",
			"id": 147853440,
			"lng": -77.38636767,
			"lat": 37.53719237,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 3,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Frank",
			"nl": "Marshall",
			"url": "https://findagrave.com/memorial/177153442",
			"id": 177153442,
			"lng": -77.38794907,
			"lat": 37.53704447,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 1,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Hezekiah",
			"nl": "Marshall",
			"url": "https://findagrave.com/memorial/149696161",
			"id": 149696161,
			"lng": -77.38687089,
			"lat": 37.53669915,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 12,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Annie",
			"nl": "Marshalle",
			"url": "https://findagrave.com/memorial/177768011",
			"id": 177768011,
			"lng": -77.38782925,
			"lat": 37.53758909,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 7,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Martin",
			"url": "https://findagrave.com/memorial/173793337",
			"id": 173793337,
			"lng": -77.38723555,
			"lat": 37.53728548,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 11,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bettie",
			"nl": "Mason",
			"url": "https://findagrave.com/memorial/170100400",
			"id": 170100400,
			"lng": -77.38744241,
			"lat": 37.53679105,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 11,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Della",
			"nl": "Mason",
			"url": "https://findagrave.com/memorial/188104576",
			"id": 188104576,
			"lng": -77.38568655,
			"lat": 37.53694037,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 7,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Mason",
			"url": "https://findagrave.com/memorial/155734904",
			"id": 155734904,
			"lng": -77.38726375,
			"lat": 37.53549294,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 2,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Kirk",
			"nl": "Mason",
			"url": "https://findagrave.com/memorial/151459499",
			"id": 151459499,
			"lng": -77.38804708,
			"lat": 37.53730737,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 9,
			"dd": 3,
			"by": 1868,
			"bd": "",
			"bm": "",
			"nm": "F.",
			"nf": "Walter",
			"nl": "Mason",
			"url": "https://findagrave.com/memorial/155735363",
			"id": 155735363,
			"lng": -77.38726036,
			"lat": 37.53550903,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 9,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "William",
			"nl": "Mason",
			"url": "https://findagrave.com/memorial/155731348",
			"id": 155731348,
			"lng": -77.38726544,
			"lat": 37.53549854,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 1,
			"dd": 15,
			"by": 1850,
			"bd": 1,
			"bm": 1,
			"nm": "A.",
			"nf": "William",
			"nl": "Mason",
			"url": "https://findagrave.com/memorial/172034068",
			"id": 172034068,
			"lng": -77.38717143,
			"lat": 37.53666325,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 6,
			"dd": 30,
			"by": 1907,
			"bd": 1,
			"bm": 11,
			"nm": "L.",
			"nf": "Lillian",
			"nl": "Massenberg",
			"url": "https://findagrave.com/memorial/170567287",
			"id": 170567287,
			"lng": -77.38596575,
			"lat": 37.53627048,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 4,
			"dd": 2,
			"by": 1904,
			"bd": 25,
			"bm": 4,
			"nm": "John",
			"nf": "Renes",
			"nl": "Massey",
			"url": "https://findagrave.com/memorial/145085234",
			"id": 145085234,
			"lng": -77.38615505,
			"lat": 37.53732199,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1905,
			"dm": 9,
			"dd": 20,
			"by": 1873,
			"bd": 9,
			"bm": 10,
			"nm": "",
			"nf": "Rosa",
			"nl": "Massey",
			"url": "https://findagrave.com/memorial/125408689",
			"id": 125408689,
			"lng": -77.38781084,
			"lat": 37.53641966,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 1,
			"dd": 16,
			"by": 1922,
			"bd": 23,
			"bm": 7,
			"nm": "H.",
			"nf": "Thomas",
			"nl": "Massie",
			"url": "https://findagrave.com/memorial/161179741",
			"id": 161179741,
			"lng": -77.38608557,
			"lat": 37.53631527,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 2,
			"dd": 5,
			"by": 1886,
			"bd": 16,
			"bm": 1,
			"nm": "",
			"nf": "Edward",
			"nl": "Mathews",
			"url": "https://findagrave.com/memorial/160981229",
			"id": 160981229,
			"lng": -77.38692157,
			"lat": 37.53699011,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 2,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Laura",
			"nl": "Matthew",
			"url": "https://findagrave.com/memorial/187366462",
			"id": 187366462,
			"lng": -77.38779436,
			"lat": 37.53711981,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 8,
			"dd": 11,
			"by": 1884,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Malachi",
			"nl": "Matthews",
			"url": "https://findagrave.com/memorial/155781968",
			"id": 155781968,
			"lng": -77.38722667,
			"lat": 37.53563706,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 10,
			"dd": 12,
			"by": 1887,
			"bd": 22,
			"bm": 1,
			"nm": "",
			"nf": "William",
			"nl": "Mayes",
			"url": "https://findagrave.com/memorial/130426346",
			"id": 130426346,
			"lng": -77.38579281,
			"lat": 37.53692911,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 11,
			"dd": 13,
			"by": 1893,
			"bd": 27,
			"bm": 9,
			"nm": "",
			"nf": "Winston",
			"nl": "Maynard",
			"url": "https://findagrave.com/memorial/172041083",
			"id": 172041083,
			"lng": -77.38691682,
			"lat": 37.53723871,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 1,
			"dd": 19,
			"by": 1892,
			"bd": "",
			"bm": "",
			"nm": "Lee",
			"nf": "Carrie",
			"nl": "Mayo",
			"url": "https://findagrave.com/memorial/142221500",
			"id": 142221500,
			"lng": -77.38740556,
			"lat": 37.53793066,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 8,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Edward",
			"nf": "James",
			"nl": "Mayo",
			"url": "https://findagrave.com/memorial/153410145",
			"id": 153410145,
			"lng": -77.38576951,
			"lat": 37.53685371,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1906,
			"dm": 11,
			"dd": 25,
			"by": 1870,
			"bd": 4,
			"bm": 7,
			"nm": "R.",
			"nf": "Thaddeus",
			"nl": "Mayo",
			"url": "https://findagrave.com/memorial/149201617",
			"id": 149201617,
			"lng": -77.3860182,
			"lat": 37.53608778,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 8,
			"dd": 23,
			"by": 1904,
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "Ulrich",
			"nl": "Mayo",
			"url": "https://findagrave.com/memorial/144820832",
			"id": 144820832,
			"lng": -77.38692937,
			"lat": 37.53666283,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 11,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Whitsell",
			"nf": "Willie",
			"nl": "Mayo",
			"url": "https://findagrave.com/memorial/175449457",
			"id": 175449457,
			"lng": -77.38747229,
			"lat": 37.53702769,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 1,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Carrie",
			"nl": "McCain",
			"url": "https://findagrave.com/memorial/160277986",
			"id": 160277986,
			"lng": -77.3860444,
			"lat": 37.5363664,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 10,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "McCall",
			"url": "https://findagrave.com/memorial/176228191",
			"id": 176228191,
			"lng": -77.3862803,
			"lat": 37.53752198,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 12,
			"dd": 29,
			"by": 1880,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sarah",
			"nl": "McCall",
			"url": "https://findagrave.com/memorial/161180424",
			"id": 161180424,
			"lng": -77.38720034,
			"lat": 37.53718016,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 5,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Robert",
			"nl": "McCargo",
			"url": "https://findagrave.com/memorial/173844919",
			"id": 173844919,
			"lng": -77.38757393,
			"lat": 37.53710879,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": 12,
			"dd": 9,
			"by": 1867,
			"bd": 12,
			"bm": 6,
			"nm": "C.",
			"nf": "E.",
			"nl": "McCarmack",
			"url": "https://findagrave.com/memorial/138926508",
			"id": 138926508,
			"lng": -77.38633613,
			"lat": 37.53656543,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": "",
			"dd": "",
			"by": 1900,
			"bd": "",
			"bm": "",
			"nm": "S.",
			"nf": "Mildred",
			"nl": "McClair",
			"url": "https://findagrave.com/memorial/188810629",
			"id": 188810629,
			"lng": -77.3880096,
			"lat": 37.53705465,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 5,
			"dd": 10,
			"by": 1925,
			"bd": 20,
			"bm": 2,
			"nm": "Roosevelt",
			"nf": "Theodore",
			"nl": "McClure",
			"url": "https://findagrave.com/memorial/130378945",
			"id": 130378945,
			"lng": -77.38659518,
			"lat": 37.53692789,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 11,
			"dd": 14,
			"by": 1916,
			"bd": 9,
			"bm": 4,
			"nm": "",
			"nf": "Laborn",
			"nl": "McCoy",
			"url": "https://findagrave.com/memorial/120726073",
			"id": 120726073,
			"lng": -77.38566633,
			"lat": 37.53689988,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 4,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Graves",
			"nf": "Bettie",
			"nl": "McCraw",
			"url": "https://findagrave.com/memorial/185151335",
			"id": 185151335,
			"lng": -77.38773094,
			"lat": 37.53650171,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 6,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Richard",
			"nl": "McCraw",
			"url": "https://findagrave.com/memorial/185151350",
			"id": 185151350,
			"lng": -77.3877333,
			"lat": 37.5364772,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 4,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Carrie",
			"nl": "McCullough",
			"url": "https://findagrave.com/memorial/157314046",
			"id": 157314046,
			"lng": -77.38663402,
			"lat": 37.53686372,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 12,
			"dd": 17,
			"by": 1904,
			"bd": 17,
			"bm": 2,
			"nm": "",
			"nf": "James",
			"nl": "McDaniel",
			"url": "https://findagrave.com/memorial/144143936",
			"id": 144143936,
			"lng": -77.38625536,
			"lat": 37.53739726,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 5,
			"dd": 11,
			"by": 1951,
			"bd": 8,
			"bm": 3,
			"nm": "",
			"nf": "James",
			"nl": "McDaniel",
			"url": "https://findagrave.com/memorial/142797051",
			"id": 142797051,
			"lng": -77.38604474,
			"lat": 37.53735988,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 5,
			"dd": 24,
			"by": 1919,
			"bd": 2,
			"bm": 5,
			"nm": "Elizabeth",
			"nf": "Mabel",
			"nl": "McDaniel",
			"url": "https://findagrave.com/memorial/172999604",
			"id": 172999604,
			"lng": -77.38697027,
			"lat": 37.53732588,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 11,
			"dd": 14,
			"by": 1887,
			"bd": 21,
			"bm": 12,
			"nm": "",
			"nf": "Novella",
			"nl": "Mcginnis",
			"url": "https://findagrave.com/memorial/173793352",
			"id": 173793352,
			"lng": -77.3869619,
			"lat": 37.53729388,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 8,
			"dd": 30,
			"by": 1954,
			"bd": 1,
			"bm": 5,
			"nm": "",
			"nf": "Manuel",
			"nl": "McGowan",
			"url": "https://findagrave.com/memorial/152412745",
			"id": 152412745,
			"lng": -77.38697393,
			"lat": 37.53737717,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 9,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Thomas",
			"nl": "McGriff",
			"url": "https://findagrave.com/memorial/154509451",
			"id": 154509451,
			"lng": -77.38648071,
			"lat": 37.53570649,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 10,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Fannie",
			"nl": "McKee",
			"url": "https://findagrave.com/memorial/145167328",
			"id": 145167328,
			"lng": -77.38629926,
			"lat": 37.53710234,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 10,
			"dd": 18,
			"by": 1879,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Esther",
			"nl": "McLane",
			"url": "https://findagrave.com/memorial/144370353",
			"id": 144370353,
			"lng": -77.38734846,
			"lat": 37.53784146,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 11,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "McLane",
			"url": "https://findagrave.com/memorial/155814937",
			"id": 155814937,
			"lng": -77.38747627,
			"lat": 37.53695129,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 9,
			"dd": 25,
			"by": 1922,
			"bd": 5,
			"bm": 4,
			"nm": "Mae",
			"nf": "Cora",
			"nl": "McLaughlin",
			"url": "https://findagrave.com/memorial/184483109",
			"id": 184483109,
			"lng": -77.38718045,
			"lat": 37.53759478,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 6,
			"dd": 28,
			"by": 1931,
			"bd": 17,
			"bm": 11,
			"nm": "Delores Everett",
			"nf": "Lillian",
			"nl": "McLean",
			"url": "https://findagrave.com/memorial/125634297",
			"id": 125634297,
			"lng": -77.38612074,
			"lat": 37.5370708,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 8,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jannie",
			"nl": "McMillian",
			"url": "https://findagrave.com/memorial/189488573",
			"id": 189488573,
			"lng": -77.38789372,
			"lat": 37.53769156,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 12,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucy",
			"nl": "McNair",
			"url": "https://findagrave.com/memorial/144370363",
			"id": 144370363,
			"lng": -77.38732543,
			"lat": 37.53781102,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 9,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Walter",
			"nl": "McNeir",
			"url": "https://findagrave.com/memorial/167182293",
			"id": 167182293,
			"lng": -77.38677756,
			"lat": 37.53682261,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 11,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "N.",
			"nf": "James",
			"nl": "McPherson",
			"url": "https://findagrave.com/memorial/139146901",
			"id": 139146901,
			"lng": -77.38785752,
			"lat": 37.53698466,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 1,
			"dd": 27,
			"by": 1916,
			"bd": 27,
			"bm": 12,
			"nm": "Isabelle",
			"nf": "Nannie",
			"nl": "McPherson",
			"url": "https://findagrave.com/memorial/175328233",
			"id": 175328233,
			"lng": -77.3874014,
			"lat": 37.53704581,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 6,
			"dd": 12,
			"by": 1879,
			"bd": "",
			"bm": "",
			"nm": "Arthur",
			"nf": "Fred",
			"nl": "McRae",
			"url": "https://findagrave.com/memorial/155531201",
			"id": 155531201,
			"lng": -77.38752634,
			"lat": 37.53772724,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 3,
			"dd": 22,
			"by": 1884,
			"bd": 25,
			"bm": 11,
			"nm": "G.",
			"nf": "Onie",
			"nl": "McRae",
			"url": "https://findagrave.com/memorial/161179745",
			"id": 161179745,
			"lng": -77.38653348,
			"lat": 37.53708179,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 10,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rufus",
			"nl": "McTeer",
			"url": "https://findagrave.com/memorial/135741641",
			"id": 135741641,
			"lng": -77.38599008,
			"lat": 37.53686315,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 1,
			"dd": 11,
			"by": 1916,
			"bd": 5,
			"bm": 1,
			"nm": "",
			"nf": "Juanita",
			"nl": "Meadows",
			"url": "https://findagrave.com/memorial/143632582",
			"id": 143632582,
			"lng": -77.38610709,
			"lat": 37.53573863,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 9,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sarah",
			"nl": "Meadows",
			"url": "https://findagrave.com/memorial/187826465",
			"id": 187826465,
			"lng": -77.38794486,
			"lat": 37.53715741,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1913,
			"dm": 7,
			"dd": 31,
			"by": 1898,
			"bd": 4,
			"bm": 1,
			"nm": "",
			"nf": "Albert",
			"nl": "Mealy",
			"url": "https://findagrave.com/memorial/156480507",
			"id": 156480507,
			"lng": -77.38677515,
			"lat": 37.53585188,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 8,
			"dd": 5,
			"by": 1884,
			"bd": 2,
			"bm": 2,
			"nm": "",
			"nf": "Abraham",
			"nl": "Meekins",
			"url": "https://findagrave.com/memorial/161000150",
			"id": 161000150,
			"lng": -77.38710073,
			"lat": 37.53699974,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 4,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alice",
			"nl": "Meekins",
			"url": "https://findagrave.com/memorial/175421100",
			"id": 175421100,
			"lng": -77.38764894,
			"lat": 37.5371783,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 5,
			"dd": 20,
			"by": 1889,
			"bd": 8,
			"bm": 6,
			"nm": "",
			"nf": "Armetter",
			"nl": "Meekins",
			"url": "https://findagrave.com/memorial/160941090",
			"id": 160941090,
			"lng": -77.38710571,
			"lat": 37.53699017,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 11,
			"dd": 3,
			"by": 1903,
			"bd": 7,
			"bm": 11,
			"nm": "",
			"nf": "Leroy",
			"nl": "Meekins",
			"url": "https://findagrave.com/memorial/161000414",
			"id": 161000414,
			"lng": -77.38709743,
			"lat": 37.53701072,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 7,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Meekins",
			"url": "https://findagrave.com/memorial/167182302",
			"id": 167182302,
			"lng": -77.38656024,
			"lat": 37.53685057,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 5,
			"dd": 8,
			"by": 1949,
			"bd": 11,
			"bm": 12,
			"nm": "Garland",
			"nf": "William",
			"nl": "Meekins",
			"url": "https://findagrave.com/memorial/192392034",
			"id": 192392034,
			"lng": -77.38741142,
			"lat": 37.53742063,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1987,
			"dm": 2,
			"dd": 25,
			"by": 1924,
			"bd": 26,
			"bm": 7,
			"nm": "",
			"nf": "Amanda",
			"nl": "Meredith",
			"url": "https://findagrave.com/memorial/129211451",
			"id": 129211451,
			"lng": -77.38618518,
			"lat": 37.53676554,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1985,
			"dm": "",
			"dd": "",
			"by": 1922,
			"bd": "",
			"bm": "",
			"nm": "G.",
			"nf": "Edward",
			"nl": "Meredith",
			"url": "https://findagrave.com/memorial/144315689",
			"id": 144315689,
			"lng": -77.38617481,
			"lat": 37.5367632,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1993,
			"dm": 1,
			"dd": 31,
			"by": 1905,
			"bd": 8,
			"bm": 6,
			"nm": "",
			"nf": "Grace",
			"nl": "Meredith",
			"url": "https://findagrave.com/memorial/148648726",
			"id": 148648726,
			"lng": -77.38616098,
			"lat": 37.5367917,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 10,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Hezekiah",
			"nl": "Meredith",
			"url": "https://findagrave.com/memorial/141658079",
			"id": 141658079,
			"lng": -77.38606463,
			"lat": 37.53716274,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 3,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Samuel",
			"nl": "Meredith",
			"url": "https://findagrave.com/memorial/146772746",
			"id": 146772746,
			"lng": -77.38614579,
			"lat": 37.53578877,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 9,
			"dd": 6,
			"by": 1857,
			"bd": 23,
			"bm": 2,
			"nm": "W.",
			"nf": "George",
			"nl": "Middleton",
			"url": "https://findagrave.com/memorial/169429852",
			"id": 169429852,
			"lng": -77.38769356,
			"lat": 37.53696426,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 5,
			"dd": 18,
			"by": 1909,
			"bd": 11,
			"bm": 10,
			"nm": "",
			"nf": "Hazel",
			"nl": "Miles",
			"url": "https://findagrave.com/memorial/158450783",
			"id": 158450783,
			"lng": -77.38586928,
			"lat": 37.53741744,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 5,
			"dd": 5,
			"by": 1945,
			"bd": 26,
			"bm": 6,
			"nm": "Anthony",
			"nf": "John",
			"nl": "Miles",
			"url": "https://findagrave.com/memorial/185715952",
			"id": 185715952,
			"lng": -77.38732892,
			"lat": 37.5374086,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 7,
			"dd": 1,
			"by": 1906,
			"bd": 4,
			"bm": 8,
			"nm": "Cornelius",
			"nf": "Leslie",
			"nl": "Miles",
			"url": "https://findagrave.com/memorial/185717314",
			"id": 185717314,
			"lng": -77.38755323,
			"lat": 37.53772856,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 8,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Miles",
			"url": "https://findagrave.com/memorial/139146911",
			"id": 139146911,
			"lng": -77.38598301,
			"lat": 37.53657298,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 11,
			"dd": 23,
			"by": 1879,
			"bd": 10,
			"bm": 5,
			"nm": "Ann",
			"nf": "Mary",
			"nl": "Miles",
			"url": "https://findagrave.com/memorial/122027569",
			"id": 122027569,
			"lng": -77.38774764,
			"lat": 37.53694278,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 7,
			"dd": 30,
			"by": 1865,
			"bd": 9,
			"bm": 3,
			"nm": "",
			"nf": "Peter",
			"nl": "Miles",
			"url": "https://findagrave.com/memorial/122027604",
			"id": 122027604,
			"lng": -77.38598345,
			"lat": 37.53657214,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 8,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alice",
			"nl": "Miller",
			"url": "https://findagrave.com/memorial/155757775",
			"id": 155757775,
			"lng": -77.38720054,
			"lat": 37.53563857,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 7,
			"dd": 29,
			"by": 1913,
			"bd": 25,
			"bm": 12,
			"nm": "",
			"nf": "Blanche",
			"nl": "Miller",
			"url": "https://findagrave.com/memorial/173071358",
			"id": 173071358,
			"lng": -77.38696251,
			"lat": 37.53734174,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 4,
			"dd": 5,
			"by": 1900,
			"bd": 5,
			"bm": 9,
			"nm": "E.",
			"nf": "Earl",
			"nl": "Miller",
			"url": "https://findagrave.com/memorial/144188900",
			"id": 144188900,
			"lng": -77.38727193,
			"lat": 37.53762236,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 5,
			"dd": 4,
			"by": 1890,
			"bd": 16,
			"bm": 6,
			"nm": "A.",
			"nf": "Elizabeth",
			"nl": "Miller",
			"url": "https://findagrave.com/memorial/140290919",
			"id": 140290919,
			"lng": -77.38616846,
			"lat": 37.53661207,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 10,
			"dd": 18,
			"by": 1895,
			"bd": "",
			"bm": 3,
			"nm": "",
			"nf": "Elnora",
			"nl": "Miller",
			"url": "https://findagrave.com/memorial/155531210",
			"id": 155531210,
			"lng": -77.38647363,
			"lat": 37.53680961,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 9,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Hall",
			"nf": "Emmett",
			"nl": "Miller",
			"url": "https://findagrave.com/memorial/145344819",
			"id": 145344819,
			"lng": -77.38581452,
			"lat": 37.53704938,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 7,
			"dd": 10,
			"by": 1875,
			"bd": 17,
			"bm": 8,
			"nm": "Bartlett",
			"nf": "Leeanna",
			"nl": "Miller",
			"url": "https://findagrave.com/memorial/183195338",
			"id": 183195338,
			"lng": -77.38731155,
			"lat": 37.53707746,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 8,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Louisa",
			"nl": "Miller",
			"url": "https://findagrave.com/memorial/157242637",
			"id": 157242637,
			"lng": -77.38668628,
			"lat": 37.53581373,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 2,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H",
			"nf": "Mary",
			"nl": "Miller",
			"url": "https://findagrave.com/memorial/144370459",
			"id": 144370459,
			"lng": -77.38613768,
			"lat": 37.53738436,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 11,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Mary",
			"nl": "Miller",
			"url": "https://findagrave.com/memorial/159663329",
			"id": 159663329,
			"lng": -77.38591587,
			"lat": 37.53741432,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 9,
			"dd": 1,
			"by": 1874,
			"bd": 1,
			"bm": 7,
			"nm": "E.",
			"nf": "William",
			"nl": "Miller",
			"url": "https://findagrave.com/memorial/155760652",
			"id": 155760652,
			"lng": -77.3875721,
			"lat": 37.53701653,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 10,
			"dd": 10,
			"by": 1917,
			"bd": 1,
			"bm": 4,
			"nm": "",
			"nf": "Mary",
			"nl": "Mills",
			"url": "https://findagrave.com/memorial/173314388",
			"id": 173314388,
			"lng": -77.38699984,
			"lat": 37.53712081,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 9,
			"dd": 26,
			"by": 1963,
			"bd": 16,
			"bm": 7,
			"nm": "R.",
			"nf": "John",
			"nl": "Milton",
			"url": "https://findagrave.com/memorial/159414605",
			"id": 159414605,
			"lng": -77.38608632,
			"lat": 37.53746889,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 9,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "baby boy",
			"nl": "Minn",
			"url": "https://findagrave.com/memorial/144143940",
			"id": 144143940,
			"lng": -77.38588194,
			"lat": 37.53738771,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 5,
			"dd": 19,
			"by": 1895,
			"bd": 4,
			"bm": 7,
			"nm": "",
			"nf": "Joseph",
			"nl": "Minor",
			"url": "https://findagrave.com/memorial/145344914",
			"id": 145344914,
			"lng": -77.38556221,
			"lat": 37.53730556,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 9,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Louise",
			"nl": "Minor",
			"url": "https://findagrave.com/memorial/142468283",
			"id": 142468283,
			"lng": -77.38739546,
			"lat": 37.53783311,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 8,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucy",
			"nl": "Minor",
			"url": "https://findagrave.com/memorial/146019963",
			"id": 146019963,
			"lng": -77.38648514,
			"lat": 37.53664811,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 1,
			"dd": 8,
			"by": 1905,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Marjorie",
			"nl": "Minor",
			"url": "https://findagrave.com/memorial/146386369",
			"id": 146386369,
			"lng": -77.38633636,
			"lat": 37.5371743,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 2,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ally",
			"nl": "Mitchell",
			"url": "https://findagrave.com/memorial/173847870",
			"id": 173847870,
			"lng": -77.38737462,
			"lat": 37.53715441,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 11,
			"dd": 28,
			"by": 1898,
			"bd": 10,
			"bm": 4,
			"nm": "",
			"nf": "James",
			"nl": "Mitchell",
			"url": "https://findagrave.com/memorial/184276788",
			"id": 184276788,
			"lng": -77.38763154,
			"lat": 37.53741746,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1907,
			"dm": 7,
			"dd": 29,
			"by": 1870,
			"bd": 29,
			"bm": 5,
			"nm": "M.",
			"nf": "Kate",
			"nl": "Mitchell",
			"url": "https://findagrave.com/memorial/127569722",
			"id": 127569722,
			"lng": -77.38620197,
			"lat": 37.53640422,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 8,
			"dd": 17,
			"by": 1900,
			"bd": 14,
			"bm": 2,
			"nm": "",
			"nf": "Louise",
			"nl": "Mitchell",
			"url": "https://findagrave.com/memorial/185357159",
			"id": 185357159,
			"lng": -77.3873748,
			"lat": 37.53680822,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 10,
			"dd": 17,
			"by": 1917,
			"bd": 23,
			"bm": 5,
			"nm": "Robinson",
			"nf": "Mary",
			"nl": "Mitchell",
			"url": "https://findagrave.com/memorial/144143943",
			"id": 144143943,
			"lng": -77.38619681,
			"lat": 37.53731124,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1911,
			"dm": 9,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mercia",
			"nl": "Mitchell",
			"url": "https://findagrave.com/memorial/125408697",
			"id": 125408697,
			"lng": -77.38769418,
			"lat": 37.53664958,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 9,
			"dd": 3,
			"by": 1889,
			"bd": 31,
			"bm": 3,
			"nm": "P.",
			"nf": "Rosa",
			"nl": "Mitchell",
			"url": "https://findagrave.com/memorial/143632588",
			"id": 143632588,
			"lng": -77.38606702,
			"lat": 37.53599719,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 9,
			"dd": 19,
			"by": 1888,
			"bd": 24,
			"bm": 1,
			"nm": "H.",
			"nf": "Thomas",
			"nl": "Mitchell",
			"url": "https://findagrave.com/memorial/143696157",
			"id": 143696157,
			"lng": -77.38603221,
			"lat": 37.53601043,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 11,
			"dd": 13,
			"by": 1856,
			"bd": 26,
			"bm": 2,
			"nm": "A.",
			"nf": "William",
			"nl": "Mitchell",
			"url": "https://findagrave.com/memorial/127131723",
			"id": 127131723,
			"lng": -77.38620367,
			"lat": 37.53640621,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 6,
			"dd": 27,
			"by": 1940,
			"bd": 2,
			"bm": 3,
			"nm": "E.",
			"nf": "Charles",
			"nl": "Mixon",
			"url": "https://findagrave.com/memorial/185958415",
			"id": 185958415,
			"lng": -77.38636146,
			"lat": 37.53593431,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 11,
			"dd": 10,
			"by": 1897,
			"bd": 31,
			"bm": 5,
			"nm": "C.",
			"nf": "Arthur",
			"nl": "Monday",
			"url": "https://findagrave.com/memorial/151266857",
			"id": 151266857,
			"lng": -77.38700012,
			"lat": 37.53693676,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 12,
			"dd": 10,
			"by": 1892,
			"bd": 2,
			"bm": 8,
			"nm": "",
			"nf": "Herbert",
			"nl": "Monroe",
			"url": "https://findagrave.com/memorial/182320457",
			"id": 182320457,
			"lng": -77.38675735,
			"lat": 37.53771569,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 12,
			"dd": 28,
			"by": 1884,
			"bd": 30,
			"bm": 11,
			"nm": "William",
			"nf": "Robert",
			"nl": "Monteeth",
			"url": "https://findagrave.com/memorial/125820934",
			"id": 125820934,
			"lng": -77.3859325,
			"lat": 37.53732167,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 5,
			"dd": 27,
			"by": 1890,
			"bd": 28,
			"bm": 12,
			"nm": "",
			"nf": "Arthur",
			"nl": "Moore",
			"url": "https://findagrave.com/memorial/141446487",
			"id": 141446487,
			"lng": -77.38724012,
			"lat": 37.53769944,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 1,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Celia",
			"nl": "Moore",
			"url": "https://findagrave.com/memorial/186921406",
			"id": 186921406,
			"lng": -77.3873641,
			"lat": 37.53692519,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 6,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "Clarence",
			"nl": "Moore",
			"url": "https://findagrave.com/memorial/155123812",
			"id": 155123812,
			"lng": -77.38666084,
			"lat": 37.53712101,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 12,
			"dd": 6,
			"by": 1924,
			"bd": 22,
			"bm": 4,
			"nm": "",
			"nf": "Clifton",
			"nl": "Moore",
			"url": "https://findagrave.com/memorial/157314396",
			"id": 157314396,
			"lng": -77.38670693,
			"lat": 37.53691134,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 6,
			"dd": 25,
			"by": 1963,
			"bd": 28,
			"bm": 12,
			"nm": "",
			"nf": "Kelvin",
			"nl": "Moore",
			"url": "https://findagrave.com/memorial/144558536",
			"id": 144558536,
			"lng": -77.38616049,
			"lat": 37.53743727,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 5,
			"dd": 3,
			"by": 1907,
			"bd": 5,
			"bm": 10,
			"nm": "L.",
			"nf": "Lloyd",
			"nl": "Moore",
			"url": "https://findagrave.com/memorial/182115900",
			"id": 182115900,
			"lng": -77.38692176,
			"lat": 37.53754933,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 2,
			"dd": 4,
			"by": 1895,
			"bd": 11,
			"bm": 8,
			"nm": "E.",
			"nf": "Mary",
			"nl": "Moore",
			"url": "https://findagrave.com/memorial/145596017",
			"id": 145596017,
			"lng": -77.38617867,
			"lat": 37.5374306,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 9,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mattie",
			"nl": "Moore",
			"url": "https://findagrave.com/memorial/177617285",
			"id": 177617285,
			"lng": -77.38655394,
			"lat": 37.53743503,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 8,
			"dd": 1,
			"by": 1906,
			"bd": 31,
			"bm": 5,
			"nm": "",
			"nf": "Mozelle",
			"nl": "Moore",
			"url": "https://findagrave.com/memorial/177285391",
			"id": 177285391,
			"lng": -77.38720658,
			"lat": 37.53734869,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 11,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Robert",
			"nl": "Moore",
			"url": "https://findagrave.com/memorial/175409028",
			"id": 175409028,
			"lng": -77.38760462,
			"lat": 37.53719243,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 2,
			"dd": 15,
			"by": 1880,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sallie",
			"nl": "Moore",
			"url": "https://findagrave.com/memorial/137430824",
			"id": 137430824,
			"lng": -77.38595724,
			"lat": 37.53710966,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1980,
			"dm": 12,
			"dd": 8,
			"by": 1904,
			"bd": 4,
			"bm": 3,
			"nm": "",
			"nf": "Frank",
			"nl": "Moran",
			"url": "https://findagrave.com/memorial/153513004",
			"id": 153513004,
			"lng": -77.38679392,
			"lat": 37.53726313,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1981,
			"dm": 4,
			"dd": 27,
			"by": 1906,
			"bd": 12,
			"bm": 11,
			"nm": "",
			"nf": "Loretta",
			"nl": "Moran",
			"url": "https://findagrave.com/memorial/153513014",
			"id": 153513014,
			"lng": -77.38679206,
			"lat": 37.53726729,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 3,
			"dd": 7,
			"by": 1926,
			"bd": 18,
			"bm": 7,
			"nm": "C.",
			"nf": "Ruby",
			"nl": "Moran",
			"url": "https://findagrave.com/memorial/171769813",
			"id": 171769813,
			"lng": -77.38681571,
			"lat": 37.53726794,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 10,
			"dd": 16,
			"by": 1904,
			"bd": 12,
			"bm": 3,
			"nm": "S.",
			"nf": "Nellie",
			"nl": "Mordecai",
			"url": "https://findagrave.com/memorial/140624981",
			"id": 140624981,
			"lng": -77.38798799,
			"lat": 37.53756827,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 11,
			"dd": 16,
			"by": 1899,
			"bd": 28,
			"bm": 2,
			"nm": "Wallace",
			"nf": "Paul",
			"nl": "Mordecai",
			"url": "https://findagrave.com/memorial/125634436",
			"id": 125634436,
			"lng": -77.3879975,
			"lat": 37.53755206,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 3,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Eliza",
			"nl": "Morgan",
			"url": "https://findagrave.com/memorial/173515352",
			"id": 173515352,
			"lng": -77.38745479,
			"lat": 37.53712529,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 11,
			"dd": 14,
			"by": 1889,
			"bd": 18,
			"bm": 9,
			"nm": "",
			"nf": "Eva",
			"nl": "Morgan",
			"url": "https://findagrave.com/memorial/162642856",
			"id": 162642856,
			"lng": -77.38716499,
			"lat": 37.53707313,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 11,
			"dd": 14,
			"by": 1878,
			"bd": 8,
			"bm": 5,
			"nm": "J.",
			"nf": "Mamie",
			"nl": "Morgan",
			"url": "https://findagrave.com/memorial/154296522",
			"id": 154296522,
			"lng": -77.38704404,
			"lat": 37.53551195,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 9,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "baby boy",
			"nl": "Morris",
			"url": "https://findagrave.com/memorial/163925086",
			"id": 163925086,
			"lng": -77.38671445,
			"lat": 37.53681732,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 4,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Emma",
			"nl": "Morris",
			"url": "https://findagrave.com/memorial/119328039",
			"id": 119328039,
			"lng": -77.3854978,
			"lat": 37.53735719,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 6,
			"dd": 14,
			"by": 1849,
			"bd": "",
			"bm": 8,
			"nm": "H.",
			"nf": "George",
			"nl": "Morris",
			"url": "https://findagrave.com/memorial/132641404",
			"id": 132641404,
			"lng": -77.38778866,
			"lat": 37.53632194,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 11,
			"dd": 20,
			"by": 1851,
			"bd": "",
			"bm": 5,
			"nm": "Ann",
			"nf": "Julia",
			"nl": "Morris",
			"url": "https://findagrave.com/memorial/132641407",
			"id": 132641407,
			"lng": -77.38778619,
			"lat": 37.53633057,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": 9,
			"dd": 28,
			"by": 1888,
			"bd": 6,
			"bm": 7,
			"nm": "Belle",
			"nf": "Juliet",
			"nl": "Morris",
			"url": "https://findagrave.com/memorial/134474433",
			"id": 134474433,
			"lng": -77.38748208,
			"lat": 37.53652773,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 11,
			"dd": 6,
			"by": 1874,
			"bd": 15,
			"bm": 2,
			"nm": "D.",
			"nf": "Mabel",
			"nl": "Morris",
			"url": "https://findagrave.com/memorial/127569729",
			"id": 127569729,
			"lng": -77.38779109,
			"lat": 37.53631507,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 10,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Mary",
			"nl": "Morris",
			"url": "https://findagrave.com/memorial/134474442",
			"id": 134474442,
			"lng": -77.38749347,
			"lat": 37.53651972,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 2,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Morris",
			"url": "https://findagrave.com/memorial/141194136",
			"id": 141194136,
			"lng": -77.38628259,
			"lat": 37.53666388,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 5,
			"dd": 23,
			"by": 1886,
			"bd": 19,
			"bm": 10,
			"nm": "",
			"nf": "Mildred",
			"nl": "Morris",
			"url": "https://findagrave.com/memorial/173793356",
			"id": 173793356,
			"lng": -77.38717139,
			"lat": 37.53718419,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 6,
			"dd": 20,
			"by": 1895,
			"bd": 3,
			"bm": 11,
			"nm": "",
			"nf": "Priscilla",
			"nl": "Morris",
			"url": "https://findagrave.com/memorial/155989124",
			"id": 155989124,
			"lng": -77.38695516,
			"lat": 37.53554116,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1904,
			"dm": 1,
			"dd": 10,
			"by": 1878,
			"bd": 12,
			"bm": 8,
			"nm": "G.",
			"nf": "Sumner",
			"nl": "Morris",
			"url": "https://findagrave.com/memorial/132764929",
			"id": 132764929,
			"lng": -77.38777792,
			"lat": 37.5363499,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 8,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Walter",
			"nl": "Morris",
			"url": "https://findagrave.com/memorial/177545580",
			"id": 177545580,
			"lng": -77.38695583,
			"lat": 37.53553537,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 1,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucinda",
			"nl": "Morrison",
			"url": "https://findagrave.com/memorial/181401052",
			"id": 181401052,
			"lng": -77.38802982,
			"lat": 37.53768598,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 2,
			"dd": 26,
			"by": 1953,
			"bd": 29,
			"bm": 11,
			"nm": "",
			"nf": "Daniel",
			"nl": "Morton",
			"url": "https://findagrave.com/memorial/155270316",
			"id": 155270316,
			"lng": -77.38703789,
			"lat": 37.53783573,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 9,
			"dd": 1,
			"by": 1904,
			"bd": 5,
			"bm": 5,
			"nm": "",
			"nf": "Estelle",
			"nl": "Morton",
			"url": "https://findagrave.com/memorial/185658256",
			"id": 185658256,
			"lng": -77.38723342,
			"lat": 37.53775597,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 10,
			"dd": 11,
			"by": 1916,
			"bd": 27,
			"bm": 3,
			"nm": "Leroy",
			"nf": "Horace",
			"nl": "Morton",
			"url": "https://findagrave.com/memorial/183863701",
			"id": 183863701,
			"lng": -77.38738488,
			"lat": 37.5369789,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 9,
			"dd": 6,
			"by": 1894,
			"bd": 3,
			"bm": 4,
			"nm": "Agnes",
			"nf": "Mary",
			"nl": "Morton",
			"url": "https://findagrave.com/memorial/163925087",
			"id": 163925087,
			"lng": -77.38682697,
			"lat": 37.53682874,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 5,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Patricia",
			"nl": "Morton",
			"url": "https://findagrave.com/memorial/153381658",
			"id": 153381658,
			"lng": -77.3861195,
			"lat": 37.53745937,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 1,
			"dd": 8,
			"by": 1891,
			"bd": 31,
			"bm": 5,
			"nm": "",
			"nf": "Shadrack",
			"nl": "Morton",
			"url": "https://findagrave.com/memorial/161096787",
			"id": 161096787,
			"lng": -77.38715068,
			"lat": 37.53709447,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 5,
			"dd": 30,
			"by": 1881,
			"bd": 9,
			"bm": 6,
			"nm": "",
			"nf": "Tinker",
			"nl": "Morton",
			"url": "https://findagrave.com/memorial/163951039",
			"id": 163951039,
			"lng": -77.38755845,
			"lat": 37.5374681,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 12,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Mamie",
			"nl": "Mosby",
			"url": "https://findagrave.com/memorial/156480514",
			"id": 156480514,
			"lng": -77.38629959,
			"lat": 37.53588115,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 2,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nancy",
			"nl": "Mosby",
			"url": "https://findagrave.com/memorial/156632733",
			"id": 156632733,
			"lng": -77.38778929,
			"lat": 37.53718226,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 1,
			"dd": 18,
			"by": 1934,
			"bd": 4,
			"bm": 6,
			"nm": "",
			"nf": "Robert",
			"nl": "Mosby",
			"url": "https://findagrave.com/memorial/152369058",
			"id": 152369058,
			"lng": -77.38647411,
			"lat": 37.5373854,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 9,
			"dd": 25,
			"by": 1963,
			"bd": 20,
			"bm": 9,
			"nm": "",
			"nf": "baby girl",
			"nl": "Moses",
			"url": "https://findagrave.com/memorial/191503847",
			"id": 191503847,
			"lng": -77.38606893,
			"lat": 37.53749837,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 12,
			"dd": 24,
			"by": 1897,
			"bd": 10,
			"bm": 3,
			"nm": "",
			"nf": "Robert",
			"nl": "Moses",
			"url": "https://findagrave.com/memorial/181401058",
			"id": 181401058,
			"lng": -77.38800435,
			"lat": 37.5374366,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 3,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Ann",
			"nf": "Marie",
			"nl": "Mosley",
			"url": "https://findagrave.com/memorial/141194177",
			"id": 141194177,
			"lng": -77.38626285,
			"lat": 37.53669247,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 4,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Albert",
			"nl": "Moss",
			"url": "https://findagrave.com/memorial/185154030",
			"id": 185154030,
			"lng": -77.38696137,
			"lat": 37.53767785,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 1,
			"dd": 4,
			"by": 1931,
			"bd": 1,
			"bm": 8,
			"nm": "Evelyn",
			"nf": "Mable",
			"nl": "Moss",
			"url": "https://findagrave.com/memorial/177279588",
			"id": 177279588,
			"lng": -77.38751606,
			"lat": 37.5372898,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 5,
			"dd": 20,
			"by": 1896,
			"bd": 4,
			"bm": 3,
			"nm": "",
			"nf": "Will",
			"nl": "Moss",
			"url": "https://findagrave.com/memorial/154037219",
			"id": 154037219,
			"lng": -77.38646199,
			"lat": 37.53715324,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 2,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "George",
			"nl": "Motley",
			"url": "https://findagrave.com/memorial/151461410",
			"id": 151461410,
			"lng": -77.38811193,
			"lat": 37.53739568,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 5,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jack",
			"nl": "Motley",
			"url": "https://findagrave.com/memorial/120726113",
			"id": 120726113,
			"lng": -77.38579672,
			"lat": 37.53691162,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 2,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nannie",
			"nl": "Motley",
			"url": "https://findagrave.com/memorial/120726132",
			"id": 120726132,
			"lng": -77.38577221,
			"lat": 37.53692156,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 4,
			"dd": 5,
			"by": 1873,
			"bd": 17,
			"bm": 5,
			"nm": "C.",
			"nf": "Atticus",
			"nl": "Moyler",
			"url": "https://findagrave.com/memorial/174616597",
			"id": 174616597,
			"lng": -77.38745455,
			"lat": 37.53701435,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 12,
			"dd": 12,
			"by": 1873,
			"bd": 9,
			"bm": 4,
			"nm": "E.",
			"nf": "Sarah",
			"nl": "Moyler",
			"url": "https://findagrave.com/memorial/174616583",
			"id": 174616583,
			"lng": -77.38745251,
			"lat": 37.53702203,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 1,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Mozell",
			"url": "https://findagrave.com/memorial/173314399",
			"id": 173314399,
			"lng": -77.38700654,
			"lat": 37.53718422,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 7,
			"dd": 8,
			"by": 1877,
			"bd": "",
			"bm": 10,
			"nm": "Estelle",
			"nf": "Eva",
			"nl": "Mundin",
			"url": "https://findagrave.com/memorial/127881091",
			"id": 127881091,
			"lng": -77.38644044,
			"lat": 37.53654305,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 8,
			"dd": 30,
			"by": 1879,
			"bd": 24,
			"bm": 6,
			"nm": "Goode",
			"nf": "Lillie",
			"nl": "Mundin",
			"url": "https://findagrave.com/memorial/157757359",
			"id": 157757359,
			"lng": -77.38561761,
			"lat": 37.53736421,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 2,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Willie",
			"nl": "Murphy",
			"url": "https://findagrave.com/memorial/187601082",
			"id": 187601082,
			"lng": -77.38756878,
			"lat": 37.5368166,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 4,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nancy",
			"nl": "Murray",
			"url": "https://findagrave.com/memorial/145596006",
			"id": 145596006,
			"lng": -77.38608573,
			"lat": 37.53738437,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 11,
			"dd": 30,
			"by": 1906,
			"bd": 19,
			"bm": 8,
			"nm": "",
			"nf": "Mayme",
			"nl": "Myers",
			"url": "https://findagrave.com/memorial/127483522",
			"id": 127483522,
			"lng": -77.3858422,
			"lat": 37.53652542,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 9,
			"dd": 7,
			"by": 1913,
			"bd": 13,
			"bm": 10,
			"nm": "Harold",
			"nf": "Walter",
			"nl": "Myers",
			"url": "https://findagrave.com/memorial/149439672",
			"id": 149439672,
			"lng": -77.38648322,
			"lat": 37.53547352,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 3,
			"dd": 15,
			"by": 1893,
			"bd": 3,
			"bm": 4,
			"nm": "Alexander",
			"nf": "Junius",
			"nl": "Nash",
			"url": "https://findagrave.com/memorial/132641409",
			"id": 132641409,
			"lng": -77.38573848,
			"lat": 37.53728587,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 9,
			"dd": 4,
			"by": 1874,
			"bd": 15,
			"bm": 8,
			"nm": "Ann",
			"nf": "Sallie",
			"nl": "Nash",
			"url": "https://findagrave.com/memorial/132641415",
			"id": 132641415,
			"lng": -77.38574319,
			"lat": 37.53727692,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 12,
			"dd": 4,
			"by": 1886,
			"bd": 20,
			"bm": 7,
			"nm": "G.",
			"nf": "Estelle",
			"nl": "Neal",
			"url": "https://findagrave.com/memorial/144370595",
			"id": 144370595,
			"lng": -77.38611038,
			"lat": 37.53731986,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 9,
			"dd": 22,
			"by": 1882,
			"bd": 3,
			"bm": 4,
			"nm": "",
			"nf": "Joshua",
			"nl": "Neal",
			"url": "https://findagrave.com/memorial/169478114",
			"id": 169478114,
			"lng": -77.3877485,
			"lat": 37.53710763,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 7,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Neale",
			"url": "https://findagrave.com/memorial/154296533",
			"id": 154296533,
			"lng": -77.38706425,
			"lat": 37.53547902,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 2,
			"dd": 12,
			"by": 1909,
			"bd": 29,
			"bm": 5,
			"nm": "C.",
			"nf": "Beatrice",
			"nl": "Nelson",
			"url": "https://findagrave.com/memorial/142526963",
			"id": 142526963,
			"lng": -77.38594233,
			"lat": 37.53736739,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 1,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lizzie",
			"nl": "Nelson",
			"url": "https://findagrave.com/memorial/173481228",
			"id": 173481228,
			"lng": -77.3873419,
			"lat": 37.53710563,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 2,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rosa",
			"nl": "Nelson",
			"url": "https://findagrave.com/memorial/175616247",
			"id": 175616247,
			"lng": -77.38802391,
			"lat": 37.5372012,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 1,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Samuel",
			"nl": "Nelson",
			"url": "https://findagrave.com/memorial/126772051",
			"id": 126772051,
			"lng": -77.38776928,
			"lat": 37.53719975,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 7,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Vesta",
			"nl": "Nelson",
			"url": "https://findagrave.com/memorial/185741796",
			"id": 185741796,
			"lng": -77.38776392,
			"lat": 37.53697106,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 11,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "T.",
			"nf": "Willie",
			"nl": "Nelson",
			"url": "https://findagrave.com/memorial/147853444",
			"id": 147853444,
			"lng": -77.38635299,
			"lat": 37.53713786,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 9,
			"dd": "",
			"by": 1954,
			"bd": 10,
			"bm": 5,
			"nm": "Leon",
			"nf": "Albert",
			"nl": "Nero",
			"url": "https://findagrave.com/memorial/180686578",
			"id": 180686578,
			"lng": -77.38620188,
			"lat": 37.53544991,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 7,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Wayne",
			"nl": "Nero",
			"url": "https://findagrave.com/memorial/142526977",
			"id": 142526977,
			"lng": -77.38585136,
			"lat": 37.5374608,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 9,
			"dd": 27,
			"by": 1880,
			"bd": 16,
			"bm": 6,
			"nm": "",
			"nf": "James",
			"nl": "Newsome",
			"url": "https://findagrave.com/memorial/182088432",
			"id": 182088432,
			"lng": -77.38664507,
			"lat": 37.537647,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 3,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Henry",
			"nf": "William",
			"nl": "Newton",
			"url": "https://findagrave.com/memorial/145344921",
			"id": 145344921,
			"lng": -77.38555214,
			"lat": 37.53733739,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 2,
			"dd": 25,
			"by": 1929,
			"bd": 16,
			"bm": 5,
			"nm": "Elizabeth",
			"nf": "Gloria",
			"nl": "Nichols",
			"url": "https://findagrave.com/memorial/153627892",
			"id": 153627892,
			"lng": -77.38668641,
			"lat": 37.53742695,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 3,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Beula",
			"nl": "Noble",
			"url": "https://findagrave.com/memorial/151888670",
			"id": 151888670,
			"lng": -77.38662765,
			"lat": 37.53572652,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 9,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rosa",
			"nl": "Noble",
			"url": "https://findagrave.com/memorial/185647527",
			"id": 185647527,
			"lng": -77.38749406,
			"lat": 37.53690387,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": 1867,
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Ellen",
			"nl": "Norris",
			"url": "https://findagrave.com/memorial/150792681",
			"id": 150792681,
			"lng": -77.38643795,
			"lat": 37.53558484,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 9,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Martha",
			"nl": "Nunnally",
			"url": "https://findagrave.com/memorial/130538968",
			"id": 130538968,
			"lng": -77.38638764,
			"lat": 37.53690279,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 10,
			"dd": 6,
			"by": 1901,
			"bd": 12,
			"bm": 2,
			"nm": "",
			"nf": "Lurie",
			"nl": "Ogburn",
			"url": "https://findagrave.com/memorial/172999368",
			"id": 172999368,
			"lng": -77.38702055,
			"lat": 37.53729635,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": 1872,
			"bd": "",
			"bm": 3,
			"nm": "",
			"nf": "Catherine",
			"nl": "Oliver",
			"url": "https://findagrave.com/memorial/125837279",
			"id": 125837279,
			"lng": -77.38783797,
			"lat": 37.53627519,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": 1870,
			"bd": "",
			"bm": 1,
			"nm": "",
			"nf": "John",
			"nl": "Oliver",
			"url": "https://findagrave.com/memorial/125837266",
			"id": 125837266,
			"lng": -77.3878383,
			"lat": 37.53627393,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 1,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lynell",
			"nl": "Oliver",
			"url": "https://findagrave.com/memorial/144013907",
			"id": 144013907,
			"lng": -77.38740749,
			"lat": 37.53766219,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": 1840,
			"bd": "",
			"bm": 5,
			"nm": "Jane",
			"nf": "Mary",
			"nl": "Oliver",
			"url": "https://findagrave.com/memorial/125837246",
			"id": 125837246,
			"lng": -77.38783863,
			"lat": 37.53627266,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 1,
			"dd": 23,
			"by": 1926,
			"bd": 9,
			"bm": 6,
			"nm": "",
			"nf": "Saunders",
			"nl": "Oliver",
			"url": "https://findagrave.com/memorial/155733899",
			"id": 155733899,
			"lng": -77.38641037,
			"lat": 37.53708404,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 4,
			"dd": 21,
			"by": 1879,
			"bd": 20,
			"bm": 6,
			"nm": "Thomas",
			"nf": "James",
			"nl": "Onley",
			"url": "https://findagrave.com/memorial/160940652",
			"id": 160940652,
			"lng": -77.38691021,
			"lat": 37.53697652,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 11,
			"dd": 21,
			"by": 1891,
			"bd": 23,
			"bm": 10,
			"nm": "",
			"nf": "Matilda",
			"nl": "Onley",
			"url": "https://findagrave.com/memorial/154509740",
			"id": 154509740,
			"lng": -77.38636281,
			"lat": 37.537363,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 6,
			"dd": 27,
			"by": 1890,
			"bd": 30,
			"bm": 11,
			"nm": "B.",
			"nf": "Fannie",
			"nl": "Osborne",
			"url": "https://findagrave.com/memorial/117804405",
			"id": 117804405,
			"lng": -77.38570276,
			"lat": 37.53712867,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 4,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "T.",
			"nf": "John",
			"nl": "Osborne",
			"url": "https://findagrave.com/memorial/169429985",
			"id": 169429985,
			"lng": -77.38772545,
			"lat": 37.53709078,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 10,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Jesse",
			"nl": "Outlaw",
			"url": "https://findagrave.com/memorial/138181482",
			"id": 138181482,
			"lng": -77.38623259,
			"lat": 37.53711561,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 4,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Terri",
			"nl": "Overby",
			"url": "https://findagrave.com/memorial/144143948",
			"id": 144143948,
			"lng": -77.38614045,
			"lat": 37.53726705,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 2,
			"dd": 19,
			"by": 1967,
			"bd": 12,
			"bm": 1,
			"nm": "",
			"nf": "Joseph",
			"nl": "Overton",
			"url": "https://findagrave.com/memorial/142468833",
			"id": 142468833,
			"lng": -77.38593935,
			"lat": 37.53743253,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": "",
			"dd": "",
			"by": 1936,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Owens",
			"url": "https://findagrave.com/memorial/185958418",
			"id": 185958418,
			"lng": -77.38637364,
			"lat": 37.53597609,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 9,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jasper",
			"nl": "Owens",
			"url": "https://findagrave.com/memorial/188269170",
			"id": 188269170,
			"lng": -77.38789238,
			"lat": 37.53721535,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 12,
			"dd": 3,
			"by": 1910,
			"bd": 10,
			"bm": 8,
			"nm": "Jake",
			"nf": "Raymond",
			"nl": "Owens",
			"url": "https://findagrave.com/memorial/177469033",
			"id": 177469033,
			"lng": -77.38761451,
			"lat": 37.53749296,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 9,
			"dd": 3,
			"by": 1890,
			"bd": 23,
			"bm": 8,
			"nm": "",
			"nf": "David",
			"nl": "Page",
			"url": "https://findagrave.com/memorial/136306512",
			"id": 136306512,
			"lng": -77.38602618,
			"lat": 37.53699112,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 12,
			"dd": 17,
			"by": 1859,
			"bd": 28,
			"bm": 8,
			"nm": "",
			"nf": "David",
			"nl": "Page",
			"url": "https://findagrave.com/memorial/136306506",
			"id": 136306506,
			"lng": -77.38602136,
			"lat": 37.53699773,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 6,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "Edgar",
			"nl": "Page",
			"url": "https://findagrave.com/memorial/151460736",
			"id": 151460736,
			"lng": -77.38801723,
			"lat": 37.53730465,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 8,
			"dd": 29,
			"by": 1865,
			"bd": 14,
			"bm": 3,
			"nm": "",
			"nf": "Florence",
			"nl": "Page",
			"url": "https://findagrave.com/memorial/136306518",
			"id": 136306518,
			"lng": -77.38601696,
			"lat": 37.53700471,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 4,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Harriet",
			"nl": "Page",
			"url": "https://findagrave.com/memorial/154296540",
			"id": 154296540,
			"lng": -77.38710384,
			"lat": 37.5354826,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 1,
			"dd": 18,
			"by": 1852,
			"bd": 15,
			"bm": 9,
			"nm": "",
			"nf": "Jeremiah",
			"nl": "Page",
			"url": "https://findagrave.com/memorial/76605000",
			"id": 76605000,
			"lng": -77.38546118,
			"lat": 37.53732697,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 2,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "R.",
			"nf": "John",
			"nl": "Page",
			"url": "https://findagrave.com/memorial/150035858",
			"id": 150035858,
			"lng": -77.38641645,
			"lat": 37.535674,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 10,
			"dd": 9,
			"by": 1898,
			"bd": 31,
			"bm": 8,
			"nm": "R.",
			"nf": "Josephine",
			"nl": "Page",
			"url": "https://findagrave.com/memorial/136306527",
			"id": 136306527,
			"lng": -77.38596247,
			"lat": 37.53698914,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 1,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "Lawson",
			"nl": "Page",
			"url": "https://findagrave.com/memorial/144316145",
			"id": 144316145,
			"lng": -77.38710378,
			"lat": 37.53547299,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 5,
			"dd": 4,
			"by": 1877,
			"bd": 11,
			"bm": 8,
			"nm": "Oliver",
			"nf": "Thomas",
			"nl": "Page",
			"url": "https://findagrave.com/memorial/142470557",
			"id": 142470557,
			"lng": -77.3855042,
			"lat": 37.53730434,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 8,
			"dd": 27,
			"by": 1917,
			"bd": 25,
			"bm": 12,
			"nm": "",
			"nf": "Vernetta",
			"nl": "Page",
			"url": "https://findagrave.com/memorial/173314405",
			"id": 173314405,
			"lng": -77.38710073,
			"lat": 37.53733028,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 10,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Page",
			"url": "https://findagrave.com/memorial/177026470",
			"id": 177026470,
			"lng": -77.38801009,
			"lat": 37.53722719,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 3,
			"dd": 25,
			"by": 1888,
			"bd": 22,
			"bm": 2,
			"nm": "A.",
			"nf": "William",
			"nl": "Page",
			"url": "https://findagrave.com/memorial/125520683",
			"id": 125520683,
			"lng": -77.3859651,
			"lat": 37.53697602,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 10,
			"dd": 19,
			"by": 1926,
			"bd": 6,
			"bm": 1,
			"nm": "",
			"nf": "Leo",
			"nl": "Pair",
			"url": "https://findagrave.com/memorial/142531401",
			"id": 142531401,
			"lng": -77.38647257,
			"lat": 37.53531904,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 6,
			"dd": 13,
			"by": 1889,
			"bd": "",
			"bm": 10,
			"nm": "",
			"nf": "Henrietta",
			"nl": "Parham",
			"url": "https://findagrave.com/memorial/130538976",
			"id": 130538976,
			"lng": -77.38639355,
			"lat": 37.53688699,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 8,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "William",
			"nf": "James",
			"nl": "Parham",
			"url": "https://findagrave.com/memorial/155290614",
			"id": 155290614,
			"lng": -77.38662146,
			"lat": 37.53559875,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 12,
			"dd": 2,
			"by": 1865,
			"bd": "",
			"bm": 3,
			"nm": "",
			"nf": "John",
			"nl": "Parham",
			"url": "https://findagrave.com/memorial/130538981",
			"id": 130538981,
			"lng": -77.3863974,
			"lat": 37.53687921,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 6,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mildred",
			"nl": "Parham",
			"url": "https://findagrave.com/memorial/130538988",
			"id": 130538988,
			"lng": -77.38639131,
			"lat": 37.53689525,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 12,
			"dd": 26,
			"by": 1898,
			"bd": 21,
			"bm": 12,
			"nm": "P.",
			"nf": "Mozell",
			"nl": "Parham",
			"url": "https://findagrave.com/memorial/144188906",
			"id": 144188906,
			"lng": -77.38620984,
			"lat": 37.53734459,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 1,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sarah",
			"nl": "Parham",
			"url": "https://findagrave.com/memorial/187366463",
			"id": 187366463,
			"lng": -77.38805304,
			"lat": 37.53769213,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 10,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Andrew",
			"nl": "Parker",
			"url": "https://findagrave.com/memorial/140624997",
			"id": 140624997,
			"lng": -77.3868336,
			"lat": 37.53544022,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1907,
			"dm": 11,
			"dd": 28,
			"by": 1845,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Andrew",
			"nl": "Parker",
			"url": "https://findagrave.com/memorial/152167172",
			"id": 152167172,
			"lng": -77.38616607,
			"lat": 37.53554005,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 2,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Julia",
			"nl": "Parker",
			"url": "https://findagrave.com/memorial/127131741",
			"id": 127131741,
			"lng": -77.38629105,
			"lat": 37.53641313,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 9,
			"dd": 18,
			"by": 1915,
			"bd": 8,
			"bm": 2,
			"nm": "",
			"nf": "Louis",
			"nl": "Parker",
			"url": "https://findagrave.com/memorial/151267122",
			"id": 151267122,
			"lng": -77.38680402,
			"lat": 37.53724991,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 7,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Louis",
			"nl": "Parker",
			"url": "https://findagrave.com/memorial/137835768",
			"id": 137835768,
			"lng": -77.38625895,
			"lat": 37.53705357,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 8,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Martha",
			"nl": "Parker",
			"url": "https://findagrave.com/memorial/152167332",
			"id": 152167332,
			"lng": -77.38616834,
			"lat": 37.53553201,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 4,
			"dd": 21,
			"by": 1893,
			"bd": 16,
			"bm": 3,
			"nm": "",
			"nf": "Lucy",
			"nl": "Paschall",
			"url": "https://findagrave.com/memorial/143998004",
			"id": 143998004,
			"lng": -77.38726184,
			"lat": 37.53766474,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 8,
			"dd": 24,
			"by": 1923,
			"bd": 26,
			"bm": 2,
			"nm": "Virginia",
			"nf": "Beatrice",
			"nl": "Patron",
			"url": "https://findagrave.com/memorial/147853464",
			"id": 147853464,
			"lng": -77.38698756,
			"lat": 37.53712291,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 12,
			"dd": 22,
			"by": 1906,
			"bd": "",
			"bm": 1,
			"nm": "",
			"nf": "Carrie",
			"nl": "Patterson",
			"url": "https://findagrave.com/memorial/161180316",
			"id": 161180316,
			"lng": -77.38644129,
			"lat": 37.53701741,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 10,
			"dd": 31,
			"by": 1878,
			"bd": 25,
			"bm": 12,
			"nm": "",
			"nf": "Eliza",
			"nl": "Patterson",
			"url": "https://findagrave.com/memorial/191703588",
			"id": 191703588,
			"lng": -77.38648332,
			"lat": 37.5374095,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 5,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Emma",
			"nl": "Patterson",
			"url": "https://findagrave.com/memorial/185151361",
			"id": 185151361,
			"lng": -77.38776419,
			"lat": 37.53661928,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": 6,
			"dd": 30,
			"by": 1813,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Patterson",
			"url": "https://findagrave.com/memorial/183512383",
			"id": 183512383,
			"lng": -77.38622528,
			"lat": 37.53541561,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 4,
			"dd": 13,
			"by": 1900,
			"bd": 28,
			"bm": 2,
			"nm": "",
			"nf": "Nannie",
			"nl": "Patterson",
			"url": "https://findagrave.com/memorial/137968575",
			"id": 137968575,
			"lng": -77.386679,
			"lat": 37.53707165,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 3,
			"dd": 8,
			"by": 1884,
			"bd": 5,
			"bm": 3,
			"nm": "",
			"nf": "Rufus",
			"nl": "Patton",
			"url": "https://findagrave.com/memorial/161179887",
			"id": 161179887,
			"lng": -77.3865306,
			"lat": 37.53707062,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 3,
			"dd": 19,
			"by": 1907,
			"bd": 21,
			"bm": 6,
			"nm": "C.",
			"nf": "Andrew",
			"nl": "Payne",
			"url": "https://findagrave.com/memorial/128672377",
			"id": 128672377,
			"lng": -77.3856927,
			"lat": 37.53715034,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 12,
			"dd": 12,
			"by": 1860,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Edmonia",
			"nl": "Payne",
			"url": "https://findagrave.com/memorial/145085238",
			"id": 145085238,
			"lng": -77.38572621,
			"lat": 37.53741085,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 12,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "Ella",
			"nl": "Payne",
			"url": "https://findagrave.com/memorial/146341607",
			"id": 146341607,
			"lng": -77.38664243,
			"lat": 37.53583741,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 11,
			"dd": 15,
			"by": 1870,
			"bd": 21,
			"bm": 3,
			"nm": "",
			"nf": "Henrietta",
			"nl": "Payne",
			"url": "https://findagrave.com/memorial/128672390",
			"id": 128672390,
			"lng": -77.38569861,
			"lat": 37.5371361,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 3,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Harrison",
			"nf": "Julian",
			"nl": "Payne",
			"url": "https://findagrave.com/memorial/142469222",
			"id": 142469222,
			"lng": -77.38572837,
			"lat": 37.53740264,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 8,
			"dd": 22,
			"by": 1899,
			"bd": 17,
			"bm": 12,
			"nm": "Harold",
			"nf": "Louis",
			"nl": "Payne",
			"url": "https://findagrave.com/memorial/113633577",
			"id": 113633577,
			"lng": -77.38567271,
			"lat": 37.53714371,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 2,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Matthews",
			"nl": "Payne",
			"url": "https://findagrave.com/memorial/173897839",
			"id": 173897839,
			"lng": -77.38758616,
			"lat": 37.53718666,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 7,
			"dd": 10,
			"by": 1922,
			"bd": 28,
			"bm": 8,
			"nm": "",
			"nf": "Purcell",
			"nl": "Payne",
			"url": "https://findagrave.com/memorial/155270318",
			"id": 155270318,
			"lng": -77.3871448,
			"lat": 37.53775387,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 6,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "V.",
			"nf": "Rosa",
			"nl": "Payne",
			"url": "https://findagrave.com/memorial/136107642",
			"id": 136107642,
			"lng": -77.38563761,
			"lat": 37.53734661,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 5,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sophie",
			"nl": "Payne",
			"url": "https://findagrave.com/memorial/174884434",
			"id": 174884434,
			"lng": -77.38748379,
			"lat": 37.53714434,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 4,
			"dd": 23,
			"by": 1913,
			"bd": 15,
			"bm": 8,
			"nm": "H.",
			"nf": "William",
			"nl": "Payne",
			"url": "https://findagrave.com/memorial/127569736",
			"id": 127569736,
			"lng": -77.38575351,
			"lat": 37.53701636,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 3,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Upton",
			"nl": "Peace",
			"url": "https://findagrave.com/memorial/177192677",
			"id": 177192677,
			"lng": -77.3878642,
			"lat": 37.53708106,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 8,
			"dd": 28,
			"by": 1870,
			"bd": 6,
			"bm": 1,
			"nm": "F.",
			"nf": "Mary",
			"nl": "Peeples",
			"url": "https://findagrave.com/memorial/157219263",
			"id": 157219263,
			"lng": -77.38655245,
			"lat": 37.53584218,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 10,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Dora",
			"nl": "Pegram",
			"url": "https://findagrave.com/memorial/155731903",
			"id": 155731903,
			"lng": -77.38727441,
			"lat": 37.53563502,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 10,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Pemberton",
			"url": "https://findagrave.com/memorial/169479024",
			"id": 169479024,
			"lng": -77.38774342,
			"lat": 37.53710593,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 8,
			"dd": 27,
			"by": 1954,
			"bd": 27,
			"bm": 8,
			"nm": "",
			"nf": "Richard",
			"nl": "Penn",
			"url": "https://findagrave.com/memorial/158450803",
			"id": 158450803,
			"lng": -77.3859203,
			"lat": 37.53734456,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 9,
			"dd": 9,
			"by": 1902,
			"bd": 4,
			"bm": 2,
			"nm": "Bell",
			"nf": "Annie",
			"nl": "Perkins",
			"url": "https://findagrave.com/memorial/176939586",
			"id": 176939586,
			"lng": -77.38707622,
			"lat": 37.53752118,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 1,
			"dd": 18,
			"by": 1886,
			"bd": "",
			"bm": "",
			"nm": "D.",
			"nf": "Elizabeth",
			"nl": "Perkins",
			"url": "https://findagrave.com/memorial/176711948",
			"id": 176711948,
			"lng": -77.38766928,
			"lat": 37.53730378,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 5,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Clara",
			"nl": "Perry",
			"url": "https://findagrave.com/memorial/122793371",
			"id": 122793371,
			"lng": -77.38590363,
			"lat": 37.53650313,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 5,
			"dd": 1,
			"by": 1896,
			"bd": 10,
			"bm": 4,
			"nm": "",
			"nf": "Henrietta",
			"nl": "Perry",
			"url": "https://findagrave.com/memorial/155021669",
			"id": 155021669,
			"lng": -77.38666585,
			"lat": 37.53746639,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 4,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Henry",
			"nl": "Perry",
			"url": "https://findagrave.com/memorial/168954471",
			"id": 168954471,
			"lng": -77.38562172,
			"lat": 37.53698892,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 9,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Bell",
			"nf": "Ida",
			"nl": "Perry",
			"url": "https://findagrave.com/memorial/168954493",
			"id": 168954493,
			"lng": -77.3856252,
			"lat": 37.53698034,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 10,
			"dd": 12,
			"by": 1899,
			"bd": 15,
			"bm": 12,
			"nm": "R.",
			"nf": "John",
			"nl": "Perry",
			"url": "https://findagrave.com/memorial/131428533",
			"id": 131428533,
			"lng": -77.38604079,
			"lat": 37.5358425,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 10,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "Perry",
			"url": "https://findagrave.com/memorial/131428525",
			"id": 131428525,
			"lng": -77.38603206,
			"lat": 37.53583799,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 1,
			"dd": 9,
			"by": 1903,
			"bd": 7,
			"bm": 5,
			"nm": "",
			"nf": "Latimus",
			"nl": "Perry",
			"url": "https://findagrave.com/memorial/147853490",
			"id": 147853490,
			"lng": -77.38699956,
			"lat": 37.53707508,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 12,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "N.",
			"nf": "Maggie",
			"nl": "Perry",
			"url": "https://findagrave.com/memorial/138570864",
			"id": 138570864,
			"lng": -77.38633358,
			"lat": 37.53658651,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 6,
			"dd": 12,
			"by": 1913,
			"bd": 21,
			"bm": 3,
			"nm": "",
			"nf": "Mary",
			"nl": "Perry",
			"url": "https://findagrave.com/memorial/155531221",
			"id": 155531221,
			"lng": -77.38769938,
			"lat": 37.53770085,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 9,
			"dd": 12,
			"by": 1878,
			"bd": 30,
			"bm": 5,
			"nm": "",
			"nf": "Mary",
			"nl": "Perry",
			"url": "https://findagrave.com/memorial/131428537",
			"id": 131428537,
			"lng": -77.38603644,
			"lat": 37.53583101,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 1,
			"dd": 21,
			"by": 1913,
			"bd": 27,
			"bm": 8,
			"nm": "Geneva",
			"nf": "Rubbie",
			"nl": "Perry",
			"url": "https://findagrave.com/memorial/134359200",
			"id": 134359200,
			"lng": -77.38757368,
			"lat": 37.53659314,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 8,
			"dd": 17,
			"by": 1902,
			"bd": 16,
			"bm": 2,
			"nm": "",
			"nf": "Sallie",
			"nl": "Perry",
			"url": "https://findagrave.com/memorial/183697482",
			"id": 183697482,
			"lng": -77.38697931,
			"lat": 37.53700602,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 1,
			"dd": 18,
			"by": 1896,
			"bd": 1,
			"bm": 6,
			"nm": "",
			"nf": "Maggie",
			"nl": "Petterson",
			"url": "https://findagrave.com/memorial/161179871",
			"id": 161179871,
			"lng": -77.38608571,
			"lat": 37.53632587,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 9,
			"dd": 29,
			"by": 1876,
			"bd": 30,
			"bm": 3,
			"nm": "",
			"nf": "Victoria",
			"nl": "Petterson",
			"url": "https://findagrave.com/memorial/128452612",
			"id": 128452612,
			"lng": -77.38565633,
			"lat": 37.53700846,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 4,
			"dd": 14,
			"by": 1927,
			"bd": 9,
			"bm": 4,
			"nm": "E.",
			"nf": "Elsie",
			"nl": "Pettus",
			"url": "https://findagrave.com/memorial/177768015",
			"id": 177768015,
			"lng": -77.38659393,
			"lat": 37.53708693,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 1,
			"dd": 8,
			"by": 1895,
			"bd": 25,
			"bm": 8,
			"nm": "",
			"nf": "James",
			"nl": "Pettus",
			"url": "https://findagrave.com/memorial/145344929",
			"id": 145344929,
			"lng": -77.38597932,
			"lat": 37.53693906,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 11,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Phoeby",
			"nl": "Pettus",
			"url": "https://findagrave.com/memorial/136306535",
			"id": 136306535,
			"lng": -77.38618462,
			"lat": 37.53636061,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 4,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "R.",
			"nf": "James",
			"nl": "Peyton",
			"url": "https://findagrave.com/memorial/144188916",
			"id": 144188916,
			"lng": -77.38604189,
			"lat": 37.53727637,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 4,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Henry",
			"nf": "John",
			"nl": "Peyton",
			"url": "https://findagrave.com/memorial/173925965",
			"id": 173925965,
			"lng": -77.38758905,
			"lat": 37.53714343,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 12,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "Bettie",
			"nl": "Phillips",
			"url": "https://findagrave.com/memorial/127719227",
			"id": 127719227,
			"lng": -77.38605965,
			"lat": 37.53657695,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 7,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "James",
			"nl": "Pickens",
			"url": "https://findagrave.com/memorial/166049021",
			"id": 166049021,
			"lng": -77.38647334,
			"lat": 37.53665956,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 7,
			"dd": 9,
			"by": 1878,
			"bd": 15,
			"bm": 8,
			"nm": "",
			"nf": "Nancy",
			"nl": "Pickett",
			"url": "https://findagrave.com/memorial/187826207",
			"id": 187826207,
			"lng": -77.38794739,
			"lat": 37.53715044,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 2,
			"dd": 23,
			"by": 1964,
			"bd": 23,
			"bm": 2,
			"nm": "",
			"nf": "baby girl",
			"nl": "Pierce",
			"url": "https://findagrave.com/memorial/159414634",
			"id": 159414634,
			"lng": -77.38617308,
			"lat": 37.53748647,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 4,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Louise",
			"nl": "Pierce",
			"url": "https://findagrave.com/memorial/138181530",
			"id": 138181530,
			"lng": -77.38683728,
			"lat": 37.53690583,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 12,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bertha",
			"nl": "Pierson",
			"url": "https://findagrave.com/memorial/154038602",
			"id": 154038602,
			"lng": -77.38639631,
			"lat": 37.53717791,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 5,
			"dd": 27,
			"by": 1884,
			"bd": 15,
			"bm": 4,
			"nm": "E. White",
			"nf": "Sarah",
			"nl": "Piett",
			"url": "https://findagrave.com/memorial/171769826",
			"id": 171769826,
			"lng": -77.38709014,
			"lat": 37.53671132,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 12,
			"dd": 22,
			"by": 1892,
			"bd": 13,
			"bm": 7,
			"nm": "L. Sullivan",
			"nf": "John",
			"nl": "Pitchford",
			"url": "https://findagrave.com/memorial/152794740",
			"id": 152794740,
			"lng": -77.38698561,
			"lat": 37.53745618,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 12,
			"dd": 3,
			"by": 1914,
			"bd": 6,
			"bm": 1,
			"nm": "",
			"nf": "Walter",
			"nl": "Pitchford",
			"url": "https://findagrave.com/memorial/144370611",
			"id": 144370611,
			"lng": -77.38723697,
			"lat": 37.5377934,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 4,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Redick",
			"nl": "Pittman",
			"url": "https://findagrave.com/memorial/177286105",
			"id": 177286105,
			"lng": -77.38733875,
			"lat": 37.53729334,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 2,
			"dd": 14,
			"by": 1879,
			"bd": 15,
			"bm": 4,
			"nm": "C.",
			"nf": "Walker",
			"nl": "Pleasant",
			"url": "https://findagrave.com/memorial/111589851",
			"id": 111589851,
			"lng": -77.38732328,
			"lat": 37.53753569,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 1,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Rebecca",
			"nf": "Alice",
			"nl": "Pleasants",
			"url": "https://findagrave.com/memorial/170604703",
			"id": 170604703,
			"lng": -77.38685448,
			"lat": 37.53690143,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 10,
			"dd": 13,
			"by": 1974,
			"bd": 12,
			"bm": 10,
			"nm": "Nicole",
			"nf": "Shannon",
			"nl": "Pleasants",
			"url": "https://findagrave.com/memorial/76605009",
			"id": 76605009,
			"lng": -77.38613845,
			"lat": 37.53672632,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 7,
			"dd": 10,
			"by": 1887,
			"bd": 6,
			"bm": 6,
			"nm": "Bernard",
			"nf": "Nelson",
			"nl": "Plummer",
			"url": "https://findagrave.com/memorial/158733716",
			"id": 158733716,
			"lng": -77.38713051,
			"lat": 37.53748662,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 12,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Virginia",
			"nl": "Plummer",
			"url": "https://findagrave.com/memorial/189076333",
			"id": 189076333,
			"lng": -77.38608437,
			"lat": 37.53616378,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 10,
			"dd": 29,
			"by": 1966,
			"bd": 17,
			"bm": 9,
			"nm": "Eric",
			"nf": "Morris",
			"nl": "Poag",
			"url": "https://findagrave.com/memorial/144189013",
			"id": 144189013,
			"lng": -77.38597049,
			"lat": 37.53745748,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 8,
			"dd": 25,
			"by": "",
			"bd": 26,
			"bm": 8,
			"nm": "",
			"nf": "Brady",
			"nl": "Poe",
			"url": "https://findagrave.com/memorial/163942732",
			"id": 163942732,
			"lng": -77.38760808,
			"lat": 37.53741919,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 7,
			"dd": 6,
			"by": 1859,
			"bd": 9,
			"bm": 8,
			"nm": "E.",
			"nf": "Fannie",
			"nl": "Poindexter",
			"url": "https://findagrave.com/memorial/150920523",
			"id": 150920523,
			"lng": -77.38618898,
			"lat": 37.53558475,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 2,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Poindexter",
			"url": "https://findagrave.com/memorial/148747858",
			"id": 148747858,
			"lng": -77.38785926,
			"lat": 37.53711373,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 11,
			"dd": 15,
			"by": 1859,
			"bd": "",
			"bm": 3,
			"nm": "",
			"nf": "Bettie",
			"nl": "Pollard",
			"url": "https://findagrave.com/memorial/143632593",
			"id": 143632593,
			"lng": -77.38602801,
			"lat": 37.536014,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 2,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Charley",
			"nl": "Pollard",
			"url": "https://findagrave.com/memorial/188269543",
			"id": 188269543,
			"lng": -77.38795762,
			"lat": 37.53707807,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 10,
			"dd": 23,
			"by": 1925,
			"bd": 2,
			"bm": 5,
			"nm": "E.",
			"nf": "Grayce",
			"nl": "Pollard",
			"url": "https://findagrave.com/memorial/38457079",
			"id": 38457079,
			"lng": -77.38570851,
			"lat": 37.53705745,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 4,
			"dd": 22,
			"by": 1915,
			"bd": 25,
			"bm": 10,
			"nm": "Johnson",
			"nf": "Jack",
			"nl": "Pollard",
			"url": "https://findagrave.com/memorial/158433253",
			"id": 158433253,
			"lng": -77.3867511,
			"lat": 37.53767706,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 2,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nelson",
			"nl": "Pollard",
			"url": "https://findagrave.com/memorial/148517520",
			"id": 148517520,
			"lng": -77.38681564,
			"lat": 37.53577965,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 1,
			"dd": 5,
			"by": 1959,
			"bd": 3,
			"bm": 9,
			"nm": "Marie",
			"nf": "Rosa",
			"nl": "Pollard",
			"url": "https://findagrave.com/memorial/138570870",
			"id": 138570870,
			"lng": -77.38622544,
			"lat": 37.53660584,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 12,
			"dd": 26,
			"by": 1841,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Thomas",
			"nl": "Pollard",
			"url": "https://findagrave.com/memorial/143696146",
			"id": 143696146,
			"lng": -77.38601299,
			"lat": 37.53603633,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 10,
			"dd": 3,
			"by": 1894,
			"bd": 10,
			"bm": 5,
			"nm": "",
			"nf": "Cora",
			"nl": "Poole",
			"url": "https://findagrave.com/memorial/173068595",
			"id": 173068595,
			"lng": -77.38706536,
			"lat": 37.53732047,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 5,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ike",
			"nl": "Poole",
			"url": "https://findagrave.com/memorial/147853504",
			"id": 147853504,
			"lng": -77.38595378,
			"lat": 37.53636002,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 7,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "John",
			"nl": "Pope",
			"url": "https://findagrave.com/memorial/143632600",
			"id": 143632600,
			"lng": -77.38603939,
			"lat": 37.53600464,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 10,
			"dd": 31,
			"by": 1922,
			"bd": 22,
			"bm": 8,
			"nm": "L.",
			"nf": "Edward",
			"nl": "Porter",
			"url": "https://findagrave.com/memorial/138570881",
			"id": 138570881,
			"lng": -77.38624034,
			"lat": 37.53680226,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "Janie",
			"nl": "Porter",
			"url": "https://findagrave.com/memorial/176720263",
			"id": 176720263,
			"lng": -77.38701492,
			"lat": 37.53747498,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 6,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "David",
			"nl": "Powell",
			"url": "https://findagrave.com/memorial/125634447",
			"id": 125634447,
			"lng": -77.38578389,
			"lat": 37.53665581,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 7,
			"dd": 2,
			"by": 1909,
			"bd": 23,
			"bm": 3,
			"nm": "",
			"nf": "Douglas",
			"nl": "Powell",
			"url": "https://findagrave.com/memorial/148648734",
			"id": 148648734,
			"lng": -77.38600584,
			"lat": 37.53738186,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 6,
			"dd": 4,
			"by": 1870,
			"bd": 15,
			"bm": 2,
			"nm": "",
			"nf": "Harriett",
			"nl": "Powell",
			"url": "https://findagrave.com/memorial/113626512",
			"id": 113626512,
			"lng": -77.38797841,
			"lat": 37.53719787,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 4,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Powell",
			"url": "https://findagrave.com/memorial/175421305",
			"id": 175421305,
			"lng": -77.38750666,
			"lat": 37.53714035,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 3,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "William",
			"nl": "Powell",
			"url": "https://findagrave.com/memorial/151461706",
			"id": 151461706,
			"lng": -77.38816264,
			"lat": 37.53738762,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 10,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "William",
			"nl": "Powell",
			"url": "https://findagrave.com/memorial/184767568",
			"id": 184767568,
			"lng": -77.38767667,
			"lat": 37.53694202,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 10,
			"dd": 11,
			"by": 1964,
			"bd": 27,
			"bm": 7,
			"nm": "Dominic",
			"nf": "Kelvin",
			"nl": "Prentiss",
			"url": "https://findagrave.com/memorial/153868177",
			"id": 153868177,
			"lng": -77.38618276,
			"lat": 37.53745362,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 12,
			"dd": 27,
			"by": 1925,
			"bd": 5,
			"bm": 2,
			"nm": "",
			"nf": "Walter",
			"nl": "Prentiss",
			"url": "https://findagrave.com/memorial/191379205",
			"id": 191379205,
			"lng": -77.38645692,
			"lat": 37.53722575,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 10,
			"dd": 1,
			"by": 1903,
			"bd": 2,
			"bm": 2,
			"nm": "",
			"nf": "Walter",
			"nl": "Prentiss",
			"url": "https://findagrave.com/memorial/144013908",
			"id": 144013908,
			"lng": -77.38742947,
			"lat": 37.53760755,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 5,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Eva",
			"nl": "Preston",
			"url": "https://findagrave.com/memorial/144821911",
			"id": 144821911,
			"lng": -77.38547992,
			"lat": 37.53732809,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1883,
			"dm": 1,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Abram",
			"nl": "Price",
			"url": "https://findagrave.com/memorial/144316209",
			"id": 144316209,
			"lng": -77.3870911,
			"lat": 37.53547557,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1906,
			"dm": 8,
			"dd": 5,
			"by": 1900,
			"bd": 4,
			"bm": 4,
			"nm": "",
			"nf": "Aurelia",
			"nl": "Price",
			"url": "https://findagrave.com/memorial/151111976",
			"id": 151111976,
			"lng": -77.38650553,
			"lat": 37.53550537,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 10,
			"dd": 5,
			"by": 1925,
			"bd": 26,
			"bm": 7,
			"nm": "E.",
			"nf": "Geraldine",
			"nl": "Price",
			"url": "https://findagrave.com/memorial/151111983",
			"id": 151111983,
			"lng": -77.38660381,
			"lat": 37.53542872,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1897,
			"dm": 9,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lydia",
			"nl": "Price",
			"url": "https://findagrave.com/memorial/144316219",
			"id": 144316219,
			"lng": -77.38709198,
			"lat": 37.53547285,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 2,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lynwood",
			"nl": "Price",
			"url": "https://findagrave.com/memorial/117449113",
			"id": 117449113,
			"lng": -77.38720366,
			"lat": 37.53712745,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 8,
			"dd": 29,
			"by": 1895,
			"bd": 14,
			"bm": 5,
			"nm": "Abner",
			"nf": "Maurice",
			"nl": "Price",
			"url": "https://findagrave.com/memorial/127483533",
			"id": 127483533,
			"lng": -77.38618537,
			"lat": 37.53699521,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 7,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nannie",
			"nl": "Price",
			"url": "https://findagrave.com/memorial/158466956",
			"id": 158466956,
			"lng": -77.38689894,
			"lat": 37.53764273,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 11,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Patsie",
			"nl": "Price",
			"url": "https://findagrave.com/memorial/146343908",
			"id": 146343908,
			"lng": -77.38631596,
			"lat": 37.53575764,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 12,
			"dd": 3,
			"by": 1898,
			"bd": 5,
			"bm": 10,
			"nm": "V.",
			"nf": "Pearl",
			"nl": "Price",
			"url": "https://findagrave.com/memorial/127483586",
			"id": 127483586,
			"lng": -77.38618977,
			"lat": 37.53698779,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 2,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Horace",
			"nf": "Ralph",
			"nl": "Price",
			"url": "https://findagrave.com/memorial/122793511",
			"id": 122793511,
			"lng": -77.38572862,
			"lat": 37.53699235,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 5,
			"dd": 3,
			"by": 1910,
			"bd": 10,
			"bm": 8,
			"nm": "E.",
			"nf": "Roger",
			"nl": "Price",
			"url": "https://findagrave.com/memorial/172031031",
			"id": 172031031,
			"lng": -77.38700942,
			"lat": 37.53744771,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 1,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Bogle",
			"nf": "Sarah",
			"nl": "Price",
			"url": "https://findagrave.com/memorial/184448923",
			"id": 184448923,
			"lng": -77.38737367,
			"lat": 37.53783624,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": "",
			"dd": "",
			"by": 1868,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Walter",
			"nl": "Price",
			"url": "https://findagrave.com/memorial/138181533",
			"id": 138181533,
			"lng": -77.3862734,
			"lat": 37.53710717,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 4,
			"dd": 13,
			"by": 1897,
			"bd": 5,
			"bm": 8,
			"nm": "Samuel",
			"nf": "Wilson",
			"nl": "Price",
			"url": "https://findagrave.com/memorial/174622146",
			"id": 174622146,
			"lng": -77.38581336,
			"lat": 37.53663518,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 3,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Lee",
			"nf": "Willie",
			"nl": "Pridgen",
			"url": "https://findagrave.com/memorial/141194239",
			"id": 141194239,
			"lng": -77.38640774,
			"lat": 37.53667627,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 10,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "James",
			"nl": "Pryor",
			"url": "https://findagrave.com/memorial/155531231",
			"id": 155531231,
			"lng": -77.38660452,
			"lat": 37.53561278,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 12,
			"dd": 27,
			"by": 1932,
			"bd": 8,
			"bm": 6,
			"nm": "Emanuel",
			"nf": "Charles",
			"nl": "Pulley",
			"url": "https://findagrave.com/memorial/158676608",
			"id": 158676608,
			"lng": -77.3868368,
			"lat": 37.53750395,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 12,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Annie",
			"nl": "Pulliam",
			"url": "https://findagrave.com/memorial/167373224",
			"id": 167373224,
			"lng": -77.38777769,
			"lat": 37.5370597,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 7,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Henry",
			"nl": "Pulliam",
			"url": "https://findagrave.com/memorial/187744295",
			"id": 187744295,
			"lng": -77.3877338,
			"lat": 37.53695362,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 4,
			"dd": 27,
			"by": 1895,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "Pulliam",
			"url": "https://findagrave.com/memorial/151267213",
			"id": 151267213,
			"lng": -77.38747413,
			"lat": 37.53686067,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 12,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Cornelius",
			"nl": "Puryear",
			"url": "https://findagrave.com/memorial/145596028",
			"id": 145596028,
			"lng": -77.38690623,
			"lat": 37.53668583,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 5,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Fannie",
			"nl": "Puryear",
			"url": "https://findagrave.com/memorial/143865733",
			"id": 143865733,
			"lng": -77.38676343,
			"lat": 37.53664787,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1987,
			"dm": 4,
			"dd": 7,
			"by": 1889,
			"bd": 19,
			"bm": 1,
			"nm": "Emma",
			"nf": "Kate",
			"nl": "Puryear",
			"url": "https://findagrave.com/memorial/158335474",
			"id": 158335474,
			"lng": -77.38613767,
			"lat": 37.53662007,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 2,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Anderson",
			"nl": "Quarles",
			"url": "https://findagrave.com/memorial/120147054",
			"id": 120147054,
			"lng": -77.38597794,
			"lat": 37.53674641,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 4,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Catherine",
			"nl": "Quarles",
			"url": "https://findagrave.com/memorial/120147064",
			"id": 120147064,
			"lng": -77.38597842,
			"lat": 37.53673707,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 2,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "Frank",
			"nl": "Quarles",
			"url": "https://findagrave.com/memorial/189075393",
			"id": 189075393,
			"lng": -77.38617016,
			"lat": 37.53612918,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 3,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Hester",
			"nl": "Quarles",
			"url": "https://findagrave.com/memorial/128672402",
			"id": 128672402,
			"lng": -77.38606003,
			"lat": 37.53663624,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 9,
			"dd": 13,
			"by": 1876,
			"bd": 30,
			"bm": 4,
			"nm": "Henry",
			"nf": "James",
			"nl": "Quarles",
			"url": "https://findagrave.com/memorial/125094188",
			"id": 125094188,
			"lng": -77.3860439,
			"lat": 37.53663163,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1905,
			"dm": 4,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Lizzie",
			"nl": "Radford",
			"url": "https://findagrave.com/memorial/125643880",
			"id": 125643880,
			"lng": -77.38725319,
			"lat": 37.53668567,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 6,
			"dd": 12,
			"by": 1907,
			"bd": 12,
			"bm": 9,
			"nm": "E.",
			"nf": "Blanche",
			"nl": "Ragland",
			"url": "https://findagrave.com/memorial/150033733",
			"id": 150033733,
			"lng": -77.38649426,
			"lat": 37.53726523,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 2,
			"dd": 10,
			"by": 1895,
			"bd": 17,
			"bm": 5,
			"nm": "",
			"nf": "Isabella",
			"nl": "Ragland",
			"url": "https://findagrave.com/memorial/161179874",
			"id": 161179874,
			"lng": -77.38649628,
			"lat": 37.53706986,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 12,
			"dd": 29,
			"by": 1905,
			"bd": 22,
			"bm": 6,
			"nm": "L.",
			"nf": "Russell",
			"nl": "Ragland",
			"url": "https://findagrave.com/memorial/150033740",
			"id": 150033740,
			"lng": -77.38649186,
			"lat": 37.5372645,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 7,
			"dd": 30,
			"by": 1918,
			"bd": 10,
			"bm": 10,
			"nm": "",
			"nf": "Ophelia",
			"nl": "Ramsey",
			"url": "https://findagrave.com/memorial/154040610",
			"id": 154040610,
			"lng": -77.38654377,
			"lat": 37.53756654,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 5,
			"dd": 29,
			"by": 1896,
			"bd": 26,
			"bm": 11,
			"nm": "James",
			"nf": "Royal",
			"nl": "Randall",
			"url": "https://findagrave.com/memorial/126652595",
			"id": 126652595,
			"lng": -77.38588656,
			"lat": 37.5365634,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 10,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Absolom",
			"nl": "Randolph",
			"url": "https://findagrave.com/memorial/150677875",
			"id": 150677875,
			"lng": -77.38642347,
			"lat": 37.53549833,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 9,
			"dd": 22,
			"by": 1899,
			"bd": 7,
			"bm": 7,
			"nm": "L.",
			"nf": "Arthur",
			"nl": "Randolph",
			"url": "https://findagrave.com/memorial/159416140",
			"id": 159416140,
			"lng": -77.3863501,
			"lat": 37.53751466,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 9,
			"dd": 18,
			"by": 1920,
			"bd": 6,
			"bm": 5,
			"nm": "Edward",
			"nf": "Carlton",
			"nl": "Randolph",
			"url": "https://findagrave.com/memorial/167072664",
			"id": 167072664,
			"lng": -77.38684301,
			"lat": 37.53714892,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1911,
			"dm": 9,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Carrie",
			"nl": "Randolph",
			"url": "https://findagrave.com/memorial/142106232",
			"id": 142106232,
			"lng": -77.38586104,
			"lat": 37.53736977,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1900,
			"dm": 4,
			"dd": 9,
			"by": 1866,
			"bd": 14,
			"bm": 6,
			"nm": "",
			"nf": "Eddie",
			"nl": "Randolph",
			"url": "https://findagrave.com/memorial/138926519",
			"id": 138926519,
			"lng": -77.38635128,
			"lat": 37.53656926,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 11,
			"dd": 9,
			"by": 1896,
			"bd": 1,
			"bm": 1,
			"nm": "G.",
			"nf": "Hamlet",
			"nl": "Randolph",
			"url": "https://findagrave.com/memorial/137332649",
			"id": 137332649,
			"lng": -77.38601984,
			"lat": 37.53696507,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 12,
			"dd": 20,
			"by": 1866,
			"bd": 1,
			"bm": 1,
			"nm": "",
			"nf": "Henry",
			"nl": "Randolph",
			"url": "https://findagrave.com/memorial/142106234",
			"id": 142106234,
			"lng": -77.38585282,
			"lat": 37.53738266,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 3,
			"dd": 29,
			"by": 1892,
			"bd": 4,
			"bm": 2,
			"nm": "Cooper",
			"nf": "Hezekiah",
			"nl": "Randolph",
			"url": "https://findagrave.com/memorial/143058187",
			"id": 143058187,
			"lng": -77.38639799,
			"lat": 37.53546601,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 7,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Louise",
			"nl": "Randolph",
			"url": "https://findagrave.com/memorial/150677877",
			"id": 150677877,
			"lng": -77.38640613,
			"lat": 37.53549455,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 2,
			"dd": 17,
			"by": 1890,
			"bd": 4,
			"bm": 9,
			"nm": "Louise",
			"nf": "Maria",
			"nl": "Randolph",
			"url": "https://findagrave.com/memorial/138570893",
			"id": 138570893,
			"lng": -77.38635323,
			"lat": 37.53656043,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 8,
			"dd": 17,
			"by": 1908,
			"bd": 5,
			"bm": 6,
			"nm": "L.",
			"nf": "Pearl",
			"nl": "Randolph",
			"url": "https://findagrave.com/memorial/143058197",
			"id": 143058197,
			"lng": -77.38641233,
			"lat": 37.53549694,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 7,
			"dd": 10,
			"by": 1882,
			"bd": 5,
			"bm": 4,
			"nm": "",
			"nf": "Silas",
			"nl": "Randolph",
			"url": "https://findagrave.com/memorial/159762344",
			"id": 159762344,
			"lng": -77.38805344,
			"lat": 37.53778726,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 6,
			"dd": 7,
			"by": 1914,
			"bd": 19,
			"bm": 6,
			"nm": "D.",
			"nf": "Verlene",
			"nl": "Randolph",
			"url": "https://findagrave.com/memorial/128452621",
			"id": 128452621,
			"lng": -77.38564445,
			"lat": 37.53701692,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 3,
			"dd": 25,
			"by": 1881,
			"bd": 28,
			"bm": 10,
			"nm": "Ruth",
			"nf": "Vivian",
			"nl": "Randolph",
			"url": "https://findagrave.com/memorial/155021677",
			"id": 155021677,
			"lng": -77.38650576,
			"lat": 37.5375732,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 9,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Walter",
			"nl": "Randolph",
			"url": "https://findagrave.com/memorial/143058205",
			"id": 143058205,
			"lng": -77.38642245,
			"lat": 37.53548142,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 6,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Arthur",
			"nl": "Ransom",
			"url": "https://findagrave.com/memorial/176769019",
			"id": 176769019,
			"lng": -77.38774391,
			"lat": 37.53701968,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 1,
			"dd": 7,
			"by": 1903,
			"bd": 30,
			"bm": 3,
			"nm": "L.",
			"nf": "Clarence",
			"nl": "Ransom",
			"url": "https://findagrave.com/memorial/160037510",
			"id": 160037510,
			"lng": -77.3865665,
			"lat": 37.53747216,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 5,
			"dd": 26,
			"by": 1903,
			"bd": 21,
			"bm": 8,
			"nm": "L.",
			"nf": "Maria",
			"nl": "Ransom",
			"url": "https://findagrave.com/memorial/129211487",
			"id": 129211487,
			"lng": -77.38595861,
			"lat": 37.53674099,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 3,
			"dd": 16,
			"by": 1926,
			"bd": 31,
			"bm": 12,
			"nm": "",
			"nf": "Ruth",
			"nl": "Ray",
			"url": "https://findagrave.com/memorial/158924517",
			"id": 158924517,
			"lng": -77.38685647,
			"lat": 37.53740855,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 1,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Charles",
			"nl": "Reaves",
			"url": "https://findagrave.com/memorial/166075723",
			"id": 166075723,
			"lng": -77.38569313,
			"lat": 37.53689645,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 6,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lula",
			"nl": "Reaves",
			"url": "https://findagrave.com/memorial/115720697",
			"id": 115720697,
			"lng": -77.38571851,
			"lat": 37.53690779,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 4,
			"dd": 29,
			"by": 1891,
			"bd": 15,
			"bm": 11,
			"nm": "H.",
			"nf": "W.",
			"nl": "Reddick",
			"url": "https://findagrave.com/memorial/187366758",
			"id": 187366758,
			"lng": -77.3879611,
			"lat": 37.53723589,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 7,
			"dd": 11,
			"by": 1898,
			"bd": 25,
			"bm": 8,
			"nm": "",
			"nf": "Arthur",
			"nl": "Reed",
			"url": "https://findagrave.com/memorial/187366761",
			"id": 187366761,
			"lng": -77.38597685,
			"lat": 37.53742007,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 6,
			"dd": 29,
			"by": 1880,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "Reed",
			"url": "https://findagrave.com/memorial/175610636",
			"id": 175610636,
			"lng": -77.38765606,
			"lat": 37.53701505,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 1,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Martha",
			"nl": "Reed",
			"url": "https://findagrave.com/memorial/153100525",
			"id": 153100525,
			"lng": -77.3867076,
			"lat": 37.53583043,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 4,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Eunice",
			"nl": "Reese",
			"url": "https://findagrave.com/memorial/144189029",
			"id": 144189029,
			"lng": -77.38593337,
			"lat": 37.53727215,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 2,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jessie",
			"nl": "Reynolds",
			"url": "https://findagrave.com/memorial/173512839",
			"id": 173512839,
			"lng": -77.38749348,
			"lat": 37.5370985,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 1,
			"dd": 2,
			"by": 1891,
			"bd": 30,
			"bm": 11,
			"nm": "",
			"nf": "Lillie",
			"nl": "Reynolds",
			"url": "https://findagrave.com/memorial/174859476",
			"id": 174859476,
			"lng": -77.38749584,
			"lat": 37.53708686,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 8,
			"dd": 23,
			"by": 1843,
			"bd": 28,
			"bm": 3,
			"nm": "J.",
			"nf": "Sarah",
			"nl": "Richards",
			"url": "https://findagrave.com/memorial/130695428",
			"id": 130695428,
			"lng": -77.38689296,
			"lat": 37.53541839,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 7,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Richardson",
			"url": "https://findagrave.com/memorial/139146925",
			"id": 139146925,
			"lng": -77.38780326,
			"lat": 37.53695485,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 12,
			"dd": 23,
			"by": 1889,
			"bd": 11,
			"bm": 10,
			"nm": "",
			"nf": "John",
			"nl": "Richardson",
			"url": "https://findagrave.com/memorial/171769836",
			"id": 171769836,
			"lng": -77.38719554,
			"lat": 37.53674525,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 3,
			"dd": 31,
			"by": 1881,
			"bd": 16,
			"bm": 4,
			"nm": "F.",
			"nf": "Mary",
			"nl": "Richardson",
			"url": "https://findagrave.com/memorial/160048630",
			"id": 160048630,
			"lng": -77.38650897,
			"lat": 37.5375644,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 7,
			"dd": 5,
			"by": 1890,
			"bd": 9,
			"bm": 3,
			"nm": "Esther",
			"nf": "Queen",
			"nl": "Richardson",
			"url": "https://findagrave.com/memorial/154512676",
			"id": 154512676,
			"lng": -77.38642988,
			"lat": 37.53566696,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 2,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sylvia",
			"nl": "Richardson",
			"url": "https://findagrave.com/memorial/159416149",
			"id": 159416149,
			"lng": -77.38611931,
			"lat": 37.53748117,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 13,
			"by": 1895,
			"bd": 28,
			"bm": 3,
			"nm": "",
			"nf": "William",
			"nl": "Richardson",
			"url": "https://findagrave.com/memorial/185658494",
			"id": 185658494,
			"lng": -77.38744263,
			"lat": 37.53739107,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 11,
			"dd": 3,
			"by": 1921,
			"bd": 1,
			"bm": 8,
			"nm": "L.",
			"nf": "William",
			"nl": "Richardson",
			"url": "https://findagrave.com/memorial/171769847",
			"id": 171769847,
			"lng": -77.38675781,
			"lat": 37.53733324,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 9,
			"dd": 8,
			"by": 1877,
			"bd": 2,
			"bm": 9,
			"nm": "",
			"nf": "David",
			"nl": "Riley",
			"url": "https://findagrave.com/memorial/154393444",
			"id": 154393444,
			"lng": -77.38621292,
			"lat": 37.53603839,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 3,
			"dd": 27,
			"by": 1863,
			"bd": "",
			"bm": 9,
			"nm": "",
			"nf": "Peter",
			"nl": "Riley",
			"url": "https://findagrave.com/memorial/132764945",
			"id": 132764945,
			"lng": -77.38783649,
			"lat": 37.53637585,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 6,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Arnie",
			"nl": "Roane",
			"url": "https://findagrave.com/memorial/146019975",
			"id": 146019975,
			"lng": -77.38656444,
			"lat": 37.53663054,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 2,
			"dd": 1,
			"by": 1868,
			"bd": 18,
			"bm": 2,
			"nm": "",
			"nf": "Bessie",
			"nl": "Roane",
			"url": "https://findagrave.com/memorial/117804449",
			"id": 117804449,
			"lng": -77.38594926,
			"lat": 37.53719774,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 6,
			"dd": 26,
			"by": 1887,
			"bd": 25,
			"bm": 12,
			"nm": "",
			"nf": "Christine",
			"nl": "Roane",
			"url": "https://findagrave.com/memorial/133137521",
			"id": 133137521,
			"lng": -77.38705387,
			"lat": 37.5370284,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 12,
			"dd": 4,
			"by": 1887,
			"bd": 18,
			"bm": 8,
			"nm": "E.",
			"nf": "Freddie",
			"nl": "Roane",
			"url": "https://findagrave.com/memorial/175595371",
			"id": 175595371,
			"lng": -77.38644719,
			"lat": 37.53531113,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1912,
			"dm": 11,
			"dd": 19,
			"by": 1838,
			"bd": 18,
			"bm": 2,
			"nm": "Washington",
			"nf": "George",
			"nl": "Roane",
			"url": "https://findagrave.com/memorial/131428513",
			"id": 131428513,
			"lng": -77.38756011,
			"lat": 37.53653411,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 8,
			"dd": 1,
			"by": 1885,
			"bd": 8,
			"bm": 2,
			"nm": "Wallace",
			"nf": "George",
			"nl": "Roane",
			"url": "https://findagrave.com/memorial/133137532",
			"id": 133137532,
			"lng": -77.38704951,
			"lat": 37.53703731,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 10,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jeanette",
			"nl": "Roane",
			"url": "https://findagrave.com/memorial/144189040",
			"id": 144189040,
			"lng": -77.38591239,
			"lat": 37.53731533,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 8,
			"dd": 20,
			"by": 1864,
			"bd": 26,
			"bm": 8,
			"nm": "H.",
			"nf": "John",
			"nl": "Roane",
			"url": "https://findagrave.com/memorial/143865748",
			"id": 143865748,
			"lng": -77.3860708,
			"lat": 37.53598975,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 4,
			"dd": 13,
			"by": 1869,
			"bd": 23,
			"bm": 11,
			"nm": "Elizabeth",
			"nf": "Mary",
			"nl": "Roane",
			"url": "https://findagrave.com/memorial/143635840",
			"id": 143635840,
			"lng": -77.38607484,
			"lat": 37.53597927,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 1,
			"dd": 23,
			"by": 1896,
			"bd": 30,
			"bm": 6,
			"nm": "Elizabeth",
			"nf": "Mary",
			"nl": "Roane",
			"url": "https://findagrave.com/memorial/156286037",
			"id": 156286037,
			"lng": -77.38587273,
			"lat": 37.5370388,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1902,
			"dm": 1,
			"dd": 6,
			"by": 1835,
			"bd": 6,
			"bm": 9,
			"nm": "",
			"nf": "Matilda",
			"nl": "Roane",
			"url": "https://findagrave.com/memorial/146019988",
			"id": 146019988,
			"lng": -77.38636962,
			"lat": 37.53650573,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 3,
			"dd": 29,
			"by": 1889,
			"bd": 12,
			"bm": 4,
			"nm": "",
			"nf": "Spencer",
			"nl": "Roane",
			"url": "https://findagrave.com/memorial/117804446",
			"id": 117804446,
			"lng": -77.38595087,
			"lat": 37.53719367,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 5,
			"dd": 28,
			"by": 1909,
			"bd": 7,
			"bm": 4,
			"nm": "",
			"nf": "Virginia",
			"nl": "Roane",
			"url": "https://findagrave.com/memorial/155531238",
			"id": 155531238,
			"lng": -77.3876771,
			"lat": 37.53770739,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 3,
			"dd": 31,
			"by": 1913,
			"bd": 14,
			"bm": 6,
			"nm": "Lee",
			"nf": "Russell",
			"nl": "Robbs",
			"url": "https://findagrave.com/memorial/176247927",
			"id": 176247927,
			"lng": -77.38771677,
			"lat": 37.53742873,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 2,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Martha",
			"nl": "Roberts",
			"url": "https://findagrave.com/memorial/146019996",
			"id": 146019996,
			"lng": -77.38771915,
			"lat": 37.53672416,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 12,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Dora",
			"nl": "Robertson",
			"url": "https://findagrave.com/memorial/177898224",
			"id": 177898224,
			"lng": -77.38756911,
			"lat": 37.53730999,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 11,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lawrence",
			"nl": "Robertson",
			"url": "https://findagrave.com/memorial/144189167",
			"id": 144189167,
			"lng": -77.38590124,
			"lat": 37.53742656,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 7,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alice",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/117804450",
			"id": 117804450,
			"lng": -77.38546573,
			"lat": 37.53733739,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 12,
			"dd": 24,
			"by": 1921,
			"bd": 13,
			"bm": 8,
			"nm": "Eloise",
			"nf": "Alma",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/156480524",
			"id": 156480524,
			"lng": -77.38573506,
			"lat": 37.53707867,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 4,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Armistead",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/126772103",
			"id": 126772103,
			"lng": -77.38782036,
			"lat": 37.53704295,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 7,
			"dd": 16,
			"by": 1897,
			"bd": 15,
			"bm": 10,
			"nm": "",
			"nf": "Arthur",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/150637828",
			"id": 150637828,
			"lng": -77.38637421,
			"lat": 37.53593329,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 10,
			"dd": 27,
			"by": 1914,
			"bd": 2,
			"bm": 5,
			"nm": "",
			"nf": "Bessie",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/114399879",
			"id": 114399879,
			"lng": -77.38574059,
			"lat": 37.53681945,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 8,
			"dd": 9,
			"by": 1854,
			"bd": "",
			"bm": 1,
			"nm": "",
			"nf": "Catherine",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/156656248",
			"id": 156656248,
			"lng": -77.3869832,
			"lat": 37.53554503,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 9,
			"dd": 22,
			"by": 1904,
			"bd": 26,
			"bm": 5,
			"nm": "J.",
			"nf": "Charles",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/168837068",
			"id": 168837068,
			"lng": -77.3865056,
			"lat": 37.53687745,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 3,
			"dd": 12,
			"by": 1907,
			"bd": 15,
			"bm": 9,
			"nm": "",
			"nf": "Cornelius",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/175585521",
			"id": 175585521,
			"lng": -77.38704297,
			"lat": 37.53697232,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 1,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Crenshaw",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/125313084",
			"id": 125313084,
			"lng": -77.38800645,
			"lat": 37.53726818,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 6,
			"dd": 20,
			"by": 1911,
			"bd": 15,
			"bm": 4,
			"nm": "",
			"nf": "Ellerson",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/161636492",
			"id": 161636492,
			"lng": -77.3865617,
			"lat": 37.53665303,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 1,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Emanuel",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/113626527",
			"id": 113626527,
			"lng": -77.38646247,
			"lat": 37.53658789,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 1,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Eva",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/167465645",
			"id": 167465645,
			"lng": -77.38784425,
			"lat": 37.53727171,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 9,
			"dd": 12,
			"by": 1915,
			"bd": 17,
			"bm": 7,
			"nm": "J.",
			"nf": "Frederick",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/128675446",
			"id": 128675446,
			"lng": -77.38614298,
			"lat": 37.53661115,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 11,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "George",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/76605051",
			"id": 76605051,
			"lng": -77.38546336,
			"lat": 37.53734692,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 12,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Gertrude",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/130426364",
			"id": 130426364,
			"lng": -77.38607981,
			"lat": 37.53585238,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1983,
			"dm": 2,
			"dd": 26,
			"by": 1895,
			"bd": 22,
			"bm": 6,
			"nm": "Ann",
			"nf": "Grace",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/158335471",
			"id": 158335471,
			"lng": -77.38613933,
			"lat": 37.53661723,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 7,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "Henry",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/175611552",
			"id": 175611552,
			"lng": -77.38767049,
			"lat": 37.5370649,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 2,
			"dd": 3,
			"by": 1911,
			"bd": 24,
			"bm": 10,
			"nm": "W.",
			"nf": "Irvin",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/126456553",
			"id": 126456553,
			"lng": -77.38635052,
			"lat": 37.53600402,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 9,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/181156845",
			"id": 181156845,
			"lng": -77.38817101,
			"lat": 37.5375152,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 12,
			"dd": 24,
			"by": 1894,
			"bd": 10,
			"bm": 9,
			"nm": "",
			"nf": "James",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/177762251",
			"id": 177762251,
			"lng": -77.38789898,
			"lat": 37.53746117,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 4,
			"dd": 23,
			"by": 1896,
			"bd": 21,
			"bm": 10,
			"nm": "Edward",
			"nf": "James",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/151267641",
			"id": 151267641,
			"lng": -77.386903,
			"lat": 37.53699571,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 9,
			"dd": 26,
			"by": 1898,
			"bd": 1,
			"bm": 4,
			"nm": "",
			"nf": "Janie",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/173664292",
			"id": 173664292,
			"lng": -77.3870716,
			"lat": 37.53731218,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 1,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/158945986",
			"id": 158945986,
			"lng": -77.38693735,
			"lat": 37.53745619,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 9,
			"dd": 2,
			"by": 1891,
			"bd": 26,
			"bm": 12,
			"nm": "Luke",
			"nf": "John",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/150349823",
			"id": 150349823,
			"lng": -77.38652815,
			"lat": 37.53733523,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 4,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Joseph",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/151461546",
			"id": 151461546,
			"lng": -77.38815918,
			"lat": 37.5373957,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 4,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Justine",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/122793576",
			"id": 122793576,
			"lng": -77.38567329,
			"lat": 37.53699003,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 7,
			"dd": 3,
			"by": 1888,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Leanna",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/150349054",
			"id": 150349054,
			"lng": -77.38650431,
			"lat": 37.5373398,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 2,
			"dd": 19,
			"by": 1934,
			"bd": 28,
			"bm": 11,
			"nm": "Thomas",
			"nf": "Lemuel",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/176767940",
			"id": 176767940,
			"lng": -77.38767274,
			"lat": 37.53687297,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 9,
			"dd": 7,
			"by": 1890,
			"bd": 31,
			"bm": 7,
			"nm": "",
			"nf": "Leslie",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/173920533",
			"id": 173920533,
			"lng": -77.38713131,
			"lat": 37.53733916,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 5,
			"dd": 30,
			"by": 1893,
			"bd": 14,
			"bm": 4,
			"nm": "",
			"nf": "Louis",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/125643956",
			"id": 125643956,
			"lng": -77.38576961,
			"lat": 37.5366203,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 12,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Louise",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/141194255",
			"id": 141194255,
			"lng": -77.38644075,
			"lat": 37.53660257,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 12,
			"dd": 1,
			"by": 1887,
			"bd": 12,
			"bm": 1,
			"nm": "",
			"nf": "Lucy",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/187366765",
			"id": 187366765,
			"lng": -77.38762266,
			"lat": 37.53737617,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 6,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Maria",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/188438585",
			"id": 188438585,
			"lng": -77.38789608,
			"lat": 37.53701346,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 9,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Mary",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/186818146",
			"id": 186818146,
			"lng": -77.38735959,
			"lat": 37.53708585,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 10,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Mary",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/151112006",
			"id": 151112006,
			"lng": -77.38680758,
			"lat": 37.53575979,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 12,
			"dd": 14,
			"by": 1908,
			"bd": 7,
			"bm": 7,
			"nm": "J.",
			"nf": "Mary",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/190047985",
			"id": 190047985,
			"lng": -77.38596553,
			"lat": 37.53632799,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 12,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Mary",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/76605090",
			"id": 76605090,
			"lng": -77.38547371,
			"lat": 37.5373452,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1913,
			"dm": 2,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Mattie",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/145838765",
			"id": 145838765,
			"lng": -77.3867074,
			"lat": 37.53577037,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 1,
			"dd": 11,
			"by": 1891,
			"bd": 25,
			"bm": 11,
			"nm": "",
			"nf": "Nannie",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/128675455",
			"id": 128675455,
			"lng": -77.3860684,
			"lat": 37.53663833,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 6,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "S.",
			"nf": "Page",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/177617289",
			"id": 177617289,
			"lng": -77.38698226,
			"lat": 37.53553775,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 1,
			"dd": 18,
			"by": 1907,
			"bd": 8,
			"bm": 4,
			"nm": "Henry",
			"nf": "Patrick",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/179570304",
			"id": 179570304,
			"lng": -77.3879292,
			"lat": 37.53765618,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 12,
			"dd": 4,
			"by": 1918,
			"bd": 29,
			"bm": 3,
			"nm": "Esther",
			"nf": "Queen",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/148285773",
			"id": 148285773,
			"lng": -77.38643855,
			"lat": 37.53725213,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 11,
			"dd": 6,
			"by": 1909,
			"bd": 6,
			"bm": 4,
			"nm": "Andrew",
			"nf": "Samuel",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/191417559",
			"id": 191417559,
			"lng": -77.38641119,
			"lat": 37.53743579,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1911,
			"dm": 1,
			"dd": 27,
			"by": 1845,
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "Sandy",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/151884949",
			"id": 151884949,
			"lng": -77.3867138,
			"lat": 37.5357584,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 3,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sarah",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/188438924",
			"id": 188438924,
			"lng": -77.38794823,
			"lat": 37.53703209,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 5,
			"dd": 10,
			"by": 1925,
			"bd": 27,
			"bm": 2,
			"nm": "C.",
			"nf": "Walter",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/151942716",
			"id": 151942716,
			"lng": -77.38580608,
			"lat": 37.53721752,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 12,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/175421012",
			"id": 175421012,
			"lng": -77.38761808,
			"lat": 37.53716035,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 5,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/152794743",
			"id": 152794743,
			"lng": -77.38600175,
			"lat": 37.53745525,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 3,
			"dd": 30,
			"by": 1913,
			"bd": 17,
			"bm": 12,
			"nm": "H",
			"nf": "Lacie",
			"nl": "Rogers",
			"url": "https://findagrave.com/memorial/143866092",
			"id": 143866092,
			"lng": -77.38604394,
			"lat": 37.53729632,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 11,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "D.",
			"nf": "Thomas",
			"nl": "Rogers",
			"url": "https://findagrave.com/memorial/161947672",
			"id": 161947672,
			"lng": -77.38582403,
			"lat": 37.53658479,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 8,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Watson",
			"nl": "Rollison",
			"url": "https://findagrave.com/memorial/187744063",
			"id": 187744063,
			"lng": -77.38785248,
			"lat": 37.53694171,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 9,
			"dd": 2,
			"by": 1885,
			"bd": 5,
			"bm": 7,
			"nm": "Henry",
			"nf": "James",
			"nl": "Roots",
			"url": "https://findagrave.com/memorial/174597877",
			"id": 174597877,
			"lng": -77.38749343,
			"lat": 37.53717449,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 9,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Patsie",
			"nl": "Roots",
			"url": "https://findagrave.com/memorial/174783256",
			"id": 174783256,
			"lng": -77.38753807,
			"lat": 37.53700914,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 4,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rebecca",
			"nl": "Roots",
			"url": "https://findagrave.com/memorial/174112659",
			"id": 174112659,
			"lng": -77.38750114,
			"lat": 37.53715536,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 7,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Eva",
			"nl": "Rose",
			"url": "https://findagrave.com/memorial/187898056",
			"id": 187898056,
			"lng": -77.38797673,
			"lat": 37.53716818,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 5,
			"dd": 16,
			"by": 1898,
			"bd": 14,
			"bm": 9,
			"nm": "G.",
			"nf": "Minnie",
			"nl": "Rose",
			"url": "https://findagrave.com/memorial/185658495",
			"id": 185658495,
			"lng": -77.38743698,
			"lat": 37.53768317,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 12,
			"dd": 21,
			"by": 1894,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Otelia",
			"nl": "Rose",
			"url": "https://findagrave.com/memorial/138570905",
			"id": 138570905,
			"lng": -77.38628948,
			"lat": 37.53659736,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 1,
			"dd": 13,
			"by": 1894,
			"bd": 4,
			"bm": 6,
			"nm": "",
			"nf": "William",
			"nl": "Rose",
			"url": "https://findagrave.com/memorial/144013918",
			"id": 144013918,
			"lng": -77.3872129,
			"lat": 37.53764247,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 10,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Atelia",
			"nl": "Ross",
			"url": "https://findagrave.com/memorial/152318042",
			"id": 152318042,
			"lng": -77.386858,
			"lat": 37.53576204,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 9,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Clara",
			"nl": "Ross",
			"url": "https://findagrave.com/memorial/184398967",
			"id": 184398967,
			"lng": -77.38785953,
			"lat": 37.53693594,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Cornelious",
			"nl": "Ross",
			"url": "https://findagrave.com/memorial/207135161",
			"id": 207135161,
			"lng": -77.38625149,
			"lat": 37.53535526,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 11,
			"dd": 9,
			"by": 1962,
			"bd": 8,
			"bm": 10,
			"nm": "Vonzell",
			"nf": "Felipe",
			"nl": "Ross",
			"url": "https://findagrave.com/memorial/159416168",
			"id": 159416168,
			"lng": -77.38615816,
			"lat": 37.53750928,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 3,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Carpenter",
			"nf": "Mattie",
			"nl": "Ross",
			"url": "https://findagrave.com/memorial/174710152",
			"id": 174710152,
			"lng": -77.38755193,
			"lat": 37.53699811,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 1,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Pearl",
			"nl": "Ross",
			"url": "https://findagrave.com/memorial/183194584",
			"id": 183194584,
			"lng": -77.38717517,
			"lat": 37.53702926,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 8,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Philip",
			"nl": "Ross",
			"url": "https://findagrave.com/memorial/183718560",
			"id": 183718560,
			"lng": -77.38699129,
			"lat": 37.53700685,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 8,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rolley",
			"nl": "Ross",
			"url": "https://findagrave.com/memorial/179535043",
			"id": 179535043,
			"lng": -77.38796575,
			"lat": 37.53765307,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 8,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Elizabeth",
			"nf": "Sarah",
			"nl": "Ross",
			"url": "https://findagrave.com/memorial/148285788",
			"id": 148285788,
			"lng": -77.38624484,
			"lat": 37.53533626,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 5,
			"dd": 4,
			"by": 1938,
			"bd": 27,
			"bm": 2,
			"nm": "Y.",
			"nf": "Dorothy",
			"nl": "Rowe",
			"url": "https://findagrave.com/memorial/160335453",
			"id": 160335453,
			"lng": -77.38611549,
			"lat": 37.53634528,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 1,
			"dd": 1,
			"by": 1929,
			"bd": 28,
			"bm": 10,
			"nm": "",
			"nf": "Fannie",
			"nl": "Royster",
			"url": "https://findagrave.com/memorial/145596030",
			"id": 145596030,
			"lng": -77.38621077,
			"lat": 37.5373868,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 12,
			"dd": 30,
			"by": 1965,
			"bd": 11,
			"bm": 5,
			"nm": "Ann",
			"nf": "Mary",
			"nl": "Royster",
			"url": "https://findagrave.com/memorial/142106240",
			"id": 142106240,
			"lng": -77.38596538,
			"lat": 37.53743904,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 8,
			"dd": 1,
			"by": 1900,
			"bd": 9,
			"bm": 4,
			"nm": "Lee",
			"nf": "Milton",
			"nl": "Royster",
			"url": "https://findagrave.com/memorial/156215163",
			"id": 156215163,
			"lng": -77.38685798,
			"lat": 37.53543129,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 11,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Milton",
			"nl": "Royster",
			"url": "https://findagrave.com/memorial/151449325",
			"id": 151449325,
			"lng": -77.38686447,
			"lat": 37.53541574,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 3,
			"dd": 28,
			"by": 1900,
			"bd": 29,
			"bm": 10,
			"nm": "",
			"nf": "Pearl",
			"nl": "Rucker",
			"url": "https://findagrave.com/memorial/187366771",
			"id": 187366771,
			"lng": -77.38712576,
			"lat": 37.53689353,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 5,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Frazier",
			"nl": "Ruffin",
			"url": "https://findagrave.com/memorial/176055817",
			"id": 176055817,
			"lng": -77.38734483,
			"lat": 37.53704303,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 6,
			"dd": 17,
			"by": 1891,
			"bd": "",
			"bm": 4,
			"nm": "Ann",
			"nf": "Sallie",
			"nl": "Ruffin",
			"url": "https://findagrave.com/memorial/120147071",
			"id": 120147071,
			"lng": -77.38598357,
			"lat": 37.53674858,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 1,
			"dd": 18,
			"by": 1962,
			"bd": 18,
			"bm": 10,
			"nm": "",
			"nf": "Ernestine",
			"nl": "Russell",
			"url": "https://findagrave.com/memorial/169041076",
			"id": 169041076,
			"lng": -77.3861343,
			"lat": 37.53749592,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 9,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ella",
			"nl": "Russell",
			"url": "https://findagrave.com/memorial/174694011",
			"id": 174694011,
			"lng": -77.38680126,
			"lat": 37.53769082,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 12,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Thomas",
			"nl": "Russell",
			"url": "https://findagrave.com/memorial/149201622",
			"id": 149201622,
			"lng": -77.38616764,
			"lat": 37.53608125,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 4,
			"dd": 25,
			"by": 1891,
			"bd": 10,
			"bm": 8,
			"nm": "",
			"nf": "Armstead",
			"nl": "Rustin",
			"url": "https://findagrave.com/memorial/138366556",
			"id": 138366556,
			"lng": -77.38663166,
			"lat": 37.53696533,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 7,
			"dd": 13,
			"by": 1925,
			"bd": 3,
			"bm": 3,
			"nm": "",
			"nf": "Maria",
			"nl": "Rustin",
			"url": "https://findagrave.com/memorial/169281489",
			"id": 169281489,
			"lng": -77.38654984,
			"lat": 37.53683499,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 6,
			"dd": 30,
			"by": 1891,
			"bd": 8,
			"bm": 8,
			"nm": "",
			"nf": "Vearylant",
			"nl": "Rustin",
			"url": "https://findagrave.com/memorial/174599396",
			"id": 174599396,
			"lng": -77.38717936,
			"lat": 37.5369697,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 7,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Martha",
			"nl": "Sales",
			"url": "https://findagrave.com/memorial/175402352",
			"id": 175402352,
			"lng": -77.38753516,
			"lat": 37.53696456,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 4,
			"dd": 14,
			"by": 1908,
			"bd": 6,
			"bm": 11,
			"nm": "",
			"nf": "Maggie",
			"nl": "Sampson",
			"url": "https://findagrave.com/memorial/128675475",
			"id": 128675475,
			"lng": -77.38619831,
			"lat": 37.53664371,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 9,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Leroy",
			"nl": "Samuels",
			"url": "https://findagrave.com/memorial/149202699",
			"id": 149202699,
			"lng": -77.38629525,
			"lat": 37.53548007,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 10,
			"dd": 25,
			"by": 1918,
			"bd": 16,
			"bm": 3,
			"nm": "",
			"nf": "Margaret",
			"nl": "Sanford",
			"url": "https://findagrave.com/memorial/191503854",
			"id": 191503854,
			"lng": -77.38646494,
			"lat": 37.53741211,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1985,
			"dm": 4,
			"dd": 30,
			"by": 1894,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jack",
			"nl": "Santos",
			"url": "https://findagrave.com/memorial/141800964",
			"id": 141800964,
			"lng": -77.38666154,
			"lat": 37.53729468,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 12,
			"dd": 19,
			"by": 1908,
			"bd": 1,
			"bm": 7,
			"nm": "Maria",
			"nf": "Sallie",
			"nl": "Santos",
			"url": "https://findagrave.com/memorial/141701282",
			"id": 141701282,
			"lng": -77.38668339,
			"lat": 37.53731403,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1988,
			"dm": "",
			"dd": "",
			"by": 1912,
			"bd": "",
			"bm": "",
			"nm": "Ernestine",
			"nf": "Alice",
			"nl": "Satterwhite",
			"url": "https://findagrave.com/memorial/122027614",
			"id": 122027614,
			"lng": -77.38602224,
			"lat": 37.53661986,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 6,
			"dd": 30,
			"by": 1887,
			"bd": 24,
			"bm": 4,
			"nm": "",
			"nf": "Clotelle",
			"nl": "Saunders",
			"url": "https://findagrave.com/memorial/182608061",
			"id": 182608061,
			"lng": -77.38628108,
			"lat": 37.5354613,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 12,
			"dd": 29,
			"by": 1937,
			"bd": 8,
			"bm": 8,
			"nm": "Lil",
			"nf": "Hannah",
			"nl": "Saunders",
			"url": "https://findagrave.com/memorial/156187918",
			"id": 156187918,
			"lng": -77.38639522,
			"lat": 37.5353067,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1907,
			"dm": 9,
			"dd": 11,
			"by": 1855,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Saunders",
			"url": "https://findagrave.com/memorial/130426370",
			"id": 130426370,
			"lng": -77.38608383,
			"lat": 37.53584244,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 3,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lelia",
			"nl": "Saunders",
			"url": "https://findagrave.com/memorial/174796572",
			"id": 174796572,
			"lng": -77.38764274,
			"lat": 37.5369204,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 12,
			"dd": 3,
			"by": 1902,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Pearl",
			"nl": "Saunders",
			"url": "https://findagrave.com/memorial/127569742",
			"id": 127569742,
			"lng": -77.38610469,
			"lat": 37.53708106,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 2,
			"dd": 7,
			"by": 1900,
			"bd": 12,
			"bm": 4,
			"nm": "",
			"nf": "Martha",
			"nl": "Sayles",
			"url": "https://findagrave.com/memorial/155021683",
			"id": 155021683,
			"lng": -77.38688097,
			"lat": 37.53734845,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 6,
			"dd": 13,
			"by": 1894,
			"bd": "",
			"bm": 2,
			"nm": "",
			"nf": "Percy",
			"nl": "Sayles",
			"url": "https://findagrave.com/memorial/155021695",
			"id": 155021695,
			"lng": -77.38687807,
			"lat": 37.53735592,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1906,
			"dm": 11,
			"dd": 17,
			"by": 1882,
			"bd": 29,
			"bm": 10,
			"nm": "P.",
			"nf": "Adalena",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/132642689",
			"id": 132642689,
			"lng": -77.38774921,
			"lat": 37.53653861,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": 7,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alice",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/143191589",
			"id": 143191589,
			"lng": -77.38636614,
			"lat": 37.53566835,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 9,
			"dd": 5,
			"by": 1864,
			"bd": "",
			"bm": 10,
			"nm": "",
			"nf": "Alpheus",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/125643969",
			"id": 125643969,
			"lng": -77.38554856,
			"lat": 37.5371342,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": 3,
			"dd": 7,
			"by": 1883,
			"bd": 19,
			"bm": 12,
			"nm": "J.",
			"nf": "Andrew",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/127881103",
			"id": 127881103,
			"lng": -77.38628046,
			"lat": 37.53635851,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": 5,
			"dd": 20,
			"by": 1890,
			"bd": 11,
			"bm": 3,
			"nm": "F.",
			"nf": "Arthur",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/127881109",
			"id": 127881109,
			"lng": -77.38628226,
			"lat": 37.53636813,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1906,
			"dm": 1,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "Bedford",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/143191584",
			"id": 143191584,
			"lng": -77.38636872,
			"lat": 37.53566863,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 7,
			"dd": 23,
			"by": 1894,
			"bd": 10,
			"bm": 11,
			"nm": "C.",
			"nf": "Bertha",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/76605146",
			"id": 76605146,
			"lng": -77.38610905,
			"lat": 37.53700661,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 5,
			"dd": 27,
			"by": 1900,
			"bd": 15,
			"bm": 9,
			"nm": "Booker",
			"nf": "Charles",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/158945994",
			"id": 158945994,
			"lng": -77.3868997,
			"lat": 37.53750481,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 11,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "R.",
			"nf": "Charles",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/134474453",
			"id": 134474453,
			"lng": -77.38611528,
			"lat": 37.53699179,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 6,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Elsie",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/121796893",
			"id": 121796893,
			"lng": -77.38578641,
			"lat": 37.53654221,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 10,
			"dd": 8,
			"by": 1893,
			"bd": 6,
			"bm": 8,
			"nm": "",
			"nf": "Eugenia",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/147853894",
			"id": 147853894,
			"lng": -77.38602868,
			"lat": 37.53629425,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 6,
			"dd": 29,
			"by": 1876,
			"bd": 3,
			"bm": 6,
			"nm": "",
			"nf": "Everlina",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/185658500",
			"id": 185658500,
			"lng": -77.38725134,
			"lat": 37.53772579,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 1,
			"dd": 19,
			"by": 1884,
			"bd": 17,
			"bm": 6,
			"nm": "B.",
			"nf": "Fannie",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/132642749",
			"id": 132642749,
			"lng": -77.38775131,
			"lat": 37.53653021,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 3,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Fannie",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/156613217",
			"id": 156613217,
			"lng": -77.3863927,
			"lat": 37.53711959,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 7,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Irene",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/125313091",
			"id": 125313091,
			"lng": -77.38593401,
			"lat": 37.53685348,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 6,
			"dd": 3,
			"by": 1874,
			"bd": 5,
			"bm": 1,
			"nm": "Emmett",
			"nf": "James",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/143191743",
			"id": 143191743,
			"lng": -77.38636571,
			"lat": 37.53567107,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1913,
			"dm": 12,
			"dd": 4,
			"by": 1858,
			"bd": "",
			"bm": 3,
			"nm": "Wesley P.",
			"nf": "John",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/132642759",
			"id": 132642759,
			"lng": -77.38772269,
			"lat": 37.53654347,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 3,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "R.",
			"nf": "John",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/143191735",
			"id": 143191735,
			"lng": -77.38636839,
			"lat": 37.53567125,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 4,
			"dd": 6,
			"by": 1891,
			"bd": 3,
			"bm": 9,
			"nm": "Mitchell",
			"nf": "John",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/143192310",
			"id": 143192310,
			"lng": -77.38602847,
			"lat": 37.53732341,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 2,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Henry",
			"nf": "John",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/114466968",
			"id": 114466968,
			"lng": -77.38593031,
			"lat": 37.53686472,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 10,
			"dd": 10,
			"by": 1891,
			"bd": 11,
			"bm": 9,
			"nm": "",
			"nf": "Joseph",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/172198018",
			"id": 172198018,
			"lng": -77.3864258,
			"lat": 37.53533403,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 3,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Josephine",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/143191604",
			"id": 143191604,
			"lng": -77.38636358,
			"lat": 37.53567933,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 3,
			"dd": 19,
			"by": 1859,
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Julia",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/139424729",
			"id": 139424729,
			"lng": -77.38629625,
			"lat": 37.53637804,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 1,
			"dd": 22,
			"by": 1914,
			"bd": 24,
			"bm": 6,
			"nm": "",
			"nf": "Katheleen",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/177325999",
			"id": 177325999,
			"lng": -77.38750771,
			"lat": 37.53731306,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 5,
			"dd": 26,
			"by": 1913,
			"bd": 6,
			"bm": 2,
			"nm": "",
			"nf": "Leaonza",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/176939600",
			"id": 176939600,
			"lng": -77.38697358,
			"lat": 37.53753645,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 2,
			"dd": 25,
			"by": 1895,
			"bd": 10,
			"bm": 10,
			"nm": "",
			"nf": "Lenard",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/183718565",
			"id": 183718565,
			"lng": -77.38699827,
			"lat": 37.53682879,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 9,
			"dd": 30,
			"by": 1876,
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Lucie",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/144821921",
			"id": 144821921,
			"lng": -77.3855573,
			"lat": 37.53715447,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 6,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Luther",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/136306541",
			"id": 136306541,
			"lng": -77.38629516,
			"lat": 37.53634335,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 5,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Maggie",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/187368543",
			"id": 187368543,
			"lng": -77.38732542,
			"lat": 37.53732644,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 1,
			"dd": 18,
			"by": 1861,
			"bd": "",
			"bm": 5,
			"nm": "",
			"nf": "Rosanna",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/132642764",
			"id": 132642764,
			"lng": -77.38772521,
			"lat": 37.53653516,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 2,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Sadie",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/155782478",
			"id": 155782478,
			"lng": -77.38724025,
			"lat": 37.53558498,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1906,
			"dm": 9,
			"dd": 28,
			"by": 1888,
			"bd": 5,
			"bm": 10,
			"nm": "W.",
			"nf": "Samuel",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/127881119",
			"id": 127881119,
			"lng": -77.3862816,
			"lat": 37.53634833,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 7,
			"dd": 8,
			"by": 1870,
			"bd": 18,
			"bm": 3,
			"nm": "",
			"nf": "Susie",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/176277199",
			"id": 176277199,
			"lng": -77.3877853,
			"lat": 37.5373829,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1913,
			"dm": 10,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Willie",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/125843832",
			"id": 125843832,
			"lng": -77.38636643,
			"lat": 37.5358896,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 9,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sally",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/192423887",
			"id": 192423887,
			"lng": -77.38741527,
			"lat": 37.53716395,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 5,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Gertrude",
			"nl": "Sears",
			"url": "https://findagrave.com/memorial/174712618",
			"id": 174712618,
			"lng": -77.38659378,
			"lat": 37.53709516,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 8,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L",
			"nf": "Carlton",
			"nl": "Seay",
			"url": "https://findagrave.com/memorial/149353188",
			"id": 149353188,
			"lng": -77.38663376,
			"lat": 37.5371906,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1909,
			"dm": 12,
			"dd": 13,
			"by": 1844,
			"bd": 14,
			"bm": 2,
			"nm": "M.",
			"nf": "Hannah",
			"nl": "Selden",
			"url": "https://findagrave.com/memorial/138570922",
			"id": 138570922,
			"lng": -77.38635702,
			"lat": 37.53655049,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 8,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rachel",
			"nl": "Selden",
			"url": "https://findagrave.com/memorial/138570933",
			"id": 138570933,
			"lng": -77.38635766,
			"lat": 37.53654154,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 12,
			"dd": 13,
			"by": 1850,
			"bd": "",
			"bm": 2,
			"nm": "S.",
			"nf": "William",
			"nl": "Selden",
			"url": "https://findagrave.com/memorial/138570948",
			"id": 138570948,
			"lng": -77.38632834,
			"lat": 37.53653661,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 4,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Willie",
			"nl": "Sexton",
			"url": "https://findagrave.com/memorial/144013922",
			"id": 144013922,
			"lng": -77.38604807,
			"lat": 37.5372614,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 3,
			"dd": 1,
			"by": 1916,
			"bd": 14,
			"bm": 8,
			"nm": "C.",
			"nf": "Alvin",
			"nl": "Shelton",
			"url": "https://findagrave.com/memorial/152369063",
			"id": 152369063,
			"lng": -77.38649758,
			"lat": 37.53739412,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 12,
			"dd": 28,
			"by": 1966,
			"bd": 2,
			"bm": 8,
			"nm": "",
			"nf": "Andrew",
			"nl": "Shelton",
			"url": "https://findagrave.com/memorial/142106261",
			"id": 142106261,
			"lng": -77.38594514,
			"lat": 37.53744736,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 4,
			"dd": 30,
			"by": 1880,
			"bd": 8,
			"bm": 4,
			"nm": "",
			"nf": "Kenneth",
			"nl": "Shelton",
			"url": "https://findagrave.com/memorial/168940043",
			"id": 168940043,
			"lng": -77.38598338,
			"lat": 37.537341,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 2,
			"dd": 20,
			"by": 1897,
			"bd": 21,
			"bm": 6,
			"nm": "L.",
			"nf": "Maria",
			"nl": "Shelton",
			"url": "https://findagrave.com/memorial/144226110",
			"id": 144226110,
			"lng": -77.38649618,
			"lat": 37.53740422,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 9,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Ellen",
			"nf": "Mary",
			"nl": "Shelton",
			"url": "https://findagrave.com/memorial/139146939",
			"id": 139146939,
			"lng": -77.38628884,
			"lat": 37.53653423,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 8,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Edward",
			"nf": "Thomas",
			"nl": "Shelton",
			"url": "https://findagrave.com/memorial/139146947",
			"id": 139146947,
			"lng": -77.38628225,
			"lat": 37.53654864,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 6,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Virginia",
			"nl": "Shelton",
			"url": "https://findagrave.com/memorial/141446518",
			"id": 141446518,
			"lng": -77.38703229,
			"lat": 37.53745379,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 4,
			"dd": 26,
			"by": 1888,
			"bd": 18,
			"bm": 3,
			"nm": "",
			"nf": "Virginia",
			"nl": "Shelton",
			"url": "https://findagrave.com/memorial/143866253",
			"id": 143866253,
			"lng": -77.38678898,
			"lat": 37.53668718,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 6,
			"dd": 11,
			"by": 1898,
			"bd": 2,
			"bm": 2,
			"nm": "",
			"nf": "Izetta",
			"nl": "Shelton",
			"url": "https://findagrave.com/memorial/192387018",
			"id": 192387018,
			"lng": -77.38630907,
			"lat": 37.53527374,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": 1854,
			"bd": 25,
			"bm": 12,
			"nm": "T.",
			"nf": "L.",
			"nl": "Shepard",
			"url": "https://findagrave.com/memorial/150792692",
			"id": 150792692,
			"lng": -77.38619457,
			"lat": 37.53565428,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 1,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "T.",
			"nf": "Cora",
			"nl": "Sherman",
			"url": "https://findagrave.com/memorial/137430832",
			"id": 137430832,
			"lng": -77.38597126,
			"lat": 37.53709701,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 2,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Willie",
			"nl": "Sherman",
			"url": "https://findagrave.com/memorial/137430845",
			"id": 137430845,
			"lng": -77.38597342,
			"lat": 37.53709049,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 12,
			"dd": 9,
			"by": 1920,
			"bd": 20,
			"bm": 8,
			"nm": "",
			"nf": "Lossie",
			"nl": "Sherod",
			"url": "https://findagrave.com/memorial/191503858",
			"id": 191503858,
			"lng": -77.38626867,
			"lat": 37.53736721,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 3,
			"dd": 14,
			"by": 1905,
			"bd": 30,
			"bm": 12,
			"nm": "",
			"nf": "Josephine",
			"nl": "Simmons",
			"url": "https://findagrave.com/memorial/183718574",
			"id": 183718574,
			"lng": -77.38636963,
			"lat": 37.53669044,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 7,
			"dd": 5,
			"by": 1874,
			"bd": 15,
			"bm": 11,
			"nm": "",
			"nf": "Eddie",
			"nl": "Simms",
			"url": "https://findagrave.com/memorial/125843846",
			"id": 125843846,
			"lng": -77.3860946,
			"lat": 37.53684047,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 12,
			"dd": 22,
			"by": 1865,
			"bd": 26,
			"bm": 12,
			"nm": "",
			"nf": "Ella",
			"nl": "Simms",
			"url": "https://findagrave.com/memorial/136173084",
			"id": 136173084,
			"lng": -77.38622161,
			"lat": 37.53647515,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 5,
			"dd": 28,
			"by": 1917,
			"bd": 20,
			"bm": 10,
			"nm": "Ella",
			"nf": "Mary",
			"nl": "Simms",
			"url": "https://findagrave.com/memorial/187368549",
			"id": 187368549,
			"lng": -77.38726296,
			"lat": 37.53729016,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 11,
			"dd": 29,
			"by": 1962,
			"bd": 3,
			"bm": 7,
			"nm": "",
			"nf": "Sharon",
			"nl": "Simms",
			"url": "https://findagrave.com/memorial/176205280",
			"id": 176205280,
			"lng": -77.38619741,
			"lat": 37.53752318,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 2,
			"dd": 10,
			"by": 1897,
			"bd": 26,
			"bm": 6,
			"nm": "Lee",
			"nf": "Herbert",
			"nl": "Simpson",
			"url": "https://findagrave.com/memorial/185658502",
			"id": 185658502,
			"lng": -77.38725582,
			"lat": 37.5376087,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 6,
			"dd": 29,
			"by": 1927,
			"bd": 12,
			"bm": 4,
			"nm": "Grant",
			"nf": "Ulysses",
			"nl": "Simpson",
			"url": "https://findagrave.com/memorial/166049761",
			"id": 166049761,
			"lng": -77.38657772,
			"lat": 37.53678586,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 7,
			"dd": 5,
			"by": "",
			"bd": 1,
			"bm": 11,
			"nm": "",
			"nf": "Maria",
			"nl": "Sims",
			"url": "https://findagrave.com/memorial/163611606",
			"id": 163611606,
			"lng": -77.38764516,
			"lat": 37.53764234,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 2,
			"dd": 19,
			"by": 1877,
			"bd": 18,
			"bm": 2,
			"nm": "",
			"nf": "Julia",
			"nl": "Singleton",
			"url": "https://findagrave.com/memorial/149202705",
			"id": 149202705,
			"lng": -77.3863339,
			"lat": 37.53543506,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1983,
			"dm": 2,
			"dd": 22,
			"by": 1896,
			"bd": 26,
			"bm": 7,
			"nm": "",
			"nf": "Julia",
			"nl": "Singleton",
			"url": "https://findagrave.com/memorial/125843857",
			"id": 125843857,
			"lng": -77.38573321,
			"lat": 37.53730342,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 10,
			"dd": 7,
			"by": 1837,
			"bd": 16,
			"bm": 8,
			"nm": "",
			"nf": "Margaret",
			"nl": "Singleton",
			"url": "https://findagrave.com/memorial/149202731",
			"id": 149202731,
			"lng": -77.38632135,
			"lat": 37.53541658,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1909,
			"dm": 3,
			"dd": 8,
			"by": 1872,
			"bd": 16,
			"bm": 1,
			"nm": "S.",
			"nf": "Meschach",
			"nl": "Singleton",
			"url": "https://findagrave.com/memorial/149202723",
			"id": 149202723,
			"lng": -77.38632353,
			"lat": 37.53541698,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 10,
			"dd": 28,
			"by": 1921,
			"bd": 26,
			"bm": 3,
			"nm": "",
			"nf": "Pearl",
			"nl": "Singleton",
			"url": "https://findagrave.com/memorial/138012346",
			"id": 138012346,
			"lng": -77.38668047,
			"lat": 37.53706555,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 12,
			"dd": 2,
			"by": 1873,
			"bd": 14,
			"bm": 2,
			"nm": "V.",
			"nf": "Susie",
			"nl": "Singleton",
			"url": "https://findagrave.com/memorial/149202771",
			"id": 149202771,
			"lng": -77.38632187,
			"lat": 37.53541494,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 1,
			"dd": 8,
			"by": 1868,
			"bd": 14,
			"bm": 10,
			"nm": "Grant",
			"nf": "William",
			"nl": "Singleton",
			"url": "https://findagrave.com/memorial/149202762",
			"id": 149202762,
			"lng": -77.38632406,
			"lat": 37.53541534,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 4,
			"dd": 4,
			"by": 1883,
			"bd": 21,
			"bm": 10,
			"nm": "",
			"nf": "Edward",
			"nl": "Sizer",
			"url": "https://findagrave.com/memorial/119328053",
			"id": 119328053,
			"lng": -77.38551718,
			"lat": 37.5372936,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 4,
			"dd": 10,
			"by": 1914,
			"bd": 28,
			"bm": 9,
			"nm": "",
			"nf": "Roberta",
			"nl": "Skinner",
			"url": "https://findagrave.com/memorial/177285943",
			"id": 177285943,
			"lng": -77.38737008,
			"lat": 37.53730691,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 8,
			"dd": 10,
			"by": 1900,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "Slade",
			"url": "https://findagrave.com/memorial/171780414",
			"id": 171780414,
			"lng": -77.38698918,
			"lat": 37.53717938,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 10,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Ann",
			"nf": "Julia",
			"nl": "Slade",
			"url": "https://findagrave.com/memorial/170839590",
			"id": 170839590,
			"lng": -77.38643506,
			"lat": 37.53703064,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 10,
			"dd": 23,
			"by": 1913,
			"bd": 17,
			"bm": 4,
			"nm": "",
			"nf": "Alberta",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/157646057",
			"id": 157646057,
			"lng": -77.38662209,
			"lat": 37.53739563,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 8,
			"dd": 5,
			"by": 1900,
			"bd": 27,
			"bm": 12,
			"nm": "T.",
			"nf": "Andrew",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/169397393",
			"id": 169397393,
			"lng": -77.38653116,
			"lat": 37.53679135,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 7,
			"dd": 8,
			"by": 1915,
			"bd": 30,
			"bm": 4,
			"nm": "H.",
			"nf": "Arthur",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/174857774",
			"id": 174857774,
			"lng": -77.38723175,
			"lat": 37.53736561,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 12,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "baby boy",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/159762363",
			"id": 159762363,
			"lng": -77.38629081,
			"lat": 37.53757239,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 7,
			"dd": 19,
			"by": 1883,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Belle",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/129211495",
			"id": 129211495,
			"lng": -77.38559648,
			"lat": 37.53710733,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 10,
			"dd": 20,
			"by": 1895,
			"bd": 25,
			"bm": 6,
			"nm": "",
			"nf": "Bessie",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/176467943",
			"id": 176467943,
			"lng": -77.38714843,
			"lat": 37.53692084,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 5,
			"dd": 20,
			"by": 1884,
			"bd": 28,
			"bm": 2,
			"nm": "",
			"nf": "Carrie",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/128452629",
			"id": 128452629,
			"lng": -77.38561614,
			"lat": 37.53698966,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 6,
			"dd": 23,
			"by": 1901,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Charles",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/151049026",
			"id": 151049026,
			"lng": -77.38645045,
			"lat": 37.53569533,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 8,
			"dd": 28,
			"by": 1949,
			"bd": 21,
			"bm": 5,
			"nm": "Elmore",
			"nf": "Charles",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/185392992",
			"id": 185392992,
			"lng": -77.38595733,
			"lat": 37.53627425,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 9,
			"dd": 9,
			"by": 1850,
			"bd": 6,
			"bm": 9,
			"nm": "E.",
			"nf": "Charles",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/132642773",
			"id": 132642773,
			"lng": -77.38784914,
			"lat": 37.53632146,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1985,
			"dm": 9,
			"dd": 28,
			"by": 1901,
			"bd": 17,
			"bm": 3,
			"nm": "",
			"nf": "Charlotte",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/141701290",
			"id": 141701290,
			"lng": -77.38662194,
			"lat": 37.53729361,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1982,
			"dm": 11,
			"dd": 17,
			"by": 1885,
			"bd": 3,
			"bm": 7,
			"nm": "",
			"nf": "Chassie",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/138572940",
			"id": 138572940,
			"lng": -77.38625176,
			"lat": 37.53669576,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 12,
			"dd": 31,
			"by": 1906,
			"bd": 23,
			"bm": 11,
			"nm": "L.",
			"nf": "Clarence",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/142469229",
			"id": 142469229,
			"lng": -77.38729005,
			"lat": 37.53784084,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 10,
			"dd": 11,
			"by": 1917,
			"bd": "",
			"bm": "",
			"nm": "Richard",
			"nf": "Cleo",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/142531408",
			"id": 142531408,
			"lng": -77.38648263,
			"lat": 37.5353387,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 1,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Clifton",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/158678498",
			"id": 158678498,
			"lng": -77.38671594,
			"lat": 37.53757308,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 4,
			"dd": 3,
			"by": 1897,
			"bd": 15,
			"bm": 2,
			"nm": "",
			"nf": "Doc",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/170839563",
			"id": 170839563,
			"lng": -77.38656474,
			"lat": 37.5370723,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 6,
			"dd": 26,
			"by": 1927,
			"bd": 27,
			"bm": 12,
			"nm": "Ann",
			"nf": "Dorothy",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/173166614",
			"id": 173166614,
			"lng": -77.3870841,
			"lat": 37.5368387,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 4,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Earnest",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/138572956",
			"id": 138572956,
			"lng": -77.38619754,
			"lat": 37.53671491,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 6,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "V.",
			"nf": "Ella",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/128675482",
			"id": 128675482,
			"lng": -77.3861365,
			"lat": 37.53665806,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 10,
			"dd": 27,
			"by": 1909,
			"bd": 3,
			"bm": 2,
			"nm": "",
			"nf": "Ethel",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/174698190",
			"id": 174698190,
			"lng": -77.3875332,
			"lat": 37.53701714,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 12,
			"dd": 5,
			"by": 1913,
			"bd": 18,
			"bm": 5,
			"nm": "F.",
			"nf": "Etta",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/157165936",
			"id": 157165936,
			"lng": -77.38648349,
			"lat": 37.53586005,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 1,
			"dd": 31,
			"by": 1899,
			"bd": 25,
			"bm": 5,
			"nm": "",
			"nf": "Eva",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/149696118",
			"id": 149696118,
			"lng": -77.38694478,
			"lat": 37.53660497,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 3,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Evelyn",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/111589854",
			"id": 111589854,
			"lng": -77.387311,
			"lat": 37.53755306,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1909,
			"dm": 8,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "George",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/155539550",
			"id": 155539550,
			"lng": -77.38677205,
			"lat": 37.53590902,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 1,
			"dd": 22,
			"by": 1887,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "George",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/175585524",
			"id": 175585524,
			"lng": -77.38664548,
			"lat": 37.5353865,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 8,
			"dd": 19,
			"by": 1945,
			"bd": 21,
			"bm": 10,
			"nm": "Edward",
			"nf": "George",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/157623692",
			"id": 157623692,
			"lng": -77.38674865,
			"lat": 37.53746505,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 1,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Margaret",
			"nf": "Gertrude",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/128452633",
			"id": 128452633,
			"lng": -77.38561385,
			"lat": 37.53700373,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 5,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Helen",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/146207081",
			"id": 146207081,
			"lng": -77.38659088,
			"lat": 37.53664634,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 6,
			"dd": 24,
			"by": 1906,
			"bd": 7,
			"bm": 3,
			"nm": "C.",
			"nf": "Henry",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/128675495",
			"id": 128675495,
			"lng": -77.38614045,
			"lat": 37.53665307,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 2,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Irene",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/141801148",
			"id": 141801148,
			"lng": -77.38659878,
			"lat": 37.53726933,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 1,
			"dd": 8,
			"by": 1902,
			"bd": 25,
			"bm": 3,
			"nm": "",
			"nf": "Isaac",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/111589857",
			"id": 111589857,
			"lng": -77.38659708,
			"lat": 37.53728929,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 8,
			"dd": 3,
			"by": 1901,
			"bd": 25,
			"bm": 12,
			"nm": "Tenson",
			"nf": "Ivrie",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/158924529",
			"id": 158924529,
			"lng": -77.38659605,
			"lat": 37.53758788,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 10,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jackson",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/187744368",
			"id": 187744368,
			"lng": -77.38770811,
			"lat": 37.53694275,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 12,
			"dd": 29,
			"by": 1867,
			"bd": 18,
			"bm": 6,
			"nm": "C.",
			"nf": "James",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/150920532",
			"id": 150920532,
			"lng": -77.38632347,
			"lat": 37.5355821,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 11,
			"dd": 2,
			"by": 1938,
			"bd": 21,
			"bm": 8,
			"nm": "",
			"nf": "Jene",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/176097675",
			"id": 176097675,
			"lng": -77.38734186,
			"lat": 37.53690302,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 5,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "G.",
			"nf": "John",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/188590736",
			"id": 188590736,
			"lng": -77.38615282,
			"lat": 37.53562518,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 7,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "R.",
			"nf": "John",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/178152992",
			"id": 178152992,
			"lng": -77.38775329,
			"lat": 37.53717746,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 2,
			"dd": 12,
			"by": 1891,
			"bd": 29,
			"bm": 3,
			"nm": "F.",
			"nf": "Joseph",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/161051897",
			"id": 161051897,
			"lng": -77.3871141,
			"lat": 37.53705797,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 1,
			"dd": 28,
			"by": 1899,
			"bd": 16,
			"bm": 9,
			"nm": "",
			"nf": "Joseph",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/138572968",
			"id": 138572968,
			"lng": -77.38624461,
			"lat": 37.53671521,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 2,
			"dd": 28,
			"by": 1895,
			"bd": 10,
			"bm": 9,
			"nm": "",
			"nf": "Josephine",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/128675505",
			"id": 128675505,
			"lng": -77.38613325,
			"lat": 37.53666366,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 2,
			"dd": 16,
			"by": 1888,
			"bd": 18,
			"bm": 5,
			"nm": "Edward",
			"nf": "Julius",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/151267777",
			"id": 151267777,
			"lng": -77.38700153,
			"lat": 37.53546898,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 11,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Junius",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/181956340",
			"id": 181956340,
			"lng": -77.38774428,
			"lat": 37.53645635,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 1,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Leroy",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/148285797",
			"id": 148285797,
			"lng": -77.38638969,
			"lat": 37.53721205,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 14,
			"by": 1893,
			"bd": 15,
			"bm": 3,
			"nm": "",
			"nf": "Lillie",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/154303989",
			"id": 154303989,
			"lng": -77.38701752,
			"lat": 37.53543204,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1980,
			"dm": 7,
			"dd": 28,
			"by": 1895,
			"bd": 26,
			"bm": 10,
			"nm": "H",
			"nf": "Linwood",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/156354482",
			"id": 156354482,
			"lng": -77.38646989,
			"lat": 37.53593234,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 11,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lizzie",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/158532807",
			"id": 158532807,
			"lng": -77.38685226,
			"lat": 37.53765825,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 6,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Madeline",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/187368553",
			"id": 187368553,
			"lng": -77.38764045,
			"lat": 37.53782397,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 3,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Martha",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/185541031",
			"id": 185541031,
			"lng": -77.38785912,
			"lat": 37.53710191,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 4,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "O.",
			"nf": "Mary",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/166816466",
			"id": 166816466,
			"lng": -77.38811577,
			"lat": 37.53749977,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 5,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mattie",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/173918724",
			"id": 173918724,
			"lng": -77.38756504,
			"lat": 37.53711768,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 9,
			"dd": 17,
			"by": 1896,
			"bd": 27,
			"bm": 5,
			"nm": "W.",
			"nf": "Monroe",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/149696123",
			"id": 149696123,
			"lng": -77.38694811,
			"lat": 37.53659734,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 6,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nancy",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/188268780",
			"id": 188268780,
			"lng": -77.38788086,
			"lat": 37.53711295,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 2,
			"dd": 7,
			"by": 1918,
			"bd": 25,
			"bm": 5,
			"nm": "E.",
			"nf": "Olivia",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/171780420",
			"id": 171780420,
			"lng": -77.38677107,
			"lat": 37.53685204,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1985,
			"dm": 10,
			"dd": 26,
			"by": 1909,
			"bd": 26,
			"bm": 9,
			"nm": "",
			"nf": "Rebecca",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/127992091",
			"id": 127992091,
			"lng": -77.38611647,
			"lat": 37.53665818,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 2,
			"dd": 7,
			"by": 1953,
			"bd": 22,
			"bm": 8,
			"nm": "LeRoy",
			"nf": "Richard",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/166049597",
			"id": 166049597,
			"lng": -77.38646201,
			"lat": 37.53675128,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 9,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Robert",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/176228666",
			"id": 176228666,
			"lng": -77.38631415,
			"lat": 37.53753285,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 10,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Francis",
			"nf": "Rosa",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/155539560",
			"id": 155539560,
			"lng": -77.38694524,
			"lat": 37.53546309,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 2,
			"dd": 24,
			"by": 1882,
			"bd": "",
			"bm": 10,
			"nm": "R.",
			"nf": "Rosa",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/116948333",
			"id": 116948333,
			"lng": -77.38576263,
			"lat": 37.53673928,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 9,
			"dd": 20,
			"by": 1885,
			"bd": 12,
			"bm": 1,
			"nm": "",
			"nf": "Sallie",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/155021704",
			"id": 155021704,
			"lng": -77.38654261,
			"lat": 37.53754541,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": "",
			"dd": "",
			"by": 1834,
			"bd": "",
			"bm": "",
			"nm": "G.",
			"nf": "Sallie",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/130426380",
			"id": 130426380,
			"lng": -77.38607363,
			"lat": 37.53582772,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 12,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Samuel",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/150881885",
			"id": 150881885,
			"lng": -77.38652902,
			"lat": 37.53587147,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 5,
			"dd": 31,
			"by": 1900,
			"bd": 17,
			"bm": 3,
			"nm": "L.",
			"nf": "Sandy",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/182089965",
			"id": 182089965,
			"lng": -77.38663785,
			"lat": 37.53767949,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 3,
			"dd": 5,
			"by": 1912,
			"bd": 5,
			"bm": 6,
			"nm": "Q.",
			"nf": "Susie",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/141701296",
			"id": 141701296,
			"lng": -77.38684773,
			"lat": 37.53740595,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1913,
			"dm": 5,
			"dd": 7,
			"by": 1875,
			"bd": 9,
			"bm": 5,
			"nm": "A.",
			"nf": "Susie",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/148459830",
			"id": 148459830,
			"lng": -77.38632278,
			"lat": 37.53558894,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 6,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Thomas",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/142469235",
			"id": 142469235,
			"lng": -77.38675193,
			"lat": 37.53665433,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 12,
			"dd": 12,
			"by": 1912,
			"bd": 23,
			"bm": 2,
			"nm": "",
			"nf": "Vester",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/139424764",
			"id": 139424764,
			"lng": -77.38784093,
			"lat": 37.53721754,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 5,
			"dd": 24,
			"by": 1863,
			"bd": 22,
			"bm": 2,
			"nm": "A.",
			"nf": "Virginia",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/143635980",
			"id": 143635980,
			"lng": -77.38617458,
			"lat": 37.53562597,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 7,
			"dd": 12,
			"by": 1905,
			"bd": 17,
			"bm": 6,
			"nm": "Lee",
			"nf": "Virginia",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/125843873",
			"id": 125843873,
			"lng": -77.38601027,
			"lat": 37.53743361,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 1,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "William",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/155964249",
			"id": 155964249,
			"lng": -77.38710809,
			"lat": 37.53561123,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 7,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "William",
			"nl": "Southall",
			"url": "https://findagrave.com/memorial/166513762",
			"id": 166513762,
			"lng": -77.38781307,
			"lat": 37.53716045,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 8,
			"dd": 3,
			"by": 1898,
			"bd": 25,
			"bm": 7,
			"nm": "",
			"nf": "Herbert",
			"nl": "Spain",
			"url": "https://findagrave.com/memorial/173793361",
			"id": 173793361,
			"lng": -77.38708095,
			"lat": 37.53718844,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 7,
			"dd": 28,
			"by": 1869,
			"bd": 14,
			"bm": 2,
			"nm": "",
			"nf": "Solomon",
			"nl": "Sparks",
			"url": "https://findagrave.com/memorial/157307813",
			"id": 157307813,
			"lng": -77.38667916,
			"lat": 37.53583164,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 2,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Bertha",
			"nl": "Spencer",
			"url": "https://findagrave.com/memorial/142106262",
			"id": 142106262,
			"lng": -77.38608123,
			"lat": 37.53742232,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 7,
			"dd": 15,
			"by": 1888,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alberta",
			"nl": "Spiller",
			"url": "https://findagrave.com/memorial/151445531",
			"id": 151445531,
			"lng": -77.38681075,
			"lat": 37.53540985,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 1,
			"dd": 2,
			"by": 1879,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "David",
			"nl": "Spiller",
			"url": "https://findagrave.com/memorial/151445990",
			"id": 151445990,
			"lng": -77.3868088,
			"lat": 37.53541658,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 2,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Irene",
			"nl": "Squire",
			"url": "https://findagrave.com/memorial/163904087",
			"id": 163904087,
			"lng": -77.38692066,
			"lat": 37.53678559,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 4,
			"dd": 14,
			"by": 1938,
			"bd": 27,
			"bm": 11,
			"nm": "Yvonne",
			"nf": "Marie",
			"nl": "Stamps",
			"url": "https://findagrave.com/memorial/185646128",
			"id": 185646128,
			"lng": -77.38747775,
			"lat": 37.53691712,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 9,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Ella",
			"nl": "Stanton",
			"url": "https://findagrave.com/memorial/132641419",
			"id": 132641419,
			"lng": -77.38782302,
			"lat": 37.53632422,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 9,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sidney",
			"nl": "Stanton",
			"url": "https://findagrave.com/memorial/171780423",
			"id": 171780423,
			"lng": -77.38784596,
			"lat": 37.53633068,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 9,
			"dd": 18,
			"by": 1908,
			"bd": 31,
			"bm": 7,
			"nm": "May",
			"nf": "Pearly",
			"nl": "Starkes",
			"url": "https://findagrave.com/memorial/175837977",
			"id": 175837977,
			"lng": -77.38772672,
			"lat": 37.53713495,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 12,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Harriet",
			"nl": "Steadman",
			"url": "https://findagrave.com/memorial/146020046",
			"id": 146020046,
			"lng": -77.38656456,
			"lat": 37.53636017,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 11,
			"dd": 5,
			"by": 1920,
			"bd": 30,
			"bm": 9,
			"nm": "Lee",
			"nf": "Robert",
			"nl": "Steele",
			"url": "https://findagrave.com/memorial/178412492",
			"id": 178412492,
			"lng": -77.38602442,
			"lat": 37.53625262,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 10,
			"dd": 9,
			"by": 1886,
			"bd": 8,
			"bm": 3,
			"nm": "Webster",
			"nf": "Daniel",
			"nl": "Stevens",
			"url": "https://findagrave.com/memorial/115720742",
			"id": 115720742,
			"lng": -77.38601488,
			"lat": 37.53713956,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 11,
			"dd": 9,
			"by": 1909,
			"bd": 10,
			"bm": 9,
			"nm": "Webster",
			"nf": "Daniel",
			"nl": "Stevens",
			"url": "https://findagrave.com/memorial/115720801",
			"id": 115720801,
			"lng": -77.38603771,
			"lat": 37.53714094,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 1,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Stevens",
			"url": "https://findagrave.com/memorial/169713741",
			"id": 169713741,
			"lng": -77.38670471,
			"lat": 37.53694714,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 2,
			"dd": 17,
			"by": 1914,
			"bd": 25,
			"bm": 3,
			"nm": "",
			"nf": "Helen",
			"nl": "Stevens",
			"url": "https://findagrave.com/memorial/175450155",
			"id": 175450155,
			"lng": -77.38751345,
			"lat": 37.53698678,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 10,
			"dd": 19,
			"by": 1888,
			"bd": 22,
			"bm": 4,
			"nm": "F.",
			"nf": "Letitia",
			"nl": "Stevens",
			"url": "https://findagrave.com/memorial/115720893",
			"id": 115720893,
			"lng": -77.38601136,
			"lat": 37.53714964,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 2,
			"dd": 5,
			"by": 1908,
			"bd": "",
			"bm": 6,
			"nm": "E.",
			"nf": "Raymond",
			"nl": "Stevens",
			"url": "https://findagrave.com/memorial/127569751",
			"id": 127569751,
			"lng": -77.38603577,
			"lat": 37.53715749,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 3,
			"dd": 9,
			"by": 1919,
			"bd": 19,
			"bm": 12,
			"nm": "Jessie",
			"nf": "Frank",
			"nl": "Stevenson",
			"url": "https://findagrave.com/memorial/150637833",
			"id": 150637833,
			"lng": -77.38644155,
			"lat": 37.53595354,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 12,
			"dd": 23,
			"by": 1900,
			"bd": 24,
			"bm": 3,
			"nm": "",
			"nf": "Novella",
			"nl": "Stevenson",
			"url": "https://findagrave.com/memorial/130538996",
			"id": 130538996,
			"lng": -77.38638585,
			"lat": 37.53690693,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 11,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Maria",
			"nl": "Steward",
			"url": "https://findagrave.com/memorial/113626543",
			"id": 113626543,
			"lng": -77.38644318,
			"lat": 37.53657103,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 7,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Steward",
			"url": "https://findagrave.com/memorial/142469242",
			"id": 142469242,
			"lng": -77.38565209,
			"lat": 37.53743362,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 12,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Henry",
			"nf": "Charles",
			"nl": "Stewart",
			"url": "https://findagrave.com/memorial/146772750",
			"id": 146772750,
			"lng": -77.38635137,
			"lat": 37.53729469,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 8,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Lee",
			"nf": "Ethel",
			"nl": "Stewart",
			"url": "https://findagrave.com/memorial/159886722",
			"id": 159886722,
			"lng": -77.38789348,
			"lat": 37.5376713,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 4,
			"dd": 5,
			"by": 1895,
			"bd": 23,
			"bm": 8,
			"nm": "C.",
			"nf": "Frank",
			"nl": "Stewart",
			"url": "https://findagrave.com/memorial/144226188",
			"id": 144226188,
			"lng": -77.3862456,
			"lat": 37.53743594,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 1,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jane",
			"nl": "Stewart",
			"url": "https://findagrave.com/memorial/119240903",
			"id": 119240903,
			"lng": -77.3859086,
			"lat": 37.5368462,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 6,
			"dd": 15,
			"by": 1911,
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Obie",
			"nl": "Stinson",
			"url": "https://findagrave.com/memorial/169905175",
			"id": 169905175,
			"lng": -77.38661918,
			"lat": 37.53712466,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1980,
			"dm": 2,
			"dd": 19,
			"by": 1897,
			"bd": 5,
			"bm": 3,
			"nm": "",
			"nf": "Ethel",
			"nl": "Stith",
			"url": "https://findagrave.com/memorial/154304010",
			"id": 154304010,
			"lng": -77.38690712,
			"lat": 37.53549452,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 1,
			"dd": 3,
			"by": 1912,
			"bd": 9,
			"bm": 5,
			"nm": "Bell",
			"nf": "Minnie",
			"nl": "Stokes",
			"url": "https://findagrave.com/memorial/160277988",
			"id": 160277988,
			"lng": -77.38601711,
			"lat": 37.53636095,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 6,
			"dd": 23,
			"by": 1861,
			"bd": 10,
			"bm": 11,
			"nm": "L.",
			"nf": "Robert",
			"nl": "Stokes",
			"url": "https://findagrave.com/memorial/125844014",
			"id": 125844014,
			"lng": -77.38610475,
			"lat": 37.53681069,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 5,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rosa",
			"nl": "Stokes",
			"url": "https://findagrave.com/memorial/123850471",
			"id": 123850471,
			"lng": -77.38609718,
			"lat": 37.53682455,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 3,
			"dd": 13,
			"by": 1903,
			"bd": 25,
			"bm": 8,
			"nm": "",
			"nf": "Viola",
			"nl": "Stokes",
			"url": "https://findagrave.com/memorial/113633317",
			"id": 113633317,
			"lng": -77.38741808,
			"lat": 37.53701242,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1888,
			"dm": 6,
			"dd": 6,
			"by": 1813,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Caroline",
			"nl": "Storrs",
			"url": "https://findagrave.com/memorial/154223081",
			"id": 154223081,
			"lng": -77.38657151,
			"lat": 37.5355554,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1886,
			"dm": 2,
			"dd": 20,
			"by": 1809,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Claiborne",
			"nl": "Storrs",
			"url": "https://findagrave.com/memorial/154222721",
			"id": 154222721,
			"lng": -77.3865708,
			"lat": 37.53557456,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 6,
			"dd": 12,
			"by": 1919,
			"bd": 19,
			"bm": 6,
			"nm": "",
			"nf": "Willie",
			"nl": "Stradford",
			"url": "https://findagrave.com/memorial/172683602",
			"id": 172683602,
			"lng": -77.38726896,
			"lat": 37.53732856,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 4,
			"dd": 4,
			"by": 1897,
			"bd": 4,
			"bm": 4,
			"nm": "",
			"nf": "Linwood",
			"nl": "Strange",
			"url": "https://findagrave.com/memorial/143866261",
			"id": 143866261,
			"lng": -77.38601468,
			"lat": 37.53729376,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 3,
			"dd": 24,
			"by": 1938,
			"bd": 16,
			"bm": 6,
			"nm": "Junior",
			"nf": "Richard",
			"nl": "Sturtevant",
			"url": "https://findagrave.com/memorial/153708826",
			"id": 153708826,
			"lng": -77.38625121,
			"lat": 37.53746207,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 3,
			"dd": 14,
			"by": 1896,
			"bd": 10,
			"bm": 12,
			"nm": "",
			"nf": "Frances",
			"nl": "Suarez",
			"url": "https://findagrave.com/memorial/173742917",
			"id": 173742917,
			"lng": -77.38737776,
			"lat": 37.53716944,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 10,
			"dd": 4,
			"by": 1908,
			"bd": 15,
			"bm": 6,
			"nm": "T.",
			"nf": "Freeman",
			"nl": "Suggs",
			"url": "https://findagrave.com/memorial/163611760",
			"id": 163611760,
			"lng": -77.38763018,
			"lat": 37.53760728,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 1,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Shirley",
			"nl": "Sukens",
			"url": "https://findagrave.com/memorial/170839602",
			"id": 170839602,
			"lng": -77.38642622,
			"lat": 37.53706188,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 11,
			"dd": 16,
			"by": 1896,
			"bd": 10,
			"bm": 3,
			"nm": "Edward",
			"nf": "Charles",
			"nl": "Sullivan",
			"url": "https://findagrave.com/memorial/153511428",
			"id": 153511428,
			"lng": -77.38655511,
			"lat": 37.53750117,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 10,
			"dd": 26,
			"by": 1919,
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Edward",
			"nl": "Sully",
			"url": "https://findagrave.com/memorial/122794910",
			"id": 122794910,
			"lng": -77.38590038,
			"lat": 37.53694977,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 3,
			"dd": 23,
			"by": 1889,
			"bd": 6,
			"bm": 10,
			"nm": "Stuart",
			"nf": "Richard",
			"nl": "Sully",
			"url": "https://findagrave.com/memorial/125313109",
			"id": 125313109,
			"lng": -77.38589556,
			"lat": 37.53697398,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 5,
			"dd": 11,
			"by": 1888,
			"bd": 26,
			"bm": 12,
			"nm": "Lee",
			"nf": "Sarah",
			"nl": "Sully",
			"url": "https://findagrave.com/memorial/125643998",
			"id": 125643998,
			"lng": -77.38589147,
			"lat": 37.53698117,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 1,
			"dd": 27,
			"by": 1905,
			"bd": 25,
			"bm": 10,
			"nm": "",
			"nf": "Ollie",
			"nl": "Sutton",
			"url": "https://findagrave.com/memorial/167073475",
			"id": 167073475,
			"lng": -77.38683476,
			"lat": 37.53716739,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 9,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "K.",
			"nf": "Frankie",
			"nl": "Sweat",
			"url": "https://findagrave.com/memorial/138181537",
			"id": 138181537,
			"lng": -77.3863842,
			"lat": 37.53707666,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 12,
			"dd": 2,
			"by": 1927,
			"bd": 16,
			"bm": 4,
			"nm": "Allen",
			"nf": "Linwood",
			"nl": "Tabb",
			"url": "https://findagrave.com/memorial/150637841",
			"id": 150637841,
			"lng": -77.38640175,
			"lat": 37.535935,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 7,
			"dd": 18,
			"by": 1906,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sadie",
			"nl": "Talbert",
			"url": "https://findagrave.com/memorial/175610176",
			"id": 175610176,
			"lng": -77.38768565,
			"lat": 37.53705487,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 10,
			"dd": 29,
			"by": 1919,
			"bd": 17,
			"bm": 12,
			"nm": "",
			"nf": "Henry",
			"nl": "Taliaferro",
			"url": "https://findagrave.com/memorial/141701313",
			"id": 141701313,
			"lng": -77.38644564,
			"lat": 37.5373103,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 12,
			"dd": 10,
			"by": 1893,
			"bd": 10,
			"bm": 2,
			"nm": "",
			"nf": "Herman",
			"nl": "Tally",
			"url": "https://findagrave.com/memorial/176983871",
			"id": 176983871,
			"lng": -77.38758064,
			"lat": 37.53557668,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1911,
			"dm": 3,
			"dd": 22,
			"by": 1892,
			"bd": "",
			"bm": 7,
			"nm": "L.",
			"nf": "Mary",
			"nl": "Tancil",
			"url": "https://findagrave.com/memorial/133668082",
			"id": 133668082,
			"lng": -77.38610474,
			"lat": 37.53583418,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 3,
			"dd": 8,
			"by": 1860,
			"bd": 20,
			"bm": 10,
			"nm": "Fillmore",
			"nf": "Richard",
			"nl": "Tancil",
			"url": "https://findagrave.com/memorial/143635987",
			"id": 143635987,
			"lng": -77.3861066,
			"lat": 37.53582741,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 4,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ella",
			"nl": "Tate",
			"url": "https://findagrave.com/memorial/186917466",
			"id": 186917466,
			"lng": -77.38748712,
			"lat": 37.53698686,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 10,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Albert",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/154304015",
			"id": 154304015,
			"lng": -77.38682971,
			"lat": 37.53553875,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 4,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Alton",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/150792701",
			"id": 150792701,
			"lng": -77.38644085,
			"lat": 37.53557132,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 4,
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "baby boy",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/142797055",
			"id": 142797055,
			"lng": -77.3860789,
			"lat": 37.53744044,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 8,
			"dd": 5,
			"by": 1858,
			"bd": 7,
			"bm": 6,
			"nm": "",
			"nf": "Capitola",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/142475112",
			"id": 142475112,
			"lng": -77.38576137,
			"lat": 37.53735378,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 3,
			"dd": 23,
			"by": 1922,
			"bd": 11,
			"bm": 7,
			"nm": "",
			"nf": "Catherine",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/158946002",
			"id": 158946002,
			"lng": -77.38693507,
			"lat": 37.53749775,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 3,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Charles",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/145596034",
			"id": 145596034,
			"lng": -77.38793103,
			"lat": 37.53728283,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1997,
			"dm": 12,
			"dd": 19,
			"by": 1942,
			"bd": 24,
			"bm": 11,
			"nm": "Stanley",
			"nf": "Clarence",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/76611076",
			"id": 76611076,
			"lng": -77.38629726,
			"lat": 37.53721941,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Cora",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/146682168",
			"id": 146682168,
			"lng": -77.3861095,
			"lat": 37.53579169,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 4,
			"dd": 4,
			"by": 1954,
			"bd": 1,
			"bm": 12,
			"nm": "G.",
			"nf": "Devon",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/147853901",
			"id": 147853901,
			"lng": -77.38599703,
			"lat": 37.53631828,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 9,
			"dd": 17,
			"by": 1910,
			"bd": 29,
			"bm": 7,
			"nm": "",
			"nf": "Edner",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/140625016",
			"id": 140625016,
			"lng": -77.38723555,
			"lat": 37.53565571,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 5,
			"dd": 8,
			"by": 1920,
			"bd": 13,
			"bm": 8,
			"nm": "",
			"nf": "Elnora",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/177768021",
			"id": 177768021,
			"lng": -77.38759016,
			"lat": 37.53761605,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 2,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Gertrude",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/132764955",
			"id": 132764955,
			"lng": -77.38588637,
			"lat": 37.53704228,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 11,
			"dd": 13,
			"by": 1900,
			"bd": "",
			"bm": "",
			"nm": "F.",
			"nf": "Gracie",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/142106265",
			"id": 142106265,
			"lng": -77.38577403,
			"lat": 37.53741699,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 8,
			"dd": 16,
			"by": 1932,
			"bd": 29,
			"bm": 10,
			"nm": "William",
			"nf": "Henry",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/169904899",
			"id": 169904899,
			"lng": -77.38664119,
			"lat": 37.53717735,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1987,
			"dm": 8,
			"dd": 26,
			"by": 1894,
			"bd": 19,
			"bm": 12,
			"nm": "",
			"nf": "Hiram",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/142106317",
			"id": 142106317,
			"lng": -77.38577649,
			"lat": 37.53741004,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 6,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Hughey",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/147853909",
			"id": 147853909,
			"lng": -77.38604054,
			"lat": 37.53624392,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 5,
			"dd": 16,
			"by": 1848,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Isaiah",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/154201784",
			"id": 154201784,
			"lng": -77.38726585,
			"lat": 37.53553103,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 1,
			"dd": 17,
			"by": 1905,
			"bd": 15,
			"bm": 3,
			"nm": "",
			"nf": "Isaiah",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/144558768",
			"id": 144558768,
			"lng": -77.38753069,
			"lat": 37.53733438,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 7,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "James",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/76611095",
			"id": 76611095,
			"lng": -77.38603943,
			"lat": 37.5366593,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 5,
			"dd": 17,
			"by": 1880,
			"bd": 24,
			"bm": 3,
			"nm": "Solomon",
			"nf": "James",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/126772114",
			"id": 126772114,
			"lng": -77.38586626,
			"lat": 37.53667429,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 8,
			"dd": 8,
			"by": 1884,
			"bd": 10,
			"bm": 6,
			"nm": "B.",
			"nf": "Jennie",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/151112011",
			"id": 151112011,
			"lng": -77.38648274,
			"lat": 37.53548967,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 2,
			"dd": 21,
			"by": 1862,
			"bd": 14,
			"bm": 4,
			"nm": "",
			"nf": "John",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/144373069",
			"id": 144373069,
			"lng": -77.38696381,
			"lat": 37.53557679,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 11,
			"dd": 15,
			"by": 1905,
			"bd": 12,
			"bm": 4,
			"nm": "Henry",
			"nf": "John",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/76611107",
			"id": 76611107,
			"lng": -77.38630811,
			"lat": 37.53719175,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 4,
			"dd": 12,
			"by": 1859,
			"bd": "",
			"bm": 1,
			"nm": "B.",
			"nf": "John",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/142106321",
			"id": 142106321,
			"lng": -77.38575867,
			"lat": 37.53734156,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 5,
			"dd": 10,
			"by": 1876,
			"bd": 16,
			"bm": 5,
			"nm": "L.",
			"nf": "Joseph",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/154242966",
			"id": 154242966,
			"lng": -77.38638292,
			"lat": 37.53550788,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 8,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Josephine",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/123850488",
			"id": 123850488,
			"lng": -77.38604585,
			"lat": 37.53664693,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 5,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Louisa",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/154304019",
			"id": 154304019,
			"lng": -77.38696075,
			"lat": 37.53550823,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 9,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Lucy",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/119391329",
			"id": 119391329,
			"lng": -77.38588217,
			"lat": 37.53666774,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 10,
			"dd": 2,
			"by": 1893,
			"bd": 26,
			"bm": 3,
			"nm": "J.",
			"nf": "Mabel",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/119391346",
			"id": 119391346,
			"lng": -77.38586716,
			"lat": 37.53666335,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 8,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Maggie",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/125313131",
			"id": 125313131,
			"lng": -77.38800637,
			"lat": 37.537277,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 3,
			"dd": 6,
			"by": 1900,
			"bd": 15,
			"bm": 6,
			"nm": "",
			"nf": "Mamie",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/123850495",
			"id": 123850495,
			"lng": -77.38599584,
			"lat": 37.53669831,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 9,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Martha",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/175820947",
			"id": 175820947,
			"lng": -77.38758144,
			"lat": 37.53699632,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 6,
			"dd": 24,
			"by": 1873,
			"bd": 14,
			"bm": 2,
			"nm": "",
			"nf": "Mary",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/120726156",
			"id": 120726156,
			"lng": -77.38566176,
			"lat": 37.53691329,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 9,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Missouri",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/130539006",
			"id": 130539006,
			"lng": -77.38634547,
			"lat": 37.53697362,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 5,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Moses",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/150037846",
			"id": 150037846,
			"lng": -77.38644872,
			"lat": 37.53628715,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 12,
			"dd": 28,
			"by": 1910,
			"bd": 18,
			"bm": 11,
			"nm": "",
			"nf": "Moses",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/161052442",
			"id": 161052442,
			"lng": -77.38714456,
			"lat": 37.53706558,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 5,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nathaniel",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/177149493",
			"id": 177149493,
			"lng": -77.38786676,
			"lat": 37.53703817,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 6,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Nettie",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/136306549",
			"id": 136306549,
			"lng": -77.38586198,
			"lat": 37.53706976,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 4,
			"dd": 6,
			"by": 1907,
			"bd": 12,
			"bm": 4,
			"nm": "",
			"nf": "Ora",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/76611140",
			"id": 76611140,
			"lng": -77.38630674,
			"lat": 37.53719712,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 10,
			"dd": 19,
			"by": 1860,
			"bd": "",
			"bm": 1,
			"nm": "Beecher",
			"nf": "Robert",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/151112022",
			"id": 151112022,
			"lng": -77.3864781,
			"lat": 37.53550315,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 4,
			"dd": 14,
			"by": 1893,
			"bd": "",
			"bm": 7,
			"nm": "Beecher",
			"nf": "Robert",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/151112035",
			"id": 151112035,
			"lng": -77.38646847,
			"lat": 37.5354863,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 6,
			"dd": 3,
			"by": 1909,
			"bd": 11,
			"bm": 11,
			"nm": "Lee",
			"nf": "Rosa",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/144227103",
			"id": 144227103,
			"lng": -77.38603109,
			"lat": 37.53738466,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 8,
			"dd": 21,
			"by": 1921,
			"bd": 29,
			"bm": 5,
			"nm": "L.",
			"nf": "Roscoe",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/158479769",
			"id": 158479769,
			"lng": -77.38675133,
			"lat": 37.53754032,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 7,
			"dd": 12,
			"by": 1878,
			"bd": 23,
			"bm": 2,
			"nm": "",
			"nf": "Sarah",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/159598354",
			"id": 159598354,
			"lng": -77.38716457,
			"lat": 37.53760212,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 6,
			"dd": 14,
			"by": 1892,
			"bd": 7,
			"bm": 12,
			"nm": "A.",
			"nf": "Sarah",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/138572981",
			"id": 138572981,
			"lng": -77.38627546,
			"lat": 37.53679705,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": 1866,
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Serena",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/151112042",
			"id": 151112042,
			"lng": -77.38646795,
			"lat": 37.53550281,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 6,
			"dd": 2,
			"by": 1943,
			"bd": 15,
			"bm": 4,
			"nm": "Gayzelle",
			"nf": "Shirley",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/142475125",
			"id": 142475125,
			"lng": -77.3860111,
			"lat": 37.53736781,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 6,
			"dd": 5,
			"by": 1901,
			"bd": 1,
			"bm": 2,
			"nm": "",
			"nf": "Viola",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/155989142",
			"id": 155989142,
			"lng": -77.38638635,
			"lat": 37.5369984,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 9,
			"dd": 30,
			"by": 1889,
			"bd": 19,
			"bm": 7,
			"nm": "T.",
			"nf": "William",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/123851379",
			"id": 123851379,
			"lng": -77.38599384,
			"lat": 37.5367027,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 10,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/119391357",
			"id": 119391357,
			"lng": -77.38587249,
			"lat": 37.5366866,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 6,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Johnson",
			"nf": "Charlotte",
			"nl": "Teasley",
			"url": "https://findagrave.com/memorial/136107652",
			"id": 136107652,
			"lng": -77.38604624,
			"lat": 37.53691488,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 2000,
			"dm": 12,
			"dd": 1,
			"by": 1899,
			"bd": 17,
			"bm": 2,
			"nm": "E.",
			"nf": "Eliza",
			"nl": "Temple",
			"url": "https://findagrave.com/memorial/76611153",
			"id": 76611153,
			"lng": -77.3860467,
			"lat": 37.53724547,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 1,
			"dd": 22,
			"by": 1917,
			"bd": 1,
			"bm": 3,
			"nm": "E.",
			"nf": "Gladys",
			"nl": "Temple",
			"url": "https://findagrave.com/memorial/76611187",
			"id": 76611187,
			"lng": -77.38601915,
			"lat": 37.53723894,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1999,
			"dm": 9,
			"dd": 29,
			"by": 1910,
			"bd": 26,
			"bm": 8,
			"nm": "H.",
			"nf": "James",
			"nl": "Temple",
			"url": "https://findagrave.com/memorial/76611174",
			"id": 76611174,
			"lng": -77.38602689,
			"lat": 37.53724122,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 3,
			"dd": 23,
			"by": 1901,
			"bd": 3,
			"bm": 7,
			"nm": "",
			"nf": "Josephine",
			"nl": "Temple",
			"url": "https://findagrave.com/memorial/128452660",
			"id": 128452660,
			"lng": -77.38589532,
			"lat": 37.53694549,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 11,
			"dd": 15,
			"by": 1895,
			"bd": 3,
			"bm": 7,
			"nm": "J.",
			"nf": "William",
			"nl": "Temple",
			"url": "https://findagrave.com/memorial/125408710",
			"id": 125408710,
			"lng": -77.38588401,
			"lat": 37.53667894,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 1,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Luke",
			"nl": "Terrell",
			"url": "https://findagrave.com/memorial/177768026",
			"id": 177768026,
			"lng": -77.38790399,
			"lat": 37.53727449,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 6,
			"dd": 16,
			"by": 1859,
			"bd": 26,
			"bm": 3,
			"nm": "Henry",
			"nf": "William",
			"nl": "Tharps",
			"url": "https://findagrave.com/memorial/119241100",
			"id": 119241100,
			"lng": -77.38580928,
			"lat": 37.53667452,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 9,
			"dd": 3,
			"by": 1896,
			"bd": 5,
			"bm": 3,
			"nm": "",
			"nf": "Bessie",
			"nl": "Thomas",
			"url": "https://findagrave.com/memorial/117449120",
			"id": 117449120,
			"lng": -77.38570903,
			"lat": 37.53670951,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 5,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "David",
			"nl": "Thomas",
			"url": "https://findagrave.com/memorial/159600776",
			"id": 159600776,
			"lng": -77.38710061,
			"lat": 37.53749968,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 9,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Edward",
			"nl": "Thomas",
			"url": "https://findagrave.com/memorial/179534889",
			"id": 179534889,
			"lng": -77.38792568,
			"lat": 37.53771914,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 9,
			"dd": 16,
			"by": 1900,
			"bd": 18,
			"bm": 6,
			"nm": "",
			"nf": "Haywood",
			"nl": "Thomas",
			"url": "https://findagrave.com/memorial/128452670",
			"id": 128452670,
			"lng": -77.38641964,
			"lat": 37.53730061,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 5,
			"dd": 30,
			"by": 1935,
			"bd": 5,
			"bm": 9,
			"nm": "Melinda",
			"nf": "Inez",
			"nl": "Thomas",
			"url": "https://findagrave.com/memorial/159973287",
			"id": 159973287,
			"lng": -77.38708832,
			"lat": 37.53747069,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 8,
			"dd": 29,
			"by": 1900,
			"bd": 9,
			"bm": 1,
			"nm": "James",
			"nf": "Johnnie",
			"nl": "Thomas",
			"url": "https://findagrave.com/memorial/173793409",
			"id": 173793409,
			"lng": -77.3871458,
			"lat": 37.53732719,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 8,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "Joseph",
			"nl": "Thomas",
			"url": "https://findagrave.com/memorial/142505846",
			"id": 142505846,
			"lng": -77.38573867,
			"lat": 37.5373562,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 5,
			"dd": 4,
			"by": 1878,
			"bd": 20,
			"bm": 2,
			"nm": "",
			"nf": "Lillie",
			"nl": "Thomas",
			"url": "https://findagrave.com/memorial/142505855",
			"id": 142505855,
			"lng": -77.3856997,
			"lat": 37.53732922,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1903,
			"dm": 7,
			"dd": 19,
			"by": 1902,
			"bd": 5,
			"bm": 9,
			"nm": "J.",
			"nf": "Lucy",
			"nl": "Thomas",
			"url": "https://findagrave.com/memorial/133137564",
			"id": 133137564,
			"lng": -77.38707211,
			"lat": 37.53655169,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 11,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "Luther",
			"nl": "Thomas",
			"url": "https://findagrave.com/memorial/144227113",
			"id": 144227113,
			"lng": -77.38594599,
			"lat": 37.53730534,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 5,
			"dd": 1,
			"by": 1881,
			"bd": 4,
			"bm": 7,
			"nm": "Catherine",
			"nf": "Mary",
			"nl": "Thomas",
			"url": "https://findagrave.com/memorial/185717336",
			"id": 185717336,
			"lng": -77.38722585,
			"lat": 37.53771198,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 12,
			"dd": 18,
			"by": 1896,
			"bd": 27,
			"bm": 12,
			"nm": "",
			"nf": "Ophelia",
			"nl": "Thomas",
			"url": "https://findagrave.com/memorial/160934060",
			"id": 160934060,
			"lng": -77.38647243,
			"lat": 37.53685277,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 12,
			"dd": 17,
			"by": 1910,
			"bd": 10,
			"bm": 12,
			"nm": "A.",
			"nf": "Samuel",
			"nl": "Thomas",
			"url": "https://findagrave.com/memorial/162672313",
			"id": 162672313,
			"lng": -77.38659634,
			"lat": 37.53700745,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 2,
			"dd": 20,
			"by": 1905,
			"bd": 13,
			"bm": 2,
			"nm": "H.",
			"nf": "Samuel",
			"nl": "Thomas",
			"url": "https://findagrave.com/memorial/142505861",
			"id": 142505861,
			"lng": -77.38574396,
			"lat": 37.53733827,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 11,
			"dd": 5,
			"by": 1903,
			"bd": 13,
			"bm": 7,
			"nm": "",
			"nf": "Willie",
			"nl": "Thomas",
			"url": "https://findagrave.com/memorial/142505868",
			"id": 142505868,
			"lng": -77.38574058,
			"lat": 37.5373464,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 10,
			"dd": 28,
			"by": 1879,
			"bd": 25,
			"bm": 12,
			"nm": "",
			"nf": "Leroy",
			"nl": "Thompkins",
			"url": "https://findagrave.com/memorial/173079259",
			"id": 173079259,
			"lng": -77.38702357,
			"lat": 37.53734341,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 1,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "Alice",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/155539567",
			"id": 155539567,
			"lng": -77.38731304,
			"lat": 37.53561537,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 5,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bettie",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/150864489",
			"id": 150864489,
			"lng": -77.38678537,
			"lat": 37.53583261,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 4,
			"dd": 16,
			"by": 1880,
			"bd": 5,
			"bm": 6,
			"nm": "Bohannon",
			"nf": "Charles",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/144373090",
			"id": 144373090,
			"lng": -77.38661125,
			"lat": 37.53578011,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 1,
			"dd": 22,
			"by": 1902,
			"bd": 10,
			"bm": 9,
			"nm": "",
			"nf": "Claudine",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/179130823",
			"id": 179130823,
			"lng": -77.38636885,
			"lat": 37.53756907,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 6,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Columbia",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/139146954",
			"id": 139146954,
			"lng": -77.38615345,
			"lat": 37.53657248,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 8,
			"dd": 31,
			"by": 1905,
			"bd": 1,
			"bm": 2,
			"nm": "Lee",
			"nf": "Cora",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/158450807",
			"id": 158450807,
			"lng": -77.38770723,
			"lat": 37.53757904,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 11,
			"dd": 3,
			"by": 1875,
			"bd": 7,
			"bm": 6,
			"nm": "W.",
			"nf": "George",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/155021719",
			"id": 155021719,
			"lng": -77.38678476,
			"lat": 37.53584253,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1912,
			"dm": 3,
			"dd": 21,
			"by": 1891,
			"bd": 21,
			"bm": 3,
			"nm": "K.",
			"nf": "George",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/150865632",
			"id": 150865632,
			"lng": -77.38723983,
			"lat": 37.53777285,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 8,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "Harry",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/150864840",
			"id": 150864840,
			"lng": -77.38678881,
			"lat": 37.53580539,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 7,
			"dd": 19,
			"by": 1870,
			"bd": "",
			"bm": 10,
			"nm": "",
			"nf": "Ida",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/173471935",
			"id": 173471935,
			"lng": -77.38730557,
			"lat": 37.5370855,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 7,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lula",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/125859672",
			"id": 125859672,
			"lng": -77.38600544,
			"lat": 37.53744454,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 6,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Luvenia",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/183921383",
			"id": 183921383,
			"lng": -77.3874016,
			"lat": 37.53698358,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": "",
			"dd": "",
			"by": 1910,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mamie",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/138181541",
			"id": 138181541,
			"lng": -77.38620054,
			"lat": 37.5371058,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 12,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Dudley",
			"nf": "Maria",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/125859678",
			"id": 125859678,
			"lng": -77.38606703,
			"lat": 37.53596057,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 10,
			"dd": 31,
			"by": 1882,
			"bd": "",
			"bm": 5,
			"nm": "L.",
			"nf": "Martha",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/150865747",
			"id": 150865747,
			"lng": -77.38678425,
			"lat": 37.53585367,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 12,
			"dd": 23,
			"by": 1890,
			"bd": 12,
			"bm": 9,
			"nm": "R.",
			"nf": "Maude",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/144821937",
			"id": 144821937,
			"lng": -77.38748321,
			"lat": 37.53775057,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 3,
			"dd": 4,
			"by": 1887,
			"bd": 31,
			"bm": 10,
			"nm": "",
			"nf": "Minnie",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/76611200",
			"id": 76611200,
			"lng": -77.38619209,
			"lat": 37.5357258,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 2,
			"dd": 6,
			"by": 1886,
			"bd": 5,
			"bm": 5,
			"nm": "",
			"nf": "Oliver",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/150864696",
			"id": 150864696,
			"lng": -77.38679254,
			"lat": 37.5358145,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 3,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Peter",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/150864330",
			"id": 150864330,
			"lng": -77.38678616,
			"lat": 37.53582441,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 10,
			"dd": 28,
			"by": 1931,
			"bd": 31,
			"bm": 10,
			"nm": "Ransome",
			"nf": "Raymond",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/183718583",
			"id": 183718583,
			"lng": -77.38704224,
			"lat": 37.53684751,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 1,
			"dd": 10,
			"by": 1913,
			"bd": 31,
			"bm": 10,
			"nm": "",
			"nf": "Robert",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/144373096",
			"id": 144373096,
			"lng": -77.38662353,
			"lat": 37.53702444,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 12,
			"dd": 31,
			"by": 1905,
			"bd": 5,
			"bm": 5,
			"nm": "Luke",
			"nf": "Roosevelt",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/161179875",
			"id": 161179875,
			"lng": -77.38644182,
			"lat": 37.53701402,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 10,
			"dd": 23,
			"by": 1883,
			"bd": 30,
			"bm": 4,
			"nm": "L.",
			"nf": "Sallie",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/144373077",
			"id": 144373077,
			"lng": -77.38661089,
			"lat": 37.53577543,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 5,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/193428743",
			"id": 193428743,
			"lng": -77.38757175,
			"lat": 37.53709668,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": "",
			"dd": "",
			"by": 1905,
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Winston",
			"nl": "Thorne",
			"url": "https://findagrave.com/memorial/144821946",
			"id": 144821946,
			"lng": -77.38624091,
			"lat": 37.53726431,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 6,
			"dd": 19,
			"by": 1892,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Hattie",
			"nl": "Thornton",
			"url": "https://findagrave.com/memorial/177240224",
			"id": 177240224,
			"lng": -77.38729256,
			"lat": 37.53739163,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 7,
			"dd": 28,
			"by": "",
			"bd": 15,
			"bm": 2,
			"nm": "",
			"nf": "Willie",
			"nl": "Thornton",
			"url": "https://findagrave.com/memorial/171368383",
			"id": 171368383,
			"lng": -77.38701492,
			"lat": 37.53671069,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1913,
			"dm": 11,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Bell",
			"nf": "Ann",
			"nl": "Tillman",
			"url": "https://findagrave.com/memorial/171100288",
			"id": 171100288,
			"lng": -77.38618984,
			"lat": 37.53597971,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 12,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mable",
			"nl": "Timmons",
			"url": "https://findagrave.com/memorial/154228765",
			"id": 154228765,
			"lng": -77.38631533,
			"lat": 37.53740641,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 8,
			"dd": 14,
			"by": 1860,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ann",
			"nl": "Tinsley",
			"url": "https://findagrave.com/memorial/151944846",
			"id": 151944846,
			"lng": -77.38661759,
			"lat": 37.53572531,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 11,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Bertha",
			"nl": "Tinsley",
			"url": "https://findagrave.com/memorial/132046788",
			"id": 132046788,
			"lng": -77.38777039,
			"lat": 37.53646036,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1906,
			"dm": 5,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ellen",
			"nl": "Tinsley",
			"url": "https://findagrave.com/memorial/160934063",
			"id": 160934063,
			"lng": -77.38644219,
			"lat": 37.53636465,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 8,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sarah",
			"nl": "Tinsley",
			"url": "https://findagrave.com/memorial/149696139",
			"id": 149696139,
			"lng": -77.3864544,
			"lat": 37.53635458,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 1,
			"dd": 30,
			"by": 1912,
			"bd": "",
			"bm": "",
			"nm": "F.",
			"nf": "William",
			"nl": "Tinsley",
			"url": "https://findagrave.com/memorial/151944722",
			"id": 151944722,
			"lng": -77.3866102,
			"lat": 37.53572779,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 8,
			"dd": 30,
			"by": 1903,
			"bd": 23,
			"bm": 6,
			"nm": "",
			"nf": "Mabel",
			"nl": "Tippett",
			"url": "https://findagrave.com/memorial/183587542",
			"id": 183587542,
			"lng": -77.38694702,
			"lat": 37.53713515,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 4,
			"dd": 11,
			"by": 1891,
			"bd": 28,
			"bm": 2,
			"nm": "R.",
			"nf": "Adell",
			"nl": "Toast",
			"url": "https://findagrave.com/memorial/137430857",
			"id": 137430857,
			"lng": -77.38619544,
			"lat": 37.5370965,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 2,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Adlaide",
			"nl": "Toast",
			"url": "https://findagrave.com/memorial/158946011",
			"id": 158946011,
			"lng": -77.38715218,
			"lat": 37.53758687,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 10,
			"dd": 21,
			"by": 1889,
			"bd": 12,
			"bm": 6,
			"nm": "Henry",
			"nf": "William",
			"nl": "Toast",
			"url": "https://findagrave.com/memorial/137835772",
			"id": 137835772,
			"lng": -77.38619136,
			"lat": 37.53710575,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 1,
			"dd": 29,
			"by": 1906,
			"bd": 3,
			"bm": 4,
			"nm": "",
			"nf": "Bessie",
			"nl": "Toliver",
			"url": "https://findagrave.com/memorial/183718587",
			"id": 183718587,
			"lng": -77.38704639,
			"lat": 37.53719809,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 7,
			"dd": 19,
			"by": 1913,
			"bd": 28,
			"bm": 7,
			"nm": "",
			"nf": "Amanda",
			"nl": "Tolliver",
			"url": "https://findagrave.com/memorial/158464391",
			"id": 158464391,
			"lng": -77.38691551,
			"lat": 37.53765555,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 11,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Tolliver",
			"url": "https://findagrave.com/memorial/191381376",
			"id": 191381376,
			"lng": -77.38773494,
			"lat": 37.53788583,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 12,
			"dd": 11,
			"by": 1890,
			"bd": 16,
			"bm": 5,
			"nm": "",
			"nf": "Matilda",
			"nl": "Tolliver",
			"url": "https://findagrave.com/memorial/150637843",
			"id": 150637843,
			"lng": -77.38640416,
			"lat": 37.53597822,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 3,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Mary",
			"nl": "Tomlin",
			"url": "https://findagrave.com/memorial/160639670",
			"id": 160639670,
			"lng": -77.38596222,
			"lat": 37.53690212,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 3,
			"dd": 23,
			"by": 1858,
			"bd": 20,
			"bm": 5,
			"nm": "H.",
			"nf": "William",
			"nl": "Tomlin",
			"url": "https://findagrave.com/memorial/160639672",
			"id": 160639672,
			"lng": -77.38604691,
			"lat": 37.53680245,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 5,
			"dd": 28,
			"by": 1878,
			"bd": 1,
			"bm": 1,
			"nm": "",
			"nf": "Richard",
			"nl": "Tompkins",
			"url": "https://findagrave.com/memorial/169904901",
			"id": 169904901,
			"lng": -77.38682645,
			"lat": 37.53709902,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 11,
			"dd": 15,
			"by": 1903,
			"bd": 3,
			"bm": 10,
			"nm": "",
			"nf": "Alice",
			"nl": "Towles",
			"url": "https://findagrave.com/memorial/150637844",
			"id": 150637844,
			"lng": -77.38638517,
			"lat": 37.53597931,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 9,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "David",
			"nl": "Townson",
			"url": "https://findagrave.com/memorial/172068272",
			"id": 172068272,
			"lng": -77.38740044,
			"lat": 37.53682988,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 10,
			"dd": 12,
			"by": 1868,
			"bd": 22,
			"bm": 9,
			"nm": "",
			"nf": "Archer",
			"nl": "Trent",
			"url": "https://findagrave.com/memorial/168088700",
			"id": 168088700,
			"lng": -77.38654463,
			"lat": 37.53689399,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 5,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Lelia",
			"nl": "Trent",
			"url": "https://findagrave.com/memorial/139424771",
			"id": 139424771,
			"lng": -77.38780868,
			"lat": 37.53722339,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 4,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Martha",
			"nl": "Trent",
			"url": "https://findagrave.com/memorial/162203623",
			"id": 162203623,
			"lng": -77.38781118,
			"lat": 37.53706567,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 12,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Robert",
			"nl": "Trent",
			"url": "https://findagrave.com/memorial/138181586",
			"id": 138181586,
			"lng": -77.38644018,
			"lat": 37.53702688,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 12,
			"dd": 20,
			"by": 1880,
			"bd": "",
			"bm": 3,
			"nm": "E.",
			"nf": "Joseph",
			"nl": "Trice",
			"url": "https://findagrave.com/memorial/155539577",
			"id": 155539577,
			"lng": -77.38671259,
			"lat": 37.53592637,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 12,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Wiley",
			"nl": "Trice",
			"url": "https://findagrave.com/memorial/185564850",
			"id": 185564850,
			"lng": -77.38727703,
			"lat": 37.53685486,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 4,
			"dd": 17,
			"by": 1910,
			"bd": 2,
			"bm": 10,
			"nm": "",
			"nf": "Magnolia",
			"nl": "Trueheart",
			"url": "https://findagrave.com/memorial/187898190",
			"id": 187898190,
			"lng": -77.38593321,
			"lat": 37.53632661,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 11,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "K.",
			"nf": "Mary",
			"nl": "Trueheart",
			"url": "https://findagrave.com/memorial/184376606",
			"id": 184376606,
			"lng": -77.38772889,
			"lat": 37.53664785,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 5,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Trueheart",
			"url": "https://findagrave.com/memorial/184477155",
			"id": 184477155,
			"lng": -77.38771276,
			"lat": 37.53665583,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 10,
			"dd": 28,
			"by": 1892,
			"bd": 1,
			"bm": 10,
			"nm": "",
			"nf": "Amy",
			"nl": "Tuck",
			"url": "https://findagrave.com/memorial/153629930",
			"id": 153629930,
			"lng": -77.38650393,
			"lat": 37.53744715,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 9,
			"dd": 29,
			"by": 1910,
			"bd": 6,
			"bm": 5,
			"nm": "",
			"nf": "Edward",
			"nl": "Tucker",
			"url": "https://findagrave.com/memorial/177118841",
			"id": 177118841,
			"lng": -77.38794167,
			"lat": 37.53692498,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 9,
			"dd": 5,
			"by": 1898,
			"bd": 10,
			"bm": 12,
			"nm": "Baptist",
			"nf": "John",
			"nl": "Tucker",
			"url": "https://findagrave.com/memorial/167338965",
			"id": 167338965,
			"lng": -77.38688118,
			"lat": 37.53730431,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 10,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "Tucker",
			"url": "https://findagrave.com/memorial/145167330",
			"id": 145167330,
			"lng": -77.38622009,
			"lat": 37.53712407,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 11,
			"dd": 26,
			"by": 1897,
			"bd": 23,
			"bm": 8,
			"nm": "",
			"nf": "Lillie",
			"nl": "Tucker",
			"url": "https://findagrave.com/memorial/167337995",
			"id": 167337995,
			"lng": -77.38687456,
			"lat": 37.53733595,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 6,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Nichols",
			"nf": "Nettie",
			"nl": "Tucker",
			"url": "https://findagrave.com/memorial/155539590",
			"id": 155539590,
			"lng": -77.38655716,
			"lat": 37.53682818,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 10,
			"dd": 23,
			"by": 1892,
			"bd": 25,
			"bm": 12,
			"nm": "",
			"nf": "Robert",
			"nl": "Tucker",
			"url": "https://findagrave.com/memorial/151268213",
			"id": 151268213,
			"lng": -77.38687648,
			"lat": 37.53733028,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 2,
			"dd": 14,
			"by": 1882,
			"bd": 7,
			"bm": 1,
			"nm": "Eliza",
			"nf": "Annie",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/174782927",
			"id": 174782927,
			"lng": -77.3874031,
			"lat": 37.5370141,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 7,
			"dd": 28,
			"by": 1968,
			"bd": 25,
			"bm": 6,
			"nm": "",
			"nf": "baby boy",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/159663333",
			"id": 159663333,
			"lng": -77.38590305,
			"lat": 37.53740513,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 3,
			"dd": 4,
			"by": 1924,
			"bd": 5,
			"bm": 2,
			"nm": "",
			"nf": "Beatrice",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/144013924",
			"id": 144013924,
			"lng": -77.38724412,
			"lat": 37.53764376,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 1,
			"dd": 17,
			"by": 1926,
			"bd": 10,
			"bm": 1,
			"nm": "Lee",
			"nf": "Daisy",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/127134101",
			"id": 127134101,
			"lng": -77.38610479,
			"lat": 37.53638237,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 6,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Emily",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/150153232",
			"id": 150153232,
			"lng": -77.38617377,
			"lat": 37.53604916,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 6,
			"dd": 1,
			"by": 1935,
			"bd": 19,
			"bm": 6,
			"nm": "",
			"nf": "Emmaline",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/144373105",
			"id": 144373105,
			"lng": -77.38751181,
			"lat": 37.53782524,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 12,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Ethel",
			"nf": "Estelle",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/179529676",
			"id": 179529676,
			"lng": -77.38796563,
			"lat": 37.53773625,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 8,
			"dd": 7,
			"by": 1907,
			"bd": 24,
			"bm": 8,
			"nm": "Washington",
			"nf": "George",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/128452673",
			"id": 128452673,
			"lng": -77.38680844,
			"lat": 37.53740121,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 1,
			"dd": 26,
			"by": 1915,
			"bd": 5,
			"bm": 8,
			"nm": "",
			"nf": "Isaac",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/147853925",
			"id": 147853925,
			"lng": -77.38703618,
			"lat": 37.53699447,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 8,
			"dd": 23,
			"by": 1913,
			"bd": 25,
			"bm": 9,
			"nm": "",
			"nf": "James",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/176059955",
			"id": 176059955,
			"lng": -77.38733471,
			"lat": 37.53704267,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 8,
			"dd": 4,
			"by": 1877,
			"bd": 9,
			"bm": 2,
			"nm": "Bruce",
			"nf": "James",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/152646372",
			"id": 152646372,
			"lng": -77.38634917,
			"lat": 37.53706417,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 12,
			"dd": 30,
			"by": 1910,
			"bd": 10,
			"bm": 4,
			"nm": "Leroy",
			"nf": "John",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/158946019",
			"id": 158946019,
			"lng": -77.38693751,
			"lat": 37.53736215,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 11,
			"dd": 11,
			"by": 1922,
			"bd": 17,
			"bm": 4,
			"nm": "Marie",
			"nf": "Lola",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/158946026",
			"id": 158946026,
			"lng": -77.38693315,
			"lat": 37.5373691,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 8,
			"dd": 29,
			"by": 1909,
			"bd": 26,
			"bm": 9,
			"nm": "Elizabeth",
			"nf": "Martha",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/171369939",
			"id": 171369939,
			"lng": -77.38702241,
			"lat": 37.53670149,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 1,
			"dd": 27,
			"by": 1881,
			"bd": 25,
			"bm": 11,
			"nm": "",
			"nf": "Rosa",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/157646360",
			"id": 157646360,
			"lng": -77.38734221,
			"lat": 37.53763027,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 1,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Sarah",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/150036814",
			"id": 150036814,
			"lng": -77.38651264,
			"lat": 37.53561443,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 8,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Walter",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/186818119",
			"id": 186818119,
			"lng": -77.38736092,
			"lat": 37.53699238,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1913,
			"dm": 8,
			"dd": 3,
			"by": 1882,
			"bd": 1,
			"bm": 9,
			"nm": "H.",
			"nf": "Frank",
			"nl": "Twine",
			"url": "https://findagrave.com/memorial/140290927",
			"id": 140290927,
			"lng": -77.38659374,
			"lat": 37.53551241,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 3,
			"dd": 20,
			"by": 1851,
			"bd": "",
			"bm": 9,
			"nm": "H.",
			"nf": "James",
			"nl": "Twine",
			"url": "https://findagrave.com/memorial/151112054",
			"id": 151112054,
			"lng": -77.38657234,
			"lat": 37.53552006,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 8,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ann",
			"nl": "Tyler",
			"url": "https://findagrave.com/memorial/132764962",
			"id": 132764962,
			"lng": -77.38778023,
			"lat": 37.53657864,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1905,
			"dm": 3,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Beatrice",
			"nl": "Tyler",
			"url": "https://findagrave.com/memorial/187368555",
			"id": 187368555,
			"lng": -77.38780958,
			"lat": 37.53632203,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 7,
			"dd": 6,
			"by": 1882,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Cora",
			"nl": "Tyler",
			"url": "https://findagrave.com/memorial/142505873",
			"id": 142505873,
			"lng": -77.3873021,
			"lat": 37.53787884,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 1,
			"dd": 3,
			"by": 1892,
			"bd": 28,
			"bm": 9,
			"nm": "L.",
			"nf": "Mildred",
			"nl": "Tyler",
			"url": "https://findagrave.com/memorial/138572991",
			"id": 138572991,
			"lng": -77.38623973,
			"lat": 37.53660091,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 10,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Oliver",
			"nl": "Tyler",
			"url": "https://findagrave.com/memorial/175476419",
			"id": 175476419,
			"lng": -77.38564282,
			"lat": 37.53684064,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 6,
			"dd": 6,
			"by": 1908,
			"bd": "",
			"bm": 11,
			"nm": "",
			"nf": "Mary",
			"nl": "Valentine",
			"url": "https://findagrave.com/memorial/160934070",
			"id": 160934070,
			"lng": -77.38639904,
			"lat": 37.53681877,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 5,
			"dd": 27,
			"by": 1892,
			"bd": 17,
			"bm": 8,
			"nm": "",
			"nf": "Thomas",
			"nl": "Valentine",
			"url": "https://findagrave.com/memorial/157311980",
			"id": 157311980,
			"lng": -77.38655119,
			"lat": 37.53713862,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 3,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "P.",
			"nf": "Samuel",
			"nl": "Van Hook",
			"url": "https://findagrave.com/memorial/169810315",
			"id": 169810315,
			"lng": -77.38672359,
			"lat": 37.53706691,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 9,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Burrell",
			"nf": "Henrietta",
			"nl": "Vaughan",
			"url": "https://findagrave.com/memorial/142106357",
			"id": 142106357,
			"lng": -77.38672413,
			"lat": 37.53667518,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 5,
			"dd": 24,
			"by": 1875,
			"bd": 7,
			"bm": 3,
			"nm": "Robert",
			"nf": "James",
			"nl": "Vaughan",
			"url": "https://findagrave.com/memorial/24865570",
			"id": 24865570,
			"lng": -77.38575564,
			"lat": 37.53673893,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 7,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jefford",
			"nl": "Vaughan",
			"url": "https://findagrave.com/memorial/168088710",
			"id": 168088710,
			"lng": -77.38656209,
			"lat": 37.53689998,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "H",
			"nl": "Venable",
			"url": "https://findagrave.com/memorial/207135117",
			"id": 207135117,
			"lng": -77.38623596,
			"lat": 37.53539208,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 10,
			"dd": 20,
			"by": 1880,
			"bd": 5,
			"bm": 5,
			"nm": "Linwood",
			"nf": "John",
			"nl": "Venable",
			"url": "https://findagrave.com/memorial/113416726",
			"id": 113416726,
			"lng": -77.38569957,
			"lat": 37.53683204,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 5,
			"dd": 25,
			"by": 1888,
			"bd": 25,
			"bm": 9,
			"nm": "",
			"nf": "Inez",
			"nl": "Waddell",
			"url": "https://findagrave.com/memorial/172687590",
			"id": 172687590,
			"lng": -77.38730217,
			"lat": 37.53730032,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 6,
			"dd": 4,
			"by": 1946,
			"bd": 3,
			"bm": 12,
			"nm": "Eugene",
			"nf": "Melvin",
			"nl": "Waddell",
			"url": "https://findagrave.com/memorial/161180433",
			"id": 161180433,
			"lng": -77.38671125,
			"lat": 37.53704479,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 7,
			"dd": 28,
			"by": 1918,
			"bd": 23,
			"bm": 6,
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Waddy",
			"url": "https://findagrave.com/memorial/134374533",
			"id": 134374533,
			"lng": -77.38629742,
			"lat": 37.53705055,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 4,
			"dd": 25,
			"by": 1872,
			"bd": 12,
			"bm": 7,
			"nm": "Washington",
			"nf": "George",
			"nl": "Wade",
			"url": "https://findagrave.com/memorial/117307721",
			"id": 117307721,
			"lng": -77.38575113,
			"lat": 37.53675844,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 3,
			"dd": 26,
			"by": 1912,
			"bd": 1,
			"bm": 10,
			"nm": "Amelia",
			"nf": "Naomi",
			"nl": "Wafer",
			"url": "https://findagrave.com/memorial/175700271",
			"id": 175700271,
			"lng": -77.3875569,
			"lat": 37.53707822,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 10,
			"dd": 27,
			"by": 1897,
			"bd": 15,
			"bm": 9,
			"nm": "W.",
			"nf": "Thomas",
			"nl": "Waith",
			"url": "https://findagrave.com/memorial/177673468",
			"id": 177673468,
			"lng": -77.3875331,
			"lat": 37.53693564,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 4,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Amanda",
			"nl": "Walden",
			"url": "https://findagrave.com/memorial/180846246",
			"id": 180846246,
			"lng": -77.38813185,
			"lat": 37.53757883,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 9,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Tim",
			"nf": "William",
			"nl": "Walden",
			"url": "https://findagrave.com/memorial/173512215",
			"id": 173512215,
			"lng": -77.38752999,
			"lat": 37.537091,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 1,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alice",
			"nl": "Walker",
			"url": "https://findagrave.com/memorial/143900182",
			"id": 143900182,
			"lng": -77.38617012,
			"lat": 37.53647442,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 5,
			"dd": 13,
			"by": 1881,
			"bd": 29,
			"bm": 1,
			"nm": "",
			"nf": "Annie",
			"nl": "Walker",
			"url": "https://findagrave.com/memorial/155539607",
			"id": 155539607,
			"lng": -77.38760157,
			"lat": 37.53762869,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 11,
			"dd": 10,
			"by": 1875,
			"bd": "",
			"bm": 4,
			"nm": "",
			"nf": "Ella",
			"nl": "Walker",
			"url": "https://findagrave.com/memorial/144383158",
			"id": 144383158,
			"lng": -77.38660453,
			"lat": 37.53537558,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 2,
			"dd": 23,
			"by": 1909,
			"bd": 13,
			"bm": 12,
			"nm": "H.",
			"nf": "Eva",
			"nl": "Walker",
			"url": "https://findagrave.com/memorial/158450809",
			"id": 158450809,
			"lng": -77.38678085,
			"lat": 37.53739107,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 8,
			"dd": 18,
			"by": 1904,
			"bd": 28,
			"bm": 3,
			"nm": "Virginia",
			"nf": "Frances",
			"nl": "Walker",
			"url": "https://findagrave.com/memorial/163611787",
			"id": 163611787,
			"lng": -77.3875801,
			"lat": 37.53759168,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 12,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Fred",
			"nl": "Walker",
			"url": "https://findagrave.com/memorial/184293117",
			"id": 184293117,
			"lng": -77.38704786,
			"lat": 37.53759886,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 4,
			"dd": 20,
			"by": 1898,
			"bd": 27,
			"bm": 11,
			"nm": "M.",
			"nf": "Hazel",
			"nl": "Walker",
			"url": "https://findagrave.com/memorial/142106360",
			"id": 142106360,
			"lng": -77.38585563,
			"lat": 37.53736068,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 3,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Henry",
			"nl": "Walker",
			"url": "https://findagrave.com/memorial/140291072",
			"id": 140291072,
			"lng": -77.38619196,
			"lat": 37.53648449,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1911,
			"dm": 10,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Walker",
			"url": "https://findagrave.com/memorial/166103955",
			"id": 166103955,
			"lng": -77.38707144,
			"lat": 37.53665672,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 2,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Mildred",
			"nl": "Walker",
			"url": "https://findagrave.com/memorial/144558771",
			"id": 144558771,
			"lng": -77.3868573,
			"lat": 37.53662366,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 2,
			"dd": 7,
			"by": 1892,
			"bd": 5,
			"bm": 1,
			"nm": "Henry",
			"nf": "Richard",
			"nl": "Walker",
			"url": "https://findagrave.com/memorial/138181592",
			"id": 138181592,
			"lng": -77.38645202,
			"lat": 37.53697085,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 1,
			"dd": 30,
			"by": 1882,
			"bd": 4,
			"bm": 7,
			"nm": "",
			"nf": "Sam",
			"nl": "Walker",
			"url": "https://findagrave.com/memorial/155021731",
			"id": 155021731,
			"lng": -77.3871194,
			"lat": 37.53774238,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 4,
			"dd": 3,
			"by": 1902,
			"bd": 25,
			"bm": 2,
			"nm": "",
			"nf": "Thomas",
			"nl": "Walker",
			"url": "https://findagrave.com/memorial/138573013",
			"id": 138573013,
			"lng": -77.3862852,
			"lat": 37.53671492,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 12,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Willard",
			"nl": "Walker",
			"url": "https://findagrave.com/memorial/155539610",
			"id": 155539610,
			"lng": -77.38760109,
			"lat": 37.53763524,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 1,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Henry",
			"nl": "Wall",
			"url": "https://findagrave.com/memorial/186818095",
			"id": 186818095,
			"lng": -77.38734628,
			"lat": 37.53694153,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 9,
			"dd": 13,
			"by": 1883,
			"bd": 24,
			"bm": 12,
			"nm": "M.",
			"nf": "Carrie",
			"nl": "Wallace",
			"url": "https://findagrave.com/memorial/167271241",
			"id": 167271241,
			"lng": -77.38655725,
			"lat": 37.53742434,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 3,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Georgia",
			"nl": "Wallace",
			"url": "https://findagrave.com/memorial/188301115",
			"id": 188301115,
			"lng": -77.3879252,
			"lat": 37.53703476,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 12,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jacob",
			"nl": "Wallace",
			"url": "https://findagrave.com/memorial/146207097",
			"id": 146207097,
			"lng": -77.38586992,
			"lat": 37.53672533,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1909,
			"dm": 5,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "Wallace",
			"url": "https://findagrave.com/memorial/156215186",
			"id": 156215186,
			"lng": -77.38650139,
			"lat": 37.53580049,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 8,
			"dd": 13,
			"by": 1864,
			"bd": 30,
			"bm": 10,
			"nm": "",
			"nf": "John",
			"nl": "Wallace",
			"url": "https://findagrave.com/memorial/156215201",
			"id": 156215201,
			"lng": -77.38650173,
			"lat": 37.53578896,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 9,
			"dd": 16,
			"by": 1925,
			"bd": 15,
			"bm": 5,
			"nm": "Fleming",
			"nf": "Kenneth",
			"nl": "Wallace",
			"url": "https://findagrave.com/memorial/177768035",
			"id": 177768035,
			"lng": -77.38799205,
			"lat": 37.53736529,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 2,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Mary",
			"nl": "Wallace",
			"url": "https://findagrave.com/memorial/156215211",
			"id": 156215211,
			"lng": -77.38650144,
			"lat": 37.53579252,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 10,
			"dd": 23,
			"by": 1835,
			"bd": 26,
			"bm": 6,
			"nm": "Etta",
			"nf": "Mary",
			"nl": "Waller",
			"url": "https://findagrave.com/memorial/153263664",
			"id": 153263664,
			"lng": -77.38672467,
			"lat": 37.53542633,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 5,
			"dd": 18,
			"by": 1882,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Aaron",
			"nl": "Walters",
			"url": "https://findagrave.com/memorial/150981690",
			"id": 150981690,
			"lng": -77.38675351,
			"lat": 37.53546137,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 2,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Olivia",
			"nl": "Walters",
			"url": "https://findagrave.com/memorial/150981848",
			"id": 150981848,
			"lng": -77.38678282,
			"lat": 37.53544333,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 3,
			"dd": 8,
			"by": 1880,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lillian",
			"nl": "Ware",
			"url": "https://findagrave.com/memorial/144383168",
			"id": 144383168,
			"lng": -77.38705556,
			"lat": 37.53551617,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 1,
			"dd": 20,
			"by": 1884,
			"bd": 19,
			"bm": 2,
			"nm": "Burnett",
			"nf": "Nelson",
			"nl": "Ware",
			"url": "https://findagrave.com/memorial/192444591",
			"id": 192444591,
			"lng": -77.38704733,
			"lat": 37.53552503,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 3,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Georgiana",
			"nl": "Warwick",
			"url": "https://findagrave.com/memorial/146207105",
			"id": 146207105,
			"lng": -77.38629801,
			"lat": 37.53667955,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 7,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Addie",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/187074955",
			"id": 187074955,
			"lng": -77.38752196,
			"lat": 37.53685207,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 3,
			"dd": 1,
			"by": 1922,
			"bd": 3,
			"bm": 4,
			"nm": "Jean",
			"nf": "Anna",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/178265731",
			"id": 178265731,
			"lng": -77.38800213,
			"lat": 37.537445,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 4,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Carrie",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/144227117",
			"id": 144227117,
			"lng": -77.387151,
			"lat": 37.53783141,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 2,
			"dd": 21,
			"by": 1881,
			"bd": 25,
			"bm": 11,
			"nm": "W.",
			"nf": "Daniel",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/146341636",
			"id": 146341636,
			"lng": -77.3864256,
			"lat": 37.53580471,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 12,
			"dd": 13,
			"by": 1897,
			"bd": "",
			"bm": 2,
			"nm": "",
			"nf": "Ernest",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/181157336",
			"id": 181157336,
			"lng": -77.38803443,
			"lat": 37.53741608,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 1,
			"dd": 2,
			"by": 1895,
			"bd": 30,
			"bm": 6,
			"nm": "M.",
			"nf": "Eva",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/127992107",
			"id": 127992107,
			"lng": -77.38610518,
			"lat": 37.53657331,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 8,
			"dd": 23,
			"by": 1888,
			"bd": 8,
			"bm": 3,
			"nm": "",
			"nf": "Fannie",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/119593483",
			"id": 119593483,
			"lng": -77.385708,
			"lat": 37.53669734,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 4,
			"dd": 4,
			"by": 1908,
			"bd": 19,
			"bm": 11,
			"nm": "Douglas",
			"nf": "Fred",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/190118371",
			"id": 190118371,
			"lng": -77.38746541,
			"lat": 37.53719533,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 5,
			"dd": 31,
			"by": 1905,
			"bd": 2,
			"bm": 8,
			"nm": "",
			"nf": "George",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/183909978",
			"id": 183909978,
			"lng": -77.38640424,
			"lat": 37.53680674,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 7,
			"dd": 16,
			"by": 1939,
			"bd": 11,
			"bm": 11,
			"nm": "",
			"nf": "George",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/144227143",
			"id": 144227143,
			"lng": -77.38598448,
			"lat": 37.53740956,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 1,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Isabelle",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/143635996",
			"id": 143635996,
			"lng": -77.38603877,
			"lat": 37.53601342,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 7,
			"dd": 24,
			"by": 1910,
			"bd": 1,
			"bm": 4,
			"nm": "Everett",
			"nf": "John",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/139566628",
			"id": 139566628,
			"lng": -77.38594559,
			"lat": 37.53638041,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 10,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Lee",
			"nf": "Laura",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/141924969",
			"id": 141924969,
			"lng": -77.38599408,
			"lat": 37.53668545,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 7,
			"dd": 2,
			"by": 1894,
			"bd": 26,
			"bm": 8,
			"nm": "Andrew",
			"nf": "Lee",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/157686094",
			"id": 157686094,
			"lng": -77.38678914,
			"lat": 37.53744464,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 2,
			"dd": 12,
			"by": 1917,
			"bd": 25,
			"bm": 11,
			"nm": "",
			"nf": "Mary",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/170724567",
			"id": 170724567,
			"lng": -77.385961,
			"lat": 37.53631664,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 11,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Priscilla",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/143696149",
			"id": 143696149,
			"lng": -77.38602047,
			"lat": 37.53607316,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 7,
			"dd": 21,
			"by": 1924,
			"bd": 1,
			"bm": 2,
			"nm": "Richard",
			"nf": "Robert",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/127992118",
			"id": 127992118,
			"lng": -77.38610056,
			"lat": 37.53658296,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 12,
			"dd": 12,
			"by": 1958,
			"bd": 20,
			"bm": 12,
			"nm": "Arletha",
			"nf": "Romanta",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/122027622",
			"id": 122027622,
			"lng": -77.38648449,
			"lat": 37.53660909,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 8,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Bell",
			"nf": "Rosa",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/183863021",
			"id": 183863021,
			"lng": -77.38735625,
			"lat": 37.53701214,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1909,
			"dm": 4,
			"dd": 9,
			"by": 1841,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Van",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/156215218",
			"id": 156215218,
			"lng": -77.38647547,
			"lat": 37.53580227,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 3,
			"dd": 1,
			"by": 1859,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Virginia",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/156215227",
			"id": 156215227,
			"lng": -77.38647743,
			"lat": 37.53579434,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 8,
			"dd": 30,
			"by": 1953,
			"bd": 9,
			"bm": 6,
			"nm": "",
			"nf": "Wesley",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/141701329",
			"id": 141701329,
			"lng": -77.38723682,
			"lat": 37.5378729,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 10,
			"dd": 12,
			"by": 1963,
			"bd": 29,
			"bm": 12,
			"nm": "",
			"nf": "William",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/151929650",
			"id": 151929650,
			"lng": -77.38599604,
			"lat": 37.53745374,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 4,
			"dd": 0,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Waters",
			"url": "https://findagrave.com/memorial/207174240",
			"id": 207174240,
			"lng": -77.38628669,
			"lat": 37.53674672,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 12,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Adolphus",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/137835776",
			"id": 137835776,
			"lng": -77.38619315,
			"lat": 37.53714358,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 11,
			"dd": 7,
			"by": 1892,
			"bd": 7,
			"bm": 3,
			"nm": "",
			"nf": "Albert",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/177545582",
			"id": 177545582,
			"lng": -77.38698182,
			"lat": 37.53776114,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 4,
			"dd": 3,
			"by": 1889,
			"bd": 28,
			"bm": 2,
			"nm": "Thomas",
			"nf": "Benjamin",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/157164236",
			"id": 157164236,
			"lng": -77.38641804,
			"lat": 37.53585461,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 12,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bettie",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/146341782",
			"id": 146341782,
			"lng": -77.38642178,
			"lat": 37.5358463,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 6,
			"dd": 20,
			"by": 1895,
			"bd": 15,
			"bm": 11,
			"nm": "",
			"nf": "Charles",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/144227152",
			"id": 144227152,
			"lng": -77.38759681,
			"lat": 37.53781719,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 1,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Clifton",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/174697689",
			"id": 174697689,
			"lng": -77.38748882,
			"lat": 37.53710903,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 12,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Edward",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/174711640",
			"id": 174711640,
			"lng": -77.3876312,
			"lat": 37.53694451,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 5,
			"dd": 27,
			"by": 1899,
			"bd": 21,
			"bm": 8,
			"nm": "H.",
			"nf": "Ivan",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/76611215",
			"id": 76611215,
			"lng": -77.38618886,
			"lat": 37.53718373,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 1,
			"dd": 17,
			"by": 1880,
			"bd": 11,
			"bm": 9,
			"nm": "Booker",
			"nf": "John",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/176134722",
			"id": 176134722,
			"lng": -77.3876812,
			"lat": 37.53715142,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 5,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Joseph",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/146207113",
			"id": 146207113,
			"lng": -77.38644317,
			"lat": 37.5358302,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 7,
			"dd": 9,
			"by": 1873,
			"bd": 10,
			"bm": 1,
			"nm": "",
			"nf": "Joshua",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/76611240",
			"id": 76611240,
			"lng": -77.38619442,
			"lat": 37.53717075,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 9,
			"dd": 30,
			"by": 1900,
			"bd": 15,
			"bm": 12,
			"nm": "",
			"nf": "Marie",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/168872082",
			"id": 168872082,
			"lng": -77.38757356,
			"lat": 37.53692521,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 2,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Martha",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/37602491",
			"id": 37602491,
			"lng": -77.38728627,
			"lat": 37.53695991,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 2,
			"dd": 5,
			"by": 1893,
			"bd": 13,
			"bm": 4,
			"nm": "Elizabeth",
			"nf": "Mary",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/178249279",
			"id": 178249279,
			"lng": -77.38773201,
			"lat": 37.53750266,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 6,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/144383180",
			"id": 144383180,
			"lng": -77.38705684,
			"lat": 37.53550069,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 5,
			"dd": 20,
			"by": 1907,
			"bd": 27,
			"bm": 4,
			"nm": "E.",
			"nf": "Mary",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/170604709",
			"id": 170604709,
			"lng": -77.38686685,
			"lat": 37.53693805,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 11,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nellie",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/184512829",
			"id": 184512829,
			"lng": -77.38749469,
			"lat": 37.53682651,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 10,
			"dd": 26,
			"by": 1900,
			"bd": 10,
			"bm": 3,
			"nm": "",
			"nf": "Robert",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/170129851",
			"id": 170129851,
			"lng": -77.38677411,
			"lat": 37.53692866,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 12,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sarah",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/111589858",
			"id": 111589858,
			"lng": -77.38619195,
			"lat": 37.53717752,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 11,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Silas",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/154304043",
			"id": 154304043,
			"lng": -77.3870169,
			"lat": 37.53549865,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 1,
			"dd": 10,
			"by": 1899,
			"bd": 13,
			"bm": 10,
			"nm": "",
			"nf": "Willie",
			"nl": "Watkins",
			"url": "https://findagrave.com/memorial/184302504",
			"id": 184302504,
			"lng": -77.38612425,
			"lat": 37.53681968,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 11,
			"dd": 25,
			"by": 1951,
			"bd": 29,
			"bm": 1,
			"nm": "",
			"nf": "Clovia",
			"nl": "Watson",
			"url": "https://findagrave.com/memorial/144558773",
			"id": 144558773,
			"lng": -77.38792506,
			"lat": 37.53745221,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 5,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Edward",
			"nl": "Watson",
			"url": "https://findagrave.com/memorial/173847288",
			"id": 173847288,
			"lng": -77.38740737,
			"lat": 37.53709559,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 1,
			"dd": 21,
			"by": 1923,
			"bd": 18,
			"bm": 8,
			"nm": "Taylor",
			"nf": "George",
			"nl": "Watson",
			"url": "https://findagrave.com/memorial/177998689",
			"id": 177998689,
			"lng": -77.38799437,
			"lat": 37.53760742,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 6,
			"dd": 20,
			"by": 1913,
			"bd": 6,
			"bm": 3,
			"nm": "",
			"nf": "Helen",
			"nl": "Watson",
			"url": "https://findagrave.com/memorial/172683157",
			"id": 172683157,
			"lng": -77.38725231,
			"lat": 37.53731325,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 7,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Junius",
			"nf": "James",
			"nl": "Watson",
			"url": "https://findagrave.com/memorial/185658504",
			"id": 185658504,
			"lng": -77.38743059,
			"lat": 37.53709964,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 9,
			"dd": 24,
			"by": 1921,
			"bd": 18,
			"bm": 10,
			"nm": "Rebecca",
			"nf": "Sarah",
			"nl": "Watson",
			"url": "https://findagrave.com/memorial/179570809",
			"id": 179570809,
			"lng": -77.38792444,
			"lat": 37.53772882,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 8,
			"dd": 27,
			"by": 1908,
			"bd": 15,
			"bm": 8,
			"nm": "",
			"nf": "Matt",
			"nl": "Watts",
			"url": "https://findagrave.com/memorial/169397396",
			"id": 169397396,
			"lng": -77.38652423,
			"lat": 37.5368036,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 9,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Lelia",
			"nl": "Webb",
			"url": "https://findagrave.com/memorial/137431002",
			"id": 137431002,
			"lng": -77.38620364,
			"lat": 37.53706753,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 2,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Eliza",
			"nl": "Wells",
			"url": "https://findagrave.com/memorial/123587278",
			"id": 123587278,
			"lng": -77.38575158,
			"lat": 37.5370053,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 7,
			"dd": 4,
			"by": 1888,
			"bd": 8,
			"bm": 9,
			"nm": "",
			"nf": "Preston",
			"nl": "Wells",
			"url": "https://findagrave.com/memorial/158960469",
			"id": 158960469,
			"lng": -77.38774163,
			"lat": 37.53776373,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 8,
			"dd": 28,
			"by": 1914,
			"bd": 8,
			"bm": 4,
			"nm": "B.",
			"nf": "Annie",
			"nl": "West",
			"url": "https://findagrave.com/memorial/157757373",
			"id": 157757373,
			"lng": -77.38564499,
			"lat": 37.53729432,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 12,
			"dd": 5,
			"by": 1921,
			"bd": 21,
			"bm": 9,
			"nm": "E.",
			"nf": "Catherine",
			"nl": "West",
			"url": "https://findagrave.com/memorial/158960474",
			"id": 158960474,
			"lng": -77.38712674,
			"lat": 37.53740254,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 6,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Charles",
			"nl": "West",
			"url": "https://findagrave.com/memorial/142511366",
			"id": 142511366,
			"lng": -77.385589,
			"lat": 37.53736309,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 10,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Elizabeth",
			"nl": "West",
			"url": "https://findagrave.com/memorial/166447800",
			"id": 166447800,
			"lng": -77.38709991,
			"lat": 37.53664839,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1902,
			"dm": 5,
			"dd": 21,
			"by": 1844,
			"bd": 21,
			"bm": 3,
			"nm": "W.",
			"nf": "John",
			"nl": "West",
			"url": "https://findagrave.com/memorial/166448786",
			"id": 166448786,
			"lng": -77.38709484,
			"lat": 37.53664723,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 5,
			"dd": 8,
			"by": 1876,
			"bd": 30,
			"bm": 1,
			"nm": "H.",
			"nf": "John",
			"nl": "West",
			"url": "https://findagrave.com/memorial/171360813",
			"id": 171360813,
			"lng": -77.38709106,
			"lat": 37.53662653,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 4,
			"dd": 17,
			"by": 1920,
			"bd": 28,
			"bm": 10,
			"nm": "M.",
			"nf": "Joseph",
			"nl": "West",
			"url": "https://findagrave.com/memorial/145344938",
			"id": 145344938,
			"lng": -77.38557711,
			"lat": 37.53734325,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 12,
			"dd": 22,
			"by": 1891,
			"bd": 16,
			"bm": 5,
			"nm": "",
			"nf": "Lena",
			"nl": "West",
			"url": "https://findagrave.com/memorial/142511372",
			"id": 142511372,
			"lng": -77.38568171,
			"lat": 37.53731149,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 6,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucinda",
			"nl": "West",
			"url": "https://findagrave.com/memorial/159859262",
			"id": 159859262,
			"lng": -77.38811395,
			"lat": 37.53741586,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 9,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucy",
			"nl": "West",
			"url": "https://findagrave.com/memorial/142511380",
			"id": 142511380,
			"lng": -77.3856028,
			"lat": 37.53735001,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 4,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Martha",
			"nl": "West",
			"url": "https://findagrave.com/memorial/191780033",
			"id": 191780033,
			"lng": -77.38684197,
			"lat": 37.53581226,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 12,
			"dd": 24,
			"by": 1899,
			"bd": 24,
			"bm": 7,
			"nm": "",
			"nf": "Mary",
			"nl": "West",
			"url": "https://findagrave.com/memorial/177118750",
			"id": 177118750,
			"lng": -77.38784595,
			"lat": 37.5370263,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 3,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Melchia",
			"nl": "West",
			"url": "https://findagrave.com/memorial/157621878",
			"id": 157621878,
			"lng": -77.38677144,
			"lat": 37.53740483,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 12,
			"dd": 20,
			"by": 1893,
			"bd": 22,
			"bm": 2,
			"nm": "B.",
			"nf": "Rosa",
			"nl": "West",
			"url": "https://findagrave.com/memorial/176239469",
			"id": 176239469,
			"lng": -77.38721932,
			"lat": 37.53704321,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 12,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Waverly",
			"nl": "West",
			"url": "https://findagrave.com/memorial/177019642",
			"id": 177019642,
			"lng": -77.38793509,
			"lat": 37.53727472,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 1,
			"dd": 23,
			"by": 1888,
			"bd": 26,
			"bm": 12,
			"nm": "H.",
			"nf": "William",
			"nl": "West",
			"url": "https://findagrave.com/memorial/175328079",
			"id": 175328079,
			"lng": -77.38740721,
			"lat": 37.53708133,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 12,
			"dd": 6,
			"by": 1890,
			"bd": 22,
			"bm": 11,
			"nm": "",
			"nf": "Ella",
			"nl": "Westinghouse",
			"url": "https://findagrave.com/memorial/144013925",
			"id": 144013925,
			"lng": -77.3869684,
			"lat": 37.53738886,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 8,
			"dd": 24,
			"by": 1886,
			"bd": 12,
			"bm": 1,
			"nm": "A.",
			"nf": "Nora",
			"nl": "Wheaton",
			"url": "https://findagrave.com/memorial/172045099",
			"id": 172045099,
			"lng": -77.38693015,
			"lat": 37.53715601,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 11,
			"dd": 28,
			"by": 1894,
			"bd": 15,
			"bm": 5,
			"nm": "",
			"nf": "Rosa",
			"nl": "Whitaker",
			"url": "https://findagrave.com/memorial/168032334",
			"id": 168032334,
			"lng": -77.38693468,
			"lat": 37.53728609,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 12,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Albert",
			"nl": "White",
			"url": "https://findagrave.com/memorial/187763273",
			"id": 187763273,
			"lng": -77.38790881,
			"lat": 37.53713518,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 7,
			"dd": 6,
			"by": 1906,
			"bd": 29,
			"bm": 1,
			"nm": "",
			"nf": "Arline",
			"nl": "White",
			"url": "https://findagrave.com/memorial/156126626",
			"id": 156126626,
			"lng": -77.38611034,
			"lat": 37.53696173,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 11,
			"dd": 20,
			"by": 1903,
			"bd": 5,
			"bm": 9,
			"nm": "C.",
			"nf": "Calvin",
			"nl": "White",
			"url": "https://findagrave.com/memorial/145167332",
			"id": 145167332,
			"lng": -77.38628497,
			"lat": 37.53713287,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 5,
			"dd": 1,
			"by": 1897,
			"bd": 12,
			"bm": 12,
			"nm": "H.",
			"nf": "Charles",
			"nl": "White",
			"url": "https://findagrave.com/memorial/76611268",
			"id": 76611268,
			"lng": -77.38608243,
			"lat": 37.53698842,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 10,
			"dd": 6,
			"by": 1900,
			"bd": "",
			"bm": "",
			"nm": "Lee",
			"nf": "Cora",
			"nl": "White",
			"url": "https://findagrave.com/memorial/153629449",
			"id": 153629449,
			"lng": -77.38652125,
			"lat": 37.53742739,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 3,
			"dd": 3,
			"by": 1893,
			"bd": 3,
			"bm": 6,
			"nm": "",
			"nf": "Elizabeth",
			"nl": "White",
			"url": "https://findagrave.com/memorial/159416179",
			"id": 159416179,
			"lng": -77.38609776,
			"lat": 37.53740575,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 3,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "G.",
			"nf": "Ethel",
			"nl": "White",
			"url": "https://findagrave.com/memorial/130737031",
			"id": 130737031,
			"lng": -77.38571657,
			"lat": 37.5371722,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 1,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Evelyn",
			"nl": "White",
			"url": "https://findagrave.com/memorial/147853936",
			"id": 147853936,
			"lng": -77.38634869,
			"lat": 37.53722925,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 7,
			"dd": 15,
			"by": 1900,
			"bd": 13,
			"bm": 10,
			"nm": "T.",
			"nf": "Everett",
			"nl": "White",
			"url": "https://findagrave.com/memorial/156126636",
			"id": 156126636,
			"lng": -77.38609341,
			"lat": 37.53697186,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1912,
			"dm": 7,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Georgia",
			"nl": "White",
			"url": "https://findagrave.com/memorial/149250595",
			"id": 149250595,
			"lng": -77.38625587,
			"lat": 37.53584102,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 1,
			"dd": 27,
			"by": 1919,
			"bd": 17,
			"bm": 12,
			"nm": "Virginia",
			"nf": "Iva",
			"nl": "White",
			"url": "https://findagrave.com/memorial/171203066",
			"id": 171203066,
			"lng": -77.38761569,
			"lat": 37.53778145,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 3,
			"dd": 16,
			"by": 1921,
			"bd": 6,
			"bm": 3,
			"nm": "Christopher Columbus",
			"nf": "James",
			"nl": "White",
			"url": "https://findagrave.com/memorial/183319922",
			"id": 183319922,
			"lng": -77.38659983,
			"lat": 37.53706569,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 10,
			"dd": 8,
			"by": 1910,
			"bd": 22,
			"bm": 1,
			"nm": "Samuel",
			"nf": "James",
			"nl": "White",
			"url": "https://findagrave.com/memorial/185308250",
			"id": 185308250,
			"lng": -77.38681339,
			"lat": 37.53768714,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 12,
			"dd": 30,
			"by": 1932,
			"bd": 4,
			"bm": 11,
			"nm": "",
			"nf": "James",
			"nl": "White",
			"url": "https://findagrave.com/memorial/153864056",
			"id": 153864056,
			"lng": -77.38623824,
			"lat": 37.5374054,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 4,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "White",
			"url": "https://findagrave.com/memorial/126652599",
			"id": 126652599,
			"lng": -77.38594098,
			"lat": 37.53648584,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 6,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "White",
			"url": "https://findagrave.com/memorial/187368560",
			"id": 187368560,
			"lng": -77.38802108,
			"lat": 37.53731801,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 7,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "Joseph",
			"nl": "White",
			"url": "https://findagrave.com/memorial/145344944",
			"id": 145344944,
			"lng": -77.38558296,
			"lat": 37.53726467,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 12,
			"dd": 26,
			"by": 1934,
			"bd": 7,
			"bm": 11,
			"nm": "",
			"nf": "Lawrence",
			"nl": "White",
			"url": "https://findagrave.com/memorial/150637846",
			"id": 150637846,
			"lng": -77.38641668,
			"lat": 37.53597999,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 4,
			"dd": 15,
			"by": 1929,
			"bd": 27,
			"bm": 3,
			"nm": "C.",
			"nf": "Lewis",
			"nl": "White",
			"url": "https://findagrave.com/memorial/175449604",
			"id": 175449604,
			"lng": -77.38736902,
			"lat": 37.53731582,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 11,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "Lillian",
			"nl": "White",
			"url": "https://findagrave.com/memorial/156126645",
			"id": 156126645,
			"lng": -77.38601438,
			"lat": 37.53691409,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 4,
			"dd": 7,
			"by": 1890,
			"bd": 9,
			"bm": 4,
			"nm": "",
			"nf": "Lillie",
			"nl": "White",
			"url": "https://findagrave.com/memorial/139424782",
			"id": 139424782,
			"lng": -77.38795568,
			"lat": 37.53698781,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 11,
			"dd": 23,
			"by": 1922,
			"bd": 14,
			"bm": 8,
			"nm": "Mae",
			"nf": "Lottie",
			"nl": "White",
			"url": "https://findagrave.com/memorial/176939610",
			"id": 176939610,
			"lng": -77.38709927,
			"lat": 37.53756722,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 4,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucille",
			"nl": "White",
			"url": "https://findagrave.com/memorial/189200293",
			"id": 189200293,
			"lng": -77.38739518,
			"lat": 37.53740437,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 3,
			"dd": 13,
			"by": 1913,
			"bd": 28,
			"bm": 8,
			"nm": "",
			"nf": "Lula",
			"nl": "White",
			"url": "https://findagrave.com/memorial/184276323",
			"id": 184276323,
			"lng": -77.38766324,
			"lat": 37.5373745,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1912,
			"dm": 6,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Martha",
			"nl": "White",
			"url": "https://findagrave.com/memorial/156480539",
			"id": 156480539,
			"lng": -77.38633677,
			"lat": 37.53569043,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 7,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "White",
			"url": "https://findagrave.com/memorial/185151787",
			"id": 185151787,
			"lng": -77.38775876,
			"lat": 37.53667434,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 6,
			"dd": 9,
			"by": 1870,
			"bd": 28,
			"bm": 3,
			"nm": "C.",
			"nf": "Mary",
			"nl": "White",
			"url": "https://findagrave.com/memorial/125644015",
			"id": 125644015,
			"lng": -77.38609436,
			"lat": 37.53699222,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 2,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": 11,
			"nm": "",
			"nf": "Meaky",
			"nl": "White",
			"url": "https://findagrave.com/memorial/176133126",
			"id": 176133126,
			"lng": -77.3874453,
			"lat": 37.53728149,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 3,
			"dd": 4,
			"by": 1900,
			"bd": 15,
			"bm": 10,
			"nm": "May",
			"nf": "Ottie",
			"nl": "White",
			"url": "https://findagrave.com/memorial/130737033",
			"id": 130737033,
			"lng": -77.38568448,
			"lat": 37.53719637,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 11,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Henry",
			"nf": "Patrick",
			"nl": "White",
			"url": "https://findagrave.com/memorial/134474473",
			"id": 134474473,
			"lng": -77.38611029,
			"lat": 37.53697228,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 7,
			"dd": 19,
			"by": 1886,
			"bd": 14,
			"bm": 5,
			"nm": "Emmett",
			"nf": "Robert",
			"nl": "White",
			"url": "https://findagrave.com/memorial/155989195",
			"id": 155989195,
			"lng": -77.38698518,
			"lat": 37.53549178,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 12,
			"dd": 17,
			"by": 1902,
			"bd": 18,
			"bm": 5,
			"nm": "",
			"nf": "Richard",
			"nl": "White",
			"url": "https://findagrave.com/memorial/138181595",
			"id": 138181595,
			"lng": -77.38650305,
			"lat": 37.53700646,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 11,
			"dd": 30,
			"by": 1884,
			"bd": 25,
			"bm": 10,
			"nm": "T.",
			"nf": "Robert",
			"nl": "White",
			"url": "https://findagrave.com/memorial/117804456",
			"id": 117804456,
			"lng": -77.38556601,
			"lat": 37.53722866,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 2,
			"dd": 18,
			"by": 1908,
			"bd": 5,
			"bm": 1,
			"nm": "Bell",
			"nf": "Rosa",
			"nl": "White",
			"url": "https://findagrave.com/memorial/176060955",
			"id": 176060955,
			"lng": -77.387468,
			"lat": 37.53730734,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 8,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Rosa",
			"nl": "White",
			"url": "https://findagrave.com/memorial/139424787",
			"id": 139424787,
			"lng": -77.38796899,
			"lat": 37.53712514,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 1,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rosa",
			"nl": "White",
			"url": "https://findagrave.com/memorial/147853941",
			"id": 147853941,
			"lng": -77.38600802,
			"lat": 37.53629999,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 3,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Ann",
			"nf": "Sallie",
			"nl": "White",
			"url": "https://findagrave.com/memorial/146682170",
			"id": 146682170,
			"lng": -77.38615709,
			"lat": 37.53577463,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 8,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Samuel",
			"nl": "White",
			"url": "https://findagrave.com/memorial/177768036",
			"id": 177768036,
			"lng": -77.38777309,
			"lat": 37.53757622,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 9,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "D.",
			"nf": "Samuel",
			"nl": "White",
			"url": "https://findagrave.com/memorial/119328069",
			"id": 119328069,
			"lng": -77.38550328,
			"lat": 37.53732739,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 12,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "Sarah",
			"nl": "White",
			"url": "https://findagrave.com/memorial/144821957",
			"id": 144821957,
			"lng": -77.38554281,
			"lat": 37.53723433,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 11,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Scott",
			"nl": "White",
			"url": "https://findagrave.com/memorial/142511383",
			"id": 142511383,
			"lng": -77.38571449,
			"lat": 37.53719233,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 3,
			"dd": 19,
			"by": 1880,
			"bd": 4,
			"bm": 10,
			"nm": "",
			"nf": "Selena",
			"nl": "White",
			"url": "https://findagrave.com/memorial/130737039",
			"id": 130737039,
			"lng": -77.38571095,
			"lat": 37.53719888,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 2,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Lee",
			"nf": "Walter",
			"nl": "White",
			"url": "https://findagrave.com/memorial/175449924",
			"id": 175449924,
			"lng": -77.38748265,
			"lat": 37.53700576,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 6,
			"dd": 8,
			"by": 1908,
			"bd": 10,
			"bm": 1,
			"nm": "Jack",
			"nf": "Wellington",
			"nl": "White",
			"url": "https://findagrave.com/memorial/170815007",
			"id": 170815007,
			"lng": -77.38630396,
			"lat": 37.53681196,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 1,
			"dd": 31,
			"by": 1903,
			"bd": 14,
			"bm": 9,
			"nm": "Hamilton",
			"nf": "William",
			"nl": "White",
			"url": "https://findagrave.com/memorial/150033853",
			"id": 150033853,
			"lng": -77.38627469,
			"lat": 37.53586226,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 3,
			"dd": 9,
			"by": 1886,
			"bd": 15,
			"bm": 3,
			"nm": "W.",
			"nf": "John",
			"nl": "Whitfield",
			"url": "https://findagrave.com/memorial/138573019",
			"id": 138573019,
			"lng": -77.38622693,
			"lat": 37.53666423,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 7,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucy",
			"nl": "Whiting",
			"url": "https://findagrave.com/memorial/119328233",
			"id": 119328233,
			"lng": -77.3855196,
			"lat": 37.53730727,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 3,
			"dd": 17,
			"by": 1892,
			"bd": 1,
			"bm": 5,
			"nm": "",
			"nf": "Channie",
			"nl": "Whitlow",
			"url": "https://findagrave.com/memorial/144383187",
			"id": 144383187,
			"lng": -77.38606721,
			"lat": 37.53730676,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 9,
			"dd": 15,
			"by": 1893,
			"bd": 12,
			"bm": 7,
			"nm": "",
			"nf": "Albert",
			"nl": "Wickham",
			"url": "https://findagrave.com/memorial/152526999",
			"id": 152526999,
			"lng": -77.38582729,
			"lat": 37.5371722,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 10,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Rosa",
			"nl": "Wickham",
			"url": "https://findagrave.com/memorial/160906583",
			"id": 160906583,
			"lng": -77.38700318,
			"lat": 37.53704103,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 10,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "John",
			"nl": "Wiggin",
			"url": "https://findagrave.com/memorial/126456570",
			"id": 126456570,
			"lng": -77.38581546,
			"lat": 37.53640476,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 12,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Cornelius",
			"nl": "Wiley",
			"url": "https://findagrave.com/memorial/157757377",
			"id": 157757377,
			"lng": -77.38575704,
			"lat": 37.53733139,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 6,
			"dd": 30,
			"by": 1905,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ethel",
			"nl": "Wiley",
			"url": "https://findagrave.com/memorial/173793418",
			"id": 173793418,
			"lng": -77.38704396,
			"lat": 37.53720503,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 2,
			"dd": 11,
			"by": 1902,
			"bd": 10,
			"bm": 12,
			"nm": "",
			"nf": "Hercules",
			"nl": "Wiley",
			"url": "https://findagrave.com/memorial/142514773",
			"id": 142514773,
			"lng": -77.38579105,
			"lat": 37.5373134,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 1,
			"dd": 22,
			"by": 1911,
			"bd": 3,
			"bm": 7,
			"nm": "W.",
			"nf": "John",
			"nl": "Wiley",
			"url": "https://findagrave.com/memorial/161179877",
			"id": 161179877,
			"lng": -77.38644955,
			"lat": 37.53707047,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 1,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lillie",
			"nl": "Wiley",
			"url": "https://findagrave.com/memorial/144227275",
			"id": 144227275,
			"lng": -77.385923,
			"lat": 37.53733135,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 11,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Virginia",
			"nl": "Wiley",
			"url": "https://findagrave.com/memorial/142514789",
			"id": 142514789,
			"lng": -77.38576267,
			"lat": 37.53731681,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 9,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ada",
			"nl": "Wilkerson",
			"url": "https://findagrave.com/memorial/151113042",
			"id": 151113042,
			"lng": -77.38657983,
			"lat": 37.53547878,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 5,
			"dd": 24,
			"by": 1872,
			"bd": 1,
			"bm": 1,
			"nm": "",
			"nf": "Elijah",
			"nl": "Wilkerson",
			"url": "https://findagrave.com/memorial/130378954",
			"id": 130378954,
			"lng": -77.38599447,
			"lat": 37.53652139,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 6,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Napoleon",
			"nl": "Wilkerson",
			"url": "https://findagrave.com/memorial/123696575",
			"id": 123696575,
			"lng": -77.38596123,
			"lat": 37.53650786,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 7,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Theodore",
			"nl": "Wilkerson",
			"url": "https://findagrave.com/memorial/137431016",
			"id": 137431016,
			"lng": -77.3859432,
			"lat": 37.53703154,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 7,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "William",
			"url": "https://findagrave.com/memorial/187075580",
			"id": 187075580,
			"lng": -77.38755252,
			"lat": 37.53687581,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 4,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Adeline",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/145085246",
			"id": 145085246,
			"lng": -77.38563359,
			"lat": 37.5369957,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 12,
			"dd": 2,
			"by": 1904,
			"bd": 17,
			"bm": 8,
			"nm": "",
			"nf": "Alease",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/177897674",
			"id": 177897674,
			"lng": -77.38759559,
			"lat": 37.53729093,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 10,
			"dd": 22,
			"by": 1913,
			"bd": 15,
			"bm": 1,
			"nm": "",
			"nf": "Anita",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/161179880",
			"id": 161179880,
			"lng": -77.38600908,
			"lat": 37.53628587,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 2,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Ann",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/185357179",
			"id": 185357179,
			"lng": -77.3878403,
			"lat": 37.53628725,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 1,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Augustus",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/134474480",
			"id": 134474480,
			"lng": -77.38621846,
			"lat": 37.53702981,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 1,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "F.",
			"nf": "Benjamin",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/175403069",
			"id": 175403069,
			"lng": -77.38759778,
			"lat": 37.53695983,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1992,
			"dm": "",
			"dd": "",
			"by": 1905,
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "Bernice",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/127569758",
			"id": 127569758,
			"lng": -77.38619611,
			"lat": 37.53703518,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 4,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bertha",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/155539619",
			"id": 155539619,
			"lng": -77.38753753,
			"lat": 37.53766458,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": 7,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bertha",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/150677881",
			"id": 150677881,
			"lng": -77.38630839,
			"lat": 37.53572164,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 9,
			"dd": 4,
			"by": 1891,
			"bd": 17,
			"bm": 7,
			"nm": "",
			"nf": "Callie",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/167327393",
			"id": 167327393,
			"lng": -77.386848,
			"lat": 37.53729526,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1905,
			"dm": 2,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Caroline",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/132046793",
			"id": 132046793,
			"lng": -77.38777487,
			"lat": 37.53636897,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 1,
			"dd": 23,
			"by": 1900,
			"bd": 27,
			"bm": 12,
			"nm": "",
			"nf": "Catherine",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/159876285",
			"id": 159876285,
			"lng": -77.38773993,
			"lat": 37.53752867,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 12,
			"dd": 22,
			"by": 1900,
			"bd": 14,
			"bm": 3,
			"nm": "",
			"nf": "Charles",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/138012354",
			"id": 138012354,
			"lng": -77.38667585,
			"lat": 37.53707952,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 4,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Thomas",
			"nf": "Charles",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/175328151",
			"id": 175328151,
			"lng": -77.38743012,
			"lat": 37.53711008,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 11,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Clarence",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/128452679",
			"id": 128452679,
			"lng": -77.38563424,
			"lat": 37.53700347,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 8,
			"dd": 2,
			"by": 1901,
			"bd": 3,
			"bm": 6,
			"nm": "",
			"nf": "Cora",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/155539701",
			"id": 155539701,
			"lng": -77.3866361,
			"lat": 37.53754694,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 8,
			"dd": 19,
			"by": 1939,
			"bd": "",
			"bm": 7,
			"nm": "",
			"nf": "Delores",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/154202723",
			"id": 154202723,
			"lng": -77.38632579,
			"lat": 37.5352597,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 6,
			"dd": 17,
			"by": 1958,
			"bd": 13,
			"bm": 3,
			"nm": "Laverne",
			"nf": "Doris",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/184099616",
			"id": 184099616,
			"lng": -77.38713542,
			"lat": 37.53763436,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 5,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "Earnest",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/146207125",
			"id": 146207125,
			"lng": -77.38659414,
			"lat": 37.53665934,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 4,
			"dd": 2,
			"by": 1898,
			"bd": 29,
			"bm": 12,
			"nm": "",
			"nf": "Edward",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/176477094",
			"id": 176477094,
			"lng": -77.38717875,
			"lat": 37.53700073,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 12,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Edward",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/144227277",
			"id": 144227277,
			"lng": -77.3858434,
			"lat": 37.53744775,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 6,
			"dd": 24,
			"by": 1904,
			"bd": 15,
			"bm": 7,
			"nm": "D.",
			"nf": "Eliza",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/161052628",
			"id": 161052628,
			"lng": -77.38714696,
			"lat": 37.53710407,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 10,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Eliza",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/150792715",
			"id": 150792715,
			"lng": -77.38653805,
			"lat": 37.53551648,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 9,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Fannie",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/154304057",
			"id": 154304057,
			"lng": -77.38696214,
			"lat": 37.53542094,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 10,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Fannie",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/131428545",
			"id": 131428545,
			"lng": -77.38744968,
			"lat": 37.53659882,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 12,
			"dd": 19,
			"by": 1881,
			"bd": 14,
			"bm": 3,
			"nm": "",
			"nf": "Fannie",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/114399883",
			"id": 114399883,
			"lng": -77.38581441,
			"lat": 37.53682894,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 9,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "T.",
			"nf": "Florence",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/152210951",
			"id": 152210951,
			"lng": -77.3858141,
			"lat": 37.53693198,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 6,
			"dd": 10,
			"by": 1930,
			"bd": 10,
			"bm": 9,
			"nm": "E.",
			"nf": "Florence",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/142531418",
			"id": 142531418,
			"lng": -77.3859367,
			"lat": 37.53737825,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1902,
			"dm": 3,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Fountain",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/175103285",
			"id": 175103285,
			"lng": -77.38751233,
			"lat": 37.53643593,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 3,
			"dd": 25,
			"by": 1919,
			"bd": 13,
			"bm": 1,
			"nm": "Carlton",
			"nf": "Frank",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/159877053",
			"id": 159877053,
			"lng": -77.38811867,
			"lat": 37.53747435,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 7,
			"dd": 24,
			"by": 1905,
			"bd": 6,
			"bm": 3,
			"nm": "",
			"nf": "Gardenia",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/138012358",
			"id": 138012358,
			"lng": -77.38667297,
			"lat": 37.53708998,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 10,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Georgianna",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/188245085",
			"id": 188245085,
			"lng": -77.38789554,
			"lat": 37.53719137,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 12,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C.",
			"nf": "Gilford",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/175464601",
			"id": 175464601,
			"lng": -77.3875079,
			"lat": 37.53702976,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 1,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "U.",
			"nf": "Harrison",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/152298549",
			"id": 152298549,
			"lng": -77.38578754,
			"lat": 37.53695118,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 2,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Henry",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/114399886",
			"id": 114399886,
			"lng": -77.38581175,
			"lat": 37.53683279,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 1,
			"dd": 12,
			"by": 1905,
			"bd": 30,
			"bm": 7,
			"nm": "",
			"nf": "Isabell",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/154516737",
			"id": 154516737,
			"lng": -77.38654898,
			"lat": 37.53701629,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 3,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Isabelle",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/144227284",
			"id": 144227284,
			"lng": -77.38604905,
			"lat": 37.53728872,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 8,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/149353934",
			"id": 149353934,
			"lng": -77.38633614,
			"lat": 37.53709535,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 10,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jeff",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/173793426",
			"id": 173793426,
			"lng": -77.38725541,
			"lat": 37.53752678,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 1,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jennie",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/135741748",
			"id": 135741748,
			"lng": -77.38562884,
			"lat": 37.53696623,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 3,
			"dd": 12,
			"by": 1893,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jesse",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/127569768",
			"id": 127569768,
			"lng": -77.3857314,
			"lat": 37.53713276,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 8,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "John",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/186917627",
			"id": 186917627,
			"lng": -77.3874916,
			"lat": 37.53695518,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 9,
			"dd": 21,
			"by": 1903,
			"bd": 26,
			"bm": 2,
			"nm": "T.",
			"nf": "John",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/173066363",
			"id": 173066363,
			"lng": -77.3870688,
			"lat": 37.53729522,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 12,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/148285811",
			"id": 148285811,
			"lng": -77.38645657,
			"lat": 37.53723138,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 4,
			"dd": 10,
			"by": 1884,
			"bd": 27,
			"bm": 10,
			"nm": "A.",
			"nf": "Junius",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/156286053",
			"id": 156286053,
			"lng": -77.38588671,
			"lat": 37.53710382,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 5,
			"dd": 5,
			"by": 1888,
			"bd": 29,
			"bm": 2,
			"nm": "",
			"nf": "Katie",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/138366563",
			"id": 138366563,
			"lng": -77.38633016,
			"lat": 37.53678094,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 5,
			"dd": 15,
			"by": 1864,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Kemp",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/150932506",
			"id": 150932506,
			"lng": -77.38676174,
			"lat": 37.53573762,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 10,
			"dd": 29,
			"by": 1927,
			"bd": 18,
			"bm": 2,
			"nm": "",
			"nf": "Lillian",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/144227352",
			"id": 144227352,
			"lng": -77.38644858,
			"lat": 37.53741481,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 2,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lillie",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/162642628",
			"id": 162642628,
			"lng": -77.3866125,
			"lat": 37.53703292,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 3,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Louis",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/155539723",
			"id": 155539723,
			"lng": -77.38630468,
			"lat": 37.5360906,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 11,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Luberta",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/154228786",
			"id": 154228786,
			"lng": -77.38635753,
			"lat": 37.53739206,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 11,
			"dd": 18,
			"by": 1863,
			"bd": 10,
			"bm": 3,
			"nm": "B.",
			"nf": "Lucy",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/144383198",
			"id": 144383198,
			"lng": -77.38724259,
			"lat": 37.53777959,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 8,
			"dd": 15,
			"by": 1884,
			"bd": 1,
			"bm": 4,
			"nm": "Virginia",
			"nf": "Lula",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/142514805",
			"id": 142514805,
			"lng": -77.38573843,
			"lat": 37.53732566,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 8,
			"dd": 18,
			"by": 1914,
			"bd": 15,
			"bm": 6,
			"nm": "H.",
			"nf": "Mary",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/128452686",
			"id": 128452686,
			"lng": -77.38623327,
			"lat": 37.53681736,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 1,
			"dd": 28,
			"by": 1910,
			"bd": 25,
			"bm": 12,
			"nm": "Alice",
			"nf": "Maxie",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/144227356",
			"id": 144227356,
			"lng": -77.38732164,
			"lat": 37.53783415,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 2,
			"dd": 19,
			"by": 1884,
			"bd": 9,
			"bm": 7,
			"nm": "",
			"nf": "Mozelle",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/145838789",
			"id": 145838789,
			"lng": -77.38675822,
			"lat": 37.53577363,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 12,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nellie",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/145167335",
			"id": 145167335,
			"lng": -77.38624474,
			"lat": 37.5371428,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 9,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "T.",
			"nf": "Oliver",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/145838803",
			"id": 145838803,
			"lng": -77.38674639,
			"lat": 37.53578446,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 4,
			"dd": 10,
			"by": 1872,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ottaway",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/158118883",
			"id": 158118883,
			"lng": -77.38785603,
			"lat": 37.53723873,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 6,
			"dd": 19,
			"by": 1889,
			"bd": 21,
			"bm": 11,
			"nm": "B.",
			"nf": "Pinkie",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/137431022",
			"id": 137431022,
			"lng": -77.3858892,
			"lat": 37.53709892,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 2,
			"dd": 28,
			"by": 1852,
			"bd": 3,
			"bm": 6,
			"nm": "",
			"nf": "Randolph",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/125644059",
			"id": 125644059,
			"lng": -77.38574838,
			"lat": 37.53666565,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 8,
			"dd": 15,
			"by": 1910,
			"bd": 25,
			"bm": 4,
			"nm": "E.",
			"nf": "Reginald",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/142514817",
			"id": 142514817,
			"lng": -77.38574972,
			"lat": 37.5373277,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 9,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Robert",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/159884839",
			"id": 159884839,
			"lng": -77.38655454,
			"lat": 37.5374483,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 8,
			"dd": 28,
			"by": 1910,
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "Robert",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/171780427",
			"id": 171780427,
			"lng": -77.38696557,
			"lat": 37.53715648,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 5,
			"dd": 12,
			"by": 1961,
			"bd": 8,
			"bm": 10,
			"nm": "Dexter",
			"nf": "Ronald",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/153865052",
			"id": 153865052,
			"lng": -77.38622369,
			"lat": 37.53744469,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 10,
			"dd": 10,
			"by": 1933,
			"bd": 7,
			"bm": 10,
			"nm": "",
			"nf": "Rosa",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/158960475",
			"id": 158960475,
			"lng": -77.38685839,
			"lat": 37.53736585,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 5,
			"dd": 16,
			"by": 1909,
			"bd": 10,
			"bm": 9,
			"nm": "",
			"nf": "Ruth",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/123851397",
			"id": 123851397,
			"lng": -77.38602461,
			"lat": 37.53669143,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 6,
			"dd": 30,
			"by": 1906,
			"bd": 29,
			"bm": 6,
			"nm": "",
			"nf": "Sarah",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/173793430",
			"id": 173793430,
			"lng": -77.38707691,
			"lat": 37.53722642,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 1,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "R.",
			"nf": "Sonja",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/142106366",
			"id": 142106366,
			"lng": -77.3859505,
			"lat": 37.53743484,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 4,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Susan",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/154259824",
			"id": 154259824,
			"lng": -77.38647226,
			"lat": 37.53551017,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1911,
			"dm": "",
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "F.",
			"nf": "Thomas",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/185357198",
			"id": 185357198,
			"lng": -77.38782773,
			"lat": 37.53630164,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 4,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Thomas",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/130737044",
			"id": 130737044,
			"lng": -77.38564246,
			"lat": 37.53695949,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 5,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Virgil",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/127134221",
			"id": 127134221,
			"lng": -77.38659402,
			"lat": 37.5366699,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 1,
			"dd": 23,
			"by": 1892,
			"bd": "",
			"bm": 7,
			"nm": "",
			"nf": "James",
			"nl": "Williamson",
			"url": "https://findagrave.com/memorial/185151799",
			"id": 185151799,
			"lng": -77.38627387,
			"lat": 37.53661973,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 3,
			"dd": 15,
			"by": 1871,
			"bd": 25,
			"bm": 1,
			"nm": "S.",
			"nf": "Joseph",
			"nl": "Williamson",
			"url": "https://findagrave.com/memorial/141701467",
			"id": 141701467,
			"lng": -77.38640554,
			"lat": 37.5373188,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 1,
			"dd": 24,
			"by": 1910,
			"bd": 23,
			"bm": 10,
			"nm": "Harold",
			"nf": "John",
			"nl": "Willingham",
			"url": "https://findagrave.com/memorial/187368568",
			"id": 187368568,
			"lng": -77.38800659,
			"lat": 37.53746666,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 1,
			"dd": 16,
			"by": 1901,
			"bd": 25,
			"bm": 3,
			"nm": "",
			"nf": "Eugene",
			"nl": "Willis",
			"url": "https://findagrave.com/memorial/155769023",
			"id": 155769023,
			"lng": -77.38717811,
			"lat": 37.53553643,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 9,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Hardinia",
			"nl": "Willis",
			"url": "https://findagrave.com/memorial/125859692",
			"id": 125859692,
			"lng": -77.38591467,
			"lat": 37.53619024,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 1,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Gibbs",
			"nf": "Julian",
			"nl": "Willis",
			"url": "https://findagrave.com/memorial/187571445",
			"id": 187571445,
			"lng": -77.3876484,
			"lat": 37.53689715,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 10,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Willis",
			"url": "https://findagrave.com/memorial/152354853",
			"id": 152354853,
			"lng": -77.38626648,
			"lat": 37.5355515,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 1,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Pauline",
			"nl": "Willis",
			"url": "https://findagrave.com/memorial/174782793",
			"id": 174782793,
			"lng": -77.38739458,
			"lat": 37.53703125,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 5,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Annie",
			"nl": "Wilson",
			"url": "https://findagrave.com/memorial/162203680",
			"id": 162203680,
			"lng": -77.38775765,
			"lat": 37.53663888,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 6,
			"dd": 23,
			"by": 1881,
			"bd": 21,
			"bm": 8,
			"nm": "",
			"nf": "Charles",
			"nl": "Wilson",
			"url": "https://findagrave.com/memorial/176247568",
			"id": 176247568,
			"lng": -77.38774405,
			"lat": 37.53741709,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 2,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Columbia",
			"nl": "Wilson",
			"url": "https://findagrave.com/memorial/173106674",
			"id": 173106674,
			"lng": -77.38773652,
			"lat": 37.53661365,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 7,
			"dd": 17,
			"by": 1968,
			"bd": 17,
			"bm": 7,
			"nm": "Yvette",
			"nf": "Jacqueline",
			"nl": "Wilson",
			"url": "https://findagrave.com/memorial/142516304",
			"id": 142516304,
			"lng": -77.38591814,
			"lat": 37.53740488,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 6,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "James",
			"nl": "Wilson",
			"url": "https://findagrave.com/memorial/173106536",
			"id": 173106536,
			"lng": -77.38773678,
			"lat": 37.53660662,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 11,
			"dd": 12,
			"by": 1898,
			"bd": 2,
			"bm": 12,
			"nm": "",
			"nf": "James",
			"nl": "Wilson",
			"url": "https://findagrave.com/memorial/158960480",
			"id": 158960480,
			"lng": -77.38714043,
			"lat": 37.53738513,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 9,
			"dd": 29,
			"by": 1930,
			"bd": 16,
			"bm": 8,
			"nm": "W.",
			"nf": "John",
			"nl": "Wilson",
			"url": "https://findagrave.com/memorial/114466982",
			"id": 114466982,
			"lng": -77.38652578,
			"lat": 37.5369515,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 7,
			"dd": 12,
			"by": 1969,
			"bd": 1,
			"bm": 6,
			"nm": "Dion",
			"nf": "Johnathan",
			"nl": "Wilson",
			"url": "https://findagrave.com/memorial/148648739",
			"id": 148648739,
			"lng": -77.38591063,
			"lat": 37.53742361,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 1,
			"dd": 28,
			"by": 1950,
			"bd": 11,
			"bm": 7,
			"nm": "Ann",
			"nf": "Mary",
			"nl": "Wilson",
			"url": "https://findagrave.com/memorial/153709044",
			"id": 153709044,
			"lng": -77.3862926,
			"lat": 37.53748807,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 12,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mollie",
			"nl": "Wilson",
			"url": "https://findagrave.com/memorial/185246163",
			"id": 185246163,
			"lng": -77.38731436,
			"lat": 37.536273,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 12,
			"dd": 13,
			"by": 1906,
			"bd": 12,
			"bm": 7,
			"nm": "",
			"nf": "Mollie",
			"nl": "Wilson",
			"url": "https://findagrave.com/memorial/182649705",
			"id": 182649705,
			"lng": -77.38676894,
			"lat": 37.53769644,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": 7,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Pinkie",
			"nl": "Wilson",
			"url": "https://findagrave.com/memorial/185151817",
			"id": 185151817,
			"lng": -77.38777876,
			"lat": 37.53661329,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 8,
			"dd": 1,
			"by": 1879,
			"bd": 12,
			"bm": 1,
			"nm": "",
			"nf": "Savannah",
			"nl": "Wilson",
			"url": "https://findagrave.com/memorial/177750417",
			"id": 177750417,
			"lng": -77.38775752,
			"lat": 37.5374101,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 4,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "William",
			"nl": "Wilson",
			"url": "https://findagrave.com/memorial/185151828",
			"id": 185151828,
			"lng": -77.38777559,
			"lat": 37.53662179,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 3,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Washington",
			"nf": "George",
			"nl": "Winchester",
			"url": "https://findagrave.com/memorial/162203456",
			"id": 162203456,
			"lng": -77.38780536,
			"lat": 37.53709617,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 6,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Elijah",
			"nl": "Wingfield",
			"url": "https://findagrave.com/memorial/119391371",
			"id": 119391371,
			"lng": -77.38581537,
			"lat": 37.53666441,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 10,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Eva",
			"nl": "Wingfield",
			"url": "https://findagrave.com/memorial/125408720",
			"id": 125408720,
			"lng": -77.38797546,
			"lat": 37.53700925,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1904,
			"dm": 6,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "John",
			"nl": "Wingfield",
			"url": "https://findagrave.com/memorial/127134266",
			"id": 127134266,
			"lng": -77.38641506,
			"lat": 37.53639715,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 8,
			"dd": 3,
			"by": 1879,
			"bd": "",
			"bm": 10,
			"nm": "W.",
			"nf": "Junius",
			"nl": "Wingfield",
			"url": "https://findagrave.com/memorial/158960487",
			"id": 158960487,
			"lng": -77.38660323,
			"lat": 37.53754046,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 3,
			"dd": 10,
			"by": 1895,
			"bd": 15,
			"bm": 1,
			"nm": "B.",
			"nf": "Mary",
			"nl": "Wingfield",
			"url": "https://findagrave.com/memorial/119391378",
			"id": 119391378,
			"lng": -77.38581878,
			"lat": 37.53665728,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": 6,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Robert",
			"nl": "Wingfield",
			"url": "https://findagrave.com/memorial/160934073",
			"id": 160934073,
			"lng": -77.38646735,
			"lat": 37.53639602,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 2,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Carolyn",
			"nl": "Winn",
			"url": "https://findagrave.com/memorial/149352234",
			"id": 149352234,
			"lng": -77.38644406,
			"lat": 37.53710622,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 10,
			"dd": 11,
			"by": 1872,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Celista",
			"nl": "Winslow",
			"url": "https://findagrave.com/memorial/151448729",
			"id": 151448729,
			"lng": -77.3868061,
			"lat": 37.53542315,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 5,
			"dd": 4,
			"by": 1900,
			"bd": 27,
			"bm": 10,
			"nm": "Wesly",
			"nf": "Willie",
			"nl": "Winstead",
			"url": "https://findagrave.com/memorial/181882745",
			"id": 181882745,
			"lng": -77.3855406,
			"lat": 37.53729081,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 8,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "baby boy",
			"nl": "Winston",
			"url": "https://findagrave.com/memorial/125859697",
			"id": 125859697,
			"lng": -77.38599519,
			"lat": 37.53746592,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 7,
			"dd": 4,
			"by": 1887,
			"bd": 10,
			"bm": 5,
			"nm": "",
			"nf": "Charlie",
			"nl": "Winston",
			"url": "https://findagrave.com/memorial/159762374",
			"id": 159762374,
			"lng": -77.38765539,
			"lat": 37.53783743,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 9,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Emma",
			"nl": "Winston",
			"url": "https://findagrave.com/memorial/117449125",
			"id": 117449125,
			"lng": -77.38578084,
			"lat": 37.53674594,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 4,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ernestine",
			"nl": "Winston",
			"url": "https://findagrave.com/memorial/144227410",
			"id": 144227410,
			"lng": -77.3859967,
			"lat": 37.53731408,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 12,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Julia",
			"nl": "Winston",
			"url": "https://findagrave.com/memorial/117449127",
			"id": 117449127,
			"lng": -77.38577685,
			"lat": 37.53675638,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 4,
			"dd": 8,
			"by": 1893,
			"bd": 10,
			"bm": 10,
			"nm": "",
			"nf": "Lillie",
			"nl": "Winston",
			"url": "https://findagrave.com/memorial/160433764",
			"id": 160433764,
			"lng": -77.38584906,
			"lat": 37.53686058,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 5,
			"dd": 18,
			"by": 1894,
			"bd": 2,
			"bm": 4,
			"nm": "",
			"nf": "Marie",
			"nl": "Winston",
			"url": "https://findagrave.com/memorial/130968039",
			"id": 130968039,
			"lng": -77.38569476,
			"lat": 37.5372109,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 8,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Louise",
			"nf": "Mary",
			"nl": "Winston",
			"url": "https://findagrave.com/memorial/159762381",
			"id": 159762381,
			"lng": -77.38765183,
			"lat": 37.53784618,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 10,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Michael",
			"nl": "Winston",
			"url": "https://findagrave.com/memorial/142531432",
			"id": 142531432,
			"lng": -77.38647579,
			"lat": 37.53531565,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 12,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mildred",
			"nl": "Winston",
			"url": "https://findagrave.com/memorial/144383208",
			"id": 144383208,
			"lng": -77.38754703,
			"lat": 37.53729484,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 9,
			"dd": 9,
			"by": 1906,
			"bd": 6,
			"bm": 1,
			"nm": "E.",
			"nf": "Morrell",
			"nl": "Winston",
			"url": "https://findagrave.com/memorial/126772137",
			"id": 126772137,
			"lng": -77.38592385,
			"lat": 37.53637269,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 3,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nicholson",
			"nl": "Winston",
			"url": "https://findagrave.com/memorial/176983174",
			"id": 176983174,
			"lng": -77.38748722,
			"lat": 37.53567991,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 5,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Patrick",
			"nl": "Winston",
			"url": "https://findagrave.com/memorial/185523371",
			"id": 185523371,
			"lng": -77.38663166,
			"lat": 37.53593066,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 2,
			"dd": 16,
			"by": 1881,
			"bd": 4,
			"bm": "",
			"nm": "J.",
			"nf": "Emma",
			"nl": "Wise",
			"url": "https://findagrave.com/memorial/137332656",
			"id": 137332656,
			"lng": -77.38596901,
			"lat": 37.53708515,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 7,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Fred",
			"nl": "Wise",
			"url": "https://findagrave.com/memorial/137431034",
			"id": 137431034,
			"lng": -77.38596563,
			"lat": 37.53709186,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 5,
			"dd": 29,
			"by": 1894,
			"bd": 20,
			"bm": 11,
			"nm": "",
			"nf": "Joanna",
			"nl": "Wise",
			"url": "https://findagrave.com/memorial/128675516",
			"id": 128675516,
			"lng": -77.38576268,
			"lat": 37.53718339,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 9,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Samuel",
			"nl": "Wise",
			"url": "https://findagrave.com/memorial/137332694",
			"id": 137332694,
			"lng": -77.38594249,
			"lat": 37.53706886,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 8,
			"dd": 20,
			"by": 1898,
			"bd": 4,
			"bm": 7,
			"nm": "",
			"nf": "Herbert",
			"nl": "Withers",
			"url": "https://findagrave.com/memorial/158960493",
			"id": 158960493,
			"lng": -77.38745996,
			"lat": 37.53756862,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 11,
			"dd": 24,
			"by": 1873,
			"bd": 3,
			"bm": 7,
			"nm": "",
			"nf": "Alexander",
			"nl": "Womack",
			"url": "https://findagrave.com/memorial/133668090",
			"id": 133668090,
			"lng": -77.38594722,
			"lat": 37.53615502,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 3,
			"dd": 28,
			"by": 1887,
			"bd": 20,
			"bm": 8,
			"nm": "",
			"nf": "Florence",
			"nl": "Womack",
			"url": "https://findagrave.com/memorial/156480548",
			"id": 156480548,
			"lng": -77.38594956,
			"lat": 37.53614554,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 4,
			"dd": 29,
			"by": 1880,
			"bd": 22,
			"bm": 9,
			"nm": "",
			"nf": "Lula",
			"nl": "Womble",
			"url": "https://findagrave.com/memorial/167182314",
			"id": 167182314,
			"lng": -77.38660118,
			"lat": 37.53685212,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 6,
			"dd": 14,
			"by": 1908,
			"bd": 16,
			"bm": 1,
			"nm": "R.",
			"nf": "Andrea",
			"nl": "Wood",
			"url": "https://findagrave.com/memorial/168819857",
			"id": 168819857,
			"lng": -77.38631855,
			"lat": 37.5369855,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 2,
			"dd": 8,
			"by": 1931,
			"bd": 2,
			"bm": 5,
			"nm": "Aristotle",
			"nf": "Andrea",
			"nl": "Wood",
			"url": "https://findagrave.com/memorial/130737051",
			"id": 130737051,
			"lng": -77.38634914,
			"lat": 37.53696316,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 10,
			"dd": 5,
			"by": 1872,
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "Charles",
			"nl": "Wood",
			"url": "https://findagrave.com/memorial/151423918",
			"id": 151423918,
			"lng": -77.38678139,
			"lat": 37.53542142,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 3,
			"dd": 23,
			"by": 1908,
			"bd": 10,
			"bm": 10,
			"nm": "",
			"nf": "Charles",
			"nl": "Wood",
			"url": "https://findagrave.com/memorial/175464172",
			"id": 175464172,
			"lng": -77.38749708,
			"lat": 37.53720279,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 6,
			"dd": 25,
			"by": 1874,
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Ellen",
			"nl": "Wood",
			"url": "https://findagrave.com/memorial/151448116",
			"id": 151448116,
			"lng": -77.38678398,
			"lat": 37.53542147,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 10,
			"dd": 8,
			"by": 1875,
			"bd": 5,
			"bm": 5,
			"nm": "Virginia",
			"nf": "Ida",
			"nl": "Wood",
			"url": "https://findagrave.com/memorial/38456109",
			"id": 38456109,
			"lng": -77.38570304,
			"lat": 37.53707267,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 7,
			"dd": 26,
			"by": 1871,
			"bd": "",
			"bm": "",
			"nm": "Peyton",
			"nf": "James",
			"nl": "Wood",
			"url": "https://findagrave.com/memorial/151491268",
			"id": 151491268,
			"lng": -77.38570503,
			"lat": 37.53706485,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1987,
			"dm": 1,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "T.",
			"nf": "Ruth",
			"nl": "Wood",
			"url": "https://findagrave.com/memorial/38455711",
			"id": 38455711,
			"lng": -77.38572692,
			"lat": 37.53695216,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 7,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H",
			"nf": "William",
			"nl": "Wood",
			"url": "https://findagrave.com/memorial/170838967",
			"id": 170838967,
			"lng": -77.38650472,
			"lat": 37.53716901,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 4,
			"dd": 27,
			"by": 1885,
			"bd": 7,
			"bm": 7,
			"nm": "L.",
			"nf": "Gertrude",
			"nl": "Wooden",
			"url": "https://findagrave.com/memorial/179854704",
			"id": 179854704,
			"lng": -77.38598787,
			"lat": 37.53733083,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 2,
			"dd": 13,
			"by": 1904,
			"bd": 4,
			"bm": 1,
			"nm": "C.",
			"nf": "Joseph",
			"nl": "Wooden",
			"url": "https://findagrave.com/memorial/174622150",
			"id": 174622150,
			"lng": -77.38686613,
			"lat": 37.53710048,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 9,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lottie",
			"nl": "Woodley",
			"url": "https://findagrave.com/memorial/142516312",
			"id": 142516312,
			"lng": -77.38589467,
			"lat": 37.53728207,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 6,
			"dd": 22,
			"by": 1893,
			"bd": 16,
			"bm": 7,
			"nm": "Lee",
			"nf": "Clarence",
			"nl": "Woodson",
			"url": "https://findagrave.com/memorial/177119422",
			"id": 177119422,
			"lng": -77.38654627,
			"lat": 37.53573063,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 7,
			"dd": 3,
			"by": 1956,
			"bd": 26,
			"bm": 4,
			"nm": "Nathaniel",
			"nf": "Emmett",
			"nl": "Woodson",
			"url": "https://findagrave.com/memorial/177545585",
			"id": 177545585,
			"lng": -77.38732156,
			"lat": 37.53792345,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 12,
			"dd": 12,
			"by": 1864,
			"bd": "",
			"bm": 3,
			"nm": "",
			"nf": "Floyd",
			"nl": "Woodson",
			"url": "https://findagrave.com/memorial/125094164",
			"id": 125094164,
			"lng": -77.38618225,
			"lat": 37.53684306,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 3,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Harriett",
			"nl": "Woodson",
			"url": "https://findagrave.com/memorial/146020052",
			"id": 146020052,
			"lng": -77.38654769,
			"lat": 37.53573985,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1907,
			"dm": 10,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Henrietta",
			"nl": "Woodson",
			"url": "https://findagrave.com/memorial/127134241",
			"id": 127134241,
			"lng": -77.38641682,
			"lat": 37.53639758,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 8,
			"dd": 11,
			"by": 1899,
			"bd": 7,
			"bm": 1,
			"nm": "Bell",
			"nf": "Ida",
			"nl": "Woodson",
			"url": "https://findagrave.com/memorial/158335478",
			"id": 158335478,
			"lng": -77.38584541,
			"lat": 37.53739142,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 8,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Woodson",
			"url": "https://findagrave.com/memorial/187586853",
			"id": 187586853,
			"lng": -77.38768786,
			"lat": 37.53701386,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 11,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Alfred",
			"nf": "James",
			"nl": "Woodson",
			"url": "https://findagrave.com/memorial/144383226",
			"id": 144383226,
			"lng": -77.3866131,
			"lat": 37.53572767,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 12,
			"dd": 19,
			"by": 1889,
			"bd": "",
			"bm": 12,
			"nm": "T.",
			"nf": "James",
			"nl": "Woodson",
			"url": "https://findagrave.com/memorial/158335483",
			"id": 158335483,
			"lng": -77.3858424,
			"lat": 37.53739519,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 12,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Lucy",
			"nl": "Woodson",
			"url": "https://findagrave.com/memorial/156480554",
			"id": 156480554,
			"lng": -77.38655009,
			"lat": 37.53575036,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 10,
			"dd": 14,
			"by": 1866,
			"bd": 5,
			"bm": 6,
			"nm": "",
			"nf": "Mary",
			"nl": "Woodson",
			"url": "https://findagrave.com/memorial/125094169",
			"id": 125094169,
			"lng": -77.38617863,
			"lat": 37.53684222,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 10,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Robert",
			"nl": "Woodson",
			"url": "https://findagrave.com/memorial/177151547",
			"id": 177151547,
			"lng": -77.38798559,
			"lat": 37.53704278,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 6,
			"dd": 23,
			"by": 1926,
			"bd": 5,
			"bm": 6,
			"nm": "",
			"nf": "Isabelle",
			"nl": "Woody",
			"url": "https://findagrave.com/memorial/160851131",
			"id": 160851131,
			"lng": -77.38778871,
			"lat": 37.53772705,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 2,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Fannie",
			"nf": "Mary",
			"nl": "Woody",
			"url": "https://findagrave.com/memorial/144558774",
			"id": 144558774,
			"lng": -77.38749951,
			"lat": 37.53733614,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1980,
			"dm": 1,
			"dd": 22,
			"by": 1926,
			"bd": 8,
			"bm": 6,
			"nm": "Louis",
			"nf": "Robert",
			"nl": "Woody",
			"url": "https://findagrave.com/memorial/150637850",
			"id": 150637850,
			"lng": -77.38641889,
			"lat": 37.53595963,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 2,
			"dd": 12,
			"by": 1887,
			"bd": 10,
			"bm": 8,
			"nm": "Ann",
			"nf": "Alice",
			"nl": "Wooldridge",
			"url": "https://findagrave.com/memorial/148519048",
			"id": 148519048,
			"lng": -77.3866992,
			"lat": 37.53540338,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 12,
			"dd": 29,
			"by": 1894,
			"bd": 9,
			"bm": 1,
			"nm": "Richard",
			"nf": "Edgar",
			"nl": "Wooldridge",
			"url": "https://findagrave.com/memorial/172031050",
			"id": 172031050,
			"lng": -77.38698161,
			"lat": 37.53726108,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 12,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ellie",
			"nl": "Wooldridge",
			"url": "https://findagrave.com/memorial/134474489",
			"id": 134474489,
			"lng": -77.38621129,
			"lat": 37.53703827,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1984,
			"dm": 9,
			"dd": 11,
			"by": 1913,
			"bd": 18,
			"bm": 2,
			"nm": "A.",
			"nf": "John",
			"nl": "Wooldridge",
			"url": "https://findagrave.com/memorial/127569773",
			"id": 127569773,
			"lng": -77.38622376,
			"lat": 37.53701809,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 2,
			"dd": 12,
			"by": 1908,
			"bd": 16,
			"bm": 10,
			"nm": "",
			"nf": "Silas",
			"nl": "Wooldridge",
			"url": "https://findagrave.com/memorial/122027633",
			"id": 122027633,
			"lng": -77.38598652,
			"lat": 37.53672787,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 8,
			"dd": 24,
			"by": 1859,
			"bd": 7,
			"bm": 8,
			"nm": "",
			"nf": "Walter",
			"nl": "Wooldridge",
			"url": "https://findagrave.com/memorial/130737057",
			"id": 130737057,
			"lng": -77.38564836,
			"lat": 37.53694446,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 6,
			"dd": 27,
			"by": 1885,
			"bd": "",
			"bm": "",
			"nm": "Thomas",
			"nf": "William",
			"nl": "Wooldridge",
			"url": "https://findagrave.com/memorial/151172091",
			"id": 151172091,
			"lng": -77.38670155,
			"lat": 37.535415,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 9,
			"dd": 18,
			"by": 1881,
			"bd": 17,
			"bm": 8,
			"nm": "H.",
			"nf": "William",
			"nl": "Wooldridge",
			"url": "https://findagrave.com/memorial/134474499",
			"id": 134474499,
			"lng": -77.38621234,
			"lat": 37.53704965,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 8,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Louisa",
			"nl": "Woolfolk",
			"url": "https://findagrave.com/memorial/151694129",
			"id": 151694129,
			"lng": -77.38681179,
			"lat": 37.53572768,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 2,
			"dd": 17,
			"by": 1923,
			"bd": 25,
			"bm": 1,
			"nm": "",
			"nf": "Claude",
			"nl": "Worsley",
			"url": "https://findagrave.com/memorial/161636479",
			"id": 161636479,
			"lng": -77.38611764,
			"lat": 37.53631193,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 2,
			"dd": 2,
			"by": 1960,
			"bd": 27,
			"bm": 12,
			"nm": "",
			"nf": "Darlene",
			"nl": "Worsley",
			"url": "https://findagrave.com/memorial/153627305",
			"id": 153627305,
			"lng": -77.38635094,
			"lat": 37.53759126,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 3,
			"dd": 28,
			"by": 1931,
			"bd": 1,
			"bm": 8,
			"nm": "C.",
			"nf": "Angie",
			"nl": "Wright",
			"url": "https://findagrave.com/memorial/158450812",
			"id": 158450812,
			"lng": -77.38667941,
			"lat": 37.53744414,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 2,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "F.",
			"nf": "Annie",
			"nl": "Wright",
			"url": "https://findagrave.com/memorial/76611325",
			"id": 76611325,
			"lng": -77.38625123,
			"lat": 37.53580621,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 6,
			"dd": 24,
			"by": "",
			"bd": 19,
			"bm": 12,
			"nm": "",
			"nf": "Ella Mae",
			"nl": "Wright",
			"url": "https://findagrave.com/memorial/160851652",
			"id": 160851652,
			"lng": -77.38676098,
			"lat": 37.53739348,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 4,
			"dd": 8,
			"by": 1917,
			"bd": 15,
			"bm": 9,
			"nm": "",
			"nf": "Grady",
			"nl": "Wright",
			"url": "https://findagrave.com/memorial/176713896",
			"id": 176713896,
			"lng": -77.38754218,
			"lat": 37.53721455,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 2,
			"dd": 28,
			"by": 1868,
			"bd": "",
			"bm": 5,
			"nm": "F.",
			"nf": "Jacob",
			"nl": "Wright",
			"url": "https://findagrave.com/memorial/76611334",
			"id": 76611334,
			"lng": -77.38624691,
			"lat": 37.53580944,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 5,
			"dd": 2,
			"by": 1916,
			"bd": "",
			"bm": "",
			"nm": "Mae",
			"nf": "Lily",
			"nl": "Wright",
			"url": "https://findagrave.com/memorial/127992141",
			"id": 127992141,
			"lng": -77.38594798,
			"lat": 37.53671565,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 6,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Louis",
			"nl": "Wright",
			"url": "https://findagrave.com/memorial/120726166",
			"id": 120726166,
			"lng": -77.38566411,
			"lat": 37.53690576,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1907,
			"dm": 3,
			"dd": "",
			"by": 1848,
			"bd": "",
			"bm": 1,
			"nm": "",
			"nf": "Mary",
			"nl": "Wright",
			"url": "https://findagrave.com/memorial/125859701",
			"id": 125859701,
			"lng": -77.38624666,
			"lat": 37.53580185,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 6,
			"dd": 7,
			"by": 1872,
			"bd": 4,
			"bm": 3,
			"nm": "L.",
			"nf": "Susan",
			"nl": "Wright",
			"url": "https://findagrave.com/memorial/125859702",
			"id": 125859702,
			"lng": -77.38624281,
			"lat": 37.53580573,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1977,
			"dm": 3,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Wright",
			"url": "https://findagrave.com/memorial/166825737",
			"id": 166825737,
			"lng": -77.38800833,
			"lat": 37.53748794,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 6,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Willie",
			"nl": "Wright",
			"url": "https://findagrave.com/memorial/185357204",
			"id": 185357204,
			"lng": -77.38723455,
			"lat": 37.5373585,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 4,
			"dd": 22,
			"by": 1890,
			"bd": 13,
			"bm": 3,
			"nm": "James",
			"nf": "Benjamin",
			"nl": "Wyche",
			"url": "https://findagrave.com/memorial/191401045",
			"id": 191401045,
			"lng": -77.38600619,
			"lat": 37.53730557,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 1,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Maria",
			"nl": "Yarborough",
			"url": "https://findagrave.com/memorial/142516326",
			"id": 142516326,
			"lng": -77.38559973,
			"lat": 37.53738098,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 3,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Jane",
			"nf": "Ellen",
			"nl": "Yates",
			"url": "https://findagrave.com/memorial/175820719",
			"id": 175820719,
			"lng": -77.38770357,
			"lat": 37.53714135,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 9,
			"dd": 29,
			"by": 1888,
			"bd": 3,
			"bm": 5,
			"nm": "",
			"nf": "Nathaniel",
			"nl": "Yates",
			"url": "https://findagrave.com/memorial/184094555",
			"id": 184094555,
			"lng": -77.38707582,
			"lat": 37.53754046,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 1,
			"dd": 9,
			"by": 1892,
			"bd": 21,
			"bm": 8,
			"nm": "C.",
			"nf": "Owen",
			"nl": "Yates",
			"url": "https://findagrave.com/memorial/173511546",
			"id": 173511546,
			"lng": -77.38753423,
			"lat": 37.53708164,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 12,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bessie",
			"nl": "Young",
			"url": "https://findagrave.com/memorial/152042556",
			"id": 152042556,
			"lng": -77.38789149,
			"lat": 37.53736365,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 12,
			"dd": 10,
			"by": 1966,
			"bd": "",
			"bm": 11,
			"nm": "Renee",
			"nf": "Deborah",
			"nl": "Young",
			"url": "https://findagrave.com/memorial/145596097",
			"id": 145596097,
			"lng": -77.38596897,
			"lat": 37.5374339,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 4,
			"dd": 22,
			"by": 1889,
			"bd": 15,
			"bm": 6,
			"nm": "",
			"nf": "Fannie",
			"nl": "Young",
			"url": "https://findagrave.com/memorial/175465867",
			"id": 175465867,
			"lng": -77.38755981,
			"lat": 37.5370455,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1929,
			"dm": 5,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Laura",
			"nl": "Young",
			"url": "https://findagrave.com/memorial/177100548",
			"id": 177100548,
			"lng": -77.38791034,
			"lat": 37.53692819,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 10,
			"dd": 13,
			"by": 1910,
			"bd": 26,
			"bm": 5,
			"nm": "H.",
			"nf": "Mary",
			"nl": "Young",
			"url": "https://findagrave.com/memorial/173071274",
			"id": 173071274,
			"lng": -77.38703536,
			"lat": 37.53733143,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 4,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Vernell",
			"nl": "Young",
			"url": "https://findagrave.com/memorial/144821970",
			"id": 144821970,
			"lng": -77.38692709,
			"lat": 37.5366417,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 7,
			"dd": 11,
			"by": 1884,
			"bd": "",
			"bm": 6,
			"nm": "H.",
			"nf": "William",
			"nl": "Young",
			"url": "https://findagrave.com/memorial/182089290",
			"id": 182089290,
			"lng": -77.38668861,
			"lat": 37.53766436,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 11,
			"dd": 16,
			"by": 1909,
			"bd": 19,
			"bm": 1,
			"nm": "",
			"nf": "Major",
			"nl": "Young",
			"url": "https://findagrave.com/memorial/145596114",
			"id": 145596114,
			"lng": -77.38634584,
			"lat": 37.53734907,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 8,
			"dd": 9,
			"by": 1927,
			"bd": 2,
			"bm": 3,
			"nm": "Flora",
			"nf": "Bernice",
			"nl": "Jefferson",
			"url": "https://findagrave.com/memorial/193504531",
			"id": 193504531,
			"lng": -77.38712055,
			"lat": 37.53719803,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 5,
			"dd": 24,
			"by": 1893,
			"bd": 20,
			"bm": 7,
			"nm": "Duqro",
			"nf": "Isaac",
			"nl": "Niles",
			"url": "https://findagrave.com/memorial/192995452",
			"id": 192995452,
			"lng": -77.38679766,
			"lat": 37.53748727,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 5,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Margaret",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/193802120",
			"id": 193802120,
			"lng": -77.38660572,
			"lat": 37.5376748,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 10,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Sadie",
			"nl": "Archer",
			"url": "https://findagrave.com/memorial/193802128",
			"id": 193802128,
			"lng": -77.38656558,
			"lat": 37.53765055,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 9,
			"dd": 11,
			"by": 1880,
			"bd": "",
			"bm": 3,
			"nm": "",
			"nf": "Zack",
			"nl": "Crump",
			"url": "https://findagrave.com/memorial/193802130",
			"id": 193802130,
			"lng": -77.38733502,
			"lat": 37.53713466,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 5,
			"dd": 19,
			"by": 1912,
			"bd": 1,
			"bm": 10,
			"nm": "Edward",
			"nf": "Leslie",
			"nl": "Atkinson",
			"url": "https://findagrave.com/memorial/193699204",
			"id": 193699204,
			"lng": -77.38726156,
			"lat": 37.53711084,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 9,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Louis",
			"nl": "Beverly",
			"url": "https://findagrave.com/memorial/193699211",
			"id": 193699211,
			"lng": -77.38745446,
			"lat": 37.53696609,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 2,
			"dd": 21,
			"by": 1898,
			"bd": 13,
			"bm": 9,
			"nm": "",
			"nf": "Ernest",
			"nl": "Gordon",
			"url": "https://findagrave.com/memorial/193802139",
			"id": 193802139,
			"lng": -77.38728942,
			"lat": 37.53705701,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 10,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Willie",
			"nl": "Poindexter",
			"url": "https://findagrave.com/memorial/193699222",
			"id": 193699222,
			"lng": -77.38746824,
			"lat": 37.53698334,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 6,
			"dd": 3,
			"by": 1893,
			"bd": 24,
			"bm": 10,
			"nm": "",
			"nf": "Edward",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/7810737",
			"id": 7810737,
			"lng": -77.38744107,
			"lat": 37.53697743,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 3,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bernard",
			"nl": "Wallace",
			"url": "https://findagrave.com/memorial/193802147",
			"id": 193802147,
			"lng": -77.38728362,
			"lat": 37.53702549,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 2,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Henry",
			"nf": "William",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/194265386",
			"id": 194265386,
			"lng": -77.38761185,
			"lat": 37.53720184,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 12,
			"dd": 6,
			"by": 1879,
			"bd": 10,
			"bm": 3,
			"nm": "M.",
			"nf": "Joseph",
			"nl": "Trice",
			"url": "https://findagrave.com/memorial/194334703",
			"id": 194334703,
			"lng": -77.38761928,
			"lat": 37.53706094,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 7,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Wilson",
			"url": "https://findagrave.com/memorial/194265406",
			"id": 194265406,
			"lng": -77.38760308,
			"lat": 37.5372106,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 12,
			"dd": 4,
			"by": 1927,
			"bd": 28,
			"bm": 1,
			"nm": "Edward",
			"nf": "William",
			"nl": "Wright",
			"url": "https://findagrave.com/memorial/161053061",
			"id": 161053061,
			"lng": -77.3871659,
			"lat": 37.53705998,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 4,
			"dd": 8,
			"by": 1887,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Katie",
			"nl": "Chambers",
			"url": "https://findagrave.com/memorial/194393404",
			"id": 194393404,
			"lng": -77.38731474,
			"lat": 37.53699937,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 8,
			"dd": 30,
			"by": 1896,
			"bd": 21,
			"bm": 6,
			"nm": "",
			"nf": "Montague",
			"nl": "Clarke",
			"url": "https://findagrave.com/memorial/194393416",
			"id": 194393416,
			"lng": -77.3873673,
			"lat": 37.53698289,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 4,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Minnie",
			"nl": "Craig",
			"url": "https://findagrave.com/memorial/194393436",
			"id": 194393436,
			"lng": -77.38731885,
			"lat": 37.53695573,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 8,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Joseph",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/194393463",
			"id": 194393463,
			"lng": -77.3872959,
			"lat": 37.53691614,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 1,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rosa",
			"nl": "Glover",
			"url": "https://findagrave.com/memorial/194393513",
			"id": 194393513,
			"lng": -77.38729952,
			"lat": 37.5369741,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 4,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Annie",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/194393522",
			"id": 194393522,
			"lng": -77.38731242,
			"lat": 37.53696796,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 9,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Louise Manson",
			"nf": "Mary",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/194334698",
			"id": 194334698,
			"lng": -77.38746063,
			"lat": 37.53705295,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 4,
			"dd": 13,
			"by": 1898,
			"bd": 18,
			"bm": 9,
			"nm": "P.",
			"nf": "Blanche",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/183872875",
			"id": 183872875,
			"lng": -77.38739303,
			"lat": 37.53699056,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 5,
			"dd": 8,
			"by": 1881,
			"bd": 16,
			"bm": 2,
			"nm": "",
			"nf": "Walter",
			"nl": "Wall",
			"url": "https://findagrave.com/memorial/194393630",
			"id": 194393630,
			"lng": -77.38731907,
			"lat": 37.53694799,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 9,
			"dd": 26,
			"by": 1905,
			"bd": 1,
			"bm": 5,
			"nm": "",
			"nf": "Ida",
			"nl": "Hatcher",
			"url": "https://findagrave.com/memorial/192791543",
			"id": 192791543,
			"lng": -77.38652338,
			"lat": 37.53741731,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 1,
			"dd": 5,
			"by": 1894,
			"bd": 2,
			"bm": 4,
			"nm": "",
			"nf": "Eddie",
			"nl": "Fisher",
			"url": "https://findagrave.com/memorial/192995022",
			"id": 192995022,
			"lng": -77.38671742,
			"lat": 37.53754756,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 10,
			"dd": 23,
			"by": 1858,
			"bd": 2,
			"bm": 3,
			"nm": "",
			"nf": "George",
			"nl": "Herbert",
			"url": "https://findagrave.com/memorial/192991194",
			"id": 192991194,
			"lng": -77.38655573,
			"lat": 37.53752288,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 10,
			"dd": 16,
			"by": 1877,
			"bd": "",
			"bm": 11,
			"nm": "",
			"nf": "Betty",
			"nl": "Hunt",
			"url": "https://findagrave.com/memorial/193037827",
			"id": 193037827,
			"lng": -77.38677785,
			"lat": 37.53672352,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 4,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "John",
			"nl": "Fauntleroy",
			"url": "https://findagrave.com/memorial/193257610",
			"id": 193257610,
			"lng": -77.38599564,
			"lat": 37.53597199,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1912,
			"dm": 4,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jennie",
			"nl": "Liggins",
			"url": "https://findagrave.com/memorial/193407090",
			"id": 193407090,
			"lng": -77.38670473,
			"lat": 37.53585317,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 9,
			"dd": 27,
			"by": 1876,
			"bd": 15,
			"bm": 3,
			"nm": "",
			"nf": "Annie",
			"nl": "Booker",
			"url": "https://findagrave.com/memorial/194987763",
			"id": 194987763,
			"lng": -77.38708365,
			"lat": 37.53698074,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 3,
			"dd": 30,
			"by": 1897,
			"bd": 10,
			"bm": 1,
			"nm": "",
			"nf": "Henry",
			"nl": "Fields",
			"url": "https://findagrave.com/memorial/194987768",
			"id": 194987768,
			"lng": -77.38712285,
			"lat": 37.53688247,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 7,
			"dd": 19,
			"by": 1890,
			"bd": 21,
			"bm": 3,
			"nm": "H.",
			"nf": "Henry",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/194987774",
			"id": 194987774,
			"lng": -77.38707774,
			"lat": 37.53700277,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 4,
			"dd": 10,
			"by": 1897,
			"bd": 15,
			"bm": 3,
			"nm": "",
			"nf": "Mack",
			"nl": "McCoy",
			"url": "https://findagrave.com/memorial/194987782",
			"id": 194987782,
			"lng": -77.38723768,
			"lat": 37.5369778,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 12,
			"dd": 24,
			"by": 1924,
			"bd": 7,
			"bm": 4,
			"nm": "Alice",
			"nf": "Mary",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/194987788",
			"id": 194987788,
			"lng": -77.38709703,
			"lat": 37.53693282,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 7,
			"dd": 6,
			"by": 1891,
			"bd": 28,
			"bm": 2,
			"nm": "",
			"nf": "Moses",
			"nl": "Fauntleroy",
			"url": "https://findagrave.com/memorial/195244811",
			"id": 195244811,
			"lng": -77.38733969,
			"lat": 37.53555893,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1928,
			"dm": 5,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "May",
			"nf": "Alice",
			"nl": "Ford",
			"url": "https://findagrave.com/memorial/155989104",
			"id": 155989104,
			"lng": -77.38715633,
			"lat": 37.53548703,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 9,
			"dd": 29,
			"by": 1904,
			"bd": 30,
			"bm": 1,
			"nm": "",
			"nf": "Signolia",
			"nl": "Haley",
			"url": "https://findagrave.com/memorial/191781162",
			"id": 191781162,
			"lng": -77.38709337,
			"lat": 37.5358179,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 9,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/195188506",
			"id": 195188506,
			"lng": -77.38691018,
			"lat": 37.53566534,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 5,
			"dd": 10,
			"by": 1861,
			"bd": 25,
			"bm": 11,
			"nm": "",
			"nf": "Johnson",
			"nl": "Lancaster",
			"url": "https://findagrave.com/memorial/195188582",
			"id": 195188582,
			"lng": -77.38692186,
			"lat": 37.53566409,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 5,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Squire",
			"nl": "Lee",
			"url": "https://findagrave.com/memorial/195092364",
			"id": 195092364,
			"lng": -77.38716101,
			"lat": 37.53567562,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 7,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Edward",
			"nl": "Merritt",
			"url": "https://findagrave.com/memorial/195188596",
			"id": 195188596,
			"lng": -77.38697652,
			"lat": 37.53566747,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 3,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nathan",
			"nl": "Moore",
			"url": "https://findagrave.com/memorial/195188602",
			"id": 195188602,
			"lng": -77.38690091,
			"lat": 37.53587916,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 1,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bettie",
			"nl": "Stevens",
			"url": "https://findagrave.com/memorial/194338409",
			"id": 194338409,
			"lng": -77.38740972,
			"lat": 37.53565571,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 7,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "John",
			"nl": "Thomas",
			"url": "https://findagrave.com/memorial/195188608",
			"id": 195188608,
			"lng": -77.38697337,
			"lat": 37.53569171,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 8,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Robert",
			"nl": "Walker",
			"url": "https://findagrave.com/memorial/195107884",
			"id": 195107884,
			"lng": -77.38715087,
			"lat": 37.5355741,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 12,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "V.",
			"nf": "Queen",
			"nl": "White",
			"url": "https://findagrave.com/memorial/195188661",
			"id": 195188661,
			"lng": -77.38691458,
			"lat": 37.53596006,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 9,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ida",
			"nl": "Winston",
			"url": "https://findagrave.com/memorial/195188668",
			"id": 195188668,
			"lng": -77.3872314,
			"lat": 37.53564917,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 1,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Henry",
			"nf": "William",
			"nl": "Young",
			"url": "https://findagrave.com/memorial/99305969",
			"id": 99305969,
			"lng": -77.38763828,
			"lat": 37.53747544,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 5,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Emma",
			"nl": "Faulk",
			"url": "https://findagrave.com/memorial/150882708",
			"id": 150882708,
			"lng": -77.38623518,
			"lat": 37.53584172,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 6,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Israel",
			"nl": "Mickins",
			"url": "https://findagrave.com/memorial/195459849",
			"id": 195459849,
			"lng": -77.38749322,
			"lat": 37.53760625,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 6,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "G.",
			"nf": "Lula",
			"nl": "Eaddy",
			"url": "https://findagrave.com/memorial/195538675",
			"id": 195538675,
			"lng": -77.38659357,
			"lat": 37.53713335,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 7,
			"dd": 21,
			"by": 1889,
			"bd": 26,
			"bm": 11,
			"nm": "G.",
			"nf": "Louise",
			"nl": "Davis",
			"url": "https://findagrave.com/memorial/195656322",
			"id": 195656322,
			"lng": -77.38681614,
			"lat": 37.53692455,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 2,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Henry",
			"nf": "John",
			"nl": "Dunn",
			"url": "https://findagrave.com/memorial/195575102",
			"id": 195575102,
			"lng": -77.38683762,
			"lat": 37.53669531,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 7,
			"dd": 2,
			"by": 1893,
			"bd": 28,
			"bm": 7,
			"nm": "Estelle",
			"nf": "Beatrice",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/195656326",
			"id": 195656326,
			"lng": -77.3868179,
			"lat": 37.53691161,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 3,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Edward",
			"nl": "Rainey",
			"url": "https://findagrave.com/memorial/195656330",
			"id": 195656330,
			"lng": -77.38680332,
			"lat": 37.53671265,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 2,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "William",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/195995269",
			"id": 195995269,
			"lng": -77.38700359,
			"lat": 37.53572812,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 1,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Louvenia",
			"nl": "Francis",
			"url": "https://findagrave.com/memorial/195995406",
			"id": 195995406,
			"lng": -77.38641514,
			"lat": 37.53707435,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 5,
			"dd": 13,
			"by": 1890,
			"bd": 22,
			"bm": 10,
			"nm": "Green",
			"nf": "William",
			"nl": "Crump",
			"url": "https://findagrave.com/memorial/182319646",
			"id": 182319646,
			"lng": -77.38672572,
			"lat": 37.53764459,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 6,
			"dd": 22,
			"by": 1916,
			"bd": 20,
			"bm": 3,
			"nm": "",
			"nf": "Pauline",
			"nl": "Henderson",
			"url": "https://findagrave.com/memorial/185929366",
			"id": 185929366,
			"lng": -77.38712528,
			"lat": 37.5371578,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 5,
			"by": 1891,
			"bd": 19,
			"bm": 12,
			"nm": "",
			"nf": "Joseph",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/195841624",
			"id": 195841624,
			"lng": -77.38745383,
			"lat": 37.53735011,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 11,
			"dd": 5,
			"by": 1918,
			"bd": 13,
			"bm": 1,
			"nm": "",
			"nf": "William",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/195841635",
			"id": 195841635,
			"lng": -77.38759535,
			"lat": 37.53745488,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 6,
			"dd": 26,
			"by": 1906,
			"bd": 6,
			"bm": 7,
			"nm": "Leroy",
			"nf": "Ernest",
			"nl": "Pollard",
			"url": "https://findagrave.com/memorial/195841638",
			"id": 195841638,
			"lng": -77.38714694,
			"lat": 37.5372343,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 12,
			"dd": 11,
			"by": 1882,
			"bd": 25,
			"bm": 2,
			"nm": "S.",
			"nf": "Sarah",
			"nl": "Trent",
			"url": "https://findagrave.com/memorial/195841641",
			"id": 195841641,
			"lng": -77.38721477,
			"lat": 37.53723895,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 5,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Mary",
			"nl": "Walker",
			"url": "https://findagrave.com/memorial/195728289",
			"id": 195728289,
			"lng": -77.38699821,
			"lat": 37.53570963,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 4,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Eddie",
			"nl": "Finch",
			"url": "https://findagrave.com/memorial/196266085",
			"id": 196266085,
			"lng": -77.38687971,
			"lat": 37.53678051,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 5,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sallie",
			"nl": "White",
			"url": "https://findagrave.com/memorial/196266138",
			"id": 196266138,
			"lng": -77.38687866,
			"lat": 37.53680052,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 6,
			"dd": 20,
			"by": 1879,
			"bd": "",
			"bm": 4,
			"nm": "H.",
			"nf": "Percy",
			"nl": "Nichols",
			"url": "https://findagrave.com/memorial/196499829",
			"id": 196499829,
			"lng": -77.38702327,
			"lat": 37.53672572,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 3,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bessie",
			"nl": "Anderson",
			"url": "https://findagrave.com/memorial/196433322",
			"id": 196433322,
			"lng": -77.38759133,
			"lat": 37.53785355,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 7,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Daisy",
			"nl": "Booker",
			"url": "https://findagrave.com/memorial/196433334",
			"id": 196433334,
			"lng": -77.38721256,
			"lat": 37.53773071,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 5,
			"dd": 14,
			"by": 1902,
			"bd": 27,
			"bm": 1,
			"nm": "W.",
			"nf": "Thomas",
			"nl": "China",
			"url": "https://findagrave.com/memorial/196372788",
			"id": 196372788,
			"lng": -77.38757625,
			"lat": 37.53790928,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 4,
			"dd": 7,
			"by": 1894,
			"bd": 9,
			"bm": 1,
			"nm": "",
			"nf": "Henrietta",
			"nl": "Fisher",
			"url": "https://findagrave.com/memorial/196377821",
			"id": 196377821,
			"lng": -77.38749055,
			"lat": 37.53787684,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 1,
			"dd": 31,
			"by": 1910,
			"bd": 17,
			"bm": 5,
			"nm": "",
			"nf": "Williett",
			"nl": "Flack",
			"url": "https://findagrave.com/memorial/196374302",
			"id": 196374302,
			"lng": -77.38749317,
			"lat": 37.53790486,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 12,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Junius",
			"nl": "Meredith",
			"url": "https://findagrave.com/memorial/196499820",
			"id": 196499820,
			"lng": -77.38777136,
			"lat": 37.53791134,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 1,
			"dd": 15,
			"by": 1957,
			"bd": 11,
			"bm": 7,
			"nm": "Anthony",
			"nf": "Michael",
			"nl": "Murphy",
			"url": "https://findagrave.com/memorial/196374132",
			"id": 196374132,
			"lng": -77.38755913,
			"lat": 37.53791918,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 9,
			"dd": 4,
			"by": 1957,
			"bd": 4,
			"bm": 9,
			"nm": "",
			"nf": "Leroy",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/196433348",
			"id": 196433348,
			"lng": -77.38751636,
			"lat": 37.53795162,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 12,
			"dd": 25,
			"by": 1890,
			"bd": 2,
			"bm": 10,
			"nm": "Major",
			"nf": "Samuel",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/196373791",
			"id": 196373791,
			"lng": -77.38761943,
			"lat": 37.53796731,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 3,
			"dd": 3,
			"by": 1912,
			"bd": 8,
			"bm": 10,
			"nm": "P.",
			"nf": "Naomi",
			"nl": "Rustin",
			"url": "https://findagrave.com/memorial/196373301",
			"id": 196373301,
			"lng": -77.38749353,
			"lat": 37.53792915,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 1,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": 2,
			"nm": "",
			"nf": "Floyd",
			"nl": "Simms",
			"url": "https://findagrave.com/memorial/196433358",
			"id": 196433358,
			"lng": -77.38706399,
			"lat": 37.53775266,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 1,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "China",
			"nf": "Pearl",
			"nl": "Staves",
			"url": "https://findagrave.com/memorial/190638021",
			"id": 190638021,
			"lng": -77.38752732,
			"lat": 37.53791335,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 8,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Freddie",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/196433377",
			"id": 196433377,
			"lng": -77.38759611,
			"lat": 37.5378427,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 8,
			"dd": 14,
			"by": 1910,
			"bd": 10,
			"bm": 10,
			"nm": "",
			"nf": "John",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/196433388",
			"id": 196433388,
			"lng": -77.38763473,
			"lat": 37.53784624,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 1,
			"dd": 17,
			"by": 1905,
			"bd": 24,
			"bm": 12,
			"nm": "",
			"nf": "Lottie",
			"nl": "Hubbard",
			"url": "https://findagrave.com/memorial/196622215",
			"id": 196622215,
			"lng": -77.38700818,
			"lat": 37.53685848,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 6,
			"dd": 7,
			"by": 1862,
			"bd": 4,
			"bm": 3,
			"nm": "",
			"nf": "Harriet",
			"nl": "Minnis",
			"url": "https://findagrave.com/memorial/196499824",
			"id": 196499824,
			"lng": -77.38696465,
			"lat": 37.53685244,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 5,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Angie",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/196499832",
			"id": 196499832,
			"lng": -77.38756714,
			"lat": 37.53767237,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 2,
			"dd": 5,
			"by": 1925,
			"bd": 13,
			"bm": 1,
			"nm": "A.",
			"nf": "Philip",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/196499836",
			"id": 196499836,
			"lng": -77.38696072,
			"lat": 37.53681033,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 1,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/196561423",
			"id": 196561423,
			"lng": -77.38778559,
			"lat": 37.53781037,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 1,
			"dd": 8,
			"by": 1900,
			"bd": 26,
			"bm": 12,
			"nm": "A.",
			"nf": "Pearl",
			"nl": "Kelley",
			"url": "https://findagrave.com/memorial/196622218",
			"id": 196622218,
			"lng": -77.38746828,
			"lat": 37.53777771,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 9,
			"dd": 22,
			"by": 1918,
			"bd": 24,
			"bm": 3,
			"nm": "",
			"nf": "Lillian",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/196622232",
			"id": 196622232,
			"lng": -77.38754066,
			"lat": 37.5377828,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 3,
			"dd": 29,
			"by": 1891,
			"bd": 1,
			"bm": 10,
			"nm": "",
			"nf": "Mary",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/196561488",
			"id": 196561488,
			"lng": -77.38777468,
			"lat": 37.53776546,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 12,
			"dd": 23,
			"by": 1932,
			"bd": 28,
			"bm": 3,
			"nm": "Mae",
			"nf": "Audrey",
			"nl": "Alston",
			"url": "https://findagrave.com/memorial/196770374",
			"id": 196770374,
			"lng": -77.3878454,
			"lat": 37.53776718,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 10,
			"dd": 15,
			"by": 1907,
			"bd": 11,
			"bm": 11,
			"nm": "",
			"nf": "Evelyn",
			"nl": "Christian Wooldridge",
			"url": "https://findagrave.com/memorial/196770478",
			"id": 196770478,
			"lng": -77.38551282,
			"lat": 37.53727447,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 3,
			"dd": 19,
			"by": 1934,
			"bd": 10,
			"bm": 6,
			"nm": "Morton",
			"nf": "John",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/196770497",
			"id": 196770497,
			"lng": -77.38550227,
			"lat": 37.53727078,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 1,
			"dd": 5,
			"by": 1896,
			"bd": 21,
			"bm": 4,
			"nm": "E.",
			"nf": "Clarence",
			"nl": "Franklin",
			"url": "https://findagrave.com/memorial/197014967",
			"id": 197014967,
			"lng": -77.3865722,
			"lat": 37.53593264,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 10,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Jenkins",
			"url": "https://findagrave.com/memorial/196770503",
			"id": 196770503,
			"lng": -77.38799182,
			"lat": 37.5377851,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1913,
			"dm": 2,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Carol",
			"nf": "Frank",
			"nl": "Lovings",
			"url": "https://findagrave.com/memorial/196050183",
			"id": 196050183,
			"lng": -77.38617994,
			"lat": 37.53599903,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 1,
			"dd": 26,
			"by": 1890,
			"bd": 8,
			"bm": 9,
			"nm": "",
			"nf": "Ella",
			"nl": "Nash",
			"url": "https://findagrave.com/memorial/187768534",
			"id": 187768534,
			"lng": -77.38774891,
			"lat": 37.53795529,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 11,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rosa",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/196965309",
			"id": 196965309,
			"lng": -77.38667171,
			"lat": 37.53585656,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1903,
			"dm": 10,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Isabella",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/196050646",
			"id": 196050646,
			"lng": -77.38620046,
			"lat": 37.53599826,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 10,
			"dd": 23,
			"by": 1900,
			"bd": "",
			"bm": 12,
			"nm": "H.",
			"nf": "Marion",
			"nl": "Small",
			"url": "https://findagrave.com/memorial/196928281",
			"id": 196928281,
			"lng": -77.38773754,
			"lat": 37.5377865,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 11,
			"dd": 6,
			"by": 1880,
			"bd": 12,
			"bm": 6,
			"nm": "",
			"nf": "John",
			"nl": "Stevenson",
			"url": "https://findagrave.com/memorial/196770518",
			"id": 196770518,
			"lng": -77.38704187,
			"lat": 37.53750648,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 6,
			"dd": 11,
			"by": 1939,
			"bd": 18,
			"bm": 6,
			"nm": "Henry",
			"nf": "Cleveland",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/196770524",
			"id": 196770524,
			"lng": -77.38748128,
			"lat": 37.53786512,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 6,
			"dd": 23,
			"by": 1890,
			"bd": 23,
			"bm": 5,
			"nm": "",
			"nf": "Rosa",
			"nl": "Thornton",
			"url": "https://findagrave.com/memorial/196770531",
			"id": 196770531,
			"lng": -77.38740581,
			"lat": 37.53772438,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 5,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Junius",
			"nl": "Townsend",
			"url": "https://findagrave.com/memorial/196770538",
			"id": 196770538,
			"lng": -77.38816924,
			"lat": 37.53788309,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 2,
			"dd": 12,
			"by": 1919,
			"bd": 1,
			"bm": 12,
			"nm": "",
			"nf": "Clarence",
			"nl": "Walker",
			"url": "https://findagrave.com/memorial/196928290",
			"id": 196928290,
			"lng": -77.38785038,
			"lat": 37.53779449,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 8,
			"dd": 15,
			"by": 1885,
			"bd": 5,
			"bm": 9,
			"nm": "",
			"nf": "Austin",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/197199939",
			"id": 197199939,
			"lng": -77.38747493,
			"lat": 37.53678247,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 3,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Anna",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/197199943",
			"id": 197199943,
			"lng": -77.38761,
			"lat": 37.53672387,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 5,
			"dd": 30,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Beverly",
			"nl": "Wright",
			"url": "https://findagrave.com/memorial/197199948",
			"id": 197199948,
			"lng": -77.38753289,
			"lat": 37.53681698,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 3,
			"dd": 10,
			"by": 1894,
			"bd": 2,
			"bm": 3,
			"nm": "",
			"nf": "Daniel",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/197320074",
			"id": 197320074,
			"lng": -77.3878385,
			"lat": 37.53780129,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 3,
			"dd": 24,
			"by": 1915,
			"bd": 22,
			"bm": 10,
			"nm": "",
			"nf": "Hunter",
			"nl": "Hewlett",
			"url": "https://findagrave.com/memorial/197320082",
			"id": 197320082,
			"lng": -77.38795229,
			"lat": 37.53786174,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 5,
			"dd": 16,
			"by": 1880,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Joseph",
			"nl": "Mayo",
			"url": "https://findagrave.com/memorial/197320379",
			"id": 197320379,
			"lng": -77.3877584,
			"lat": 37.53722914,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 12,
			"dd": 16,
			"by": 1906,
			"bd": "",
			"bm": 11,
			"nm": "",
			"nf": "Elijah",
			"nl": "McClain",
			"url": "https://findagrave.com/memorial/197320390",
			"id": 197320390,
			"lng": -77.38777549,
			"lat": 37.53755063,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 7,
			"dd": 25,
			"by": 1886,
			"bd": 4,
			"bm": 6,
			"nm": "R.",
			"nf": "Israel",
			"nl": "Ross",
			"url": "https://findagrave.com/memorial/197320063",
			"id": 197320063,
			"lng": -77.38774821,
			"lat": 37.53743464,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 3,
			"dd": 23,
			"by": 1910,
			"bd": 13,
			"bm": 8,
			"nm": "Mae",
			"nf": "Edith",
			"nl": "Rowlett",
			"url": "https://findagrave.com/memorial/197320400",
			"id": 197320400,
			"lng": -77.38790254,
			"lat": 37.53787576,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 6,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Moses",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/197320422",
			"id": 197320422,
			"lng": -77.38788572,
			"lat": 37.53783271,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 9,
			"dd": 17,
			"by": 1911,
			"bd": 15,
			"bm": 9,
			"nm": "",
			"nf": "Ida",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/197320682",
			"id": 197320682,
			"lng": -77.38764466,
			"lat": 37.53731128,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 3,
			"dd": 26,
			"by": 1867,
			"bd": 1,
			"bm": 1,
			"nm": "E.",
			"nf": "William",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/197320685",
			"id": 197320685,
			"lng": -77.38791372,
			"lat": 37.5378678,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 7,
			"dd": 9,
			"by": 1904,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "James",
			"nl": "Thompson",
			"url": "https://findagrave.com/memorial/197320697",
			"id": 197320697,
			"lng": -77.38794217,
			"lat": 37.53785872,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 7,
			"dd": 7,
			"by": 1876,
			"bd": "",
			"bm": 8,
			"nm": "",
			"nf": "Ardelia",
			"nl": "Washington",
			"url": "https://findagrave.com/memorial/197320705",
			"id": 197320705,
			"lng": -77.38735915,
			"lat": 37.53778519,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1926,
			"dm": 11,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Robert",
			"nl": "Cross",
			"url": "https://findagrave.com/memorial/197320068",
			"id": 197320068,
			"lng": -77.38783735,
			"lat": 37.53706833,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 9,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Luke",
			"nl": "Saunders",
			"url": "https://findagrave.com/memorial/197320406",
			"id": 197320406,
			"lng": -77.3878954,
			"lat": 37.5372027,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1925,
			"dm": 4,
			"dd": 6,
			"by": 1882,
			"bd": "",
			"bm": 1,
			"nm": "",
			"nf": "Lucy",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/197320716",
			"id": 197320716,
			"lng": -77.38792706,
			"lat": 37.53700478,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 4,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Isaac",
			"nl": "Berry",
			"url": "https://findagrave.com/memorial/197499473",
			"id": 197499473,
			"lng": -77.38683977,
			"lat": 37.53749333,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 1,
			"dd": 16,
			"by": 1886,
			"bd": 27,
			"bm": 11,
			"nm": "T.",
			"nf": "James",
			"nl": "Birchett",
			"url": "https://findagrave.com/memorial/197499478",
			"id": 197499478,
			"lng": -77.38795721,
			"lat": 37.53782526,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 5,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Virginia",
			"nl": "Breedlove",
			"url": "https://findagrave.com/memorial/197499482",
			"id": 197499482,
			"lng": -77.38805941,
			"lat": 37.53776318,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 6,
			"dd": 4,
			"by": 1875,
			"bd": 5,
			"bm": 7,
			"nm": "",
			"nf": "Rosa",
			"nl": "Christian",
			"url": "https://findagrave.com/memorial/197483316",
			"id": 197483316,
			"lng": -77.38791606,
			"lat": 37.53789649,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 3,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Quarles",
			"nf": "Louise",
			"nl": "Dance",
			"url": "https://findagrave.com/memorial/197499488",
			"id": 197499488,
			"lng": -77.3878833,
			"lat": 37.53788142,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1942,
			"dm": 2,
			"dd": 27,
			"by": 1920,
			"bd": 6,
			"bm": 5,
			"nm": "",
			"nf": "Elnora",
			"nl": "Henderson",
			"url": "https://findagrave.com/memorial/197499493",
			"id": 197499493,
			"lng": -77.38788082,
			"lat": 37.53788821,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 7,
			"dd": 22,
			"by": 1893,
			"bd": 20,
			"bm": 2,
			"nm": "",
			"nf": "Daniel",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/197499499",
			"id": 197499499,
			"lng": -77.3877828,
			"lat": 37.53766337,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 7,
			"dd": 20,
			"by": 1888,
			"bd": 19,
			"bm": 8,
			"nm": "B.",
			"nf": "Pearl",
			"nl": "Mayo",
			"url": "https://findagrave.com/memorial/197499502",
			"id": 197499502,
			"lng": -77.38775705,
			"lat": 37.53766182,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 1,
			"dd": 28,
			"by": 1932,
			"bd": 23,
			"bm": 4,
			"nm": "Mae",
			"nf": "Esther",
			"nl": "Scott",
			"url": "https://findagrave.com/memorial/197499514",
			"id": 197499514,
			"lng": -77.38775268,
			"lat": 37.53786467,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 10,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucretia",
			"nl": "Garrison",
			"url": "https://findagrave.com/memorial/169431610",
			"id": 169431610,
			"lng": -77.38771825,
			"lat": 37.53695564,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 3,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Pauline",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/190857203",
			"id": 190857203,
			"lng": -77.38800477,
			"lat": 37.5370431,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 3,
			"dd": 27,
			"by": 1909,
			"bd": 14,
			"bm": 11,
			"nm": "",
			"nf": "Madeline",
			"nl": "Williams",
			"url": "https://findagrave.com/memorial/197602152",
			"id": 197602152,
			"lng": -77.3878385,
			"lat": 37.53700165,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 3,
			"dd": 11,
			"by": 1876,
			"bd": "",
			"bm": 10,
			"nm": "",
			"nf": "Amelia",
			"nl": "Moore",
			"url": "https://findagrave.com/memorial/197708636",
			"id": 197708636,
			"lng": -77.38793757,
			"lat": 37.53721967,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1909,
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Adeline",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/197602135",
			"id": 197602135,
			"lng": -77.38673776,
			"lat": 37.53603693,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 4,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Edward",
			"nf": "Thomas",
			"nl": "Cheatham",
			"url": "https://findagrave.com/memorial/193030492",
			"id": 193030492,
			"lng": -77.3868849,
			"lat": 37.53746172,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 11,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Rena",
			"nl": "Braxton",
			"url": "https://findagrave.com/memorial/197708619",
			"id": 197708619,
			"lng": -77.38756356,
			"lat": 37.53699132,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 1,
			"dd": 27,
			"by": 1918,
			"bd": 27,
			"bm": 4,
			"nm": "R.",
			"nf": "Louis",
			"nl": "Clark",
			"url": "https://findagrave.com/memorial/197708628",
			"id": 197708628,
			"lng": -77.38756822,
			"lat": 37.53696949,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 12,
			"dd": 14,
			"by": "",
			"bd": 6,
			"bm": 1,
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Bowler",
			"url": "https://findagrave.com/memorial/187098753",
			"id": 187098753,
			"lng": -77.38713077,
			"lat": 37.53628666,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 4,
			"dd": 6,
			"by": 1933,
			"bd": 30,
			"bm": 9,
			"nm": "M.",
			"nf": "Royal",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/186733007",
			"id": 186733007,
			"lng": -77.38606793,
			"lat": 37.53627783,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 2,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Charity",
			"nl": "Archer",
			"url": "https://findagrave.com/memorial/197767026",
			"id": 197767026,
			"lng": -77.38772452,
			"lat": 37.53779768,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 7,
			"dd": 8,
			"by": 1891,
			"bd": 24,
			"bm": 12,
			"nm": "",
			"nf": "Paul",
			"nl": "Butts",
			"url": "https://findagrave.com/memorial/197765999",
			"id": 197765999,
			"lng": -77.38770791,
			"lat": 37.53774623,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 5,
			"dd": 9,
			"by": 1889,
			"bd": "",
			"bm": "",
			"nm": "W",
			"nf": "John",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/197761685",
			"id": 197761685,
			"lng": -77.38675128,
			"lat": 37.53765164,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 11,
			"dd": 30,
			"by": 1897,
			"bd": 20,
			"bm": 1,
			"nm": "Mary",
			"nf": "Estelle",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/197783592",
			"id": 197783592,
			"lng": -77.38674948,
			"lat": 37.53773102,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1911,
			"dm": 5,
			"dd": 20,
			"by": 1869,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Emma",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/197770462",
			"id": 197770462,
			"lng": -77.38684517,
			"lat": 37.53604781,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 3,
			"dd": 2,
			"by": 1937,
			"bd": "",
			"bm": "",
			"nm": "Yvonne",
			"nf": "Celeste",
			"nl": "Dennis",
			"url": "https://findagrave.com/memorial/197879210",
			"id": 197879210,
			"lng": -77.38738662,
			"lat": 37.53689932,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 6,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Delia",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/177223800",
			"id": 177223800,
			"lng": -77.38742582,
			"lat": 37.53687422,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 7,
			"dd": 28,
			"by": 1905,
			"bd": 6,
			"bm": 12,
			"nm": "",
			"nf": "Ruth",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/198109392",
			"id": 198109392,
			"lng": -77.38716202,
			"lat": 37.53729369,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 5,
			"dd": 29,
			"by": 1923,
			"bd": 19,
			"bm": 11,
			"nm": "",
			"nf": "Pernett",
			"nl": "Anthony",
			"url": "https://findagrave.com/memorial/197965214",
			"id": 197965214,
			"lng": -77.38730901,
			"lat": 37.53735894,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 8,
			"dd": 3,
			"by": 1902,
			"bd": 30,
			"bm": 8,
			"nm": "Maryland",
			"nf": "James",
			"nl": "Bradshaw",
			"url": "https://findagrave.com/memorial/197962198",
			"id": 197962198,
			"lng": -77.38718203,
			"lat": 37.53732034,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 8,
			"dd": 8,
			"by": 1912,
			"bd": 28,
			"bm": 7,
			"nm": "Mathew",
			"nf": "Parker",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/177286849",
			"id": 177286849,
			"lng": -77.38729047,
			"lat": 37.5372404,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 2,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "John",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/198067476",
			"id": 198067476,
			"lng": -77.38795265,
			"lat": 37.53783906,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 14,
			"by": 1929,
			"bd": 27,
			"bm": 2,
			"nm": "Elmore",
			"nf": "Walter",
			"nl": "Hinton",
			"url": "https://findagrave.com/memorial/192391148",
			"id": 192391148,
			"lng": -77.38738165,
			"lat": 37.53727259,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 21,
			"by": 1915,
			"bd": 3,
			"bm": 11,
			"nm": "",
			"nf": "Maxton",
			"nl": "Hooker",
			"url": "https://findagrave.com/memorial/198017038",
			"id": 198017038,
			"lng": -77.38739384,
			"lat": 37.53733291,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 6,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Florence",
			"nl": "Mickens",
			"url": "https://findagrave.com/memorial/198109395",
			"id": 198109395,
			"lng": -77.38733597,
			"lat": 37.53738671,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 1,
			"dd": 24,
			"by": 1903,
			"bd": 7,
			"bm": 9,
			"nm": "",
			"nf": "Nellie",
			"nl": "Pegeas",
			"url": "https://findagrave.com/memorial/198016709",
			"id": 198016709,
			"lng": -77.38721741,
			"lat": 37.53725786,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 9,
			"dd": 10,
			"by": 1897,
			"bd": 21,
			"bm": 3,
			"nm": "",
			"nf": "Charlie",
			"nl": "Roane",
			"url": "https://findagrave.com/memorial/197932492",
			"id": 197932492,
			"lng": -77.38735316,
			"lat": 37.53686528,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 12,
			"dd": 20,
			"by": 1931,
			"bd": 17,
			"bm": 2,
			"nm": "",
			"nf": "Josephine",
			"nl": "Tucker",
			"url": "https://findagrave.com/memorial/197962851",
			"id": 197962851,
			"lng": -77.38734673,
			"lat": 37.53721153,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 22,
			"by": 1905,
			"bd": 14,
			"bm": 6,
			"nm": "Allen",
			"nf": "Jones",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/179531348",
			"id": 179531348,
			"lng": -77.38738562,
			"lat": 37.53734346,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 9,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Hattie",
			"nl": "Adkins",
			"url": "https://www.findagrave.com/memorial/198148125/hattie-adkins",
			"id": 198148125,
			"lng": -77.38706331,
			"lat": 37.53726692,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 8,
			"dd": 31,
			"by": 1926,
			"bd": 9,
			"bm": 3,
			"nm": "",
			"nf": "Mary",
			"nl": "Andrews",
			"url": "https://findagrave.com/memorial/198148131",
			"id": 198148131,
			"lng": -77.38718776,
			"lat": 37.53727079,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 3,
			"by": 1895,
			"bd": 28,
			"bm": 2,
			"nm": "",
			"nf": "Meril",
			"nl": "Avant",
			"url": "https://findagrave.com/memorial/198148138",
			"id": 198148138,
			"lng": -77.38719366,
			"lat": 37.53724432,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 3,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Pruden",
			"nl": "Crew",
			"url": "https://findagrave.com/memorial/198157349",
			"id": 198157349,
			"lng": -77.38723843,
			"lat": 37.53627847,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 3,
			"dd": 5,
			"by": 1877,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Margaret",
			"nl": "Crump",
			"url": "https://findagrave.com/memorial/198157352",
			"id": 198157352,
			"lng": -77.38713298,
			"lat": 37.53684439,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 7,
			"dd": 24,
			"by": 1891,
			"bd": 2,
			"bm": 6,
			"nm": "P. M.",
			"nf": "Charles",
			"nl": "Lipscomb",
			"url": "https://findagrave.com/memorial/198157357",
			"id": 198157357,
			"lng": -77.38719599,
			"lat": 37.53730703,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 10,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Felix",
			"nf": "James",
			"nl": "Randall",
			"url": "https://findagrave.com/memorial/198157364",
			"id": 198157364,
			"lng": -77.38710365,
			"lat": 37.53627991,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 9,
			"dd": 3,
			"by": 1926,
			"bd": 10,
			"bm": 5,
			"nm": "",
			"nf": "Charlie",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/198199714",
			"id": 198199714,
			"lng": -77.38685302,
			"lat": 37.5368516,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 10,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Roberta",
			"nl": "Richardson",
			"url": "https://findagrave.com/memorial/198109405",
			"id": 198109405,
			"lng": -77.38782905,
			"lat": 37.53628531,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 12,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ruby",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/185740526",
			"id": 185740526,
			"lng": -77.38700942,
			"lat": 37.53689457,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 10,
			"dd": 6,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lee",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/194337551",
			"id": 194337551,
			"lng": -77.38742585,
			"lat": 37.53560585,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1901,
			"dm": "",
			"dd": "",
			"by": 1836,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "George",
			"nl": "Braxton",
			"url": "https://findagrave.com/memorial/201803892",
			"id": 201803892,
			"lng": -77.38758865,
			"lat": 37.53627995,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 10,
			"dd": 30,
			"by": 1908,
			"bd": 8,
			"bm": 11,
			"nm": "J.",
			"nf": "Robert",
			"nl": "Brooks",
			"url": "https://findagrave.com/memorial/201798289",
			"id": 201798289,
			"lng": -77.38740564,
			"lat": 37.53685159,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 1,
			"dd": 29,
			"by": 1912,
			"bd": 4,
			"bm": 7,
			"nm": "Ann",
			"nf": "Lucy",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/202608026",
			"id": 202608026,
			"lng": -77.38668068,
			"lat": 37.53715578,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 2,
			"dd": 24,
			"by": 1899,
			"bd": 18,
			"bm": 9,
			"nm": "W.",
			"nf": "Waverly",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/201437687",
			"id": 201437687,
			"lng": -77.38662483,
			"lat": 37.53585481,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 7,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Julia",
			"nl": "Covington",
			"url": "https://findagrave.com/memorial/198146675",
			"id": 198146675,
			"lng": -77.38614894,
			"lat": 37.5360206,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1910,
			"dm": 1,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Elvira",
			"nl": "Harvey",
			"url": "https://findagrave.com/memorial/202198435",
			"id": 202198435,
			"lng": -77.38683385,
			"lat": 37.53592098,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 1,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "S.",
			"nf": "Alice",
			"nl": "Hicks",
			"url": "https://findagrave.com/memorial/202608036",
			"id": 202608036,
			"lng": -77.38672233,
			"lat": 37.53714391,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1960,
			"dm": 10,
			"dd": 23,
			"by": 1881,
			"bd": 31,
			"bm": 7,
			"nm": "",
			"nf": "Eddie",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/200905346",
			"id": 200905346,
			"lng": -77.38657841,
			"lat": 37.5375394,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 6,
			"dd": 8,
			"by": 1893,
			"bd": 1,
			"bm": 6,
			"nm": "",
			"nf": "Carrie",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/200769360",
			"id": 200769360,
			"lng": -77.38641735,
			"lat": 37.53754162,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 11,
			"dd": 1,
			"by": 1906,
			"bd": 25,
			"bm": 11,
			"nm": "",
			"nf": "Samuel",
			"nl": "McKeever",
			"url": "https://findagrave.com/memorial/201128955",
			"id": 201128955,
			"lng": -77.38698689,
			"lat": 37.53775286,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 10,
			"dd": 2,
			"by": 1908,
			"bd": 24,
			"bm": 12,
			"nm": "",
			"nf": "Floyd",
			"nl": "Onley",
			"url": "https://findagrave.com/memorial/201228267",
			"id": 201228267,
			"lng": -77.38714037,
			"lat": 37.5372564,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 8,
			"dd": 12,
			"by": 1909,
			"bd": 23,
			"bm": 11,
			"nm": "",
			"nf": "Raymond",
			"nl": "Ragland",
			"url": "https://findagrave.com/memorial/200595635",
			"id": 200595635,
			"lng": -77.38649806,
			"lat": 37.53726572,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 2,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Clara",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/195078232",
			"id": 195078232,
			"lng": -77.38734469,
			"lat": 37.53549351,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 7,
			"dd": 12,
			"by": 1889,
			"bd": 19,
			"bm": 2,
			"nm": "",
			"nf": "Callie",
			"nl": "Saunders",
			"url": "https://findagrave.com/memorial/202608050",
			"id": 202608050,
			"lng": -77.38660567,
			"lat": 37.53714744,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 10,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "George",
			"nl": "Stevens",
			"url": "https://findagrave.com/memorial/201798297",
			"id": 201798297,
			"lng": -77.38735106,
			"lat": 37.53685242,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 6,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ulysses",
			"nl": "Sullivan",
			"url": "https://findagrave.com/memorial/202273647",
			"id": 202273647,
			"lng": -77.38636028,
			"lat": 37.53558851,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1971,
			"dm": 1,
			"dd": 2,
			"by": 1910,
			"bd": 20,
			"bm": 9,
			"nm": "",
			"nf": "Richard",
			"nl": "Winston",
			"url": "https://findagrave.com/memorial/201333200",
			"id": 201333200,
			"lng": -77.38702347,
			"lat": 37.53738437,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 8,
			"dd": 1,
			"by": 1874,
			"bd": 14,
			"bm": 9,
			"nm": "",
			"nf": "Ardelia",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/203190617",
			"id": 203190617,
			"lng": -77.38704892,
			"lat": 37.53771769,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 8,
			"dd": 18,
			"by": 1908,
			"bd": 23,
			"bm": 7,
			"nm": "Edward",
			"nf": "James",
			"nl": "Fant",
			"url": "https://findagrave.com/memorial/203190270",
			"id": 203190270,
			"lng": -77.38704987,
			"lat": 37.53773011,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 1,
			"dd": 6,
			"by": 1898,
			"bd": 3,
			"bm": 4,
			"nm": "",
			"nf": "Sampson",
			"nl": "Melvin",
			"url": "https://findagrave.com/memorial/203191135",
			"id": 203191135,
			"lng": -77.38721222,
			"lat": 37.53761838,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 11,
			"dd": 7,
			"by": 1931,
			"bd": 3,
			"bm": 6,
			"nm": "Ray",
			"nf": "Billie",
			"nl": "Monroe",
			"url": "https://findagrave.com/memorial/203190024",
			"id": 203190024,
			"lng": -77.3870356,
			"lat": 37.53774959,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 7,
			"dd": 22,
			"by": 1912,
			"bd": 21,
			"bm": 4,
			"nm": "Roselle",
			"nf": "Edith",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/203190761",
			"id": 203190761,
			"lng": -77.38701512,
			"lat": 37.53772133,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 7,
			"dd": 3,
			"by": 189,
			"bd": 7,
			"bm": 1,
			"nm": "",
			"nf": "Cary",
			"nl": "Booker",
			"url": "https://findagrave.com/memorial/203371954",
			"id": 203371954,
			"lng": -77.3869938,
			"lat": 37.53756054,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 3,
			"dd": 31,
			"by": 1901,
			"bd": 15,
			"bm": 12,
			"nm": "",
			"nf": "Edward",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/203050886",
			"id": 203050886,
			"lng": -77.38712973,
			"lat": 37.53766308,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 4,
			"dd": 15,
			"by": 1931,
			"bd": 28,
			"bm": 3,
			"nm": "",
			"nf": "Willie",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/202737916",
			"id": 202737916,
			"lng": -77.38656006,
			"lat": 37.53708576,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 7,
			"dd": 19,
			"by": 1915,
			"bd": 17,
			"bm": 1,
			"nm": "",
			"nf": "Frank",
			"nl": "Burton",
			"url": "https://findagrave.com/memorial/170838980",
			"id": 170838980,
			"lng": -77.3864498,
			"lat": 37.53717942,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 9,
			"dd": 17,
			"by": 1893,
			"bd": 26,
			"bm": 11,
			"nm": "G.",
			"nf": "Richard",
			"nl": "Burton",
			"url": "https://findagrave.com/memorial/203818334",
			"id": 203818334,
			"lng": -77.3867812,
			"lat": 37.53692496,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 5,
			"dd": 25,
			"by": 1913,
			"bd": 15,
			"bm": 3,
			"nm": "",
			"nf": "Louvenia",
			"nl": "Coleman",
			"url": "https://findagrave.com/memorial/203029258",
			"id": 203029258,
			"lng": -77.38702778,
			"lat": 37.53767832,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 9,
			"dd": 24,
			"by": 1896,
			"bd": 2,
			"bm": 9,
			"nm": "",
			"nf": "Jannie",
			"nl": "Cooper",
			"url": "https://findagrave.com/memorial/203999525",
			"id": 203999525,
			"lng": -77.38769669,
			"lat": 37.53776995,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 2,
			"dd": 28,
			"by": 1901,
			"bd": 17,
			"bm": 3,
			"nm": "L.",
			"nf": "Joseph",
			"nl": "Dabney",
			"url": "https://findagrave.com/memorial/203839116",
			"id": 203839116,
			"lng": -77.38670532,
			"lat": 37.53717816,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 7,
			"dd": 14,
			"by": 1903,
			"bd": 26,
			"bm": 7,
			"nm": "",
			"nf": "James",
			"nl": "Dunston",
			"url": "https://findagrave.com/memorial/170838932",
			"id": 170838932,
			"lng": -77.38649643,
			"lat": 37.53717722,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 7,
			"dd": 27,
			"by": 1891,
			"bd": 2,
			"bm": 3,
			"nm": "Robinson",
			"nf": "Mary",
			"nl": "Fenderson",
			"url": "https://findagrave.com/memorial/170838949",
			"id": 170838949,
			"lng": -77.38649621,
			"lat": 37.53718288,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "George",
			"nl": "Foster",
			"url": "https://findagrave.com/memorial/203984744",
			"id": 203984744,
			"lng": -77.38744952,
			"lat": 37.53737932,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 4,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Martha",
			"nl": "Gardner",
			"url": "https://findagrave.com/memorial/204136637",
			"id": 204136637,
			"lng": -77.38751448,
			"lat": 37.53568508,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 8,
			"dd": 7,
			"by": 1895,
			"bd": 12,
			"bm": 10,
			"nm": "Lee",
			"nf": "Roscoe",
			"nl": "Grinaway",
			"url": "https://findagrave.com/memorial/203029889",
			"id": 203029889,
			"lng": -77.38708466,
			"lat": 37.53769954,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 2,
			"dd": 25,
			"by": 1883,
			"bd": 6,
			"bm": 7,
			"nm": "J.",
			"nf": "Sarah",
			"nl": "Gwathmy",
			"url": "https://findagrave.com/memorial/203974376",
			"id": 203974376,
			"lng": -77.38763524,
			"lat": 37.53798197,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 8,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sallie",
			"nl": "Hailey",
			"url": "https://findagrave.com/memorial/185308083",
			"id": 185308083,
			"lng": -77.38698302,
			"lat": 37.53757706,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1921,
			"dm": 12,
			"dd": 28,
			"by": 1841,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Benjamin",
			"nl": "Hall",
			"url": "https://findagrave.com/memorial/204137322",
			"id": 204137322,
			"lng": -77.38753979,
			"lat": 37.53563853,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 11,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Ernest",
			"nf": "Richard",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/202834474",
			"id": 202834474,
			"lng": -77.38648592,
			"lat": 37.53722282,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 5,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alice",
			"nl": "Herndon",
			"url": "https://findagrave.com/memorial/203999532",
			"id": 203999532,
			"lng": -77.38768574,
			"lat": 37.53769908,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 6,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Allen",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/170838988",
			"id": 170838988,
			"lng": -77.3864578,
			"lat": 37.53716439,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 3,
			"dd": 13,
			"by": 1952,
			"bd": 2,
			"bm": 8,
			"nm": "Lucille",
			"nf": "Gayle",
			"nl": "Langhorne",
			"url": "https://findagrave.com/memorial/203011746",
			"id": 203011746,
			"lng": -77.38708583,
			"lat": 37.537714,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 10,
			"dd": 29,
			"by": 1907,
			"bd": 28,
			"bm": 12,
			"nm": "Edward",
			"nf": "Willis",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/203785011",
			"id": 203785011,
			"lng": -77.38696486,
			"lat": 37.53696824,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 6,
			"dd": 9,
			"by": 1910,
			"bd": 5,
			"bm": 7,
			"nm": "",
			"nf": "Henry",
			"nl": "Mills",
			"url": "https://findagrave.com/memorial/203028689",
			"id": 203028689,
			"lng": -77.38702299,
			"lat": 37.53768885,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 7,
			"dd": 22,
			"by": 1882,
			"bd": 8,
			"bm": 2,
			"nm": "",
			"nf": "Elijah",
			"nl": "Pinnex",
			"url": "https://findagrave.com/memorial/203012368",
			"id": 203012368,
			"lng": -77.38704724,
			"lat": 37.53770315,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 3,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lucy",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/204577702",
			"id": 204577702,
			"lng": -77.38731177,
			"lat": 37.53559695,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 6,
			"dd": 13,
			"by": 1903,
			"bd": 2,
			"bm": 1,
			"nm": "",
			"nf": "Nelson",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/203584547",
			"id": 203584547,
			"lng": -77.38678867,
			"lat": 37.53773353,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 3,
			"dd": 12,
			"by": 1923,
			"bd": 20,
			"bm": 8,
			"nm": "",
			"nf": "Celestine",
			"nl": "Smoot",
			"url": "https://findagrave.com/memorial/203026257",
			"id": 203026257,
			"lng": -77.38697193,
			"lat": 37.53767106,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 10,
			"dd": 31,
			"by": 1932,
			"bd": 7,
			"bm": 4,
			"nm": "",
			"nf": "Betty",
			"nl": "Stovall",
			"url": "https://findagrave.com/memorial/170838884",
			"id": 170838884,
			"lng": -77.3864849,
			"lat": 37.53720129,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 2,
			"dd": 11,
			"by": 1895,
			"bd": 2,
			"bm": 7,
			"nm": "",
			"nf": "William",
			"nl": "Wade",
			"url": "https://findagrave.com/memorial/195168940",
			"id": 195168940,
			"lng": -77.38736594,
			"lat": 37.53761146,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 6,
			"dd": 6,
			"by": 1958,
			"bd": 14,
			"bm": 4,
			"nm": "Artell",
			"nf": "Larry",
			"nl": "Winston",
			"url": "https://findagrave.com/memorial/203975014",
			"id": 203975014,
			"lng": -77.38756379,
			"lat": 37.53796784,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 6,
			"dd": 27,
			"by": 1941,
			"bd": 9,
			"bm": 3,
			"nm": "L.",
			"nf": "Sterling",
			"nl": "Allen",
			"url": "https://findagrave.com/memorial/204783830",
			"id": 204783830,
			"lng": -77.38729454,
			"lat": 37.53560377,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 5,
			"dd": 19,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lewis",
			"nl": "Bentley",
			"url": "https://findagrave.com/memorial/204783851",
			"id": 204783851,
			"lng": -77.38713913,
			"lat": 37.53567596,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 9,
			"dd": 1,
			"by": 1897,
			"bd": 21,
			"bm": 12,
			"nm": "",
			"nf": "Calvin",
			"nl": "Booker",
			"url": "https://findagrave.com/memorial/205759210",
			"id": 205759210,
			"lng": -77.38680525,
			"lat": 37.53679417,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 5,
			"dd": 15,
			"by": 1919,
			"bd": 29,
			"bm": 1,
			"nm": "",
			"nf": "Wilbur",
			"nl": "Brooks",
			"url": "https://findagrave.com/memorial/206005409",
			"id": 206005409,
			"lng": -77.3868059,
			"lat": 37.53677584,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 4,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Beulah",
			"nl": "Brown",
			"url": "https://findagrave.com/memorial/204784411",
			"id": 204784411,
			"lng": -77.38736485,
			"lat": 37.53551329,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 4,
			"dd": 9,
			"by": 1865,
			"bd": 10,
			"bm": 9,
			"nm": "W.",
			"nf": "George",
			"nl": "Carrington",
			"url": "https://findagrave.com/memorial/205854376",
			"id": 205854376,
			"lng": -77.38667126,
			"lat": 37.53556497,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 9,
			"dd": 18,
			"by": 1868,
			"bd": 19,
			"bm": 7,
			"nm": "Washington",
			"nf": "George",
			"nl": "Clay",
			"url": "https://findagrave.com/memorial/204784439",
			"id": 204784439,
			"lng": -77.3873962,
			"lat": 37.53549744,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 9,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lizzie",
			"nl": "Dickerson",
			"url": "https://findagrave.com/memorial/204517186",
			"id": 204517186,
			"lng": -77.38763783,
			"lat": 37.53558021,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 4,
			"dd": 9,
			"by": 1893,
			"bd": 30,
			"bm": 5,
			"nm": "Thomas",
			"nf": "Wilbur",
			"nl": "Gayles",
			"url": "https://findagrave.com/memorial/204784476",
			"id": 204784476,
			"lng": -77.38740906,
			"lat": 37.53554634,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 1,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "George",
			"nl": "Henderson",
			"url": "https://findagrave.com/memorial/204787137",
			"id": 204787137,
			"lng": -77.38736127,
			"lat": 37.53550889,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 1,
			"dd": 30,
			"by": 1895,
			"bd": 10,
			"bm": 1,
			"nm": "William",
			"nf": "John",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/195168508",
			"id": 195168508,
			"lng": -77.38795343,
			"lat": 37.53719277,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 12,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Amanda",
			"nl": "Jones",
			"url": "https://findagrave.com/memorial/204787143",
			"id": 204787143,
			"lng": -77.38749399,
			"lat": 37.53550886,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1919,
			"dm": 7,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alberta",
			"nl": "Meekins",
			"url": "https://findagrave.com/memorial/204577828",
			"id": 204577828,
			"lng": -77.38739838,
			"lat": 37.5354877,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 4,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Mccue",
			"nf": "Ada",
			"nl": "Nicholas",
			"url": "https://findagrave.com/memorial/205758544",
			"id": 205758544,
			"lng": -77.38694326,
			"lat": 37.53682138,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1922,
			"dm": 8,
			"dd": 31,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Richard",
			"nl": "Price",
			"url": "https://findagrave.com/memorial/204787154",
			"id": 204787154,
			"lng": -77.38743612,
			"lat": 37.53553654,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Pattie",
			"nl": "Randolph",
			"url": "https://findagrave.com/memorial/204787217",
			"id": 204787217,
			"lng": -77.38726533,
			"lat": 37.53569022,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 8,
			"dd": 7,
			"by": 1900,
			"bd": 1,
			"bm": 4,
			"nm": "Henry",
			"nf": "William",
			"nl": "Wilson",
			"url": "https://findagrave.com/memorial/205758165",
			"id": 205758165,
			"lng": -77.38690707,
			"lat": 37.53686054,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1948,
			"dm": 4,
			"dd": 1,
			"by": 1889,
			"bd": 26,
			"bm": 12,
			"nm": "",
			"nf": "Lula",
			"nl": "Suitts El",
			"url": "https://findagrave.com/memorial/205786683",
			"id": 205786683,
			"lng": -77.3869276,
			"lat": 37.53680682,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 5,
			"dd": 10,
			"by": 1890,
			"bd": 21,
			"bm": 2,
			"nm": "",
			"nf": "Robert",
			"nl": "Cunningham",
			"url": "https://findagrave.com/memorial/206558611",
			"id": 206558611,
			"lng": -77.38664175,
			"lat": 37.53697607,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 12,
			"dd": 13,
			"by": 1870,
			"bd": 16,
			"bm": 3,
			"nm": "",
			"nf": "Richard",
			"nl": "Price",
			"url": "https://findagrave.com/memorial/206558641",
			"id": 206558641,
			"lng": -77.38668931,
			"lat": 37.53698707,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 2,
			"dd": 26,
			"by": 1928,
			"bd": 28,
			"bm": 1,
			"nm": "",
			"nf": "Eulalia",
			"nl": "Ellis",
			"url": "https://findagrave.com/memorial/206729312",
			"id": 206729312,
			"lng": -77.38641557,
			"lat": 37.53666027,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 3,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Bessie",
			"nl": "Hilton",
			"url": "https://findagrave.com/memorial/206737320",
			"id": 206737320,
			"lng": -77.38744839,
			"lat": 37.5373692,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 1,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "M.",
			"nf": "James",
			"nl": "Singleton",
			"url": "https://findagrave.com/memorial/206737326",
			"id": 206737326,
			"lng": -77.38618298,
			"lat": 37.53683909,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 7,
			"dd": 27,
			"by": 1892,
			"bd": 18,
			"bm": 4,
			"nm": "M.",
			"nf": "Sallie",
			"nl": "Patton",
			"url": "https://findagrave.com/memorial/206962630",
			"id": 206962630,
			"lng": -77.38657665,
			"lat": 37.53716239,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 10,
			"dd": 27,
			"by": 1854,
			"bd": 1,
			"bm": 11,
			"nm": "B.",
			"nf": "Luvenia",
			"nl": "Lewis",
			"url": "https://findagrave.com/memorial/198673724",
			"id": 198673724,
			"lng": -77.3861424,
			"lat": 37.53572458,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 4,
			"dd": 21,
			"by": 1847,
			"bd": 16,
			"bm": 8,
			"nm": "",
			"nf": "Fannie",
			"nl": "Roane",
			"url": "https://findagrave.com/memorial/204951016",
			"id": 204951016,
			"lng": -77.38756713,
			"lat": 37.53651763,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 2,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Isham",
			"nl": "Lawrence",
			"url": "https://findagrave.com/memorial/205054411",
			"id": 205054411,
			"lng": -77.38707936,
			"lat": 37.5356791,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 4,
			"dd": 22,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Eddie",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/205201107",
			"id": 205201107,
			"lng": -77.3875745,
			"lat": 37.53562417,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 3,
			"dd": 20,
			"by": 1913,
			"bd": 23,
			"bm": 2,
			"nm": "Nataniel",
			"nf": "Robert",
			"nl": "Thomas",
			"url": "https://findagrave.com/memorial/205484021",
			"id": 205484021,
			"lng": -77.38595212,
			"lat": 37.53629843,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lemuel",
			"nl": "Carter",
			"url": "https://findagrave.com/memorial/206017331",
			"id": 206017331,
			"lng": -77.38690274,
			"lat": 37.53665598,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 5,
			"dd": 24,
			"by": 180,
			"bd": 8,
			"bm": 4,
			"nm": "",
			"nf": "Laura",
			"nl": "Calloway",
			"url": "https://findagrave.com/memorial/206159296",
			"id": 206159296,
			"lng": -77.38724736,
			"lat": 37.53696246,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1945,
			"dm": 4,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "G.",
			"nf": "Lettie",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/206160530",
			"id": 206160530,
			"lng": -77.38720362,
			"lat": 37.53695967,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 3,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Evrie",
			"nl": "Ellis",
			"url": "https://findagrave.com/memorial/206423623",
			"id": 206423623,
			"lng": -77.38812055,
			"lat": 37.53745632,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 5,
			"dd": 8,
			"by": 1887,
			"bd": 25,
			"bm": 12,
			"nm": "",
			"nf": "Sophia",
			"nl": "Trent",
			"url": "https://findagrave.com/memorial/206423629",
			"id": 206423629,
			"lng": -77.38706174,
			"lat": 37.53688418,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 8,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Randolph",
			"nl": "Turner",
			"url": "https://findagrave.com/memorial/207044917",
			"id": 207044917,
			"lng": -77.38668451,
			"lat": 37.53664459,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nathan",
			"nl": "Aytes",
			"url": "https://findagrave.com/memorial/198908126",
			"id": 198908126,
			"lng": -77.38603168,
			"lat": 37.53615712,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 11,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "B.",
			"nf": "Lucy",
			"nl": "King",
			"url": "https://findagrave.com/memorial/198907802",
			"id": 198907802,
			"lng": -77.38612103,
			"lat": 37.53607433,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 2,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Littleton",
			"nl": "Britton",
			"url": "https://findagrave.com/memorial/173908791",
			"id": 173908791,
			"lng": -77.38759325,
			"lat": 37.53717207,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 4,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Isaac",
			"nl": "Crump",
			"url": "https://findagrave.com/memorial/203645514",
			"id": 203645514,
			"lng": -77.38642924,
			"lat": 37.53632998,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 1,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Frank",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/195877147",
			"id": 195877147,
			"lng": -77.3859896,
			"lat": 37.53598586,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1954,
			"dm": 7,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Nancy",
			"nl": "Robinson",
			"url": "https://findagrave.com/memorial/205362251",
			"id": 205362251,
			"lng": -77.3865704,
			"lat": 37.5364753,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 8,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Frances",
			"nf": "Mary",
			"nl": "Smith",
			"url": "https://findagrave.com/memorial/188624291",
			"id": 188624291,
			"lng": -77.38651691,
			"lat": 37.53589611,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 11,
			"dd": 10,
			"by": 1899,
			"bd": 26,
			"bm": 3,
			"nm": "",
			"nf": "William",
			"nl": "Pierce",
			"url": "https://findagrave.com/memorial/203786208",
			"id": 203786208,
			"lng": -77.38690918,
			"lat": 37.53730747,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 6,
			"dd": 4,
			"by": 1885,
			"bd": 28,
			"bm": 5,
			"nm": "Henry Miles",
			"nf": "John",
			"nl": "Farrar",
			"url": "https://findagrave.com/memorial/142470744",
			"id": 142470744,
			"lng": -77.38725332,
			"lat": 37.53695376,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 8,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Maria",
			"nl": "Randall",
			"url": "https://findagrave.com/memorial/142470793",
			"id": 142470793,
			"lng": -77.38724351,
			"lat": 37.53695334,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 4,
			"dd": 24,
			"by": 1903,
			"bd": 22,
			"bm": 10,
			"nm": "Newton",
			"nf": "Samuel",
			"nl": "Barr",
			"url": "https://findagrave.com/memorial/207174199",
			"id": 207174199,
			"lng": -77.3871693,
			"lat": 37.53684018,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 9,
			"dd": 19,
			"by": 1902,
			"bd": 2,
			"bm": 3,
			"nm": "Roy",
			"nf": "James",
			"nl": "Harris",
			"url": "https://findagrave.com/memorial/207174212",
			"id": 207174212,
			"lng": -77.38709633,
			"lat": 37.53735364,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 8,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Gertrude",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/207174232",
			"id": 207174232,
			"lng": -77.38715083,
			"lat": 37.5371995,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 10,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Wooden",
			"nf": "Isabelle",
			"nl": "Moore",
			"url": "https://findagrave.com/memorial/205663574",
			"id": 205663574,
			"lng": -77.38761675,
			"lat": 37.53727605,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1920,
			"dm": 1,
			"dd": 1,
			"by": 1849,
			"bd": 23,
			"bm": 12,
			"nm": "",
			"nf": "Kate",
			"nl": "Holmes",
			"url": "https://findagrave.com/memorial/207712871",
			"id": 207712871,
			"lng": -77.38781104,
			"lat": 37.53639422,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 5,
			"dd": 17,
			"by": 1923,
			"bd": 17,
			"bm": 6,
			"nm": "Mae",
			"nf": "Ethel",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/207344637",
			"id": 207344637,
			"lng": -77.38745807,
			"lat": 37.53787218,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 3,
			"dd": 13,
			"by": 1897,
			"bd": 17,
			"bm": 1,
			"nm": "",
			"nf": "Zemora",
			"nl": "Monteeth",
			"url": "https://findagrave.com/memorial/207540740",
			"id": 207540740,
			"lng": -77.3867741,
			"lat": 37.53687514,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 4,
			"dd": 11,
			"by": 1957,
			"bd": 8,
			"bm": 10,
			"nm": "",
			"nf": "Monanstao",
			"nl": "Small",
			"url": "https://findagrave.com/memorial/207382121",
			"id": 207382121,
			"lng": -77.3876297,
			"lat": 37.537899,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 5,
			"dd": 8,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sim",
			"nl": "Taylor",
			"url": "https://findagrave.com/memorial/207281725",
			"id": 207281725,
			"lng": -77.38711255,
			"lat": 37.5367499,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1930,
			"dm": 1,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "R.",
			"nf": "William",
			"nl": "Anderson",
			"url": "https://www.findagrave.com/memorial/211706867/william-r.-anderson",
			"id": 211706867,
			"lng": -77.386681,
			"lat": 37.53544304,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 9,
			"dd": 23,
			"by": 1913,
			"bd": 2,
			"bm": 7,
			"nm": "Mollie",
			"nf": "Mary",
			"nl": "Wingo",
			"url": "https://www.findagrave.com/memorial/215059747/mary-mollie-wingo",
			"id": 215059747,
			"lng": -77.38624632,
			"lat": 37.5354645,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": 4,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Dolly",
			"nl": "Chavers",
			"url": "https://www.findagrave.com/memorial/179307773/dolly-chavers",
			"id": 179307773,
			"lng": -77.38613434,
			"lat": 37.53567392,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 10,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "C. Evans",
			"nf": "Elizabeth",
			"nl": "Payne",
			"url": "https://www.findagrave.com/memorial/169921982/elizabeth-c-payne",
			"id": 169921982,
			"lng": -77.38652047,
			"lat": 37.53571537,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 7,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "T.",
			"nf": "Letitia",
			"nl": "Dabbs",
			"url": "https://www.findagrave.com/memorial/211869014/letitia-t.-dabbs",
			"id": 211869014,
			"lng": -77.38673997,
			"lat": 37.53569889,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1914,
			"dm": 6,
			"dd": 16,
			"by": 1894,
			"bd": 25,
			"bm": 1,
			"nm": "Beatrice",
			"nf": "Annie",
			"nl": "Allen",
			"url": "https://www.findagrave.com/memorial/207804066/annie-beatrice-allen",
			"id": 207804066,
			"lng": -77.38696052,
			"lat": 37.5357922,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1933,
			"dm": 3,
			"dd": 29,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Gertrude",
			"nl": "Sparks",
			"url": "https://www.findagrave.com/memorial/212207968/gertrude-sparks",
			"id": 212207968,
			"lng": -77.38667473,
			"lat": 37.53582409,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1908,
			"dm": 4,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Irene",
			"nf": "Lottie",
			"nl": "Brown",
			"url": "https://www.findagrave.com/memorial/176388847/lottie-irene-brown",
			"id": 176388847,
			"lng": -77.38625853,
			"lat": 37.53583237,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1909,
			"dm": 11,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Brabby",
			"url": "https://www.findagrave.com/memorial/211854588/mary-brabby",
			"id": 211854588,
			"lng": -77.38675603,
			"lat": 37.53598548,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1913,
			"dm": 1,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "P.",
			"nf": "Lewis",
			"nl": "Cheatham",
			"url": "https://www.findagrave.com/memorial/168967225/lewis-p.-cheatham",
			"id": 168967225,
			"lng": -77.38622092,
			"lat": 37.53601778,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 3,
			"dd": 2,
			"by": 1918,
			"bd": 17,
			"bm": 2,
			"nm": "Pollard",
			"nf": "Lincoln",
			"nl": "Johnson",
			"url": "https://www.findagrave.com/memorial/209266417/lincoln-pollard-johnson",
			"id": 209266417,
			"lng": -77.3859875,
			"lat": 37.53600009,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1940,
			"dm": 2,
			"dd": 27,
			"by": 1857,
			"bd": 20,
			"bm": 5,
			"nm": "McPherson",
			"nf": "Christopher",
			"nl": "Kemp",
			"url": "https://www.findagrave.com/memorial/170268764/christopher-mcpherson-kemp",
			"id": 170268764,
			"lng": -77.38601689,
			"lat": 37.53608339,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 6,
			"dd": 9,
			"by": 1886,
			"bd": 10,
			"bm": 10,
			"nm": "",
			"nf": "Paul",
			"nl": "Thompson",
			"url": "https://www.findagrave.com/memorial/211045902/paul-thompson",
			"id": 211045902,
			"lng": -77.38622663,
			"lat": 37.53615076,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 6,
			"dd": 25,
			"by": 1876,
			"bd": 18,
			"bm": 5,
			"nm": "",
			"nf": "Cora",
			"nl": "Thompson",
			"url": "https://www.findagrave.com/memorial/205121222/cora-thompson",
			"id": 205121222,
			"lng": -77.38600695,
			"lat": 37.53626343,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1915,
			"dm": 6,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Henry",
			"nl": "Williams",
			"url": "https://www.findagrave.com/memorial/150037966/henry-williams",
			"id": 150037966,
			"lng": -77.38626291,
			"lat": 37.53641111,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1904,
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "William",
			"nl": "Ferguson",
			"url": "https://www.findagrave.com/memorial/187074826/william-ferguson",
			"id": 187074826,
			"lng": -77.38626871,
			"lat": 37.53642527,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1924,
			"dm": 2,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Hazel",
			"nl": "Vanhook",
			"url": "https://www.findagrave.com/memorial/211936988/hazel-vanhook",
			"id": 211936988,
			"lng": -77.38663033,
			"lat": 37.53625824,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 12,
			"dd": 10,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "L.",
			"nf": "Abram",
			"nl": "Harris",
			"url": "https://www.findagrave.com/memorial/194636088/abram-l.-harris",
			"id": 194636088,
			"lng": -77.38773777,
			"lat": 37.5364077,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1944,
			"dm": 3,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Briggs",
			"url": "https://www.findagrave.com/memorial/134403100/mary-briggs",
			"id": 134403100,
			"lng": -77.3877603,
			"lat": 37.53658178,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1927,
			"dm": 3,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Henry",
			"nf": "William",
			"nl": "Liggins",
			"url": "https://www.findagrave.com/memorial/207787291/william-henry-liggins",
			"id": 207787291,
			"lng": -77.38775682,
			"lat": 37.53658722,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1943,
			"dm": 4,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Harris",
			"url": "https://www.findagrave.com/memorial/184478696/mary-harris",
			"id": 184478696,
			"lng": -77.38769084,
			"lat": 37.53662392,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1946,
			"dm": 6,
			"dd": 27,
			"by": 1849,
			"bd": 15,
			"bm": 1,
			"nm": "P.",
			"nf": "John",
			"nl": "Clarke",
			"url": "https://www.findagrave.com/memorial/205830048/john-p.-clarke",
			"id": 205830048,
			"lng": -77.38762265,
			"lat": 37.53661748,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1917,
			"dm": 8,
			"dd": 19,
			"by": 1915,
			"bd": 28,
			"bm": 6,
			"nm": "Helen",
			"nf": "Mary",
			"nl": "Perry",
			"url": "https://www.findagrave.com/memorial/211945672/mary-helen-perry",
			"id": 211945672,
			"lng": -77.38757217,
			"lat": 37.5366004,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Isaiah",
			"nl": "Dabney",
			"url": "https://www.findagrave.com/memorial/208044806/isaiah-dabney",
			"id": 208044806,
			"lng": -77.38752999,
			"lat": 37.53662016,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "A.",
			"nf": "Benjamin",
			"nl": "Harris",
			"url": "https://www.findagrave.com/memorial/207963111/benjamin-a.-harris",
			"id": 207963111,
			"lng": -77.38767274,
			"lat": 37.5367677,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1918,
			"dm": 2,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Ann",
			"nf": "Ellen",
			"nl": "Briggs",
			"url": "https://www.findagrave.com/memorial/215345550/ellen-ann-briggs",
			"id": 215345550,
			"lng": -77.3876116,
			"lat": 37.53676588,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 7,
			"dd": 21,
			"by": 1894,
			"bd": 9,
			"bm": 4,
			"nm": "",
			"nf": "Richard",
			"nl": "Washington",
			"url": "https://www.findagrave.com/memorial/215610216/richard-washington",
			"id": 215610216,
			"lng": -77.38747981,
			"lat": 37.53677427,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 11,
			"dd": 27,
			"by": 1906,
			"bd": 8,
			"bm": "",
			"nm": "May",
			"nf": "Lottie",
			"nl": "Green",
			"url": "https://www.findagrave.com/memorial/208672682/lottie-may-green",
			"id": 208672682,
			"lng": -77.38752594,
			"lat": 37.53683663,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1935,
			"dm": 1,
			"dd": 9,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Arthur",
			"nl": "White",
			"url": "https://www.findagrave.com/memorial/212453526/arthur-white",
			"id": 212453526,
			"lng": -77.38700178,
			"lat": 37.53669203,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 1,
			"dd": 10,
			"by": 1891,
			"bd": 11,
			"bm": 12,
			"nm": "Lottie",
			"nf": "Mary",
			"nl": "Smith",
			"url": "https://www.findagrave.com/memorial/215611682/mary-smith",
			"id": 215611682,
			"lng": -77.38686166,
			"lat": 37.53676556,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1938,
			"dm": 1,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Beatrice",
			"nf": "Sarah",
			"nl": "Jonathan",
			"url": "https://www.findagrave.com/memorial/168963625/sarah-beatrice-jonathan",
			"id": 168963625,
			"lng": -77.38665562,
			"lat": 37.53660453,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 7,
			"dd": 24,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Clara",
			"nl": "Starke",
			"url": "https://www.findagrave.com/memorial/213036460/clara-starke",
			"id": 213036460,
			"lng": -77.38654082,
			"lat": 37.53665751,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 5,
			"dd": 19,
			"by": 1910,
			"bd": 22,
			"bm": 5,
			"nm": "C.",
			"nf": "William",
			"nl": "Smith",
			"url": "https://www.findagrave.com/memorial/208373118/william-c.-smith",
			"id": 208373118,
			"lng": -77.38641353,
			"lat": 37.5367737,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 12,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Infant Daughter",
			"nl": "Robinson",
			"url": "https://www.findagrave.com/memorial/208372707/infant-robinson",
			"id": 208372707,
			"lng": -77.38644224,
			"lat": 37.5367972,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1947,
			"dm": 9,
			"dd": 15,
			"by": 1947,
			"bd": 14,
			"bm": 9,
			"nm": "",
			"nf": "Baby Girl",
			"nl": "Person",
			"url": "https://www.findagrave.com/memorial/206778715/infant-female-person",
			"id": 206778715,
			"lng": -77.3871406,
			"lat": 37.53682577,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1937,
			"dm": 3,
			"dd": 14,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Sallie",
			"nl": "Hundley",
			"url": "https://www.findagrave.com/memorial/212749787/sallie-hundley",
			"id": 212749787,
			"lng": -77.38719984,
			"lat": 37.53684049,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 7,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Edward",
			"nl": "Vaden",
			"url": "https://www.findagrave.com/memorial/173919689/edward-vaden",
			"id": 173919689,
			"lng": -77.38754199,
			"lat": 37.53715174,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1923,
			"dm": 12,
			"dd": 13,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Margaret",
			"nl": "Butcher",
			"url": "https://www.findagrave.com/memorial/214111896/margaret-butcher",
			"id": 214111896,
			"lng": -77.38793257,
			"lat": 37.53729109,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1979,
			"dm": 3,
			"dd": 16,
			"by": 1914,
			"bd": 6,
			"bm": 4,
			"nm": "Matthew",
			"nf": "John",
			"nl": "Crump",
			"url": "https://www.findagrave.com/memorial/5254135/john-matthew-crump",
			"id": 5254135,
			"lng": -77.38658638,
			"lat": 37.53696666,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 1,
			"dd": 1,
			"by": 1944,
			"bd": 19,
			"bm": 5,
			"nm": "Edward",
			"nf": "Warren",
			"nl": "Preston",
			"url": "https://www.findagrave.com/memorial/208372385/warren-edward-preston",
			"id": 208372385,
			"lng": -77.38639804,
			"lat": 37.53691259,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 6,
			"dd": 7,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Thomas",
			"nf": "William",
			"nl": "Kelly",
			"url": "https://www.findagrave.com/memorial/201040691/william-thomas-kelly",
			"id": 201040691,
			"lng": -77.38570909,
			"lat": 37.53674605,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1931,
			"dm": 6,
			"dd": 15,
			"by": 1879,
			"bd": 6,
			"bm": 7,
			"nm": "R.",
			"nf": "Joshua",
			"nl": "Griffin",
			"url": "https://www.findagrave.com/memorial/208040250/joshua-r.-griffin",
			"id": 208040250,
			"lng": -77.38556814,
			"lat": 37.53702607,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1951,
			"dm": 10,
			"dd": 24,
			"by": 1906,
			"bd": 7,
			"bm": 2,
			"nm": "Wilbur",
			"nf": "Richard",
			"nl": "Holmes",
			"url": "https://www.findagrave.com/memorial/207843554/richard-wilbur-holmes",
			"id": 207843554,
			"lng": -77.38564788,
			"lat": 37.53715781,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1968,
			"dm": 6,
			"dd": 13,
			"by": 1900,
			"bd": 17,
			"bm": 4,
			"nm": "",
			"nf": "Harvey",
			"nl": "Lightfoot",
			"url": "https://www.findagrave.com/memorial/214628741/harvey-lightfoot",
			"id": 214628741,
			"lng": -77.38587788,
			"lat": 37.53745165,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 5,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Stacy",
			"nl": "Lewis",
			"url": "https://www.findagrave.com/memorial/211363873/stacy-lewis",
			"id": 211363873,
			"lng": -77.38597894,
			"lat": 37.53735906,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 4,
			"dd": 23,
			"by": 1963,
			"bd": 23,
			"bm": 4,
			"nm": "Charles",
			"nf": "Christopher",
			"nl": "Harris",
			"url": "https://www.findagrave.com/memorial/214566183/christopher-charles-harris",
			"id": 214566183,
			"lng": -77.38619894,
			"lat": 37.53751325,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1966,
			"dm": 10,
			"dd": 12,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Peter",
			"nf": "Doctor",
			"nl": "Martin",
			"url": "https://www.findagrave.com/memorial/130927225/doctor-peter-martin",
			"id": 130927225,
			"lng": -77.38636644,
			"lat": 37.53710683,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 9,
			"dd": 4,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "W.",
			"nf": "Sarah",
			"nl": "Hopkins",
			"url": "https://www.findagrave.com/memorial/170838995/sarah-w-hopkins",
			"id": 170838995,
			"lng": -77.38642085,
			"lat": 37.53716585,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 1,
			"dd": 5,
			"by": 1909,
			"bd": 9,
			"bm": 7,
			"nm": "",
			"nf": "Walter",
			"nl": "Scott",
			"url": "https://www.findagrave.com/memorial/177326276/walter-scott",
			"id": 177326276,
			"lng": -77.38754054,
			"lat": 37.53731556,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 11,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Clarence",
			"nl": "Mason",
			"url": "https://www.findagrave.com/memorial/197483388/clarence-mason",
			"id": 197483388,
			"lng": -77.38802642,
			"lat": 37.53781689,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1941,
			"dm": 5,
			"dd": 30,
			"by": 1922,
			"bd": 15,
			"bm": 6,
			"nm": "Herman",
			"nf": "Charles",
			"nl": "Spears",
			"url": "https://www.findagrave.com/memorial/214198064/charles-herman-spears",
			"id": 214198064,
			"lng": -77.38789285,
			"lat": 37.53782422,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 1,
			"dd": 20,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Lestine",
			"nf": "Agnes",
			"nl": "Langston",
			"url": "https://www.findagrave.com/memorial/214237195/agnes-lestine-langston",
			"id": 214237195,
			"lng": -77.38764008,
			"lat": 37.5379004,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 5,
			"dd": 15,
			"by": 1905,
			"bd": 14,
			"bm": 4,
			"nm": "",
			"nf": "Thomas",
			"nl": "Pettis",
			"url": "https://www.findagrave.com/memorial/207130609/thomas-pettis",
			"id": 207130609,
			"lng": -77.38747882,
			"lat": 37.53774029,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 9,
			"dd": 17,
			"by": 1910,
			"bd": 10,
			"bm": 6,
			"nm": "",
			"nf": "Rozella",
			"nl": "Maroney",
			"url": "https://www.findagrave.com/memorial/184476104/rozella-maroney",
			"id": 184476104,
			"lng": -77.38731951,
			"lat": 37.53758921,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 9,
			"dd": 28,
			"by": 1884,
			"bd": 15,
			"bm": 5,
			"nm": "",
			"nf": "Robert",
			"nl": "Henderson",
			"url": "https://www.findagrave.com/memorial/188065506/robert-henderson",
			"id": 188065506,
			"lng": -77.38720458,
			"lat": 37.53760538,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 11,
			"dd": 14,
			"by": 1938,
			"bd": 17,
			"bm": 8,
			"nm": "",
			"nf": "Delores",
			"nl": "Williams",
			"url": "https://www.findagrave.com/memorial/214980948/delores-williams",
			"id": 214980948,
			"lng": -77.38695717,
			"lat": 37.5377554,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 6,
			"dd": 25,
			"by": 1886,
			"bd": 15,
			"bm": 2,
			"nm": "",
			"nf": "Grant",
			"nl": "Wingfield",
			"url": "https://www.findagrave.com/memorial/207345998/grant-wingfield",
			"id": 207345998,
			"lng": -77.38693093,
			"lat": 37.53773948,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 8,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Claiborne",
			"nf": "William",
			"nl": "Jones",
			"url": "https://www.findagrave.com/memorial/214995732/william-claiborne-jones",
			"id": 214995732,
			"lng": -77.38641152,
			"lat": 37.53749227,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 7,
			"dd": 26,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Alice",
			"nl": "Albright",
			"url": "https://www.findagrave.com/memorial/215753501/alice-albright",
			"id": 215753501,
			"lng": -77.38723668,
			"lat": 37.53556336,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 1,
			"dd": 23,
			"by": 1918,
			"bd": 27,
			"bm": 6,
			"nm": "",
			"nf": "Laura",
			"nl": "Brown",
			"url": "https://www.findagrave.com/memorial/216110923/laura-brown",
			"id": 216110923,
			"lng": -77.38642137,
			"lat": 37.53756309,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 6,
			"dd": 17,
			"by": 1888,
			"bd": 24,
			"bm": 5,
			"nm": "",
			"nf": "Ida",
			"nl": "Johnson",
			"url": "https://www.findagrave.com/memorial/216505410/ida-johnson",
			"id": 216505410,
			"lng": -77.38682941,
			"lat": 37.53773282,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 8,
			"dd": 10,
			"by": 1870,
			"bd": 6,
			"bm": 8,
			"nm": "",
			"nf": "William",
			"nl": "Christian",
			"url": "https://www.findagrave.com/memorial/216539622/william-christian",
			"id": 216539622,
			"lng": -77.38760195,
			"lat": 37.53770995,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": 8,
			"dd": 17,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Emmett",
			"nl": "Haskins",
			"url": "https://www.findagrave.com/memorial/216541230/emmett-haskins",
			"id": 216541230,
			"lng": -77.38760613,
			"lat": 37.53772048,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 5,
			"dd": 31,
			"by": 1959,
			"bd": 14,
			"bm": 3,
			"nm": "",
			"nf": "Jimmy",
			"nl": "Quarles",
			"url": "https://www.findagrave.com/memorial/203578517/jimmy-quarles",
			"id": 203578517,
			"lng": -77.38677086,
			"lat": 37.53775334,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1958,
			"dm": 2,
			"dd": 16,
			"by": 1896,
			"bd": 13,
			"bm": 5,
			"nm": "",
			"nf": "Sadie",
			"nl": "Hamm",
			"url": "https://www.findagrave.com/memorial/196561439/sadie-hamm",
			"id": 196561439,
			"lng": -77.38777001,
			"lat": 37.53780125,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1957,
			"dm": 12,
			"dd": 7,
			"by": 1990,
			"bd": 15,
			"bm": 8,
			"nm": "",
			"nf": "Viola",
			"nl": "Roberts",
			"url": "https://www.findagrave.com/memorial/196374820/viola-roberts",
			"id": 196374820,
			"lng": -77.38764905,
			"lat": 37.53796173,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 9,
			"dd": 1,
			"by": 1875,
			"bd": 12,
			"bm": 10,
			"nm": "B.",
			"nf": "John",
			"nl": "Braxton",
			"url": "https://www.findagrave.com/memorial/159846368/john-baptist-braxton",
			"id": 159846368,
			"lng": -77.38737786,
			"lat": 37.53756996,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 5,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Mary",
			"nl": "Murray",
			"url": "https://www.findagrave.com/memorial/159846968/mary-jackson-murray",
			"id": 159846968,
			"lng": -77.38738334,
			"lat": 37.53755146,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 3,
			"dd": 18,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Jennifer",
			"nl": "Scarborough",
			"url": "https://www.findagrave.com/memorial/144226025/jennifer-l.-scarborough",
			"id": 144226025,
			"lng": -77.38592784,
			"lat": 37.53743327,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 0,
			"dm": 0,
			"dd": 0,
			"by": 0,
			"bd": 0,
			"bm": 0,
			"nm": "",
			"nf": "Baby Girl",
			"nl": "Unknown",
			"url": "https://www.findagrave.com/memorial/219723070/baby_girl-unknown",
			"id": 219723070,
			"lng": -77.38595864,
			"lat": 37.5374282,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 0,
			"dm": 0,
			"dd": 0,
			"by": 0,
			"bd": 0,
			"bm": 0,
			"nm": "",
			"nf": "Baby",
			"nl": "Unknown",
			"url": "https://www.findagrave.com/memorial/219723522/baby-unknown",
			"id": 219723522,
			"lng": -77.38621908,
			"lat": 37.53745943,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 12,
			"dd": 22,
			"by": 1930,
			"bd": 26,
			"bm": 5,
			"nm": "",
			"nf": "Kate",
			"nl": "Taylor",
			"url": "https://www.findagrave.com/memorial/179091015/kate-taylor",
			"id": 179091015,
			"lng": -77.38788577,
			"lat": 37.53747588,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 12,
			"dd": 3,
			"by": 1890,
			"bd": 4,
			"bm": 2,
			"nm": "V.",
			"nf": "Eugene",
			"nl": "Love",
			"url": "https://www.findagrave.com/memorial/179091004/eugene-v.-love",
			"id": 179091004,
			"lng": -77.38785669,
			"lat": 37.53749589,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 6,
			"dd": 12,
			"by": 1929,
			"bd": 22,
			"bm": 2,
			"nm": "J.",
			"nf": "Harvey",
			"nl": "Teasley",
			"url": "https://www.findagrave.com/memorial/179091022/harvey-j.-teasley",
			"id": 179091022,
			"lng": -77.38773642,
			"lat": 37.53734182,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1963,
			"dm": 4,
			"dd": 17,
			"by": 1920,
			"bd": 18,
			"bm": 8,
			"nm": "Thompson",
			"nf": "Mary",
			"nl": "West",
			"url": "https://www.findagrave.com/memorial/177761153/mary-west",
			"id": 177761153,
			"lng": -77.38768567,
			"lat": 37.53733646,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1952,
			"dm": 10,
			"dd": 2,
			"by": 1900,
			"bd": 16,
			"bm": 1,
			"nm": "L.",
			"nf": "Caroline",
			"nl": "Manson",
			"url": "https://www.findagrave.com/memorial/148285748/caroline-l.-manson",
			"id": 148285748,
			"lng": -77.38702502,
			"lat": 37.53713068,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 12,
			"dd": 19,
			"by": 1913,
			"bd": 13,
			"bm": 3,
			"nm": "",
			"nf": "Julian",
			"nl": "Glover",
			"url": "https://www.findagrave.com/memorial/172693003/julian-glover",
			"id": 172693003,
			"lng": -77.38606381,
			"lat": 37.53623581,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 2,
			"dd": 17,
			"by": 1922,
			"bd": 13,
			"bm": 9,
			"nm": "",
			"nf": "Charles",
			"nl": "Goodson",
			"url": "https://www.findagrave.com/memorial/219983916/charles-goodson",
			"id": 219983916,
			"lng": -77.38609225,
			"lat": 37.53628165,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1974,
			"dm": 9,
			"dd": 30,
			"by": 1896,
			"bd": 27,
			"bm": 4,
			"nm": "",
			"nf": "Clarence",
			"nl": "Rudd",
			"url": "https://www.findagrave.com/memorial/160335463/clarence-j._windy-rudd",
			"id": 160335463,
			"lng": -77.38610988,
			"lat": 37.53633036,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1975,
			"dm": 1,
			"dd": 4,
			"by": 1892,
			"bd": 16,
			"bm": 11,
			"nm": "",
			"nf": "Charles",
			"nl": "Davis",
			"url": "https://www.findagrave.com/memorial/219985007/charles-davis",
			"id": 219985007,
			"lng": -77.38605473,
			"lat": 37.53623032,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 7,
			"dd": 30,
			"by": 1924,
			"bd": 1,
			"bm": 12,
			"nm": "",
			"nf": "Edna",
			"nl": "Tolliver",
			"url": "https://www.findagrave.com/memorial/155989152/edna-tolliver",
			"id": 155989152,
			"lng": -77.38631598,
			"lat": 37.53529407,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 3,
			"dd": 29,
			"by": 1950,
			"bd": 29,
			"bm": 3,
			"nm": "",
			"nf": "Baby",
			"nl": "Lewis",
			"url": "https://www.findagrave.com/memorial/125313034/baby-lewis",
			"id": 125313034,
			"lng": -77.38590004,
			"lat": 37.53688939,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1964,
			"dm": 4,
			"dd": 8,
			"by": 1883,
			"bd": 3,
			"bm": 12,
			"nm": "A.",
			"nf": "Willie",
			"nl": "Sessoms",
			"url": "https://www.findagrave.com/memorial/197602147/willie-a.-sessoms",
			"id": 197602147,
			"lng": -77.38746256,
			"lat": 37.53741863,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1961,
			"dm": 8,
			"dd": 23,
			"by": 1908,
			"bd": 12,
			"bm": 2,
			"nm": "Theo",
			"nf": "Nancy",
			"nl": "Epps",
			"url": "https://www.findagrave.com/memorial/191519035/nancy-theo-epps",
			"id": 191519035,
			"lng": -77.38636522,
			"lat": 37.53752445,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1936,
			"dm": 4,
			"dd": 2,
			"by": 1922,
			"bd": 12,
			"bm": 6,
			"nm": "",
			"nf": "Alfred",
			"nl": "Hamilton",
			"url": "https://www.findagrave.com/memorial/171761588/alfred-e.-hamilton",
			"id": 171761588,
			"lng": -77.38723283,
			"lat": 37.53680709,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 12,
			"dd": 12,
			"by": 1908,
			"bd": 15,
			"bm": 6,
			"nm": "",
			"nf": "Willie",
			"nl": "Bryant",
			"url": "https://www.findagrave.com/memorial/210408018/willie-bryant",
			"id": 210408018,
			"lng": -77.38655108,
			"lat": 37.5369212,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1978,
			"dm": 11,
			"dd": 27,
			"by": 1909,
			"bd": 16,
			"bm": 3,
			"nm": "",
			"nf": "Roosevelt",
			"nl": "Williams",
			"url": "https://www.findagrave.com/memorial/183718595/roosevelt-williams",
			"id": 183718595,
			"lng": -77.3869022,
			"lat": 37.53704871,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1976,
			"dm": 12,
			"dd": 4,
			"by": 1912,
			"bd": 23,
			"bm": 6,
			"nm": "Mae",
			"nf": "Beulah",
			"nl": "Jackson",
			"url": "https://www.findagrave.com/memorial/220346559/beulah-mae-jackson",
			"id": 220346559,
			"lng": -77.38802375,
			"lat": 37.53739563,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 3,
			"dd": 26,
			"by": 1912,
			"bd": 24,
			"bm": 4,
			"nm": "D.",
			"nf": "Douglas",
			"nl": "Bluford",
			"url": "https://www.findagrave.com/memorial/220346845/douglas-d.-bluford",
			"id": 220346845,
			"lng": -77.38634767,
			"lat": 37.53669815,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 9,
			"dd": 9,
			"by": 1892,
			"bd": 14,
			"bm": 9,
			"nm": "",
			"nf": "Jeroline",
			"nl": "Hill",
			"url": "https://www.findagrave.com/memorial/220501464/jeroline-hill",
			"id": 220501464,
			"lng": -77.38641238,
			"lat": 37.53717896,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1932,
			"dm": 1,
			"dd": 21,
			"by": 1861,
			"bd": 22,
			"bm": 2,
			"nm": "Taylor",
			"nf": "Alice",
			"nl": "Haywood",
			"url": "https://www.findagrave.com/memorial/220538220/alice-taylor-haywood",
			"id": 220538220,
			"lng": -77.38806919,
			"lat": 37.53745599,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1959,
			"dm": 4,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Lewis",
			"nl": "Lacy",
			"url": "https://www.findagrave.com/memorial/220596925/lewis-j.-lacy",
			"id": 220596925,
			"lng": -77.38681504,
			"lat": 37.53747925,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 7,
			"dd": 14,
			"by": 1910,
			"bd": 10,
			"bm": 5,
			"nm": "",
			"nf": "Charlie",
			"nl": "Bines",
			"url": "https://www.findagrave.com/memorial/184094501/charlie-bines",
			"id": 184094501,
			"lng": -77.38724361,
			"lat": 37.53750509,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1955,
			"dm": 2,
			"dd": 5,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Nannie",
			"nl": "Barner",
			"url": "https://www.findagrave.com/memorial/220598285/nannie-barner",
			"id": 220598285,
			"lng": -77.38745629,
			"lat": 37.53761541,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 3,
			"dd": 3,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ernest",
			"nl": "Lewis",
			"url": "https://www.findagrave.com/memorial/220908969/ernest-lewis",
			"id": 220908969,
			"lng": -77.38666177,
			"lat": 37.53692966,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1950,
			"dm": 10,
			"dd": 18,
			"by": 1890,
			"bd": 4,
			"bm": 2,
			"nm": "",
			"nf": "Sallie",
			"nl": "Harper",
			"url": "https://www.findagrave.com/memorial/168953101/sallie-harper",
			"id": 168953101,
			"lng": -77.386552,
			"lat": 37.53691579,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1965,
			"dm": 3,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Floyd",
			"nl": "McQuinn",
			"url": "https://www.findagrave.com/memorial/183818858/floyd-unknown",
			"id": 183818858,
			"lng": -77.38644395,
			"lat": 37.53666671,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1956,
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Baby",
			"nl": "Everett",
			"url": "https://www.findagrave.com/memorial/220945797/baby-everett",
			"id": 220945797,
			"lng": -77.38732005,
			"lat": 37.53792027,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1972,
			"dm": 8,
			"dd": 3,
			"by": "",
			"bd": 8,
			"bm": 1,
			"nm": "",
			"nf": "Leslie",
			"nl": "Freeman",
			"url": "https://www.findagrave.com/memorial/220945161/leslie-freeman",
			"id": 220945161,
			"lng": -77.38741707,
			"lat": 37.53754669,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1967,
			"dm": 8,
			"dd": 26,
			"by": "",
			"bd": 25,
			"bm": 12,
			"nm": "",
			"nf": "Mary",
			"nl": "Bennett",
			"url": "https://www.findagrave.com/memorial/221662211/mary-starke-bennett",
			"id": 221662211,
			"lng": -77.38661395,
			"lat": 37.53721585,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1962,
			"dm": 9,
			"dd": 2,
			"by": 1897,
			"bd": 27,
			"bm": 1,
			"nm": "H.",
			"nf": "Annie",
			"nl": "Porter",
			"url": "https://www.findagrave.com/memorial/158450806/annie-h.-porter",
			"id": 158450806,
			"lng": -77.387661,
			"lat": 37.53755596,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1969,
			"dm": 2,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Shelman",
			"url": "https://www.findagrave.com/memorial/195459855/mary-shelman",
			"id": 195459855,
			"lng": -77.3875175,
			"lat": 37.5376467,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1949,
			"dm": 2,
			"dd": 26,
			"by": 1923,
			"bd": 13,
			"bm": 1,
			"nm": "",
			"nf": "Orrin",
			"nl": "Scott",
			"url": "https://www.findagrave.com/memorial/186083752/orrin-scott",
			"id": 186083752,
			"lng": -77.38675759,
			"lat": 37.53688504,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1939,
			"dm": 11,
			"dd": 8,
			"by": 1858,
			"bd": 22,
			"bm": 2,
			"nm": "",
			"nf": "Junius",
			"nl": "Corbett",
			"url": "https://www.findagrave.com/memorial/223286961/unknown-unknown",
			"id": 223286961,
			"lng": -77.38629903,
			"lat": 37.53550652,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1973,
			"dm": 11,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Unknown",
			"nl": "Unknown",
			"url": "https://www.findagrave.com/memorial/215186538/junius-corbett",
			"id": 215186538,
			"lng": -77.38617578,
			"lat": 37.53737783,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 4,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Charles",
			"nl": "White",
			"url": "https://www.findagrave.com/memorial/224682343/charles-white",
			"id": 224682343,
			"lng": -77.38649977,
			"lat": 37.53556195,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1916,
			"dm": 4,
			"dd": 23,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Joseph",
			"nl": "Morgan",
			"url": "https://www.findagrave.com/memorial/225145676/joseph-morgan",
			"id": 225145676,
			"lng": -77.38650829,
			"lat": 37.53557601,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1934,
			"dm": 8,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "H.",
			"nf": "P.",
			"nl": "Allen",
			"url": "https://www.findagrave.com/memorial/225286384/patrick-henry-allen",
			"id": 225286384,
			"lng": -77.38648579,
			"lat": 37.5355512,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1970,
			"dm": 7,
			"dd": 14,
			"by": 1901,
			"bd": 22,
			"bm": 1,
			"nm": "",
			"nf": "Pearl",
			"nl": "Allen",
			"url": "https://www.findagrave.com/memorial/225286636/pearl-allen",
			"id": 225286636,
			"lng": -77.38648387,
			"lat": 37.53555507,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1907,
			"dm": "",
			"dd": "",
			"by": 1831,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Martha",
			"nl": "Fields",
			"url": "https://www.findagrave.com/memorial/228424126/martha-fields",
			"id": 228424126,
			"lng": -77.38684145,
			"lat": 37.53590361,
			"n": "",
			"t": "Highly Accurate"
		},
		{
			"dy": 1953,
			"dm": 6,
			"dd": 27,
			"by": 1878,
			"bd": 3,
			"bm": 4,
			"nm": "",
			"nf": "Mary",
			"nl": "Harris",
			"url": "https://www.findagrave.com/memorial/144370317/mary-harris",
			"id": 144370317,
			"lng": -77.38583873,
			"lat": 37.53680061,
			"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
			"t": "No GPS"
		},
		{
			"dy": 1953,
			"dm": 1,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Henry",
			"nf": "Charles",
			"nl": "Bryde",
			"url": "https://findagrave.com/memorial/185307467",
			"id": 185307467,
			"lng": -77.38721,
			"lat": 37.53764,
			"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
			"t": "Find A Grave"
		},
		{
			"dy": 1961,
			"dm": 11,
			"dd": 19,
			"by": 1900,
			"bd": 7,
			"bm": 6,
			"nm": "Fariall",
			"nf": "Marion",
			"nl": "Gary",
			"url": "https://findagrave.com/memorial/177617281",
			"id": 177617281,
			"lng": -77.38662,
			"lat": 37.537449,
			"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
			"t": "Find A Grave"
		},
		{
			"dy": 1977,
			"dm": 8,
			"dd": 16,
			"by": 1891,
			"bd": 31,
			"bm": 12,
			"nm": "",
			"nf": "Elizabeth",
			"nl": "Jackson",
			"url": "https://findagrave.com/memorial/183587453",
			"id": 183587453,
			"lng": -77.386162,
			"lat": 37.53685,
			"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
			"t": "Find A Grave"
		},
		{
			"dy": 1964,
			"dm": "",
			"dd": "",
			"by": 1889,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Samuel",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/187354570",
			"id": 187354570,
			"lng": -77.38755,
			"lat": 37.537437,
			"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
			"t": "Find A Grave"
		},
		{
			"dy": 1976,
			"dm": 2,
			"dd": 11,
			"by": 1900,
			"bd": 1,
			"bm": 7,
			"nm": "",
			"nf": "Odessa",
			"nl": "Vines",
			"url": "https://findagrave.com/memorial/172693016",
			"id": 172693016,
			"lng": -77.386004,
			"lat": 37.536324,
			"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
			"t": "Find A Grave"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Freddie",
			"nl": "Peterson",
			"url": "https://www.findagrave.com/memorial/170838280/freddie-peterson",
			"id": 170838280,
			"lng": -77.386431,
			"lat": 37.537201,
			"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
			"t": "Find A Grave"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mary",
			"nl": "Farrell",
			"url": "https://www.findagrave.com/memorial/187351671/mary-farrell",
			"id": 187351671,
			"lng": -77.38743,
			"lat": 37.53731,
			"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
			"t": "Find A Grave"
		},
		{
			"dy": 1966,
			"dm": 3,
			"dd": 9,
			"by": 1966,
			"bd": 1,
			"bm": 3,
			"nm": "Denise",
			"nf": "Sharon",
			"nl": "Anthony",
			"url": "https://findagrave.com/memorial/151929431",
			"id": 151929431,
			"lng": -77.38577011,
			"lat": 37.53678583,
			"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
			"t": "No GPS"
		},
		{
			"dy": 1977,
			"dm": 2,
			"dd": 20,
			"by": 1903,
			"bd": 3,
			"bm": 3,
			"nm": "C.",
			"nf": "Ernest",
			"nl": "Bates",
			"url": "https://findagrave.com/memorial/159877888",
			"id": 159877888,
			"lng": -77.38577579,
			"lat": 37.53678402,
			"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
			"t": "No GPS"
		},
		{
			"dy": 1977,
			"dm": 8,
			"dd": 9,
			"by": 1903,
			"bd": 3,
			"bm": 11,
			"nm": "M.",
			"nf": "Henry",
			"nl": "Booker",
			"url": "https://findagrave.com/memorial/128632046",
			"id": 128632046,
			"lng": -77.38577905,
			"lat": 37.53678795,
			"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
			"t": "No GPS"
		},
		{
			"dy": 1956,
			"dm": 9,
			"dd": 9,
			"by": 1895,
			"bd": 23,
			"bm": 3,
			"nm": "",
			"nf": "Jane",
			"nl": "Bridy",
			"url": "https://findagrave.com/memorial/144367905",
			"id": 144367905,
			"lng": -77.38578366,
			"lat": 37.53678595,
			"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
			"t": "No GPS"
		},
		{
			"dy": 1972,
			"dm": 2,
			"dd": 27,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Lillian",
			"nl": "Cobb",
			"url": "https://findagrave.com/memorial/161563065",
			"id": 161563065,
			"lng": -77.38578695,
			"lat": 37.5367898,
			"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
			"t": "No GPS"
		},
		{
			"dy": 1978,
			"dm": 2,
			"dd": 8,
			"by": 1924,
			"bd": 15,
			"bm": 12,
			"nm": "S.",
			"nf": "Malachai",
			"nl": "Damon",
			"url": "https://findagrave.com/memorial/117180898",
			"id": 117180898,
			"lng": -77.38579189,
			"lat": 37.53678794,
			"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
			"t": "No GPS"
		},
		{
			"dy": 1964,
			"dm": 10,
			"dd": 3,
			"by": 1925,
			"bd": 24,
			"bm": 11,
			"nm": "",
			"nf": "Carolyn",
			"nl": "Fisher",
			"url": "https://findagrave.com/memorial/173106918",
			"id": 173106918,
			"lng": -77.38579489,
			"lat": 37.53679166,
			"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
			"t": "No GPS"
		},
		{
			"dy": 1954,
			"dm": 11,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Lucille",
			"nf": "Pearlie",
			"nl": "Green",
			"url": "https://findagrave.com/memorial/141658020",
			"id": 141658020,
			"lng": -77.38579956,
			"lat": 37.53679002,
			"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
			"t": "No GPS"
		},
		{
			"dy": 1963,
			"dm": 8,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Edgar",
			"nl": "Haskins",
			"url": "https://findagrave.com/memorial/192002722",
			"id": 192002722,
			"lng": -77.3858029,
			"lat": 37.53679362,
			"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
			"t": "No GPS"
		},
		{
			"dy": 1948,
			"dm": 6,
			"dd": 15,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "R.",
			"nf": "Theodore",
			"nl": "Hill",
			"url": "https://findagrave.com/memorial/146339064",
			"id": 146339064,
			"lng": -77.38580819,
			"lat": 37.53679237,
			"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
			"t": "No GPS"
		},
		{
			"dy": 1972,
			"dm": 8,
			"dd": 7,
			"by": 1947,
			"bd": 6,
			"bm": 5,
			"nm": "",
			"nf": "Nathaniel",
			"nl": "Hope",
			"url": "https://findagrave.com/memorial/159850640",
			"id": 159850640,
			"lng": -77.38581164,
			"lat": 37.53679638,
			"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
			"t": "No GPS"
		},
		{
			"dy": 1964,
			"dm": 9,
			"dd": 27,
			"by": 1917,
			"bd": 17,
			"bm": 5,
			"nm": "Edward",
			"nf": "William",
			"nl": "Howard",
			"url": "https://findagrave.com/memorial/172999043",
			"id": 172999043,
			"lng": -77.3858177,
			"lat": 37.53679498,
			"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
			"t": "No GPS"
		},
		{
			"dy": 1962,
			"dm": 2,
			"dd": 22,
			"by": 1923,
			"bd": 7,
			"bm": 5,
			"nm": "",
			"nf": "Mary",
			"nl": "Hubbard",
			"url": "https://findagrave.com/memorial/177354172",
			"id": 177354172,
			"lng": -77.38582157,
			"lat": 37.53679904,
			"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
			"t": "No GPS"
		},
		{
			"dy": 1960,
			"dm": 1,
			"dd": 2,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Clarice",
			"nl": "James",
			"url": "https://findagrave.com/memorial/160053484",
			"id": 160053484,
			"lng": -77.38582804,
			"lat": 37.5367977,
			"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
			"t": "No GPS"
		},
		{
			"dy": 1978,
			"dm": 2,
			"dd": 16,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Lee Dennis",
			"nf": "Walter",
			"nl": "Johnson",
			"url": "https://findagrave.com/memorial/130693683",
			"id": 130693683,
			"lng": -77.38583192,
			"lat": 37.5368022,
			"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
			"t": "No GPS"
		},
		{
			"dy": 1979,
			"dm": 2,
			"dd": 11,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "J.",
			"nf": "Mary",
			"nl": "Wood",
			"url": "https://findagrave.com/memorial/130737053",
			"id": 130737053,
			"lng": -77.38633592,
			"lat": 37.53695892,
			"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
			"t": "Assumed"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "Abdul",
			"nf": "Rahman",
			"nl": "Williamson",
			"url": "https://www.findagrave.com/memorial/125644026/rahman-abdul-williamson",
			"id": 125644026,
			"lng": -77.38621305,
			"lat": 37.53686115,
			"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
			"t": "Assumed"
		},
		{
			"dy": 1918,
			"dm": 10,
			"dd": 11,
			"by": 1872,
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Celista",
			"nl": "Winslow",
			"url": "https://www.findagrave.com/memorial/151448729/celista-winslow",
			"id": 151448729,
			"lng": -77.38691295,
			"lat": 37.53554458,
			"n": "This person has another marker in a different section of the cemetery.",
			"t": "Duplicate"
		},
		{
			"dy": 1915,
			"dm": 3,
			"dd": 21,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Mildred",
			"nl": "Coles",
			"url": "https://www.findagrave.com/memorial/155984790/mildred-coles",
			"id": 155984790,
			"lng": -77.38725571,
			"lat": 37.5355603,
			"n": "This person has another marker in a different section of the cemetery.",
			"t": "Duplicate"
		},
		{
			"dy": 1920,
			"dm": 9,
			"dd": 28,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Hardinia",
			"nl": "Willis",
			"url": "https://www.findagrave.com/memorial/125859692/hardinia-willis",
			"id": 125859692,
			"lng": -77.38659775,
			"lat": 37.53586968,
			"n": "This person has another marker in a different section of the cemetery.",
			"t": "Duplicate"
		},
		{
			"dy": "",
			"dm": "",
			"dd": "",
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "R.",
			"nf": "Hugh",
			"nl": "Williams",
			"url": "https://www.findagrave.com/memorial/78060051/hugh-r-williams",
			"id": 78060051,
			"lng": -77.38743582,
			"lat": 37.5366122,
			"n": "This person is buried in a different cemetery but is noted on the family plot sill.",
			"t": "Named Memorial"
		},
		{
			"dy": 1928,
			"dm": 3,
			"dd": 1,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "E.",
			"nf": "Mary",
			"nl": "Tomlin",
			"url": "https://www.findagrave.com/memorial/160639670/mary-e.-tomlin",
			"id": 160639670,
			"lng": -77.38604429,
			"lat": 37.53680872,
			"n": "This person has another marker in a different section of the cemetery.",
			"t": "Duplicate"
		},
		{
			"dy": 1928,
			"dm": 6,
			"dd": 25,
			"by": "",
			"bd": "",
			"bm": "",
			"nm": "",
			"nf": "Ella",
			"nl": "Gray",
			"url": "https://www.findagrave.com/memorial/145638801/ella-gray",
			"id": 145638801,
			"lng": -77.38776424,
			"lat": 37.53698323,
			"n": "This person has another marker in a different section of the cemetery.",
			"t": "Duplicate"
		},
		{
			"dy": 1979,
			"dm": 3,
			"dd": 16,
			"by": 1919,
			"bd": 4,
			"bm": 10,
			"nm": "C.",
			"nf": "Raymond",
			"nl": "Chapman",
			"url": "https://www.findagrave.com/memorial/150078581/raymond-c.-chapman",
			"id": 150078581,
			"lng": -77.38802753,
			"lat": 37.53753343,
			"n": "This person has another marker in a different section of the cemetery.",
			"t": "Duplicate"
		},
		{
			"dy": 1966,
			"dm": 7,
			"dd": 7,
			"by": 1914,
			"bd": 3,
			"bm": 8,
			"nm": "",
			"nf": "Sandy",
			"nl": "Hudson",
			"url": "https://www.findagrave.com/memorial/125820817/sandy-hudson",
			"id": 125820817,
			"lng": -77.38633143,
			"lat": 37.53707049,
			"n": "This person has another marker in a different section of the cemetery.",
			"t": "Duplicate"
		},
		{
			"dy": 1947,
			"dm": 11,
			"dd": 15,
			"by": 1895,
			"bd": 3,
			"bm": 7,
			"nm": "J.",
			"nf": "William",
			"nl": "Temple",
			"url": "https://www.findagrave.com/memorial/125408710/william-j.-temple",
			"id": 125408710,
			"lng": -77.3858972,
			"lat": 37.53693854,
			"n": "This person has another marker in a different section of the cemetery.",
			"t": "Duplicate"
		},
		{
			"dy": 1966,
			"dm": 11,
			"dd": 11,
			"by": 1937,
			"bd": 10,
			"bm": 11,
			"nm": "",
			"nf": "Victoria",
			"nl": "Arrington",
			"url": "https://www.findagrave.com/memorial/145167317/victoria-arrington",
			"id": 145167317,
			"lng": -77.38620841,
			"lat": 37.53713679,
			"n": "This person has another marker in a different section of the cemetery.",
			"t": "Duplicate"
		},
		{
			"dy": 1965,
			"dm": 6,
			"dd": 25,
			"by": 1963,
			"bd": 28,
			"bm": 12,
			"nm": "",
			"nf": "Kelvin",
			"nl": "Moore",
			"url": "https://www.findagrave.com/memorial/144558536/kelvin-moore",
			"id": 144558536,
			"lng": -77.38607169,
			"lat": 37.53744495,
			"n": "This person has another marker in a different section of the cemetery.",
			"t": "Duplicate"
		}
	];

/***/ },
/* 187 */
/***/ function(module, exports) {

	module.exports = {
		"type": "Polygon",
		"coordinates": [
			[
				[
					0,
					90
				],
				[
					180,
					90
				],
				[
					180,
					-90
				],
				[
					0,
					-90
				],
				[
					-180,
					-90
				],
				[
					-180,
					0
				],
				[
					-180,
					90
				],
				[
					0,
					90
				]
			],
			[
				[
					-77.38616777122564,
					37.535453001554856
				],
				[
					-77.3860817411794,
					37.53567260610595
				],
				[
					-77.38593449877806,
					37.536066044212646
				],
				[
					-77.3856653739578,
					37.53677076016248
				],
				[
					-77.38553327703909,
					37.53707301600696
				],
				[
					-77.38543660171774,
					37.53731243352206
				],
				[
					-77.38543530579472,
					37.53736879043737
				],
				[
					-77.38545578155902,
					37.537415953583434
				],
				[
					-77.38549673308773,
					37.53745615777552
				],
				[
					-77.38563518821331,
					37.53755357683616
				],
				[
					-77.38578339468785,
					37.537643263525865
				],
				[
					-77.3858409216212,
					37.537670324126225
				],
				[
					-77.38595207602742,
					37.53770743554975
				],
				[
					-77.38611490817641,
					37.537745320390286
				],
				[
					-77.38622411195314,
					37.537775473759154
				],
				[
					-77.3864113193269,
					37.53781181176578
				],
				[
					-77.38656147553161,
					37.53785820149483
				],
				[
					-77.38666190462317,
					37.53790845651014
				],
				[
					-77.38678183461394,
					37.53799118424581
				],
				[
					-77.38684813713178,
					37.53806154180677
				],
				[
					-77.38687251325587,
					37.538081643453154
				],
				[
					-77.38696611739238,
					37.538202256029365
				],
				[
					-77.38700316856136,
					37.53823627468438
				],
				[
					-77.3870402197303,
					37.53824941827611
				],
				[
					-77.38707824666369,
					37.53825251104462
				],
				[
					-77.3872147520591,
					37.53822313109265
				],
				[
					-77.38744358185579,
					37.538180317967374
				],
				[
					-77.387634018695,
					37.5381537403029
				],
				[
					-77.38786863742763,
					37.53811145867695
				],
				[
					-77.38810630306341,
					37.53806072072575
				],
				[
					-77.38817181417784,
					37.53804864013267
				],
				[
					-77.3883805333349,
					37.53798823716744
				],
				[
					-77.38868827954042,
					37.53785293416564
				],
				[
					-77.38888176418203,
					37.5377393767709
				],
				[
					-77.38902802002707,
					37.53761736215159
				],
				[
					-77.38915447010265,
					37.53752313298622
				],
				[
					-77.38924740424426,
					37.53743615235658
				],
				[
					-77.38931443791097,
					37.537364876587844
				],
				[
					-77.38937537777144,
					37.53729239213027
				],
				[
					-77.38942321540901,
					37.53722962125005
				],
				[
					-77.38950280001416,
					37.53709928160663
				],
				[
					-77.3895626930638,
					37.537014012386805
				],
				[
					-77.3896315424617,
					37.53689060561703
				],
				[
					-77.38969347607303,
					37.53676489658278
				],
				[
					-77.38974837338867,
					37.53663713079902
				],
				[
					-77.38979612559069,
					37.536507558277265
				],
				[
					-77.38983664184752,
					37.53637643172698
				],
				[
					-77.38989498086863,
					37.53622470260797
				],
				[
					-77.38996080764514,
					37.53607492951443
				],
				[
					-77.39003401965425,
					37.53592734537074
				],
				[
					-77.38968344233695,
					37.53584441169028
				],
				[
					-77.38893554453972,
					37.535786731872236
				],
				[
					-77.38840749770782,
					37.53561880236589
				],
				[
					-77.38627995625495,
					37.53512034233
				],
				[
					-77.38616777122564,
					37.535453001554856
				]
			]
		]
	};

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2016 Dominik Moritz
	
	This file is part of the leaflet locate control. It is licensed under the MIT license.
	You can find the project at: https://github.com/domoritz/leaflet-locatecontrol
	*/
	(function (factory, window) {
	     // see https://github.com/Leaflet/Leaflet/blob/master/PLUGIN-GUIDE.md#module-loaders
	     // for details on how to structure a leaflet plugin.
	
	    // define an AMD module that relies on 'leaflet'
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	    // define a Common JS module that relies on 'leaflet'
	    } else if (typeof exports === 'object') {
	        if (typeof window !== 'undefined' && window.L) {
	            module.exports = factory(L);
	        } else {
	            module.exports = factory(require('leaflet'));
	        }
	    }
	
	    // attach your plugin to the global 'L' variable
	    if (typeof window !== 'undefined' && window.L){
	        window.L.Control.Locate = factory(L);
	    }
	} (function (L) {
	    var LDomUtilApplyClassesMethod = function(method, element, classNames) {
	        classNames = classNames.split(' ');
	        classNames.forEach(function(className) {
	            L.DomUtil[method].call(this, element, className);
	        });
	    };
	
	    var addClasses = function(el, names) { LDomUtilApplyClassesMethod('addClass', el, names); };
	    var removeClasses = function(el, names) { LDomUtilApplyClassesMethod('removeClass', el, names); };
	
	    /**
	     * Compatible with L.Circle but a true marker instead of a path
	     */
	    var LocationMarker = L.Marker.extend({
	        initialize: function (latlng, options) {
	            L.Util.setOptions(this, options);
	            this._latlng = latlng;
	            this.createIcon();
	        },
	
	        /**
	         * Create a styled circle location marker
	         */
	        createIcon: function() {
	            var opt = this.options;
	
	            var style = '';
	
	            if (opt.color !== undefined) {
	                style += 'stroke:'+opt.color+';';
	            }
	            if (opt.weight !== undefined) {
	                style += 'stroke-width:'+opt.weight+';';
	            }
	            if (opt.fillColor !== undefined) {
	                style += 'fill:'+opt.fillColor+';';
	            }
	            if (opt.fillOpacity !== undefined) {
	                style += 'fill-opacity:'+opt.fillOpacity+';';
	            }
	            if (opt.opacity !== undefined) {
	                style += 'opacity:'+opt.opacity+';';
	            }
	
	            var icon = this._getIconSVG(opt, style);
	
	            this._locationIcon = L.divIcon({
	                className: icon.className,
	                html: icon.svg,
	                iconSize: [icon.w,icon.h],
	            });
	
	            this.setIcon(this._locationIcon);
	        },
	
	        /**
	         * Return the raw svg for the shape
	         *
	         * Split so can be easily overridden
	         */
	        _getIconSVG: function(options, style) {
	            var r = options.radius;
	            var w = options.weight;
	            var s = r + w;
	            var s2 = s * 2;
	            var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="'+s2+'" height="'+s2+'" version="1.1" viewBox="-'+s+' -'+s+' '+s2+' '+s2+'">' +
	            '<circle r="'+r+'" style="'+style+'" />' +
	            '</svg>';
	            return {
	                className: 'leaflet-control-locate-location',
	                svg: svg,
	                w: s2,
	                h: s2
	            };
	        },
	
	        setStyle: function(style) {
	            L.Util.setOptions(this, style);
	            this.createIcon();
	        }
	    });
	
	    var CompassMarker = LocationMarker.extend({
	        initialize: function (latlng, heading, options) {
	            L.Util.setOptions(this, options);
	            this._latlng = latlng;
	            this._heading = heading;
	            this.createIcon();
	        },
	
	        setHeading: function(heading) {
	            this._heading = heading;
	        },
	
	        /**
	         * Create a styled arrow compass marker
	         */
	        _getIconSVG: function(options, style) {
	            var r = options.radius;
	            var w = (options.width + options.weight);
	            var h = (r+options.depth + options.weight)*2;
	            var path = 'M0,0 l'+(options.width/2)+','+options.depth+' l-'+(w)+',0 z';
	            var svgstyle = 'transform: rotate('+this._heading+'deg)';
	            var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="'+(w)+'" height="'+h+'" version="1.1" viewBox="-'+(w/2)+' 0 '+w+' '+h+'" style="'+svgstyle+'">'+
	            '<path d="'+path+'" style="'+style+'" />'+
	            '</svg>';
	            return {
	                className: 'leaflet-control-locate-heading',
	                svg: svg,
	                w: w,
	                h: h
	            };
	        },
	    });
	
	
	    var LocateControl = L.Control.extend({
	        options: {
	            /** Position of the control */
	            position: 'topleft',
	            /** The layer that the user's location should be drawn on. By default creates a new layer. */
	            layer: undefined,
	            /**
	             * Automatically sets the map view (zoom and pan) to the user's location as it updates.
	             * While the map is following the user's location, the control is in the `following` state,
	             * which changes the style of the control and the circle marker.
	             *
	             * Possible values:
	             *  - false: never updates the map view when location changes.
	             *  - 'once': set the view when the location is first determined
	             *  - 'always': always updates the map view when location changes.
	             *              The map view follows the user's location.
	             *  - 'untilPan': like 'always', except stops updating the
	             *                view if the user has manually panned the map.
	             *                The map view follows the user's location until she pans.
	             *  - 'untilPanOrZoom': (default) like 'always', except stops updating the
	             *                view if the user has manually panned the map.
	             *                The map view follows the user's location until she pans.
	             */
	            setView: 'untilPanOrZoom',
	            /** Keep the current map zoom level when setting the view and only pan. */
	            keepCurrentZoomLevel: false,
		    /** After activating the plugin by clicking on the icon, zoom to the selected zoom level, even when keepCurrentZoomLevel is true. Set to 'false' to disable this feature. */
		    initialZoomLevel: false,
	            /**
	             * This callback can be used to override the viewport tracking
	             * This function should return a LatLngBounds object.
	             *
	             * For example to extend the viewport to ensure that a particular LatLng is visible:
	             *
	             * getLocationBounds: function(locationEvent) {
	             *    return locationEvent.bounds.extend([-33.873085, 151.219273]);
	             * },
	             */
	            getLocationBounds: function (locationEvent) {
	                return locationEvent.bounds;
	            },
	            /** Smooth pan and zoom to the location of the marker. Only works in Leaflet 1.0+. */
	            flyTo: false,
	            /**
	             * The user location can be inside and outside the current view when the user clicks on the
	             * control that is already active. Both cases can be configures separately.
	             * Possible values are:
	             *  - 'setView': zoom and pan to the current location
	             *  - 'stop': stop locating and remove the location marker
	             */
	            clickBehavior: {
	                /** What should happen if the user clicks on the control while the location is within the current view. */
	                inView: 'stop',
	                /** What should happen if the user clicks on the control while the location is outside the current view. */
	                outOfView: 'setView',
	                /**
	                 * What should happen if the user clicks on the control while the location is within the current view
	                 * and we could be following but are not. Defaults to a special value which inherits from 'inView';
	                 */
	                inViewNotFollowing: 'inView',
	            },
	            /**
	             * If set, save the map bounds just before centering to the user's
	             * location. When control is disabled, set the view back to the
	             * bounds that were saved.
	             */
	            returnToPrevBounds: false,
	            /**
	             * Keep a cache of the location after the user deactivates the control. If set to false, the user has to wait
	             * until the locate API returns a new location before they see where they are again.
	             */
	            cacheLocation: true,
	            /** If set, a circle that shows the location accuracy is drawn. */
	            drawCircle: true,
	            /** If set, the marker at the users' location is drawn. */
	            drawMarker: true,
	            /** If set and supported then show the compass heading */
	            showCompass: true,
	            /** The class to be used to create the marker. For example L.CircleMarker or L.Marker */
	            markerClass: LocationMarker,
	            /** The class us be used to create the compass bearing arrow */
	            compassClass: CompassMarker,
	            /** Accuracy circle style properties. NOTE these styles should match the css animations styles */
	            circleStyle: {
	                className:   'leaflet-control-locate-circle',
	                color:       '#136AEC',
	                fillColor:   '#136AEC',
	                fillOpacity: 0.15,
	                weight:      0
	            },
	            /** Inner marker style properties. Only works if your marker class supports `setStyle`. */
	            markerStyle: {
	                className:   'leaflet-control-locate-marker',
	                color:       '#fff',
	                fillColor:   '#2A93EE',
	                fillOpacity: 1,
	                weight:      3,
	                opacity:     1,
	                radius:      9
	            },
	            /** Compass */
	            compassStyle: {
	                fillColor:   '#2A93EE',
	                fillOpacity: 1,
	                weight:      0,
	                color:       '#fff',
	                opacity:     1,
	                radius:      9, // How far is the arrow is from the center of of the marker
	                width:       9, // Width of the arrow
	                depth:       6  // Length of the arrow
	            },
	            /**
	             * Changes to accuracy circle and inner marker while following.
	             * It is only necessary to provide the properties that should change.
	             */
	            followCircleStyle: {},
	            followMarkerStyle: {
	                // color: '#FFA500',
	                // fillColor: '#FFB000'
	            },
	            followCompassStyle: {},
	            /** The CSS class for the icon. For example fa-location-arrow or fa-map-marker */
	            icon: 'fa fa-map-marker',
	            iconLoading: 'fa fa-spinner fa-spin',
	            /** The element to be created for icons. For example span or i */
	            iconElementTag: 'span',
	            /** Padding around the accuracy circle. */
	            circlePadding: [0, 0],
	            /** Use metric units. */
	            metric: true,
	            /**
	             * This callback can be used in case you would like to override button creation behavior.
	             * This is useful for DOM manipulation frameworks such as angular etc.
	             * This function should return an object with HtmlElement for the button (link property) and the icon (icon property).
	             */
	            createButtonCallback: function (container, options) {
	                var link = L.DomUtil.create('a', 'leaflet-bar-part leaflet-bar-part-single', container);
	                link.title = options.strings.title;
	                var icon = L.DomUtil.create(options.iconElementTag, options.icon, link);
	                return { link: link, icon: icon };
	            },
	            /** This event is called in case of any location error that is not a time out error. */
	            onLocationError: function(err, control) {
	                alert(err.message);
	            },
	            /**
	             * This event is called when the user's location is outside the bounds set on the map.
	             * The event is called repeatedly when the location changes.
	             */
	            onLocationOutsideMapBounds: function(control) {
	                control.stop();
	                alert(control.options.strings.outsideMapBoundsMsg);
	            },
	            /** Display a pop-up when the user click on the inner marker. */
	            showPopup: true,
	            strings: {
	                title: "Show me where I am",
	                metersUnit: "meters",
	                feetUnit: "feet",
	                popup: "You are within {distance} {unit} from this point",
	                outsideMapBoundsMsg: "You seem located outside the boundaries of the map"
	            },
	            /** The default options passed to leaflets locate method. */
	            locateOptions: {
	                maxZoom: Infinity,
	                watch: true,  // if you overwrite this, visualization cannot be updated
	                setView: false // have to set this to false because we have to
	                               // do setView manually
	            }
	        },
	
	        initialize: function (options) {
	            // set default options if nothing is set (merge one step deep)
	            for (var i in options) {
	                if (typeof this.options[i] === 'object') {
	                    L.extend(this.options[i], options[i]);
	                } else {
	                    this.options[i] = options[i];
	                }
	            }
	
	            // extend the follow marker style and circle from the normal style
	            this.options.followMarkerStyle = L.extend({}, this.options.markerStyle, this.options.followMarkerStyle);
	            this.options.followCircleStyle = L.extend({}, this.options.circleStyle, this.options.followCircleStyle);
	            this.options.followCompassStyle = L.extend({}, this.options.compassStyle, this.options.followCompassStyle);
	        },
	
	        /**
	         * Add control to map. Returns the container for the control.
	         */
	        onAdd: function (map) {
	            var container = L.DomUtil.create('div',
	                'leaflet-control-locate leaflet-bar leaflet-control');
	            this._container = container;
	            this._map = map;
	            this._layer = this.options.layer || new L.LayerGroup();
	            this._layer.addTo(map);
	            this._event = undefined;
	            this._compassHeading = null;
	            this._prevBounds = null;
	
	            var linkAndIcon = this.options.createButtonCallback(container, this.options);
	            this._link = linkAndIcon.link;
	            this._icon = linkAndIcon.icon;
	
	            L.DomEvent
	                .on(this._link, 'click', L.DomEvent.stopPropagation)
	                .on(this._link, 'click', L.DomEvent.preventDefault)
	                .on(this._link, 'click', this._onClick, this)
	                .on(this._link, 'dblclick', L.DomEvent.stopPropagation);
	
	            this._resetVariables();
	
	            this._map.on('unload', this._unload, this);
	
	            return container;
	        },
	
	        /**
	         * This method is called when the user clicks on the control.
	         */
	        _onClick: function() {
	            this._justClicked = true;
	            var wasFollowing =  this._isFollowing();
	            this._userPanned = false;
	            this._userZoomed = false;
	
	            if (this._active && !this._event) {
	                // click while requesting
	                this.stop();
	            } else if (this._active && this._event !== undefined) {
	                var behaviors = this.options.clickBehavior;
	                var behavior = behaviors.outOfView;
	                if (this._map.getBounds().contains(this._event.latlng)) {
	                    behavior = wasFollowing ? behaviors.inView : behaviors.inViewNotFollowing;
	                }
	
	                // Allow inheriting from another behavior
	                if (behaviors[behavior]) {
	                    behavior = behaviors[behavior];
	                }
	
	                switch (behavior) {
	                    case 'setView':
	                        this.setView();
	                        break;
	                    case 'stop':
	                        this.stop();
	                        if (this.options.returnToPrevBounds) {
	                            var f = this.options.flyTo ? this._map.flyToBounds : this._map.fitBounds;
	                            f.bind(this._map)(this._prevBounds);
	                        }
	                        break;
	                }
	            } else {
	                if (this.options.returnToPrevBounds) {
	                  this._prevBounds = this._map.getBounds();
	                }
	                this.start();
	            }
	
	            this._updateContainerStyle();
	        },
	
	        /**
	         * Starts the plugin:
	         * - activates the engine
	         * - draws the marker (if coordinates available)
	         */
	        start: function() {
	            this._activate();
	
	            if (this._event) {
	                this._drawMarker(this._map);
	
	                // if we already have a location but the user clicked on the control
	                if (this.options.setView) {
	                    this.setView();
	                }
	            }
	            this._updateContainerStyle();
	        },
	
	        /**
	         * Stops the plugin:
	         * - deactivates the engine
	         * - reinitializes the button
	         * - removes the marker
	         */
	        stop: function() {
	            this._deactivate();
	
	            this._cleanClasses();
	            this._resetVariables();
	
	            this._removeMarker();
	        },
	
	        /**
	         * Keep the control active but stop following the location
	         */
	        stopFollowing: function() {
	            this._userPanned = true;
	            this._updateContainerStyle();
	            this._drawMarker();
	        },
	
	        /**
	         * This method launches the location engine.
	         * It is called before the marker is updated,
	         * event if it does not mean that the event will be ready.
	         *
	         * Override it if you want to add more functionalities.
	         * It should set the this._active to true and do nothing if
	         * this._active is true.
	         */
	        _activate: function() {
	            if (!this._active) {
	                this._map.locate(this.options.locateOptions);
	                this._active = true;
	
	                // bind event listeners
	                this._map.on('locationfound', this._onLocationFound, this);
	                this._map.on('locationerror', this._onLocationError, this);
	                this._map.on('dragstart', this._onDrag, this);
	                this._map.on('zoomstart', this._onZoom, this);
	                this._map.on('zoomend', this._onZoomEnd, this);
	                if (this.options.showCompass) {
	                    var oriAbs = 'ondeviceorientationabsolute' in window;
	                    if (oriAbs || ('ondeviceorientation' in window)) {
	                        var _this = this;
	                        var deviceorientation = function () {
	                            L.DomEvent.on(window, oriAbs ? 'deviceorientationabsolute' : 'deviceorientation', _this._onDeviceOrientation, _this);
	                        };
	                        if (DeviceOrientationEvent && typeof DeviceOrientationEvent.requestPermission === 'function') {
	                            DeviceOrientationEvent.requestPermission().then(function (permissionState) {
	                                if (permissionState === 'granted') {
	                                    deviceorientation();
	                                }
	                            })
	                        } else {
	                            deviceorientation();
	                        }
	                    }
	                }
	            }
	        },
	
	        /**
	         * Called to stop the location engine.
	         *
	         * Override it to shutdown any functionalities you added on start.
	         */
	        _deactivate: function() {
	            this._map.stopLocate();
	            this._active = false;
	
	            if (!this.options.cacheLocation) {
	                this._event = undefined;
	            }
	
	            // unbind event listeners
	            this._map.off('locationfound', this._onLocationFound, this);
	            this._map.off('locationerror', this._onLocationError, this);
	            this._map.off('dragstart', this._onDrag, this);
	            this._map.off('zoomstart', this._onZoom, this);
	            this._map.off('zoomend', this._onZoomEnd, this);
	            if (this.options.showCompass) {
	                this._compassHeading = null;
	                if ('ondeviceorientationabsolute' in window) {
	                    L.DomEvent.off(window, 'deviceorientationabsolute', this._onDeviceOrientation, this);
	                } else if ('ondeviceorientation' in window) {
	                    L.DomEvent.off(window, 'deviceorientation', this._onDeviceOrientation, this);
	                }
	            }
	        },
	
	        /**
	         * Zoom (unless we should keep the zoom level) and an to the current view.
	         */
	        setView: function() {
	            this._drawMarker();
	            if (this._isOutsideMapBounds()) {
	                this._event = undefined;  // clear the current location so we can get back into the bounds
	                this.options.onLocationOutsideMapBounds(this);
	            } else {
			if (this._justClicked && this.options.initialZoomLevel !== false) {
	                    var f = this.options.flyTo ? this._map.flyTo : this._map.setView;
	                    f.bind(this._map)([this._event.latitude, this._event.longitude], this.options.initialZoomLevel);
			} else
	                if (this.options.keepCurrentZoomLevel) {
	                    var f = this.options.flyTo ? this._map.flyTo : this._map.panTo;
	                    f.bind(this._map)([this._event.latitude, this._event.longitude]);
	                } else {
	                    var f = this.options.flyTo ? this._map.flyToBounds : this._map.fitBounds;
	                    // Ignore zoom events while setting the viewport as these would stop following
	                    this._ignoreEvent = true;
	                    f.bind(this._map)(this.options.getLocationBounds(this._event), {
	                        padding: this.options.circlePadding,
	                        maxZoom: this.options.locateOptions.maxZoom
	                    });
	                    L.Util.requestAnimFrame(function(){
	                        // Wait until after the next animFrame because the flyTo can be async
	                        this._ignoreEvent = false;
	                    }, this);
	
	                }
	            }
	        },
	
	        /**
	         *
	         */
	        _drawCompass: function() {
	            if (!this._event) {
	                return;
	            }
	
	            var latlng = this._event.latlng;
	
	            if (this.options.showCompass && latlng && this._compassHeading !== null) {
	                var cStyle = this._isFollowing() ? this.options.followCompassStyle : this.options.compassStyle;
	                if (!this._compass) {
	                    this._compass = new this.options.compassClass(latlng, this._compassHeading, cStyle).addTo(this._layer);
	                } else {
	                    this._compass.setLatLng(latlng);
	                    this._compass.setHeading(this._compassHeading);
	                    // If the compassClass can be updated with setStyle, update it.
	                    if (this._compass.setStyle) {
	                        this._compass.setStyle(cStyle);
	                    }
	                }
	                // 
	            }
	            if (this._compass && (!this.options.showCompass || this._compassHeading === null)) {
	                this._compass.removeFrom(this._layer);
	                this._compass = null;
	            }
	        },
	
	        /**
	         * Draw the marker and accuracy circle on the map.
	         *
	         * Uses the event retrieved from onLocationFound from the map.
	         */
	        _drawMarker: function() {
	            if (this._event.accuracy === undefined) {
	                this._event.accuracy = 0;
	            }
	
	            var radius = this._event.accuracy;
	            var latlng = this._event.latlng;
	
	            // circle with the radius of the location's accuracy
	            if (this.options.drawCircle) {
	                var style = this._isFollowing() ? this.options.followCircleStyle : this.options.circleStyle;
	
	                if (!this._circle) {
	                    this._circle = L.circle(latlng, radius, style).addTo(this._layer);
	                } else {
	                    this._circle.setLatLng(latlng).setRadius(radius).setStyle(style);
	                }
	            }
	
	            var distance, unit;
	            if (this.options.metric) {
	                distance = radius.toFixed(0);
	                unit =  this.options.strings.metersUnit;
	            } else {
	                distance = (radius * 3.2808399).toFixed(0);
	                unit = this.options.strings.feetUnit;
	            }
	
	            // small inner marker
	            if (this.options.drawMarker) {
	                var mStyle = this._isFollowing() ? this.options.followMarkerStyle : this.options.markerStyle;
	                if (!this._marker) {
	                    this._marker = new this.options.markerClass(latlng, mStyle).addTo(this._layer);
	                } else {
	                    this._marker.setLatLng(latlng);
	                    // If the markerClass can be updated with setStyle, update it.
	                    if (this._marker.setStyle) {
	                        this._marker.setStyle(mStyle);
	                    }
	                }
	            }
	
	            this._drawCompass();
	
	            var t = this.options.strings.popup;
	            function getPopupText() {
	                if (typeof t === 'string') {
	                    return L.Util.template(t, {distance: distance, unit: unit});
	                } else if (typeof t === 'function') {
	                    return t({distance: distance, unit: unit});
	                } else {
	                    return t;
	                }
	            }
	            if (this.options.showPopup && t && this._marker) {
	                this._marker
	                    .bindPopup(getPopupText())
	                    ._popup.setLatLng(latlng);
	            }
	            if (this.options.showPopup && t && this._compass) {
	                this._compass
	                    .bindPopup(getPopupText())
	                    ._popup.setLatLng(latlng);
	            }
	        },
	
	        /**
	         * Remove the marker from map.
	         */
	        _removeMarker: function() {
	            this._layer.clearLayers();
	            this._marker = undefined;
	            this._circle = undefined;
	        },
	
	        /**
	         * Unload the plugin and all event listeners.
	         * Kind of the opposite of onAdd.
	         */
	        _unload: function() {
	            this.stop();
	            this._map.off('unload', this._unload, this);
	        },
	
	        /**
	         * Sets the compass heading
	         */
	        _setCompassHeading: function(angle) {
	            if (!isNaN(parseFloat(angle)) && isFinite(angle)) {
	                angle = Math.round(angle);
	
	                this._compassHeading = angle;
	                L.Util.requestAnimFrame(this._drawCompass, this);
	            } else {
	                this._compassHeading = null;
	            }
	        },
	
	        /**
	         * If the compass fails calibration just fail safely and remove the compass
	         */
	        _onCompassNeedsCalibration: function() {
	            this._setCompassHeading();
	        },
	
	        /**
	         * Process and normalise compass events
	         */
	        _onDeviceOrientation: function(e) {
	            if (!this._active) {
	                return;
	            }
	
	            if (e.webkitCompassHeading) {
	                // iOS
	                this._setCompassHeading(e.webkitCompassHeading);
	            } else if (e.absolute && e.alpha) {
	                // Android
	                this._setCompassHeading(360 - e.alpha)
	            }
	        },
	
	        /**
	         * Calls deactivate and dispatches an error.
	         */
	        _onLocationError: function(err) {
	            // ignore time out error if the location is watched
	            if (err.code == 3 && this.options.locateOptions.watch) {
	                return;
	            }
	
	            this.stop();
	            this.options.onLocationError(err, this);
	        },
	
	        /**
	         * Stores the received event and updates the marker.
	         */
	        _onLocationFound: function(e) {
	            // no need to do anything if the location has not changed
	            if (this._event &&
	                (this._event.latlng.lat === e.latlng.lat &&
	                 this._event.latlng.lng === e.latlng.lng &&
	                     this._event.accuracy === e.accuracy)) {
	                return;
	            }
	
	            if (!this._active) {
	                // we may have a stray event
	                return;
	            }
	
	            this._event = e;
	
	            this._drawMarker();
	            this._updateContainerStyle();
	
	            switch (this.options.setView) {
	                case 'once':
	                    if (this._justClicked) {
	                        this.setView();
	                    }
	                    break;
	                case 'untilPan':
	                    if (!this._userPanned) {
	                        this.setView();
	                    }
	                    break;
	                case 'untilPanOrZoom':
	                    if (!this._userPanned && !this._userZoomed) {
	                        this.setView();
	                    }
	                    break;
	                case 'always':
	                    this.setView();
	                    break;
	                case false:
	                    // don't set the view
	                    break;
	            }
	
	            this._justClicked = false;
	        },
	
	        /**
	         * When the user drags. Need a separate event so we can bind and unbind event listeners.
	         */
	        _onDrag: function() {
	            // only react to drags once we have a location
	            if (this._event && !this._ignoreEvent) {
	                this._userPanned = true;
	                this._updateContainerStyle();
	                this._drawMarker();
	            }
	        },
	
	        /**
	         * When the user zooms. Need a separate event so we can bind and unbind event listeners.
	         */
	        _onZoom: function() {
	            // only react to drags once we have a location
	            if (this._event && !this._ignoreEvent) {
	                this._userZoomed = true;
	                this._updateContainerStyle();
	                this._drawMarker();
	            }
	        },
	
	        /**
	         * After a zoom ends update the compass and handle sideways zooms
	         */
	        _onZoomEnd: function() {
	            if (this._event) {
	                this._drawCompass();
	            }
	
	            if (this._event && !this._ignoreEvent) {
	                // If we have zoomed in and out and ended up sideways treat it as a pan
	                if (this._marker && !this._map.getBounds().pad(-.3).contains(this._marker.getLatLng())) {
	                    this._userPanned = true;
	                    this._updateContainerStyle();
	                    this._drawMarker();
	                }
	            }
	        },
	
	        /**
	         * Compute whether the map is following the user location with pan and zoom.
	         */
	        _isFollowing: function() {
	            if (!this._active) {
	                return false;
	            }
	
	            if (this.options.setView === 'always') {
	                return true;
	            } else if (this.options.setView === 'untilPan') {
	                return !this._userPanned;
	            } else if (this.options.setView === 'untilPanOrZoom') {
	                return !this._userPanned && !this._userZoomed;
	            }
	        },
	
	        /**
	         * Check if location is in map bounds
	         */
	        _isOutsideMapBounds: function() {
	            if (this._event === undefined) {
	                return false;
	            }
	            return this._map.options.maxBounds &&
	                !this._map.options.maxBounds.contains(this._event.latlng);
	        },
	
	        /**
	         * Toggles button class between following and active.
	         */
	        _updateContainerStyle: function() {
	            if (!this._container) {
	                return;
	            }
	
	            if (this._active && !this._event) {
	                // active but don't have a location yet
	                this._setClasses('requesting');
	            } else if (this._isFollowing()) {
	                this._setClasses('following');
	            } else if (this._active) {
	                this._setClasses('active');
	            } else {
	                this._cleanClasses();
	            }
	        },
	
	        /**
	         * Sets the CSS classes for the state.
	         */
	        _setClasses: function(state) {
	            if (state == 'requesting') {
	                removeClasses(this._container, "active following");
	                addClasses(this._container, "requesting");
	
	                removeClasses(this._icon, this.options.icon);
	                addClasses(this._icon, this.options.iconLoading);
	            } else if (state == 'active') {
	                removeClasses(this._container, "requesting following");
	                addClasses(this._container, "active");
	
	                removeClasses(this._icon, this.options.iconLoading);
	                addClasses(this._icon, this.options.icon);
	            } else if (state == 'following') {
	                removeClasses(this._container, "requesting");
	                addClasses(this._container, "active following");
	
	                removeClasses(this._icon, this.options.iconLoading);
	                addClasses(this._icon, this.options.icon);
	            }
	        },
	
	        /**
	         * Removes all classes from button.
	         */
	        _cleanClasses: function() {
	            L.DomUtil.removeClass(this._container, "requesting");
	            L.DomUtil.removeClass(this._container, "active");
	            L.DomUtil.removeClass(this._container, "following");
	
	            removeClasses(this._icon, this.options.iconLoading);
	            addClasses(this._icon, this.options.icon);
	        },
	
	        /**
	         * Reinitializes state variables.
	         */
	        _resetVariables: function() {
	            // whether locate is active or not
	            this._active = false;
	
	            // true if the control was clicked for the first time
	            // we need this so we can pan and zoom once we have the location
	            this._justClicked = false;
	
	            // true if the user has panned the map after clicking the control
	            this._userPanned = false;
	
	            // true if the user has zoomed the map after clicking the control
	            this._userZoomed = false;
	        }
	    });
	
	    L.control.locate = function (options) {
	        return new L.Control.Locate(options);
	    };
	
	    return LocateControl;
	}, window));


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(76);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(76);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(192);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 192 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.9.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(2),m=__webpack_require__(51),q=__webpack_require__(236);function t(a){for(var b=a.message,c="https://reactjs.org/docs/error-decoder.html?invariant="+b,d=1;d<arguments.length;d++)c+="&args[]="+encodeURIComponent(arguments[d]);a.message="Minified React error #"+b+"; visit "+c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}if(!aa)throw t(Error(227));var ba=null,ca={};
	function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw t(Error(96),a);if(!ea[c]){if(!b.extractEvents)throw t(Error(97),a);ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;if(fa.hasOwnProperty(g))throw t(Error(99),g);fa[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],h,g);e=!0}else f.registrationName?(ha(f.registrationName,h,g),e=!0):e=!1;if(!e)throw t(Error(98),d,a);}}}}
	function ha(a,b,c){if(ia[a])throw t(Error(100),a);ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,h,g,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(n){this.onError(n)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,h,g,k){la=!1;ma=null;ka.apply(pa,arguments)}
	function ra(a,b,c,d,e,f,h,g,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw t(Error(198));na||(na=!0,oa=l)}}var sa=null,ta=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw t(Error(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
	function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw t(Error(95));if(na)throw a=oa,na=!1,oa=null,a;}}
	var Ca={injectEventPluginOrder:function(a){if(ba)throw t(Error(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw t(Error(102),c);ca[c]=d;b=!0}}b&&da()}};
	function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw t(Error(231),b,typeof c);
	return c}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;throw t(Error(33));}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Ma(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}
	function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement);
	function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
	Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
	var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),ab=Wa("transitionend"),bb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),cb=null,db=null,eb=null;
	function fb(){if(eb)return eb;var a,b=db,c=b.length,d,e="value"in cb?cb.value:cb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);return eb=e.slice(a,1<d?1-d:void 0)}function gb(){return!0}function hb(){return!1}
	function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?gb:hb;this.isPropagationStopped=hb;return this}
	m(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=gb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=gb)},persist:function(){this.isPersistent=gb},isPersistent:hb,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=hb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;m(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=m({},d.Interface,a);c.extend=d.extend;ib(c);return c};ib(y);function jb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function kb(a){if(!(a instanceof this))throw t(Error(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function ib(a){a.eventPool=[];a.getPooled=jb;a.release=kb}var lb=y.extend({data:null}),mb=y.extend({data:null}),nb=[9,13,27,32],ob=Ra&&"CompositionEvent"in window,pb=null;Ra&&"documentMode"in document&&(pb=document.documentMode);
	var qb=Ra&&"TextEvent"in window&&!pb,sb=Ra&&(!ob||pb&&8<pb&&11>=pb),tb=String.fromCharCode(32),ub={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},vb=!1;
	function wb(a,b){switch(a){case "keyup":return-1!==nb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function xb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var yb=!1;function Ab(a,b){switch(a){case "compositionend":return xb(b);case "keypress":if(32!==b.which)return null;vb=!0;return tb;case "textInput":return a=b.data,a===tb&&vb?null:a;default:return null}}
	function Bb(a,b){if(yb)return"compositionend"===a||!ob&&wb(a,b)?(a=fb(),eb=db=cb=null,yb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return sb&&"ko"!==b.locale?null:b.data;default:return null}}
	var Cb={eventTypes:ub,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(ob)b:{switch(a){case "compositionstart":e=ub.compositionStart;break b;case "compositionend":e=ub.compositionEnd;break b;case "compositionupdate":e=ub.compositionUpdate;break b}e=void 0}else yb?wb(a,c)&&(e=ub.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=ub.compositionStart);e?(sb&&"ko"!==c.locale&&(yb||e!==ub.compositionStart?e===ub.compositionEnd&&yb&&(f=fb()):(cb=d,db="value"in cb?cb.value:cb.textContent,yb=
	!0)),e=lb.getPooled(e,b,c,d),f?e.data=f:(f=xb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=qb?Ab(a,c):Bb(a,c))?(b=mb.getPooled(ub.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Db=null,Eb=null,Fb=null;function Gb(a){if(a=ta(a)){if("function"!==typeof Db)throw t(Error(280));var b=sa(a.stateNode);Db(a.stateNode,a.type,b)}}function Hb(a){Eb?Fb?Fb.push(a):Fb=[a]:Eb=a}function Ib(){if(Eb){var a=Eb,b=Fb;Fb=Eb=null;Gb(a);if(b)for(a=0;a<b.length;a++)Gb(b[a])}}
	function Jb(a,b){return a(b)}function Kb(a,b,c,d){return a(b,c,d)}function Lb(){}var Mb=Jb,Nb=!1;function Ob(){if(null!==Eb||null!==Fb)Lb(),Ib()}var Pb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Qb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Pb[a.type]:"textarea"===b?!0:!1}
	function Rb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Sb(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Tb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Ub(a){var b=Tb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function Vb(a){a._valueTracker||(a._valueTracker=Ub(a))}function Wb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Tb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Xb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Xb.hasOwnProperty("ReactCurrentDispatcher")||(Xb.ReactCurrentDispatcher={current:null});Xb.hasOwnProperty("ReactCurrentBatchConfig")||(Xb.ReactCurrentBatchConfig={suspense:null});
	var Yb=/^(.*)[\\\/]/,B="function"===typeof Symbol&&Symbol.for,Zb=B?Symbol.for("react.element"):60103,$b=B?Symbol.for("react.portal"):60106,ac=B?Symbol.for("react.fragment"):60107,bc=B?Symbol.for("react.strict_mode"):60108,cc=B?Symbol.for("react.profiler"):60114,dc=B?Symbol.for("react.provider"):60109,ec=B?Symbol.for("react.context"):60110,fc=B?Symbol.for("react.concurrent_mode"):60111,gc=B?Symbol.for("react.forward_ref"):60112,hc=B?Symbol.for("react.suspense"):60113,ic=B?Symbol.for("react.suspense_list"):
	60120,jc=B?Symbol.for("react.memo"):60115,kc=B?Symbol.for("react.lazy"):60116;B&&Symbol.for("react.fundamental");B&&Symbol.for("react.responder");var lc="function"===typeof Symbol&&Symbol.iterator;function mc(a){if(null===a||"object"!==typeof a)return null;a=lc&&a[lc]||a["@@iterator"];return"function"===typeof a?a:null}
	function oc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ac:return"Fragment";case $b:return"Portal";case cc:return"Profiler";case bc:return"StrictMode";case hc:return"Suspense";case ic:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case ec:return"Context.Consumer";case dc:return"Context.Provider";case gc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jc:return oc(a.type);case kc:if(a=1===a._status?a._result:null)return oc(a)}return null}function pc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=oc(a.type);c=null;d&&(c=oc(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Yb,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	var qc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,rc=Object.prototype.hasOwnProperty,sc={},tc={};
	function uc(a){if(rc.call(tc,a))return!0;if(rc.call(sc,a))return!1;if(qc.test(a))return tc[a]=!0;sc[a]=!0;return!1}function vc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function wc(a,b,c,d){if(null===b||"undefined"===typeof b||vc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function D(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var F={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){F[a]=new D(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];F[b]=new D(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){F[a]=new D(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){F[a]=new D(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){F[a]=new D(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){F[a]=new D(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){F[a]=new D(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){F[a]=new D(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){F[a]=new D(a,5,!1,a.toLowerCase(),null,!1)});var xc=/[\-:]([a-z])/g;function yc(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(xc,
	yc);F[b]=new D(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(xc,yc);F[b]=new D(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(xc,yc);F[b]=new D(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){F[a]=new D(a,1,!1,a.toLowerCase(),null,!1)});
	F.xlinkHref=new D("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){F[a]=new D(a,1,!1,a.toLowerCase(),null,!0)});
	function zc(a,b,c,d){var e=F.hasOwnProperty(b)?F[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(wc(b,c,e,d)&&(c=null),d||null===e?uc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function Ac(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Bc(a,b){var c=b.checked;return m({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Cc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Ac(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Dc(a,b){b=b.checked;null!=b&&zc(a,"checked",b,!1)}
	function Ec(a,b){Dc(a,b);var c=Ac(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fc(a,b.type,Ac(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Gc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Fc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Hc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Ic(a,b,c){a=y.getPooled(Hc.change,a,b,c);a.type="change";Hb(c);Qa(a);return a}var Jc=null,Kc=null;function Lc(a){Ba(a)}
	function Mc(a){var b=Ja(a);if(Wb(b))return a}function Nc(a,b){if("change"===a)return b}var Oc=!1;Ra&&(Oc=Sb("input")&&(!document.documentMode||9<document.documentMode));function Pc(){Jc&&(Jc.detachEvent("onpropertychange",Qc),Kc=Jc=null)}function Qc(a){if("value"===a.propertyName&&Mc(Kc))if(a=Ic(Kc,a,Rb(a)),Nb)Ba(a);else{Nb=!0;try{Jb(Lc,a)}finally{Nb=!1,Ob()}}}function Rc(a,b,c){"focus"===a?(Pc(),Jc=b,Kc=c,Jc.attachEvent("onpropertychange",Qc)):"blur"===a&&Pc()}
	function Sc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Mc(Kc)}function Tc(a,b){if("click"===a)return Mc(b)}function Uc(a,b){if("input"===a||"change"===a)return Mc(b)}
	var Vc={eventTypes:Hc,_isInputEventSupported:Oc,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=Nc:Qb(e)?Oc?f=Uc:(f=Sc,h=Rc):(g=e.nodeName)&&"input"===g.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Tc);if(f&&(f=f(a,b)))return Ic(f,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fc(e,"number",e.value)}},Wc=y.extend({view:null,detail:null}),Xc={Alt:"altKey",
	Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Yc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Xc[a])?!!b[a]:!1}function Zc(){return Yc}
	var $c=0,ad=0,bd=!1,cd=!1,dd=Wc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Zc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=$c;$c=a.screenX;return bd?"mousemove"===a.type?a.screenX-b:0:(bd=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=ad;ad=a.screenY;return cd?"mousemove"===a.type?a.screenY-b:0:(cd=!0,0)}}),ed=dd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),fd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},gd={eventTypes:fd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var h=void 0,g=void 0,k=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)h=dd,g=fd.mouseLeave,k=fd.mouseEnter,l="mouse";
	else if("pointerout"===a||"pointerover"===a)h=ed,g=fd.pointerLeave,k=fd.pointerEnter,l="pointer";var n=null==f?e:Ja(f);e=null==b?e:Ja(b);a=h.getPooled(g,f,c,d);a.type=l+"leave";a.target=n;a.relatedTarget=e;c=h.getPooled(k,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=n;d=b;if(f&&d)a:{b=f;e=d;l=0;for(h=b;h;h=La(h))l++;h=0;for(k=e;k;k=La(k))h++;for(;0<l-h;)b=La(b),l--;for(;0<h-l;)e=La(e),h--;for(;l--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
	f.alternate;if(null!==l&&l===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function hd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var id=Object.prototype.hasOwnProperty;
	function jd(a,b){if(hd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!id.call(b,c[d])||!hd(a[c[d]],b[c[d]]))return!1;return!0}function kd(a,b){return{responder:a,props:b}}new Map;new Map;new Set;new Map;
	function ld(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function od(a){if(2!==ld(a))throw t(Error(188));}
	function pd(a){var b=a.alternate;if(!b){b=ld(a);if(3===b)throw t(Error(188));return 1===b?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return od(e),a;if(f===d)return od(e),b;f=f.sibling}throw t(Error(188));}if(c.return!==d.return)c=e,d=f;else{for(var h=!1,g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===
	c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}if(!h)throw t(Error(189));}}if(c.alternate!==d)throw t(Error(190));}if(3!==c.tag)throw t(Error(188));return c.stateNode.current===c?a:b}function qd(a){a=pd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	var rd=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),sd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),td=Wc.extend({relatedTarget:null});function ud(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var vd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},wd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},xd=Wc.extend({key:function(a){if(a.key){var b=vd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ud(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?wd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Zc,charCode:function(a){return"keypress"===
	a.type?ud(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ud(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),yd=dd.extend({dataTransfer:null}),zd=Wc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Zc}),Ad=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Bd=dd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Cd=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],
	["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",
	1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",2],[Xa,"animationEnd",2],[Ya,"animationIteration",2],[Za,"animationStart",2],["canplay","canPlay",2],["canplaythrough",
	"canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress","progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",
	2],[ab,"transitionEnd",2],["waiting","waiting",2]],Dd={},Ed={},Fd=0;for(;Fd<Cd.length;Fd++){var Gd=Cd[Fd],Hd=Gd[0],Id=Gd[1],Jd=Gd[2],Kd="on"+(Id[0].toUpperCase()+Id.slice(1)),Ld={phasedRegistrationNames:{bubbled:Kd,captured:Kd+"Capture"},dependencies:[Hd],eventPriority:Jd};Dd[Id]=Ld;Ed[Hd]=Ld}
	var Md={eventTypes:Dd,getEventPriority:function(a){a=Ed[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=Ed[a];if(!e)return null;switch(a){case "keypress":if(0===ud(c))return null;case "keydown":case "keyup":a=xd;break;case "blur":case "focus":a=td;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=dd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
	yd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=zd;break;case Xa:case Ya:case Za:a=rd;break;case ab:a=Ad;break;case "scroll":a=Wc;break;case "wheel":a=Bd;break;case "copy":case "cut":case "paste":a=sd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=ed;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},Nd=Md.getEventPriority,Od=[];
	function Pd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Rb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,h=null,g=0;g<ea.length;g++){var k=ea[g];k&&(k=k.extractEvents(d,b,f,e))&&(h=xa(h,k))}Ba(h)}}var Qd=!0;function G(a,b){Rd(b,a,!1)}
	function Rd(a,b,c){switch(Nd(b)){case 0:var d=Sd.bind(null,b,1);break;case 1:d=Td.bind(null,b,1);break;default:d=Ud.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Sd(a,b,c){Nb||Lb();var d=Ud,e=Nb;Nb=!0;try{Kb(d,a,b,c)}finally{(Nb=e)||Ob()}}function Td(a,b,c){Ud(a,b,c)}
	function Ud(a,b,c){if(Qd){b=Rb(c);b=Ha(b);null===b||"number"!==typeof b.tag||2===ld(b)||(b=null);if(Od.length){var d=Od.pop();d.topLevelType=a;d.nativeEvent=c;d.targetInst=b;a=d}else a={topLevelType:a,nativeEvent:c,targetInst:b,ancestors:[]};try{if(c=a,Nb)Pd(c,void 0);else{Nb=!0;try{Mb(Pd,c,void 0)}finally{Nb=!1,Ob()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Od.length&&Od.push(a)}}}var Vd=new ("function"===typeof WeakMap?WeakMap:Map);
	function Wd(a){var b=Vd.get(a);void 0===b&&(b=new Set,Vd.set(a,b));return b}function Xd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Yd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Zd(a,b){var c=Yd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Yd(c)}}function $d(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?$d(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
	function ae(){for(var a=window,b=Xd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Xd(a.document)}return b}function be(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
	var ce=Ra&&"documentMode"in document&&11>=document.documentMode,de={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ee=null,fe=null,ge=null,he=!1;
	function ie(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(he||null==ee||ee!==Xd(c))return null;c=ee;"selectionStart"in c&&be(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return ge&&jd(ge,c)?null:(ge=c,a=y.getPooled(de.select,fe,a,b),a.type="select",a.target=ee,Qa(a),a)}
	var je={eventTypes:de,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Wd(e);f=ja.onSelect;for(var h=0;h<f.length;h++)if(!e.has(f[h])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Qb(e)||"true"===e.contentEditable)ee=e,fe=b,ge=null;break;case "blur":ge=fe=ee=null;break;case "mousedown":he=!0;break;case "contextmenu":case "mouseup":case "dragend":return he=!1,ie(c,d);case "selectionchange":if(ce)break;
	case "keydown":case "keyup":return ie(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));sa=Ka;ta=Ia;va=Ja;Ca.injectEventPluginsByName({SimpleEventPlugin:Md,EnterLeaveEventPlugin:gd,ChangeEventPlugin:Vc,SelectEventPlugin:je,BeforeInputEventPlugin:Cb});function ke(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
	function le(a,b){a=m({children:void 0},b);if(b=ke(b.children))a.children=b;return a}function me(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Ac(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function ne(a,b){if(null!=b.dangerouslySetInnerHTML)throw t(Error(91));return m({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function oe(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw t(Error(92));if(Array.isArray(b)){if(!(1>=b.length))throw t(Error(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:Ac(c)}}
	function pe(a,b){var c=Ac(b.value),d=Ac(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function qe(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var re={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function se(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function te(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?se(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var ue=void 0,ve=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==re.svg||"innerHTML"in a)a.innerHTML=b;else{ue=ue||document.createElement("div");ue.innerHTML="<svg>"+b+"</svg>";for(b=ue.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function we(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var xe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},ye=["Webkit","ms","Moz","O"];Object.keys(xe).forEach(function(a){ye.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);xe[b]=xe[a]})});function ze(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||xe.hasOwnProperty(a)&&xe[a]?(""+b).trim():b+"px"}
	function Ae(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ze(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Ce=m({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function De(a,b){if(b){if(Ce[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw t(Error(137),a,"");if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw t(Error(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw t(Error(61));}if(null!=b.style&&"object"!==typeof b.style)throw t(Error(62),"");}}
	function Ee(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
	function Fe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Wd(a);b=ja[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.has(e)){switch(e){case "scroll":Rd(a,"scroll",!0);break;case "focus":case "blur":Rd(a,"focus",!0);Rd(a,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Sb(e)&&Rd(a,e,!0);break;case "invalid":case "submit":case "reset":break;default:-1===bb.indexOf(e)&&G(e,a)}c.add(e)}}}function Ge(){}var He=null,Ie=null;
	function Je(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Ke(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Le="function"===typeof setTimeout?setTimeout:void 0,Me="function"===typeof clearTimeout?clearTimeout:void 0;
	function Ne(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}new Set;var Oe=[],Pe=-1;function H(a){0>Pe||(a.current=Oe[Pe],Oe[Pe]=null,Pe--)}function J(a,b){Pe++;Oe[Pe]=a.current;a.current=b}var Qe={},L={current:Qe},M={current:!1},Re=Qe;
	function Se(a,b){var c=a.type.contextTypes;if(!c)return Qe;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function N(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Te(a){H(M,a);H(L,a)}function Ue(a){H(M,a);H(L,a)}
	function Ve(a,b,c){if(L.current!==Qe)throw t(Error(168));J(L,b,a);J(M,c,a)}function We(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw t(Error(108),oc(b)||"Unknown",e);return m({},c,d)}function Xe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Qe;Re=L.current;J(L,b,a);J(M,M.current,a);return!0}
	function Ye(a,b,c){var d=a.stateNode;if(!d)throw t(Error(169));c?(b=We(a,b,Re),d.__reactInternalMemoizedMergedChildContext=b,H(M,a),H(L,a),J(L,b,a)):H(M,a);J(M,c,a)}
	var Ze=q.unstable_runWithPriority,$e=q.unstable_scheduleCallback,af=q.unstable_cancelCallback,bf=q.unstable_shouldYield,cf=q.unstable_requestPaint,df=q.unstable_now,ef=q.unstable_getCurrentPriorityLevel,ff=q.unstable_ImmediatePriority,hf=q.unstable_UserBlockingPriority,jf=q.unstable_NormalPriority,kf=q.unstable_LowPriority,lf=q.unstable_IdlePriority,mf={},nf=void 0!==cf?cf:function(){},of=null,pf=null,qf=!1,rf=df(),sf=1E4>rf?df:function(){return df()-rf};
	function tf(){switch(ef()){case ff:return 99;case hf:return 98;case jf:return 97;case kf:return 96;case lf:return 95;default:throw t(Error(332));}}function uf(a){switch(a){case 99:return ff;case 98:return hf;case 97:return jf;case 96:return kf;case 95:return lf;default:throw t(Error(332));}}function vf(a,b){a=uf(a);return Ze(a,b)}function wf(a,b,c){a=uf(a);return $e(a,b,c)}function xf(a){null===of?(of=[a],pf=$e(ff,yf)):of.push(a);return mf}function O(){null!==pf&&af(pf);yf()}
	function yf(){if(!qf&&null!==of){qf=!0;var a=0;try{var b=of;vf(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});of=null}catch(c){throw null!==of&&(of=of.slice(a+1)),$e(ff,O),c;}finally{qf=!1}}}function zf(a,b){if(1073741823===b)return 99;if(1===b)return 95;a=10*(1073741821-b)-10*(1073741821-a);return 0>=a?99:250>=a?98:5250>=a?97:95}function Af(a,b){if(a&&a.defaultProps){b=m({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
	function Bf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var Cf={current:null},Df=null,Ef=null,Ff=null;function Gf(){Ff=Ef=Df=null}
	function Hf(a,b){var c=a.type._context;J(Cf,c._currentValue,a);c._currentValue=b}function If(a){var b=Cf.current;H(Cf,a);a.type._context._currentValue=b}function Jf(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
	function Kf(a,b){Df=a;Ff=Ef=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(Lf=!0),a.firstContext=null)}function Mf(a,b){if(Ff!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Ff=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===Ef){if(null===Df)throw t(Error(308));Ef=b;Df.dependencies={expirationTime:0,firstContext:b,responders:null}}else Ef=Ef.next=b}return a._currentValue}var Nf=!1;
	function Of(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Pf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function Qf(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Rf(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
	function Sf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=Of(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=Of(a.memoizedState),e=c.updateQueue=Of(c.memoizedState)):d=a.updateQueue=Pf(e):null===e&&(e=c.updateQueue=Pf(d));null===e||d===e?Rf(d,b):null===d.lastUpdate||null===e.lastUpdate?(Rf(d,b),Rf(e,b)):(Rf(d,b),e.lastUpdate=b)}
	function Tf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=Of(a.memoizedState):Uf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Uf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Pf(b));return b}
	function Vf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-2049|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return m({},d,e);case 2:Nf=!0}return d}
	function Wf(a,b,c,d,e){Nf=!1;b=Uf(a,b);for(var f=b.baseState,h=null,g=0,k=b.firstUpdate,l=f;null!==k;){var n=k.expirationTime;n<e?(null===h&&(h=k,f=l),g<n&&(g=n)):(Xf(n,k.suspenseConfig),l=Vf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}n=null;for(k=b.firstCapturedUpdate;null!==k;){var z=k.expirationTime;z<e?(null===n&&(n=k,null===h&&(f=l)),g<z&&(g=z)):(l=Vf(a,b,k,l,c,d),null!==
	k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===h&&(b.lastUpdate=null);null===n?b.lastCapturedUpdate=null:a.effectTag|=32;null===h&&null===n&&(f=l);b.baseState=f;b.firstUpdate=h;b.firstCapturedUpdate=n;a.expirationTime=g;a.memoizedState=l}
	function Yf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Zf(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Zf(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Zf(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw t(Error(191),c);c.call(d)}a=a.nextEffect}}
	var $f=Xb.ReactCurrentBatchConfig,ag=(new aa.Component).refs;function bg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:m({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
	var fg={isMounted:function(a){return(a=a._reactInternalFiber)?2===ld(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=cg(),e=$f.suspense;d=dg(d,a,e);e=Qf(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf(a,e);eg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=cg(),e=$f.suspense;d=dg(d,a,e);e=Qf(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf(a,e);eg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=cg(),d=$f.suspense;
	c=dg(c,a,d);d=Qf(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Sf(a,d);eg(a,c)}};function gg(a,b,c,d,e,f,h){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,h):b.prototype&&b.prototype.isPureReactComponent?!jd(c,d)||!jd(e,f):!0}
	function hg(a,b,c){var d=!1,e=Qe;var f=b.contextType;"object"===typeof f&&null!==f?f=Mf(f):(e=N(b)?Re:L.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Se(a,e):Qe);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=fg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function ig(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&fg.enqueueReplaceState(b,b.state,null)}
	function jg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=ag;var f=b.contextType;"object"===typeof f&&null!==f?e.context=Mf(f):(f=N(b)?Re:L.current,e.context=Se(a,f));f=a.updateQueue;null!==f&&(Wf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(bg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
	typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&fg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Wf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var kg=Array.isArray;
	function lg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;if(c){if(1!==c.tag)throw t(Error(309));d=c.stateNode}if(!d)throw t(Error(147),a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===ag&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw t(Error(284));if(!c._owner)throw t(Error(290),a);}return a}
	function mg(a,b){if("textarea"!==a.type)throw t(Error(31),"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"");}
	function ng(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=og(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=pg(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=lg(a,b,c),d.return=a,d;d=qg(c.type,c.key,c.props,null,a.mode,d);d.ref=lg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=rg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function n(a,b,c,d,f){if(null===b||7!==b.tag)return b=sg(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=pg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Zb:return c=qg(b.type,b.key,b.props,null,a.mode,c),c.ref=lg(a,null,b),c.return=a,c;case $b:return b=rg(b,a.mode,c),b.return=a,b}if(kg(b)||
	mc(b))return b=sg(b,a.mode,c,null),b.return=a,b;mg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Zb:return c.key===e?c.type===ac?n(a,b,c.props.children,d,e):k(a,b,c,d):null;case $b:return c.key===e?l(a,b,c,d):null}if(kg(c)||mc(c))return null!==e?null:n(a,b,c,d,null);mg(a,c)}return null}function v(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Zb:return a=a.get(null===d.key?c:d.key)||null,d.type===ac?n(b,a,d.props.children,e,d.key):k(b,a,d,e);case $b:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(kg(d)||mc(d))return a=a.get(c)||null,n(b,a,d,e,null);mg(b,d)}return null}function rb(e,h,g,k){for(var l=null,u=null,n=h,w=h=0,C=null;null!==n&&w<g.length;w++){n.index>w?(C=n,n=null):C=n.sibling;var p=x(e,n,g[w],k);if(null===p){null===n&&(n=C);break}a&&
	n&&null===p.alternate&&b(e,n);h=f(p,h,w);null===u?l=p:u.sibling=p;u=p;n=C}if(w===g.length)return c(e,n),l;if(null===n){for(;w<g.length;w++)n=z(e,g[w],k),null!==n&&(h=f(n,h,w),null===u?l=n:u.sibling=n,u=n);return l}for(n=d(e,n);w<g.length;w++)C=v(n,e,w,g[w],k),null!==C&&(a&&null!==C.alternate&&n.delete(null===C.key?w:C.key),h=f(C,h,w),null===u?l=C:u.sibling=C,u=C);a&&n.forEach(function(a){return b(e,a)});return l}function Be(e,h,g,k){var l=mc(g);if("function"!==typeof l)throw t(Error(150));g=l.call(g);
	if(null==g)throw t(Error(151));for(var n=l=null,u=h,w=h=0,C=null,p=g.next();null!==u&&!p.done;w++,p=g.next()){u.index>w?(C=u,u=null):C=u.sibling;var r=x(e,u,p.value,k);if(null===r){null===u&&(u=C);break}a&&u&&null===r.alternate&&b(e,u);h=f(r,h,w);null===n?l=r:n.sibling=r;n=r;u=C}if(p.done)return c(e,u),l;if(null===u){for(;!p.done;w++,p=g.next())p=z(e,p.value,k),null!==p&&(h=f(p,h,w),null===n?l=p:n.sibling=p,n=p);return l}for(u=d(e,u);!p.done;w++,p=g.next())p=v(u,e,w,p.value,k),null!==p&&(a&&null!==
	p.alternate&&u.delete(null===p.key?w:p.key),h=f(p,h,w),null===n?l=p:n.sibling=p,n=p);a&&u.forEach(function(a){return b(e,a)});return l}return function(a,d,f,g){var k="object"===typeof f&&null!==f&&f.type===ac&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Zb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){if(7===k.tag?f.type===ac:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===ac?f.props.children:f.props,g);d.ref=lg(a,k,f);d.return=a;a=d;break a}c(a,
	k);break}else b(a,k);k=k.sibling}f.type===ac?(d=sg(f.props.children,a.mode,g,f.key),d.return=a,a=d):(g=qg(f.type,f.key,f.props,null,a.mode,g),g.ref=lg(a,d,f),g.return=a,a=g)}return h(a);case $b:a:{for(k=f.key;null!==d;){if(d.key===k){if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],g);d.return=a;a=d;break a}c(a,d);break}else b(a,d);d=d.sibling}d=rg(f,a.mode,g);d.return=a;a=d}return h(a)}if("string"===typeof f||
	"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,g),d.return=a,a=d):(c(a,d),d=pg(f,a.mode,g),d.return=a,a=d),h(a);if(kg(f))return rb(a,d,f,g);if(mc(f))return Be(a,d,f,g);l&&mg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,t(Error(152),a.displayName||a.name||"Component");}return c(a,d)}}var tg=ng(!0),ug=ng(!1),vg={},wg={current:vg},xg={current:vg},yg={current:vg};function zg(a){if(a===vg)throw t(Error(174));return a}
	function Ag(a,b){J(yg,b,a);J(xg,a,a);J(wg,vg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:te(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=te(b,c)}H(wg,a);J(wg,b,a)}function Bg(a){H(wg,a);H(xg,a);H(yg,a)}function Cg(a){zg(yg.current);var b=zg(wg.current);var c=te(b,a.type);b!==c&&(J(xg,a,a),J(wg,c,a))}function Dg(a){xg.current===a&&(H(wg,a),H(xg,a))}var Eg=1,Fg=1,Gg=2,P={current:0};
	function Hg(a){for(var b=a;null!==b;){if(13===b.tag){if(null!==b.memoizedState)return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}
	var Ig=0,Jg=2,Kg=4,Lg=8,Mg=16,Ng=32,Og=64,Pg=128,Qg=Xb.ReactCurrentDispatcher,Rg=0,Sg=null,Q=null,Tg=null,Ug=null,R=null,Vg=null,Wg=0,Xg=null,Yg=0,Zg=!1,$g=null,ah=0;function bh(){throw t(Error(321));}function ch(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!hd(a[c],b[c]))return!1;return!0}
	function dh(a,b,c,d,e,f){Rg=f;Sg=b;Tg=null!==a?a.memoizedState:null;Qg.current=null===Tg?eh:fh;b=c(d,e);if(Zg){do Zg=!1,ah+=1,Tg=null!==a?a.memoizedState:null,Vg=Ug,Xg=R=Q=null,Qg.current=fh,b=c(d,e);while(Zg);$g=null;ah=0}Qg.current=hh;a=Sg;a.memoizedState=Ug;a.expirationTime=Wg;a.updateQueue=Xg;a.effectTag|=Yg;a=null!==Q&&null!==Q.next;Rg=0;Vg=R=Ug=Tg=Q=Sg=null;Wg=0;Xg=null;Yg=0;if(a)throw t(Error(300));return b}
	function ih(){Qg.current=hh;Rg=0;Vg=R=Ug=Tg=Q=Sg=null;Wg=0;Xg=null;Yg=0;Zg=!1;$g=null;ah=0}function jh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===R?Ug=R=a:R=R.next=a;return R}function kh(){if(null!==Vg)R=Vg,Vg=R.next,Q=Tg,Tg=null!==Q?Q.next:null;else{if(null===Tg)throw t(Error(310));Q=Tg;var a={memoizedState:Q.memoizedState,baseState:Q.baseState,queue:Q.queue,baseUpdate:Q.baseUpdate,next:null};R=null===R?Ug=a:R.next=a;Tg=Q.next}return R}
	function lh(a,b){return"function"===typeof b?b(a):b}
	function mh(a){var b=kh(),c=b.queue;if(null===c)throw t(Error(311));c.lastRenderedReducer=a;if(0<ah){var d=c.dispatch;if(null!==$g){var e=$g.get(c);if(void 0!==e){$g.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);hd(f,b.memoizedState)||(Lf=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var h=b.baseUpdate;f=b.baseState;null!==h?(null!==d&&(d.next=null),d=h.next):d=null!==d?d.next:null;if(null!==
	d){var g=e=null,k=d,l=!1;do{var n=k.expirationTime;n<Rg?(l||(l=!0,g=h,e=f),n>Wg&&(Wg=n)):(Xf(n,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));h=k;k=k.next}while(null!==k&&k!==d);l||(g=h,e=f);hd(f,b.memoizedState)||(Lf=!0);b.memoizedState=f;b.baseUpdate=g;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
	function nh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===Xg?(Xg={lastEffect:null},Xg.lastEffect=a.next=a):(b=Xg.lastEffect,null===b?Xg.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,Xg.lastEffect=a));return a}function oh(a,b,c,d){var e=jh();Yg|=a;e.memoizedState=nh(b,c,void 0,void 0===d?null:d)}
	function ph(a,b,c,d){var e=kh();d=void 0===d?null:d;var f=void 0;if(null!==Q){var h=Q.memoizedState;f=h.destroy;if(null!==d&&ch(d,h.deps)){nh(Ig,c,f,d);return}}Yg|=a;e.memoizedState=nh(b,c,f,d)}function qh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function rh(){}
	function sh(a,b,c){if(!(25>ah))throw t(Error(301));var d=a.alternate;if(a===Sg||null!==d&&d===Sg)if(Zg=!0,a={expirationTime:Rg,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===$g&&($g=new Map),c=$g.get(b),void 0===c)$g.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=cg(),f=$f.suspense;e=dg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var h=b.last;if(null===h)f.next=f;else{var g=h.next;null!==g&&
	(f.next=g);h.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(hd(l,k))return}catch(n){}finally{}eg(a,e)}}
	var hh={readContext:Mf,useCallback:bh,useContext:bh,useEffect:bh,useImperativeHandle:bh,useLayoutEffect:bh,useMemo:bh,useReducer:bh,useRef:bh,useState:bh,useDebugValue:bh,useResponder:bh},eh={readContext:Mf,useCallback:function(a,b){jh().memoizedState=[a,void 0===b?null:b];return a},useContext:Mf,useEffect:function(a,b){return oh(516,Pg|Og,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return oh(4,Kg|Ng,qh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return oh(4,
	Kg|Ng,a,b)},useMemo:function(a,b){var c=jh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=jh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=sh.bind(null,Sg,a);return[d.memoizedState,a]},useRef:function(a){var b=jh();a={current:a};return b.memoizedState=a},useState:function(a){var b=jh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue=
	{last:null,dispatch:null,lastRenderedReducer:lh,lastRenderedState:a};a=a.dispatch=sh.bind(null,Sg,a);return[b.memoizedState,a]},useDebugValue:rh,useResponder:kd},fh={readContext:Mf,useCallback:function(a,b){var c=kh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&ch(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:Mf,useEffect:function(a,b){return ph(516,Pg|Og,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return ph(4,Kg|Ng,qh.bind(null,
	b,a),c)},useLayoutEffect:function(a,b){return ph(4,Kg|Ng,a,b)},useMemo:function(a,b){var c=kh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&ch(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:mh,useRef:function(){return kh().memoizedState},useState:function(a){return mh(lh,a)},useDebugValue:rh,useResponder:kd},th=null,uh=null,vh=!1;
	function wh(a,b){var c=xh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function yh(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function zh(a){if(vh){var b=uh;if(b){var c=b;if(!yh(a,b)){b=Ne(c.nextSibling);if(!b||!yh(a,b)){a.effectTag|=2;vh=!1;th=a;return}wh(th,c)}th=a;uh=Ne(b.firstChild)}else a.effectTag|=2,vh=!1,th=a}}function Ah(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;th=a}
	function Bh(a){if(a!==th)return!1;if(!vh)return Ah(a),vh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Ke(b,a.memoizedProps))for(b=uh;b;)wh(a,b),b=Ne(b.nextSibling);Ah(a);uh=th?Ne(a.stateNode.nextSibling):null;return!0}function Ch(){uh=th=null;vh=!1}var Dh=Xb.ReactCurrentOwner,Lf=!1;function S(a,b,c,d){b.child=null===a?ug(b,null,c,d):tg(b,a.child,c,d)}
	function Eh(a,b,c,d,e){c=c.render;var f=b.ref;Kf(b,e);d=dh(a,b,c,d,f,e);if(null!==a&&!Lf)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Fh(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
	function Gh(a,b,c,d,e,f){if(null===a){var h=c.type;if("function"===typeof h&&!Hh(h)&&void 0===h.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=h,Ih(a,b,h,d,e,f);a=qg(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}h=a.child;if(e<f&&(e=h.memoizedProps,c=c.compare,c=null!==c?c:jd,c(e,d)&&a.ref===b.ref))return Fh(a,b,f);b.effectTag|=1;a=og(h,d,f);a.ref=b.ref;a.return=b;return b.child=a}
	function Ih(a,b,c,d,e,f){return null!==a&&jd(a.memoizedProps,d)&&a.ref===b.ref&&(Lf=!1,e<f)?Fh(a,b,f):Jh(a,b,c,d,f)}function Kh(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Jh(a,b,c,d,e){var f=N(c)?Re:L.current;f=Se(b,f);Kf(b,e);c=dh(a,b,c,d,f,e);if(null!==a&&!Lf)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Fh(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
	function Lh(a,b,c,d,e){if(N(c)){var f=!0;Xe(b)}else f=!1;Kf(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),hg(b,c,d,e),jg(b,c,d,e),d=!0;else if(null===a){var h=b.stateNode,g=b.memoizedProps;h.props=g;var k=h.context,l=c.contextType;"object"===typeof l&&null!==l?l=Mf(l):(l=N(c)?Re:L.current,l=Se(b,l));var n=c.getDerivedStateFromProps,z="function"===typeof n||"function"===typeof h.getSnapshotBeforeUpdate;z||"function"!==typeof h.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof h.componentWillReceiveProps||(g!==d||k!==l)&&ig(b,h,d,l);Nf=!1;var x=b.memoizedState;k=h.state=x;var v=b.updateQueue;null!==v&&(Wf(b,v,d,h,e),k=b.memoizedState);g!==d||x!==k||M.current||Nf?("function"===typeof n&&(bg(b,c,n,d),k=b.memoizedState),(g=Nf||gg(b,c,g,d,x,k,l))?(z||"function"!==typeof h.UNSAFE_componentWillMount&&"function"!==typeof h.componentWillMount||("function"===typeof h.componentWillMount&&h.componentWillMount(),"function"===typeof h.UNSAFE_componentWillMount&&
	h.UNSAFE_componentWillMount()),"function"===typeof h.componentDidMount&&(b.effectTag|=4)):("function"===typeof h.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),h.props=d,h.state=k,h.context=l,d=g):("function"===typeof h.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.stateNode,g=b.memoizedProps,h.props=b.type===b.elementType?g:Af(b.type,g),k=h.context,l=c.contextType,"object"===typeof l&&null!==l?l=Mf(l):(l=N(c)?Re:L.current,l=Se(b,l)),n=c.getDerivedStateFromProps,(z=
	"function"===typeof n||"function"===typeof h.getSnapshotBeforeUpdate)||"function"!==typeof h.UNSAFE_componentWillReceiveProps&&"function"!==typeof h.componentWillReceiveProps||(g!==d||k!==l)&&ig(b,h,d,l),Nf=!1,k=b.memoizedState,x=h.state=k,v=b.updateQueue,null!==v&&(Wf(b,v,d,h,e),x=b.memoizedState),g!==d||k!==x||M.current||Nf?("function"===typeof n&&(bg(b,c,n,d),x=b.memoizedState),(n=Nf||gg(b,c,g,d,k,x,l))?(z||"function"!==typeof h.UNSAFE_componentWillUpdate&&"function"!==typeof h.componentWillUpdate||
	("function"===typeof h.componentWillUpdate&&h.componentWillUpdate(d,x,l),"function"===typeof h.UNSAFE_componentWillUpdate&&h.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof h.componentDidUpdate&&(b.effectTag|=4),"function"===typeof h.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof h.componentDidUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof h.getSnapshotBeforeUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
	d,b.memoizedState=x),h.props=d,h.state=x,h.context=l,d=n):("function"!==typeof h.componentDidUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof h.getSnapshotBeforeUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return Mh(a,b,c,d,f,e)}
	function Mh(a,b,c,d,e,f){Kh(a,b);var h=0!==(b.effectTag&64);if(!d&&!h)return e&&Ye(b,c,!1),Fh(a,b,f);d=b.stateNode;Dh.current=b;var g=h&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&h?(b.child=tg(b,a.child,null,f),b.child=tg(b,null,g,f)):S(a,b,g,f);b.memoizedState=d.state;e&&Ye(b,c,!0);return b.child}function Nh(a){var b=a.stateNode;b.pendingContext?Ve(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ve(a,b.context,!1);Ag(a,b.containerInfo)}
	var Oh={};
	function Ph(a,b,c){var d=b.mode,e=b.pendingProps,f=P.current,h=null,g=!1,k;(k=0!==(b.effectTag&64))||(k=0!==(f&Gg)&&(null===a||null!==a.memoizedState));k?(h=Oh,g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=Fg);f&=Eg;J(P,f,b);if(null===a)if(g){e=e.fallback;a=sg(null,d,0,null);a.return=b;if(0===(b.mode&2))for(g=null!==b.memoizedState?b.child.child:b.child,a.child=g;null!==g;)g.return=a,g=g.sibling;c=sg(e,d,c,null);c.return=b;a.sibling=
	c;d=a}else d=c=ug(b,null,e.children,c);else{if(null!==a.memoizedState)if(f=a.child,d=f.sibling,g){e=e.fallback;c=og(f,f.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==f.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;e=og(d,e,d.expirationTime);e.return=b;c.sibling=e;d=c;c.childExpirationTime=0;c=e}else d=c=tg(b,f.child,e.children,c);else if(f=a.child,g){g=e.fallback;e=sg(null,d,0,null);e.return=b;e.child=f;null!==f&&(f.return=e);if(0===(b.mode&
	2))for(f=null!==b.memoizedState?b.child.child:b.child,e.child=f;null!==f;)f.return=e,f=f.sibling;c=sg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;d=e;e.childExpirationTime=0}else c=d=tg(b,f,e.children,c);b.stateNode=a.stateNode}b.memoizedState=h;b.child=d;return c}function Qh(a,b,c,d,e){var f=a.memoizedState;null===f?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e}:(f.isBackwards=b,f.rendering=null,f.last=d,f.tail=c,f.tailExpiration=0,f.tailMode=e)}
	function Rh(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;S(a,b,d.children,c);d=P.current;if(0!==(d&Gg))d=d&Eg|Gg,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag){if(null!==a.memoizedState){a.expirationTime<c&&(a.expirationTime=c);var h=a.alternate;null!==h&&h.expirationTime<c&&(h.expirationTime=c);Jf(a.return,c)}}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===
	b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=Eg}J(P,d,b);if(0===(b.mode&2))b.memoizedState=null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)d=c.alternate,null!==d&&null===Hg(d)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Qh(b,!1,e,c,f);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){d=e.alternate;if(null!==d&&null===Hg(d)){b.child=e;break}d=e.sibling;e.sibling=c;c=e;e=d}Qh(b,!0,c,null,f);break;case "together":Qh(b,
	!1,null,null,void 0);break;default:b.memoizedState=null}return b.child}function Fh(a,b,c){null!==a&&(b.dependencies=a.dependencies);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw t(Error(153));if(null!==b.child){a=b.child;c=og(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=og(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Sh(a){a.effectTag|=4}
	var Th=void 0,Uh=void 0,Vh=void 0,Wh=void 0;Th=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(20===c.tag)a.appendChild(c.stateNode.instance);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Uh=function(){};
	Vh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var h=b.stateNode;zg(wg.current);a=null;switch(c){case "input":f=Bc(h,f);d=Bc(h,d);a=[];break;case "option":f=le(h,f);d=le(h,d);a=[];break;case "select":f=m({},f,{value:void 0});d=m({},d,{value:void 0});a=[];break;case "textarea":f=ne(h,f);d=ne(h,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(h.onclick=Ge)}De(c,d);h=c=void 0;var g=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
	c){var k=f[c];for(h in k)k.hasOwnProperty(h)&&(g||(g={}),g[h]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ia.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var l=d[c];k=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&l!==k&&(null!=l||null!=k))if("style"===c)if(k){for(h in k)!k.hasOwnProperty(h)||l&&l.hasOwnProperty(h)||(g||(g={}),g[h]="");for(h in l)l.hasOwnProperty(h)&&k[h]!==l[h]&&(g||
	(g={}),g[h]=l[h])}else g||(a||(a=[]),a.push(c,g)),g=l;else"dangerouslySetInnerHTML"===c?(l=l?l.__html:void 0,k=k?k.__html:void 0,null!=l&&k!==l&&(a=a||[]).push(c,""+l)):"children"===c?k===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(c,""+l):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ia.hasOwnProperty(c)?(null!=l&&Fe(e,c),a||k===l||(a=[])):(a=a||[]).push(c,l))}g&&(a=a||[]).push("style",g);e=a;(b.updateQueue=e)&&Sh(b)}};Wh=function(a,b,c,d){c!==d&&Sh(b)};
	function $h(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function ai(a){switch(a.tag){case 1:N(a.type)&&Te(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:Bg(a);Ue(a);b=a.effectTag;if(0!==(b&64))throw t(Error(285));a.effectTag=b&-2049|64;return a;case 5:return Dg(a),null;case 13:return H(P,a),b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 19:return H(P,a),null;case 4:return Bg(a),null;case 10:return If(a),null;default:return null}}function bi(a,b){return{value:a,source:b,stack:pc(b)}}
	var ci="function"===typeof WeakSet?WeakSet:Set;function di(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=pc(c));null!==c&&oc(c.type);b=b.value;null!==a&&1===a.tag&&oc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function ei(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){fi(a,c)}}function gi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){fi(a,c)}else b.current=null}
	function hi(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Ig){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Ig&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
	function ii(a,b){"function"===typeof ji&&ji(a);switch(a.tag){case 0:case 11:case 14:case 15:var c=a.updateQueue;if(null!==c&&(c=c.lastEffect,null!==c)){var d=c.next;vf(97<b?97:b,function(){var b=d;do{var c=b.destroy;if(void 0!==c){var h=a;try{c()}catch(g){fi(h,g)}}b=b.next}while(b!==d)})}break;case 1:gi(a);b=a.stateNode;"function"===typeof b.componentWillUnmount&&ei(a,b);break;case 5:gi(a);break;case 4:ki(a,b)}}
	function li(a,b){for(var c=a;;)if(ii(c,b),null!==c.child&&4!==c.tag)c.child.return=c,c=c.child;else{if(c===a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}function mi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function ni(a){a:{for(var b=a.return;null!==b;){if(mi(b)){var c=b;break a}b=b.return}throw t(Error(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw t(Error(161));}c.effectTag&16&&(we(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||mi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f||20===e.tag){var h=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var g=h;h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(h,c);else d?(g=b,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=Ge)):
	b.appendChild(h)}else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function ki(a,b){for(var c=a,d=!1,e=void 0,f=void 0;;){if(!d){d=c.return;a:for(;;){if(null===d)throw t(Error(160));e=d.stateNode;switch(d.tag){case 5:f=!1;break a;case 3:e=e.containerInfo;f=!0;break a;case 4:e=e.containerInfo;f=!0;break a}d=d.return}d=!0}if(5===c.tag||6===c.tag)if(li(c,b),f){var h=e,g=c.stateNode;8===h.nodeType?h.parentNode.removeChild(g):h.removeChild(g)}else e.removeChild(c.stateNode);else if(20===c.tag)g=c.stateNode.instance,li(c,b),f?(h=e,8===h.nodeType?h.parentNode.removeChild(g):
	h.removeChild(g)):e.removeChild(g);else if(4===c.tag){if(null!==c.child){e=c.stateNode.containerInfo;f=!0;c.child.return=c;c=c.child;continue}}else if(ii(c,b),null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return;4===c.tag&&(d=!1)}c.sibling.return=c.return;c=c.sibling}}
	function oi(a,b){switch(b.tag){case 0:case 11:case 14:case 15:hi(Kg,Lg,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Ga]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Dc(c,d);Ee(a,e);b=Ee(a,d);for(e=0;e<f.length;e+=2){var h=f[e],g=f[e+1];"style"===h?Ae(c,g):"dangerouslySetInnerHTML"===h?ve(c,g):"children"===h?we(c,g):zc(c,h,g,b)}switch(a){case "input":Ec(c,d);break;case "textarea":pe(c,
	d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?me(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?me(c,!!d.multiple,d.defaultValue,!0):me(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw t(Error(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,pi=sf());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=
	f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ze("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===
	a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}qi(b);break;case 19:qi(b);break;case 17:break;case 20:break;default:throw t(Error(163));}}function qi(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new ci);b.forEach(function(b){var d=ri.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var si="function"===typeof WeakMap?WeakMap:Map;
	function ti(a,b,c){c=Qf(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){ui||(ui=!0,vi=d);di(a,b)};return c}
	function wi(a,b,c){c=Qf(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){di(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===xi?xi=new Set([this]):xi.add(this),di(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var yi=Math.ceil,zi=Xb.ReactCurrentDispatcher,Ai=Xb.ReactCurrentOwner,T=0,Bi=8,Ci=16,Di=32,Ei=0,Fi=1,Gi=2,Hi=3,Ii=4,U=T,Ji=null,V=null,W=0,X=Ei,Ki=1073741823,Li=1073741823,Mi=null,Ni=!1,pi=0,Oi=500,Y=null,ui=!1,vi=null,xi=null,Pi=!1,Qi=null,Ri=90,Si=0,Ti=null,Ui=0,Vi=null,Wi=0;function cg(){return(U&(Ci|Di))!==T?1073741821-(sf()/10|0):0!==Wi?Wi:Wi=1073741821-(sf()/10|0)}
	function dg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=tf();if(0===(b&4))return 99===d?1073741823:1073741822;if((U&Ci)!==T)return W;if(null!==c)a=1073741821-25*(((1073741821-a+(c.timeoutMs|0||5E3)/10)/25|0)+1);else switch(d){case 99:a=1073741823;break;case 98:a=1073741821-10*(((1073741821-a+15)/10|0)+1);break;case 97:case 96:a=1073741821-25*(((1073741821-a+500)/25|0)+1);break;case 95:a=1;break;default:throw t(Error(326));}null!==Ji&&a===W&&--a;return a}var Xi=0;
	function eg(a,b){if(50<Ui)throw Ui=0,Vi=null,t(Error(185));a=Yi(a,b);if(null!==a){a.pingTime=0;var c=tf();if(1073741823===b)if((U&Bi)!==T&&(U&(Ci|Di))===T)for(var d=Z(a,1073741823,!0);null!==d;)d=d(!0);else Zi(a,99,1073741823),U===T&&O();else Zi(a,c,b);(U&4)===T||98!==c&&99!==c||(null===Ti?Ti=new Map([[a,b]]):(c=Ti.get(a),(void 0===c||c>b)&&Ti.set(a,b)))}}
	function Yi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(b>e.firstPendingTime&&(e.firstPendingTime=b),a=e.lastPendingTime,0===a||b<a)&&(e.lastPendingTime=
	b);return e}function Zi(a,b,c){if(a.callbackExpirationTime<c){var d=a.callbackNode;null!==d&&d!==mf&&af(d);a.callbackExpirationTime=c;1073741823===c?a.callbackNode=xf($i.bind(null,a,Z.bind(null,a,c))):(d=null,1!==c&&(d={timeout:10*(1073741821-c)-sf()}),a.callbackNode=wf(b,$i.bind(null,a,Z.bind(null,a,c)),d))}}function $i(a,b,c){var d=a.callbackNode,e=null;try{return e=b(c),null!==e?$i.bind(null,a,e):null}finally{null===e&&d===a.callbackNode&&(a.callbackNode=null,a.callbackExpirationTime=0)}}
	function aj(){(U&(1|Ci|Di))===T&&(bj(),cj())}function dj(a,b){var c=a.firstBatch;return null!==c&&c._defer&&c._expirationTime>=b?(wf(97,function(){c._onComplete();return null}),!0):!1}function bj(){if(null!==Ti){var a=Ti;Ti=null;a.forEach(function(a,c){xf(Z.bind(null,c,a))});O()}}function ej(a,b){var c=U;U|=1;try{return a(b)}finally{U=c,U===T&&O()}}function fj(a,b,c,d){var e=U;U|=4;try{return vf(98,a.bind(null,b,c,d))}finally{U=e,U===T&&O()}}
	function gj(a,b){var c=U;U&=-2;U|=Bi;try{return a(b)}finally{U=c,U===T&&O()}}
	function hj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Me(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Te(d);break;case 3:Bg(d);Ue(d);break;case 5:Dg(d);break;case 4:Bg(d);break;case 13:H(P,d);break;case 19:H(P,d);break;case 10:If(d)}c=c.return}Ji=a;V=og(a.current,null,b);W=b;X=Ei;Li=Ki=1073741823;Mi=null;Ni=!1}
	function Z(a,b,c){if((U&(Ci|Di))!==T)throw t(Error(327));if(a.firstPendingTime<b)return null;if(c&&a.finishedExpirationTime===b)return ij.bind(null,a);cj();if(a!==Ji||b!==W)hj(a,b);else if(X===Hi)if(Ni)hj(a,b);else{var d=a.lastPendingTime;if(d<b)return Z.bind(null,a,d)}if(null!==V){d=U;U|=Ci;var e=zi.current;null===e&&(e=hh);zi.current=hh;if(c){if(1073741823!==b){var f=cg();if(f<b)return U=d,Gf(),zi.current=e,Z.bind(null,a,f)}}else Wi=0;do try{if(c)for(;null!==V;)V=jj(V);else for(;null!==V&&!bf();)V=
	jj(V);break}catch(rb){Gf();ih();f=V;if(null===f||null===f.return)throw hj(a,b),U=d,rb;a:{var h=a,g=f.return,k=f,l=rb,n=W;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==l&&"object"===typeof l&&"function"===typeof l.then){var z=l,x=0!==(P.current&Fg);l=g;do{var v;if(v=13===l.tag)null!==l.memoizedState?v=!1:(v=l.memoizedProps,v=void 0===v.fallback?!1:!0!==v.unstable_avoidThisFallback?!0:x?!1:!0);if(v){g=l.updateQueue;null===g?(g=new Set,g.add(z),l.updateQueue=g):g.add(z);if(0===(l.mode&
	2)){l.effectTag|=64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(n=Qf(1073741823,null),n.tag=2,Sf(k,n)));k.expirationTime=1073741823;break a}k=h;h=n;x=k.pingCache;null===x?(x=k.pingCache=new si,g=new Set,x.set(z,g)):(g=x.get(z),void 0===g&&(g=new Set,x.set(z,g)));g.has(h)||(g.add(h),k=kj.bind(null,k,z,h),z.then(k,k));l.effectTag|=2048;l.expirationTime=n;break a}l=l.return}while(null!==l);l=Error((oc(k.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+
	pc(k))}X!==Ii&&(X=Fi);l=bi(l,k);k=g;do{switch(k.tag){case 3:k.effectTag|=2048;k.expirationTime=n;n=ti(k,l,n);Tf(k,n);break a;case 1:if(z=l,h=k.type,g=k.stateNode,0===(k.effectTag&64)&&("function"===typeof h.getDerivedStateFromError||null!==g&&"function"===typeof g.componentDidCatch&&(null===xi||!xi.has(g)))){k.effectTag|=2048;k.expirationTime=n;n=wi(k,z,n);Tf(k,n);break a}}k=k.return}while(null!==k)}V=lj(f)}while(1);U=d;Gf();zi.current=e;if(null!==V)return Z.bind(null,a,b)}a.finishedWork=a.current.alternate;
	a.finishedExpirationTime=b;if(dj(a,b))return null;Ji=null;switch(X){case Ei:throw t(Error(328));case Fi:return d=a.lastPendingTime,d<b?Z.bind(null,a,d):c?ij.bind(null,a):(hj(a,b),xf(Z.bind(null,a,b)),null);case Gi:if(1073741823===Ki&&!c&&(c=pi+Oi-sf(),10<c)){if(Ni)return hj(a,b),Z.bind(null,a,b);d=a.lastPendingTime;if(d<b)return Z.bind(null,a,d);a.timeoutHandle=Le(ij.bind(null,a),c);return null}return ij.bind(null,a);case Hi:if(!c){if(Ni)return hj(a,b),Z.bind(null,a,b);c=a.lastPendingTime;if(c<b)return Z.bind(null,
	a,c);1073741823!==Li?c=10*(1073741821-Li)-sf():1073741823===Ki?c=0:(c=10*(1073741821-Ki)-5E3,d=sf(),b=10*(1073741821-b)-d,c=d-c,0>c&&(c=0),c=(120>c?120:480>c?480:1080>c?1080:1920>c?1920:3E3>c?3E3:4320>c?4320:1960*yi(c/1960))-c,b<c&&(c=b));if(10<c)return a.timeoutHandle=Le(ij.bind(null,a),c),null}return ij.bind(null,a);case Ii:return!c&&1073741823!==Ki&&null!==Mi&&(d=Ki,e=Mi,b=e.busyMinDurationMs|0,0>=b?b=0:(c=e.busyDelayMs|0,d=sf()-(10*(1073741821-d)-(e.timeoutMs|0||5E3)),b=d<=c?0:c+b-d),10<b)?(a.timeoutHandle=
	Le(ij.bind(null,a),b),null):ij.bind(null,a);default:throw t(Error(329));}}function Xf(a,b){a<Ki&&1<a&&(Ki=a);null!==b&&a<Li&&1<a&&(Li=a,Mi=b)}function jj(a){var b=mj(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=lj(a));Ai.current=null;return b}
	function lj(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&1024)){a:{var c=b;b=V;var d=W,e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:N(b.type)&&Te(b);break;case 3:Bg(b);Ue(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===c||null===c.child)Bh(b),b.effectTag&=-3;Uh(b);break;case 5:Dg(b);d=zg(yg.current);var f=b.type;if(null!==c&&null!=b.stateNode)Vh(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var h=
	zg(wg.current);if(Bh(b)){c=b;e=void 0;f=c.stateNode;var g=c.type,k=c.memoizedProps;f[Fa]=c;f[Ga]=k;switch(g){case "iframe":case "object":case "embed":G("load",f);break;case "video":case "audio":for(var l=0;l<bb.length;l++)G(bb[l],f);break;case "source":G("error",f);break;case "img":case "image":case "link":G("error",f);G("load",f);break;case "form":G("reset",f);G("submit",f);break;case "details":G("toggle",f);break;case "input":Cc(f,k);G("invalid",f);Fe(d,"onChange");break;case "select":f._wrapperState=
	{wasMultiple:!!k.multiple};G("invalid",f);Fe(d,"onChange");break;case "textarea":oe(f,k),G("invalid",f),Fe(d,"onChange")}De(g,k);l=null;for(e in k)k.hasOwnProperty(e)&&(h=k[e],"children"===e?"string"===typeof h?f.textContent!==h&&(l=["children",h]):"number"===typeof h&&f.textContent!==""+h&&(l=["children",""+h]):ia.hasOwnProperty(e)&&null!=h&&Fe(d,e));switch(g){case "input":Vb(f);Gc(f,k,!0);break;case "textarea":Vb(f);qe(f,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
	(f.onclick=Ge)}d=l;c.updateQueue=d;null!==d&&Sh(b)}else{k=f;c=e;g=b;l=9===d.nodeType?d:d.ownerDocument;h===re.html&&(h=se(k));h===re.html?"script"===k?(k=l.createElement("div"),k.innerHTML="<script>\x3c/script>",l=k.removeChild(k.firstChild)):"string"===typeof c.is?l=l.createElement(k,{is:c.is}):(l=l.createElement(k),"select"===k&&(k=l,c.multiple?k.multiple=!0:c.size&&(k.size=c.size))):l=l.createElementNS(h,k);k=l;k[Fa]=g;k[Ga]=c;c=k;Th(c,b,!1,!1);g=c;var n=d,z=Ee(f,e);switch(f){case "iframe":case "object":case "embed":G("load",
	g);d=e;break;case "video":case "audio":for(d=0;d<bb.length;d++)G(bb[d],g);d=e;break;case "source":G("error",g);d=e;break;case "img":case "image":case "link":G("error",g);G("load",g);d=e;break;case "form":G("reset",g);G("submit",g);d=e;break;case "details":G("toggle",g);d=e;break;case "input":Cc(g,e);d=Bc(g,e);G("invalid",g);Fe(n,"onChange");break;case "option":d=le(g,e);break;case "select":g._wrapperState={wasMultiple:!!e.multiple};d=m({},e,{value:void 0});G("invalid",g);Fe(n,"onChange");break;case "textarea":oe(g,
	e);d=ne(g,e);G("invalid",g);Fe(n,"onChange");break;default:d=e}De(f,d);k=void 0;l=f;h=g;var x=d;for(k in x)if(x.hasOwnProperty(k)){var v=x[k];"style"===k?Ae(h,v):"dangerouslySetInnerHTML"===k?(v=v?v.__html:void 0,null!=v&&ve(h,v)):"children"===k?"string"===typeof v?("textarea"!==l||""!==v)&&we(h,v):"number"===typeof v&&we(h,""+v):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(ia.hasOwnProperty(k)?null!=v&&Fe(n,k):null!=v&&zc(h,k,v,z))}switch(f){case "input":Vb(g);
	Gc(g,e,!1);break;case "textarea":Vb(g);qe(g,e);break;case "option":null!=e.value&&g.setAttribute("value",""+Ac(e.value));break;case "select":d=g;g=e;d.multiple=!!g.multiple;k=g.value;null!=k?me(d,!!g.multiple,k,!1):null!=g.defaultValue&&me(d,!!g.multiple,g.defaultValue,!0);break;default:"function"===typeof d.onClick&&(g.onclick=Ge)}Je(f,e)&&Sh(b);b.stateNode=c}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw t(Error(166));break;case 6:if(c&&null!=b.stateNode)Wh(c,b,c.memoizedProps,
	e);else{if("string"!==typeof e&&null===b.stateNode)throw t(Error(166));c=zg(yg.current);zg(wg.current);Bh(b)?(d=b.stateNode,c=b.memoizedProps,d[Fa]=b,d.nodeValue!==c&&Sh(b)):(d=b,c=(9===c.nodeType?c:c.ownerDocument).createTextNode(e),c[Fa]=b,d.stateNode=c)}break;case 11:break;case 13:H(P,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}d=null!==e;e=!1;null===c?Bh(b):(f=c.memoizedState,e=null!==f,d||null===f||(f=c.child.sibling,null!==f&&(g=b.firstEffect,null!==g?(b.firstEffect=
	f,f.nextEffect=g):(b.firstEffect=b.lastEffect=f,f.nextEffect=null),f.effectTag=8)));if(d&&!e&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(P.current&Fg))X===Ei&&(X=Gi);else if(X===Ei||X===Gi)X=Hi;if(d||e)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Bg(b);Uh(b);break;case 10:If(b);break;case 9:break;case 14:break;case 17:N(b.type)&&Te(b);break;case 18:break;case 19:H(P,b);e=b.memoizedState;if(null===e)break;f=0!==(b.effectTag&64);g=e.rendering;
	if(null===g)if(f)$h(e,!1);else{if(X!==Ei||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){g=Hg(c);if(null!==g){b.effectTag|=64;$h(e,!1);c=g.updateQueue;null!==c&&(b.updateQueue=c,b.effectTag|=4);b.firstEffect=b.lastEffect=null;for(c=b.child;null!==c;)e=c,f=d,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,g=e.alternate,null===g?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=
	g.childExpirationTime,e.expirationTime=g.expirationTime,e.child=g.child,e.memoizedProps=g.memoizedProps,e.memoizedState=g.memoizedState,e.updateQueue=g.updateQueue,f=g.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),c=c.sibling;J(P,P.current&Eg|Gg,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=Hg(g),null!==c){if(b.effectTag|=64,f=!0,$h(e,!0),null===e.tail&&"hidden"===e.tailMode){d=c.updateQueue;null!==d&&(b.updateQueue=
	d,b.effectTag|=4);b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else sf()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,$h(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(g.sibling=b.child,b.child=g):(d=e.last,null!==d?d.sibling=g:b.child=g,e.last=g)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=sf()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;e.lastEffect=b.lastEffect;d.sibling=null;c=P.current;c=f?c&Eg|Gg:c&Eg;J(P,c,b);b=d;break a}break;case 20:break;
	default:throw t(Error(156));}b=null}d=V;if(1===W||1!==d.childExpirationTime){c=0;for(e=d.child;null!==e;)f=e.expirationTime,g=e.childExpirationTime,f>c&&(c=f),g>c&&(c=g),e=e.sibling;d.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&1024)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,
	a.lastEffect=V))}else{b=ai(V,W);if(null!==b)return b.effectTag&=1023,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=1024)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===Ei&&(X=Ii);return null}function ij(a){var b=tf();vf(99,nj.bind(null,a,b));null!==Qi&&wf(97,function(){cj();return null});return null}
	function nj(a,b){cj();if((U&(Ci|Di))!==T)throw t(Error(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw t(Error(177));a.callbackNode=null;a.callbackExpirationTime=0;var e=c.expirationTime,f=c.childExpirationTime;e=f>e?f:e;a.firstPendingTime=e;e<a.lastPendingTime&&(a.lastPendingTime=e);a===Ji&&(V=Ji=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;
	if(null!==e){f=U;U|=Di;Ai.current=null;He=Qd;var h=ae();if(be(h)){if("selectionStart"in h)var g={start:h.selectionStart,end:h.selectionEnd};else a:{g=(g=h.ownerDocument)&&g.defaultView||window;var k=g.getSelection&&g.getSelection();if(k&&0!==k.rangeCount){g=k.anchorNode;var l=k.anchorOffset,n=k.focusNode;k=k.focusOffset;try{g.nodeType,n.nodeType}catch(zb){g=null;break a}var z=0,x=-1,v=-1,rb=0,Be=0,u=h,w=null;b:for(;;){for(var C;;){u!==g||0!==l&&3!==u.nodeType||(x=z+l);u!==n||0!==k&&3!==u.nodeType||
	(v=z+k);3===u.nodeType&&(z+=u.nodeValue.length);if(null===(C=u.firstChild))break;w=u;u=C}for(;;){if(u===h)break b;w===g&&++rb===l&&(x=z);w===n&&++Be===k&&(v=z);if(null!==(C=u.nextSibling))break;u=w;w=u.parentNode}u=C}g=-1===x||-1===v?null:{start:x,end:v}}else g=null}g=g||{start:0,end:0}}else g=null;Ie={focusedElem:h,selectionRange:g};Qd=!1;Y=e;do try{for(;null!==Y;){if(0!==(Y.effectTag&256)){var I=Y.alternate;h=Y;switch(h.tag){case 0:case 11:case 15:hi(Jg,Ig,h);break;case 1:if(h.effectTag&256&&null!==
	I){var E=I.memoizedProps,ua=I.memoizedState,gh=h.stateNode,oj=gh.getSnapshotBeforeUpdate(h.elementType===h.type?E:Af(h.type,E),ua);gh.__reactInternalSnapshotBeforeUpdate=oj}break;case 3:case 5:case 6:case 4:case 17:break;default:throw t(Error(163));}}Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));fi(Y,zb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(I=b;null!==Y;){var A=Y.effectTag;A&16&&we(Y.stateNode,"");if(A&128){var p=Y.alternate;if(null!==p){var r=p.ref;null!==r&&("function"===typeof r?
	r(null):r.current=null)}}switch(A&14){case 2:ni(Y);Y.effectTag&=-3;break;case 6:ni(Y);Y.effectTag&=-3;oi(Y.alternate,Y);break;case 4:oi(Y.alternate,Y);break;case 8:E=Y;ki(E,I);E.return=null;E.child=null;E.memoizedState=null;E.updateQueue=null;E.dependencies=null;var K=E.alternate;null!==K&&(K.return=null,K.child=null,K.memoizedState=null,K.updateQueue=null,K.dependencies=null)}Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));fi(Y,zb);Y=Y.nextEffect}while(null!==Y);r=Ie;p=ae();A=r.focusedElem;
	I=r.selectionRange;if(p!==A&&A&&A.ownerDocument&&$d(A.ownerDocument.documentElement,A)){null!==I&&be(A)&&(p=I.start,r=I.end,void 0===r&&(r=p),"selectionStart"in A?(A.selectionStart=p,A.selectionEnd=Math.min(r,A.value.length)):(r=(p=A.ownerDocument||document)&&p.defaultView||window,r.getSelection&&(r=r.getSelection(),E=A.textContent.length,K=Math.min(I.start,E),I=void 0===I.end?K:Math.min(I.end,E),!r.extend&&K>I&&(E=I,I=K,K=E),E=Zd(A,K),ua=Zd(A,I),E&&ua&&(1!==r.rangeCount||r.anchorNode!==E.node||r.anchorOffset!==
	E.offset||r.focusNode!==ua.node||r.focusOffset!==ua.offset)&&(p=p.createRange(),p.setStart(E.node,E.offset),r.removeAllRanges(),K>I?(r.addRange(p),r.extend(ua.node,ua.offset)):(p.setEnd(ua.node,ua.offset),r.addRange(p))))));p=[];for(r=A;r=r.parentNode;)1===r.nodeType&&p.push({element:r,left:r.scrollLeft,top:r.scrollTop});"function"===typeof A.focus&&A.focus();for(A=0;A<p.length;A++)r=p[A],r.element.scrollLeft=r.left,r.element.scrollTop=r.top}Ie=null;Qd=!!He;He=null;a.current=c;Y=e;do try{for(A=d;null!==
	Y;){var $a=Y.effectTag;if($a&36){var nc=Y.alternate;p=Y;r=A;switch(p.tag){case 0:case 11:case 15:hi(Mg,Ng,p);break;case 1:var md=p.stateNode;if(p.effectTag&4)if(null===nc)md.componentDidMount();else{var Fj=p.elementType===p.type?nc.memoizedProps:Af(p.type,nc.memoizedProps);md.componentDidUpdate(Fj,nc.memoizedState,md.__reactInternalSnapshotBeforeUpdate)}var Xh=p.updateQueue;null!==Xh&&Yf(p,Xh,md,r);break;case 3:var Yh=p.updateQueue;if(null!==Yh){K=null;if(null!==p.child)switch(p.child.tag){case 5:K=
	p.child.stateNode;break;case 1:K=p.child.stateNode}Yf(p,Yh,K,r)}break;case 5:var Gj=p.stateNode;null===nc&&p.effectTag&4&&(r=Gj,Je(p.type,p.memoizedProps)&&r.focus());break;case 6:break;case 4:break;case 12:break;case 13:case 19:case 17:case 20:break;default:throw t(Error(163));}}if($a&128){var nd=Y.ref;if(null!==nd){var Zh=Y.stateNode;switch(Y.tag){case 5:var gf=Zh;break;default:gf=Zh}"function"===typeof nd?nd(gf):nd.current=gf}}$a&512&&(Pi=!0);Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));
	fi(Y,zb);Y=Y.nextEffect}while(null!==Y);Y=null;nf();U=f}else a.current=c;if(Pi)Pi=!1,Qi=a,Si=d,Ri=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0!==b?($a=cg(),$a=zf($a,b),Zi(a,$a,b)):xi=null;"function"===typeof pj&&pj(c.stateNode,d);1073741823===b?a===Vi?Ui++:(Ui=0,Vi=a):Ui=0;if(ui)throw ui=!1,a=vi,vi=null,a;if((U&Bi)!==T)return null;O();return null}
	function cj(){if(null===Qi)return!1;var a=Qi,b=Si,c=Ri;Qi=null;Si=0;Ri=90;return vf(97<c?97:c,qj.bind(null,a,b))}function qj(a){if((U&(Ci|Di))!==T)throw t(Error(331));var b=U;U|=Di;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:hi(Pg,Ig,c),hi(Ig,Og,c)}}catch(d){if(null===a)throw t(Error(330));fi(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}U=b;O();return!0}
	function rj(a,b,c){b=bi(c,b);b=ti(a,b,1073741823);Sf(a,b);a=Yi(a,1073741823);null!==a&&Zi(a,99,1073741823)}function fi(a,b){if(3===a.tag)rj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){rj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===xi||!xi.has(d))){a=bi(b,a);a=wi(c,a,1073741823);Sf(c,a);c=Yi(c,1073741823);null!==c&&Zi(c,99,1073741823);break}}c=c.return}}
	function kj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);Ji===a&&W===c?X===Hi||X===Gi&&1073741823===Ki&&sf()-pi<Oi?hj(a,W):Ni=!0:a.lastPendingTime<c||(b=a.pingTime,0!==b&&b<c||(a.pingTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),b=cg(),b=zf(b,c),Zi(a,b,c)))}function ri(a,b){var c=a.stateNode;null!==c&&c.delete(b);c=cg();b=dg(c,a,null);c=zf(c,b);a=Yi(a,b);null!==a&&Zi(a,c,b)}var mj=void 0;
	mj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||M.current)Lf=!0;else if(d<c){Lf=!1;switch(b.tag){case 3:Nh(b);Ch();break;case 5:Cg(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:N(b.type)&&Xe(b);break;case 4:Ag(b,b.stateNode.containerInfo);break;case 10:Hf(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Ph(a,b,c);J(P,P.current&
	Eg,b);b=Fh(a,b,c);return null!==b?b.sibling:null}J(P,P.current&Eg,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Rh(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);J(P,P.current,b);if(!d)return null}return Fh(a,b,c)}}else Lf=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Se(b,L.current);Kf(b,c);e=dh(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&
	null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;ih();if(N(d)){var f=!0;Xe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var h=d.getDerivedStateFromProps;"function"===typeof h&&bg(b,d,h,a);e.updater=fg;b.stateNode=e;e._reactInternalFiber=b;jg(b,d,a,c);b=Mh(null,b,d,!0,f,c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Bf(e);b.type=e;f=b.tag=sj(e);
	a=Af(e,a);switch(f){case 0:b=Jh(null,b,e,a,c);break;case 1:b=Lh(null,b,e,a,c);break;case 11:b=Eh(null,b,e,a,c);break;case 14:b=Gh(null,b,e,Af(e.type,a),d,c);break;default:throw t(Error(306),e,"");}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Jh(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Lh(a,b,d,e,c);case 3:Nh(b);d=b.updateQueue;if(null===d)throw t(Error(282));e=b.memoizedState;e=null!==e?e.element:null;Wf(b,d,b.pendingProps,
	null,c);d=b.memoizedState.element;if(d===e)Ch(),b=Fh(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)uh=Ne(b.stateNode.containerInfo.firstChild),th=b,e=vh=!0;e?(b.effectTag|=2,b.child=ug(b,null,d,c)):(S(a,b,d,c),Ch());b=b.child}return b;case 5:return Cg(b),null===a&&zh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,h=e.children,Ke(d,e)?h=null:null!==f&&Ke(d,f)&&(b.effectTag|=16),Kh(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):
	(S(a,b,h,c),b=b.child),b;case 6:return null===a&&zh(b),null;case 13:return Ph(a,b,c);case 4:return Ag(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=tg(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Eh(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;h=b.memoizedProps;
	f=e.value;Hf(b,f);if(null!==h){var g=h.value;f=hd(g,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(g,f):1073741823)|0;if(0===f){if(h.children===e.children&&!M.current){b=Fh(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){var k=g.dependencies;if(null!==k){h=g.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===g.tag&&(l=Qf(c,null),l.tag=2,Sf(g,l));g.expirationTime<c&&(g.expirationTime=c);l=g.alternate;null!==l&&l.expirationTime<
	c&&(l.expirationTime=c);Jf(g.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else h=10===g.tag?g.type===b.type?null:g.child:g.child;if(null!==h)h.return=g;else for(h=g;null!==h;){if(h===b){h=null;break}g=h.sibling;if(null!==g){g.return=h.return;h=g;break}h=h.return}g=h}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Kf(b,c),e=Mf(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=Af(e,b.pendingProps),
	f=Af(e.type,f),Gh(a,b,e,f,d,c);case 15:return Ih(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,N(d)?(a=!0,Xe(b)):a=!1,Kf(b,c),hg(b,d,e,c),jg(b,d,e,c),Mh(null,b,d,!0,a,c);case 19:return Rh(a,b,c)}throw t(Error(156));};var pj=null,ji=null;
	function tj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);pj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};ji=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function uj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function xh(a,b,c,d){return new uj(a,b,c,d)}
	function Hh(a){a=a.prototype;return!(!a||!a.isReactComponent)}function sj(a){if("function"===typeof a)return Hh(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gc)return 11;if(a===jc)return 14}return 2}
	function og(a,b){var c=a.alternate;null===c?(c=xh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function qg(a,b,c,d,e,f){var h=2;d=a;if("function"===typeof a)Hh(a)&&(h=1);else if("string"===typeof a)h=5;else a:switch(a){case ac:return sg(c.children,e,f,b);case fc:h=8;e|=7;break;case bc:h=8;e|=1;break;case cc:return a=xh(12,c,b,e|8),a.elementType=cc,a.type=cc,a.expirationTime=f,a;case hc:return a=xh(13,c,b,e),a.type=hc,a.elementType=hc,a.expirationTime=f,a;case ic:return a=xh(19,c,b,e),a.elementType=ic,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case dc:h=
	10;break a;case ec:h=9;break a;case gc:h=11;break a;case jc:h=14;break a;case kc:h=16;d=null;break a}throw t(Error(130),null==a?a:typeof a,"");}b=xh(h,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function sg(a,b,c,d){a=xh(7,a,d,b);a.expirationTime=c;return a}function pg(a,b,c){a=xh(6,a,null,b);a.expirationTime=c;return a}
	function rg(a,b,c){b=xh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function vj(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=this.firstBatch=null;this.pingTime=this.lastPendingTime=this.firstPendingTime=this.callbackExpirationTime=0}function wj(a,b,c){a=new vj(a,b,c);b=xh(3,null,null,2===b?7:1===b?3:0);a.current=b;return b.stateNode=a}
	function xj(a,b,c,d,e,f){var h=b.current;a:if(c){c=c._reactInternalFiber;b:{if(2!==ld(c)||1!==c.tag)throw t(Error(170));var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(N(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);throw t(Error(171));}if(1===c.tag){var k=c.type;if(N(k)){c=We(c,k,g);break a}}c=g}else c=Qe;null===b.context?b.context=c:b.pendingContext=c;b=f;e=Qf(d,e);e.payload={element:a};b=void 0===b?null:b;null!==b&&
	(e.callback=b);Sf(h,e);eg(h,d);return d}function yj(a,b,c,d){var e=b.current,f=cg(),h=$f.suspense;e=dg(f,e,h);return xj(a,b,c,e,h,d)}function zj(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Aj(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$b,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	Db=function(a,b,c){switch(b){case "input":Ec(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);if(!e)throw t(Error(90));Wb(d);Ec(d,e)}}}break;case "textarea":pe(a,c);break;case "select":b=c.value,null!=b&&me(a,!!c.multiple,b,!1)}};
	function Bj(a){var b=1073741821-25*(((1073741821-cg()+500)/25|0)+1);b<=Xi&&--b;this._expirationTime=Xi=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Bj.prototype.render=function(a){if(!this._defer)throw t(Error(250));this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Cj;xj(a,b,null,c,null,d._onCommit);return d};
	Bj.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Bj.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;if(!this._defer||null===b)throw t(Error(251));if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;if(null===d)throw t(Error(251));d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;b=c;if((U&(Ci|Di))!==T)throw t(Error(253));xf(Z.bind(null,a,b));O();b=this._next;this._next=
	null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=null,this._defer=!1};Bj.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Cj(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Cj.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Cj.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];if("function"!==typeof c)throw t(Error(191),c);c()}}};function Dj(a,b,c){this._internalRoot=wj(a,b,c)}function Ej(a,b){this._internalRoot=wj(a,2,b)}Ej.prototype.render=Dj.prototype.render=function(a,b){var c=this._internalRoot,d=new Cj;b=void 0===b?null:b;null!==b&&d.then(b);yj(a,c,null,d._onCommit);return d};
	Ej.prototype.unmount=Dj.prototype.unmount=function(a){var b=this._internalRoot,c=new Cj;a=void 0===a?null:a;null!==a&&c.then(a);yj(null,b,null,c._onCommit);return c};Ej.prototype.createBatch=function(){var a=new Bj(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};
	function Hj(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Jb=ej;Kb=fj;Lb=aj;Mb=function(a,b){var c=U;U|=2;try{return a(b)}finally{U=c,U===T&&O()}};function Ij(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Dj(a,0,b)}
	function Jj(a,b,c,d,e){var f=c._reactRootContainer,h=void 0;if(f){h=f._internalRoot;if("function"===typeof e){var g=e;e=function(){var a=zj(h);g.call(a)}}yj(b,h,a,e)}else{f=c._reactRootContainer=Ij(c,d);h=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=zj(h);k.call(a)}}gj(function(){yj(b,h,a,e)})}return zj(h)}function Kj(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!Hj(b))throw t(Error(200));return Aj(a,b,null,c)}
	var Nj={createPortal:Kj,findDOMNode:function(a){if(null==a)a=null;else if(1!==a.nodeType){var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw t(Error(188));throw t(Error(268),Object.keys(a));}a=qd(b);a=null===a?null:a.stateNode}return a},hydrate:function(a,b,c){if(!Hj(b))throw t(Error(200));return Jj(null,a,b,!0,c)},render:function(a,b,c){if(!Hj(b))throw t(Error(200));return Jj(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!Hj(c))throw t(Error(200));
	if(null==a||void 0===a._reactInternalFiber)throw t(Error(38));return Jj(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!Hj(a))throw t(Error(40));return a._reactRootContainer?(gj(function(){Jj(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Kj.apply(void 0,arguments)},unstable_batchedUpdates:ej,unstable_interactiveUpdates:function(a,b,c,d){aj();return fj(a,b,c,d)},unstable_discreteUpdates:fj,unstable_flushDiscreteUpdates:aj,flushSync:function(a,
	b){if((U&(Ci|Di))!==T)throw t(Error(187));var c=U;U|=1;try{return vf(99,a.bind(null,b))}finally{U=c,O()}},unstable_createRoot:Lj,unstable_createSyncRoot:Mj,unstable_flushControlled:function(a){var b=U;U|=1;try{vf(99,a)}finally{U=b,U===T&&O()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ca.injectEventPluginsByName,fa,Qa,function(a){ya(a,Pa)},Hb,Ib,Ud,Ba,cj,{current:!1}]}};
	function Lj(a,b){if(!Hj(a))throw t(Error(299),"unstable_createRoot");return new Ej(a,null!=b&&!0===b.hydrate)}function Mj(a,b){if(!Hj(a))throw t(Error(299),"unstable_createRoot");return new Dj(a,1,null!=b&&!0===b.hydrate)}
	(function(a){var b=a.findFiberByHostInstance;return tj(m({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Xb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=qd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.9.0",
	rendererPackageName:"react-dom"});var Oj={default:Nj},Pj=Oj&&Nj||Oj;module.exports=Pj.default||Pj;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(129);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(123);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(127);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(128);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(131);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(130);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(132);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _fuse = __webpack_require__(185);
	
	var _fuse2 = _interopRequireDefault(_fuse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  searchBoxStyle: {
	    border: '1px solid #eee',
	    borderRadius: 2,
	    padding: '8px 10px',
	    lineHeight: '24px',
	    width: '100%',
	    outline: 'none',
	    fontSize: 16,
	    color: '#666',
	    boxSizing: 'border-box',
	    fontFamily: 'inherit'
	  },
	  searchBoxWrapper: {
	    padding: '4px',
	    boxShadow: '0 4px 15px 4px rgba(0,0,0,0.2)',
	    borderRadius: 2,
	    backgroundColor: '#fff'
	  },
	  resultsStyle: {
	    backgroundColor: '#fff',
	    position: 'relative',
	    padding: '12px',
	    borderTop: '1px solid #eee',
	    color: '#666',
	    fontSize: 14,
	    cursor: 'pointer'
	  },
	  selectedResultStyle: {
	    backgroundColor: '#f9f9f9',
	    position: 'relative',
	    padding: '12px',
	    borderTop: '1px solid #eee',
	    color: '#666',
	    fontSize: 14,
	    cursor: 'pointer'
	  },
	  resultsWrapperStyle: {
	    width: '100%',
	    boxShadow: '0px 12px 30px 2px rgba(0, 0, 0, 0.1)',
	    border: '1px solid #eee',
	    borderTop: 0,
	    boxSizing: 'border-box',
	    maxHeight: 400,
	    overflow: 'auto',
	    position: 'relative'
	  }
	};
	
	function defaultResultsTemplate(props, state, styl, clickHandler) {
	  return state.results.map(function (val, i) {
	    var style = state.selectedIndex === i ? styl.selectedResultStyle : styl.resultsStyle;
	    return _react2.default.createElement(
	      'div',
	      { key: i, style: style, onClick: function onClick() {
	          return clickHandler(i);
	        } },
	      val.title
	    );
	  });
	}
	
	var FuzzySearch = function (_Component) {
	  (0, _inherits3.default)(FuzzySearch, _Component);
	
	  function FuzzySearch(props) {
	    (0, _classCallCheck3.default)(this, FuzzySearch);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FuzzySearch.__proto__ || (0, _getPrototypeOf2.default)(FuzzySearch)).call(this, props));
	
	    _this.state = {
	      results: [],
	      selectedIndex: 0,
	      selectedValue: {},
	      value: ''
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleMouseClick = _this.handleMouseClick.bind(_this);
	    _this.fuse = new _fuse2.default(props.list, _this.getOptions());
	    return _this;
	  }
	
	  (0, _createClass3.default)(FuzzySearch, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      var _props = this.props,
	          caseSensitive = _props.caseSensitive,
	          id = _props.id,
	          include = _props.include,
	          keys = _props.keys,
	          shouldSort = _props.shouldSort,
	          sortFn = _props.sortFn,
	          tokenize = _props.tokenize,
	          verbose = _props.verbose,
	          maxPatternLength = _props.maxPatternLength,
	          distance = _props.distance,
	          threshold = _props.threshold,
	          location = _props.location,
	          options = _props.options;
	
	
	      return (0, _extends3.default)({
	        caseSensitive: caseSensitive,
	        id: id,
	        include: include,
	        keys: keys,
	        shouldSort: shouldSort,
	        sortFn: sortFn,
	        tokenize: tokenize,
	        verbose: verbose,
	        maxPatternLength: maxPatternLength,
	        distance: distance,
	        threshold: threshold,
	        location: location
	      }, options);
	    }
	  }, {
	    key: 'getResultsTemplate',
	    value: function getResultsTemplate() {
	      var _this2 = this;
	
	      return this.state.results.map(function (val, i) {
	        var style = _this2.state.selectedIndex === i ? styles.selectedResultStyle : styles.resultsStyle;
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: style },
	          val.title
	        );
	      });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(e) {
	      this.setState({
	        results: this.fuse.search(e.target.value).slice(0, this.props.maxResults - 1),
	        value: e.target.value
	      });
	    }
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(e) {
	      var _state = this.state,
	          results = _state.results,
	          selectedIndex = _state.selectedIndex;
	
	      // Handle DOWN arrow
	
	      if (e.keyCode === 40 && selectedIndex < results.length - 1) {
	        this.setState({
	          selectedIndex: selectedIndex + 1
	        });
	
	        // Handle UP arrow
	      } else if (e.keyCode === 38 && selectedIndex > 0) {
	        this.setState({
	          selectedIndex: selectedIndex - 1
	        });
	
	        // Handle ENTER
	      } else if (e.keyCode === 13) {
	        if (results[selectedIndex]) {
	          this.props.onSelect(results[this.state.selectedIndex]);
	          this.setState({
	            selectedValue: results[this.state.selectedIndex]
	          });
	        }
	        this.setState({
	          results: [],
	          selectedIndex: 0,
	          value: results[this.state.selectedIndex].item.value
	        });
	      }
	    }
	  }, {
	    key: 'handleMouseClick',
	    value: function handleMouseClick(clickedIndex) {
	      var results = this.state.results;
	
	
	      if (results[clickedIndex]) {
	        this.props.onSelect(results[clickedIndex]);
	      }
	      this.setState({
	        results: [],
	        selectedIndex: 0,
	        value: results[this.state.selectedIndex].item.value
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          autoFocus = _props2.autoFocus,
	          className = _props2.className,
	          list = _props2.list,
	          placeholder = _props2.placeholder,
	          resultsTemplate = _props2.resultsTemplate,
	          width = _props2.width;
	
	      // Update the search space list
	
	      if (this.fuse.setCollection && list) {
	        this.fuse.setCollection(list);
	      }
	
	      var mainClass = (0, _classnames2.default)('react-fuzzy-search', className);
	
	      return _react2.default.createElement(
	        'div',
	        { className: mainClass, style: { width: width }, onKeyDown: this.handleKeyDown },
	        _react2.default.createElement(
	          'div',
	          { style: styles.searchBoxWrapper },
	          _react2.default.createElement('input', {
	            autoFocus: autoFocus,
	            onChange: this.handleChange,
	            placeholder: placeholder,
	            style: styles.searchBoxStyle,
	            type: 'text',
	            value: this.state.value
	          })
	        ),
	        this.state.results && this.state.results.length > 0 && _react2.default.createElement(
	          'div',
	          { style: styles.resultsWrapperStyle },
	          resultsTemplate(this.props, this.state, styles, this.handleMouseClick)
	        )
	      );
	    }
	  }]);
	  return FuzzySearch;
	}(_react.Component);
	
	FuzzySearch.propTypes = {
	  caseSensitive: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  distance: _propTypes2.default.number,
	  id: _propTypes2.default.string,
	  include: _propTypes2.default.array,
	  maxPatternLength: _propTypes2.default.number,
	  onSelect: _propTypes2.default.func.isRequired,
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  keys: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
	  list: _propTypes2.default.array.isRequired,
	  location: _propTypes2.default.number,
	  placeholder: _propTypes2.default.string,
	  resultsTemplate: _propTypes2.default.func,
	  shouldSort: _propTypes2.default.bool,
	  sortFn: _propTypes2.default.func,
	  threshold: _propTypes2.default.number,
	  tokenize: _propTypes2.default.bool,
	  verbose: _propTypes2.default.bool,
	  autoFocus: _propTypes2.default.bool,
	  maxResults: _propTypes2.default.number,
	  options: _propTypes2.default.object
	};
	FuzzySearch.defaultProps = {
	  caseSensitive: false,
	  distance: 100,
	  include: [],
	  location: 0,
	  width: 430,
	  placeholder: 'Search',
	  resultsTemplate: defaultResultsTemplate,
	  shouldSort: true,
	  sortFn: function sortFn(a, b) {
	    return a.score - b.score;
	  },
	
	  threshold: 0.6,
	  tokenize: false,
	  verbose: false,
	  autoFocus: false,
	  maxResults: 10
	};
	exports.default = FuzzySearch;

/***/ },
/* 195 */
/***/ function(module, exports) {

	/** @license React v16.9.0
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
	60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
	exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
	exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _leaflet = __webpack_require__(4);
	
	var _context = __webpack_require__(5);
	
	var _MapControl2 = _interopRequireDefault(__webpack_require__(30));
	
	var AttributionControl =
	/*#__PURE__*/
	function (_MapControl) {
	  (0, _inheritsLoose2.default)(AttributionControl, _MapControl);
	
	  function AttributionControl() {
	    return _MapControl.apply(this, arguments) || this;
	  }
	
	  var _proto = AttributionControl.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    return new _leaflet.Control.Attribution(props);
	  };
	
	  return AttributionControl;
	}(_MapControl2.default);
	
	var _default = (0, _context.withLeaflet)(AttributionControl);
	
	exports.default = _default;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _leaflet = __webpack_require__(4);
	
	var _context = __webpack_require__(5);
	
	var _Path2 = _interopRequireDefault(__webpack_require__(15));
	
	var Circle =
	/*#__PURE__*/
	function (_Path) {
	  (0, _inheritsLoose2.default)(Circle, _Path);
	
	  function Circle() {
	    return _Path.apply(this, arguments) || this;
	  }
	
	  var _proto = Circle.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    var center = props.center,
	        radius = props.radius,
	        options = (0, _objectWithoutPropertiesLoose2.default)(props, ["center", "radius"]);
	    return new _leaflet.Circle(center, radius, this.getOptions(options));
	  };
	
	  _proto.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
	    if (toProps.center !== fromProps.center) {
	      this.leafletElement.setLatLng(toProps.center);
	    }
	
	    if (toProps.radius !== fromProps.radius) {
	      this.leafletElement.setRadius(toProps.radius);
	    }
	  };
	
	  return Circle;
	}(_Path2.default);
	
	var _default = (0, _context.withLeaflet)(Circle);
	
	exports.default = _default;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _leaflet = __webpack_require__(4);
	
	var _context = __webpack_require__(5);
	
	var _Path2 = _interopRequireDefault(__webpack_require__(15));
	
	var CircleMarker =
	/*#__PURE__*/
	function (_Path) {
	  (0, _inheritsLoose2.default)(CircleMarker, _Path);
	
	  function CircleMarker() {
	    return _Path.apply(this, arguments) || this;
	  }
	
	  var _proto = CircleMarker.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    var el = new _leaflet.CircleMarker(props.center, this.getOptions(props));
	    this.contextValue = (0, _extends2.default)({}, props.leaflet, {
	      popupContainer: el
	    });
	    return el;
	  };
	
	  _proto.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
	    if (toProps.center !== fromProps.center) {
	      this.leafletElement.setLatLng(toProps.center);
	    }
	
	    if (toProps.radius !== fromProps.radius) {
	      this.leafletElement.setRadius(toProps.radius);
	    }
	  };
	
	  return CircleMarker;
	}(_Path2.default);
	
	var _default = (0, _context.withLeaflet)(CircleMarker);
	
	exports.default = _default;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _leaflet = __webpack_require__(4);
	
	var _context = __webpack_require__(5);
	
	var _Path2 = _interopRequireDefault(__webpack_require__(15));
	
	var FeatureGroup =
	/*#__PURE__*/
	function (_Path) {
	  (0, _inheritsLoose2.default)(FeatureGroup, _Path);
	
	  function FeatureGroup() {
	    return _Path.apply(this, arguments) || this;
	  }
	
	  var _proto = FeatureGroup.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    var el = new _leaflet.FeatureGroup(this.getOptions(props));
	    this.contextValue = (0, _extends2.default)({}, props.leaflet, {
	      layerContainer: el,
	      popupContainer: el
	    });
	    return el;
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    _Path.prototype.componentDidMount.call(this);
	
	    this.setStyle(this.props);
	  };
	
	  return FeatureGroup;
	}(_Path2.default);
	
	var _default = (0, _context.withLeaflet)(FeatureGroup);
	
	exports.default = _default;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _leaflet = __webpack_require__(4);
	
	var _context = __webpack_require__(5);
	
	var _Path2 = _interopRequireDefault(__webpack_require__(15));
	
	var GeoJSON =
	/*#__PURE__*/
	function (_Path) {
	  (0, _inheritsLoose2.default)(GeoJSON, _Path);
	
	  function GeoJSON() {
	    return _Path.apply(this, arguments) || this;
	  }
	
	  var _proto = GeoJSON.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    return new _leaflet.GeoJSON(props.data, this.getOptions(props));
	  };
	
	  _proto.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
	    if (typeof toProps.style === 'function') {
	      this.leafletElement.setStyle(toProps.style);
	    } else {
	      this.setStyleIfChanged(fromProps, toProps);
	    }
	  };
	
	  return GeoJSON;
	}(_Path2.default);
	
	var _default = (0, _context.withLeaflet)(GeoJSON);
	
	exports.default = _default;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _leaflet = __webpack_require__(4);
	
	var _context = __webpack_require__(5);
	
	var _MapLayer2 = _interopRequireDefault(__webpack_require__(21));
	
	var ImageOverlay =
	/*#__PURE__*/
	function (_MapLayer) {
	  (0, _inheritsLoose2.default)(ImageOverlay, _MapLayer);
	
	  function ImageOverlay() {
	    return _MapLayer.apply(this, arguments) || this;
	  }
	
	  var _proto = ImageOverlay.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    var el = new _leaflet.ImageOverlay(props.url, props.bounds, this.getOptions(props));
	    this.contextValue = (0, _extends2.default)({}, props.leaflet, {
	      popupContainer: el
	    });
	    return el;
	  };
	
	  _proto.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
	    if (toProps.url !== fromProps.url) {
	      this.leafletElement.setUrl(toProps.url);
	    }
	
	    if (toProps.bounds !== fromProps.bounds) {
	      this.leafletElement.setBounds((0, _leaflet.latLngBounds)(toProps.bounds));
	    }
	
	    if (toProps.opacity !== fromProps.opacity) {
	      this.leafletElement.setOpacity(toProps.opacity);
	    }
	
	    if (toProps.zIndex !== fromProps.zIndex) {
	      this.leafletElement.setZIndex(toProps.zIndex);
	    }
	  };
	
	  return ImageOverlay;
	}(_MapLayer2.default);
	
	var _default = (0, _context.withLeaflet)(ImageOverlay);
	
	exports.default = _default;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _leaflet = __webpack_require__(4);
	
	var _context = __webpack_require__(5);
	
	var _MapLayer2 = _interopRequireDefault(__webpack_require__(21));
	
	var LayerGroup =
	/*#__PURE__*/
	function (_MapLayer) {
	  (0, _inheritsLoose2.default)(LayerGroup, _MapLayer);
	
	  function LayerGroup() {
	    return _MapLayer.apply(this, arguments) || this;
	  }
	
	  var _proto = LayerGroup.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    var el = new _leaflet.LayerGroup([], this.getOptions(props));
	    this.contextValue = (0, _extends2.default)({}, props.leaflet, {
	      layerContainer: el
	    });
	    return el;
	  };
	
	  return LayerGroup;
	}(_MapLayer2.default);
	
	var _default = (0, _context.withLeaflet)(LayerGroup);
	
	exports.default = _default;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(16);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = exports.ControlledLayer = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(17));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _leaflet = __webpack_require__(4);
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _context = __webpack_require__(5);
	
	var _MapControl2 = _interopRequireDefault(__webpack_require__(30));
	
	// Abtract class for layer container, extended by BaseLayer and Overlay
	var ControlledLayer =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(ControlledLayer, _Component);
	
	  function ControlledLayer() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "contextValue", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "layer", void 0);
	    return _this;
	  }
	
	  var _proto = ControlledLayer.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate(_ref) {
	    var checked = _ref.checked;
	
	    if (this.props.leaflet.map == null) {
	      return;
	    } // Handle dynamically (un)checking the layer => adding/removing from the map
	
	
	    if (this.props.checked === true && (checked == null || checked === false)) {
	      this.props.leaflet.map.addLayer(this.layer);
	    } else if (checked === true && (this.props.checked == null || this.props.checked === false)) {
	      this.props.leaflet.map.removeLayer(this.layer);
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.props.removeLayerControl(this.layer);
	  };
	
	  _proto.addLayer = function addLayer() {
	    throw new Error('Must be implemented in extending class');
	  };
	
	  _proto.removeLayer = function removeLayer(layer) {
	    this.props.removeLayer(layer);
	  };
	
	  _proto.render = function render() {
	    var children = this.props.children;
	    return children ? _react.default.createElement(_context.LeafletProvider, {
	      value: this.contextValue
	    }, children) : null;
	  };
	
	  return ControlledLayer;
	}(_react.Component);
	
	exports.ControlledLayer = ControlledLayer;
	
	var BaseLayer =
	/*#__PURE__*/
	function (_ControlledLayer) {
	  (0, _inheritsLoose2.default)(BaseLayer, _ControlledLayer);
	
	  function BaseLayer(props) {
	    var _this2;
	
	    _this2 = _ControlledLayer.call(this, props) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "addLayer", function (layer) {
	      _this2.layer = layer; // Keep layer reference to handle dynamic changes of props
	
	      var _this2$props = _this2.props,
	          addBaseLayer = _this2$props.addBaseLayer,
	          checked = _this2$props.checked,
	          name = _this2$props.name;
	      addBaseLayer(layer, name, checked);
	    });
	    _this2.contextValue = (0, _extends2.default)({}, props.leaflet, {
	      layerContainer: {
	        addLayer: _this2.addLayer.bind((0, _assertThisInitialized2.default)(_this2)),
	        removeLayer: _this2.removeLayer.bind((0, _assertThisInitialized2.default)(_this2))
	      }
	    });
	    return _this2;
	  }
	
	  return BaseLayer;
	}(ControlledLayer);
	
	var Overlay =
	/*#__PURE__*/
	function (_ControlledLayer2) {
	  (0, _inheritsLoose2.default)(Overlay, _ControlledLayer2);
	
	  function Overlay(props) {
	    var _this3;
	
	    _this3 = _ControlledLayer2.call(this, props) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "addLayer", function (layer) {
	      _this3.layer = layer; // Keep layer reference to handle dynamic changes of props
	
	      var _this3$props = _this3.props,
	          addOverlay = _this3$props.addOverlay,
	          checked = _this3$props.checked,
	          name = _this3$props.name;
	      addOverlay(layer, name, checked);
	    });
	    _this3.contextValue = (0, _extends2.default)({}, props.leaflet, {
	      layerContainer: {
	        addLayer: _this3.addLayer.bind((0, _assertThisInitialized2.default)(_this3)),
	        removeLayer: _this3.removeLayer.bind((0, _assertThisInitialized2.default)(_this3))
	      }
	    });
	    return _this3;
	  }
	
	  return Overlay;
	}(ControlledLayer);
	
	var LayersControl =
	/*#__PURE__*/
	function (_MapControl) {
	  (0, _inheritsLoose2.default)(LayersControl, _MapControl);
	
	  function LayersControl(props) {
	    var _this4;
	
	    _this4 = _MapControl.call(this, props) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this4), "controlProps", void 0);
	    _this4.controlProps = {
	      addBaseLayer: _this4.addBaseLayer.bind((0, _assertThisInitialized2.default)(_this4)),
	      addOverlay: _this4.addOverlay.bind((0, _assertThisInitialized2.default)(_this4)),
	      leaflet: props.leaflet,
	      removeLayer: _this4.removeLayer.bind((0, _assertThisInitialized2.default)(_this4)),
	      removeLayerControl: _this4.removeLayerControl.bind((0, _assertThisInitialized2.default)(_this4))
	    };
	    return _this4;
	  }
	
	  var _proto2 = LayersControl.prototype;
	
	  _proto2.createLeafletElement = function createLeafletElement(props) {
	    var _children = props.children,
	        options = (0, _objectWithoutPropertiesLoose2.default)(props, ["children"]);
	    return new _leaflet.Control.Layers(undefined, undefined, options);
	  };
	
	  _proto2.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
	    _MapControl.prototype.updateLeafletElement.call(this, fromProps, toProps);
	
	    if (toProps.collapsed !== fromProps.collapsed) {
	      if (toProps.collapsed === true) {
	        this.leafletElement.collapse();
	      } else {
	        this.leafletElement.expand();
	      }
	    }
	  };
	
	  _proto2.componentWillUnmount = function componentWillUnmount() {
	    var _this5 = this;
	
	    setTimeout(function () {
	      _MapControl.prototype.componentWillUnmount.call(_this5);
	    }, 0);
	  };
	
	  _proto2.addBaseLayer = function addBaseLayer(layer, name, checked) {
	    if (checked === void 0) {
	      checked = false;
	    }
	
	    if (checked && this.props.leaflet.map != null) {
	      this.props.leaflet.map.addLayer(layer);
	    }
	
	    this.leafletElement.addBaseLayer(layer, name);
	  };
	
	  _proto2.addOverlay = function addOverlay(layer, name, checked) {
	    if (checked === void 0) {
	      checked = false;
	    }
	
	    if (checked && this.props.leaflet.map != null) {
	      this.props.leaflet.map.addLayer(layer);
	    }
	
	    this.leafletElement.addOverlay(layer, name);
	  };
	
	  _proto2.removeLayer = function removeLayer(layer) {
	    if (this.props.leaflet.map != null) {
	      this.props.leaflet.map.removeLayer(layer);
	    }
	  };
	
	  _proto2.removeLayerControl = function removeLayerControl(layer) {
	    this.leafletElement.removeLayer(layer);
	  };
	
	  _proto2.render = function render() {
	    var _this6 = this;
	
	    var children = _react.Children.map(this.props.children, function (child) {
	      return child ? (0, _react.cloneElement)(child, _this6.controlProps) : null;
	    });
	
	    return _react.default.createElement(_react.Fragment, null, children);
	  };
	
	  return LayersControl;
	}(_MapControl2.default);
	
	var LayersControlExport = (0, _context.withLeaflet)(LayersControl);
	LayersControlExport.BaseLayer = BaseLayer;
	LayersControlExport.Overlay = Overlay;
	var _default = LayersControlExport;
	exports.default = _default;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(17));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _leaflet = __webpack_require__(4);
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _context = __webpack_require__(5);
	
	var _MapEvented2 = _interopRequireDefault(__webpack_require__(37));
	
	var _updateClassName = _interopRequireDefault(__webpack_require__(57));
	
	var _omit = _interopRequireDefault(__webpack_require__(78));
	
	var OTHER_PROPS = ['children', 'className', 'id', 'style', 'useFlyTo', 'whenReady'];
	
	var normalizeCenter = function normalizeCenter(pos) {
	  return Array.isArray(pos) ? [pos[0], pos[1]] : [pos.lat, pos.lon ? pos.lon : pos.lng];
	};
	
	var Map =
	/*#__PURE__*/
	function (_MapEvented) {
	  (0, _inheritsLoose2.default)(Map, _MapEvented);
	
	  function Map(props) {
	    var _this;
	
	    _this = _MapEvented.call(this, props) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "className", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "contextValue", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "container", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "viewport", {
	      center: undefined,
	      zoom: undefined
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_ready", false);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_updating", false);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onViewportChange", function () {
	      var center = _this.leafletElement.getCenter();
	
	      _this.viewport = {
	        center: center ? [center.lat, center.lng] : undefined,
	        zoom: _this.leafletElement.getZoom()
	      };
	
	      if (_this.props.onViewportChange && !_this._updating) {
	        _this.props.onViewportChange(_this.viewport);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onViewportChanged", function () {
	      if (_this.props.onViewportChanged && !_this._updating) {
	        _this.props.onViewportChanged(_this.viewport);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "bindContainer", function (container) {
	      _this.container = container;
	    });
	    _this.className = props.className;
	    return _this;
	  }
	
	  var _proto = Map.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    var viewport = props.viewport,
	        options = (0, _objectWithoutPropertiesLoose2.default)(props, ["viewport"]);
	
	    if (viewport) {
	      if (viewport.center) {
	        options.center = viewport.center;
	      }
	
	      if (typeof viewport.zoom === 'number') {
	        options.zoom = viewport.zoom;
	      }
	    }
	
	    return new _leaflet.Map(this.container, options);
	  };
	
	  _proto.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
	    this._updating = true;
	    var bounds = toProps.bounds,
	        boundsOptions = toProps.boundsOptions,
	        boxZoom = toProps.boxZoom,
	        center = toProps.center,
	        className = toProps.className,
	        doubleClickZoom = toProps.doubleClickZoom,
	        dragging = toProps.dragging,
	        keyboard = toProps.keyboard,
	        maxBounds = toProps.maxBounds,
	        scrollWheelZoom = toProps.scrollWheelZoom,
	        tap = toProps.tap,
	        touchZoom = toProps.touchZoom,
	        useFlyTo = toProps.useFlyTo,
	        viewport = toProps.viewport,
	        zoom = toProps.zoom;
	    (0, _updateClassName.default)(this.container, fromProps.className, className);
	
	    if (viewport && viewport !== fromProps.viewport) {
	      var c = viewport.center ? viewport.center : center;
	      var z = viewport.zoom == null ? zoom : viewport.zoom;
	
	      if (useFlyTo === true) {
	        this.leafletElement.flyTo(c, z, this.getZoomPanOptions(toProps));
	      } else {
	        this.leafletElement.setView(c, z, this.getZoomPanOptions(toProps));
	      }
	    } else if (center && this.shouldUpdateCenter(center, fromProps.center)) {
	      if (useFlyTo === true) {
	        this.leafletElement.flyTo(center, zoom, this.getZoomPanOptions(toProps));
	      } else {
	        this.leafletElement.setView(center, zoom, this.getZoomPanOptions(toProps));
	      }
	    } else if (typeof zoom === 'number' && zoom !== fromProps.zoom) {
	      if (fromProps.zoom == null) {
	        this.leafletElement.setView(center, zoom, this.getZoomPanOptions(toProps));
	      } else {
	        this.leafletElement.setZoom(zoom, this.getZoomPanOptions(toProps));
	      }
	    }
	
	    if (maxBounds && this.shouldUpdateBounds(maxBounds, fromProps.maxBounds)) {
	      this.leafletElement.setMaxBounds(maxBounds);
	    }
	
	    if (bounds && (this.shouldUpdateBounds(bounds, fromProps.bounds) || boundsOptions !== fromProps.boundsOptions)) {
	      if (useFlyTo === true) {
	        this.leafletElement.flyToBounds(bounds, this.getFitBoundsOptions(toProps));
	      } else {
	        this.leafletElement.fitBounds(bounds, this.getFitBoundsOptions(toProps));
	      }
	    }
	
	    if (boxZoom !== fromProps.boxZoom) {
	      if (boxZoom === true) {
	        this.leafletElement.boxZoom.enable();
	      } else {
	        this.leafletElement.boxZoom.disable();
	      }
	    }
	
	    if (doubleClickZoom !== fromProps.doubleClickZoom) {
	      if (doubleClickZoom === true) {
	        this.leafletElement.doubleClickZoom.enable();
	      } else {
	        this.leafletElement.doubleClickZoom.disable();
	      }
	    }
	
	    if (dragging !== fromProps.dragging) {
	      if (dragging === true) {
	        this.leafletElement.dragging.enable();
	      } else {
	        this.leafletElement.dragging.disable();
	      }
	    }
	
	    if (keyboard !== fromProps.keyboard) {
	      if (keyboard === true) {
	        this.leafletElement.keyboard.enable();
	      } else {
	        this.leafletElement.keyboard.disable();
	      }
	    }
	
	    if (scrollWheelZoom !== fromProps.scrollWheelZoom) {
	      if (scrollWheelZoom === true || typeof scrollWheelZoom === 'string') {
	        this.leafletElement.options.scrollWheelZoom = scrollWheelZoom;
	        this.leafletElement.scrollWheelZoom.enable();
	      } else {
	        this.leafletElement.scrollWheelZoom.disable();
	      }
	    }
	
	    if (tap !== fromProps.tap) {
	      if (tap === true) {
	        this.leafletElement.tap.enable();
	      } else {
	        this.leafletElement.tap.disable();
	      }
	    }
	
	    if (touchZoom !== fromProps.touchZoom) {
	      if (touchZoom === true || typeof touchZoom === 'string') {
	        this.leafletElement.options.touchZoom = touchZoom;
	        this.leafletElement.touchZoom.enable();
	      } else {
	        this.leafletElement.touchZoom.disable();
	      }
	    }
	
	    this._updating = false;
	  };
	
	  _proto.getZoomPanOptions = function getZoomPanOptions(props) {
	    var animate = props.animate,
	        duration = props.duration,
	        easeLinearity = props.easeLinearity,
	        noMoveStart = props.noMoveStart;
	    return {
	      animate: animate,
	      duration: duration,
	      easeLinearity: easeLinearity,
	      noMoveStart: noMoveStart
	    };
	  };
	
	  _proto.getFitBoundsOptions = function getFitBoundsOptions(props) {
	    var zoomPanOptions = this.getZoomPanOptions(props);
	    return (0, _extends2.default)({}, zoomPanOptions, props.boundsOptions);
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    var props = _omit.default.apply(void 0, [this.props].concat(OTHER_PROPS));
	
	    this.leafletElement = this.createLeafletElement(props);
	    this.leafletElement.on('move', this.onViewportChange);
	    this.leafletElement.on('moveend', this.onViewportChanged);
	
	    if (props.bounds != null) {
	      this.leafletElement.fitBounds(props.bounds, this.getFitBoundsOptions(props));
	    }
	
	    this.contextValue = {
	      layerContainer: this.leafletElement,
	      map: this.leafletElement
	    };
	
	    _MapEvented.prototype.componentDidMount.call(this);
	
	    this.forceUpdate(); // Re-render now that leafletElement is created
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this._ready === false) {
	      this._ready = true;
	
	      if (this.props.whenReady) {
	        this.leafletElement.whenReady(this.props.whenReady);
	      }
	    }
	
	    _MapEvented.prototype.componentDidUpdate.call(this, prevProps);
	
	    this.updateLeafletElement(prevProps, this.props);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    _MapEvented.prototype.componentWillUnmount.call(this);
	
	    this.leafletElement.off('move', this.onViewportChange);
	    this.leafletElement.off('moveend', this.onViewportChanged); // The canvas renderer uses requestAnimationFrame, making a deferred call to a deleted object
	    // When preferCanvas is set, use simpler teardown logic
	
	    if (this.props.preferCanvas === true) {
	      this.leafletElement._initEvents(true);
	
	      this.leafletElement._stop();
	    } else {
	      this.leafletElement.remove();
	    }
	  };
	
	  _proto.shouldUpdateCenter = function shouldUpdateCenter(next, prev) {
	    if (!prev) return true;
	    next = normalizeCenter(next);
	    prev = normalizeCenter(prev);
	    return next[0] !== prev[0] || next[1] !== prev[1];
	  };
	
	  _proto.shouldUpdateBounds = function shouldUpdateBounds(next, prev) {
	    return prev ? !(0, _leaflet.latLngBounds)(next).equals((0, _leaflet.latLngBounds)(prev)) : true;
	  };
	
	  _proto.render = function render() {
	    return _react.default.createElement("div", {
	      className: this.className,
	      id: this.props.id,
	      ref: this.bindContainer,
	      style: this.props.style
	    }, this.contextValue ? _react.default.createElement(_context.LeafletProvider, {
	      value: this.contextValue
	    }, this.props.children) : null);
	  };
	
	  return Map;
	}(_MapEvented2.default);
	
	exports.default = Map;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _leaflet = __webpack_require__(4);
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _context = __webpack_require__(5);
	
	var _MapLayer2 = _interopRequireDefault(__webpack_require__(21));
	
	var Marker =
	/*#__PURE__*/
	function (_MapLayer) {
	  (0, _inheritsLoose2.default)(Marker, _MapLayer);
	
	  function Marker() {
	    return _MapLayer.apply(this, arguments) || this;
	  }
	
	  var _proto = Marker.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    var el = new _leaflet.Marker(props.position, this.getOptions(props));
	    this.contextValue = (0, _extends2.default)({}, props.leaflet, {
	      popupContainer: el
	    });
	    return el;
	  };
	
	  _proto.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
	    if (toProps.position !== fromProps.position) {
	      this.leafletElement.setLatLng(toProps.position);
	    }
	
	    if (toProps.icon !== fromProps.icon) {
	      this.leafletElement.setIcon(toProps.icon);
	    }
	
	    if (toProps.zIndexOffset !== fromProps.zIndexOffset) {
	      this.leafletElement.setZIndexOffset(toProps.zIndexOffset);
	    }
	
	    if (toProps.opacity !== fromProps.opacity) {
	      this.leafletElement.setOpacity(toProps.opacity);
	    }
	
	    if (toProps.draggable !== fromProps.draggable) {
	      if (toProps.draggable === true) {
	        this.leafletElement.dragging.enable();
	      } else {
	        this.leafletElement.dragging.disable();
	      }
	    }
	  };
	
	  _proto.render = function render() {
	    var children = this.props.children;
	    return children == null || this.contextValue == null ? null : _react.default.createElement(_context.LeafletProvider, {
	      value: this.contextValue
	    }, children);
	  };
	
	  return Marker;
	}(_MapLayer2.default);
	
	var _default = (0, _context.withLeaflet)(Marker);
	
	exports.default = _default;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(16);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _warning = _interopRequireDefault(__webpack_require__(243));
	
	var _context = __webpack_require__(5);
	
	var _updateClassName = __webpack_require__(57);
	
	var _omit = _interopRequireDefault(__webpack_require__(78));
	
	// flowlint sketchy-null-string:off
	var idCounter = 0;
	
	var uniqueId = function uniqueId() {
	  return ++idCounter;
	};
	
	var LEAFLET_PANES = ['tile', 'shadow', 'overlay', 'map', 'marker', 'tooltip', 'popup'];
	var PANE_RE = /-*pane/gi;
	
	var isLeafletPane = function isLeafletPane(name) {
	  return LEAFLET_PANES.indexOf(name.replace(PANE_RE, '')) !== -1;
	};
	
	var paneStyles = {
	  position: 'absolute',
	  top: 0,
	  right: 0,
	  bottom: 0,
	  left: 0
	};
	
	var Pane =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(Pane, _Component);
	
	  function Pane() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
	      name: undefined,
	      context: undefined
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setStyle", function (_temp) {
	      var _ref = _temp === void 0 ? _this.props : _temp,
	          style = _ref.style,
	          className = _ref.className;
	
	      var pane = _this.getPane(_this.state.name);
	
	      if (pane) {
	        if (className) {
	          (0, _updateClassName.addClassName)(pane, className);
	        }
	
	        if (style) {
	          // Without the cast, Flow throws this error:
	          //   Cannot assign style[key] to pane.style[key] because string
	          //   is incompatible with number.
	          Object.keys(style).forEach(function (key) {
	            pane.style[key] = style[key];
	          });
	        }
	      }
	    });
	    return _this;
	  }
	
	  var _proto = Pane.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.createPane(this.props);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (!this.state.name) {
	      // Do nothing if this.state.name is undefined due to errors or
	      // an invalid props.name value
	      return;
	    } // If the 'name' prop has changed the current pane is unmounted and a new
	    // pane is created.
	
	
	    if (this.props.name !== prevProps.name) {
	      this.removePane();
	      this.createPane(this.props);
	    } else {
	      // Remove the previous css class name from the pane if it has changed.
	      // setStyle() will take care of adding in the updated className
	      if (prevProps.className && this.props.className !== prevProps.className) {
	        var pane = this.getPane(this.state.name);
	
	        if (pane != null && prevProps.className != null) {
	          (0, _updateClassName.removeClassName)(pane, prevProps.className);
	        }
	      } // Update the pane's DOM node style and class
	
	
	      this.setStyle(this.props);
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.removePane();
	  };
	
	  _proto.createPane = function createPane(props) {
	    var map = props.leaflet.map;
	    var name = props.name || "pane-" + uniqueId();
	
	    if (map != null && map.createPane != null) {
	      var isDefault = isLeafletPane(name);
	      var existing = isDefault || this.getPane(name);
	
	      if (existing == null) {
	        map.createPane(name, this.getParentPane());
	      } else {
	        var message = isDefault ? "You must use a unique name for a pane that is not a default leaflet pane (" + name + ")" : "A pane with this name already exists. (" + name + ")";
	         false ? (0, _warning.default)(false, message) : void 0;
	      }
	
	      this.setState({
	        name: name,
	        context: (0, _extends2.default)({}, props.leaflet, {
	          pane: name
	        })
	      }, this.setStyle);
	    }
	  };
	
	  _proto.removePane = function removePane() {
	    // Remove the created pane
	    var name = this.state.name;
	
	    if (name != null) {
	      var pane = this.getPane(name);
	      if (pane != null && pane.remove) pane.remove();
	      var map = this.props.leaflet.map;
	
	      if (map != null && map._panes != null) {
	        map._panes = (0, _omit.default)(map._panes, name);
	        map._paneRenderers = (0, _omit.default)(map._paneRenderers, name);
	      }
	    }
	  };
	
	  _proto.getParentPane = function getParentPane() {
	    return this.getPane(this.props.pane || this.props.leaflet.pane);
	  };
	
	  _proto.getPane = function getPane(name) {
	    if (name != null && this.props.leaflet.map != null) {
	      return this.props.leaflet.map.getPane(name);
	    }
	  };
	
	  _proto.render = function render() {
	    var context = this.state.context;
	    return context ? _react.default.createElement(_context.LeafletProvider, {
	      value: context
	    }, _react.default.createElement("div", {
	      style: paneStyles
	    }, this.props.children)) : null;
	  };
	
	  return Pane;
	}(_react.Component);
	
	var _default = (0, _context.withLeaflet)(Pane);
	
	exports.default = _default;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _leaflet = __webpack_require__(4);
	
	var _context = __webpack_require__(5);
	
	var _Path2 = _interopRequireDefault(__webpack_require__(15));
	
	var Polygon =
	/*#__PURE__*/
	function (_Path) {
	  (0, _inheritsLoose2.default)(Polygon, _Path);
	
	  function Polygon() {
	    return _Path.apply(this, arguments) || this;
	  }
	
	  var _proto = Polygon.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    return new _leaflet.Polygon(props.positions, this.getOptions(props));
	  };
	
	  _proto.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
	    if (toProps.positions !== fromProps.positions) {
	      this.leafletElement.setLatLngs(toProps.positions);
	    }
	
	    this.setStyleIfChanged(fromProps, toProps);
	  };
	
	  return Polygon;
	}(_Path2.default);
	
	var _default = (0, _context.withLeaflet)(Polygon);
	
	exports.default = _default;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _leaflet = __webpack_require__(4);
	
	var _context = __webpack_require__(5);
	
	var _Path2 = _interopRequireDefault(__webpack_require__(15));
	
	var Polyline =
	/*#__PURE__*/
	function (_Path) {
	  (0, _inheritsLoose2.default)(Polyline, _Path);
	
	  function Polyline() {
	    return _Path.apply(this, arguments) || this;
	  }
	
	  var _proto = Polyline.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    return new _leaflet.Polyline(props.positions, this.getOptions(props));
	  };
	
	  _proto.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
	    if (toProps.positions !== fromProps.positions) {
	      this.leafletElement.setLatLngs(toProps.positions);
	    }
	
	    this.setStyleIfChanged(fromProps, toProps);
	  };
	
	  return Polyline;
	}(_Path2.default);
	
	var _default = (0, _context.withLeaflet)(Polyline);
	
	exports.default = _default;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _leaflet = __webpack_require__(4);
	
	var _context = __webpack_require__(5);
	
	var _DivOverlay2 = _interopRequireDefault(__webpack_require__(53));
	
	var Popup =
	/*#__PURE__*/
	function (_DivOverlay) {
	  (0, _inheritsLoose2.default)(Popup, _DivOverlay);
	
	  function Popup() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _DivOverlay.call.apply(_DivOverlay, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPopupOpen", function (_ref) {
	      var popup = _ref.popup;
	
	      if (popup === _this.leafletElement) {
	        _this.onOpen();
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPopupClose", function (_ref2) {
	      var popup = _ref2.popup;
	
	      if (popup === _this.leafletElement) {
	        _this.onClose();
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRender", function () {
	      if (_this.props.autoPan !== false && _this.leafletElement.isOpen()) {
	        if (_this.leafletElement._map && _this.leafletElement._map._panAnim) {
	          _this.leafletElement._map._panAnim = undefined;
	        }
	
	        _this.leafletElement._adjustPan();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = Popup.prototype;
	
	  _proto.getOptions = function getOptions(props) {
	    return (0, _extends2.default)({}, _DivOverlay.prototype.getOptions.call(this, props), {
	      autoPan: false
	    });
	  };
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    var options = this.getOptions(props);
	    options.autoPan = props.autoPan !== false;
	    return new _leaflet.Popup(options, props.leaflet.popupContainer);
	  };
	
	  _proto.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
	    if (toProps.position !== fromProps.position) {
	      this.leafletElement.setLatLng(toProps.position);
	    }
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    var position = this.props.position;
	    var _this$props$leaflet = this.props.leaflet,
	        map = _this$props$leaflet.map,
	        popupContainer = _this$props$leaflet.popupContainer;
	    var el = this.leafletElement;
	
	    if (map != null) {
	      map.on({
	        popupopen: this.onPopupOpen,
	        popupclose: this.onPopupClose
	      });
	    }
	
	    if (popupContainer) {
	      // Attach to container component
	      popupContainer.bindPopup(el);
	    } else {
	      // Attach to a Map
	      if (position) {
	        el.setLatLng(position);
	      }
	
	      el.openOn(map);
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    var map = this.props.leaflet.map;
	
	    if (map != null) {
	      map.off({
	        popupopen: this.onPopupOpen,
	        popupclose: this.onPopupClose
	      });
	      map.removeLayer(this.leafletElement);
	    }
	
	    _DivOverlay.prototype.componentWillUnmount.call(this);
	  };
	
	  return Popup;
	}(_DivOverlay2.default);
	
	(0, _defineProperty2.default)(Popup, "defaultProps", {
	  pane: 'popupPane'
	});
	
	var _default = (0, _context.withLeaflet)(Popup);
	
	exports.default = _default;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _leaflet = __webpack_require__(4);
	
	var _context = __webpack_require__(5);
	
	var _Path2 = _interopRequireDefault(__webpack_require__(15));
	
	var Rectangle =
	/*#__PURE__*/
	function (_Path) {
	  (0, _inheritsLoose2.default)(Rectangle, _Path);
	
	  function Rectangle() {
	    return _Path.apply(this, arguments) || this;
	  }
	
	  var _proto = Rectangle.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    return new _leaflet.Rectangle(props.bounds, this.getOptions(props));
	  };
	
	  _proto.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
	    if (toProps.bounds !== fromProps.bounds) {
	      this.leafletElement.setBounds(toProps.bounds);
	    }
	
	    this.setStyleIfChanged(fromProps, toProps);
	  };
	
	  return Rectangle;
	}(_Path2.default);
	
	var _default = (0, _context.withLeaflet)(Rectangle);
	
	exports.default = _default;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _leaflet = __webpack_require__(4);
	
	var _context = __webpack_require__(5);
	
	var _MapControl2 = _interopRequireDefault(__webpack_require__(30));
	
	var ScaleControl =
	/*#__PURE__*/
	function (_MapControl) {
	  (0, _inheritsLoose2.default)(ScaleControl, _MapControl);
	
	  function ScaleControl() {
	    return _MapControl.apply(this, arguments) || this;
	  }
	
	  var _proto = ScaleControl.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    return new _leaflet.Control.Scale(props);
	  };
	
	  return ScaleControl;
	}(_MapControl2.default);
	
	var _default = (0, _context.withLeaflet)(ScaleControl);
	
	exports.default = _default;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _leaflet = __webpack_require__(4);
	
	var _context = __webpack_require__(5);
	
	var _GridLayer2 = _interopRequireDefault(__webpack_require__(54));
	
	var TileLayer =
	/*#__PURE__*/
	function (_GridLayer) {
	  (0, _inheritsLoose2.default)(TileLayer, _GridLayer);
	
	  function TileLayer() {
	    return _GridLayer.apply(this, arguments) || this;
	  }
	
	  var _proto = TileLayer.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    return new _leaflet.TileLayer(props.url, this.getOptions(props));
	  };
	
	  _proto.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
	    _GridLayer.prototype.updateLeafletElement.call(this, fromProps, toProps);
	
	    if (toProps.url !== fromProps.url) {
	      this.leafletElement.setUrl(toProps.url);
	    }
	  };
	
	  return TileLayer;
	}(_GridLayer2.default);
	
	var _default = (0, _context.withLeaflet)(TileLayer);
	
	exports.default = _default;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _leaflet = __webpack_require__(4);
	
	var _context = __webpack_require__(5);
	
	var _DivOverlay2 = _interopRequireDefault(__webpack_require__(53));
	
	var Tooltip =
	/*#__PURE__*/
	function (_DivOverlay) {
	  (0, _inheritsLoose2.default)(Tooltip, _DivOverlay);
	
	  function Tooltip() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _DivOverlay.call.apply(_DivOverlay, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTooltipOpen", function (_ref) {
	      var tooltip = _ref.tooltip;
	
	      if (tooltip === _this.leafletElement) {
	        _this.onOpen();
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTooltipClose", function (_ref2) {
	      var tooltip = _ref2.tooltip;
	
	      if (tooltip === _this.leafletElement) {
	        _this.onClose();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = Tooltip.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    return new _leaflet.Tooltip(this.getOptions(props), props.leaflet.popupContainer);
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    var popupContainer = this.props.leaflet.popupContainer;
	    if (popupContainer == null) return;
	    popupContainer.on({
	      tooltipopen: this.onTooltipOpen,
	      tooltipclose: this.onTooltipClose
	    });
	    popupContainer.bindTooltip(this.leafletElement);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    var popupContainer = this.props.leaflet.popupContainer;
	    if (popupContainer == null) return;
	    popupContainer.off({
	      tooltipopen: this.onTooltipOpen,
	      tooltipclose: this.onTooltipClose
	    });
	
	    if (popupContainer._map != null) {
	      popupContainer.unbindTooltip(this.leafletElement);
	    }
	  };
	
	  return Tooltip;
	}(_DivOverlay2.default);
	
	(0, _defineProperty2.default)(Tooltip, "defaultProps", {
	  pane: 'tooltipPane'
	});
	
	var _default = (0, _context.withLeaflet)(Tooltip);
	
	exports.default = _default;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _leaflet = __webpack_require__(4);
	
	var _context = __webpack_require__(5);
	
	var _MapLayer2 = _interopRequireDefault(__webpack_require__(21));
	
	var VideoOverlay =
	/*#__PURE__*/
	function (_MapLayer) {
	  (0, _inheritsLoose2.default)(VideoOverlay, _MapLayer);
	
	  function VideoOverlay() {
	    return _MapLayer.apply(this, arguments) || this;
	  }
	
	  var _proto = VideoOverlay.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    return new _leaflet.VideoOverlay(props.url, props.bounds, this.getOptions(props));
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    _MapLayer.prototype.componentDidMount.call(this);
	
	    if (this.props.play === true) {
	      this.leafletElement.getElement().play();
	    }
	  };
	
	  _proto.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
	    if (toProps.url !== fromProps.url) {
	      this.leafletElement.setUrl(toProps.url);
	    }
	
	    if (toProps.bounds !== fromProps.bounds) {
	      this.leafletElement.setBounds((0, _leaflet.latLngBounds)(toProps.bounds));
	    }
	
	    if (toProps.opacity !== fromProps.opacity) {
	      this.leafletElement.setOpacity(toProps.opacity);
	    }
	
	    if (toProps.zIndex !== fromProps.zIndex) {
	      this.leafletElement.setZIndex(toProps.zIndex);
	    } // flowlint-next-line sketchy-null-bool:off
	
	
	    if (toProps.play === true && !fromProps.play) {
	      this.leafletElement.getElement().play(); // flowlint-next-line sketchy-null-bool:off
	    } else if (!toProps.play && fromProps.play === true) {
	      this.leafletElement.getElement().pause();
	    }
	  };
	
	  return VideoOverlay;
	}(_MapLayer2.default);
	
	var _default = (0, _context.withLeaflet)(VideoOverlay);
	
	exports.default = _default;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _leaflet = __webpack_require__(4);
	
	var _fastDeepEqual = _interopRequireDefault(__webpack_require__(74));
	
	var _context = __webpack_require__(5);
	
	var _GridLayer2 = _interopRequireDefault(__webpack_require__(54));
	
	var _MapEvented = __webpack_require__(37);
	
	var WMSTileLayer =
	/*#__PURE__*/
	function (_GridLayer) {
	  (0, _inheritsLoose2.default)(WMSTileLayer, _GridLayer);
	
	  function WMSTileLayer() {
	    return _GridLayer.apply(this, arguments) || this;
	  }
	
	  var _proto = WMSTileLayer.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    var url = props.url,
	        params = (0, _objectWithoutPropertiesLoose2.default)(props, ["url"]);
	    return new _leaflet.TileLayer.WMS(url, this.getOptions(params));
	  };
	
	  _proto.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
	    _GridLayer.prototype.updateLeafletElement.call(this, fromProps, toProps);
	
	    var prevUrl = fromProps.url,
	        _po = fromProps.opacity,
	        _pz = fromProps.zIndex,
	        prevParams = (0, _objectWithoutPropertiesLoose2.default)(fromProps, ["url", "opacity", "zIndex"]);
	    var url = toProps.url,
	        _o = toProps.opacity,
	        _z = toProps.zIndex,
	        params = (0, _objectWithoutPropertiesLoose2.default)(toProps, ["url", "opacity", "zIndex"]);
	
	    if (url !== prevUrl) {
	      this.leafletElement.setUrl(url);
	    }
	
	    if (!(0, _fastDeepEqual.default)(params, prevParams)) {
	      this.leafletElement.setParams(params);
	    }
	  };
	
	  _proto.getOptions = function getOptions(params) {
	    var superOptions = _GridLayer.prototype.getOptions.call(this, params);
	
	    return Object.keys(superOptions).reduce(function (options, key) {
	      if (!_MapEvented.EVENTS_RE.test(key)) {
	        options[key] = superOptions[key];
	      }
	
	      return options;
	    }, {});
	  };
	
	  return WMSTileLayer;
	}(_GridLayer2.default);
	
	var _default = (0, _context.withLeaflet)(WMSTileLayer);
	
	exports.default = _default;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(3));
	
	var _leaflet = __webpack_require__(4);
	
	var _context = __webpack_require__(5);
	
	var _MapControl2 = _interopRequireDefault(__webpack_require__(30));
	
	var ZoomControl =
	/*#__PURE__*/
	function (_MapControl) {
	  (0, _inheritsLoose2.default)(ZoomControl, _MapControl);
	
	  function ZoomControl() {
	    return _MapControl.apply(this, arguments) || this;
	  }
	
	  var _proto = ZoomControl.prototype;
	
	  _proto.createLeafletElement = function createLeafletElement(props) {
	    return new _leaflet.Control.Zoom(props);
	  };
	
	  return ZoomControl;
	}(_MapControl2.default);
	
	var _default = (0, _context.withLeaflet)(ZoomControl);
	
	exports.default = _default;

/***/ },
/* 217 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = pick;
	
	function pick(object, keys) {
	  return keys.reduce(function (obj, key) {
	    if (object[key]) {
	      obj[key] = object[key];
	    }
	
	    return obj;
	  }, {});
	}

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(12));
	
	var _Context = __webpack_require__(22);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(58));
	
	function Provider(_ref) {
	  var store = _ref.store,
	      context = _ref.context,
	      children = _ref.children;
	  var contextValue = (0, _react.useMemo)(function () {
	    var subscription = new _Subscription["default"](store);
	    subscription.onStateChange = subscription.notifyNestedSubs;
	    return {
	      store: store,
	      subscription: subscription
	    };
	  }, [store]);
	  var previousState = (0, _react.useMemo)(function () {
	    return store.getState();
	  }, [store]);
	  (0, _react.useEffect)(function () {
	    var subscription = contextValue.subscription;
	    subscription.trySubscribe();
	
	    if (previousState !== store.getState()) {
	      subscription.notifyNestedSubs();
	    }
	
	    return function () {
	      subscription.tryUnsubscribe();
	      subscription.onStateChange = null;
	    };
	  }, [contextValue, previousState]);
	  var Context = context || _Context.ReactReduxContext;
	  return _react["default"].createElement(Context.Provider, {
	    value: contextValue
	  }, children);
	}
	
	Provider.propTypes = {
	  store: _propTypes["default"].shape({
	    subscribe: _propTypes["default"].func.isRequired,
	    dispatch: _propTypes["default"].func.isRequired,
	    getState: _propTypes["default"].func.isRequired
	  }),
	  context: _propTypes["default"].object,
	  children: _propTypes["default"].any
	};
	var _default = Provider;
	exports["default"] = _default;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(17));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(79));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(84));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(220));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(221));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(222));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(223));
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced["default"] : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps["default"] : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps["default"] : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps["default"] : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory["default"] : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual["default"] : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual["default"] : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual["default"] : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2["default"])({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = createConnect();
	
	exports["default"] = _default;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	exports["default"] = void 0;
	
	var _redux = __webpack_require__(59);
	
	var _wrapMapToProps = __webpack_require__(80);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports["default"] = _default;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	exports["default"] = void 0;
	
	var _wrapMapToProps = __webpack_require__(80);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports["default"] = _default;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(85));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2["default"])({}, ownProps, {}, stateProps, {}, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject["default"])(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports["default"] = _default;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports["default"] = finalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(17));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(224));
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors["default"])(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(86));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
	      (0, _warning["default"])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createDispatchHook = createDispatchHook;
	exports.useDispatch = void 0;
	
	var _Context = __webpack_require__(22);
	
	var _useStore = __webpack_require__(82);
	
	/**
	 * Hook factory, which creates a `useDispatch` hook bound to a given context.
	 *
	 * @param {Function} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useDispatch` hook bound to the specified context.
	 */
	function createDispatchHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useStore = context === _Context.ReactReduxContext ? _useStore.useStore : (0, _useStore.createStoreHook)(context);
	  return function useDispatch() {
	    var store = useStore();
	    return store.dispatch;
	  };
	}
	/**
	 * A hook to access the redux `dispatch` function.
	 *
	 * @returns {any|function} redux store's `dispatch` function
	 *
	 * @example
	 *
	 * import React, { useCallback } from 'react'
	 * import { useDispatch } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const dispatch = useDispatch()
	 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
	 *   return (
	 *     <div>
	 *       <span>{value}</span>
	 *       <button onClick={increaseCounter}>Increase counter</button>
	 *     </div>
	 *   )
	 * }
	 */
	
	
	var useDispatch = createDispatchHook();
	exports.useDispatch = useDispatch;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.createSelectorHook = createSelectorHook;
	exports.useSelector = void 0;
	
	var _react = __webpack_require__(2);
	
	var _invariant = _interopRequireDefault(__webpack_require__(50));
	
	var _useReduxContext2 = __webpack_require__(81);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(58));
	
	var _Context = __webpack_require__(22);
	
	// React currently throws a warning when using useLayoutEffect on the server.
	// To get around it, we can conditionally useEffect on the server (no-op) and
	// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
	// subscription callback always has the selector from the latest render commit
	// available, otherwise a store update may happen between render and the effect,
	// which may cause missed updates; we also must ensure the store subscription
	// is created synchronously, otherwise a store update may occur before the
	// subscription is created and an inconsistent state may be observed
	var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
	
	var refEquality = function refEquality(a, b) {
	  return a === b;
	};
	
	function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
	  var _useReducer = (0, _react.useReducer)(function (s) {
	    return s + 1;
	  }, 0),
	      forceRender = _useReducer[1];
	
	  var subscription = (0, _react.useMemo)(function () {
	    return new _Subscription["default"](store, contextSub);
	  }, [store, contextSub]);
	  var latestSubscriptionCallbackError = (0, _react.useRef)();
	  var latestSelector = (0, _react.useRef)();
	  var latestSelectedState = (0, _react.useRef)();
	  var selectedState;
	
	  try {
	    if (selector !== latestSelector.current || latestSubscriptionCallbackError.current) {
	      selectedState = selector(store.getState());
	    } else {
	      selectedState = latestSelectedState.current;
	    }
	  } catch (err) {
	    var errorMessage = "An error occured while selecting the store state: " + err.message + ".";
	
	    if (latestSubscriptionCallbackError.current) {
	      errorMessage += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\nOriginal stack trace:";
	    }
	
	    throw new Error(errorMessage);
	  }
	
	  useIsomorphicLayoutEffect(function () {
	    latestSelector.current = selector;
	    latestSelectedState.current = selectedState;
	    latestSubscriptionCallbackError.current = undefined;
	  });
	  useIsomorphicLayoutEffect(function () {
	    function checkForUpdates() {
	      try {
	        var newSelectedState = latestSelector.current(store.getState());
	
	        if (equalityFn(newSelectedState, latestSelectedState.current)) {
	          return;
	        }
	
	        latestSelectedState.current = newSelectedState;
	      } catch (err) {
	        // we ignore all errors here, since when the component
	        // is re-rendered, the selectors are called again, and
	        // will throw again, if neither props nor store state
	        // changed
	        latestSubscriptionCallbackError.current = err;
	      }
	
	      forceRender({});
	    }
	
	    subscription.onStateChange = checkForUpdates;
	    subscription.trySubscribe();
	    checkForUpdates();
	    return function () {
	      return subscription.tryUnsubscribe();
	    };
	  }, [store, subscription]);
	  return selectedState;
	}
	/**
	 * Hook factory, which creates a `useSelector` hook bound to a given context.
	 *
	 * @param {Function} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useSelector` hook bound to the specified context.
	 */
	
	
	function createSelectorHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useSelector(selector, equalityFn) {
	    if (equalityFn === void 0) {
	      equalityFn = refEquality;
	    }
	
	    (0, _invariant["default"])(selector, "You must pass a selector to useSelectors");
	
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store,
	        contextSub = _useReduxContext.subscription;
	
	    return useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
	  };
	}
	/**
	 * A hook to access the redux store's state. This hook takes a selector function
	 * as an argument. The selector is called with the store state.
	 *
	 * This hook takes an optional equality comparison function as the second parameter
	 * that allows you to customize the way the selected state is compared to determine
	 * whether the component needs to be re-rendered.
	 *
	 * @param {Function} selector the selector function
	 * @param {Function=} equalityFn the function that will be used to determine equality
	 *
	 * @returns {any} the selected state
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useSelector } from 'react-redux'
	 *
	 * export const CounterComponent = () => {
	 *   const counter = useSelector(state => state.counter)
	 *   return <div>{counter}</div>
	 * }
	 */
	
	
	var useSelector = createSelectorHook();
	exports.useSelector = useSelector;

/***/ },
/* 227 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.unstable_batchedUpdates = void 0;
	
	var _reactDom = __webpack_require__(52);
	
	exports.unstable_batchedUpdates = _reactDom.unstable_batchedUpdates;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(190).enable();
	  window.Promise = __webpack_require__(189);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(245);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(51);


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.9.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var h=__webpack_require__(51),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.suspense_list"):60120,ba=n?Symbol.for("react.memo"):
	60115,ca=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");var z="function"===typeof Symbol&&Symbol.iterator;
	function A(a){for(var b=a.message,d="https://reactjs.org/docs/error-decoder.html?invariant="+b,c=1;c<arguments.length;c++)d+="&args[]="+encodeURIComponent(arguments[c]);a.message="Minified React error #"+b+"; visit "+d+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}var B={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},C={};
	function D(a,b,d){this.props=a;this.context=b;this.refs=C;this.updater=d||B}D.prototype.isReactComponent={};D.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw A(Error(85));this.updater.enqueueSetState(this,a,b,"setState")};D.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function E(){}E.prototype=D.prototype;function F(a,b,d){this.props=a;this.context=b;this.refs=C;this.updater=d||B}var G=F.prototype=new E;
	G.constructor=F;h(G,D.prototype);G.isPureReactComponent=!0;var H={current:null},I={suspense:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,d){var c=void 0,e={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:k,props:e,_owner:J.current}}
	function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
	function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){e=a[k];var f=b+T(e,k);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=z&&a[z]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(e=a.next()).done;)e=e.value,f=b+T(e,k++),g+=S(e,f,d,c);else if("object"===e)throw d=""+a,A(Error(31),"[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,"");return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
	function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=H.current;if(null===a)throw A(Error(321));return a}
	var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw A(Error(143));return a}},createRef:function(){return{current:null}},Component:D,PureComponent:F,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:ca,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:ba,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
	b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,unstable_SuspenseList:aa,createElement:M,cloneElement:function(a,b,d){if(null===a||void 0===a)throw A(Error(267),a);var c=void 0,e=
	h({},a.props),g=a.key,k=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:k,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);
	b.type=a;return b},isValidElement:N,version:"16.9.0",unstable_withSuspenseConfig:function(a,b){var d=I.suspense;I.suspense=void 0===b?null:b;try{a()}finally{I.suspense=d}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:H,ReactCurrentBatchConfig:I,ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ },
/* 231 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.batchActions = batchActions;
	exports.enableBatching = enableBatching;
	exports.batchDispatchMiddleware = batchDispatchMiddleware;
	var BATCH = exports.BATCH = 'BATCHING_REDUCER.BATCH';
	
	function batchActions(actions) {
		var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : BATCH;
	
		return { type: type, meta: { batch: true }, payload: actions };
	}
	
	function enableBatching(reduce) {
		return function batchingReducer(state, action) {
			if (action && action.meta && action.meta.batch) {
				return action.payload.reduce(batchingReducer, state);
			}
			return reduce(state, action);
		};
	}
	
	function batchDispatchMiddleware(store) {
		function dispatchChildActions(store, action) {
			if (action.meta && action.meta.batch) {
				action.payload.forEach(function (childAction) {
					dispatchChildActions(store, childAction);
				});
			} else {
				store.dispatch(action);
			}
		}
	
		return function (next) {
			return function (action) {
				if (action && action.meta && action.meta.batch) {
					dispatchChildActions(store, action);
				}
				return next(action);
			};
		};
	}

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 233 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 234 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
	  if (prev === null || next === null || prev.length !== next.length) {
	    return false;
	  }
	
	  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
	  var length = prev.length;
	  for (var i = 0; i < length; i++) {
	    if (!equalityCheck(prev[i], next[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
	
	  var lastArgs = null;
	  var lastResult = null;
	  // we reference arguments instead of spreading them for performance reasons
	  return function () {
	    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
	      // apply arguments instead of spreading for performance.
	      lastResult = func.apply(null, arguments);
	    }
	
	    lastArgs = arguments;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    memoizeOptions[_key - 1] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      funcs[_key2] = arguments[_key2];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      // apply arguments instead of spreading for performance.
	      return resultFunc.apply(null, arguments);
	    }].concat(memoizeOptions));
	
	    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
	    var selector = memoize(function () {
	      var params = [];
	      var length = dependencies.length;
	
	      for (var i = 0; i < length; i++) {
	        // apply arguments instead of spreading and mutate a local list of params for performance.
	        params.push(dependencies[i].apply(null, arguments));
	      }
	
	      // apply arguments instead of spreading for performance.
	      return memoizedResultFunc.apply(null, params);
	    });
	
	    selector.resultFunc = resultFunc;
	    selector.dependencies = dependencies;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      values[_key3] = arguments[_key3];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ },
/* 235 */
/***/ function(module, exports) {

	/** @license React v0.15.0
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var d=void 0,e=void 0,g=void 0,m=void 0,n=void 0;exports.unstable_now=void 0;exports.unstable_forceFrameRate=void 0;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,r=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(r,0),b;}};exports.unstable_now=function(){return Date.now()};d=function(a){null!==p?setTimeout(d,0,a):(p=a,setTimeout(r,0))};e=function(a,b){q=setTimeout(a,b)};g=function(){clearTimeout(q)};m=function(){return!1};n=exports.unstable_forceFrameRate=function(){}}else{var t=window.performance,u=window.Date,v=window.setTimeout,
	w=window.clearTimeout,x=window.requestAnimationFrame,y=window.cancelAnimationFrame;"undefined"!==typeof console&&("function"!==typeof x&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!==typeof y&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));exports.unstable_now="object"===typeof t&&
	"function"===typeof t.now?function(){return t.now()}:function(){return u.now()};var z=!1,A=null,B=-1,C=-1,D=33.33,E=-1,F=-1,G=0,H=!1;m=function(){return exports.unstable_now()>=G};n=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):0<a?(D=Math.floor(1E3/a),H=!0):(D=33.33,H=!1)};var J=function(){if(null!==A){var a=exports.unstable_now(),b=0<G-a;try{A(b,
	a)||(A=null)}catch(c){throw I.postMessage(null),c;}}},K=new MessageChannel,I=K.port2;K.port1.onmessage=J;var L=function(a){if(null===A)F=E=-1,z=!1;else{z=!0;x(function(a){w(B);L(a)});var b=function(){G=exports.unstable_now()+D/2;J();B=v(b,3*D)};B=v(b,3*D);if(-1!==E&&.1<a-E){var c=a-E;!H&&-1!==F&&c<D&&F<D&&(D=c<F?F:c,8.33>D&&(D=8.33));F=c}E=a;G=a+D;I.postMessage(null)}};d=function(a){A=a;z||(z=!0,x(function(a){L(a)}))};e=function(a,b){C=v(function(){a(exports.unstable_now())},b)};g=function(){w(C);
	C=-1}}var M=null,N=null,O=null,P=3,Q=!1,R=!1,S=!1;
	function T(a,b){var c=a.next;if(c===a)M=null;else{a===M&&(M=c);var f=a.previous;f.next=c;c.previous=f}a.next=a.previous=null;c=a.callback;f=P;var l=O;P=a.priorityLevel;O=a;try{var h=a.expirationTime<=b;switch(P){case 1:var k=c(h);break;case 2:k=c(h);break;case 3:k=c(h);break;case 4:k=c(h);break;case 5:k=c(h)}}catch(Z){throw Z;}finally{P=f,O=l}if("function"===typeof k)if(b=a.expirationTime,a.callback=k,null===M)M=a.next=a.previous=a;else{k=null;h=M;do{if(b<=h.expirationTime){k=h;break}h=h.next}while(h!==
	M);null===k?k=M:k===M&&(M=a);b=k.previous;b.next=k.previous=a;a.next=k;a.previous=b}}function U(a){if(null!==N&&N.startTime<=a){do{var b=N,c=b.next;if(b===c)N=null;else{N=c;var f=b.previous;f.next=c;c.previous=f}b.next=b.previous=null;V(b,b.expirationTime)}while(null!==N&&N.startTime<=a)}}function W(a){S=!1;U(a);R||(null!==M?(R=!0,d(X)):null!==N&&e(W,N.startTime-a))}
	function X(a,b){R=!1;S&&(S=!1,g());U(b);Q=!0;try{if(!a)for(;null!==M&&M.expirationTime<=b;)T(M,b),b=exports.unstable_now(),U(b);else if(null!==M){do T(M,b),b=exports.unstable_now(),U(b);while(null!==M&&!m())}if(null!==M)return!0;null!==N&&e(W,N.startTime-b);return!1}finally{Q=!1}}function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}
	function V(a,b){if(null===M)M=a.next=a.previous=a;else{var c=null,f=M;do{if(b<f.expirationTime){c=f;break}f=f.next}while(f!==M);null===c?c=M:c===M&&(M=a);b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}}var aa=n;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
	exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=P;P=a;try{return b()}finally{P=c}};exports.unstable_next=function(a){switch(P){case 1:case 2:case 3:var b=3;break;default:b=P}var c=P;P=b;try{return a()}finally{P=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var f=exports.unstable_now();if("object"===typeof c&&null!==c){var l=c.delay;l="number"===typeof l&&0<l?f+l:f;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),l=f;c=l+c;a={callback:b,priorityLevel:a,startTime:l,expirationTime:c,next:null,previous:null};if(l>f){c=l;if(null===N)N=a.next=a.previous=a;else{b=null;var h=N;do{if(c<h.startTime){b=h;break}h=h.next}while(h!==N);null===b?b=N:b===N&&(N=a);c=b.previous;c.next=b.previous=a;a.next=b;a.previous=
	c}null===M&&N===a&&(S?g():S=!0,e(W,l-f))}else V(a,c),R||Q||(R=!0,d(X));return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(a===b)a===M?M=null:a===N&&(N=null);else{a===M?M=b:a===N&&(N=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=P;return function(){var c=P;P=b;try{return a.apply(this,arguments)}finally{P=c}}};exports.unstable_getCurrentPriorityLevel=function(){return P};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();U(a);return null!==O&&null!==M&&M.startTime<=a&&M.expirationTime<O.expirationTime||m()};exports.unstable_requestPaint=aa;exports.unstable_continueExecution=function(){R||Q||(R=!0,d(X))};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return M};


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(235);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(238);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(244)(module)))

/***/ },
/* 238 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/EastEndCemetery_white.33604b3e.png";

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/FOEE-small-white.31421a55.png";

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/foee-01.4c302617.png";

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/vcu-mobile.c9d3c8df.png";

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 244 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 245 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.f5a4b05d.js